function Resources() {
	return {
		Common: {
			"body-composition-analyzers": {
				en: "Body Composition Analyzers",
				it: "Analizzatori di composizione corporea",
				es: "Analizadores de composición corporal",
				fr: "Analyseurs de composition corporelle"
			},
			"body-composition-analyzer": {
				en: "Body Composition Analyzer",
				it: "Analizzatore di composizione corporea",
				es: "Analizador de composición corporal",
				fr: "Analyseur de composition corporelle",
			},
			"add-body-composition-analyzer": {
				en: "Add Body Composition Analyzer",
				it: "Aggiungi Analizzatore di composizione corporea",
				es: "Añadir Analizador de composición corporal",
				fr: "Ajouter Analyseur de composition corporelle",
			},
			"edit-body-composition-analyzer": {
				en: "Edit Body Composition Analyzer",
				it: "Modifica Analizzatore di composizione corporea",
				es: "Editar Analizador de composición corporal",
				fr: "Modifier Analyseur de composition corporelle",
			},
			"body-composition-analyzera": {
				en: "Edit Body Composition Analyzera",
				it: "Modifica Body Composition Analyzer",
				es: "Editar Body Composition Analyzer",
				fr: "Modifier Body Composition Analyzer",
			},
			"first-name": {
				en: "First/Mid Name",
				it: "Nome",
				es: "Nombre",
				fr: "Prénoms",
			},
			"last-name": {
				en: "Last Name",
				it: "Cognome",
				es: "Apellido",
				fr: "Nom",
			},
			"enable-sensor-self-registration": {
				"en": "Enable Sensor Self Registration",
				"it": "Abilita l'Auto Registrazione Dei Sensori",
				"es": "Habilitar El Autorregistro De Sensores",
				"fr": "Activer l'Auto Enregistrement Des Capteurs"
			},
			"duration-min": {
				"en": "Duration (min.)",
				"it": "Durata (min.)",
				"es": "Duración (min.)",
				"fr": "Durée (min.)"
			},
			"public-workouts": {
				"en": "Public Workouts (visible to all athletes)",
				"it": "Workouts pubblici (visibili a tutti gli atleti)",
				"es": "Workouts públicos (visibles para todos los atletas)",
				"fr": "Workouts publics (visibles par tutti les athlètes)"
			},
			"athlete-workouts": {
				"en": "Athlete Workouts",
				"it": "Workouts dell'atleta",
				"es": "Workouts del atleta",
				"fr": "Workouts de l'athlète"
			},
			"select-at-least-one-metric": {
				"en": "You must select at least one metric",
				"it": "Devi selezionare almeno una metrica",
				"es": "Debes seleccionar al menos una métrica",
				"fr": "Vous devez sélectionner au moins une métrique"
			},
			"ask-me-comment-training": {
				"en": "Ask me to comment your training",
				"it": "Chiedimi di commentare il tuo allenamento",
				"es": "Pídeme que comente tu entrenamiento",
				"fr": "Demandez-moi di commenter votre entraînement"
			},
			"analyzing-workout": {
				"en": "Analyzing workout... it takes a while",
				"it": "Analisi dell'allenamento in corso... potrebbe richiedere un po' di tempo",
				"es": "Analizando el entrenamiento... tardará un poco",
				"fr": "Analyse de l'entraînement in cours... cela prendra un certain temps"
			},
			"imported": {
				"en": "Imported",
				"it": "Importato",
				"es": "Importado",
				"fr": "Importé"
			},
			"maximum-limit-reached": {
				"en": "Maximum limit reached",
				"es": "Límite máximo alcanzado",
				"fr": "Limite maximale atteinte",
				"it": "Limite massimo raggiunto"
			},
			"you-cannot-upload-more-than-500-intensity-flows": {
				"en": "You cannot upload more than 500 intensity flows.",
				"it": "Non puoi caricare più di 500 Intensity Flow.",
				"es": "No puedes subir más de 500 Intensity Flow.",
				"fr": "Vous ne pouvez pas télécharger plus de 500 Intensity Flow."
			},
			"you-cannot-upload-more-than-100-timers": {
				"en": "You cannot upload more than 100 timers.",
				"it": "Non puoi caricare più di 100 timer.",
				"es": "No puedes subir más de 100 temporizadores.",
				"fr": "Vous ne pouvez pas télécharger plus de 100 minuteries."
			},
			"you-cannot-upload-more-than-100-images": {
				"en": "You cannot upload more than 100 images.",
				"es": "No puedes subir más de 100 imágenes.",
				"fr": "Vous ne pouvez pas télécharger plus de 100 images.",
				"it": "Non puoi caricare più di 100 immagini."
			},
			"athletes-to-show": {
				"en": "Athletes To Show",
				"it": "Atleti da Mostrare",
				"es": "Atletas a Mostrar",
				"fr": "Athlètes à Afficher"
			},
			"direct-link": {
				"en": "Direct Link",
				"it": "Link Diretto",
				"es": "Enlace Directo",
				"fr": "Lien Direct"
			},
			"external-links": {
				"en": "External Links",
				"it": "Link Esterni",
				"es": "Enlaces Externos",
				"fr": "Liens Externes"
			},
			"show-in-global-rankings": {
				"en": "Show in Global Rankings",
				"it": "Mostra nelle Classifiche Globali",
				"es": "Mostrar en Clasificaciones Globales",
				"fr": "Afficher dans les Classements Mondiaux"
			},
			"show-in-club-rankings": {
				"en": "Show in Club Rankings",
				"it": "Mostra nelle Classifiche Club",
				"es": "Mostrar en Clasificaciones Club",
				"fr": "Afficher dans les Classements Club",
			},
			"view-logs": {
				"it": "Visualizza Log",
				"en": "View Logs",
				"de": "Protokolle anzeigen",
				"fr": "Afficher les journaux"
			},
			"email-sent": {
				"en": "Email sent",
				"it": "Email inviata",
				"es": "Correo electrónico enviado",
				"fr": "E-mail envoyé"
			},
			"email-resent": {
				"en": "Email resent",
				"it": "Email reinviata",
				"es": "Correo electrónico reenviado",
				"fr": "E-mail renvoyé"
			},
			"last-delivery-success": {
				"it": "Ultima consegna con successo",
				"en": "Last Delivery Success",
				"fr": "Succès dernière livraison",
				"de": "Letzte Zustellung erfolgreich"
			},
			"last-delivery-error": {
				"it": "Ultima consegna errata",
				"en": "Last Delivery Error",
				"fr": "Erreur dernière livraison",
				"de": "Letzter Zustellungsfehler"
			},
			"last-delivery-update": {
				"en": "Last Delivery Update",
				"it": "Aggiornamento ultima consegna",
				"es": "Actualización de la última entrega",
				"fr": "Mise à jour de la dernière livraison"
			},
			"mail-sending": {
				"en": "Mail sending...",
				"it": "Invio email...",
				"es": "Enviando correo...",
				"fr": "Envoi d'e-mail..."
			},
			"delivered": {
				"en": "Delivered",
				"it": "Consegnato",
				"es": "Entregado",
				"fr": "Livré"
			},
			"mail-succesfully-resend": {
				"en": "Mail successfully resent",
				"it": "Email reinviata con successo",
				"es": "Correo electrónico reenviado con éxito",
				"fr": "E-mail renvoyé avec succès"
			},
			"error-resending-email": {
				"en": "Error resending email",
				"it": "Errore durante il reinvio dell'email",
				"es": "Error al reenviar el correo electrónico",
				"fr": "Erreur lors du renvoi de l'e-mail"
			},
			"resend-email-to": {
				"en": "Resend email to",
				"it": "Reinvia email a",
				"es": "Reenviar correo electrónico a",
				"fr": "Renvoyer l'e-mail à"
			},
			"calculate-by-max-bpm-percent": {
				"en": "Calculate by max bpm %",
				"it": "Calcola su BPM max %",
				"es": "Calcular por BPM máximo %",
				"fr": "Calculer par BPM max %"
			},
			"percentage-of": {
				"en": "Percentage of",
				"it": "Percentuale di",
				"es": "Porcentaje de",
				"fr": "Pourcentage de"
			},
			"warning-high-bpm": {
				"en": "Warning High bpm",
				"it": "Avviso bpm alti",
				"es": "Aviso bpm altos",
				"fr": "Attention bpm élevés"
			},
			"insights-derived-in-part-from-Garmin-device-sourced-data": {
				"en": "Insights derived in part from Garmin device-sourced data.",
				"it": "Analisi derivanti in parte dai dati raccolti dai dispositivi Garmin.",
				"es": "Información obtenida en parte a partir de datos procedentes de dispositivos Garmin.",
				"fr": "Informations tirées en partie des données provenant des appareils Garmin."
			},
			 "garmin-dashboard-attribution": {
				"en": "This dashboard was created using data provided by Garmin devices.",
				"it": "Questa dashboard è stata creata utilizzando dati forniti da dispositivi Garmin.",
				"es": "Este panel de control fue creado utilizando datos proporcionados por dispositivos Garmin.",
				"fr": "Ce tableau de bord a été créé à l'aide des données fournies par les appareils Garmin."
			},
			"garmin-chart-attribution": {
				"en": "This chart was created using data provided by Garmin devices.",
				"it": "Questo grafico è stato creato utilizzando i dati forniti dai dispositivi Garmin.",
				"es": "Este gráfico fue creado utilizando datos proporcionados por dispositivos Garmin.",
				"fr": "Ce graphique a été créé à l'aide des données fournies par les appareils Garmin."
			},
			"level-update-date": {
				"en": "Level Update Date",
				"it": "Data Aggiornamento Livello",
				"es": "Fecha de Actualización de Nivel",
				"fr": "Date de Mise à Jour du Niveau"
			},
			"administrators": {
				"en": "Administrators",
				"it": "Amministratori",
				"es": "Administradores",
				"fr": "Administrateurs"
			},
			"challenge-type": {
				en: "Challenge Type",
				it: "Tipo Di Sfida",
				es: "Tipo De Desafío",
				fr: "Type De Défi",
			},
			"the-challenge-will-start-on-the-first-day-of-next-month": {
				en: "The challenge will start on the first day of next month.",
				it: "La sfida partirà il primo giorno del prossimo mese.",
				es: "El desafío comenzará el primer día del próximo mes.",
				fr: "Le défi commencera le premier jour du mois prochain.",
			},
			"challenge-start": {
				en: "Challenge Start",
				it: "Inizio Sfida",
				es: "Inicio Del Desafío",
				fr: "Début Du Défi",
			},
			"add-challenge": {
				en: "Ranking",
				it: "Classifica",
				es: "Clasificación",
				fr: "Classement",
			},
			"add-goals": {
				en: "Goal",
				it: "Obiettivo",
				es: "Objetivo",
				fr: "Objectif",
			},
			"monthly-challenges": {
				en: "Monthly Challenges",
				it: "Sfide Mensili",
				es: "Desafíos Mensuales",
				fr: "Défis Mensuels",
			},
			"recurring": {
				en: "Recurring",
				it: "Ricorrenti",
				es: "Recurrentes",
				fr: "Récurrents"
			},
			"running": {
				en: "Running",
				it: "In Corso",
				es: "En Curso",
				fr: "En Cours",
			},
			"history": {
				en: "History",
				it: "Storico",
				es: "Historia",
				fr: "Archiver",
			},
			"schedule-challenge": {
				en: "Ranking",
				it: "Classifica",
				es: "Clasificación",
				fr: "Classement",
			},
			"schedule-goals": {
				en: "Goal",
				it: "Obiettivo",
				es: "Objetivo",
				fr: "Objectif",
			},
			"quick-schedule-challenge": {
				en: "Quick Schedule",
				it: "Programmazione Rapida",
				es: "Programacion Rapida",
				fr: "Programmation Rapide",
			},
			"club-metrics": {
				"it": "Metriche del club",
				"en": "Club metrics",
				"es": "Métricas del club",
				"fr": "Mesures du club"
			},
			"organization-metrics": {
				"it": "Metriche dell'organizzazione",
				"en": "Organization metrics",
				"es": "Métricas de la organización",
				"fr": "Mesures de l'organisation"
			},
			"rankings-trainings-origin": {
				"en": "Trainings to consider for rankings",
				"it": "Allenamenti da considerare per le classifiche",
				"es": "Entrenamientos a considerar para las clasificaciones",
				"fr": "Entraînements à considérer pour les classements"
			},
			"any": {
				"en": "all",
				"it": "tutti",
				"es": "todos",
				"fr": "tous"
			},
			"show-logo": {
				"en": "Show Logo",
				"it": "Mostra Logo",
				"es": "Mostrar Logo",
				"fr": "Afficher le Logo"
			},
			"public-ranking": {
				"en": "Public Ranking",
				"it": "Classifica Pubblica",
				"es": "Clasificación pública",
				"fr": "Classement public"
			},
			"select-at-least-one-timeframe": {
				"en": "You must select at least one timeframe",
				"it": "Devi selezionare almeno un intervallo di tempo",
				"es": "Debes seleccionar al menos un rango de tiempo",
				"fr": "Vous devez sélectionner au moins une plage de temps"
			},
			"select-ranking-or-challenge": {
				"en": "You must select at least one ranking or challenge",
				"it": "Devi selezionare almeno una classifica o una sfida",
				"es": "Debes seleccionar al menos una clasificación o un desafío",
				"fr": "Vous devez sélectionner au moins un classement ou un défi"
			},
			"show-brand-challenges": {
				"en": "Show Organization Challenges",
				"it": "Mostra Sfide Organizzazione",
				"es": "Mostrar Desafíos de la Organización",
				"fr": "Afficher les Défis de l'Organisation"
			},
			"show-brand-rankings": {
				"en": "Show Organization Rankings",
				"it": "Mostra Classifiche Organizzazione",
				"es": "Mostrar Clasificación de la Organización",
				"fr": "Afficher les Défis de l'Organisation"
			},
			"show-club-challenges": {
				"en": "Show Club Challenges",
				"it": "Mostra Sfide Club",
				"es": "Mostrar Desafíos del Club",
				"fr": "Afficher les Défis du Club"
			},
			"club-rankings-to-show": {
				"en": "Club rankings to show",
				"it": "Classifiche club da mostrare",
				"es": "Clasificaciones del club para mostrar",
				"fr": "Classements du club à afficher"
			},
			"brand-rankings-to-show": {
				"en": "Organization rankings to show",
				"it": "Classifiche organizzazione da mostrare",
				"es": "Clasificaciones de organización para mostrar",
				"fr": "Classements d'organisation à afficher"
			},
			"timeframes": {
				"en": "Timeframes",
				"it": "Intervalli di tempo",
				"es": "Períodos",
				"fr": "Périodes"
			},
			"disallowed-characters": {
				"en": "Disallowed characters",
				"it": "Caratteri non ammessi",
				"es": "Caracteres no permitidos",
				"fr": "Caractères non autorisés"
			},
			"width": {
				"en": "Width",
				"it": "Larghezza",
				"es": "Ancho",
				"fr": "Largeur"
			},
			"copied-to-clipboard": {
				"en": "Copied to clipboard",
				"it": "Copiato negli appunti",
				"es": "Copiado al portapapeles",
				"fr": "Copié dans le presse-papiers"
			},
			"iframe-embed-configuration": {
				"en": "Iframe Embed Configuration",
				"it": "Configurazione Incorporamento Iframe",
				"es": "Configuración de Inserción de Iframe",
				"fr": "Configuration d'Intégration Iframe"
			},
			"iframe-embed": {
				"en": "Iframe Embed",
				"it": "Incorporamento Iframe",
				"es": "Inserción de Iframe",
				"fr": "Intégration Iframe"
			},
			"invitation-link-expiry": {
				"en": "This invitation link will stop working on July 31st.\n Generate a new link to replace its functionality.",
				"it": "Questo link di invito smetterà di funzionare il 31 luglio.\n Genera un nuovo link per sostituirne la funzionalità.",
				"es": "Este enlace de invitación dejará de funcionar el 31 de julio.\n Genera un nuevo enlace para reemplazar su funcionalidad.",
				"fr": "Ce lien d'invitation cessera de fonctionner le 31 juillet.\n Générez un nouveau lien pour en remplacer la fonctionnalité."
			},
			"choose-sensor-type": {
				"en": "Choose sensor type",
				"it": "Scegli il tipo di sensore",
				"es": "Elige el tipo de sensor",
				"fr": "Choisissez le type de capteur"
			},
			"you-are-deleting": {
				"en": "You are deleting",
				"it": "Stai eliminando",
				"es": "Estás eliminando",
				"fr": "Vous êtes en train de supprimer"
			},
			"you-are-unsharing": {
				"en": "You are unsharing",
				"it": "Stai togliendo la condivisione",
				"es": "Estás dejando de compartir",
				"fr": "Vous annulez le partage",
			},
			"no-exercises-for-selected-equipments": {
				"en": "No exercises available for the selected equipment",
				"it": "Non ci sono esercizi disponibili per le attrezzature selezionate",
				"es": "No hay ejercicios disponibles para el equipo seleccionado",
				"fr": "Aucun exercice disponible pour les équipements sélectionnés"
			},
			"unable-to-generate-workout-sheet": {
				"en": "Unable to generate the workout sheet",
				"it": "Impossibile generare la scheda",
				"es": "No se puede generar la hoja de entrenamiento",
				"fr": "Impossible de générer la fiche d'entraînement"
			},
			"nate-form-home": {
				"en": "Home",
				"it": "Casa",
				"es": "Hogar",
				"fr": "Domicile"
			},
			"nate-form-outdoor": {
				"en": "Outdoor",
				"it": "All'aperto",
				"es": "Al aire libre",
				"fr": "En extérieur"
			},
			"nate-form-club": {
				"en": "Club",
				"it": "Club",
				"es": "Club",
				"fr": "Club"
			},
			"save-all": {
				"en": "Save All",
				"it": "Salva Tutto",
				"es": "Guardar Todo",
				"fr": "Tout Enregistrer"
			},
			"this-content-was-automatically-generated-using-AI-and-may-contain-errors": {
				"en": "This content was automatically generated using AI and may contain errors.",
				"it": "Questo contenuto è stato generato automaticamente tramite IA e potrebbe contenere errori.",
				"es": "Este contenido fue generado automáticamente con IA y puede contener errores.",
				"fr": "Ce contenu a été généré automatiquement par l'IA et peut contenir des erreurs."
			},
			"this-content-was-automatically-generated-using-AI-recommend-reviewing": {
				"en": "This content was automatically generated using AI. We recommend reviewing it for possible errors or inaccuracies.",
				"it": "Questo contenuto è stato generato automaticamente tramite IA. Ti consigliamo di verificarlo per eventuali errori o imprecisioni.",
				"es": "Este contenido fue generado automáticamente con IA. Recomendamos revisarlo por posibles errores o inexactitudes.",
				"fr": "Ce contenu a été généré automatiquement par l'IA. Nous vous recommandons de le relire pour détecter d'éventuelles erreurs ou imprécisions."
			},
			"this-content-will-be-automatically-generated-using-AI-recommend-reviewing": {
				"it": "Questo contenuto sarà generato automaticamente tramite IA. Ti consigliamo di verificarlo per eventuali errori o imprecisioni.",
				"en": "This content will be automatically generated using AI. We recommend reviewing it for possible errors or inaccuracies.",
				"es": "Este contenido se generará automáticamente mediante IA. Te recomendamos revisarlo por posibles errores o imprecisiones.",
				"fr": "Ce contenu sera généré automatiquement par l'IA. Nous vous recommandons de le vérifier pour d'éventuelles erreurs ou imprécisions."
			},
			"gym-equipment": {
				"en": "Gym Equipment",
				"it": "Attrezzatura Palestra",
				"es": "Equipo Gimnasio",
				"fr": "Équipement Gymnase"
			},
			"NATE": {
				"en": "NATE",
				"it": "NATE",
				"es": "NATE",
				"fr": "NATE"
			},
			"enable-nate-feedbacks": {
				"en": "Enable Training Feedback By NATE",
				"it": "Abilita Feedback Allenamento Di NATE",
				"es": "Activar Comentarios Entrenamiento De NATE",
				"fr": "Activer Les Retours Entraînement De NATE"
			},
			"enable-nate-coach": {
				"en": "Enable NATE Coach",
				"it": "Abilita Coach NATE",
				"es": "Activar Entrenador NATE",
				"fr": "Activer Coach NATE"
			},
			"nate-coach-enabled": {
				"en": "NATE Coach",
				"it": "Coach NATE",
				"es": "Entrenador NATE",
				"fr": "Coach NATE"
			},
			"nate-assistant-enabled": {
				"en": "NATE Assistant",
				"it": "Assistente NATE",
				"es": "Asistente NATE",
				"fr": "Assistant NATE"
			},
			"telemetry-enabled": {
				"en": "Telemetry",
				"it": "Telemetria",
				"es": "Telemetría",
				"fr": "Télémétrie"
			},
			"management-enabled": {
				"en": "Management",
				"it": "Management",
				"es": "Management",
				"fr": "Management"
			},
			"workout-sheets-enabled": {
				"en": "Workout sheets",
				"it": "Schede di allenamento",
				"es": "Hojas de entrenamiento",
				"fr": "Fiches d'entraînement"
			},
			"restore-defaults": {
				"en": "Restore Defaults",
				"it": "Ripristina Predefiniti",
				"es": "Restaurar Valores Predeterminados",
				"fr": "Restaurer les Paramètres par Défaut"
			},
			"club-equipments": {
				"en": "Equipments available in the club",
				"it": "Attrezzi disponibili nel club",
				"es": "Equipos disponibles en el club",
				"fr": "Équipements disponibles dans le club"
			},
			"home-equipments": {
				"en": "Equipments available at home",
				"it": "Attrezzi disponibili a casa",
				"es": "Equipos disponibles en casa",
				"fr": "Équipements disponibles à la maison"
			},
			"outdoor-equipments": {
				"en": "Equipments available outdoors",
				"it": "Attrezzi disponibili all'aperto",
				"es": "Equipos disponibles al aire libre",
				"fr": "Équipements disponibles à l'extérieur"
			},
			"equipments": {
				"en": "Equipments",
				"it": "Attrezzi",
				"es": "Equipamientos",
				"fr": "Équipements"
			},
			"enable-in-app-purchases": {
				"en": "Enable In-App Purchases",
				"it": "Abilita Acquisti In-App",
				"es": "Habilitar Compras Integradas",
				"fr": "Activer les Achats Intégrés"
			},
			"onsite-online-free-access-lesson": {
				"en": "This Onsite and Online lesson is free to access because it has no cost in credits or associated subscriptions.",
				"it": "Questa lezione In Presenza e Online è ad accesso gratuito perché non ha costo in crediti o abbonamenti associati.",
				"es": "Esta lección En Sitio y En Línea es de acceso gratuito porque no tiene costo en créditos ni suscripciones asociadas.",
				"fr": "Cette leçon Sur Site et En Ligne est en accès gratuit car elle n'a aucun coût en crédits ou abonnements associés."
			},
			"online-free-access-lesson": {
				"en": "This Online lesson is free to access because it has no cost in credits or associated subscriptions.",
				"it": "Questa lezione Online è ad accesso gratuito perché non ha costo in crediti o abbonamenti associati.",
				"es": "Esta lección En Línea es de acceso gratuito porque no tiene costo en créditos ni suscripciones asociadas.",
				"fr": "Cette leçon En Ligne est en accès gratuit car elle n'a aucun coût en crédits ou abonnements associés."
			},
			"onsite-free-access-lesson": {
				"en": "This Onsite lesson is free to access because it has no cost in credits or associated subscriptions.",
				"it": "Questa lezione In Presenza è ad accesso gratuito perché non ha costo in crediti o abbonamenti associati.",
				"es": "Esta lección En Sitio es de acceso gratuito porque no tiene costo en créditos ni suscripciones asociadas.",
				"fr": "Cette leçon Sur Site est en accès gratuit car elle n'a aucun coût en crédits ou abonnements associés."
			},
			"free-lesson-access": {
				"en": "Free access",
				"it": "Accesso gratuito",
				"es": "Acceso gratuito",
				"fr": "Accès gratuit"
			},
			"generate-with-nate": {
				en: "Generate with NATE",
				it: "Genera con NATE",
				es: "Generar con NATE",
				fr: "Générer avec NATE"
			},
			"training-feedbacks": {
				en: "Training Feedbacks",
				it: "Training Feedbacks",
				es: "Training Feedbacks",
				fr: "Training Feedbacks",
			},
			"nate-generating-workout": {
				en: "Please wait while I generate the workout sheet. It will take about a minute.",
				it: "Attendi mentre genero la scheda di allenamento. Ci vorrà circa un minuto.",
				es: "Espera mientras genero la hoja de entrenamiento. Tomará aproximadamente un minuto.",
				fr: "Veuillez patienter pendant que je génère la fiche d'entraînement. Cela prendra environ une minute."
			},
			"all-tiers-must-have-a-reward": {
				en: "All tiers must have a reward",
				it: "Tutti i livelli devono avere una ricompensa",
				es: "Todos los niveles deben tener una recompensa",
				fr: "Tous les niveaux doivent avoir une récompense"
			},
			"select-badge": {
				en: "Select Badge",
				it: "Seleziona Badge",
				es: "Seleccionar Badge",
				fr: "Sélectionner des badges",
			},
			"exercise-cannot-have-duration-and-repetitions": {
				"en": "An exercise cannot have both duration and repetitions in the same set.",
				"it": "Un esercizio non può avere durata e ripetizioni nello stesso set.",
				"es": "Un ejercicio no puede tener duración y repeticiones en el mismo set.",
				"fr": "Un exercice ne peut pas avoir à la fois une durée et des répétitions dans le même ensemble."
			},
			"value-must-be-between": {
				"en": "Value must be comprised between {0} and {1}",
				"it": "Il valore deve essere compreso tra {0} e {1}",
				"es": "El valor debe estar comprendido entre {0} y {1}",
				"fr": "La valeur doit être comprise entre {0} et {1}"
			},
			"warnings": {
				"en": "Warnings",
				"it": "Avvisi",
				"es": "Advertencias",
				"fr": "Avertissements"
			},
			"user-measures": {
				en: "Measurements",
				it: "Misurazioni",
				es: "Medidas",
				fr: "Mesures",
			},
			"biometric-report": {
				en: "Biometric Report",
				it: "Report Biometrico",
				es: "Informe biométrico",
				fr: "Rapport biométrique",
			},
			"no-workout-sheet-execution-to-display": {
				"en": "No workout sheet execution to display.",
				"it": "Nessuna esecuzione scheda da visualizzare.",
				"es": "No hay ejecución de hoja de entrenamiento para mostrar.",
				"fr": "Aucune exécution de fiche d'entraînement à afficher."
			},
			"warnings": {
				"en": "Warnings",
				"it": "Avvisi",
				"es": "Advertencias",
				"fr": "Avertissements"
			},
			"workout-sheets-executions": {
				"en": "Workout Sheets Executions",
				"it": "Esecuzioni Schede Allenamento",
				"es": "Ejecuciones de Hojas de Entrenamiento",
				"fr": "Exécutions des Fiches d'Entraînement"
			},
			"workout-sheet-execution": {
				"en": "Workout Sheet Execution",
				"it": "Esecuzione Scheda Allenamento",
				"es": "Ejecución de Hoja de Entrenamiento",
				"fr": "Exécution de la Fiche d'Entraînement"
			},
			"value-must-be-one-or-greater": {
				"en": "Enter a value greater than or equal to 1.",
				"it": "Inserire un valore superiore o uguale a 1.",
				"es": "Introduzca un valor mayor o igual a 1.",
				"fr": "Entrez une valeur supérieure ou égale à 1."
			},
			"stripe-payment-configuration-required": {
				"en": "You cannot assign a recurring plan without enabling Stripe payments in the club profile",
				"it": "Non puoi assegnare un piano ricorrente senza aver abilitato i pagamenti di Stripe dal profilo del club",
				"es": "No puedes asignar un plan recurrente sin habilitar los pagos de Stripe en el perfil del club",
				"fr": "Vous ne pouvez pas attribuer un plan récurrent sans activer les paiements Stripe dans le profil du club"
			},
			"mail-sent-successfully": {
				en: "Mail sent successfully",
				it: "Mail inviata con successo",
				es: "El correo enviado con éxito",
				fr: "Courrier envoyé avec succès",
			},
			"mail-send-error": {
				"en": "Error sending mail",
				"it": "Errore invio mail",
				"es": "Error al enviar el correo",
				"fr": "Erreur lors de l'envoi du courriel"
			},
			"resend-invoice-mail": {
				"en": "Resend Invoice Mail",
				"it": "Reinvia Email Fattura",
				"es": "Reenviar Correo de Factura",
				"fr": "Renvoyer le Courriel de Facture"
			},
			"copy-invoice-link": {
				"en": "Copy Invoice Link",
				"it": "Copia Link Fattura",
				"es": "Copiar Enlace de Factura",
				"fr": "Copier le Lien de la Facture"
			},
			"payment-status": {
				en: "Payment Status",
				it: "Stato Pagamento",
				es: "Estado del Pago",
				fr: "Statut du Paiement"
			},
			"ext-payment": {
				"en": "With External Payment",
				"it": "Con Pagamento Esterno",
				"es": "Con Pago Externo",
				"fr": "Avec Paiement Externe"
			},
			unsubscribe: {
				en: "Unsubscribe",
				it: "Disiscriviti",
				es: "Cancelar suscripción",
				fr: "Se désabonner",
			},
			"cancel-unsubscribe": {
				en: "Cancel unsubscribe",
				it: "Annulla disiscrizione",
				es: "Cancelar cancelar suscripción",
				fr: "Annuler se désabonner",
			},
			"unsubscribe-immediately": {
				en: "Unsubscribe immediately",
				it: "Disiscriversi immediatamente",
				es: "Cancelar suscripción inmediatamente",
				fr: "Se désabonner immédiatement",
			},
			"confirm-unsubscribe-immediately": {
				en: "Are you sure you want to unsubscribe immediately?",
				it: "Sei sicuro di voler annullare l'iscrizione immediatamente?",
				es: "¿Estás seguro de que deseas cancelar la suscripción de inmediato?",
				fr: "Êtes-vous sûr de vouloir vous désabonner immédiatement ?"
			},
			"unsubscribe-at-end": {
				en: "Unsubscribe at end",
				it: "Disiscriversi alla fine",
				es: "Cancelar suscripción al final",
				fr: "Se désabonner à la fin",
			},
			"confirm-unsubscribe-at-end": {
				en: "Are you sure you want to unsubscribe at the end?",
				it: "Sei sicuro di voler annullare l'iscrizione alla fine?",
				es: "¿Estás seguro de que deseas cancelar la suscripción al final?",
				fr: "Êtes-vous sûr de vouloir vous désabonner à la fin ?"
			},
			"cancellation-requested": {
				en: "Cancellation requested",
				it: "Cancellazione richiesta",
				es: "Cancelación solicitada",
				fr: "Annulation demandée",
			},
			"confirm-cancel-unsubscribe": {
				en: "Are you sure you want to cancel the unsubscribe?",
				it: "Sei sicuro di voler annullare la disiscrizione?",
				es: "¿Estás seguro de que deseas cancelar la cancelación de la suscripción?",
				fr: "Êtes-vous sûr de vouloir annuler le désabonnement ?"
			},
			customer: {
				en: "Customer",
				it: "Cliente",
				es: "Cliente",
				fr: "Client",
			},
			"subscription-assignment-zero-price-error": {
				"en": "It is not possible to assign a subscription with a payment order with a price of 0.",
				"it": "Non è possibile assegnare un abbonamento con un ordine di pagamento con prezzo 0.",
				"es": "No es posible asignar una suscripción con un pedido de pago con un precio de 0.",
				"fr": "Il n'est pas possible d'attribuer un abonnement avec une commande de paiement d'un montant de 0."
			},
			"subscription-assignment-error": {
				"en": "An error occurred during the subscription assignment",
				"it": "Si è verificato un errore durante l'assegnazione dell'abbonamento",
				"es": "Se produjo un error durante la asignación de la suscripción",
				"fr": "Une erreur s'est produite lors de l'attribution de l'abonnement"
			},
			"order-succesfully-created": {
				"en": "Order successfully created",
				"it": "Ordine creato con successo",
				"es": "Pedido creado con éxito",
				"fr": "Commande créée avec succès"
			},
			"external-payment": {
				"en": "External",
				"it": "Esterno",
				"es": "Externo",
				"fr": "Externe"
			},
			"subscription-payment-instructions": {
				"en": "The subscription will be assigned as active, and an email will be sent to the athlete with payment instructions. If payment is not made within 7 days, the subscription will automatically be deactivated. A transaction will be automatically added upon payment.",
				"it": "L'abbonamento verrà assegnato come attivo e verrà inviata una mail all'atleta con le istruzioni per il pagamento. Se non verrà pagato entro 7 giorni l'abbonamento verrà disattivato in automatico. Al pagamento verrà aggiunta automaticamente una transazione.",
				"es": "La suscripción se asignará como activa y se enviará un correo electrónico al atleta con instrucciones de pago. Si no se realiza el pago en 7 días, la suscripción se desactivará automáticamente. Al realizar el pago, se añadirá automáticamente una transacción.",
				"fr": "L'abonnement sera attribué comme actif et un email sera envoyé à l'athlète avec les instructions de paiement. Si le paiement n'est pas effectué sous 7 jours, l'abonnement sera automatiquement désactivé. Une transaction sera automatiquement ajoutée lors du paiement."
			},
			"payment-outside-platform": {
				"en": "The payment is made outside the platform.",
				"it": "Il pagamento avviene al di fuori della piattaforma.",
				"es": "El pago se realiza fuera de la plataforma.",
				"fr": "Le paiement est effectué en dehors de la plateforme."
			},
			"start-time-format-error": {
				en: "The Start Time field must be in the format hh:mm",
				it: "Il campo Start Time deve avere il seguente formato hh:mm",
				es: "El campo Hora de Inicio debe tener el formato hh:mm",
				fr: "Le champ Heure de début doit être au format hh:mm"
			},
			"end-time-format-error": {
				"en": "The End Time field must be in the format hh:mm",
				"it": "Il campo End Time deve avere il seguente formato hh:mm",
				"es": "El campo Hora de Fin debe tener el formato hh:mm",
				"fr": "Le champ Heure de fin doit être au format hh:mm"
			},
			"begin": {
				en: "Begin",
				it: "Inizio",
				es: "Inicio",
				fr: "Début",
			},
			"hour": {
				en: "Hour",
				it: "Ora",
				es: "Hora",
				fr: "Heure",
			},
			"tags": { 
				"en": "Tags",
				"it": "Tags",
				"es": "Tags",
				"fr": "Tags"
			},
			"video-upload-suggestion": {
				"en": "We suggest uploading videos in 16:9 format, without audio, and shorter than 30 seconds. The video should show: Opening - 2/3 repetitions - Closing. Supported formats: webm, mp4, quicktime, wmv, matroska",
				"it": "Suggeriamo di caricare video in formato 16:9, senza audio e con una durata inferiore ai 30 secondi. Il video deve mostrare: Apertura - 2/3 ripetizioni - Chiusura. Formati supportati: webm, mp4, quicktime, wmv, matroska",
				"es": "Sugerimos cargar videos en formato 16:9, sin audio y con una duración inferior a 30 segundos. El video debe mostrar: Apertura - 2/3 repeticiones - Cierre. Formatos compatibles: webm, mp4, quicktime, wmv, matroska",
				"fr": "Nous suggérons de télécharger des vidéos au format 16:9, sans audio et de moins de 30 secondes. La vidéo doit montrer : Ouverture - 2/3 répétitions - Fermeture. Formats pris en charge : webm, mp4, quicktime, wmv, matroska"
			},
			"1010": { 
				"en": "Input Error",
				"it": "Errore di Input",
				"es": "Error de Entrada",
				"fr": "Erreur d'Entrée"
			},
			"1020": { 
				"en": "Video Error",
				"it": "Errore Video",
				"es": "Error de Video",
				"fr": "Erreur Vidéo"
			},
			"1021": { 
				"en": "Audio Error",
				"it": "Errore Audio",
				"es": "Error de Audio",
				"fr": "Erreur Audio"
			},
			"1030": { 
				"en": "Unsupported Codec",
				"it": "Codec Non Supportato",
				"es": "Codec No Soportado",
				"fr": "Codec Non Pris en Charge"
			},
			"1040": { 
				"en": "Settings Error",
				"it": "Errore di Impostazioni",
				"es": "Error de Configuración",
				"fr": "Erreur de Paramètres"
			},
			"1041": { 
				"en": "Acceleration Settings Error",
				"it": "Errore Impostazioni di Accelerazione",
				"es": "Error de Configuración de Aceleración",
				"fr": "Erreur Paramètres d'Accélération"
			},
			"1042": { 
				"en": "Job Doesn't Require Enough Processing Power for Accelerated Transcoding",
				"it": "Il Lavoro Non Richiede Abbastanza Potenza di Elaborazione per la Transcodifica Accelerata",
				"es": "El Trabajo No Requiere Suficiente Potencia de Procesamiento para la Transcodificación Acelerada",
				"fr": "Le Travail Ne Nécessite Pas Assez de Puissance de Traitement pour le Transcodage Accéléré"
			},
			"1056": { 
				"en": "File Open Error",
				"it": "Errore di Apertura File",
				"es": "Error de Apertura de Archivo",
				"fr": "Erreur d'Ouverture de Fichier"
			},
			"1060": { 
				"en": "Clipping Error",
				"it": "Errore di Clipping",
				"es": "Error de Recorte",
				"fr": "Erreur de Découpage"
			},
			"1075": { 
				"en": "Demuxer Parse Error",
				"it": "Errore di Parsing del Demuxer",
				"es": "Error de Análisis del Demuxer",
				"fr": "Erreur de Parsing du Démultiplexeur"
			},
			"1076": { 
				"en": "Source Read Error",
				"it": "Errore di Lettura della Sorgente",
				"es": "Error de Lectura de Fuente",
				"fr": "Erreur de Lecture de Source"
			},
			"1080": { 
				"en": "MXF Output Error",
				"it": "Errore di Output MXF",
				"es": "Error de Salida MXF",
				"fr": "Erreur de Sortie MXF"
			},
			"1091": { 
				"en": "Encryption Error",
				"it": "Errore di Crittografia",
				"es": "Error de Cifrado",
				"fr": "Erreur de Chiffrement"
			},
			"1092": { 
				"en": "Decode Audio Initialization Error",
				"it": "Errore di Inizializzazione della Decodifica Audio",
				"es": "Error de Inicialización de Decodificación de Audio",
				"fr": "Erreur d'Initialisation du Décodage Audio"
			},
			"1401": { 
				"en": "Permissions Issue",
				"it": "Problema di Permessi",
				"es": "Problema de Permisos",
				"fr": "Problème de Permissions"
			},
			"1404": { 
				"en": "File Open Error",
				"it": "Errore di Apertura File",
				"es": "Error de Apertura de Archivo",
				"fr": "Erreur d'Ouverture de Fichier"
			},
			"1432": { 
				"en": "IAM Role Error",
				"it": "Errore Ruolo IAM",
				"es": "Error de Rol IAM",
				"fr": "Erreur de Rôle IAM"
			},
			"1433": { 
				"en": "IAM Role Error",
				"it": "Errore Ruolo IAM",
				"es": "Error de Rol IAM",
				"fr": "Erreur de Rôle IAM"
			},
			"1434": { 
				"en": "IAM Role Error",
				"it": "Errore Ruolo IAM",
				"es": "Error de Rol IAM",
				"fr": "Erreur de Rôle IAM"
			},
			"1515": { 
				"en": "IAM Role Error",
				"it": "Errore Ruolo IAM",
				"es": "Error de Rol IAM",
				"fr": "Erreur de Rôle IAM"
			},
			"1522": { 
				"en": "Terminated",
				"it": "Terminato",
				"es": "Terminado",
				"fr": "Terminé"
			},
			"1550": { 
				"en": "Acceleration Fault",
				"it": "Errore di Accelerazione",
				"es": "Falla de Aceleración",
				"fr": "Défaut d'Accélération"
			},
			"1999": { 
				"en": "Unknown Error",
				"it": "Errore Sconosciuto",
				"es": "Error Desconocido",
				"fr": "Erreur Inconnue"
			},
			"3400": { 
				"en": "HLS Input Doesn't Meet Requirements",
				"it": "L'Input HLS Non Soddisfa i Requisiti",
				"es": "La Entrada HLS No Cumple los Requisitos",
				"fr": "L'Entrée HLS Ne Répond Pas aux Exigences"
			},
			"3401": { 
				"en": "HTTP File Access Not Authorized",
				"it": "Accesso al File HTTP Non Autorizzato",
				"es": "Acceso al Archivo HTTP No Autorizado",
				"fr": "Accès au Fichier HTTP Non Autorisé"
			},
			"3403": { 
				"en": "HTTP Access Forbidden",
				"it": "Accesso HTTP Vietato",
				"es": "Acceso HTTP Prohibido",
				"fr": "Accès HTTP Interdit"
			},
			"3404": { 
				"en": "HTTP File Not Found",
				"it": "File HTTP Non Trovato",
				"es": "Archivo HTTP No Encontrado",
				"fr": "Fichier HTTP Non Trouvé"
			},
			"3408": { 
				"en": "HTTP Upload Error",
				"it": "Errore di Upload HTTP",
				"es": "Error de Carga HTTP",
				"fr": "Erreur de Téléchargement HTTP"
			},
			"3450": { 
				"en": "HTTP Server Error",
				"it": "Errore del Server HTTP",
				"es": "Error del Servidor HTTP",
				"fr": "Erreur du Serveur HTTP"
			},
			"3451": { 
				"en": "HTTP Server Connection Error",
				"it": "Errore di Connessione al Server HTTP",
				"es": "Error de Conexión al Servidor HTTP",
				"fr": "Erreur de Connexion au Serveur HTTP"
			},
			"3457": { 
				"en": "Input Disallowed by Policy",
				"it": "Input Vietato dalla Politica",
				"es": "Entrada Prohibida por la Política",
				"fr": "Entrée Interdite par la Politique"
			},
			"3999": { 
				"en": "HTTP Unknown Error",
				"it": "Errore HTTP Sconosciuto",
				"es": "Error HTTP Desconocido",
				"fr": "Erreur HTTP Inconnue"
			},
			"retry": {
				"en": "Retry",
				"it": "Riprova",
				"es": "Reintentar",
				"fr": "Réessayer"
			},
			"video-uploading": {
				"en": "Uploading...",
				"it": "Uploading...",
				"es": "Uploading...",
				"fr": "Uploading..."
			},
			"video-processing": {
				"en": "Processing...",
				"it": "Elaborazione...",
				"es": "Procesando...",
				"fr": "Traitement..."
			},
			"uploading-video": {
				"en": "Uploading...",
				"it": "Caricamento...",
				"es": "Cargando...",
				"fr": "Téléchargement..."
			},
			"video-uploading-message": {
				"en": "Please wait for the upload to finish. Do not close or reload this window.",
				"it": "Attendere la fine del caricamento. Non chiudere o ricaricare questa finestra.",
				"es": "Espere a que termine la carga. No cierre ni recargue esta ventana.",
				"fr": "Veuillez attendre la fin du téléchargement. Ne fermez pas et ne rechargez pas cette fenêtre."
			},
			"media": {
				"en": "Media",
				"it": "Media",
				"es": "Media",
				"fr": "Media"
			},
			"video": {
				"en": "Video",
				"it": "Video",
				"es": "Vídeo",
				"fr": "Vidéo"
			},
			"video-upload-error": {
				"en": "Error during video upload",
				"it": "Errore durante il caricamento del video",
				"es": "Error durante la carga del vídeo",
				"fr": "Erreur lors du téléchargement de la vidéo"
			},
			"video-uploaded-successfully": {
				"en": "Video uploaded successfully",
				"it": "Video caricato correttamente",
				"es": "Vídeo cargado correctamente",
				"fr": "Vidéo téléchargée avec succès"
			},
			"select-screen-workout": {
				"en": "Select Screen Workout",
				"it": "Seleziona Allenamento A Schermo",
				"es": "Seleccionar Entrenamiento En Pantalla",
				"fr": "Sélectionner l'Entraînement à l'Écran"
			},
			"workouts-planning": {
				"en": "Workouts Planning",
				"it": "Pianificazione dei Workout",
				"es": "Planificación de Entrenamientos",
				"fr": "Planification des Entraînements"
			},
			"single-workout-planning": {
				en: "Single Workout Planning",
				it: "Pianificazione di un Singolo Workout",
				es: "Planificación de Entrenamiento Único",
				fr: "Planification d'un Entraînement Unique"
			},
			"display-group": {
				en: "Room",
				it: "Sala",
				es: "Sala",
				fr: "Salle",
			},
			"slots-duration-error": {
				"en": "All slots on the calendar must have a duration greater than or equal to that of the selected workout.",
				"it": "Tutti gli slot sul calendario devono avere una durata maggiore o uguale di quella del workout selezionato.",
				"es": "Todos los espacios en el calendario deben tener una duración mayor o igual a la del entrenamiento seleccionado.",
				"fr": "Tous les créneaux du calendrier doivent avoir une durée supérieure ou égale à celle de l'entraînement sélectionné."
			},
			"slot-duration-error": {
				"en": "Slot calendar must have a duration greater than or equal to that of the selected workout.",
				"it": "Lo slot sul calendario devono avere una durata maggiore o uguale di quella del workout selezionato.",
				"es": "Espacio en el calendario deben tener una duración mayor o igual a la del entrenamiento seleccionado.",
				"fr": "Créneaux du calendrier doivent avoir une durée supérieure ou égale à celle de l'entraînement sélectionné."
			},
			"you-must-select-an-on-screen-workout": {
				"en": "You must select an on-screen Workout",
				"it": "Devi selezionare un allenamento a schermo",
				"es": "Debes seleccionar un entrenamiento De pantalla",
				"fr": "Vous devez sélectionner un entraînement à l'écran"
			},
			"hide-free-spots": {
				"en": "Hide Free Spots",
				"it": "Nascondi Posti Liberi",
				"es": "Ocultar Puestos Libres",
				"fr": "Masquer Places Disponibles"
			},
			"start-hour": {
				"en": "Start time",
				"it": "Ora inizio",
				"es": "Hora de inicio",
				"fr": "Heure de début"
			},
			"end-hour": {
				"en": "End time",
				"it": "Ora fine",
				"es": "Hora de finalización",
				"fr": "Heure de fin"
			},
			"you-are-cloning-the-selected-workouts": {
				en: "You are cloning the selected workouts.",
				it: "Stai clonando i workout selezionati.",
				es: "Estás clonando los entrenamientos seleccionados.",
				fr: "Vous clonez les séances d'entraînement sélectionnées."
			},
			"acceptance-date": {
				en: "Acceptance Date",
				it: "Data Accettazione",
				es: "Fecha Aceptación",
				fr: "Date Acceptation"
			},
			"type-policy-text-here": {
				en: "Type the policy text here",
				it: "Scrivi qui il testo della policy",
				es: "Escriba el texto de la política aquí",
				fr: "Tapez le texte de la politique ici",
			},
			"kiosk": {
				en: "Kiosk",
				it: "Kiosk",
				es: "Kiosk",
				fr: "Kiosk"
			},
			"no-kiosk": {
				en: "No Kiosk",
				it: "Nessun Kiosk",
				es: "Sin Kiosk",
				fr: "Aucun Kiosk",
			},
			"policies": {
				en: "Policies",
				it: "Policies",
				es: "Policies",
				fr: "Policies"
			},
			"Accepted": {
				en: "Accepted",
				it: "Accettato",
				es: "Aceptado",
				fr: "Accepté"
			},
			"NotAccepted": {
				en: "Not Accepted",
				it: "Non Accettato",
				es: "No Aceptado",
				fr: "Non Accepté"
			},
			"NotAnswered": {
				en: "Not Answered",
				it: "Non Risposto",
				es: "No Respondido",
				fr: "Non Répondu"
			},
			"new-policy": {
				en: "New Policy",
				it: "Nuova Policy",
				es: "Nueva Política",
				fr: "Nouvelle Politique"
			},
			"edit-policy": {
				en: "Edit Policy",
				it: "Modifica Policy",
				es: "Editar Política",
				fr: "Modifier la Politique"
			},
			"summary": {
				en: "Summary",
				it: "Riepilogo",
				es: "Resumen",
				fr: "Résumé"
			},
			"policy-will-be": {
				en: "The policy will be:",
				it: "La policy sarà:",
				es: "La política será:",
				fr: "La politique sera:"
			},
			"TermsOfPurchase": {
				en: "Terms of Purchase",
				it: "Termini di Acquisto",
				es: "Términos de Compra",
				fr: "Conditions d'Achat"
			},
			"JoinClub": {
				en: "Join Club",
				it: "Unione al Club",
				es: "Join Club",
				fr: "Join Club"
			},
			"publication-date": {
				en: "Publication Date",
				it: "Data di Pubblicazione",
				es: "Fecha de Publicación",
				fr: "Date de Publication"
			},
			"club-policies": {
				en: "Policies",
				it: "Policy",
				es: "Términos y Condiciones",
				fr: "Termes et Conditions"
			},
			"cannot-suspend-a-subscription-with-active-bookings": {
				en: "Cannot suspend a subscription with active bookings",
				it: "Impossibile sospendere un abbonamento con prenotazioni attive",
				es: "No se puede suspender una suscripción con reservas activas",
				fr: "Impossible de suspendre un abonnement avec des réservations actives"
			},
			"unable-to-copy-following-workouts": {
				en: "Unable to copy the following on-screen workouts:",
				it: "Impossibile copiare i seguenti allenamenti a schermo:",
				es: "No se pudieron copiar los siguientes entrenamientos de pantalla:",
				fr: "Impossible de copier les entraînements sur ècran:"
			}, 
			"unable-to-copy-following-club-workouts": {
				en: "Unable to copy the following workouts:",
				it: "Impossibile copiare i seguenti allenamenti :",
				es: "No se pudieron copiar los siguientes entrenamientos:",
				fr: "Impossible de copier les entraînements:"
			}, 
			"exercise-not-found": {
				en: "Exercise not found",
				it: "Esercizio non trovato",
				es: "Ejercicio no encontrado",
				fr: "Exercice non trouvé"
			},
			"exercise-not-found-in-destination-club": {
				en: "Exercise not found in destination club",
				it: "Esercizio non trovato nel club di destinazione",
				es: "Ejercicio no encontrado en el club de destino",
				fr: "Exercice non trouvé dans le club de destination"
			},
			"elements": {
				en: "Elements",
				it: "Elementi",
				es: "Elementos",
				fr: "Éléments"
			},
			"check-field-cardioZone": {
				en: "Check the HR Target field.",
				it: "Controlla il campo HR Target.",
				es: "Verifique el campo FC Target.",
				fr: "Vérifiez le champ FC Target."
			},
			"check-field-rPE": {
				en: "Check the RPE field.",
				it: "Controlla il campo RPE.",
				es: "Verifique el campo RPE.",
				fr: "Vérifiez le champ RPE."
			},
			"check-field-reps": {
				en: "Check the repetitions field.",
				it: "Controlla il campo ripetizioni.",
				es: "Verifique el campo de repeticiones.",
				fr: "Vérifiez le champ des répétitions."
			},
			"check-field-level": {
				en: "Check the equipment level field.",
				it: "Controlla il campo livello attrezzo.",
				es: "Verifique el campo de nivel de equipo.",
				fr: "Vérifiez le champ niveau de l'équipement."
			},
			"check-field-weight": {
				en: "Check the field weight.",
				it: "Controlla il campo peso.",
				es: "Verifique el campo de peso.",
				fr: "Vérifiez le champ de poids."
			},
			"check-repetition-interval-field": {
				en: "Check the repetition interval field.",
				it: "Controlla il campo intervallo ripetizioni.",
				es: "Verifique el campo de intervalo de repeticiones.",
				fr: "Vérifiez le champ intervalle de répétitions."
			},
			"check-weight-interval-field": {
				en: "Check the weight range field.",
				it: "Controlla il campo intervallo peso.",
				es: "Verifica el campo del rango de peso.",
				fr: "Vérifiez le champ de l'intervalle de poids."
			},
			"exercise-cannot-have-only-pause": {
				en: "An exercise cannot have only a pause.",
				it: "Un esercizio non può avere solo una pausa.",
				es: "Un ejercicio no puede tener solo una pausa.",
				fr: "Un exercice ne peut pas avoir seulement une pause."
			},
			"check-round-rest-field": {
				en: "Check the round rest field.",
				it: "Controlla il campo pausa round.",
				es: "Verifique el campo de descanso de la ronda.",
				fr: "Vérifiez le champ repos du round."
			},
			"check-rest-field": {
				en: "Check the rest field.",
				it: "Controlla il campo pausa.",
				es: "Verifique el campo de descans.",
				fr: "Vérifiez le champ repos."
			},
			"check-round-duration-field": {
				en: "Check the round duration field.",
				it: "Controlla il campo durata round.",
				es: "Verifique el campo de duración de la ronda.",
				fr: "Vérifiez le champ durée du round."
			},
			"check-notes-field": {
				en: "Check the notes field.",
				it: "Controlla il campo note.",
				es: "Verifique el campo de notas.",
				fr: "Vérifiez le champ notes."
			},
			"folder-and-all-workouts-inside-will-be-deleted": {
				en: "The folder and all workouts inside it will be deleted.",
				it: "La cartella e tutti i workout al suo interno verranno eliminati.",
				es: "La carpeta y todos los entrenamientos dentro de ella serán eliminados.",
				fr: "Le dossier et tous les entraînements qu'il contient seront supprimés."
			},
			"select-destination": {
				en: "Select Destination",
				it: "Seleziona Destinazione",
				es: "Seleccione Destino",
				fr: "Sélectionner La Destination",
			},
			"create-new-folder": {
				en: "Create New Folder:",
				it: "Crea Nuova Cartella:",
				es: "Crear Nueva Carpeta:",
				fr: "Créer Un Nouveau Dossier:",
			},
			"new-folder-name": {
				en: "New Folder Name",
				it: "Nome Nuova Cartella",
				es: "Nuevo Nombre De Carpeta",
				fr: "Nouveau Nom De Dossier",
			},
			"move": {
				en: "Move",
				it: "Sposta",
				es: "Mover",
				fr: "Déplacer",
			},
			"level-rank": {
				"en": "Rank",
				"it": "Rank",
				"es": "Rango",
				"fr": "Rang"
			},
			"no-level": {
				en: "No Level",
				it: "Nessun Livello",
				es: "Sin Nivel",
				fr: "Pas De Niveau",
			},
			"event": {
				en: "Event",
				it: "Evento",
				es: "Evento",
				fr: "Événement",
			},
			"support": {
				en: "Support",
				it: "Supporto",
				es: "Asistencia",
				fr: "Assistance",
			},
			"check-exercise-duration-filed": {
				en: "Check the exercise duration field.",
				it: "Controlla il campo della durata dell'esercizio.",
				es: "Verifica el campo de duración del ejercicio.",
				fr: "Vérifiez le champ de durée de l'exercice."
			},
			"exercises-duration-at-least-five-seconds": {
				en: "Exercise duration must be at least five seconds.",
				it: "La durata dell'esercizio deve essere di almeno cinque secondi.",
				es: "La duración del ejercicio debe ser de al menos cinco segundos.",
				fr: "La durée de l'exercice doit être d'au moins cinq secondes."
			},
			"duration-at-least-five-seconds": {
				en: "Duration must be at least five seconds.",
				it: "La durata deve essere di almeno cinque secondi.",
				es: "La duración debe ser de al menos cinco segundos.",
				fr: "La durée doit être d'au moins cinq secondes."
			},
			"impossible-to-delete-the-element": {
				en: "Impossible to delete the element because it contains {0} exercises;",
				it: "Impossibile eliminare l'elemento perché contiene {0} esercizi;",
				es: "Imposible eliminar el elemento porque contiene {0} ejercicios;",
				fr: "Impossible de supprimer l'élément car il contient {0} exercices;"
			},
			"unable-to-delete-element-stations": {
				en: "Unable to delete the element because it contains {0} exercises. Check that all stations do not have exercises.",
				it: "Impossibile eliminare l'elemento perchè contiene {0} esercizi. Controllare che tutte le stazioni non abbiano esercizi.",
				es: "No se puede eliminar el elemento porque contiene {0} ejercicios. Verifique que todas las estaciones no tengan ejercicios.",
				fr: "Impossible de supprimer l'élément car il contient {0} exercices. Vérifiez que toutes les stations n'ont pas d'exercices."
			},
			exercise: {
				en: "Exercise",
				it: "Esercizio",
				es: "Ejercicio",
				fr: "Exercice",
			},
			"overnight-avg": {
				en: "Overnight Avg",
				it: "Media Notturna",
				es: "Promedio Nocturno",
				fr: "Moyenne Nocturne"
			},
			"kcal-session": {
				en: "kcal/session",
				it: "kcal/sessione",
				es: "kcal/sesión",
				fr: "kcal/séance"
			},
			"upps-session": {
				en: "UPPs/session",
				it: "UPPs/sessione",
				es: "UPPs/sesión",
				fr: "UPPs/séance"
			},
			"open": {
				en: "Open",
				it: "Open",
				es: "Open",
				fr: "Open"
			},
			"you-are-cloning-a-circuit": {
				en: "You are cloning a circuit",
				it: "Stai clonando un circuito",
				es: "Estás clonando un circuito",
				fr: "Vous clonez un circuit"
			},
			"station-not-configured-in-the-club": {
				en: "Station not configured in the club",
				it: "Stazione non configurata nel club",
				es: "Estación no configurada en el club",
				fr: "Station non configurée dans le club"
			},
			"exercise-definition-not-found": {
				en: "Exercise definition not found. Exercise removed. Id: {0}.",
				it: "Definizione dell'esercizio non trovata. Esercizio rimosso. Id: {0}.",
				es: "Definición del ejercicio no encontrada. Ejercicio eliminado. Id: {0}.",
				fr: "Définition de l'exercice non trouvée. Exercice supprimé. Id: {0}."
			},
			"select-all": {
				"en": "Select all",
				"it": "Seleziona tutto",
				"es": "Seleccionar todo",
				"fr": "Sélectionner tout"
			},
			"pause-field-error": {
				en: "Pause field error.",
				it: "Errore campo pausa.",
				es: "Error en el campo de pausa.",
				fr: "Erreur de champ de pause."
			},
			"check-exercise-pause-field": {
				en: "Check exercise pause field.",
				it: "Controlla il campo pausa esercizio.",
				es: "Verifica el campo de pausa ejercicio.",
				fr: "Vérifiez le champ de pause exercice."
			},
			"check-set-field": {
				en: "Check set field.",
				it: "Controlla il campo set.",
				es: "Verifica el campo de serie.",
				fr: "Vérifiez le champ de série."
			},
			"check-round-pause-field": {
				en: "Check round pause field.",
				it: "Controlla il campo pausa del round.",
				es: "Verifica el campo de pausa de ronda.",
				fr: "Vérifiez le champ de pause de manche."
			},
			"check-round-field": {
				en: "Check round field.",
				it: "Controlla il campo round.",
				es: "Verifica el campo de ronda.",
				fr: "Vérifiez le champ de tour."
			},
			"check-exercise-duration-field": {
				en: "Check exercise duration field.",
				it: "Controlla il campo durata dell'esercizio.",
				es: "Verifica el campo duración del ejercicio.",
				fr: "Vérifiez le champ de durée de l'exercice."
			},
			"check-duration-filed": {
				en: "Check duration field.",
				it: "Controlla il campo durata.",
				es: "Verifica el campo duración.",
				fr: "Vérifiez le champ de durée."
			},
			"exercise-note-error": {
				en: "Exercise note error.",
				it: "Errore nota dell'esercizio.",
				es: "Error de nota del ejercicio.",
				fr: "Erreur de note d'exercice."
			},
			"check-the-element": {
				en: "Check the element {0}.",
				it: "Controlla l'elemento {0}.",
				es: "Verifica el elemento {0}.",
				fr: "Vérifiez l'élément {0}."
			},
			"you-must-have-at-least-one-exercise-in-each-set": {
				en: "You must have at least one exercise in each set.",
				it: "Devi avere almeno un esercizio in ogni set.",
				es: "Debes tener al menos un ejercicio en cada serie.",
				fr: "Vous devez avoir au moins un exercice dans chaque série."
			},
			"station-with-set-without-exercises": {
				en: "Station with set without exercises.",
				it: "Stazione con set senza esercizi.",
				es: "Estación con serie sin ejercicios.",
				fr: "Station avec série sans exercices."
			},
			"check-name-field": {
				en: "Check Name Field.",
				it: "Controlla il Campo Nome.",
				es: "Verificar Campo Nombre.",
				fr: "Vérifier le Champ Nom."
			},
			"check-description-field": {
				en: "Check the description field.",
				it: "Controlla il campo descrizione.",
				es: "Verifique el campo de descripción.",
				fr: "Vérifiez le champ description."
			},
			"select-club": {
				en: "Select Club",
				it: "Seleziona Club",
				es: "Seleccionar Club",
				fr: "Sélectionner un Club"
			},
			"copy-to-other-club": {
				"en": "Copy to other club",
				"it": "Copia in un altro club",
				"es": "Copiar en otro club",
				"fr": "Copier dans un autre club"
			},
			"you-are-about-to-delete-circuit": {
				en: "You are about to delete circuit",
				it: "Stai per eliminare il circuito",
				es: "Estás a punto de borrar el circuito",
				fr: "Vous êtes sur le point de supprimer le circuit"
			},
			"enable-stations-to-create-synchronized-workouts-on-multiple-TVs": {
				en: "Enable stations to create synchronized workouts on multiple TVs (each station is managed by a different Bridge)",
				it: "Abilita le stazioni per creare workout sincronizzati su più televisori (ogni stazione è gestita da un Bridge diverso)",
				es: "Habilitar las estaciones para crear entrenamientos sincronizados en varios televisores (cada estación es administrada por un Bridge diferente)",
				fr: "Activez les stations pour créer des entraînements synchronisés sur plusieurs téléviseurs (chaque station est gérée par un Bridge différent)"
			},
			"select-stations": {
				en: "Select Stations",
				it: "Seleziona Stazioni",
				es: "Seleccionar Estaciones",
				fr: "Sélectionner des Stations"
			},
			"stations": {
				en: "Stations",
				it: "Stazioni",
				es: "Estaciones",
				fr: "Stations"
			},
			"to-activate-stations-you-must-have-at-least-one-bridge-with-a-station": {
				en: "To activate stations, you must have at least one bridge with a station",
				it: "Per poter attivare le stazioni devi avere almeno un bridge con una stazione",
				es: "Para activar las estaciones, debes tener al menos un bridge con una estación",
				fr: "Pour activer les stations, vous devez avoir au moins un bridge avec une station"
			},
			"you-must-select-at-least-one-station-or-deactivate-the-stations": {
				en: "You must select at least one station, or deactivate the stations",
				it: "Devi selezionare almeno una stazione, oppure disattivare le stazioni",
				es: "Debes seleccionar al menos una estación o desactivar las estaciones",
				fr: "Vous devez sélectionner au moins une station, ou désactiver les stations"
			},
			"to-deactivate-stations-you-must-have-only-one-active-station": {
				en: "To deactivate stations you must have only one active station",
				it: "Per disattivare le stazioni devi avere attiva solo una stazione",
				es: "Para desactivar las estaciones debes tener solo una estación activa",
				fr: "Pour désactiver les stations, vous ne devez avoir qu'une seule station active"
			},
			"impossible-to-remove-station-because-it-contains-exercises": {
				en: "Impossible to remove the station because it contains {0} exercises.",
				it: "Impossibile rimuovere la stazione perché contiene {0} esercizi.",
				es: "Imposible eliminar la estación porque contiene {0} ejercicios.",
				fr: "Impossible de supprimer la station car elle contient {0} exercices."
			},
			"exercise-note": {
				en: "Exercise Note",
				it: "Nota sull'esercizio",
				es: "Nota del ejercicio",
				fr: "Note d'exercice"
			},
			"you-are-about-to-save-some-exercises-in-stations-that-not-exist": {
				en: "You are about to save some exercises in stations that do not exist. Stations: ",
				it: "Stai per salvare alcuni esercizi in stazioni che non esistono. Stazioni: ",
				es: "Estás a punto de guardar algunos ejercicios en estaciones que no existen. Estaciones: ",
				fr: "Vous êtes sur le point de sauvegarder certains exercices dans des stations qui n'existent pas. Stations : "
			},
			"Timer": {
				en: "Interval",
				it: "Interval",
				es: "Interval",
				fr: "Interval"
			},
			"EMOM": {
				en: "EMOM",
				it: "EMOM",
				es: "EMOM",
				fr: "EMOM",
			},
			"AMRAP": {
				en: "AMRAP",
				it: "AMRAP",
				es: "AMRAP",
				fr: "AMRAP",
			},
			"enable-stations": {
				en: "Enable Stations",
				it: "Abilita Stazioni",
				es: "Activar Estaciones",
				fr: "Activer les Stations"
			},
			"station": {
				en: "Station",
				it: "Stazione",
				es: "Estación",
				fr: "Station"
			},
			"exercises-pause": {
				en: "Exercises Pause",
				it: "Pausa degli Esercizi",
				es: "Pausa de Ejercicios",
				fr: "Pause des Exercices"
			},
			"lap-pause": {
				en: "Lap Pause",
				it: "Pausa Giro",
				es: "Pausa de Vuelta",
				fr: "Pause de Tour"
			},
			"lap-pause-field-at-least-five-seconds": {
				en: "The Lap Pause field must be at least five seconds.",
				it: "Il campo Pausa Giro deve essere di almeno cinque secondi.",
				es: "El campo Pausa de Vuelta debe ser de al menos cinco segundos.",
				fr: "Le champ Pause de Tour doit être d'au moins cinq secondes."
			},
			"create-bw-timer": {
				en: "Create Circuit",
				it: "Crea Circuito",
				es: "Crear Circuito",
				fr: "Créer un Circuit"
			},
			"edit-bw-timer": {
				en: "Edit Circuit",
				it: "Modifica Circuito",
				es: "Editar Circuito",
				fr: "Modifier un Circuit"
			},
			"add-bw-timer": {
				en: "Add Circuit",
				it: "Aggiungi Circuito",
				es: "Crear Circuito",
				fr: "Créer Circuit"
			},
			"remove-timer": {
				en: "Remove Circuit",
				it: "Rimuovi Circuito",
				es: "Eliminar Circuito",
				fr: "Supprimer un Circuit"
			},
			"brand": {
				en: "Organization",
				it: "Organizzazione",
				es: "Organización",
				fr: "Organisation"
			},
			"add-to-brand": {
				"en": "Add to Organization",
				"it": "Aggiungi all'Organizzazione",
				"es": "Agregar a la Organización",
				"fr": "Ajouter à l'Organisation"
			},
			"add-to-club": {
				"en": "Add to Club",
				"it": "Aggiungi al club",
				"es": "Agregar al club",
				"fr": "Ajouter au club"
			},
			"templates": {
				en: "Templates",
				it: "Modelli",
				es: "Plantillas",
				fr: "Modèles"
			},
			"no-activity-in-selected-period": {
				"en": "No activity in selected period",
				"it": "Nessuna attività nel periodo selezionato",
				"es": "Sin actividad en el período seleccionado",
				"fr": "Aucune activité dans la période sélectionnée"
			},
			"intensity-minutes": {
				"en": "Intensity Minutes",
				"it": "Minuti di Intensità",
				"es": "Minutos de Intensidad",
				"fr": "Minutes d'Intensité"
			},
			"resting-hr": {
				"en": "Resting HR",
				"it": "HR a Riposo",
				"es": "FC en Reposo",
				"fr": "FC au Repos"
			},
			"prc": {
				"en": "Prc",
				"it": "Prc",
				"es": "Prc",
				"fr": "Prc"
			},
			"rank": {
				"en": "Rank",
				"it": "Rank",
				"es": "Rank",
				"fr": "Rank"
			},
			"heartrate": {
				"en": "Heart Rate",
				"it": "Frequenza Cardiaca",
				"es": "Ritmo Cardíaco",
				"fr": "Fréquence Cardiaque"
			},
			"stress": {
				"en": "Stress",
				"it": "Stress",
				"es": "Stress",
				"fr": "Stress"
			},
			"stress": {
				"en": "Stress",
				"it": "Stress",
				"es": "Stress",
				"fr": "Stress"
			},
			"no-data": {
				"en": "No Data",
				"it": "Nessun Dato",
				"es": "Sin Datos",
				"fr": "Pas de Données"
			},
			"rest-stress-duration": {
				"en": "Rest Stress Duration",
				"it": "Durata Stress Riposo",
				"es": "Duración de Estrés en Reposo",
				"fr": "Durée du Stress au Repos"
			},
			"high-stress-duration": {
				"en": "High Stress Duration",
				"it": "Durata Stress Elevato",
				"es": "Duración de Estrés Alto",
				"fr": "Durée du Stress Élevé"
			},
			"medium-stress-duration": {
				"en": "Medium Stress Duration",
				"it": "Durata Stress Media",
				"es": "Duración de Estrés Medio",
				"fr": "Durée du Stress Moyen"
			},
			"low-stress-duration": {
				"en": "Low Stress Duration",
				"it": "Durata Stress Bassa",
				"es": "Duración de Estrés Bajo",
				"fr": "Durée du Stress Faible"
			},
			"completed": {
				"en": "Completed",
				"it": "Completato",
				"es": "Completado",
				"fr": "Terminé"
			},
			"to-do": {
				"en": "To Do",
				"it": "Da Fare",
				"es": "Por Hacer",
				"fr": "À Faire"
			},
			"sleep-FAIR": {
				"en": "Fair",
				"it": "Discreto",
				"es": "Fair",
				"fr": "Fair"
			},
			"sleep-POOR": {
				"en": "Poor",
				"it": "Scarso",
				"es": "Pobre",
				"fr": "Mauvais"
			},
			"sleep-GOOD": {
				"en": "Good",
				"it": "Buono",
				"es": "Bueno",
				"fr": "Bon"
			},
			"sleep-EXCELLENT": {
				"en": "Excellent",
				"it": "Eccellente",
				"es": "Excelente",
				"fr": "Excellent"
			},
			"health": {
				en: "Health",
				it: "Health",
				es: "Health",
				fr: "Health"
			},
			"garmin-health": {
				en: "Garmin Health",
				it: "Garmin Health",
				es: "Garmin Health",
				fr: "Garmin Health"
			},
			"resting-calories": {
				en: "Resting Calories",
				it: "Calorie a Riposo",
				es: "Calorías en Reposo",
				fr: "Calories au Repos"
			},
			"active-calories": {
				en: "Active Calories",
				it: "Calorie Attive",
				es: "Calorías Activas",
				fr: "Calories Actives"
			},
			"you-can-view-the-data-up-to-today-date": {
				en: "You can view the data up to today's date",
				it: "Puoi visualizzare i dati fino alla data odierna",
				es: "Puedes ver los datos hasta la fecha de hoy",
				fr: "Vous pouvez consulter les données jusqu'à la date d'aujourd'hui"
			},
			"avg-resting-hr": {
				en: "Average Resting HR",
				it: "HR a Riposo Media",
				es: "HR en Reposo Promedio",
				fr: "HR au Repos Moyenne"
			},
			"tot-activities": {
				en: "Total Activities",
				it: "Attività Totali",
				es: "Actividades Totales",
				fr: "Activités Totales"
			},
			"sleep": {
				en: "Sleep",
				it: "Sonno",
				es: "Sueño",
				fr: "Sommeil"
			},
			"avg-body-battery": {
				en: "Average Body Battery",
				it: "Body Battery Media",
				es: "Body Battery Promedio",
				fr: "Body Battery Moyenne"
			},
			"7-day-average": {
				en: "7-Day Average",
				it: "Media 7 giorni",
				es: "Promedio de 7 días",
				fr: "Moyenne sur 7 jours"
			},
			"avg-stress-level": {
				en: "Average Stress Level",
				it: "Livello di Stress Medio",
				es: "Nivel de Estrés Promedio",
				fr: "Niveau de Stress Moyen"
			},
			"intensity-minutes": {
				en: "Intensity Minutes",
				it: "Minuti di Intensità",
				es: "Minutos de Intensidad",
				fr: "Minutes d'Intensité"
			},
			"resting": {
				en: "Resting",
				it: "A riposo",
				es: "En reposo",
				fr: "Repos"
			},
			"body-battery": {
				en: "Body Battery",
				it: "Body Battery",
				es: "Body Battery",
				fr: "Body Battery"
			},
			"highest": {
				en: "Highest",
				it: "Più alto",
				es: "Más alto",
				fr: "Le plus élevé"
			},
			"lowest": {
				en: "Lowest",
				it: "Più basso",
				es: "Más bajo",
				fr: "Le plus bas"
			},
			"hrv-status": {
				en: "HRV Status",
				it: "Stato HRV",
				es: "Estado de HRV",
				fr: "État HRV"
			},
			"stress-level": {
				en: "Stress Level",
				it: "Livello di Stress",
				es: "Nivel de Estrés",
				fr: "Niveau de Stress"
			},
			"score": {
				en: "Score",
				it: "Punteggio",
				es: "Puntaje",
				fr: "Score"
			},
			"avg-score": {
				en: "Average Score",
				it: "Punteggio Medio",
				es: "Puntuación Promedio",
				fr: "Score Moyen"
			},
			"steps": {
				en: "Steps",
				it: "Passi",
				es: "Pasos",
				fr: "Pas"
			},
			"floors": {
				en: "Floors",
				it: "Piani",
				es: "Pisos",
				fr: "Étages"
			},
			"week-goal": {
				en: "Week Goal",
				it: "Obiettivo Settimanale",
				es: "Meta Semanal",
				fr: "Objectif Hebdomadaire"
			},
			"deep": {
				en: "Deep",
				it: "Profondo",
				es: "Profundo",
				fr: "Profond",
			},
			"light": {
				en: "Light",
				it: "Leggero",
				es: "Ligero",
				fr: "Léger",
			},
			"rem": {
				en: "REM",
				it: "REM",
				es: "MOR",
				fr: "Sommeil Paradoxal",
			},
			"awake": {
				en: "Awake",
				it: "Veglia",
				es: "Vigilia",
				fr: "Éveil",
			},
			"help": {
				en: "Help",
				it: "Aiuto",
				es: "Ayuda",
				fr: "Aide",
			},
			"news-title": {
				en: "What's New",
				it: "Nuove Funzionalità",
				es: "Novedades",
				fr: "Nouvelles fonctionnalités",
			},
			boxing: {
				en: "Combat",
				it: "Combat",
				es: "Combat",
				fr: "Combat",
			},
			punch: {
				en: "punch",
				it: "pugno",
				es: "puño",
				fr: "poing",
			},
			"you-are-about-to-delete": {
				en: "You are about to delete",
				it: "Stai per cancellare",
				es: "Estás a punto de cancelar",
				fr: "Vous êtes sur le point d'annuler",
			},
			"this-file-is-assigned-to": {
				en: "This workout is assigned to {0} athletes.",
				it: "Questo workout è assegnato a {0} atleti.",
				es: "Este entrenamiento está asignado a {0} atletas.",
				fr: "Cet entraînement est attribué à {0} athlètes.",
			},
			hit: {
				en: "hit",
				it: "colpo",
				es: "puño",
				fr: "poing",
			},
			mode: {
				en: "Mode",
				it: "Modalità",
				es: "Modo",
				fr: "Mode",
			},
			"visibility-days-must-be-greater-than-Booking-hours-by-24-hours": {
				en: "Visibility days must be greater than Booking hours by 24 hours.",
				it: "I giorni di visibilità devono essere superiori alle ore di prenotazione di 24 ore.",
				es: "Los días de visibilidad deben ser mayores que las horas de reserva en 24 horas.",
				fr: "Les jours de visibilité doivent être supérieurs aux heures de réservation de 24 heures.",
			},
			"4-week": {
				en: "4 Week",
				it: "4 Settimane",
				es: "4 Semanas",
				fr: "4 Semaines",
			},
			"7-days": {
				en: "7 Days",
				it: "7 Giorni",
				es: "7 Días",
				fr: "7 Jours"
			},
			week: {
				en: "Week",
				it: "Settimana",
				es: "Semana",
				fr: "Semaine",
			},
			"this-week": {
				en: "This week",
				it: "Questa Settimana",
				es: "Esta semana",
				fr: "Cette semaine",
			},
			"single-service": {
				en: "Single Service",
				it: "Singolo Servizio",
				es: "Servicio Unico",
				fr: "Service Unique",
			},
			origin: {
				en: "Origin",
				it: "Origine",
				es: "Origen",
				fr: "Origine",
			},
			"select-operator": {
				en: "Select operator",
				it: "Seleziona operatore",
				es: "Seleccionar operador",
				fr: "sélectionner l'opérateur",
			},
			"operator-name": {
				en: "Operator name",
				it: "Nome operatore",
				es: "Nombre del operador",
				fr: "Nom de l'opérateur",
			},
			operator: {
				en: "Operator",
				it: "Operatore",
				es: "Operador",
				fr: "Opérateur",
			},
			"enable-uptivo-live": {
				en: "Enable Uptivo LIVE",
				it: "Abilita Uptivo LIVE",
				es: "Activar Uptivo LIVE",
				fr: "Activer Uptivo LIVE",
			},
			"enable-activities": {
				en: "Enable Activities",
				it: "Abilita Attività",
				es: "Activar Actividades",
				fr: "Activer Planning",
			},
			"enable-on-demand": {
				en: "Enable On Demand",
				it: "Abilita On Demand",
				es: "Activar On Demand",
				fr: "Activer On Demand",
			},
			"disable-dashboard": {
				en: "Disable Dashboard",
				it: "Disabilita Dashboard",
				es: "Deshabilitar Dashboard",
				fr: "Désactiver Dashboard",
			},
			subscriptions: {
				en: "Subscriptions",
				it: "Abbonamenti",
				es: "Suscripciones",
				fr: "Abonnements",
			},
			"uptivo-on-demand": {
				en: "On Demand",
				it: "On Demand",
				es: "On Demand",
				fr: "On Demand",
			},
			"sensor-already-associated": {
				en: "Sensor Already Associated",
				it: "Sensore Già Associato",
				es: "Sensor Ya Asociado",
				fr: "Capteur Déjà Associé",
			},
			"associate-anyway": {
				en: "Associate Anyway",
				it: "Associa Comunque",
				es: "Asociar Igualmente",
				fr: "Associer Quand Même",
			},
			"this-sensor-is-already-associated-with-these-club-users": {
				en: "This sensor is already associated with these club users. \n If you proceed, the sensor will be disassociated from the other users.",
				it: "Questo sensore risulta già associato a questi utenti del club. \n Se si procede, il sensore verrà dissociato dagli altri utenti.",
				es: "Este sensor ya está asociado con estos usuarios del club. \n Si continúa, el sensor se desvinculará de los demás usuarios.",
				fr: "Ce capteur est déjà associé à ces utilisateurs du club. \n Si vous continuez, le capteur sera dissocié des autres utilisateurs.",
			},
			"this-sensor-is-already-associated-with-this-user": {
				en: "This sensor is already associated with this user.",
				it: "Questo sensore risulta già associato a questo utente",
				es: "Este sensor ya está asociado con este usuario.",
				fr: "Ce capteur est déjà associé à cet utilisateur.",
			},
			associate: {
				en: "Associate",
				it: "Associa",
				es: "Asociar",
				fr: "Associer",
			},
			"invite-user": {
				en: "Invite User",
				it: "Invita Utente",
				es: "Invitar usuario",
				fr: "Inviter un utilisateur",
			},
			create: {
				en: "Create",
				it: "Crea",
				es: "Crear",
				fr: "Créer",
			},
			expired: {
				en: "Expired",
				it: "Scaduto",
				es: "Caducado",
				fr: "Expiré",
			},
			time: {
				en: "Time",
				it: "Tempo",
				es: "Tiempo",
				fr: "Temps",
			},
			ora: {
				en: "Hour",
				it: "Ora",
				es: "Hora",
				fr: "Heure",
			},
			hide: {
				en: "Hide",
				it: "Nascondi",
				es: "Ocultar",
				fr: "Masquer",
			},
			speed: {
				en: "Speed",
				it: "Velocità",
				es: "Velocidad",
				fr: "Vitesse",
			},
			enable: {
				en: "Enable",
				it: "Abilita",
				es: "Activar",
				fr: "Activer",
			},
			disable: {
				"en": "Disable",
				"it": "Disabilita",
				"es": "Desactivar",
				"fr": "Désactiver"
			},
			unlimited: {
				en: "Unlimited",
				it: "Illimitato",
				es: "Ilimitada",
				fr: "Illimité",
			},
			"create-new": {
				en: "Create a new",
				it: "Crea un nuovo",
				es: "Crea un nuevo",
				fr: "Créer un nouveau",
			},
			"club-message": {
				en: "Message",
				it: "Messaggio",
				es: "Mensaje",
				fr: "Message",
			},
			"no-club-messages": {
				en: "There are no Message Templates set.",
				it: "Non ci sono modelli di messaggio impostati.",
				es: "No hay plantillas de mensaje establecidas.",
				fr: "Il n'y a pas de modèles de message définis.",
			},
			"select-message": {
				en: "Select a message",
				it: "Seleziona un messaggio",
				es: "Selecciona un mensaje",
				fr: "Sélectionnez un message",
			},
			"activities-not-enabled-club": {
				en: "Activities are not enabled for the selected club.",
				it: "Le attività non sono abilitate nel club selezionato.",
				es: "Las actividades no están habilitadas en el club seleccionado.",
				fr: "Les activités ne sont pas activées dans le club sélectionné.",
			},
			"dashboard-not-enabled-club": {
				en: "The dashboard is not enabled in the selected club.",
				it: "La dashboard non è abilitata nel club selezionato.",
				es: "El panel de control no está habilitado en el club seleccionado.",
				fr: "Le tableau de bord n'est pas activé dans le club sélectionné.",
			},
			"total-space-used": {
				en: "Total space used: ",
				it: "Spazio totale utilizzato: ",
				es: "Espacio total utilizado: ",
				fr: "Espace total utilisé: ",
			},
			"folder-space-used": {
				en: "Space used by the folder ",
				it: "Spazio utilizzato dalla cartella: ",
				es: "Espacio utilizado por la carpeta: ",
				fr: "Espace utilisé par le dossier: ",
			},
			biometrics: {
				en: "Biometrics",
				it: "Biometriche",
				es: "Biometría",
				fr: "Biométrie",
			},
			"add-measurements": {
				en: "Create measurements",
				it: "Crea misurazioni",
				es: "Crear medidas",
				fr: "Créer des mesures",
			},
			any: {
				en: "All",
				it: "Tutti",
				es: "Todos",
				fr: "Tous",
			},
			"new-tag": {
				en: "New Group",
				it: "Nuovo Gruppo",
				es: "Nuevo Grupo",
				fr: "Nouveau Groupe",
			},
			"no-tags-defined": {
				en: "You haven't defined any groups yet.",
				it: "Non hai ancora definito nessun gruppo.",
				es: "Aún no has definido ningún grupo.",
				fr: "Vous n'avez encore défini aucun groupe.",
			},
			"define-tags-help": {
				en: "Go to Club <i class='fa fa-arrow-right'></i> Settings to create nee groups and organize your members into groups.",
				it: "Vai in Club <i class='fa fa-arrow-right'></i> Impostazioni per creare nuovi gruppi e organizzare i tuoi membri in gruppi.",
				es: "Vaya a Club <i class='fa fa-arrow-right'></i> Ajustes para crear nuevos grupos y organizar a sus miembros en grupos.",
				fr: "Accédez à Club <i class='fa fa-arrow-right'></i> Réglages pour créer de nouveaux groupes et organiser vos membres en groupes.",
			},
			"select-tags": {
				en: "Filter By Groups",
				it: "Filtra Per Gruppi",
				es: "Filtrar Por Grupos",
				fr: "Filtrer Par Groupes",
			},
			"edit-training": {
				en: "Edit training",
				it: "Modifica allenamento",
				es: "Editar entrenamiento",
				fr: "Modifier l'entraînement",
			},
			trainings: {
				en: "Trainings",
				it: "Allenamenti",
				es: "Entrenamientos",
				fr: "Entraînements",
			},
			athletes: {
				en: "Athletes",
				it: "Atleti",
				es: "Deportistas",
				fr: "Athlètes",
			},
			roles: {
				en: "Roles",
				it: "Ruoli",
				es: "Roles",
				fr: "Rôles",
			},
			version: {
				en: "Version",
				it: "Versione",
				es: "Versión",
				fr: "Version",
			},
			notes: {
				en: "Notes",
				it: "Note",
				es: "Notas",
				fr: "Notes",
			},
			view: {
				en: "View",
				it: "Vedi",
				es: "Ver",
				fr: "Voir",
			},
			"shares-count": {
				en: "{0} shares",
				it: "{0} condivisioni",
				es: "{0} repartos",
				fr: "{0} partages",
			},
			"assign-tags": {
				en: "Add Gropus",
				it: "Aggiungi Gruppi",
				es: "Añadir Grupos",
				fr: "Ajouter Groupes",
			},
			"remove-tags": {
				en: "Remove Gropus",
				it: "Rimuovi Gruppi",
				es: "Quitar Grupos",
				fr: "Retirer Groupes",
			},
			"assign-tags-result": {
				en: "{0} users were added to the group.",
				it: "{0} utenti sono stati aggiunti al gruppo.",
				es: "Se agregaron {0} usuarios al grupo.",
				fr: "{0} utilisateurs ont été ajoutés au groupe.",
			},
			"remove-tags-result": {
				en: "{0} users were removed from the group.",
				it: "{0} utenti sono stati rimossi dal gruppo",
				es: "Se han eliminado {0} grupos.",
				fr: "{0} étiquettes ont été groupes",
			},
			"send-message-result": {
				en: "The message has been sent to {0} athletes.",
				it: "Il messaggio è stato inviato a {0} atleti.",
				es: "{0} usuarios fueron eliminados del grupo.",
				fr: "{0} utilisateurs ont été supprimés du groupe.",
			},
			"share-training-program-result": {
				en: "The program has been shared with {0} athletes (out of {1})",
				it: "Il programma è stato condiviso con {0} atleti (su {1})",
				es: "El programa fue compartido con {0} atletas (de {1})",
				fr: "Le programme a été partagé avec {0} athlètes (sur {1})",
			},
			"unshare-training-program-result": {
				en: "Sharing has been removed from {0} athletes (out of {1})",
				it: "La condivisione è stata rimossa da {0} atleti (su {1})",
				es: "Compartir ha sido eliminado por {0} atletas (de {1})",
				fr: "Le partage a été supprimé par {0} athlètes (sur {1})",
			},
			send: {
				en: "Send",
				it: "Invia",
				es: "Enviar",
				fr: "Envoyer",
			},
			"send-message": {
				en: "Send Message",
				it: "Invia Messaggio",
				es: "Enviar Mensaje",
				fr: "Envoyer Message",
			},
			"share-training-program": {
				en: "Share a Workout Program",
				it: "Condividi Programma di Allenamento",
				es: "Compartir Programa de Entrenamiento",
				fr: "Partager Programmes d'Entraînement",
			},
			share: {
				en: "Share",
				it: "Condividi",
				es: "Compartir",
				fr: "Partager",
			},
			unshare: {
				en: "Remove Sharing",
				it: "Rimuovi Condivisione",
				es: "Dejar de compartir",
				fr: "Ne pas partager",
			},
			progress: {
				en: "Progress",
				it: "Progresso",
				es: "Progreso",
				fr: "Progrès",
			},
			min: {
				en: "Min Value",
				it: "Minimo",
				es: "Valor mínimo",
				fr: "Valeur minimale",
			},
			avg: {
				en: "Average",
				it: "Media",
				es: "Promedio",
				fr: "Moyen",
			},
			max: {
				en: "Max",
				it: "Massimo",
				es: "Máximo",
				fr: "Maximale",
			},
			"invalid-range-error": {
				en: "The entered range is invalid",
				it: "L'intervallo inserito non è valido",
				es: "El rango introducido no es válido",
				fr: "La plage entrée est invalide",
			},
			"invalid-name": {
				en: "Invalid name",
				it: "Nome non valido",
				es: "Nombre inválido",
				fr: "Nom invalide",
			},
			"creation-date": {
				en: "Creation date",
				it: "Data Creazione",
				es: "Fecha creación",
				fr: "Date création",
			},
			"modification-date": {
				en: "Modification date",
				it: "Data Modifica",
				es: "Fecha modificación",
				fr: "Date modification",
			},
			"check-browser-settings": {
				en: "<p>It seems that some settings on your browser are preventing this app from working properly.</p><br><p>Please check your security settings and verify that <strong>cookies are enabled</ strong>, then reload this page.</p>",
				it: "<p>Sembra che alcune impostazioni del tuo browser stiano impedendo il corretto funzionamento di questa app.</p><br><p>Per favore controlla le impostazioni di sicurezza e verifica che i <strong>cookie siano abilitati</strong>, poi ricarica questa pagina.</p>",
				es: "<p>Parece que algunas configuraciones en su navegador están impidiendo que esta aplicación funcione correctamente.</p><br><p>Verifique sus configuraciones de seguridad y verifique que las <strong>cookies estén habilitadas</strong>, luego vuelve a cargar esta página.</p>",
				fr: "<p>Il semble que certains paramètres de votre navigateur empêchent cette application de fonctionner correctement.</p><br><p>Vérifiez vos paramètres de sécurité et vérifiez que les <strong>cookies sont activés</strong>, puis rechargez cette page.</p>",
			},
			"open-bridge": {
				en: "Open Bridge",
				it: "Apri Bridge",
				es: "Abre Bridge",
				fr: "Ouvrez Bridge",
			},
			"open-rooms-totem": {
				en: "Room Display",
				it: "Display Sale",
				es: "Room Display",
				fr: "Room Display",
			},
			"open-boxing-totem": {
				en: "Boxing Display",
				it: "Display Boxing",
				es: "Boxing Display",
				fr: "Boxing Display",
			},
			"check-connections": {
				en: "Check Connections",
				it: "Controlla le connessioni",
				es: "Comprobar las conexiones",
				fr: "Vérifiez les connexions",
			},
			"time-range": {
				en: "Time Range",
				it: "Intervallo temporale",
				es: "Intervalo de tiempo",
				fr: "Intervalle de temps",
			},
			range: {
				en: "Range",
				it: "Intervallo",
				es: "Intervalo",
				fr: "Intervalle",
			},
			"activation-date": {
				en: "Activation Date",
				it: "Data Attivazione",
				es: "Fecha de activación",
				fr: "Date d’activation",
			},
			"deactivation-date": {
				en: "Deactivation Date",
				it: "Data Disattivazione",
				es: "Fecha de desactivación",
				fr: "Date de désactivation",
			},
			"expiration-date": {
				en: "Expiration Date",
				it: "Data Scadenza",
				es: "Fecha De Expiración",
				fr: "Date d'Expiration",
			},
			recurring: {
				en: "Recurring",
				it: "Ricorrente",
				es: "Recurrente",
				fr: "Récurrent",
			},
			recurrence: {
				en: "Recurrence",
				it: "Ricorrenza",
				es: "Frequencia",
				fr: "Récurrence ",
			},
			installments: {
				en: "Installments",
				it: "Rate",
				es: "Cuotas",
				fr: "Versements",
			},
			"installment-price": {
				en: "Installment Price",
				it: "Prezzo Rate",
				es: "Precio a plazos",
				fr: "Prix ​​d'acompte",
			},
			invoices: {
				en: "Invoices",
				it: "Pagamenti",
				es: "Pagos",
				fr: "Paiements",
			},
			invoice: {
				en: "Invoice",
				it: "Fattura",
				es: "Factura",
				fr: "Facture"
			},
			amount: {
				en: "Amount",
				it: "Importo",
				es: "Cantidad",
				fr: "Montant",
			},
			"scheduled-end-date": {
				en: "Scheduled End",
				it: "Termine Programmato",
				es: "Término programado",
				fr: "Terme prévu",
			},
			disabled: {
				en: "Disabled",
				it: "Non attivo",
				es: "Inhabilitado",
				fr: "Inactif",
			},
			"mark-as-complete": {
				en: "Mark as complete?",
				it: "Segna come completato?",
				es: "¿Marcar como completo?",
				fr: "Marquer comme terminé ?",
			},
			"enter-valid-duration": {
				en: "Enter a valid duration value",
				it: "Inserisci un valore di durata valido",
				es: "Ingrese un valor de duración válido",
				fr: "Entrez une valeur de durée valide",
			},
			"assigned-to": {
				en: "Assigned To",
				it: "Assegnato A",
				es: "Asignado A",
				fr: "Assigné A",
			},
			"show-tasks-assigned-to-me": {
				en: "Show My Tasks",
				it: "Mostra i Miei Tasks",
				es: "Mostrar mis Tasks",
				fr: "Afficher Mes Tasks",
			},
			confirm: {
				en: "Confirm",
				it: "Conferma",
				es: "Confirmar",
				fr: "Confirmer",
			},
			edit: {
				en: "Edit",
				it: "Modifica",
				es: "Editar",
				fr: "Modifier",
			},
			remove: {
				en: "Remove",
				it: "Rimuovi",
				es: "Quitar",
				fr: "Retirer",
			},
			target: {
				en: "Target",
				it: "Obiettivo",
				es: "Objetivo",
				fr: "Objectif",
			},
			targets: {
				en: "Targets",
				it: "Obiettivi",
				es: "Objetivos",
				fr: "Objectifs",
			},
			today: {
				en: "Today",
				it: "Oggi",
				es: "Hoy",
				fr: "Aujourd'hui",
			},
			power: {
				en: "Power",
				it: "Potenza",
				es: "Potencia",
				fr: "Puissance",
			},
			force: {
				en: "Force",
				it: "Forza",
				es: "Fuerza",
				fr: "Force",
			},
			bpm: {
				en: "bpm",
				it: "bpm",
				es: "lpm",
				fr: "bpm",
			},
			"bpm-avg": {
				en: "bpm (avg)",
				it: "bpm (med)",
				es: "lpm (promedio)",
				fr: "bpm (moy.)",
			},
			"max-speed": {
				en: "Max Speed",
				it: "Max Velocità",
				es: "Velocidad máx.",
				fr: "Vitesse max.",
			},
			"total-calories": {
				en: "total calories",
				it: "calorie totali",
				es: "calorías totales",
				fr: "total de calories",
			},
			"heart-rate-zones": {
				en: "Heart Rate Zones",
				it: "Zone Cardio",
				es: "Zonas de Frecuencia Cardíaca",
				fr: "Zones de fréquence cardiaque",
			},
			"power-zones": {
				en: "Power Zones",
				it: "Zone Power",
				es: "Zonas de Potencia",
				fr: "Zones de puissance",
			},
			total: {
				en: "Total",
				it: "Totale",
				es: "Total",
				fr: "Total",
			},
			"device-id": {
				en: "Device Id",
				it: "Id dispositivo",
				es: "ID del dispositivo",
				fr: "Identifiant de l’appareil",
			},
			"ht-id-left": {
				en: "(Red) AL-",
				it: "(Rosso) AL-",
				es: "(Rojo) AL-",
				fr: "(Rouge) AL-",
			},
			"ht-id-right": {
				en: "(Yellow) AR-",
				it: "(Giallo) AR-",
				es: "(Amarillo) AR-",
				fr: "(Jaune) AR-",
			},
			users: {
				en: "Users",
				it: "Utenti",
				es: "Usuarios",
				fr: "Utilisateurs",
			},
			measure: {
				en: "Measure",
				it: "Misura",
				es: "Medida",
				fr: "Mesure",
			},
			value: {
				en: "Value",
				it: "Valore",
				es: "Valor",
				fr: "Valeur",
			},
			select: {
				en: "Select",
				it: "Seleziona",
				es: "Seleccionar",
				fr: "Sélectionner",
			},
			"change-display-group": {
				en: "Change Room",
				it: "Cambia Sala",
				es: "Cambiar Sala",
				fr: "Modifier Salle",
			},
			export: {
				en: "Export",
				it: "Esporta",
				es: "Exportar",
				fr: "Exporter",
			},
			role: {
				en: "Role",
				it: "Ruolo",
				es: "Oficio",
				fr: "Rôle",
			},
			print: {
				en: "Print",
				it: "Stampa",
				es: "Imprimir",
				fr: "Imprimer",
			},
			"go-to": {
				en: "Go to…",
				it: "Vai a…",
				es: "Ir…",
				fr: "Aller à…",
			},
			actions: {
				en: "Actions",
				it: "Azioni",
				es: "Acciones",
				fr: "Actions",
			},
			follow: {
				en: "Follow",
				it: "Segui",
				es: "Seguir",
				fr: "Suivre",
			},
			user: {
				en: "User",
				it: "Utente",
				es: "Usuario",
				fr: "Utilisateur",
			},
			left: {
				en: "Left",
				it: "Sinistra",
				es: "Izquierda",
				fr: "Gauche",
			},
			right: {
				en: "Right",
				it: "Destra",
				es: "Derecha",
				fr: "Droite",
			},
			"full-name": {
				en: "Full Name",
				it: "Nome Completo",
				es: "Nombre completo",
				fr: "Nom complet",
			},
			"date-time": {
				en: "Date/time",
				it: "Data/ora",
				es: "Fecha/hora",
				fr: "Date/Heure",
			},
			"dont-follow": {
				en: "Stop Following",
				it: "Non Seguire",
				es: "No Seguir",
				fr: "Ne Pas Suivre",
			},
			watch: {
				en: "Get Notifications",
				it: "Ricevi Notifiche",
				es: "Recibir notificaciones",
				fr: "Recevoir des notifications",
			},
			trainer: {
				en: "Trainer",
				it: "Trainer",
				es: "Entrenador",
				fr: "Entraîneur",
			},
			"trainer-operator": {
				en: "Trainer / Operator",
				it: "Trainer / Operatore",
				es: "Entrenador / Operador",
				fr: "Formateur / Opérateur",
			},
			trainers: {
				en: "Trainers",
				it: "Trainer",
				es: "Entrenadores",
				fr: "Entraîneurs",
			},
			"try-again": {
				en: "Try again",
				it: "Riprova",
				es: "Intentar de nuevo",
				fr: "Réessayer",
			},
			"something-went-wrong": {
				en: "Something went wrong",
				it: "Qualcosa è andato storto",
				es: "Algo salió mal",
				fr: "Une erreur est survenue",
			},
			"could-not-get-training": {
				en: "Error getting the training data.",
				it: "C'è stato un errore nel recuperare i dati del training.",
				es: "Error al obtener los datos del entrenamiento.",
				fr: "Erreur lors de l'obtention des données d'entraînement.",
			},
			"could-not-save-comment": {
				en: "Error saving the comment.",
				it: "C'è stato un errore nel salvataggio del commento.",
				es: "Error al guardar el comentario.",
				fr: "Erreur lors de l’enregistrement du commentaire.",
			},
			"open-in-uptivo": {
				en: "Open in my.uptivo.fit",
				it: "Apri in my.uptivo.fit",
				es: "Abrir en my.uptivo.fit",
				fr: "Ouvrir dans uptivo.fit",
			},
			"go-to-new-portal": {
				en: "Go to the new portal",
				it: "Vai al nuovo portale",
				es: "Ir al nuevo portal",
				fr: "Aller sur le nouveau portail",
			},
			"uptivo-fit-moved-title": {
				en: "Uptivo is migrating to my.uptivo.fit",
				it: "Uptivo si sposta su my.uptivo.fit",
				es: "Uptivo está migrando a my.uptivo.fit",
				fr: "Uptivo migre vers my.uptivo.fit",
			},
			"uptivo-fit-moved-text": {
				en: "<h3>Hi there!</h3><p>As of April 23rd 2018 the Uptivo platform is exclusively available at <strong>my.uptivo.fit</strong>.</p><p>Remember to update your browser bookmarks!</p>",
				it: "<h3>Ciao!</h3>Dal 23 aprile 2018, il portale Uptivo è raggiungibile esclusivamente da <strong>my.uptivo.fit</strong>.<br>Ricordati di aggiornare i preferiti del tuo browser!",
				es: "<h3>¡Hola!</h3>A partir del 23 de abril de 2018, Uptivo está disponible exclusivamente en <strong>my.uptivo.fit</strong>.<br>¡Recuerde actualizar los marcadores de su navegador!",
				fr: "<h3>Bonjour!</h3>À compter du 23 avril 2018, Uptivo est exclusivement disponible sur <strong>my.uptivo.fit</strong>.<br>N'oubliez pas de mettre à jour les favoris de votre navigateur!",
			},
			"add-comment": {
				en: "Add Feedback",
				it: "Commenta",
				es: "Añadir comentarios",
				fr: "Ajouter un feedback",
			},
			"edit-comment": {
				en: "Change your Feedback",
				it: "Cambia il tuo commento",
				es: "Cambiar sus comentarios",
				fr: "Modifier le feedback",
			},
			"training-comments-others": {
				en: "Your Trainer's feedback",
				it: "Il feedback del tuo trainer",
				es: "Comentarios de su entrenador",
				fr: "Le feedback de votre entraîneur",
			},
			"top-workout-athlete": {
				en: "That was awesome!",
				it: "Alla grande!",
				es: "¡Asombroso!",
				fr: "C'était génial!",
			},
			"top-workout-others": {
				en: "TOP workout!",
				it: "Allenamento TOP!",
				es: "¡Entrenamiento TOP!",
				fr: "SUPER entraînement!",
			},
			"good-workout-athlete": {
				en: "Way to go!",
				it: "Niente male!",
				es: "¡Así se hace!",
				fr: "Bravo!",
			},
			"good-workout-others": {
				en: "Good Workout!",
				it: "Buon allenamento!",
				es: "¡Buen entrenamiento!",
				fr: "Bon entraînement!",
			},
			"can-do-more-athlete": {
				en: "Could've done better…",
				it: "Ero un po' giù…",
				es: "Podría haberlo hecho mejor…",
				fr: "Peut mieux faire…",
			},
			"can-do-more-others": {
				en: "Not your best workout…",
				it: "Puoi fare di meglio…",
				es: "No ha sido su mejor entrenamiento…",
				fr: "Ça n'a pas été votre meilleur entraînement…",
			},
			"rate-this-workout-athlete": {
				en: "How did I feel?",
				it: "Come è andata?",
				es: "¿Cómo me sentí?",
				fr: "Comment me suis-je senti?",
			},
			"rate-this-workout-others": {
				en: "Add your feedback",
				it: "Commenta il training",
				es: "Añadir comentarios",
				fr: "Ajouter votre feedback",
			},
			"no-next-items": {
				en: "There are no further items",
				it: "Non ci sono elementi successivi",
				es: "No hay más artículos",
				fr: "Il n'y a pas d'autres éléments",
			},
			"no-prev-items": {
				en: "There are no previous items",
				it: "Non ci sono elementi precedenti",
				es: "No hay artículos anteriores",
				fr: "Il n'y a aucun élément précédent",
			},
			"user-training-programs": {
				en: "My Workout programs",
				it: "I miei Programmi di Allenamento",
				es: "Mis Programas de Entrenamiento",
				fr: "Mes Programmes d'Entraînement",
			},
			"my-files": {
				en: "My Files",
				it: "I Miei File",
				es: "Mis Archivos",
				fr: "Mes Fichiers",
			},
			"message-templates": {
				en: "Messages",
				it: "Messaggi",
				es: "Mensajes",
				fr: "Messages",
			},
			language: {
				en: "Language",
				it: "Lingua",
				es: "Idioma",
				fr: "Langue",
			},
			"change-picture": {
				en: "Change Picture",
				it: "Cambia Immagine",
				es: "Cambiar imagen",
				fr: "Changer d'image",
			},
			"remove-this-image": {
				en: "Do you really want to remove this image?",
				it: "Vuoi veramente rimuovere questa immagine?",
				es: "¿Realmente quieres eliminar esta imagen?",
				fr: "Voulez-vous vraiment supprimer cette image?",
			},
			"image-uploaded": {
				en: "Image Uploaded Successfully",
				it: "Immagine aggiornata con successo",
				es: "La imagen se ha subido correctamente",
				fr: "Téléchargement de l'image réussi",
			},
			picture: {
				en: "Picture",
				it: "Immagine",
				es: "Imagen",
				fr: "Image",
			},
			"mark-all-as-read": {
				en: "Mark all as read",
				it: "Segna tutto come letto",
				es: "Marcar todos como leídos",
				fr: "Marquer tous comme lus",
			},
			"no-new-notifications": {
				en: "There are no new notifications",
				it: "Non sono presenti nuove notifiche",
				es: "No hay nuevas notificaciones",
				fr: "Il n'y a pas de nouvelles notifications",
			},
			"see-all-notifications": {
				en: "See All Notifications",
				it: "Guarda tutte le notifiche",
				es: "Ver todas las notificaciones",
				fr: "Voir toutes les notifications",
			},
			"go-club-logs": {
				en: "Go to Club Events Registry",
				it: "Vai al registro Eventi del Club",
				es: "Ir al Registro Eventos del Club",
				fr: "Aller au Registre Événements du Club",
			},
			"club-logs-registry": {
				en: "Club Logs Registry",
				it: "Registro Eventi del Club",
				es: "Registro Eventos del Club",
				fr: "Registre Événements du Club",
			},
			"no-new-tasks": {
				en: "There are no new tasks",
				it: "Non sono presenti nuovi tasks",
				es: "No hay nuevas tasks",
				fr: "Il n'y a pas de nouvelles tasks",
			},
			"see-all-tasks": {
				en: "See All tasks",
				it: "Guarda tutti i tasks",
				es: "Ver todas tasks",
				fr: "Voir toutes tasks",
			},
			"avg-calories": {
				en: "Avg Calories",
				it: "Calorie Medie",
				es: "Calorías promedio",
				fr: "Calories moy.",
			},
			"min-hr": {
				en: "Min HR",
				it: "FC Min",
				es: "FC mín",
				fr: "FC min.",
			},
			"avg-speed": {
				en: "Avg Speed",
				it: "Velocità Media",
				es: "Velocidad promedio",
				fr: "Vitesse moy.",
			},
			"avg-pace": {
				en: "Avg Pace",
				it: "Ritmo Medio",
				es: "Pasos promedio",
				fr: "Allure moy.",
			},
			pace: {
				en: "Pace",
				it: "Ritmo",
				es: "Pasos",
				fr: "Allure",
			},
			"avg-power": {
				en: "Avg Power",
				it: "Potenza Med",
				es: "Potencia promedio",
				fr: "Puissance moy.",
			},
			"avg-force": {
				en: "Avg Force",
				it: "Forza Med",
				es: "Fuerza promedio",
				fr: "Force moy.",
			},
			"avg-cadence": {
				en: "Avg Cadence",
				it: "Cadenza Med",
				es: "Cadencia promedio",
				fr: "Cadence moy.",
			},
			"max-power": {
				en: "Max Power",
				it: "Potenza Max",
				es: "Potencia máx",
				fr: "Puissance max.",
			},
			"avg-time": {
				en: "Avg Time",
				it: "Tempo Med",
				es: "Tiempo promedio",
				fr: "Temps moy.",
			},
			"bar-chart": {
				en: "Bar Chart",
				it: "Grafico a Barre",
				es: "Gráfico de barras",
				fr: "Diagramme",
			},
			"line-chart": {
				en: "Line Chart",
				it: "Grafico a Linea",
				es: "Gráfico de Líneas",
				fr: "Graphique linéaire",
			},
			"new-email": {
				en: "New Email",
				it: "Nuova Email",
				es: "Correo electrónico nuevo",
				fr: "Nouvelle adresse e-mail",
			},
			"confirm-email": {
				en: "Confirm Email",
				it: "Conferma Email",
				es: "Confirmar correo electrónico",
				fr: "Confirmer l'adresse e-mail",
			},
			"change-email": {
				en: "Change Email",
				it: "Cambia Email",
				es: "Cambiar dirección de correo electrónico",
				fr: "Changer l'e-mail",
			},
			"change-email-info": {
				en: "You are about to change the email you use for login and Uptivo notifications",
				it: "Stai per cambiare l'email usata per il login e per le notifiche di Uptivo",
				es: "Está a punto de cambiar el correo electrónico que utiliza para iniciar sesión y las notificaciones de Uptivo",
				fr: "Vous êtes sur le point de modifier l'e-mail que vous utilisez pour les connexions et les notifications Uptivo",
			},
			"add-sensor": {
				en: "Add Sensor",
				it: "Aggiungi Sensore",
				es: "Añadir Sensor",
				fr: "Ajouter un capteur",
			},
			"add-uptivo-sensor": {
				en: "Add Uptivo Sensor by ID",
				it: "Aggiungi Sensore Uptivo con ID",
				es: "Añadir Uptivo Sensor por ID",
				fr: "Ajouter la ceinture Uptivo par identifiant",
			},
			"add-uptivo-sensor-desc": {
				en: "Please type the 7-digit ID that you can find on the back of your Uptivo Sensor.",
				it: "Scrivi l’ID a 7 cifre stampato sul retro del tuo sensore Uptivo.",
				es: "Por favor, introduzca la ID de 7 dígitos que puede encontrar en la parte posterior de su Sensor Uptivo.",
				fr: "Veuillez taper l'identifiant à 7 chiffres que vous pouvez trouver à l'arrière de votre Capteur Uptivo.",
			},
			"add-mz-sensor": {
				en: "Add MZ Sensor by SN",
				it: "Aggiungi Sensore MZ con SN",
				es: "Añadir MZ Sensor por SN",
				fr: "Ajouter la ceinture MZ par SN",
			},
			"add-garmin-sensor": {
				en: "Add Garmin Sensor by SN",
				it: "Aggiungi Sensore Garmin con SN",
				es: "Añadir Sensor Garmin por SN",
				fr: "Ajouter la ceinture Garmin par SN",
			},
			"edit-demo-user": {
				en: "Edit Demo User",
				it: "Modifica Utente Demo",
				es: "Editar usuario demo",
				fr: "Modifier l'Utilisateur Démo",
			},
			notifications: {
				en: "Notifications",
				it: "Notifiche",
				es: "Notificaciones",
				fr: "Notifications",
			},
			rankings: {
				en: "Rankings",
				it: "Classifiche",
				es: "Posiciones",
				fr: "Classements",
			},
			ranking: {
				en: "Ranking",
				it: "Classifica",
				es: "Clasificación",
				fr: "Classement",
			},
			objectives: {
				en: "Objectives",
				it: "Obiettivi",
				es: "Objetivos",
				fr: "Objectifs",
			},
			"ranking-prc": {
				en: "Ranking Prc",
				it: "Classifica Prc",
				es: "Clasificación Prc",
				fr: "Classement Prc",
			},
			"public-rankings": {
				en: "Public Rankings",
				it: "Classifiche Pubbliche",
				es: "Clasificaciones Públicas",
				fr: "Classements Publics",
			},
			"interactive-rankings": {
				it: "Classifiche Interattive",
				en: "Interactive Rankings",
				es: "Clasificaciones Interactivas",
				fr: "Classements Interactifs"
			},
			"automatic-rotation": {
				it: "Rotazione Automatica",
				en: "Automatic Rotation",
				es: "Rotación Automática",
				fr: "Rotation Automatique"
			},
			"no-public-rankings": {
				en: "No Public Rankings",
				it: "Nessuna Classifica Pubblica",
				es: "Sin Clasificaciones Públicas",
				fr: "Aucun Classement Public",
			},
			"uptivo-sensor-id": {
				en: "Uptivo Sensor ID",
				it: "ID del Sensore Uptivo",
				es: "ID del Sensor Uptivo",
				fr: "Identification du Capteur Uptivo",
			},
			"mz-sensor-id": {
				en: "MZ Sensor SN",
				it: "SN del Sensore MZ",
				es: "SN del Sensor MZ",
				fr: "SN du Capteur MZ",
			},
			"garmin-sensor-id": {
				en: "Garmin Sensor SN",
				it: "SN del Sensore Garmin",
				es: "SN del Sensor Garmin",
				fr: "SN du Capteur Garmin",
			},
			optional: {
				en: "optional",
				it: "opzionale",
				es: "opcional",
				fr: "optionnel",
			},
			account: {
				en: "Account",
				it: "Account",
				es: "Cuenta",
				fr: "Compte",
			},
			"creation-successful": {
				en: "Creation successful",
				it: "Creazione effettuata con successo",
				es: "Se ha creado correctamente",
				fr: "Création réussie",
			},
			"update-successful": {
				en: "Update successful",
				it: "Aggiornamento riuscito",
				es: "Actualización exitosa",
				fr: "Mise à jour réussie",
			},
			"operation-failed": {
				en: "Operation failed",
				it: "Operazione fallita",
				es: "Operación fallida.",
				fr: "L'opération n'a pas abouti",
			},
			"operation-complete": {
				en: "Operation complete",
				it: "Operazione completata",
				es: "Operación completa",
				fr: "Opération terminée",
			},
			"changes-saved": {
				en: "Successfully saved changes",
				it: "Cambiamenti effettuati con successo",
				es: "Los cambios se han guardado correctamente",
				fr: "Changements enregistrés avec succès",
			},
			"delete-successful": {
				en: "Delete successful",
				it: "Cancellazione effettuata con successo",
				es: "Eliminado correctamente",
				fr: "Suppression réussie",
			},
			"get-failed": {
				en: "Couldn't load data from server",
				it: "Non è stato possibile scaricare i dati dal server",
				es: "No se pudieron cargar los datos del servidor",
				fr: "Impossible de charger les données du serveur",
			},
			"creation-failed": {
				en: "Creation error",
				it: "Errore di creazione",
				es: "Error al crear",
				fr: "Erreur lors de la création",
			},
			"update-failed": {
				en: "Error updating data",
				it: "Errore nell'aggiornamento dei dati",
				es: "Error al actualizar los datos",
				fr: "Erreur lors de la mise à jour des données",
			},
			"delete-failed": {
				en: "Deletion error",
				it: "Errore nella cancellazione dei dati",
				es: "Error de eliminación",
				fr: "Erreur lors de la suppression",
			},
			error: {
				en: "Error",
				it: "Errore",
				es: "Error",
				fr: "Erreur",
			},
			badge: {
				en: "Badge",
				it: "Badge",
				es: "Badge",
				fr: "Badge",
			},
			"server-error": {
				en: "Network or Server Problem",
				it: "Errore di rete o del server",
				es: "Problema de red o servidor",
				fr: "Problème de réseau ou de serveur",
			},
			"component-load-error": {
				en: "This component could not be downloaded, check the network and reload the page",
				it: "Non è stato possibile scaricare questo componente, verificare la rete e ricaricare la pagina",
				es: "Este componente no se pudo descargar, verifique la red y vuelva a cargar la página",
				fr: "Ce composant n'a pas pu être téléchargé, vérifiez le réseau et rechargez la page",
			},
			"error-license-limit-exceeded": {
				en: "No License or Limits Exceeded",
				it: "Nessuna licenza o limiti superati",
				es: "Sin licencia o límites excedidos",
				fr: "Aucune licence, ou limites dépassées",
			},
			"error-no-license": {
				en: "No Valid License",
				it: "Nessuna licenza valida",
				es: "Sin licencia válida",
				fr: "Pas de licence valable",
			},
			miles: {
				en: "miles",
				it: "miglia",
				es: "millas",
				fr: "miles",
			},
			rename: {
				en: "Rename",
				it: "Rinomina",
				es: "Cambiar el nombre",
				fr: "Renommer",
			},
			"age-comprised-between": {
				en: "Age must be comprised between {0} and {1}",
				it: "L'età deve essere compresa tra {0} e {1}",
				es: "La edad debe estar comprendida entre {0} y {1}",
				fr: "L'âge doit être compris entre {0} et {1}",
			},
			"value-multiple-of": {
				en: "Value must be multiple of {0} seconds",
				it: "Il valore deve essere multiplo di {0} secondi",
				es: "El valor debe ser múltiplo de {0} segundos",
				fr: "La valeur doit être multiple de {0} secondes",
			},
			"enter-valid-number": {
				en: "Please enter a valid number (separators: '{0}' for thousands, '{1}' for decimals)",
				it: "Inserisci un numero valido (separatori: '{0}' per migliaia, '{1}' per decimali)",
				es: "Ingrese un número válido (separadores: '{0}' para miles, '{1}' para decimales)",
				fr: "Veuillez saisir un nombre valide (séparateurs: '{0}' pour les milliers, '{1}' pour les décimaux)",
			},
			"enter-valid-url": {
				en: "Please enter a valid web URL starting with http:// or https://",
				it: "Inserisci un URL web valido che inizi con http:// o https://",
				es: "Ingrese una URL web válida que comience con http:// o https://",
				fr: "Veuillez entrer une URL Web valide commençant par http:// ou https://",
			},
			"enter-valid-ipv4": {
				en: "Please enter a valid IPv4 address",
				it: "Inserisci un indirizzo IPv4 valido",
				es: "Por favor, introduzca una dirección de IPv4 válida",
				fr: "Veuillez saisir une adresse IPv4 valide",
			},
			status: {
				en: "Status",
				it: "Stato",
				es: "Estado",
				fr: "État",
			},
			add: {
				en: "Add",
				it: "Aggiungi",
				es: "Añadir",
				fr: "Ajouter",
			},
			cancel: {
				en: "Cancel",
				it: "Annulla",
				es: "Cancelar",
				fr: "Annuler",
			},
			distance: {
				en: "Distance",
				it: "Distanza",
				es: "Distancia",
				fr: "Distance",
			},
			calories: {
				en: "Calories",
				it: "Calorie",
				es: "Calorías",
				fr: "Calories",
			},
			"add-new-group": {
				en: "Add New Room",
				it: "Aggiungi Nuova Sala",
				es: "Añadir Nueva Sala",
				fr: "Ajouter Une Nouvelle Salle",
			},
			phone: {
				en: "Phone",
				it: "Telefono",
				es: "Teléfono",
				fr: "Téléphone",
			},
			"max-hr": {
				en: "Max HR",
				it: "FC Max",
				es: "FC máx.",
				fr: "FC max.",
			},
			"avg-hr": {
				en: "Avg HR",
				it: "FC Med",
				es: "FC promedio",
				fr: "FC moy.",
			},
			en: {
				en: "English",
				it: "Inglese",
				es: "Inglés",
				fr: "Anglais",
			},
			logo: {
				en: "Logo",
				it: "Logo",
				es: "Logotipo",
				fr: "Logo",
			},
			delete: {
				en: "Delete",
				it: "Elimina",
				es: "Eliminar",
				fr: "Supprimer",
			},
			"change-logo": {
				en: "Change Logo",
				it: "Cambia Logo",
				es: "Cambiar logotipo",
				fr: "Modifier le logo",
			},
			"save-changes": {
				en: "Save",
				it: "Salva",
				es: "Guardar",
				fr: "Enregistrer",
			},
			close: {
				en: "Close",
				it: "Chiudi",
				es: "Cerrar",
				fr: "Fermer",
			},
			"clear-selection": {
				en: "Deselect All",
				it: "Deseleziona tutto",
				es: "Deseleccionar todo",
				fr: "Désélectionner tous",
			},
			"resize-logo": {
				en: "Resize Logo",
				it: "Ridimensiona Logo",
				es: "Cambiar el tamaño del logotipo",
				fr: "Redimensionner le logo",
			},
			submit: {
				en: "Submit",
				it: "Invia",
				es: "Enviar",
				fr: "Transmettre",
			},
			email: {
				en: "Email",
				it: "Email",
				es: "Correo electrónico",
				fr: "E-mail",
			},
			clubs: {
				en: "Clubs",
				it: "Club",
				es: "Club",
				fr: "Club",
			},
			club: {
				en: "Club",
				it: "Club",
				es: "Club",
				fr: "Club",
			},
			equipment: {
				en: "Equipment",
				it: "Attrezzature",
				es: "Equipo",
				fr: "Équipement",
			},
			guest: {
				en: "Guest",
				it: "Guest",
				es: "Guest",
				fr: "Guest",
			},
			athlete: {
				en: "Athlete",
				it: "Atleta",
				es: "Deportista",
				fr: "Athlète",
			},
			manager: {
				en: "Manager",
				it: "Manager",
				es: "Gerente",
				fr: "Gestionnaire",
			},
			"athlete-small": {
				en: "A",
				it: "A",
				es: "D",
				fr: "A",
			},
			"trainer-small": {
				en: "T",
				it: "T",
				es: "E",
				fr: "T",
			},
			"manager-small": {
				en: "M",
				it: "M",
				es: "G",
				fr: "M",
			},
			gender: {
				en: "Gender",
				it: "Sesso",
				es: "Sexo",
				fr: "Genre",
			},
			text: {
				en: "Text",
				it: "Testo",
				es: "Texto",
				fr: "Texte",
			},
			author: {
				en: "Author",
				it: "Autore",
				es: "Autor",
				fr: "Auteur",
			},
			"nickname-display": {
				en: "Nickname (display name)",
				it: "Nickname (nome a schermo)",
				es: "Apodo (nombre que se muestra)",
				fr: "Pseudo (nom d'affichage)",
			},
			unspecified: {
				en: "Unspecified",
				it: "Non Specificato",
				es: "No especificado",
				fr: "Non spécifié",
			},
			males: {
				en: "Males",
				it: "Maschi",
				es: "Hombres",
				fr: "Hommes",
			},
			male: {
				en: "Male",
				it: "Maschio",
				es: "Hombre",
				fr: "Homme",
			},
			females: {
				en: "Females",
				it: "Femmine",
				es: "Mujeres",
				fr: "Femmes",
			},
			female: {
				en: "Female",
				it: "Femmina",
				es: "Mujer",
				fr: "Femme",
			},
			"unspecified-small": {
				en: "NA",
				it: "ND",
				es: "NE",
				fr: "NA",
			},
			"male-small": {
				en: "M",
				it: "M",
				es: "H",
				fr: "M",
			},
			"female-small": {
				en: "F",
				it: "F",
				es: "M",
				fr: "F",
			},
			nickname: {
				en: "Nickname",
				it: "Nickname",
				es: "Apodo",
				fr: "Pseudo",
			},
			country: {
				en: "Country",
				it: "Paese",
				es: "País",
				fr: "Pays",
			},
			"country-required": {
				en: "Country *",
				it: "Paese *",
				es: "País *",
				fr: "Pays *",
			},
			"time-zone": {
				en: "Time Zone",
				it: "Time Zone",
				es: "Zona Horaria",
				fr: "Fuseau Horaire",
			},
			"time-zone-required": {
				en: "Time Zone *",
				it: "Time Zone *",
				es: "Zona Horaria *",
				fr: "Fuseau Horaire *",
			},
			"add-new": {
				en: "Add New",
				it: "Aggiungi Nuovo",
				es: "Añadir Nuevo",
				fr: "Ajouter nouveau",
			},
			age: {
				en: "Age",
				it: "Età",
				es: "Edad",
				fr: "Âge",
			},
			"physical-settings": {
				en: "Physical Settings",
				it: "Impostazioni Biometriche",
				es: "Configuración física",
				fr: "Paramètres physiques",
			},
			"weight-ms": {
				en: "Weight",
				it: "Peso",
				es: "Peso",
				fr: "Poids",
			},
			"Weight-ms": {
				en: "Weight",
				it: "Peso",
				es: "Peso",
				fr: "Poids",
			},
			height: {
				en: "Height",
				it: "Altezza",
				es: "Altura",
				fr: "Taille",
			},
			"height-required": {
				en: "Height *",
				it: "Altezza *",
				es: "Altura *",
				fr: "Taille *",
			},
			"hr-sensor": {
				en: "HR Sensor",
				it: "Sensore Cardio",
				es: "Sensor de FC",
				fr: "Capteur FC",
			},
			"hr-sensors": {
				en: "HR Sensors",
				it: "Sensori Cardio",
				es: "Sensores de FC",
				fr: "Capteurs FC",
			},
			"remove-sensor": {
				en: "Remove Sensor",
				it: "Rimuovi Sensore",
				es: "Eliminar el sensor",
				fr: "Supprimer le capteur",
			},
			"no-associated-sensors": {
				en: "No associated sensors",
				it: "Nessun sensore associato",
				es: "Sin sensores asociados",
				fr: "Aucun capteur associé",
			},
			default: {
				en: "Default",
				it: "Default",
				es: "Predeterminado",
				fr: "Défaut",
			},
			custom: {
				en: "Custom",
				it: "Manuale",
				es: "Personalizado",
				fr: "Personnalisé",
			},
			name: {
				en: "Name",
				it: "Nome",
				es: "Nombre",
				fr: "Nom",
			},
			title: {
				en: "Title",
				it: "Titolo",
				es: "Título",
				fr: "Titre",
			},
			settings: {
				en: "Settings",
				it: "Impostazioni",
				es: "Ajustes",
				fr: "Réglages",
			},
			setup: {
				en: "Setup",
				it: "Setup",
				es: "Setup",
				fr: "Setup",
			},
			"general-settings": {
				en: "General Settings",
				it: "Impostazioni generali",
				es: "Ajustes generales",
				fr: "Paramètres généraux",
			},
			"user-info": {
				en: "Users Info",
				it: "Info Utenti",
				es: "Información de los usuarios",
				fr: "Informations sur les utilisateurs",
			},
			"zone-error-msg": {
				en: "Invalid data - the zone limit has to be less than the next and greater than previous zone limit",
				it: "Dati non validi - il valore della zona deve essere inferiore al successivo e superiore al precededente",
				es: "Datos inválidos - el límite de la zona debe ser menor que el siguiente y mayor que el límite de la zona anterior",
				fr: "Données non valides - la limite de zone doit être inférieure à la limite suivante, et supérieure à la limite de zone précédente",
			},
			"target-zone": {
				en: "Target Zone",
				it: "Target Zone",
				es: "Zona objetivo",
				fr: "Zone cible",
			},
			"log-out": {
				en: "Log Out",
				it: "Esci",
				es: "Cerrar sesión",
				fr: "Se déconnecter",
			},
			profile: {
				en: "Profile",
				it: "Profilo",
				es: "Perfil",
				fr: "Profil",
			},
			duration: {
				en: "Duration",
				it: "Durata",
				es: "Duración",
				fr: "Durée",
			},
			months: {
				en: "Months",
				it: "Mesi",
				es: "Meses",
				fr: "Mois"
			},
			days: {
				en: "Days",
				it: "Giorni",
				es: "Días",
				fr: "Jours",
			},
			day: {
				en: "Day",
				it: "Giorno",
				es: "Día",
				fr: "Journée",
			},
			"no-training-to-display": {
				en: "No trainings to display",
				it: "Non ci sono training da mostrare",
				es: "No hay entrenamientos apropiados para mostrar",
				fr: "Aucun entraînement à afficher",
			},
			"duration-small": {
				en: "duration",
				it: "durata",
				es: "duración",
				fr: "durée",
			},
			"calories-small": {
				en: "calories",
				it: "calorie",
				es: "calorías",
				fr: "calories",
			},
			"distance-small": {
				en: "distance",
				it: "distanza",
				es: "distancia",
				fr: "distance",
			},
			"speed-small": {
				en: "speed",
				it: "velocità",
				es: "velocidad",
				fr: "vitesse",
			},
			meters: {
				en: "meters",
				it: "metri",
				es: "metros",
				fr: "mètres",
			},
			minutes: {
				en: "minutes",
				it: "minuti",
				es: "minutos",
				fr: "minutes",
			},
			seconds: {
				en: "seconds",
				it: "secondi",
				es: "secondes",
				fr: "minutes",
			},
			"are-you-sure": {
				en: "Are you sure?",
				it: "Sei sicuro?",
				es: "¿Está seguro?",
				fr: "Êtes vous sûr?",
			},
			"first-day": {
				en: "First Day of the Week",
				it: "Primo Giorno della Settimana",
				es: "Primer día de la semana",
				fr: "Premier jour de la semaine",
			},
			"date-format": {
				en: "Date Format",
				it: "Formato Data",
				es: "Formato de fecha",
				fr: "Format de date",
			},
			"time-format": {
				en: "Time Format",
				it: "Formato Ora",
				es: "Formato de hora",
				fr: "Format horaire",
			},
			units: {
				en: "Units",
				it: "Unità di Misura",
				es: "Unidades",
				fr: "Unités",
			},
			"delete-all": {
				en: "Delete all",
				it: "Cancella tutto",
				es: "Borrar todo",
				fr: "Tout effacer",
			},
			"provide-valid-date": {
				en: "Please provide a valid date",
				it: "Per favore inserisci una data valida",
				es: "Por favor, escriba un tiempo válido",
				fr: "Veuillez saisir une date valide",
			},
			"provide-valid-time": {
				en: "Please provide a valid time",
				it: "Per favore inserisci un'ora valida",
				es: "Por favor, scriba una hora válida",
				fr: "Veuillez saisir une heure valide",
			},
			"provide-valid-email": {
				en: "Please provide a valid email address",
				it: "Per favore inserisci una email valida",
				es: "Por favor, introduzca una dirección de correo electrónico válida",
				fr: "Veuillez saisir une adresse e-mail valide.",
			},
			"yes-leave-club": {
				en: "Yes, leave the club!",
				it: "Si, lascia il Club!",
				es: "¡Sí, deje el club!",
				fr: "Oui, quitter le club!",
			},
			"uptivo-live": {
				en: "LIVE",
				it: "LIVE",
				es: "LIVE",
				fr: "LIVE",
			},
			"training-title": {
				en: "Title",
				it: "Titolo",
				es: "Título",
				fr: "Titre",
			},
			"training-description": {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			"create-live-training": {
				en: "Create Live Training",
				it: "Crea Live Training",
				es: "Crear Live Training",
				fr: "Créer Live Training",
			},
			"live-training-start-confirm": {
				en: "Are you sure you want to start this live training?",
				it: "Sei sicuro di voler iniziare questo live training?",
				es: "¿Estás seguro de que quieres comenzar este entrenamiento en vivo?",
				fr: "Voulez-vous vraiment commencer cette entraînement en direct",
			},
			"live-training-stop-confirm": {
				en: "Are you sure you want to stop this live training?",
				it: "Sei sicuro di voler terminare questo live training?",
				es: "¿Estás seguro de que quieres detener este entrenamiento en vivo?",
				fr: "Voulez-vous vraiment commencer arrêtez entraînement en direct",
			},
			"delete-live-training-confirm": {
				en: "Are you sure you want to delete this live training?",
				it: "Sei sicuro di voler canellare questo live training?",
				es: "Estás seguro de que deseas eliminar esta capacitación en vivo?",
				fr: "Voulez-vous vraiment supprimer cette entraînement en direct?",
			},
			"athlete-successfully-remove": {
				en: "Athlete successfully removed",
				it: "Atleta rimosso con successo",
				es: "Atleta eliminado con éxito",
				fr: "Athlète retiré avec succès",
			},
			"successfully-create-live-training": {
				en: "Successfully create live training",
				it: "Live training creato con successo",
				es: "Crea exitosamente entrenamiento en vivo",
				fr: "Créer avec succès une entraînement en direct",
			},
			"successfully-edited-live-training": {
				en: "Successfully edited live training",
				it: "Live training modificato con successo",
				es: "Entrenamiento en vivo editado con éxito",
				fr: "Entraînement en direct modifiée avec succès",
			},
			"successfully-delete-live-training": {
				en: "Live training successfully deleted",
				it: "Live training cancellato con successo",
				es: "Entrenamiento en vivo eliminado con éxito",
				fr: "L' entraînement en direct a bien été supprimée",
			},
			"successfully-emptied-participant-list": {
				en: "Participant list emptied successfully",
				it: "Lista partecipanti svuotata con successo",
				es: "Lista de participantes vaciada con éxito",
				fr: "Liste des participants vidée avec succès",
			},
			"successfully-stop-live-training": {
				en: "Live training successfully stopped",
				it: "Live training interrotto con successo",
				es: "Entrenamiento en vivo se detuvo con éxito",
				fr: "L' entraînement en direct s'est arrêté avec succès",
			},
			"successfully-start-live-training": {
				en: "Live training successfully started",
				it: "Live training avviato con successo",
				es: "El entrenamiento en vivo comenzó con éxito",
				fr: "L' entraînement en direct a démarré avec succès",
			},
			"stop-successfully": {
				en: "Successfully stopped",
				it: "Interrotto con successo",
				es: "Se detuvo exitosamente",
				fr: "Arrêté avec succès",
			},
			"start-successfully": {
				en: "Successfully started",
				it: "Avviato con successo",
				es: "Comenzó con éxito",
				fr: "Démarré avec succès",
			},
			"start-error": {
				en: "Start error",
				it: "Errore di avvio",
				es: "Error de inicio",
				fr: "Erreur de démarrage",
			},
			"must-select-trainer": {
				en: "No trainer selected",
				it: "Nessun trainer selezionato",
				es: "Ningún entrenador seleccionado",
				fr: "Aucun formateur sélectionné",
			},
			"live-training-already-actived": {
				en: "It's already an active live training",
				it: "Risulta gia' un live training attivo",
				es: "Ya es un entrenamiento activo en vivo",
				fr: "C'est déjà un entraînement active en direct",
			},
			"live-training-already-actived-for-trainer": {
				en: "It's already an active training for this trainer",
				it: "Risulta gia' un training attivo per questo trainer",
				es: "Ya es un entrenamiento activo para este entrenador",
				fr: "C'est déjà un entraînement active pour ce formateur",
			},
			"add-athletes": {
				en: "Add Athletes",
				it: "Aggiungi Atleti",
				es: "Añadir atletas",
				fr: "Ajouter athlètes",
			},
			"resend-invitation": {
				en: "Resend Invitation",
				it: "Rimanda invito",
				es: "Reenviar invitacíon",
				fr: "Renvoyer l'invitation",
			},
			"resend-invitation-confirm": {
				en: "Are you sure you want to resend the invitation for the user ",
				it: "Sei sicuro di voler rimandare l' invito per l utente ",
				es: "¿Está seguro de que desea reenviar la invitación para el usuario?",
				fr: "Voulez-vous vraiment renvoyer l'invitation à l'utilisateur",
			},
			"start-live-training": {
				en: "Start Live Training",
				it: "Iniza Allenamento Live",
				es: "Comience El Entrenamiento",
				fr: "Commencez L' Entraînement",
			},
			color: {
				en: "Color",
				it: "Colore",
				es: "Color",
				fr: "Couleur",
			},
			"trainer-name": {
				en: "Trainer name",
				it: "Nome trainer",
				es: "Nombre del entrenador",
				fr: "Nom du formateur",
			},
			"select-trainer": {
				en: "Select Trainer",
				it: "Seleziona Trainer",
				es: "Seleccionar Entrenador",
				fr: "Sélectionnez Le Entraîneur",
			},
			"change-trainer": {
				en: "Change Trainer",
				it: "Cambia Trainer",
				es: "Cambiar entrenador",
				fr: "Changer de Entraîneur",
			},
			"select-staff": {
				en: "Select Staff",
				it: "Seleziona Staff",
				es: "Seleccionar Staff",
				fr: "Sélectionnez Staff",
			},
			"change-staff": {
				en: "Change Staff",
				it: "Cambia Staff",
				es: "Cambiar Staff",
				fr: "Changer Staff",
			},
			"remove-trainer": {
				en: "Remove",
				it: "Rimuovi",
				es: "Eliminar",
				fr: "Supprimer",
			},
			"participants-max": {
				en: "Participants/max",
				it: "Partecipanti/max",
				es: "Participantes/max",
				fr: "Participants/max",
			},
			"not-able-to-bring-back": {
				en: "You will not be able to recover this data!",
				it: "Non sarà possibile recuperare questi dati!",
				es: "¡No podrá recuperar este registro!",
				fr: "Vous ne pourrez pas récupérer ces données!",
			},
			Single: {
				en: "Lesson",
				it: "Lezione",
				es: "Lesson",
				fr: "Lesson",
			},
			Course: {
				en: "Course",
				it: "Corso",
				es: "Course",
				fr: "Évènements",
			},
			participants: {
				en: "Participants",
				it: "Partecipanti",
				es: "Participantes",
				fr: "Participants",
			},
			onsite: {
				en: "Onsite",
				it: "In Presenza",
				es: "En Sitio",
				fr: "Sur Site",
			},
			home: {
				en: "Online",
				it: "Online",
				es: "En Línea",
				fr: "En Ligne",
			},
			"onsite-participants": {
				en: "Onsite participants",
				it: "Partecipanti in presenza",
				es: "Participantes en el sitio",
				fr: "Participants sur site",
			},
			"home-participants": {
				en: "Online participants",
				it: "Partecipanti online",
				es: "Participantes en línea",
				fr: "Participants en Ligne",
			},
			"remove-class-participants": {
				en: "Do you want to remove all participants?",
				it: "Vuoi rimuovere tutti i partecipanti?",
				es: "¿Desea eliminar a todos los participantes?",
				fr: "Voulez-vous supprimer tous les participants?",
			},
			"remove-class-participants-insite": {
				en: "Do you want to remove all onsite participants?",
				it: "Vuoi rimuovere tutti i partecipanti in presenza?",
				es: "¿Desea eliminar a todos los participantes en el sitio?",
				fr: "Voulez-vous supprimer tous les participants sur site?",
			},
			"remove-class-participants-home": {
				en: "Do you want to remove all online participants?",
				it: "Vuoi rimuovere tutti i partecipanti online?",
				es: "¿Desea eliminar a todos los participantes en línea?",
				fr: "Voulez-vous supprimer tous les participants en ligne?",
			},
			search: {
				en: "Search",
				it: "Cerca",
				es: "Buscar",
				fr: "Recherche",
			},
			type: {
				en: "Type",
				it: "Tipo",
				es: "Tipo",
				fr: "Type",
			},
			place: {
				en: "Location",
				it: "Luogo",
				es: "Sitio",
				fr: "Lieu",
			},
			"clear-filters": {
				en: "Clear Filters",
				it: "Reset Filtri",
				es: "Borrar Filtros",
				fr: "Effacer Filtres",
			},
			published: {
				en: "Active",
				it: "Attivo",
				es: "Activo",
				fr: "Actif",
			},
			unpublished: {
				en: "Inactive",
				it: "Inattivo",
				es: "Inactivo",
				fr: "Inactif",
			},
			"proceed-anyway": {
				en: "Do you want to proceed anyway?",
				it: "Vuoi procedere comunque?",
				es: "¿Quieres continuar de todos modos?",
				fr: "Voulez-vous quand même continuer?",
			},
			single: {
				en: "Lesson",
				it: "Lezione",
				es: "Lección",
				fr: "Leçon",
			},
			course: {
				en: "Course",
				it: "Corso",
				es: "Curso",
				fr: "Évènements",
			},
			group: {
				en: "Group",
				it: "Gruppo",
				es: "Grupo",
				fr: "Groupe",
			},
			Group: {
				en: "Lesson Group",
				it: "Gruppo Di Lezioni",
				es: "Grupo Lecciones",
				fr: "Groupe Training",
			},
			calendar: {
				en: "Calendar",
				it: "Calendario",
				es: "Calendario",
				fr: "Calendrier",
			},
			calendars: {
				en: "Calendars",
				it: "Calendari",
				es: "Calendarios",
				fr: "Calendriers",
			},
			activities: {
				en: "Activities",
				it: "Attività",
				es: "Actividades",
				fr: "Activités",
			},
			"1_day": {
				en: "1 Day",
				it: "1 Giorno",
				es: "1 Día",
				fr: "1 Jour",
			},
			x_days: {
				en: "{0} Days",
				it: "{0} Giorni",
				es: "{0} Días",
				fr: "{0} Jours",
			},
			every_day: {
				en: "Every Day",
				it: "Ogni Giorno",
				es: "Cada Día",
				fr: "Tous les Jours",
			},
			every_x_days: {
				en: "Every {0} Days",
				it: "Ogni {0} Giorni",
				es: "Cada {0} Días",
				fr: "Tous les {0} Jours",
			},

			"1_month": {
				en: "1 Month",
				it: "1 Mese",
				es: "1 Mes",
				fr: "1 Mois",
			},
			x_months: {
				en: "{0} Months",
				it: "{0} Mesi",
				es: "{0} Meses",
				fr: "{0} Mois",
			},
			every_month: {
				en: "Every Month",
				it: "Ogni Mese",
				es: "Cada Mes",
				fr: "Chaque Mois",
			},
			every_x_months: {
				en: "Every {0} Months",
				it: "Ogni {0} Mesi",
				es: "Cada {0} Meses",
				fr: "Tous les {0} Mois",
			},

			"1_year": {
				en: "1 Year",
				it: "1 Anno",
				es: "1 Año",
				fr: "1 Ans",
			},
			x_years: {
				en: "{0} Years",
				it: "{0} Anni",
				es: "{0} Años",
				fr: "{0} Années",
			},
			every_year: {
				en: "Every Year",
				it: "Ogni Anno",
				es: "Todos los Años",
				fr: "Chaque Année",
			},
			every_x_years: {
				en: "Every {0} Years",
				it: "Ogni {0} Anni",
				es: "Cada {0} Años",
				fr: "Tous les {0} Ans",
			},

			change: {
				en: "Change",
				it: "Cambia",
				es: "Cambiar",
				fr: "Modifier",
			},
			"added-date": {
				en: "Added Date",
				it: "Data Aggiunta",
				es: "Fecha Añadida",
				fr: "Date d'Ajout",
			},
			date: {
				en: "Date",
				it: "Data",
				es: "Fecha",
				fr: "Date",
			},
			"start-date": {
				en: "Start Date",
				it: "Data Inizio",
				es: "Fecha Inicio",
				fr: "Date Début",
			},
			"end-date": {
				en: "End Date",
				it: "Data Fine",
				es: "Fecha final",
				fr: "Date Fin",
			},
			"cannot-delete-status-published": {
				en: "Could not delete because the status is 'Active'",
				it: "Impossibile cancellare perchè lo stato è 'Attivo'",
				es: "No se pudo eliminar porque el estado es 'Activo'",
				fr: "Impossible de supprimer car l'état est 'Actif'",
			},
			"my-activities": {
				en: "Upcoming Activities",
				it: "Prossime Attività",
				es: "Próximas Actividades",
				fr: "Activités À Venir",
			},
			"rename-file": {
				en: "Rename File",
				it: "Rinomina il file",
				es: "Renombrar archivo",
				fr: "Renommer le fichier",
			},
			"rename-folder": {
				en: "Rename Folder",
				it: "Rinomina La Cartella",
				es: "Renombrar Carpeta",
				fr: "Renommer Le Dossier",
			},
			"new-name": {
				en: "New name",
				it: "Nuovo nome",
				es: "Nuevo nombre",
				fr: "Nouveau nom",
			},
			trophies: {
				en: "Trophies",
				it: "Trofei",
				es: "Trofeos",
				fr: "Trophées",
			},
			"club-trophies": {
				en: "Club Trophies",
				it: "Trofei Del Club",
				es: "Trofeos Del Club",
				fr: "Trophées de club",
			},
			challenges: {
				en: "Challenges",
				it: "Sfide",
				es: "Desafíos",
				fr: "Défis",
			},
			objectives: {
				en: "Objectives",
				it: "Obiettivi",
				es: "Objetivos",
				fr: "Objectifs",
			},
			challenge: {
				en: "Challenge",
				it: "Sfida",
				es: "Desafío",
				fr: "Défi",
			},
			description: {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			"short-description": {
				en: "Short Description",
				it: "Descrizione Breve",
				es: "Breve Descripción",
				fr: "Brève Description",
			},
			"create-challenge": {
				en: "Create Challenge",
				it: "Crea Sfida",
				es: "Crear Desafío",
				fr: "Créer Un Défi",
			},
			"challenge-contains-invalid-dates": {
				en: "Challenge contains invalid dates",
				it: "La Sfida contiene date non valide",
				es: "La Desafío contiene fechas inválidas",
				fr: "La Défi contient des dates non valides",
			},
			"challenge-start-date-after-end": {
				en: "Challenge end date is earlier than a start date",
				it: "La data di fine della sfida è anteriore alla data di inizio",
				es: "La fecha de finalización del desafío es anterior a la fecha de inicio",
				fr: "La date de fin du défi est antérieure à une date de début",
			},
			"challenge-end-date-must-be-after-start-date": {
				en: "The challenge end date must be after the start date",
				it: "La data di fine della sfida deve essere successiva alla data di inizio",
				es: "La fecha de finalización del desafío debe ser posterior a la fecha de inicio",
				fr: "La date de fin du défi doit être postérieure à la date de début",
			},
			"challenge-cannot-last-more-than-365-days": {
				"en": "The challenge cannot last more than 365 days",
				"it": "La sfida non può durare più di 365 giorni",
				"es": "El desafío no puede durar más de 365 días",
				"fr": "Le défi ne peut pas durer plus de 365 jours"
			},
			"challenge-exceeded-maximum-months": {
				en: "Challenge has exceeded the maximum number of months: ",
				it: "La sfida ha superato il numero massimo di mesi: ",
				es: "La Desafío ha excedido el número máximo de meses: ",
				fr: "La Défi a dépassé le nombre maximum de mois: ",
			},
			"challenge-succesfully-deleted": {
				en: "challenge succesfully deleted",
				it: "sfida eliminata con successo",
				es: "Desafío eliminado con éxito",
				fr: "Défi supprimé avec succès",
			},
			"challenge-start-date-must-be-in-future": {
				en: "The challenge start date must be in the future",
				it: "La data di inizio della sfida deve essere nel futuro",
				es: "La fecha de inicio del desafío debe ser futura",
				fr: "La date de début du défi doit être dans le futur",
			},
			"select-image": {
				en: "Select Image",
				it: "Seleziona Immagine",
				es: "Selecciona Imagen",
				fr: "Sélectionner Image",
			},
			"select-color": {
				en: "Select Color",
				it: "Seleziona Colore",
				es: "Seleccionar Color",
				fr: "Choisissez Couleur",
			},
			"club-challenges": {
				en: "Club Challenges",
				it: "Sfide Del Club",
				es: "Retos Del Club",
				fr: "Défis de club",
			},
			"brand-challenges": {
				en: "Brand Challenges",
				it: "Sfide dell' Organizzazione",
				es: "Retos del Organización",
				fr: "Défis de Organisation",
			},
			"uptivo-live-for-windows": {
				en: "Uptivo LIVE for Windows",
				it: "Uptivo LIVE per Windows",
				es: "Uptivo LIVE para Windows",
				fr: "Uptivo LIVE pour Windows",
			},
			"uptivo-live-link": {
				en: "https://uptivo.fit/support/download/",
				it: "https://uptivo.fit/it/support/download/",
				es: "https://uptivo.fit/support/download/",
				fr: "https://uptivo.fit/support/download/",
			},
			"link-copied": {
				en: "Link copied!",
				it: "Link copiato!",
				es: "Enlace copiado!",
				fr: "Lien copié!",
			},
			"click-to-copy-link": {
				en: "Click to copy link",
				it: "Clicca per copiare il link",
				es: "Haga clic para copiar el enlace",
				fr: "Cliquer pour copier le lien",
			},
			"click-to-download": {
				"en": "Click to download",
				"it": "Clicca per scaricare",
				"es": "Haz clic para descargar",
				"fr": "Cliquez per scaricare"
			},
			"total-duration": {
				en: "Total duration",
				it: "Durata totale",
				es: "Duración total",
				fr: "Durée totale",
			},
			"valid-zones-points": {
				en: "Valid zones Points",
				it: "Punti zone valide",
				es: "Puntos de zonas válidas",
				fr: "Points de zones valides",
			},
			"valid-zones-time": {
				en: "Time in valid zones",
				it: "Tempo in zone valide",
				es: "Hora en zonas válidas",
				fr: "Heure dans les zones valides",
			},
			"valid-zones-time-prc": {
				en: "% time in valid zones",
				it: "% tempo in zone valide",
				es: "% hora en zonas válidas",
				fr: "% heure dans les zones valides",
			},
			to: {
				en: "To",
				it: "A",
				es: "A",
				fr: "À",
			},
			"active-challenges": {
				en: "Active",
				it: "Attivo",
				es: "Activos",
				fr: "Actifs",
			},
			"history-challenges": {
				en: "History",
				it: "Storico",
				es: "Historia",
				fr: "L'histoire",
			},
			"credits-and-subscriptions": {
				en: "Credits And Subscriptions",
				it: "Crediti e Abbonamenti",
				es: "Créditos y Suscripciones",
				fr: "Crédits Et Abonnements",
			},
			management: {
				en: "Management",
				it: "Gestione",
				es: "Gestión",
				fr: "Gestion",
			},
			engagement: {
				en: "Engagement",
				it: "Engagement",
				es: "Engagement",
				fr: "Engagement",
			},
			publish: {
				en: "Activate",
				it: "Attiva",
				es: "Activar",
				fr: "Activer",
			},
			unpublish: {
				en: "Deactivate",
				it: "Disattiva",
				es: "Desactivar",
				fr: "Désactiver",
			},
			credits: {
				en: "Credits",
				it: "Crediti",
				es: "Créditos",
				fr: "Crédits",
			},
			"insufficient-club-credits": {
				en: "Insufficient SMS club credits",
				it: "Crediti SMS del club insufficienti",
				es: "Créditos SMS del club insuficientes",
				fr: "Crédits SMS de club insuffisants",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti richiesti",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"training-type": {
				en: "Training type",
				it: "Tipo allenamento",
				es: "Tipo entrenamiento",
				fr: "Type entraînement",
			},
			"booking-mode": {
				en: "Booking Mode",
				it: "Modalità Prenotazione",
				es: "Modo De Reserva",
				fr: "Mode De Réservation",
			},
			hours: {
				en: "Hours",
				it: "Ore",
				es: "Horas",
				fr: "Heures",
			},
			"visibility-days": {
				en: "Booking Interval",
				it: "Intervallo Prenotazione",
				es: "Intervalo Reserva",
				fr: "Intervalle Réservation",
			},
			"booking-before": {
				en: "Booking Before",
				it: "Prenota Entro",
				es: "Reserva Antes",
				fr: "Réservation Avant",
			},
			"cancel-before": {
				en: "Cancel Before",
				it: "Disdici Entro",
				es: "Cancela Antes",
				fr: "Annuler Avant",
			},
			subscription: {
				en: "Subscription",
				it: "Abbonamento",
				es: "Suscripción",
				fr: "Abonnement",
			},
			"multiple-values": {
				en: "Multiple Values",
				it: "Valori Multipli",
				es: "Varios Valores",
				fr: "Valeurs multiples",
			},
			"with-participants": {
				en: "With Participants",
				it: "Con Partecipanti",
				es: "Sin Participantes",
				fr: "Avec Participants",
			},
			"without-participants": {
				en: "Without Participants",
				it: "Senza Partecipanti",
				es: "Con Participantes",
				fr: "Participants En File D'Attente",
			},
			"queued-participants": {
				en: "Queued Participants",
				it: "Partecipanti In Coda",
				es: "Participantes En Cola",
				fr: "Sans Participants",
			},
			"publish-failed": {
				en: "Activation/s failed",
				it: "Attivazione/i fallita/e",
				es: "Activaciones fallidas",
				fr: "Activations echouées",
			},
			"publish-successful": {
				en: "Activation/s successful",
				it: "Attivazione/i avvenuta/e con successo",
				es: "Activaciónes exitosa",
				fr: "Activation réussie",
			},
			"unpublish-failed": {
				en: "Deactivation/s failed",
				it: "Disattivazione/i fallita/e",
				es: "Desactivación fallida",
				fr: "La désactivation a échoué",
			},
			"unpublish-successful": {
				en: "Deactivation/s successful",
				it: "Disattivazione/i avvenuta/e con successo",
				es: "Desactivaciones Exitosas",
				fr: "Désactivations Réussies",
			},
			"classes-with-participants": {
				en: "Edit disable. You have selected classes with participants",
				it: "Modifica disabilita. Hai selezionato classi con partecipanti.",
				es: "Editar deshabilitar. Has seleccionado clases con participantes",
				fr: "Modifier désactiver. Vous avez sélectionné des èvènements avec des participants",
			},
			"classes-with-participants-edit": {
				en: "You have selected classes with participants",
				it: "Hai selezionato classi con partecipanti.",
				es: "Has seleccionado clases con participantes",
				fr: "Vous avez sélectionné des èvènements avec des participants",
			},
			"activity-type": {
				en: "Activity Type",
				it: "Tipo Attività",
				es: "Tipo De Actividad",
				fr: "Type D'Activité",
			},
			"activity-date": {
				en: "Activity Date",
				it: "Data Attività",
				es: "Fecha Actividad",
				fr: "Date D'Activité",
			},
			"onsite-online": {
				en: "Onsite/Online",
				it: "Onsite/Online",
				es: "Onsite/Online",
				fr: "Onsite/Online",
			},
			"day-of-week": {
				en: "Day",
				it: "Giorno",
				es: "Día",
				fr: "Jour",
			},
			sunday: {
				en: "Sunday",
				it: "Domenica",
				es: "Domingo",
				fr: "Dimanche",
			},
			monday: {
				en: "Monday",
				it: "Lunedì",
				es: "Lunes",
				fr: "Lundi",
			},
			tuesday: {
				en: "Tuesday",
				it: "Martedì",
				es: "Martes",
				fr: "Mardi",
			},
			wednesday: {
				en: "Wednesday",
				it: "Mercoledì",
				es: "Miércoles",
				fr: "Mercredi",
			},
			thursday: {
				en: "Thursday",
				it: "Giovedì",
				es: "Jueves",
				fr: "Jeudi",
			},
			friday: {
				en: "Friday",
				it: "Venerdì",
				es: "Viernes",
				fr: "Vendredi",
			},
			saturday: {
				en: "Saturday",
				it: "Sabato",
				es: "Sábado",
				fr: "Samedi",
			},
			"edit-all": {
				en: "Edit All",
				it: "Modifica Tutti",
				es: "Editar Todo",
				fr: "Tout Modifier",
			},
			"lock-all": {
				en: "Lock All",
				it: "Blocca Tutti",
				es: "Bloquear Todo",
				fr: "Vout Verrouiller",
			},
			lessons: {
				en: "Lessons",
				it: "Lezioni",
				es: "Lecciones",
				fr: "Training",
			},
			location: {
				en: "Location",
				it: "Luogo",
				es: "Sitio",
				fr: "Lieu",
			},
			"add-filters": {
				en: "Add Filters",
				it: "Aggiungi Filtri",
				es: "Agregar Filtros",
				fr: "Ajouter Filtres",
			},
			"reduce-filters": {
				en: "Reduce filters",
				it: "Riduci filtri",
				es: "Reducir filtros",
				fr: "Réduire Filtres",
			},
			"cannot-delete-class-with-participants": {
				en: "Cannot delete activity with participants",
				it: "Impossibile cancellare attività con partecipanti",
				es: "No se puede eliminar la actividad con los participantes",
				fr: "Réduire Filtres",
			},
			"class-is-notbookable-cannot-edit-participants": {
				en: "The activity is open and does not include a list of participants",
				it: "L'attività è aperta e non prevede una lista di partecipanti",
				es: "La actividad está abierta y no incluye lista de participantes",
				fr: "Impossible de supprimer l'activité avec les participants",
			},
			"activities-calendar": {
				en: "Club Calendar",
				it: "Calendario Club",
				es: "Calendario Club",
				fr: "Calendrier Club",
			},
			"pt-calendar": {
				en: "PT Calendar",
				it: "Calendario PT",
				es: "Calendario PT",
				fr: "Calendrier PT",
			},
			"services-calendar": {
				en: "Services Calendar",
				it: "Calendario Servizi",
				es: "Calendario Servicios",
				fr: "Calendrier Prestations",
			},
			services: {
				en: "Services",
				it: "Servizi",
				es: "Servicios",
				fr: "Prestations",
			},
			"service-type": {
				en: "Service Type",
				it: "Tipo Di Servizio",
				es: "Tipo De Servicio",
				fr: "Type De Service",
			},
			OsteopathyType: {
				en: "Osteopathy",
				it: "Osteopatia",
				es: "Osteopatía",
				fr: "Ostéopathie",
			},
			MassageTherapyType: {
				en: "Massage Therapy",
				it: "Massofisioterapia",
				es: "Terapia De Masajes",
				fr: "Massage Thérapeutique",
			},
			NutritionType: {
				en: "Nutrition",
				it: "Nutrizione",
				es: "Nutrición",
				fr: "Nutrition",
			},
			BioMeasurementsType: {
				en: "Biometric Measurements",
				it: "Misurazioni Biometriche",
				es: "Medidas Biométricas",
				fr: "Mesures Biométriques",
			},
			OrthopedicsType: {
				en: "Orthopedics",
				it: "Ortopedia",
				es: "Ortopedía",
				fr: "Orthopédie",
			},
			ManicureType: {
				en: "Manicure",
				it: "Manicure",
				es: "Manicura",
				fr: "Manucure",
			},
			PedicureType: {
				en: "Pedicure",
				it: "Pedicure",
				es: "Pedicure",
				fr: "Pédicure",
			},
			HairRemovalType: {
				en: "Hair Removal",
				it: "Epilazione",
				es: "Depilación",
				fr: "Épilation",
			},
			BodyCareType: {
				en: "Body Care",
				it: "Cura Del Corpo",
				es: "Cuidado Del Cuerpo",
				fr: "Soin Du Corps",
			},
			FacialCleansingType: {
				en: "Facial Cleansing",
				it: "Pulizia Viso",
				es: "Limpieza Facial",
				fr: "Nettoyage Du Visage",
			},
			BodyMassagesType: {
				en: "Body Massages",
				it: "Massaggi Corpo",
				es: "Masajes Corporales",
				fr: "Massages Du Corps",
			},
			SolariumType: {
				en: "Solarium",
				it: "Solarium",
				es: "Solárium",
				fr: "Solarium",
			},
			AntiCelluliteTreatmentType: {
				en: "Anti-cellulite Treatment",
				it: "Trattamento Anticellulite",
				es: "Tratamiento Anticelulítico",
				fr: "Traitement Anti-cellulite",
			},
			CryotherapyType: {
				en: "Cryotherapy",
				it: "Crioterapia",
				es: "Crioterapia",
				fr: "Cryothérapie",
			},
			PosturalAssessmentType: {
				en: "Postural Assessment",
				it: "Valutazione Posturale",
				es: "Evaluación Postural",
				fr: "Évaluation Posturale",
			},
			"free-access": {
				en: "Free Access",
				it: "Accesso Libero",
				es: "Acceso Libre",
				fr: "Accès Libre",
			},
			"click-on-the-locks-to-enable-the-change": {
				en: "Click on the locks to enable the change",
				it: "Clicca sui lucchetti per abilitare la modifica",
				es: "Haga clic en las cerraduras para habilitar el cambio",
				fr: "Cliquez sur les cadenas pour activer le changement",
			},
			activity: {
				en: "Activity",
				it: "Attività",
				es: "Actividad",
				fr: "Activité",
			},
			"you-are-marking-the-athlete-as-present": {
				en: "You are marking the athlete as present.",
				it: "Stai marcando l'atleta come presente.",
				es: "Estás marcando al atleta como presente.",
				fr: "Vous marquez l'athlète comme présent.",
			},
			"you-are-marking-the-athlete-as-absent": {
				en: "You are marking the athlete as absent.",
				it: "Stai marcando l'atleta come assente.",
				es: "Estás marcando al atleta como ausente.",
				fr: "Vous marquez l'athlète comme absent.",
			},
			"assign-remove-tags": {
				en: "Add/Remove Groups",
				it: "Aggiungi/Rimuovi Gruppi",
				es: "Añadir/Quitar Grupos",
				fr: "Ajouter/Retirer Groupes",
			},
			"save-in-club-messages": {
				en: "Save in club messages",
				it: "Salva nei messaggi del club",
				es: "Guardar en mensajes del club",
				fr: "Enregistrer dans les messages du club",
			},
			"instant-message": {
				en: "Instant Message",
				it: "Messaggio Istantaneo",
				es: "Mensaje Instantáneo",
				fr: "Message Instantané",
			},
			"predefined-message": {
				en: "Predefined",
				it: "Predefinito",
				es: "Predefinido",
				fr: "Prédéfini",
			},
			"goal-challenge": {
				en: "Goal Challenge",
				it: "Obiettivi",
				es: "Agregar Objetivos",
				fr: "Ajouter Objectifs",
			},
			"zone-0-valid": {
				en: "Is Zone 0 Valid?",
				it: "La Zona 0 É Valida?",
				es: "¿Es Válida La Zona 0?",
				fr: "La Zone 0 Est-elle Valide?",
			},
			"zone-1-valid": {
				en: "Minimum Effort",
				it: "Intensità Moderata",
				es: "Esfuerzo Mìnimo",
				fr: "Effort Minimal",
			},
			"zone-2-valid": {
				en: "Weight Control",
				it: "Controllo Peso",
				es: "Control De Peso",
				fr: "Contrôle Du Poids",
			},
			"zone-3-valid": {
				en: "Aerobic",
				it: "Zona Aerobica",
				es: "Aeròbico",
				fr: "Aèrobie",
			},
			"zone-4-valid": {
				en: "Anaerobic",
				it: "Zona Anaerobica",
				es: "Anaeròbico",
				fr: "Anaèrobie",
			},
			"zone-5-valid": {
				en: "Maximum Effort",
				it: "Massima intensità",
				es: "Esfuerzo Màximo",
				fr: "Effort Maximal",
			},
			repetition: {
				en: "Repetition",
				it: "Ripetizione",
				es: "Repetición",
				fr: "Répétition",
			},
			"select-participants": {
				en: "Select Participants",
				it: "Seleziona Partecipanti",
				es: "Seleccionar Participantes",
				fr: "Sélectionnez Les Participants",
			},
			"challenge-assign-mode-open": {
				en: "Open",
				it: "Aperto",
				es: "Abierto",
				fr: "Ouvert",
			},
			"challenge-assign-mode-invite": {
				en: "Invite",
				it: "A Invito",
				es: "Invitación",
				fr: "Invitation",
			},
			workouts: {
				en: "Workouts",
				it: "Allenamenti",
				es: "Entrenamientos",
				fr: "Entraînements",
			},
			personal: {
				en: "Personal",
				it: "Personale",
				es: "Personal",
				fr: "Personnel",
			},
			club: {
				en: "Club",
				it: "Club",
				es: "Club",
				fr: "Club",
			},
			"challenge-based-on": {
				en: "Challenge Based On",
				it: "Sfida Basata Su",
				es: "Desafío Basado En",
				fr: "Défi Basé Sur",
			},
			"based-on": {
				en: "Based On",
				it: "Basata Su",
				es: "Basado En",
				fr: "Basé Sur",
			},
			"upps-zones": {
				en: "UPPs / Zones",
				it: "UPPs / Zone",
				es: "UPPs / Zonas",
				fr: "UPPs / Zones",
			},
			"min-target-zone-prc": {
				en: "% Minimal Target Zone",
				it: "% Minima Target Zone",
				es: "% Mínimo Target Zone",
				fr: "% Minimal Target Zone",
			},
			"rewards-structure": {
				en: "Rewards Structure",
				it: "Struttura Dei Premi",
				es: "Estructura De Recompensas",
				fr: "Structure Des Récompenses",
			},
			"only-upps-earned-in-the-following-zones": {
				en: "Only UPPs earned in the following zones:",
				it: "Solo UPP guadagnati nelle seguenti zone:",
				es: "Solo los UPP obtenidos en las siguientes zonas:",
				fr: "Seuls les UPP gagnés dans les zones suivantes:",
			},
			"delete-challenge": {
				en: "You are about to delete a challenge",
				it: "Stai per cancellare una sfida",
				es: "Estás a punto de cancelar un desafío",
				fr: "Vous êtes sur le point d'annuler un défi",
			},
			"invalid-rewards-structure": {
				en: "Invalid rewards structure",
				it: "Struttura dei premi non valida",
				es: "Estructura de recompensas no válida",
				fr: "Structure de récompenses invalide",
			},
			"must-be-greater-than-the-previous": {
				en: "Must be greater than the previous one",
				it: "Deve essere maggiore del precedente",
				es: "Debe ser mayor que el anterior",
				fr: "Il doit être supérieur au précédent",
			},
			"remove-all-athletes": {
				en: "Remove All Athletes",
				it: "Rimuovi Tutti Gli Atleti",
				es: "Eliminar Todos Los Atletas",
				fr: "Supprimer Tous Les Athlètes",
			},
			"remove-all-athletes-confirm": {
				en: "You are about to remove all athletes from the challenge.",
				it: "Stai per rimuovere tutti gli atleti dalla sfida.",
				es: "Está a punto de eliminar a todos los atletas del desafío.",
				fr: "Vous êtes sur le point de retirer tous les athlètes du défi.",
			},
			from: {
				en: "From:",
				it: "Da:",
				es: "Desde:",
				fr: "De:",
			},
			"before-the": {
				en: "Before",
				it: "Prima del",
				es: "Antes de",
				fr: "Avant de",
			},
			"from-the": {
				en: "From",
				it: "Dal",
				es: "Desde",
				fr: "De",
			},
			to: {
				en: "To:",
				it: "A:",
				es: "A:",
				fr: "À:",
			},
			"participating-athletes": {
				en: "Participating Athletes",
				it: "Atleti Partecipanti",
				es: "Atletas Participantes",
				fr: "Athlètes Participants",
			},
			"adding-participants-to-a-challenge-that-has-already-started": {
				en: "You are adding participants to a challenge that has already started. They will accumulate points from now on.",
				it: "Stai aggiungendo partecipanti a una sfida che è già iniziata. Accumuleranno punti solo da questo momento in poi.",
				es: "Está agregando participantes a un desafío que ya ha comenzado. Acumularán puntos a partir de ahora.",
				fr: "Vous ajoutez des participants à un défi qui a déjà commencé. Ils accumuleront désormais des points.",
			},
			"select-dates": {
				en: "Select Dates",
				it: "Seleziona Date",
				es: "Seleccionar Fechas",
				fr: "Sélectionnez Dates",
			},
			monthly: {
				en: "Monthly",
				it: "Mensile",
				es: "Mensual",
				fr: "Mensuel",
			},
			"first-day-of-month": {
				en: "First day of month",
				it: "Primo giorno del mese",
				es: "Primer dia del mes",
				fr: "Premier jour du mois",
			},
			"last-day-of-month": {
				en: "Last day of month",
				it: "Ultimo giorno del mese",
				es: "Último día del mes",
				fr: "Dernier jour du mois",
			},
			"self-join-tag": {
				en: "SELF JOIN",
				it: "SELF JOIN",
				es: "SELF JOIN",
				fr: "SELF JOIN",
			},
			"guest-tag": {
				en: "GUEST",
				it: "GUEST",
				es: "GUEST",
				fr: "GUEST",
			},
			"please-enter-a-valid-time": {
				en: "Please enter a valid time",
				it: "Per favore inserisci un orario valido",
				es: "Ingrese una hora válida",
				fr: "Veuillez entrer une heure valide",
			},
			"never-ending": {
				en: "Never-Ending",
				it: "Infinito",
				es: "Sin fin",
				fr: "Sans fin",
			},
			"has-attended": {
				en: "Has Attended",
				it: "Ha Frequentato",
				es: "Ha Atendido",
				fr: "A Participé",
			},
			"new-participants-initial-state": {
				en: "New Participants Initial State",
				it: "Stato Iniziale Nuovi Partecipanti",
				es: "Estado Inicial Nuevos Participantes",
				fr: "État Initial Nouveaux Participants"
			},
			absent: {
				en: "Absent",
				it: "Assente",
				es: "Ausente",
				fr: "Absent",
			},
			present: {
				en: "Present",
				it: "Presente",
				es: "presente",
				fr: "Présent",
			},
			attendance: {
				en: "Attendance",
				it: "Presenze",
				es: "Asistencia",
				fr: "Présence",
			},
			"edit-subscriptions": {
				en: "Edit Subscriptions",
				it: "Modifica Abbonamenti",
				es: "Editar Suscripciones",
				fr: "Modification Abonnements",
			},
			"select-subscriptions": {
				en: "Select Subscriptions",
				it: "Seleziona Abbonamenti",
				es: "Seleccione Suscripciones",
				fr: "Sélectionnez Abonnements",
			},
			"subscriptions-that-are-not-homogeneous-cannot-be-changed": {
				en: "Subscriptions that are not homogeneous cannot be changed.",
				it: "Gli abbonamenti non omogenei non possono essere modificati.",
				es: "Las suscripciones que no son homogéneas no se pueden modificar.",
				fr: "Les abonnements qui ne sont pas homogènes ne peuvent pas être modifiés.",
			},
			"subscriptions-update-successful": {
				en: "Subscriptions updated successfully",
				it: "Abbonamenti aggiornati con successo",
				es: "Suscripciones actualizadas con éxito",
				fr: "Abonnements mis à jour avec succès",
			},
			"start-time": {
				en: "Begin",
				it: "Inizio",
				es: "Inicio",
				fr: "Début",
			},
			"duration-min": {
				en: "Duration (Min)",
				it: "Durata (Min)",
				es: "Duración (Min)",
				fr: "Durée (Min)",
			},
			"level": {
				en: "Level",
				it: "Livello",
				es: "Nivel",
				fr: "Niveau",
			},
			"defaults-level": {
				en: "Level",
				it: "Livello",
				es: "Nivel",
				fr: "Niveau",
			},
			tickets: {
				en: "Tickets",
				it: "Ingressi",
				es: "Entradas",
				fr: "Jetons",
			},
			recurring: {
				en: "Recurring",
				it: "Ricorrente",
				es: "Recurrente",
				fr: "Récurrent",
			},
			"you-are-about-to-delete": {
				en: "You are about to delete",
				it: "Stai per cancellare",
				es: "Estás a punto de cancelar",
				fr: "Vous êtes sur le point d'annuler",
			},
			"invalid-phone-number": {
				en: "Invalid phone number",
				it: "Numero di telefono non valido",
				es: "Numero de telefono invalido",
				fr: "Numéro de téléphone invalide",
			},
			"invalid-country-code": {
				en: "Invalid country code",
				it: "Codice paese non valido",
				es: "Código de país no válido",
				fr: "Code pays invalide",
			},
			"too-short": {
				en: "Too short",
				it: "Troppo corto",
				es: "Demasiado corto",
				fr: "Trop court",
			},
			"too-long": {
				en: "Too long",
				it: "Troppo lungo",
				es: "Demasiado largo",
				fr: "Trop long",
			},
			TimeRange: {
				en: "Time Range",
				it: "Intervallo temporale",
				es: "Intervalo de tiempo",
				fr: "Intervalle de temps",
			},
			Today: {
				en: "Today",
				it: "Oggi",
				es: "Hoy",
				fr: "Aujourd'hui",
			},
			Yesterday: {
				en: "Yesterday",
				it: "Ieri",
				es: "Ayer",
				fr: "Hier",
			},
			Tomorrow: {
				en: "Tomorrow",
				it: "Domani",
				es: "Mañana",
				fr: "Demain",
			},
			Near14Days: {
				en: "+- 7 Days",
				it: "+- 7 Giorni",
				es: "+- 7 Días",
				fr: "+- 7 Jours",
			},
			LastNext7Days: {
				en: "+- 7 Days",
				it: "+- 7 Giorni",
				es: "+- 7 Días",
				fr: "+- 7 Jours",
			},
			LastNext30Days: {
				en: "+- 30 Days",
				it: "+- 30 Giorni",
				es: "+- 30 Días",
				fr: "+- 30 Jours",
			},
			TodayAndTomorrow: {
				en: "Today And Tomorrow",
				it: "Oggi E Domani",
				es: "Hoy Y Mañana",
				fr: "Aujourd'Hui Et Demain",
			},
			SameDayLastWeek: {
				en: "Same Day Last Week",
				it: "Stesso Giorno Ultima Settimana",
				es: "Mismo día la semana pasada",
				fr: "Même jour la semaine dernière",
			},
			Last12Months: {
				en: "Last 12 Months",
				it: "Ultimi 12 mesi",
				es: "Últimos 12 meses",
				fr: "Derniers 12 mois",
			},
			LastMonth: {
				en: "Last Month",
				it: "Mese scorso",
				es: "Mes pasado",
				fr: "Mois dernier",
			},
			ThisMonth: {
				en: "This Month",
				it: "Questo Mese",
				es: "Este Mes",
				fr: "Ce Mois",
			},
			ThisWeek: {
				en: "This Week",
				it: "Questa Settimana",
				es: "Esta Semana",
				fr: "Cette Semaine",
			},
			LastWeek: {
				en: "Last Week",
				it: "Ultima Settimana",
				es: "Última Semana",
				fr: "Dernière Semaine",
			},
			Last7Days: {
				en: "Last 7 Days",
				it: "Ultimi 7 giorni",
				es: "Últimos 7 días",
				fr: "7 derniers jours",
			},
			Last7DaysAndToday: {
				en: "Last 7 Days",
				it: "Ultimi 7 giorni",
				es: "Últimos 7 días",
				fr: "7 derniers jours",
			},
			Last30DaysAndToday: {
				en: "Last 30 Days",
				it: "Ultimi 30 giorni",
				es: "Últimos 30 días",
				fr: "30 Derniers Jours",
			},
			Last30Days: {
				en: "Last 30 Days",
				it: "Ultimi 30 giorni",
				es: "Últimos 30 días",
				fr: "30 Derniers Jours",
			},
			Last365Days: {
				en: "Last 365 Days",
				it: "Ultimi 365 giorni",
				es: "Últimos 365 días",
				fr: "365 derniers jours",
			},
			leads: {
				en: "Leads",
				it: "Leads",
				es: "Leads",
				fr: "Leads",
			},
			"leads-qualified": {
				en: "Leads - Qualified",
				it: "Leads - Qualified",
				es: "Leads - Qualified",
				fr: "Leads - Qualified",
			},
			prospects: {
				en: "Prospects",
				it: "Prospects",
				es: "Prospects",
				fr: "Prospects",
			},
			clients: {
				en: "Clients",
				it: "Clienti",
				es: "Clients",
				fr: "Clients",
			},
			lead: {
				en: "Lead",
				it: "Lead",
				es: "Lead",
				fr: "Lead",
			},
			"lead-qualified": {
				en: "Lead - Qualified",
				it: "Lead - Qualified",
				es: "Lead - Qualified",
				fr: "Lead - Qualified",
			},
			prospect: {
				en: "Prospect",
				it: "Prospect",
				es: "Prospect",
				fr: "Prospect",
			},
			client: {
				en: "Client",
				it: "Clienti",
				es: "Client",
				fr: "Client",
			},
			"client-from": {
				en: "Client From",
				it: "Client Da",
				es: "Client De",
				fr: "Client De",
			},
			dashboard: {
				en: "Dashboard",
				it: "Dashboard",
				es: "Dashboard",
				fr: "Dashboard",
			},
			"dashboard-settings": {
				en: "Dashboard Settings",
				it: "Impostazioni Dashboard",
				es: "Configuración Dashboard",
				fr: "Paramètres Dashboard",
			},
			trial: {
				en: "Trial",
				it: "Prova",
				es: "Prueba",
				fr: "Essai",
			},
			"change-client-state": {
				en: "Change State",
				it: "Cambia Stato",
				es: "Cambiar Estado",
				fr: "Changer Etat",
			},
			"client-state": {
				en: "Client State",
				it: "Stato Cliente",
				es: "Estado Cliente",
				fr: "Etat Client",
			},
			"select-period": {
				en: "Select Period",
				it: "Seleziona Periodo",
				es: "Seleccionar Periodo",
				fr: "Sélectionnez Période",
			},
			birthdays: {
				en: "Birthdays",
				it: "Compleanni",
				es: "Cumpleaños",
				fr: "Anniversaires",
			},
			"birth-date": {
				en: "Birth Date",
				it: "Data Compleanno",
				es: "Fecha De Nacimiento",
				fr: "Date De Naissance",
			},
			"award-date": {
				en: "Award Date",
				it: "Data Premiazione",
				es: "Fecha De Premiación",
				fr: "Date D'Attribution",
			},
			trophies: {
				en: "Trophies",
				it: "Trofei",
				es: "Trofeos",
				fr: "Trophées",
			},
			"sms-sent-successfully": {
				en: "SMS sent successfully",
				it: "SMS inviato con successo",
				es: "SMS enviado satisfactoriamente",
				fr: "SMS envoyé avec succès",
			},
			"sms-sent-error": {
				en: "Error while sending SMS",
				it: "Errore durante l'invio SMS",
				es: "Error al enviar SMS",
				fr: "Erreur lors de l'envoi SMS",
			},
			sms: {
				en: "SMS",
				it: "SMS",
				es: "SMS",
				fr: "SMS",
			},
			"sms-credits": {
				en: "SMS Credits",
				it: "SMS Rimanenti",
				es: "SMS Restantes",
				fr: "SMS Restants",
			},
			"remaining-sms-credits": {
				en: "Remaining SMS Credits:",
				it: "Crediti SMS Rimanenti:",
				es: "Créditos SMS Restantes:",
				fr: "Crédits SMS Restants:",
			},
			"missing-number": {
				en: "Missing Phone",
				it: "Telefono Mancante",
				es: "Teléfono Faltante",
				fr: "Téléphone Manquant",
			},
			"send-sms": {
				en: "Send SMS",
				it: "Invia SMS",
				es: "Envoyer SMS",
				fr: "Enviar SMS",
			},
			"all-selected-users-are-without-phone": {
				en: "All selected users are without phone number",
				it: "Tutti gli utenti selezionati sono senza numero di telefono",
				es: "Todos los usuarios seleccionados no tienen teléfono",
				fr: "Tous les utilisateurs sélectionnés sont sans téléphone",
			},
			"expired-subscriptions-membership": {
				en: "Expired Subscriptions",
				it: "Abbonamenti Scaduti",
				es: "Subscripciones Expiradas",
				fr: "Abonnements Expirés",
			},
			"suspended-date": {
				en: "Suspended Date",
				it: "Data Sospensione",
				es: "Fecha Suspendida",
				fr: "Date Suspendue",
			},
			"last-activity": {
				en: "Last Activity",
				it: "Ultima Attività",
				es: "Última Actividad",
				fr: "Dernière Activité",
			},
			"training-date": {
				en: "Training Date",
				it: "Data Allenamento",
				es: "Fecha De Entrenamiento",
				fr: "Date D'Entraînement",
			},
			"send-sms": {
				en: "Send SMS",
				it: "Invia SMS",
				es: "Enviar SMS",
				fr: "Envoyer SMS",
			},
			"warning-user-do-not-have-phone": {
				en: "Warning: some of the selected users do not have a phone number.",
				it: "Attenzione: alcuni degli utenti selezionati non hanno un numero di telefono.",
				es: "Advertencia: algunos de los usuarios seleccionados no tienen un número de teléfono.",
				fr: "Avertissement: certains des utilisateurs sélectionnés n'ont pas de numéro de téléphone.",
			},
			"view-training": {
				en: "View Training",
				it: "Visualizza Allenamento",
				es: "Ver Entrenamiento",
				fr: "Voir Entraînement",
			},
			"view-class": {
				en: "View Activity",
				it: "Visualizza Attività",
				es: "Ver Actividad",
				fr: "Voir Activité",
			},
			"expired-subscriptions": {
				en: "Expired Subscriptions",
				it: "Abbonamenti Scaduti",
				es: "Subscripciones Expiradas",
				fr: "Abonnements Expirés",
			},
			"subscription-expiration": {
				en: "Subscription Expiration",
				it: "Scadenza Abbonamento",
				es: "Suscripción Caducidad",
				fr: "Expiration De L'Abonnement",
			},
			"no-activity": {
				en: "No Activity",
				it: "Nessuna Attività",
				es: "No Activity",
				fr: "Pas D'Activité",
			},
			"suspended-membership": {
				en: "Suspended Subscription",
				it: "Abbonamento Sospeso",
				es: "Suscripción Suspendida",
				fr: "Abonnement Suspendue",
			},
			"suspended-memberships": {
				en: "Suspended Subscriptions",
				it: "Abbonamenti Sospesi",
				es: "Suscripciones Suspendidas",
				fr: "Abonnements Suspendus",
			},
			"single-ticket": {
				en: "One Remaining Ticket",
				it: "Un Ticket Rimanente",
				es: "Un Ticket Restante",
				fr: "Un Ticket Restant",
			},
			"no-show": {
				en: "No Show",
				it: "Assenti",
				es: "Ausente",
				fr: "Absent",
			},
			"save-and-remove": {
				en: "Save And Remove",
				it: "Salva E Rimuovi",
				es: "Guardar Y Eliminar",
				fr: "Enregistrer Et Supprimer",
			},
			"comment-trainings": {
				en: "Comment Trainings",
				it: "Commenta Allenamenti",
				es: "Comentarios De Entrenamiento",
				fr: "Commentaires D'Entraînement",
			},
			"view-profile": {
				en: "View Profile",
				it: "Vedi Profilo",
				es: "Ver Perfil",
				fr: "Voir Le Profil",
			},
			"view-diary": {
				en: "View Diary",
				it: "Vedi Diario",
				es: "Ver Diario",
				fr: "Voir Le Journal",
			},
			"trainings-with-no-comments": {
				en: "Trainings Without Comments",
				it: "Allenamenti Senza Commenti",
				es: "Entrenamientos Sin Comentarios",
				fr: "Entraînements Sans Commentaires",
			},
			"no-show-date": {
				en: "No Show Date",
				it: "Data No Show",
				es: "Fecha No Show",
				fr: "Date No Show",
			},
			"clients-no-trainings": {
				en: "New Clients With No Training",
				it: "Nuovi Clienti Senza Allenamenti",
				es: "Nuevos Clientes Sin Entrenamiento",
				fr: "Nouveaux Clients Sans Entraînement",
			},
			"last-comment": {
				en: "Last Comment",
				it: "Ultimo Commento",
				es: "Último Comentario",
				fr: "Dernier Commentaire",
			},
			"athletes-with-no-comments": {
				en: "No Staff Comments",
				it: "Nessun Commento Dallo Staff",
				es: "Sin Comentarios Del Personal",
				fr: "Aucun Commentaire Du Personnel",
			},
			"join-date": {
				en: "Join Date",
				it: "Data Iscrizione",
				es: "Fecha Ingreso",
				fr: "Date Inscription",
			},
			"selected-interval-cannot-exceed-120-days": {
				en: "The selected interval cannot exceed 120 days",
				it: "L'intervallo selezionato non può superare i 120 giorni",
				es: "El intervalo seleccionado no puede exceder 120 días",
				fr: "L'intervalle sélectionné ne peut pas dépasser 120 jours",
			},
			"new-users": {
				en: "New Users",
				it: "Nuovi Utenti",
				es: "Nuevos Usuarios",
				fr: "Nouveaux Utilisateurs",
			},
			"new-users": {
				en: "New Users",
				it: "Nuovi Utenti",
				es: "Nuevos Usuarios",
				fr: "Nouveaux Utilisateurs",
			},
			"last-training": {
				en: "Last Training",
				it: "Ultimo Allenamento",
				es: "Último Entrenamiento",
				fr: "Dernier Entraînement",
			},
			"last-training-date": {
				en: "Last Training Data",
				it: "Data Ultimo Allenamento",
				es: "Últimos Datos De Entrenamiento",
				fr: "Dernières Données D'Entraînement",
			},
			"expired-date": {
				en: "Expired Date",
				it: "Scaduto Il",
				es: "Fecha De Vencimiento",
				fr: "Date d'Expiration",
			},
			"last-booking": {
				en: "Last Booking",
				it: "Ultima Prenotazione",
				es: "Última Reservación",
				fr: "Dernière Réservation",
			},
			"phone-number-copied": {
				en: "Phone number copied!",
				it: "Numero Di Telefono Copiato!",
				es: "¡Número de teléfono copiado!",
				fr: "Numéro De Téléphone Copié!",
			},
			"leads-tooltip": {
				en: "New club members with no interaction from staff in the selected time period",
				it: "Nuovi soci del club senza interazione da parte del personale nel periodo di tempo selezionato",
				es: "Nuevos socios del club sin interacción del personal en el período de tiempo seleccionado",
				fr: "Nouveaux membres du club sans interaction du personnel pendant la période sélectionnée",
			},
			"qualified-tooltip": {
				en: "Club members with interaction from staff in the selected time period",
				it: "Membri del club con interazione da parte del personale nel periodo di tempo selezionato",
				es: "Miembros del club con interacción del personal en el período de tiempo seleccionado",
				fr: "Membres du club avec interaction du personnel dans la période sélectionnée",
			},
			"prospect-tooltip": {
				en: "Club members who have done a trial workout in the selected time period",
				it: "Membri del club che hanno svolto un allenamento di prova nel periodo di tempo selezionato",
				es: "Miembros del club que han realizado un entrenamiento de prueba en el período de tiempo seleccionado",
				fr: "Les membres du club qui ont fait un entraînement d'essai dans la période sélectionnée",
			},
			"client-tooltip": {
				en: "Club members who purchased (or were assigned) a subscription in the selected time period",
				it: "Membri del club che hanno acquistato (o assegnato) un abbonamento nel periodo di tempo selezionato",
				es: "Miembros del club que compraron (o se les asignó) una suscripción en el período de tiempo seleccionado",
				fr: "Membres du club qui ont acheté (ou ont reçu) un abonnement au cours de la période sélectionnée",
			},
			"no-comments-tooltip": {
				en: "Members with no staff comments to trainings in the selected time period",
				it: "Membri senza commenti del personale agli allenamenti nel periodo di tempo selezionato",
				es: "Miembros sin comentarios del personal sobre las capacitaciones en el período de tiempo seleccionado",
				fr: "Membres sans commentaires du personnel sur les entraînements dans la période sélectionnée",
			},
			"no-trainings-tooltip": {
				en: "Members who became clients in the selected time period and that didn't do any trainings after becoming clients",
				it: "Membri che sono diventati clienti nel periodo di tempo selezionato e che non hanno fatto nessun allenamento dopo essere diventati clienti",
				es: "Miembros que se convirtieron en clientes en el período de tiempo seleccionado y que no realizaron ninguna capacitación después de convertirse en clientes",
				fr: "Membres qui sont devenus clients au cours de la période sélectionnée et qui n'ont fait aucun entraînement après être devenus clients",
			},
			"no-show-tooltip": {
				en: "Members who missed a training they were booked for in the selected time period",
				it: "Membri che hanno perso un allenamento per il quale erano stati prenotati nel periodo di tempo selezionato",
				es: "Miembros que se perdieron un entrenamiento para el que estaban reservados en el período de tiempo seleccionado",
				fr: "Membres qui ont manqué une séance d'entraînement pour laquelle ils avaient été réservés au cours de la période sélectionnée",
			},
			"single-ticket-tooltip": {
				en: "Members with a subscription with only one remaining ticket",
				it: "I membri con un abbonamento con un solo biglietto rimanente",
				es: "Miembros con una suscripción con solo un boleto restante",
				fr: "Membres ayant un abonnement avec un seul ticket restant",
			},
			"no-activity-tooltip": {
				en: "Members with no activity (trainings or bookings) in the selected time period who have performed activities (training or bookings) in the 30 days prior to the selected period",
				it: "Membri senza attività (allenamenti o prenotazioni) nel periodo di tempo selezionato che hanno svolto attività (allenamenti o prenotazioni) nei 30 giorni precedenti al periodo selezionato",
				es: "Miembros sin actividad (entrenamientos o reservas) en el período de tiempo seleccionado que han realizado actividades (entrenamientos o reservas) en los 30 días anteriores al período seleccionado",
				fr: "Membres sans activité (entrainement ou réservations) dans la période sélectionnée qui ont effectué des activités (entrainement ou réservations) dans les 30 jours précédant la période sélectionnée",
			},
			"suspended-membership-tooltip": {
				en: "Members with suspended subscriptions in the selected time period",
				it: "Membri con abbonamenti sospesi nel periodo di tempo selezionato",
				es: "Miembros con suscripciones suspendidas en el período de tiempo seleccionado",
				fr: "Membres avec des abonnements suspendus dans la période sélectionnée",
			},
			"expired-membership-tooltip": {
				en: "Members with expired subscriptions and no renewals in the selected time period",
				it: "Membri con abbonamenti scaduti e nessun rinnovo nel periodo di tempo selezionato",
				es: "Miembros con suscripciones vencidas y sin renovaciones en el período de tiempo seleccionado",
				fr: "Membres dont les abonnements ont expiré et aucun renouvellement dans la période sélectionnée",
			},
			"birthdays-tooltip": {
				en: "Members who have their birthday in the selected time period",
				it: "Membri che compiono gli anni nel periodo di tempo selezionato",
				es: "Membres dont l'anniversaire se situe dans la période sélectionnée",
				fr: "Membres dont l'anniversaire se situe dans la période sélectionnée",
			},
			"trophies-tooltip": {
				en: "Members who gained a trophy in the selected time period",
				it: "Membri che hanno ottenuto un trofeo nel periodo di tempo selezionato",
				es: "Miembros que ganaron un trofeo en el período de tiempo seleccionado",
				fr: "Membres dont l'anniversaire se situe dans la période sélectionnée",
			},
			"trial-tooltip": {
				en: "Leads booked for a trial session in the selected time period",
				it: "I Leads che hanno prenotato una sessione di prova nel periodo di tempo selezionato",
				es: "Leads reservados para una sesión de prueba en el período de tiempo seleccionado",
				fr: "Leads réservés pour une session d'essai dans la période sélectionnée",
			},
			"tasks-tooltip": {
				en: "Club tasks not completed",
				it: "Tasks del club non completati",
				es: "Tasks del club no completadas",
				fr: "Tasks du club non terminées",
			},
			"default-training-type": {
				en: "Club Default Workout",
				it: "Allenamento Predefinito Nel Club",
				es: "Entrenamiento Predeterminado En El Club",
				fr: "Entraînement Par Défaut Dans Le Club",
			},
			"user-has-no-data-to-view": {
				en: "User Has No Data To View",
				it: "L'Utente Non Ha Dati Da Visualizzare",
				es: "El Usuario No Tiene Datos Para Ver",
				fr: "L'Utilisateur N'A Pas De Données Pour Visualiser",
			},
			"ranking-challenge": {
				en: "Ranking Challenge",
				it: "Sfida A Classifica",
				es: "Desafío De Clasificación",
				fr: "Un Défi De Classement",
			},
			"scheduled-ranking-challenge": {
				en: "Scheduled Ranking Challenge",
				it: "Sfida A Classifica Programmata",
				es: "Desafío De Clasificación Programado",
				fr: "Défi De Classement Programmé",
			},
			"generic-task": {
				en: "Generic Task",
				it: "Task Generico",
				es: "Task Genérico",
				fr: "Task générique",
			},
			"call-task": {
				en: "Call",
				it: "Chiamata",
				es: "llamada",
				fr: "Appel",
			},
			"do-not-call-task": {
				en: "Don't Call",
				it: "Non Chiamare",
				es: "No Llames",
				fr: "Ne Pas Appeler",
			},
			assignee: {
				en: "Assignee",
				it: "Assegnatario",
				es: "Cesionario",
				fr: "Cessionnaire",
			},
			"task-is-mandatory-for-generic-task": {
				en: "The task field is mandatory for generic tasks",
				it: "Il campo task è obbligatorio per i tasks generi",
				es: "El campo task es obligatorio para las tasks genéricas",
				fr: "Le champ task est obligatoire pour les tasks génériques",
			},
			tasks: {
				en: "Tasks",
				it: "Tasks",
				es: "Tasks",
				fr: "Tasks",
			},
			task: {
				en: "Task",
				it: "Task",
				es: "Task",
				fr: "Task",
			},
			"add-task": {
				en: "Add Task",
				it: "Aggiungi Task",
				es: "Agregar Task",
				fr: "Ajouter Task",
			},
			"edit-task": {
				en: "Edit Task",
				it: "Modifica Task",
				es: "Editar Task",
				fr: "Éditer Task",
			},
			"my-tasks": {
				en: "My Tasks",
				it: "I Miei Task",
				es: "Mi Task",
				fr: "Mes Task",
			},
			"show-completed-tasks": {
				en: "Show Completed Tasks",
				it: "Mostra Task Completati",
				es: "Mostrar Task Completadas",
				fr: "Afficher Task Terminées",
			},
			staff: {
				en: "Staff",
				it: "Staff",
				es: "Staff",
				fr: "Staff",
			},
			"enable-leads-management": {
				en: "Enable Leads Management",
				it: "Abilita La Gestione Dei Leads",
				es: "Habilitar La Gestión De Leads",
				fr: "Activer la gestion des Leads",
			},
			membership: {
				en: "Membership",
				it: "Iscrizione",
				es: "Matrícula",
				fr: "Inscription",
			},
			receiver: {
				en: "Receiver",
				it: "Ricevitore",
				es: "Receptor",
				fr: "Receveur",
			},
			"personal-app": {
				en: "Personal App",
				it: "App Personale",
				es: "Aplicación Personal",
				fr: "Application Personnelle",
			},
			kos: {
				en: "KOs",
				it: "KOs",
				es: "KOs",
				fr: "KOs",
			},
			"to-avoid": {
				en: "To Avoid",
				it: "Da Evitare",
				es: "Ser Evitado",
				fr: "Interdits",
			},
			"kos-min": {
				en: "KOs/min",
				it: "KOs/min",
				es: "KOs/min",
				fr: "KOs/min",
			},
			Last50Trainings: {
				en: "Last 50 Trainings",
				it: "Ultimi 50 Allenamenti",
				es: "Últimos 50 Entrenamientos",
				fr: "50 Dernières Formations",
			},
			Last100Trainings: {
				en: "Last 100 Trainings",
				it: "Ultimi 100 Allenamenti",
				es: "Últimos 100 Entrenamientos",
				fr: "100 Dernières Formations",
			},
			Last250Trainings: {
				en: "Last 250 Trainings",
				it: "Ultimi 250 Allenamenti",
				es: "Últimos 250 Entrenamientos",
				fr: "250 Dernières Formations",
			},
			Last500Trainings: {
				en: "Last 500",
				it: "Ultimi 500",
				es: "Últimos 500",
				fr: "500 Dernières",
			},
			Last50: {
				en: "Last 50",
				it: "Ultimi 50",
				es: "Últimos 50",
				fr: "50 Dernières",
			},
			Last100: {
				en: "Last 100 ",
				it: "Ultimi 100",
				es: "Últimos 100",
				fr: "100 Dernières",
			},
			Last250: {
				en: "Last 250",
				it: "Ultimi 250",
				es: "Últimos 250",
				fr: "250 Dernières",
			},
			Last500: {
				en: "Last 500",
				it: "Ultimi 500",
				es: "Últimos 500",
				fr: "500 Dernières",
			},
			"group-training": {
				en: "Group Training",
				it: "Training di Gruppo",
				es: "Entrenamiento en grupo",
				fr: "Entraînement en groupe",
			},
			Second: {
				en: "Seconds",
				it: "Secondi",
				es: "Segundos",
				fr: "Seconds",
			},
			"BenchPressMaxReps-ms": {
				en: "Bench Press (max reps)",
				it: "Bench Press (ripetizioni max)",
				es: "Press de banca (repeticiones máx)",
				fr: "Développé Couché (répétitions max)",
			},
			"BenchPressMaxWgt-ms": {
				en: "Bench Press (max weight)",
				it: "Bench Press (massimale)",
				es: "Press de banca (peso máximo)",
				fr: "Développé Couché (poids max)",
			},
			"HandGripTest-ms": {
				en: "Hand Grip Test",
				it: "Hand Grip Test",
				es: "Hand Grip Test",
				fr: "Force de la Poignée",
			},
			"LatPullDownMaxReps-ms": {
				en: "Lat Pull Down (max reps)",
				it: "Lat Pull Down (ripetizioni max)",
				es: "Jalón hacia abajo (repeticiones máx)",
				fr: "Tirage Poitrine (répétitions max)",
			},
			"LatPullDownMaxWgt-ms": {
				en: "Lat Pull Down (max weight)",
				it: "Lat Pull Down (massimale)",
				es: "Jalón hacia abajo (peso màximo)",
				fr: "Tirage Poitrine (poids max)",
			},
			"MaxAerobicSpeed-ms": {
				en: "MAS",
				it: "MVA",
				es: "VAM",
				fr: "VMA",
			},
			"MaxAerobicSpeed-desc": {
				en: "Maximum Aerobic Speed",
				it: "Massima Velocità Aerobica",
				es: "Velocidad Aeróbica Máxima",
				fr: "Volume Maximal Aérobie",
			},
			"Plank-ms": {
				en: "Max Plank",
				it: "Max Plank",
				es: "Plancha máx",
				fr: "Gainage Max",
			},
			"PushUpMaxReps1Minute-ms": {
				en: "Push-ups (max reps 1 min)",
				it: "Push-up (ripetizioni max 1 minuto)",
				es: "Flexiones (repeticiones máx 1 min)",
				fr: "Pompes (répétitions max 1 min)",
			},
			"SquatMaxReps1Minute-ms": {
				en: "Squat (max reps 1 min)",
				it: "Squat (ripetizioni max 1 min)",
				es: "Sentadilla (repeticiones máx 1 min)",
				fr: "Squat (répétitions max 1 min)",
			},
			"RowerMaxDist1Minute-ms": {
				en: "Rowing machine (max distance 1 min)",
				it: "Vogatore (distanza max 1 min)",
				es: "Máquina de remo (distancia máx 1 min)",
				fr: "Rameur (distance max 1 min)",
			},
			"x-days-left": {
				en: "{0} days left",
				it: "Rimangono {0} giorni",
				es: "Faltan {0} días",
				fr: "{0} jours restants",
			},
			"expired-x-days-ago": {
				en: "Expired {0} days ago",
				it: "Scaduto da {0} giorni",
				es: "Vencido por {0} dias",
				fr: "Expiré depuis {0} jours",
			},
			"PullUpMaxReps-ms": {
				en: "Pull Up",
				it: "Pull Up",
				es: "Dominadas",
				fr: "Tractions",
			},
			"SquatMaxReps-ms": {
				en: "Squat (max reps)",
				it: "Squat (ripetizioni max)",
				es: "Sentadillas (repeticiones máx)",
				fr: "Squat (répétitions max)",
			},
			"SquatMaxWgt-ms": {
				en: "Squat (max weight)",
				it: "Squat (massimale)",
				es: "Sentadillas (peso màximo)",
				fr: "Squat (poids max)",
			},
			documents: {
				en: "Documents",
				it: "Documenti",
				es: "Documentos",
				fr: "Documents",
			},
			active: {
				en: "Active",
				it: "Attivo",
				es: "Activo",
				fr: "Actif",
			},
			expiring: {
				en: "Expiring",
				it: "In Scadenza",
				es: "Expirando",
				fr: "Expirant",
			},
			"medical-certificate": {
				en: "Medical Certificate",
				it: "Certificato Medico",
				es: "Certificado Medico",
				fr: "Certificat Médical",
			},
			MedicalCertificate: {
				en: "Medical Certificate",
				it: "Certificato Medico",
				es: "Certificado Medico",
				fr: "Certificat Médical",
			},
			"add-document": {
				en: "Add Document",
				it: "Aggiungi Documento",
				es: "Agregar Documento",
				fr: "Ajouter Document",
			},
			"edit-document": {
				en: "Edit Document",
				it: "Modifica Documento",
				es: "Editar Documento",
				fr: "Modifier  Document",
			},
			missing: {
				en: "Missing",
				it: "Mancante",
				es: "Ausente",
				fr: "Manquant",
			},
			"machine-level": {
				en: "Gear Level",
				it: "Livello Attrezzo",
				es: "Nivel de dificultad",
				fr: "Niveau d'Outil",
			},
			"workout-reps": {
				en: "Reps",
				it: "Ripetizioni",
				es: "Repeticiones",
				fr: "Répétitions",
			},
			na: {
				en: "N/A",
				it: "N/A",
				es: "N/A",
				fr: "N/A",
			},
			"cardio-zone": {
				en: "HR Target",
				it: "HR Target",
				es: "HR Target",
				fr: "HR Target",
			},
			"choose-cardio-zone": {
				en: "Choose zone",
				it: "Scegli zona",
				es: "Elegir zona",
				fr: "Choisir zone",
			},
			"also-shows-clubs-where-is-not-currently-an-athlete": {
				en: "Also shows clubs where is not currently an athlete.",
				it: "Mostra anche i club in cui non è attualmente un atleta.",
				es: "También muestra clubes en los que actualmente no es deportista.",
				fr: "Montre également les clubs où il n'est pas actuellement athlète.",
			},
			"share-count": {
				en: "Share Count",
				it: "Condivisioni",
				es: "Comparte",
				fr: "Partage",
			},
			"workout-sheets": {
				en: "Workouts",
				it: "Schede Allenamento",
				es: "Programas De Entrenamiento",
				fr: "Programmes De Entraînement",
			},
			"add-workout": {
				en: "Add Workout",
				it: "Aggiungi Scheda",
				es: "Agregar Workout",
				fr: "Ajouter Workout",
			},
			"edit-workout": {
				en: "Edit Workout",
				it: "Modifica Scheda",
				es: "Editar Workout",
				fr: "Modifier Workout",
			},
			"add-interval-workout": {
				en: "Add Interval Workout",
				it: "Aggiungi Scheda A Intervalli",
				es: "Agregar Interval Workout",
				fr: "Ajouter Interval Workout",
			},
			"workout-exercise": {
				en: "Workout Exercise",
				it: "Escercizio",
				es: "Ejercicio",
				fr: "Exercer",
			},
			"repsMax-cannot-be-lower-than-reps": {
				en: "The maximum number of repetitions cannot be less than repetitions",
				it: "Il numero massimo di ripetizioni non può essere inferiore alle ripetizioni",
				es: "El número máximo de repeticiones no puede ser inferior a repeticiones",
				fr: "Le nombre maximum de répétitions ne peut pas être inférieur à répétitions",
			},
			"weightMax-cannot-be-lower-than-weight": {
				en: "The maximum weight cannot be less than or equal to the minimum weight.",
				it: "Il peso massimo non può essere inferiore o uguale al peso minimo.",
				es: "El peso máximo no puede ser inferior o igual al peso mínimo.",
				fr: "Le poids maximum ne peut pas être inférieur ou égal au poids minimum."
			},
			"assign-subscription": {
				en: "Assign Subscription",
				it: "Assegna Abbonamento",
				es: "Asignar Suscripción",
				fr: "Attribuer Un Abonnement",
			},
			"edit-subscription": {
				en: "Edit Subscription",
				it: "Modifica Abbonamento",
				es: "Editar Suscripción",
				fr: "Modifier L'Abonnement",
			},
			suspended: {
				en: "Suspended",
				it: "Sospeso",
				es: "Suspendido",
				fr: "Suspendu",
			},
			early: {
				en: "Not started",
				it: "Non iniziato",
				es: "No empezado",
				fr: "Non démarré",
			},
			"choose-subscription": {
				en: "Choose Subscription",
				it: "Scegli Abbonamento",
				es: "Elija Suscripción",
				fr: "Choisissez l'Abonnement",
			},
			remaining: {
				en: "Remaining",
				it: "Rimanenti",
				es: "Restante",
				fr: "Restant",
			},
			"suspend-subscription": {
				en: "Suspend Subscription",
				it: "Sospendi Abbonamento",
				es: "Suspender Suscripción",
				fr: "Suspendre Abonnement",
			},
			"blank-manual-reactivation": {
				en: "Leave blank for manual reactivation",
				it: "Lasciare vuoto per riattivazione manuale",
				es: "Dejar en blanco para reactivación manual",
				fr: "Laisser vide pour la réactivation manuelle",
			},
			operation: {
				en: "Operation",
				it: "Operazione",
				es: "Operación",
				fr: "Opération",
			},
			"past-operations": {
				en: "Past Operations",
				it: "Storico Operazioni",
				es: "Operaciones Pasadas",
				fr: "Opérations Passées",
			},
			files: {
				en: "Files",
				it: "File",
				es: "Archivos",
				fr: "Fichiers",
			},
			pick: {
				en: "Pick",
				it: "Scegli",
				es: "Elegir",
				fr: "Prendre",
			},
			"add-subscription": {
				en: "Add Subscription",
				it: "Aggiungi Abbonamento",
				es: "Agregar Suscripción",
				fr: "Ajouter Abonnement",
			},
			exercises: {
				en: "Exercises",
				it: "Esercizi",
				es: "Ejercicios",
				fr: "Exercices",
			},
			rest: {
				en: "Rest",
				it: "Pausa",
				es: "Descanso",
				fr: "Repos",
			},
			REST: {
				en: "REST",
				it: "PAUSA",
				es: "DESCANSO",
				fr: "REPOS",
			},
			round: {
				en: "Round",
				it: "Round",
				es: "Ronda",
				fr: "Manche"
			},
			rounds: {
				en: "Round",
				it: "Rounds",
				es: "Rondas",
				fr: "Manches"
			},
			"configure": {
				en: "Configure",
				it: "Configura",
				es: "Configurar",
				fr: "Configurer"
			},
			"round-pause": {
				en: "Round Pause",
				it: "Pausa del Round",
				es: "Pausa de la Ronda",
				fr: "Pause de Manche"
			},
			"set": {
				en: "Set",
				it: "Serie",
				es: "Serie",
				fr: "Sèrie",
			},
			"select-cardio-zone": {
				en: "Select Cardio Zone",
				it: "Seleziona Zona Cardio",
				es: "Seleccionar Zona Cardio",
				fr: "Sélectionnez zone cardio",
			},
			"ok": {
				en: "Ok",
				it: "Ok",
				es: "Ok",
				fr: "Ok",
			},
			"total-duration": {
				en: "Total duration",
				it: "Durata totale",
				es: "Duración total",
				fr: "Durée totale",
			},
			notes: {
				en: "Notes",
				it: "Note",
				es: "Notas",
				fr: "Remarques",
			},
			RPE: {
				en: "RPE",
				it: "RPE",
				es: "RPE",
				fr: "RPE",
			},
			EPCP: {
				en: "EPCP",
				it: "EPCP",
				es: "EPCP",
				fr: "EPCP",
			},
			repsMax: {
				en: "repsMax",
				it: "repsMax",
				es: "repsMax",
				fr: "repsMax",
			},
			reps: {
				en: "Number of Exercises",
				it: "Numero Esercizi",
				es: "Numero de Ejercicios",
				fr: "Nombre d'Exercices",
			},
			shared: {
				en: "Shared",
				it: "Condivisi",
				es: "Shared",
				fr: "Shared",
			},
			"no-exercise-selected": {
				en: "No exercise selected",
				it: "Nessun Esercizio Selezionato",
				es: "Ningún Ejercicio Seleccionado",
				fr: "Aucun Exercice Sélectionné",
			},
			"edit-group": {
				en: "Edit Group",
				it: "Modifica Gruppo",
				es: "Editar Grupo",
				fr: "Modifier Groupe",
			},
			"add-new-timer": {
				en: "Add New Timer",
				it: "Aggiungi Nuovo Timer",
				es: "Add New Timer",
				fr: "Add New Timer",
			},
			"choose-exercise": {
				en: "Choose Exercise",
				it: "Scegli Esercizio",
				es: "Elige Ejercicio",
				fr: "Choisissez Exercice",
			},
			"add-exercise": {
				en: "Add Exercise",
				it: "Aggiungi Esercizio",
				es: "Añadir Ejercicio",
				fr: "Ajouter Exercice",
			},
			"add-set": {
				en: "Add Set",
				it: "Aggiungi Set",
				es: "Añadir Set",
				fr: "Ajouter Set",
			},
			"show-fields": {
				en: "Show Fields",
				it: "Mostra Campi",
				es: "Mostrar Campos",
				fr: "Afficher les Champs",
			},
			"add-rest": {
				en: "Add Rest",
				it: "Aggiungi Pausa",
				es: "Añadir Descanso",
				fr: "Ajouter Repos",
			},
			"sheet-intensity": {
				en: "Intensity",
				it: "Intensità",
				es: "Intensidad",
				fr: "Intensité",
			},
			"free-group": {
				en: "Free",
				it: "Libero",
				es: "Libre",
				fr: "Libérer",
			},
			intensity: {
				en: "Intensity",
				it: "Intensità",
				es: "Intensidad",
				fr: "Intensité",
			},
			"round-duration": {
				en: "Round Duration",
				it: "Durata Round",
				es: "Duración Ronda",
				fr: "Durée Round",
			},
			"round-rest": {
				en: "Round Rest",
				it: "Pausa Round",
				es: "Descanso Ronda",
				fr: "Repos Manche",
			},
			"exercise-rest": {
				en: "Exercise Rest",
				it: "Pausa Esercizio",
				es: "Descanso Ejercicio",
				fr: "Repos Exercice",
			},
			repetitions: {
				en: "Repetitions",
				it: "Ripetizioni",
				es: "Repeticiones",
				fr: "Répétitions",
			},
			"max-repetitions": {
				en: "Max Repetitions",
				it: "Max Ripetizioni",
				es: "Max Repeticiones",
				fr: "Max Répétitions",
			},
			weight: {
				en: "Weight",
				it: "Peso",
				es: "Peso",
				fr: "Poids",
			},
			"weight-range": {
				en: "Weight Range",
				it: "Intervallo Peso",
				es: "Rango de Peso",
				fr: "Plage de Poids"
			},
			tempo: {
				en: "Tempo",
				it: "Tempo",
				es: "Tempo",
				fr: "Tempo",
			},
			superset: {
				en: "Superset",
				it: "Superset",
				es: "Superset",
				fr: "Superset",
			},
			AFAP: {
				en: "AFAP",
				it: "AFAP",
				es: "AFAP",
				fr: "AFAP",
			},
			EMOM: {
				en: "EMOM",
				it: "EMOM",
				es: "EMOM",
				fr: "EMOM",
			},
			AMRAP: {
				en: "AMRAP",
				it: "AMRAP",
				es: "AMRAP",
				fr: "AMRAP",
			},
			Interval: {
				en: "Interval Training",
				it: "Interval Training",
				es: "Interval Training",
				fr: "Interval Training",
			},
			est: {
				en: "est.",
				it: "est.",
				es: "est.",
				fr: "est.",
			},
			"rest-must-be-greater-than-0": {
				en: "Rest must be greater than 0.",
				it: "La pausa deve essere maggiore di 0.",
				es: "La pausa debe ser mayor que 0.",
				fr: "La pause doit être supérieure à 0.",
			},
			"duration-must-be-greater-than-0": {
				en: "Duration must be greater than 0.",
				it: "La durata deve essere maggiore di 0.",
				es: "La duración debe ser mayor que 0.",
				fr: "La durée doit être supérieure à 0.",
			},
			"exercise-cannot-contains-only-rest": {
				en: "An exercise cannot contain only rests.",
				it: "Un esercizio non può contenere solo pause.",
				es: "Un ejercicio no puede contener solo silencios.",
				fr: "Un exercice ne peut pas contenir que des descansos.",
			},
			"export-workout": {
				en: "Export Workout",
				it: "Esporta Scheda",
				es: "Exportar Entrenamiento",
				fr: "Exporter l'Entraînement",
			},
			"clone-to-personal": {
				en: "Clone to personal",
				it: "Clona come personale",
				es: "Clone to personal",
				fr: "Clone to personal",
			},
			"choose-athletes": {
				en: "Choose Athletes",
				it: "Seleziona Atleti",
				es: "Elegir Atletas",
				fr: "Choisir Athlètes",
			},
			"create-as-template": {
				en: "Create as template",
				it: "Crea come template",
				es: "Create as template",
				fr: "Create as template",
			},
			"interval-training": {
				en: "Interval Training",
				it: "Interval Training",
				es: "Interval Training",
				fr: "Interval Training",
			},
			"expand-series": {
				en: "Expand Sets",
				it: "Espandi Sets",
				es: "Expandir Sets",
				fr: "Expand Sets",
			},
			"collapse-series": {
				en: "Collapse Sets",
				it: "Comprimi Sets",
				es: "Comprimir Sets",
				fr: "Compresse Sets",
			},
			"expand": {
				en: "Expand",
				it: "Espandi",
				es: "Expandir",
				fr: "Expand",
			},
			"collapse": {
				en: "Collapse",
				it: "Comprimi",
				es: "Comprimir",
				fr: "Compresse",
			},
			"defaults": {
				en: "Defaults",
				it: "Defaults",
				es: "Defaults",
				fr: "Defaults",
			},
			"workout-definitions": {
				en: "Workout Definitions",
				it: "Definizioni Allenamento",
				es: "Definiciones Entrenamiento",
				fr: "Définitions Entraînement",
			},
			"exercise-library": {
				en: "Exercise Library",
				it: "Libreria di Esercizi",
				es: "Biblioteca de Ejercicios",
				fr: "Bibliothèque d'Exercices",
			},
			"uptivo-editor-exercise-library": {
				en: "Exercise Library (EDITOR)",
				it: "Libreria di Esercizi (EDITOR)",
				es: "Biblioteca de Ejercicios (EDITOR)",
				fr: "Bibliothèque d'Exercices (EDITOR)",
			},
			"exercise-duration": {
				en: "Exercise Duration",
				it: "Durata Esercizio",
				es: "Duración Ejercicio",
				fr: "Durée Exercice",
			},
			"create-group": {
				en: "Create Group",
				it: "Crea Gruppo",
				es: "Crea Grupo",
				fr: "Créer Groupe",
			},
			"MainMuscle-Abductors": {
				en: "Abductors",
				it: "Abduttori",
				es: "Abductores",
				fr: "Abducteurs",
			},
			"MainMuscle-Abs": {
				en: "Abs",
				it: "Addominali",
				es: "Abdominales",
				fr: "Abdos",
			},
			"MainMuscle-Adductors": {
				en: "Adductors",
				it: "Adduttori",
				es: "Aductores",
				fr: "Adducteurs",
			},
			"MainMuscle-BackLower": {
				en: "Lower Back",
				it: "Schiena Bassa",
				es: "Espalda Baja",
				fr: "Bas du dos",
			},
			"MainMuscle-BackMiddle": {
				en: "Middle Back",
				it: "Schiena Media",
				es: "Espalda Media",
				fr: "Milieu du dos",
			},
			"MainMuscle-Bicep": {
				en: "Biceps",
				it: "Bicipiti",
				es: "Bíceps",
				fr: "Biceps",
			},
			"MainMuscle-Calves": {
				en: "Calves",
				it: "Polpacci",
				es: "Gemelos",
				fr: "Mollets",
			},
			"MainMuscle-Chest": {
				en: "Chest",
				it: "Pettorali",
				es: "Pecho",
				fr: "Poitrine",
			},
			"MainMuscle-Forearms": {
				en: "Forearms",
				it: "Avambracci",
				es: "Antebrazos",
				fr: "Avant-bras",
			},
			"MainMuscle-Glutes": {
				en: "Glutes",
				it: "Glutei",
				es: "Glúteos",
				fr: "Fessiers",
			},
			"MainMuscle-Hamstrings": {
				en: "Hamstrings",
				it: "Ischiocrurali",
				es: "Isquiotibiales",
				fr: "Ischio-jambiers",
			},
			"MainMuscle-Lats": {
				en: "Lats",
				it: "Dorsali",
				es: "Dorsales",
				fr: "Dorsaux",
			},
			"MainMuscle-Neck": {
				en: "Neck",
				it: "Collo",
				es: "Cuello",
				fr: "Cou",
			},
			"MainMuscle-Obliques": {
				en: "Obliques",
				it: "Addominali Obliqui",
				es: "Oblicuos",
				fr: "Obliques",
			},
			"MainMuscle-Quads": {
				en: "Quads",
				it: "Quadricipiti",
				es: "Cuádriceps",
				fr: "Quadriceps",
			},
			"MainMuscle-Shoulder": {
				en: "Shoulders",
				it: "Spalle",
				es: "Hombros",
				fr: "Épaule",
			},
			"MainMuscle-Traps": {
				en: "Traps",
				it: "Trapezi",
				es: "Trapecios",
				fr: "Trapèzes",
			},
			"MainMuscle-Triceps": {
				en: "Triceps",
				it: "Tricipiti",
				es: "Tríceps",
				fr: "Triceps",
			},
			"MainMuscle-Hips": {
				en: "Hip flexors",
				it: "Flessori dell'anca",
				es: "Hip flexors",
				fr: "Hip flexors",
			},
			"MainMuscle-Rhomboids": {
				en: "Rhomboids",
				it: "Romboidi",
				es: "Romboides",
				fr: "Rhomboïdes",
			},
			"Muscle-Abductors": {
				en: "Abductors",
				it: "Abduttori",
				es: "Abductores",
				fr: "Abducteurs",
			},
			"Muscle-Abs": {
				en: "Abs",
				it: "Addominali",
				es: "Abdominales",
				fr: "Abdos",
			},
			"Muscle-Adductors": {
				en: "Adductors",
				it: "Adduttori",
				es: "Aductores",
				fr: "Adducteurs",
			},
			"Muscle-BackLower": {
				en: "Lower Back",
				it: "Schiena Bassa",
				es: "Espalda Baja",
				fr: "Bas du dos",
			},
			"Muscle-BackMiddle": {
				en: "Middle Back",
				it: "Schiena Media",
				es: "Espalda Media",
				fr: "Milieu du dos",
			},
			"Muscle-Bicep": {
				en: "Biceps",
				it: "Bicipiti",
				es: "Bíceps",
				fr: "Biceps",
			},
			"Muscle-Calves": {
				en: "Calves",
				it: "Polpacci",
				es: "Gemelos",
				fr: "Mollets",
			},
			"Muscle-Chest": {
				en: "Chest",
				it: "Pettorali",
				es: "Pecho",
				fr: "Poitrine",
			},
			"Muscle-Forearms": {
				en: "Forearms",
				it: "Avambracci",
				es: "Antebrazos",
				fr: "Avant-bras",
			},
			"Muscle-Glutes": {
				en: "Glutes",
				it: "Glutei",
				es: "Glúteos",
				fr: "Fessiers",
			},
			"Muscle-Hamstrings": {
				en: "Hamstrings",
				it: "Ischiocrurali",
				es: "Isquiotibiales",
				fr: "Ischio-jambiers",
			},
			"Muscle-Lats": {
				en: "Lats",
				it: "Dorsali",
				es: "Dorsales",
				fr: "Dorsaux",
			},
			"Muscle-Neck": {
				en: "Neck",
				it: "Collo",
				es: "Cuello",
				fr: "Cou",
			},
			"Muscle-Obliques": {
				en: "Obliques",
				it: "Addominali Obliqui",
				es: "Oblicuos",
				fr: "Obliques",
			},
			"Muscle-Quads": {
				en: "Quads",
				it: "Quadricipiti",
				es: "Cuádriceps",
				fr: "Quadriceps",
			},
			"Muscle-Shoulder": {
				en: "Shoulders",
				it: "Spalle",
				es: "Hombros",
				fr: "Épaule",
			},
			"Muscle-Traps": {
				en: "Traps",
				it: "Trapezi",
				es: "Trapecios",
				fr: "Trapèzes",
			},
			"Muscle-Triceps": {
				en: "Triceps",
				it: "Tricipiti",
				es: "Tríceps",
				fr: "Triceps",
			},
			"Muscle-Hips": {
				en: "Hip flexors",
				it: "Flessori dell'anca",
				es: "Hip flexors",
				fr: "Hip flexors",
			},
			"Muscle-Rhomboids": {
				en: "Rhomboids",
				it: "Romboidi",
				es: "Romboides",
				fr: "Rhomboïdes",
			},
			"Equipment-BalanceBoard": {
				en: "Balance board",
				it: "Tavoletta propriocettiva",
				es: "Plato de freeman",
				fr: "Tableau d'équilibre",
			},
			"Equipment-HandleBands": {
				en: "Handle bands",
				it: "Elastici con maniglie",
				es: "Elásticos con asas",
				fr: "Bande élastique avec poignéess",
			},
			"Equipment-LoopBands": {
				en: "Loop bands ",
				it: "Fasce elastiche",
				es: "Bandas elásticas",
				fr: "Élastiques",
			},
			"Equipment-Barbell": {
				en: "Barbell",
				it: "Bilanciere",
				es: "Barra",
				fr: "Barre de musculation",
			},
			"Equipment-BattleRopes": {
				en: "Battle ropes",
				it: "Battle ropes",
				es: "Battle ropes",
				fr: "Battle ropes",
			},
			"Equipment-Bench": {
				en: "Bench",
				it: "Panca",
				es: "Banco",
				fr: "Banc",
			},
			"Equipment-BodyWeight": {
				en: "Bodyweight",
				it: "Corpo libero",
				es: "Cuerpo libre",
				fr: "Poids du corps",
			},
			Functional: {
				en: "Functional",
				it: "Functional",
				es: "Functional",
				fr: "Functional",
			},
			"Equipment-BOSU": {
				en: "BOSU",
				it: "BOSU",
				es: "BOSU",
				fr: "BOSU",
			},
			"Equipment-PlyoBox": {
                en: "Plyo box / Step",
                it: "Plyo box / Step",
                es: "Plyo box / Step",
                fr: "Plyo box / Step",
            },
			"Equipment-Dumbbell": {
				en: "Dumbbell",
				it: "Manubrio",
				es: "Mancuerna",
				fr: "Haltère",
			},
			"Equipment-FoamRoller": {
				en: "Foam roller",
				it: "Foam roller",
				es: "Foam roller",
				fr: "Foam roller",
			},
			"Equipment-PilatesRoller": {
				en: "Pilates roller",
				it: "Pilates roller",
				es: "Pilates roller",
				fr: "Pilates roller",
			},
			"Equipment-PilatesRing": {
				en: "Pilates ring",
				it: "Pilates ring",
				es: "Aro de Pilates",
				fr: "Pilates ring",
			},
			"Equipment-JumpRope": {
				en: "Jump rope",
				it: "Corda per saltare",
				es: "Cuerda para saltar",
				fr: "Corde à sauter",
			},
			"Equipment-Kettlebell": {
				en: "Kettlebell",
				it: "Kettlebell",
				es: "Pesas rusas",
				fr: "Kettlebell",
			},
			"Equipment-LacrosseBall": {
				en: "Lacrosse ball",
				it: "Palla da lacrosse",
				es: "Pelota de lacrosse",
				fr: "Balle de lacrosse",
			},
			"Equipment-Landmine": {
				en: "Landmine",
				it: "Landmine",
				es: "Landmine",
				fr: "Landmine",
			},
			"Equipment-Strength": {
				en: "Strength equipments",
				it: "Strength equipments",
				es: "Strength equipments",
				fr: "Strength equipments",
			},
			"Equipment-Cardio": {
				en: "Cardio equipments",
				it: "Cardio equipments",
				es: "Cardio equipments",
				fr: "Cardio equipments",
			},
			"Equipment-Mat": {
				en: "Mat",
				it: "Tappetino",
				es: "Colchoneta",
				fr: "Tapis",
			},
			"Equipment-Boxing": {
				en: "Boxing",
				it: "Boxing",
				es: "Boxing",
				fr: "Boxing",
			},
			"Equipment-MedicineBall": {
				en: "Medicine ball",
				it: "Palla medica",
				es: "Pelota medicinal",
				fr: "Medicine ball",
			},
			"Equipment-MiniBand": {
				en: "Mini band",
				it: "Mini band",
				es: "Mini band",
				fr: "Mini bande élastique",
			},
			"Equipment-Plate": {
				en: "Plate",
				it: "Piastra",
				es: "Disco",
				fr: "Disque",
			},
			"Equipment-PullUpBar": {
				en: "Pull up bar",
				it: "Sbarra per trazioni",
				es: "Barra de dominadas",
				fr: "Barre de traction",
			},
			"Equipment-Sandbag": {
				en: "Sandbag",
				it: "Sandbag",
				es: "Sandbag",
				fr: "Sandbag",
			},
			"Equipment-SlamBall": {
				en: "Slam ball",
				it: "Slam ball",
				es: "Slam ball",
				fr: "Slam ball",
			},
			"Equipment-Sled": {
				en: "Sled",
				it: "Slitta",
				es: "Trineo",
				fr: "Traîneau",
			},
			"Equipment-Sliders": {
				en: "Sliders",
				it: "Sliders",
				es: "Discos deslizantes",
				fr: "Sliders",
			},
			"Equipment-SuspensionTrainer": {
				en: "Suspension trainer",
				it: "Suspension trainer",
				es: "Suspension trainer",
				fr: "Suspension trainer",
			},
			"Equipment-SwissBall": {
				en: "Swiss ball",
				it: "Swiss ball",
				es: "Fit ball",
				fr: "Swiss ball",
			},
			"Equipment-Clubbell": {
				en: "Clubbell",
				it: "Clubbell",
				es: "Clubbell",
				fr: "Clubbell",
			},
			"Equipment-TGEEncompass": {
				en: "Total Gym Encompass™",
				it: "Total Gym Encompass™",
				es: "Total Gym Encompass™",
				fr: "Total Gym Encompass™",
			},
			"Equipment-PosturalBench": {
				en: "Postural Bench",
				it: "Panca Posturale",
				es: "Banco Postural",
				fr: "Banc Postural"
			},
			"Equipment-Blast": {
				en: "Blast",
				it: "Blast",
				es: "Blast",
				fr: "Blast",
			},
			"Equipment-Reformer": {
				en: "Reformer",
				it: "Reformer",
				es: "Reformer",
				fr: "Reformer",
			},
			"Equipment-EVOWorkstation": {
				en: "EVO Workstation",
				it: "EVO Workstation",
				es: "EVO Workstation",
				fr: "EVO Workstation",
			},
			"Equipment-WallBall": {
				en: "Wall Ball",
				it: "Wall Ball",
				es: "Wall Ball",
				fr: "Wall Ball",
			},
			"Activity-Cardio": {
				en: "Cardio",
				it: "Cardio",
				es: "Cardio",
				fr: "Cardio",
			},
			"Activity-BodyWeight": {
				en: "Body weight",
				it: "Corpo libero",
				es: "Cuerpo libre",
				fr: "Poids du corps",
			},
			"Activity-YogaPilates": {
				en: "Yoga/Pilates",
				it: "Yoga/Pilates",
				es: "Yoga/Pilates",
				fr: "Yoga/Pilates",
			},
			"Activity-Functional": {
				en: "Functional",
				it: "Functional",
				es: "Functional",
				fr: "Functional",
			},
			"Activity-Stretching": {
				en: "Stretching",
				it: "Stretching",
				es: "Stretching",
				fr: "Stretching",
			},
			"Activity-Mobility": {
				en: "Mobility",
				it: "Mobility",
				es: "Mobility",
				fr: "Mobility",
			},
			"Activity-Combat": {
				en: "Combat",
				it: "Combat",
				es: "Combat",
				fr: "Combat",
			},
			"Activity-Strengthening": {
				en: "Strengthening",
				it: "Strengthening",
				es: "Strengthening",
				fr: "Strengthening",
			},
			"Wkstag-Stretching": {
				en: "Stretching",
				it: "Stretching",
				es: "Stretching",
				fr: "Ètirement",
			},
			"Wkstag-Strengthening": {
				en: "Strengthening",
				it: "Forza",
				es: "Fuerza",
				fr: "Musculation",
			},
			"Wkstag-Mobility": {
				en: "Mobility",
				it: "Mobilità",
				es: "Movilidad",
				fr: "Mobilisation",
			},
			"Wkstag-Cardio": {
				en: "Cardio",
				it: "Cardio",
				es: "Cardio",
				fr: "Cardio",
			},
			"Wkstag-Combat": {
				en: "Combat",
				it: "Combat",
				es: "Combat",
				fr: "Combat",
			},
			"Wkstag-YogaPilates": {
				en: "Yoga/Pilates",
				it: "Yoga/Pilates",
				es: "Yoga/Pilates",
				fr: "Yoga/Pilates",
			},
			"Wkstag-BodyWeight": {
				en: "Bodyweight",
				it: "Corpo libero",
				es: "Peso Corporal",
				fr: "Corps Libre",
			},
			"Wkstag-CrossTraining": {
				en: "Cross Training",
				it: "Cross Training",
				es: "Cross Training",
				fr: "Cross Training",
			},
			"Wkstag-BackSchool": {
				en: "Back School",
				it: "Back School",
				es: "Escuela de la Espalda",
				fr: "Gym du Dos",
			},
			"Wkstag-BodyBuilding": {
				en: "Body Building",
				it: "Body Building",
				es: "Body Building",
				fr: "Body Building",
			},
			"Wkstag-Endurance": {
				en: "Endurance",
				it: "Endurance",
				es: "Resistencia",
				fr: "Endurance",
			},
			"wetag-Equipment": {
				en: "Equipment",
				it: "Attrezzatura",
				es: "Equipo",
				fr: "Équipement",
			},
			"wetag-Activity": {
				en: "Activity",
				it: "Attività",
				es: "Actividad",
				fr: "Activité",
			},
			"wetag-Brand": {
				en: "Brand",
				it: "Brand",
				es: "Brand",
				fr: "Brand",
			},
			"wetag-MainMuscle": {
				en: "Main Muscle",
				it: "Muscolo Principale",
				es: "Músculo Principal",
				fr: "Muscle Principal",
			},
			"wetag-Muscle": {
				en: "Secondary Muscles",
				it: "Muscoli Secondari",
				es: "Músculos secundarios",
				fr: "Muscles secondaires",
			},
			"Brand-Triform": {
				en: "Triform",
				it: "Triform",
				es: "Triform",
				fr: "Triform",
			},
			"Brand-TotalGym": {
				en: "TotalGym",
				it: "TotalGym",
				es: "TotalGym",
				fr: "TotalGym",
			},
			"Brand-WellBackSystem": {
				en: "WellBackSystem",
				it: "WellBackSystem",
				es: "WellBackSystem",
				fr: "WellBackSystem",
			},
			"Brand-Flowin": {
				en: "Flowin",
				it: "Flowin",
				es: "Flowin",
				fr: "Flowin",
			},
			"Brand-XeniosUSA": {
				en: "Xenios USA",
				it: "Xenios USA",
				es: "Xenios USA",
				fr: "Xenios USA",
			},
			"Brand-BlastJump": {
				en: "Blast Jump",
				it: "Blast Jump",
				es: "Blast Jump",
				fr: "Blast Jump",
			},
			"Brand-BodyExercisePilates": {
				en: "Body & Exercise Pilates",
				it: "Body & Exercise Pilates",
				es: "Body & Exercise Pilates",
				fr: "Body & Exercise Pilates",
			},
			Muscles: {
				en: "Muscles",
				it: "Muscoli",
				es: "Músculos",
				fr: "Muscles",
			},
			Defaults: {
				en: "Defaults",
				it: "Defaults",
				es: "Defaults",
				fr: "Defaults",
			},
			Front: {
				en: "Front",
				it: "Frontale",
				es: "Frente",
				fr: "Avant",
			},
			Side: {
				en: "Side",
				it: "Lato",
				es: "Lado",
				fr: "Côté",
			},
			ThreeQuarters: {
				en: "Three Quarters",
				it: "Tre Quarti",
				es: "Tres Cuartos",
				fr: "Trois Quarts",
			},
			selected: {
				en: "Selected",
				it: "Selezionati",
				es: "Seleccionado",
				fr: "Choisi",
			},
			interval: {
				en: "Interval",
				it: "Interval",
				es: "Interval",
				fr: "Interval",
			},
			regular: {
				en: "Regular",
				it: "Regular",
				es: "Regular",
				fr: "Regular",
			},
			"create-workout": {
				en: "Create Workout",
				it: "Crea Scheda di Allenamento",
				es: "Crear Programa de Entrenamiento",
				fr: "Créer Programme d’Entraînement",
			},
			"create-timer-workout": {
				en: "Create time-based workout. All exercises will be guided by duration.",
				it: "Crea una scheda a tempo. Tutti gli esercizi saranno guidati dalla durata.",
				es: "Crear un programa basado en el tiempo. Todos los ejercicios estarán guiados por la duración.",
				fr: "Créez un programme basé sur le temps. Tous les exercices seront guidés par la durée.",
			},
			"create-standard-workout": {
				en: "This workout can contain both time-based elements and standalone exercises.",
				it: "Questa scheda può contenere sia elementi basati sul tempo che esercizi autonomi.",
				es: "Este programa puede contener tanto elementos basados en el tiempo como ejercicios independientes.",
				fr: "Ce programme peut contenir à la fois des éléments temporels et des exercices autonomes.",
			},
			"all-members": {
				en: "All members",
				it: "Tutti i membri",
				es: "Todos los miembros",
				fr: "Tous les membres",
			},
			"this-file-is-visible-to-all-club-members": {
				en: "This file is visible to all club members",
				it: "Questo file è visibile a tutti i membri del club",
				es: "Este archivo es visible para todos los miembros del club",
				fr: "Ce fichier est visible pour tous les membres du club",
			},
			"if-you-want-to-share-it-with-only-some-members-you-need-to-remove-visibility-to-all-club-members": {
				en: "If you want to share it with only some members, you need to remove visibility to all club members",
				it: "Se vuoi condividerlo solo con alcuni membri, devi rimuovere la visibilità a tutti i membri del club",
				es: "Si deseas compartirlo solo con algunos miembros, debes quitar la visibilidad a todos los miembros del club",
				fr: "Si vous voulez le partager avec certains membres, vous devez supprimer la visibilité pour tous les membres du club",
			},
			"make-the-selected-workout-visible-to-all-members": {
				en: "Make the selected workout visible to all members.",
				it: "Rendi visibile la scheda a tutti i membri del tuo Club.",
				es: "Haga que el programa seleccionado sea visible para todos los miembros.",
				fr: "Rendre le programme sélectionné visible à tous les membres.",
			},
			"continuing-you-will-remove-all-shares-with-members": {
				en: "Continuing, you will remove all shares with members",
				it: "Continuando, rimuoverai tutte le condivisioni con i membri",
				es: "Continuando, eliminarás todas las comparticiones con los miembros",
				fr: "En continuant, vous supprimerez toutes les partages avec les membres",
			},
			"remove-visibility-to-all-members": {
				en: "Remove visibility to all club members.",
				it: "Rimuovi la visibilità a tutti i membri del club.",
				es: "Quitar visibilidad a todos los miembros del club.",
				fr: "Supprimer la visibilité pour tous les membres du club.",
			},
			"the-date-range-entered-cannot-include-the-week-you-are-copying": {
				en: "The date range entered cannot include the week you are copying.",
				it: "L'intervallo di date inserito non può includere la settimana che stai copiando.",
				es: "El rango de fechas ingresado no puede incluir la semana que está copiando",
				fr: "La plage de dates saisie ne peut pas inclure la semaine que vous copiez.",
			},
			"copy-week": {
				en: "Copy Week",
				it: "Copia Settimana",
				es: "Copiar Semana",
				fr: "Copier la Semaine",
			},
			"apply-this-schedule-to-the-interval": {
				en: "Apply this schedule to the interval:",
				it: "Applica questa programmazione all'intervallo:",
				es: "Aplicar este horario al intervalo:",
				fr: "Appliquer cette planification à l'intervalle:",
			},
			"you-are-unsharing-the-file-from": {
				en: "You are unsharing the file from",
				it: "Stai togliendo la condivisione del file a",
				es: "Estás dejando de compartir el archivo un",
				fr: "Vous annulez le partage du fichier a",
			},
			"you-are-deleting-the-file-from": {
				en: "You are deleting the file from",
				it: "Stai eliminando il file da",
				es: "Estás eliminando el archivo de",
				fr: "Vous supprimez le fichier de",
			},
			"you-are-editing-a-workout-shared-with-x-athletes": {
				en: "You are editing a workout shared with {0} athletes.",
				it: "Stai modificado una scheda condivisa con {0} atleti.",
				es: "Estás editando un entrenamiento compartido con {0} atletas.",
				fr: "Vous modifiez un entraînement partagé avec {0} athlètes.",
			},
			"you-are-cloning-this-workout-and-assigning-it-to-selected-athletes": {
				en: "You are cloning this workout and assigning it to selected athletes",
				it: "Stai clonando questo allenamento e assegnandolo agli atleti selezionati",
				es: "Está clonando este entrenamiento y asignándolo a atletas seleccionados",
				fr: "Vous êtes en train de cloner cet entraînement et de l'attribuer à certains athlètes",
			},
			"you-are-cloning-this-workout-so-that-it-becomes-shareable-you-will-find-it-in-the-club-tab": {
				en: "You are cloning this workout so that it becomes shareable. You will find it in the Club tab.",
				it: "Stai clonando questo workout in modo che diventi condivisibile. Lo ritrovareai nella Scheda Club.",
				es: "Estás clonando este entrenamiento para que se pueda compartir. Lo encontrarás en la pestaña Club.",
				fr: "Vous clonez cet entraînement afin qu'il devienne partageable. Vous le trouverez dans l'onglet Club.",
			},
			"selected-athletes": {
				en: "Selected athletes",
				it: "Atleti selezionati",
				es: "Atletas seleccionados",
				fr: "Athlètes sélectionnés",
			},
			"selected-members": {
				en: "Selected members",
				it: "Membri selezionati",
				es: "Miembros seleccionados",
				fr: "Membres sélectionnés",
			},
			"add-participant": {
				en: "Add Participant",
				it: "Aggiungi Partecipante",
				es: "Añada Participante",
				fr: "Ajouter Participant",
			},
			Waiting: {
				en: "Waiting",
				it: "In Attesa",
				es: "Esperando",
				fr: "En Attente",
			},
			Processing: {
				en: "Processing",
				it: "Elaborazione",
				es: "Procesando",
				fr: "En Cours",
			},
			Success: {
				en: "Success",
				it: "Ok",
				es: "Éxito",
				fr: "Succès",
			},
			Failed: {
				en: "Failed",
				it: "Fallito",
				es: "Fallido",
				fr: "Échec",
			},
			"show-athlete-menu": {
				en: "Show athlete menù",
				it: "Mostra menù atleta",
				es: "Mostrar menú de atleta",
				fr: "Afficher menu des athlètes",
			},
			"you-have-selected-activities-that-are-not-published": {
				en: "You have selected activities that are not Published",
				it: "Hai selezionato attività non pubblicate",
				es: "Has seleccionado actividades que no están publicadas",
				fr: "Vous avez sélectionné des activités qui ne sont pas publiées",
			},
			"select-athlete": {
				en: "Select Athlete",
				it: "Seleziona Atleta",
				es: "Seleccionar Atleta",
				fr: "Sélectionnez Un Athlète",
			},
			"inconsistent-lessons": {
				en: "Inconsistent lessons",
				it: "Lezioni non omogenee",
				es: "Lecciones no homogéneas",
				fr: "Leçons non homogènes",
			},
			source: {
				en: "Source",
				it: "Origine",
				es: "Fuente",
				fr: "Source",
			},
			uptivo: {
				en: "Uptivo",
				it: "Uptivo",
				es: "Uptivo",
				fr: "Uptivo",
			},
			"you-are-publish-this-exercise": {
				en: "You are publishing this exercise",
				it: "Stai pubblicando questo esercizio",
				es: "Estás publicando este ejercicio",
				fr: "Vous publiez cet exercice",
			},
			"you-are-unpublish-this-exercise": {
				en: "You are unpublishing this exercise",
				it: "Stai togliendo dalla pubblicazione questo esercizio",
				es: "Estás retirando la publicación de este ejercicio",
				fr: "Vous retirez la publication de cet exercice",
			},
			"you-are-publish-this-workoutsheet": {
				en: "You are publishing this workout",
				it: "Stai pubblicando questa scheda",
				es: "Estás publicando este workout",
				fr: "Vous publiez cet workout",
			},
			"you-are-unpublish-this-workoutsheet": {
				en: "You are unpublishing this workout",
				it: "Stai togliendo dalla pubblicazione questa scheda",
				es: "Estás retirando la publicación de este workout",
				fr: "Vous retirez la publication de cet workout",
			},
			"uptivo-editor-sheets": {
				en: "Uptivo Workouts (EDITOR)",
				it: "Uptivo Workouts (EDITOR)",
				es: "Uptivo Workouts (EDITOR)",
				fr: "Uptivo Workouts (EDITOR)",
			},
			"uptivo-workouts": {
				en: "Uptivo Workouts",
				it: "Uptivo Workouts",
				es: "Uptivo Workouts",
				fr: "Uptivo Workouts",
			},
			"make-visible-to-all": {
				en: "Make visible to all",
				it: "Rendi visibile a tutti",
				es: "Hacer visible para todos",
				fr: "Rendre visible pour tous",
			},
			"hide-from-everyone": {
				en: "Hide from everyone",
				it: "Nascondi a tutti",
				es: "Ocultar de todos",
				fr: "Masquer à tout le monde",
			},
			"move-up": {
				en: "Move Up",
				it: "Sposta in alto",
				es: "Mover hacia arriba",
				fr: "Déplacer vers le haut",
			},
			"move-down": {
				en: "Move Down",
				it: "Sposta in basso",
				es: "Mover hacia abajo",
				fr: "Déplacer vers le bas",
			},
			"move-left": {
				en: "Move Left",
				it: "Sposta a Sinistra",
				es: "Mover a la Izquierda",
				fr: "Déplacer à Gauche"
			},
			"move-right": {
				en: "Move Right",
				it: "Sposta a Destra",
				es: "Mover a la Derecha",
				fr: "Déplacer à Droite"
			},
			"rotate-right": {
				en: "Rotate Right",
				it: "Ruota a Destra",
				es: "Rotar a la Derecha",
				fr: "Tourner à Droite"
			},
			"rotate-left": {
				en: "Rotate Left",
				it: "Ruota a Sinistra",
				es: "Rotar a la Izquierda",
				fr: "Tourner à Gauche"
			},
			"clone": {
				en: "Clone",
				it: "Clona",
				es: "Clonar",
				fr: "Cloner",
			},
			"image": {
				en: "Picture",
				it: "Immagine",
				es: "Imagen",
				fr: "Image",
			},
			"new": {
				en: "New",
				it: "Nuovi",
				es: "Nuevos",
				fr: "Nouveaux",
			},
			"choose-workout": {
				en: "Choose Workout",
				it: "Scegli Allenamento",
				es: "Seleccionar Entrenamiento",
				fr: "Choisir Entraînement",
			},
			"you-are-cloning-this-workout-and-assigning-it-to-selected-athlete": {
				en: "You are cloning this workout and assigning it to the selected athlete",
				it: "Stai clonando questo allenamento e assegnandolo all'atleta selezionato",
				es: "Estás clonando este entrenamiento y asignándolo al atleta seleccionado",
				fr: "Vous clonez cet entraînement et l'assignez à l'athlète sélectionné",
			},
			"clone-workout": {
				en: "Select existing workouts and assign them to this user as personal workouts.",
				it: "Seleziona una scheda esistente e assegnala a questo utente come scheda personale.",
				es: "Seleccione un programa existente y asígnelo a este usuario como programa personal.",
				fr: "Sélectionnez un programme existant et attribuez-le à cet utilisateur en tant que programme personnel.",
			},
			"share-workout": {
				en: "Select existing workouts and share them with this user.",
				it: "Seleziona le schede esistenti e condividile con questo utente.",
				es: "Selecciona programas existentes y compártalos con este usuario.",
				fr: "Sélectionnez les programmes existants et partagez-les avec cet utilisateur.",
			},
			"create-new-workout": {
				en: "Create new workout.",
				it: "Crea nuovo allenamento.",
				es: "Crear nuevo entrenamiento.",
				fr: "Créer un nouvel entraînement.",
			},
			"invalid-id": {
				en: "Invalid Id",
				it: "Id non valido",
				es: "Id no válido",
				fr: "Id invalide",
			},
			"add-image": {
				en: "Add Image",

				it: "Aggiungi Immagine",
				es: "Agregar Imagen",
				fr: "Ajouter une Image",
			},
			"cash": {
				en: "Cash",
				it: "Contante",
				es: "Efectivo",
				fr: "Argent liquide"
			},
			"debit": {
				en: "Debit Card",
				it: "Carta di Debito",
				es: "Tarjeta de Débito",
				fr: "Carte de Débit"
			},
			"credit": {
				en: "Credit Card",
				it: "Carta di Credito",
				es: "Tarjeta de Crédito",
				fr: "Carte de Crédit"
			},
			"wire-transfer": {
				en: "Wire Transfer",
				it: "Bonifico Bancario",
				es: "Transferencia Bancaria",
				fr: "Virement Bancaire"
			},
			"other": {
				en: "Other",
				it: "Altro",
				es: "Otro",
				fr: "Autre"
			},
			"refund": {
				en: "Refund",
				it: "Rimborso",
				es: "Reembolso",
				fr: "Remboursement"
			},
			"total-movements": {
				en: "TOTAL",
				it: "TOTALE",
				es: "TOTAL",
				fr: "TOTAL"
			},
			"tax-id": {
				en: "Tax Id",
				it: "C.F./P.I.",
				es: "Tax Id",
				fr: "Tax Id",
			},
			"translated-exercises": {
				en: "Translated Exercises",
				it: "Esercizi tradotti",
				es: "Ejercicios traducidos",
				fr: "Exercices traduits"
			},
			"untranslated-exercises": {
				en: "Untranslated Exercises",
				it: "Esercizi non tradotti",
				es: "Ejercicios no traducidos",
				fr: "Exercices non traduits"
			},
			"choose-language": {
				en: "Choose Language",
				it: "Scegli Lingua",
				es: "Seleccionar Idioma",
				fr: "Choisir la Langue"
			},
			"movements": {
				en: "Transactions",
				it: "Movimenti",
				es: "Transacciones",
				fr: "Transactions"
			},
			"method": {
				en: "Method",
				it: "Metodo",
				es: "Método",
				fr: "Moyen"
			},
			"transaction-type": {
				en: "Transaction Type",
				it: "Tipo di Transazione",
				es: "Tipo de Transacción",
				fr: "Type de Transaction"
			},
			"payment-mode": {
				en: "Payment Mode",
				it: "Modalità di Pagamento",
				es: "Modo de Pago",
				fr: "Mode de Paiement"
			},
			"movement-not-found": {
				en: "Movement Not Found",
				it: "Movimento Non Trovato",
				es: "Movimiento no Encontrado",
				fr: "Mouvement Non Trouvé"
			},
			"add-transaction": {
				en: "Add Transaction",
				it: "Aggiungi Pagamento",
				es: "Agregar Transacción",
				fr: "Ajouter une Transaction"
			},
			"currency": {
				en: "Currency",
				it: "Valuta",
				es: "Moneda",
				fr: "Devise"
			},
			"movement": {
				en: "Movement",
				it: "Movimento",
				es: "Movimiento",
				fr: "Mouvement"
			},
			"movement-not-in-export": {
				en: "This movement will not appear in the export",
				it: "Questo movimento non comparirà nell'esportazione",
				es: "Este movimiento no aparecerá en la exportación",
				fr: "Ce mouvement n'apparaîtra pas dans l'export"
			},
			"movement-in-export": {
				en: "This movement will appear in the export",
				it: "Questo movimento comparirà nell'esportazione",
				es: "Este movimiento aparecerá en la exportación",
				fr: "Ce mouvement apparaîtra dans l'export"
			},
			"visible-in-export": {
				en: "Visible in the export",
				it: "Visibile nell'esportazione",
				es: "Visible en la exportación",
				fr: "Visible dans l'export"
			},
			"purchase": {
				en: "Purchase",
				it: "Acquisto",
				es: "Compra",
				fr: "Achat"
			},
			"check-movement-data": {
				en: "Check the movement data",
				it: "Verifica i dati del movimento",
				es: "Verifica los datos del movimiento",
				fr: "Vérifiez les données du mouvement"
			},
			"credits-modified-successfully": {
				en: "Credits modified successfully",
				it: "Crediti modificati correttamente",
				es: "Créditos modificados correctamente",
				fr: "Crédits modifiés avec succès"
			},
			"missing-language": {
				en: "Missing Language",
				it: "Lingua Mancante",
				es: "Idioma Faltante",
				fr: "Langue Manquante"
			},
			"add-circuit": {
				en: "Circuit",
				it: "Circuit",
				es: "Circuit",
				fr: "Circuit"
			},
			"laps": {
				en: "Rounds",
				it: "Round",
				es: "Rondas",
				fr: "Manches"
			},
			"create-for": {
				en: "Create for",
				it: "Crea per",
				es: "Crear para",
				fr: "Créer pour"
			},
			"payment-method": {
				en: "Payment Method",
				it: "Metodo di Pagamento",
				es: "Método de Pago",
				fr: "Moyen de Paiement"
			},
			"payment": {
				en: "Payment",
				it: "Pagamento",
				es: "Pago",
				fr: "Paiement"
			},
			"manual": {
				en: "Manual",
				it: "Manuale",
				es: "Manual",
				fr: "Manuel"
			},
			"online": {
				en: "Online",
				it: "Online",
				es: "En Línea",
				fr: "En Ligne"
			},
			"operator": {
				en: "Operator",
				it: "Operatore",
				es: "Operador",
				fr: "Opérateur"
			},
			"operator-email": {
				en: "Operator Email",
				it: "Email Operatore",
				es: "Operador Email",
				fr: "Opérateur Email"
			},
			"linked-payment": {
				en: "Linked Payment",
				it: "Pagamento Collegato",
				es: "Pago Vinculado",
				fr: "Paiement Lié"
			},
			"user-bookings-enabled": {
				en: "User has bookings enabled",
				it: "L'utente ha le prenotazioni abilitate",
				es: "El usuario tiene reservas habilitadas",
				fr: "L'utilisateur a des réservations activées"
			},
			"user-bookings-disabled": {
				en: "User Bookings Disabled",
				it: "Prenotazioni disabilitate per l'utente",
				es: "Reservas deshabilitadas para el usuario",
				fr: "Réservations désactivées pour l'utilisateur"
			},
			"bookings-block-until": {
				en: "Ban bookings until",
				it: "Blocco prenotazioni fino al",
				es: "Bloqueo reservas hasta",
				fr: "Blocage réservations jusqu'au"
			},
			"bookings-block": {
				en: "Bookings Ban",
				it: "Blocco Prenotazioni",
				es: "Bloqueo de Reservas",
				fr: "Blocage des Réservations"
			},
			"delete-booking-limit": {
				en: "Delete Booking Limit",
				it: "Elimina limite di prenotazione",
				es: "Eliminar límite de reserva",
				fr: "Supprimer la limite de réservation"
			},
			"user-will-have-active-bookings": {
				en: "User will have active bookings",
				it: "L'utente avrà le prenotazioni attive",
				es: "El usuario tendrá reservas activas",
				fr: "L'utilisateur aura des réservations actives"
			},
			"rest-at-least-five-seconds": {
				en: "The rest must be at least 5 seconds",
				it: "La pausa deve essere di almeno 5 secondi",
				es: "El descanso debe ser de al menos 5 segundos",
				fr: "La pause doit être d'au moins 5 secondes"
			},
			"cannot-add-same-exercises-to-set": {
				en: "It is not possible to add exercises that are the same as those already present in the set",
				it: "Non è possibile aggiungere esercizi uguali a quelli già presenti nel set",
				es: "No es posible agregar ejercicios que sean iguales a los que ya están presentes en el conjunto",
				fr: "Il n'est pas possible d'ajouter des exercices identiques à ceux déjà présents dans l'ensemble"
			},
			"max-exercises-number-is-9": {
				en: "The maximum number of exercises allowed is 9",
				it: "Il numero massimo di esercizi consentiti è 9",
				es: "El número máximo de ejercicios permitidos es 9",
				fr: "Le nombre maximum d'exercices autorisés est de 9"
			},
			"no-zone": {
				en: "No Zone",
				it: "Nessuna Zona",
				es: "Sin Zona",
				fr: "Pas de Zone"
			},
			"groups": {
				en: "Groups",
				it: "Gruppi",
				es: "Grupos",
				fr: "Groupes"
			},
			"circuit": {
				en: "On-screen Workout",
				it: "Allenamento A Schermo",
				es: "Entrenamiento De Pantalla",
				fr: "Entraînement Sur Ècran"
			},
			"circuits": {
				en: "On-screen Workouts",
				it: "Allenamenti A Schermo",
				es: "Entrenamientos De Pantalla",
				fr: "Entraînements Sur Ècran"
			},
			"on-screen-workout-planning": {
				"en": "On-screen Workout Planning",
				"it": "Pianificazione Allenamenti A Schermo",
				"es": "Planificación De Entrenamientos En Pantalla",
				"fr": "Planification Des Entraînements À l'Ecran"
			},
			"elements": {
				en: "elements",
				it: "elementi",
				es: "elementos",
				fr: "èléments"
			},
			"element": {
				en: "element",
				it: "elemento",
				es: "elemento",
				fr: "èlément"
			},
			"you-are-about-to-clone": {
				en: "You are about to clone",
				it: "Stai per clonare",
				es: "Estás a punto de clonar",
				fr: "Vous êtes sur le point de cloner"
			},
			"classes-participations": {
				en: "Classes Participations",
				it: "Partecipazioni alle Classi",
				es: "Participaciones en Clases",
				fr: "Participations aux Cours"
			},
			"past": {
				en: "Past",
				it: "Passate",
				es: "Pasadas",
				fr: "Passées"
			},
			"next": {
				en: "Next",
				it: "Prossime",
				es: "Próximas",
				fr: "Prochaines"
			},
			"disable-bookings-invalid-medical-certificate": {
				en: "Disable bookings if user does not have a valid medical certificate",
				it: "Disabilita prenotazioni se l'utente non ha un certificato medico valido",
				es: "Deshabilitar reservas si el usuario no tiene un certificado médico válido",
				fr: "Désactiver les réservations si l'utilisateur n'a pas de certificat médical valide"
			},
			"disable-bookings-invalid-mebership": {
				en: "Disable bookings if user does not have a valid membership",
				it: "Disabilita prenotazioni se l'utente non ha una iscrizione valida",
				es: "Deshabilitar reservas si el usuario no tiene una matrícula válida",
				fr: "Désactiver les réservations si l'utilisateur n'a pas une inscription valide"
			}
		},
		HomeView: {
			"uptivo-cloud-description": {
				en: "Combining a heart-rate monitoring solution with sport tracking and gamification features, Uptivo provides vertical solutions for functional training, combat fitness, indoor biking, and watersports in gyms, fitness boutiques, and PT studios.",
				it: "Combinando una soluzione di monitoraggio della frequenza cardiaca con funzionalità di tracciamento sportivo e gamification, Uptivo offre soluzioni verticali per l'allenamento funzionale, il combat fitness, il ciclismo indoor e gli sport acquatici in palestre, fitness boutique e studi PT.",
				es: "Al combinar una solución de monitoreo de frecuencia cardíaca con funciones de seguimiento deportivo y ludificación, Uptivo proporciona soluciones verticales para entrenamiento funcional, fitness de combate, ciclismo de interior y deportes acuáticos en gimnasios, boutiques de fitness y estudios de PT.",
				fr: "Combinant une solution de surveillance de la fréquence cardiaque avec des fonctionnalités de suivi sportif et de gamification, Uptivo fournit des solutions verticales pour l'entraînement fonctionnel, le fitness de combat, le vélo en salle et les sports nautiques dans les gymnases, les boutiques de fitness et les studios de PT.",
			},
			"app-description": {
				en: "Haven't you installed the Uptivo app yet to review all your progress and train when you're not at the gym? Download it here:",
				it: "Non hai ancora installato l'app Uptivo per rivedere tutti i tuoi progressi e allenarti quando non sei in palestra? Scaricala qui:",
				es: "¿Aún no has instalado la app de Uptivo para revisar todos tus progresos y entrenar cuando no estés en el gimnasio? Descarguelo aqui:",
				fr: "Vous n'avez pas encore installé l'application Uptivo pour revoir tous vos progrès et vous entraîner lorsque vous n'êtes pas à la salle de sport ? Télécharger les ici:",
			},
			signIn: {
				en: "Already a member? Sign in",
				it: "Sei già un membro? Accedi",
				es: "¿Ya eres miembro? Iniciar sesión",
				fr: "Déjà membre? Connectez-vous",
			},
			signUp: {
				en: "New member? Create an account",
				it: "Nuovo membro? Crea un account",
				es: "¿Nuevo miembro? Crear un perfil",
				fr: "Nouveau membre? Créer un profil",
			},
		},
		ClubMessagesView: {
			"new-message": {
				en: "New message from your club!",
				it: "Nuovo messaggio dal tuo club!",
				es: "¡Nuevo mensaje de tu club!",
				fr: "Nouveau message de votre club!",
			},
			"type-message-text-here": {
				en: "Type the message here",
				it: "Scrivi qui il messaggio",
				es: "Escribe el mensaje aquí",
				fr: "Tapez le message ici",
			},
			"edit-message": {
				en: "Edit Template",
				it: "Modifica Modello",
				es: "Editar Plantilla",
				fr: "Modifier le Modèle",
			},
			yes: {
				en: "Yes",
				it: "Sì",
				es: "Sí",
				fr: "Oui",
			},
			"successfully-add-athlete": {
				en: "Successfully add athlete/s",
				it: "Atleta/i aggiunto/i con successo",
				es: "Añadir con éxito atletas",
				fr: "Ajouter des athlètes avec succès",
			},
			"fast-schedule-challenge-title-calories": {
				en: "Monthly Calories",
				it: "Calorie Mensili",
				es: "Calorías Mensuales",
				fr: "Calories Mensuelles",
			},
			"fast-schedule-challenge-title-trainings": {
				en: "Monthly Trainings",
				it: "Allenamenti Mensili",
				es: "Entrenamientos Mensuales",
				fr: "Entrainement Mensuelles",
			},
			"fast-schedule-challenge-title-points": {
				en: "Monthly UPPs",
				it: "UPPs Mensili",
				es: "UPP Mensuales",
				fr: "UPP Mensuels",
			},
			"fast-schedule-challenge-title-valid-zone-points": {
				en: "Monthly Valid Zones UPPs",
				it: "UPPs In Zone Valide Mensili",
				es: "UPPs Mensuales De Zonas Válidas",
				fr: "UPPs De Zones Valides Mensuels",
			},
		},
		TrainingProgramsView: {
			"share-file": {
				en: "File Shares",
				it: "Condivisione del file",
				es: "Compartir el archivo",
				fr: "Partager le fichier",
			},
			"shared-programs": {
				en: "Shared Programs",
				it: "Programmi Condivisi",
				es: "Programas Compartidos",
				fr: "Programmes Partagés",
			},
			"training-programs": {
				en: "Workout Programs",
				it: "Programmi Di Allenamento",
				es: "Programas De Entrenamiento",
				fr: "Programmes D'Entraînement",
			},
			size: {
				en: "Size",
				it: "Dimensione",
				es: "Tamaño",
				fr: "Taille",
			},
			"shared-at": {
				en: "Shared on",
				it: "Condiviso il",
				es: "Compartido el",
				fr: "Partagé le",
			},
			"shared-by": {
				en: "Shared By",
				it: "Condiviso da",
				es: "Compartido por",
				fr: "Partagé par",
			},
			"no-shares": {
				en: "Not shared",
				it: "Non condiviso",
				es: "No compartido",
				fr: "Non partagé",
			},
		},
		AthletesBioView: {
			"BODY_CIRCUMFERENCES-mg": {
				en: "Circumferences",
				it: "Circonferenze",
				es: "Circunferencias",
				fr: "Circonférences",
			},
			"BODY_MASS-mg": {
				en: "Body Mass",
				it: "Massa Corporea",
				es: "Masa Corporal",
				fr: "Masse Corporelle",
			},
			"BODY_WATER-mg": {
				en: "Body Water",
				it: "Acqua Corporea",
				es: "Agua Corporal",
				fr: "Eau Corporelle",
			},
			"BODY_OTHER-mg": {
				en: "Other",
				it: "Altro",
				es: "Otro",
				fr: "Autre",
			},
			"SKINFOLD_MEAS-mg": {
				en: "Skinfold",
				it: "Plicometria",
				es: "Plicometría",
				fr: "Plicométrie",
			},
			"BLOOD_MEAS-mg": {
				en: "Blood",
				it: "Sangue",
				es: "Sangre",
				fr: "Sang",
			},
			"TEST-mg": {
				en: "Test",
				it: "Test",
				es: "Test",
				fr: "Test",
			},
			"save-batch-measurements-result": {
				en: "Measurements saved on {0} athletes",
				it: "Misure salvate su {0} atleti",
				es: "Mediciones guardadas en {0} atletas.",
				fr: "Mesures enregistrées sur {0} athlètes.",
			},
		},
		AdvancedBiometricsView: {
			"no-user-measurements": {
				en: "No measurements for this user",
				it: "Nessuna misurazione per questo utente",
				es: "Sin medidas para este usuario",
				fr: "Aucune mesure pour cet utilisateur",
			},
			variation: {
				en: "Variation",
				it: "Variazione",
				es: "Cambio",
				fr: "Variation",
			},
			initial: {
				en: "Initial",
				it: "Iniziale",
				es: "Inicial",
				fr: "Initial",
			},
			current: {
				en: "Current",
				it: "Attuale",
				es: "En curso",
				fr: "Actuel",
			},
			"measurement-events": {
				en: "Measurement Events",
				it: "Eventi di misurazione",
				es: "Herramientas de medición",
				fr: "Événements de mesure",
			},
			UptivoYMCAStep: {
				en: "Uptivo 3M",
				it: "Uptivo 3M",
				es: "Uptivo 3M",
				fr: "Uptivo 3M",
			},
			"UptivoYMCAStep.Score-ms": {
				en: "Uptivo Fitness Test",
				it: "Fitness Test Uptivo",
				es: "Fitness Test Uptivo",
				fr: "Test de condition physique Uptivo",
			},
			"SpO2Prc-sh-ms": {
				en: "SpO₂",
				it: "SpO₂",
				es: "SpO₂",
				fr: "SpO₂",
			},
			"SpO2Prc-ms": {
				en: "SpO₂",
				it: "SpO₂",
				es: "SpO₂",
				fr: "SpO₂",
			},
			"SpO2Prc-desc": {
				en: "Oxygen Saturation",
				it: "Saturazione Ossigeno",
				es: "Saturación de oxígeno",
				fr: "Saturation d'oxygène",
			},
			"BloodPressureMin-sh-ms": {
				en: "BP Min",
				it: "PA Min",
				es: "TA Mín",
				fr: "TA Min",
			},
			"BloodPressureMin-ms": {
				en: "Blood Pressure Min",
				it: "Pressione Arteriosa Min",
				es: "Tensión Arterial Mínima",
				fr: "Tension Artérielle Min",
			},
			"BloodPressureMin-desc": {
				en: "Diastolic Blood Pressure",
				it: "Pressione Arteriosa Diastolica",
				es: "Presión Arterial Diastólica",
				fr: "Pression Artérielle Diastolique",
			},
			"BloodPressureMax-sh-ms": {
				en: "BP Max",
				it: "PA Max",
				es: "TA Máx",
				fr: "TA Max",
			},
			"BloodPressureMax-ms": {
				en: "Blood Pressure Max",
				it: "Pressione Arteriosa Massima",
				es: "Tensión Arterial Máxima",
				fr: "Tension Artérielle Max",
			},
			"BloodPressureMax-desc": {
				en: "Systolic Blood Pressure",
				it: "Pressione Arteriosa Sistolica",
				es: "Presión Arterial Sistólica",
				fr: "Pression Artérielle Systolique",
			},
			"PercentBodyWater-ms": {
				en: "BWP",
				it: "PAC",
				es: "PAC",
				fr: "PEC",
			},
			"PercentBodyWater-desc": {
				en: "Body Water Percentage",
				it: "Percentuale di Acqua Corporea",
				es: "Porcentaje de agua corporal",
				fr: "Pourcentage d'eau corporelle",
			},
			"BoneMass-sh-ms": {
				en: "BM",
				it: "MO",
				es: "MO",
				fr: "MO",
			},
			"BoneMass-ms": {
				en: "Bone Mass",
				it: "Massa Ossea",
				es: "Masa Ósea",
				fr: "Masse Osseuse",
			},
			"VisceralFatLevel-sh-ms": {
				en: "VF",
				it: "GV",
				es: "GV",
				fr: "GV",
			},
			"VisceralFatLevel-ms": {
				en: "Visceral Fat Level",
				it: "Livello di Grasso Viscerale",
				es: "Nivel de grasa visceral",
				fr: "Niveau de graisse viscérale",
			},
			"PercentBoneMass-sh-ms": {
				en: "BMP",
				it: "PMO",
				es: "PMO",
				fr: "PMO",
			},
			"PercentBoneMass-ms": {
				en: "Bone Mass Percentage",
				it: "Percentuale di Massa Ossea",
				es: "Porcentaje de masa ósea",
				fr: "Pourcentage de masse osseuse",
			},
			"ChestCirc-sh-ms": {
				en: "Chest",
				it: "Torace",
				es: "Torax",
				fr: "Thorax",
			},
			"ChestCirc-ms": {
				en: "Chest Circumference",
				it: "Circonferenza Toracica",
				es: "Circunferencia del Torax",
				fr: "Tour de Poitrine",
			},
			"WaistCirc-sh-ms": {
				en: "Waist",
				it: "Vita",
				es: "Cintura",
				fr: "Taille",
			},
			"WaistCirc-ms": {
				en: "Waist Circumference",
				it: "Circonferenza della Vita",
				es: "Circunferencia de la Cintura",
				fr: "Tour de Taille",
			},
			"HipCirc-sh-ms": {
				en: "Hip",
				it: "Anche",
				es: "Cadera",
				fr: "Hanche",
			},
			"HipCirc-ms": {
				en: "Hip Circumference",
				it: "Circonferenza all'Anca",
				es: "Circunferencia de la Cadera",
				fr: "Tour de Hanche",
			},
			"ThighCirc-sh-ms": {
				en: "Thigh",
				it: "Coscia",
				es: "Muslo",
				fr: "Cuisse",
			},
			"ThighCirc-ms": {
				en: "Thigh Circumference",
				it: "Circonferenza della Coscia",
				es: "Circunferencia del Muslo",
				fr: "Tour de Cuisse",
			},
			"ArmCirc-sh-ms": {
				en: "Arm",
				it: "Braccio",
				es: "Brazo",
				fr: "Bras",
			},
			"ArmCirc-ms": {
				en: "Arm Circumference",
				it: "Circonferenza del Braccio",
				es: "Circunferencia del Brazo",
				fr: "Circonférence du Bras",
			},
			"HeartRateAverage-sh-ms": {
				en: "Avg HR",
				it: "FC Med",
				es: "FC Med",
				fr: "FC Moy",
			},
			"HeartRateAverage-ms": {
				en: "Avegage Heart Rate",
				it: "Frequenza Cardiaca Media",
				es: "Frecuencia Cardíaca Media",
				fr: "Fréquence Cardiaque Moyenne",
			},
			"HeartRateRest-sh-ms": {
				en: "Rest HR",
				it: "FC Riposo",
				es: "FC Reposo",
				fr: "FC Repos",
			},
			"HeartRateRest-ms": {
				en: "Rest Heart Rate",
				it: "Frequenza Cardiaca a Riposo",
				es: "Frecuencia Cardíaca en Reposo",
				fr: "Fréquence Cardiaque au Repos",
			},
			"manual-measurements": {
				en: "Manual Measurements",
				it: "Misurazione manuale",
				es: "Mediciones manuales",
				fr: "Mesures manuelles",
			},
			"BloodGlucose-ms": {
				en: "Glucose",
				it: "Glucosio",
				es: "Glucosa",
				fr: "Glycémie",
			},
			"BloodGlucose.1-ms": {
				en: "Glucose 1",
				it: "Glucosio 1",
				es: "Glucosa 1",
				fr: "Glycémie 1",
			},
			"BloodGlucose.2-ms": {
				en: "Glucose 2",
				it: "Glucosio 2",
				es: "Glucosa 2",
				fr: "Glycémie 2",
			},
			"BloodGlucose.3-ms": {
				en: "Glucose 3",
				it: "Glucosio 3",
				es: "Glucosa 3",
				fr: "Glycémie 3",
			},
			"BloodGlucose.4-ms": {
				en: "Glucose 4",
				it: "Glucosio 4",
				es: "Glucosa 4",
				fr: "Glycémie 4",
			},
			"TricepsTK-ms": {
				en: "Tricep",
				it: "Tricipite",
				es: "Tríceps",
				fr: "Triceps",
			},
			"AbdomenTK-ms": {
				en: "Abdomen",
				it: "Addome",
				es: "Abdomen",
				fr: "Abdomen",
			},
			"SuprailiacTK-ms": {
				en: "Suprailiac",
				it: "Sovrailiaco",
				es: "Suprailíaco",
				fr: "Supra-iliaque",
			},
			"SubscapularTK-ms": {
				en: "Subscapular",
				it: "Sottoscapolare",
				es: "Subescapular",
				fr: "Sous-scapulaire",
			},
			"AxillaryTK-ms": {
				en: "Axillary",
				it: "Ascellare",
				es: "Axilar",
				fr: "Axillaire",
			},
			"PectoralTK-ms": {
				en: "Pectoral",
				it: "Pettorale",
				es: "Pectoral",
				fr: "Pectoral",
			},
			"ThighTK-ms": {
				en: "Thigh",
				it: "Coscia",
				es: "Muslo",
				fr: "Cuisse",
			},
			"CalfTK-ms": {
				en: "Calf",
				it: "Polpaccio",
				es: "Pantorrilla",
				fr: "Mollet",
			},
		},
		BiometricReportView: {
		},
		FitnessTestView: {
			FitnessTest: {
				en: "Fitness Test",
				it: "Fitness Test",
				es: "Fitness Test",
				fr: "Test de condition physique",
			},
			MaxHrThresholdExceeded: {
				en: "Heart Rate Exceeded 85% Of Max",
				it: "Frequenza cardiaca superiore a 85%",
				es: "La frecuencia cardíaca superó el 85% de máxima",
				fr: "La fréquence cardiaque a dépassé 85% de la valeur max.",
			},
			StoppedByUser: {
				en: "Stopped by user",
				it: "Interrotto dall'utente",
				es: "Detenido por el usuario",
				fr: "Arrêté par utilisateur",
			},
			rating: {
				en: "Rating",
				it: "Livello",
				es: "Clasificación",
				fr: "Évaluation",
			},
			score: {
				en: "Score",
				it: "Punteggio",
				es: "Puntuación",
				fr: "Score",
			},
			"Rating.excellent": {
				en: "Excellent",
				it: "Eccellente",
				es: "Excelente",
				fr: "Excellent",
			},
			"Rating.good": {
				en: "Good",
				it: "Buono",
				es: "Bien",
				fr: "Bon",
			},
			"Rating.aboveaverage": {
				en: "Above Average",
				it: "Sopra la media",
				es: "Por encima de la media",
				fr: "Supérieur à la moyenne",
			},
			"Rating.average": {
				en: "Average",
				it: "Nella media",
				es: "Promedio",
				fr: "Moyen",
			},
			"Rating.belowaverage": {
				en: "Below Average",
				it: "Sotto la media",
				es: "Por debajo de la media",
				fr: "Inférieur à la moyenne",
			},
			"Rating.poor": {
				en: "Poor",
				it: "Scarso",
				es: "Mala",
				fr: "Mauvais",
			},
			"Rating.verypoor": {
				en: "Very Poor",
				it: "Molto scarso",
				es: "Muy pobre",
				fr: "Pas bon",
			},
			results: {
				en: "Results",
				it: "Risultati",
				es: "Resultados",
				fr: "Résultats",
			},
			"heart-rates": {
				en: "Heart Rates",
				it: "Frequenze cardiache",
				es: "Frecuencia cardiaca",
				fr: "Fréquences cardiaques",
			},
			"HrPreTest-ms": {
				en: "Pre Test",
				it: "Pre test",
				es: "Prueba previa",
				fr: "Pré-test",
			},
			"HrAt1Min-ms": {
				en: "Rate At 60s",
				it: "Frequenza a 60s",
				es: "Frecuencia a 60s",
				fr: "Fréquence à 60s",
			},
			"HrAt2Min-ms": {
				en: "Rate At 120s",
				it: "Frequenza a 120s",
				es: "Frecuencia a 120s",
				fr: "Fréquence à 120s",
			},
			"HrAt3Min-ms": {
				en: "Rate At 180s",
				it: "Frequenza a 180s",
				es: "Frecuencia a 180s",
				fr: "Fréquence à 180s",
			},
			"Hr1MinPost-ms": {
				en: "Recovery HR At 60s",
				it: "Freq. cardiaca di recupero a 60s",
				es: "Recuperación de FC a 60 pulsaciones",
				fr: "Récupération FC à 60 s.",
			},
			"HrAtStop-ms": {
				en: "Rate At Stop",
				it: "Frequenza allo stop",
				es: "Frecuencia en lo stop",
				fr: "Fréquence à l'arrêt",
			},
			"EstimatedVO2Max-ms": {
				en: "Estimated VO₂ Max",
				it: "Stima VO₂ max",
				es: "VO₂ Máx. Estimado",
				fr: "VO₂ max. estimé",
			},
			TestInterruptedAtTime: {
				en: "Test Interrupted At Time",
				it: "Test interrotto al tempo",
				es: "Prueba interrumpida en el tiempo",
				fr: "Test interrompu à Heure",
			},
		},
		BodyCompositionView: {
			BodyComposition: {
				en: "Body Composition Analysis",
				it: "Analisi Composizione Corporea",
				es: "Análisis composición corporal",
				fr: "Analyse de la composition corporelle",
			},
			"TotalBodyWater-ms": {
				en: "TBW",
				it: "ACT",
				es: "ACT",
				fr: "MHT",
			},
			"TotalBodyWater-desc": {
				en: "Total Body Water",
				it: "Acqua Corporea Totale",
				es: "Agua Corporal Total",
				fr: "Masse Hydrique Totale",
			},
			"protein-ms": {
				en: "Protein",
				it: "Proteine",
				es: "Proteína",
				fr: "Protéines",
			},
			"minerals-ms": {
				en: "Minerals",
				it: "Minerali",
				es: "Minerales",
				fr: "Minéraux",
			},
			"dry-lean-mass-ms": {
				en: "Dry Lean Mass",
				it: "Massa Muscolare Magra",
				es: "Masa Muscular Magra",
				fr: "Masse Corporelle Maigre",
			},
			"BodyFatMass-sh-ms": {
				en: "BFM",
				it: "MGC",
				es: "MGC",
				fr: "MCG",
			},
			"BodyFatMass-ms": {
				en: "Body Fat Mass",
				it: "Massa Grassa Corporea",
				es: "Masa de Grasa Corporal",
				fr: "Masse Corporelle Grasse",
			},
			"muscle-fat-analysis": {
				en: "Muscle-Fat Analysis",
				it: "Analisi Muscolo-Grasso",
				es: "Análisis de Grasa Muscular",
				fr: "Analyse Muscle-Graisse",
			},
			"SkeletalMuscleMass-ms": {
				en: "SMM",
				it: "MMS",
				es: "MME",
				fr: "MMS",
			},
			"SkeletalMuscleMass-desc": {
				en: "Skeletal Muscle Mass",
				it: "Massa del Muscolo Scheletrico",
				es: "Masa músculo-esquelética",
				fr: "Masse musculaire squelettique",
			},
			"obesity-analysis": {
				en: "Obesity Analysis",
				it: "Analisi dell'Obesità",
				es: "Análisis de Obesidad",
				fr: "Analyse d'obésité",
			},
			"BodyMassIndex-ms": {
				en: "BMI",
				it: "BMI",
				es: "IMC",
				fr: "IMC",
			},
			"BodyMassIndex-desc": {
				en: "Body Mass Index",
				it: "Indice di Massa Corporea",
				es: "Índice de masa corporal",
				fr: "Indice de masse corporelle",
			},
			"IntracellularWater-ms": {
				en: "ICW",
				it: "AIC",
				es: "AIC",
				fr: "EIC",
			},
			"IntracellularWater-desc": {
				en: "Intracellular Water",
				it: "Acqua intracellulare",
				es: "Agua intracelular",
				fr: "Eau intracellulaire",
			},
			"ExtracellularWater-ms": {
				en: "ECW",
				it: "AEC",
				es: "AEC",
				fr: "EEC",
			},
			"ExtracellularWater-desc": {
				en: "Extracellular Water",
				it: "Acqua Extra-Cellulare",
				es: "Agua Extra-Celular",
				fr: "Eau Extra-Cellulaire",
			},
			"BoneMineralContent-ms": {
				en: "Bone Mineral Content",
				it: "Contenuto Minerale Osseo",
				es: "Contenido mineral óseo",
				fr: "Contenu minéral osseux",
			},
			"BodyCellMass-ms": {
				en: "Body Cell Mass",
				it: "Massa cellulare",
				es: "Masa celular",
				fr: "Masse cellulaire",
			},
			"LeftArm-ms": {
				en: "Left Arm",
				it: "Braccio sinistro",
				es: "Brazo izquierdo",
				fr: "Bras gauche",
			},
			"RightArm-ms": {
				en: "Right Arm",
				it: "Braccio destro",
				es: "Brazo derecho",
				fr: "Bras droit",
			},
			"Trunk-ms": {
				en: "Trunk",
				it: "Tronco",
				es: "Tronco",
				fr: "Tronc",
			},
			"LeftLeg-ms": {
				en: "Left Leg",
				it: "Gamba sinistra",
				es: "Pierna izquierda",
				fr: "Jambe gauche",
			},
			"RightLeg-ms": {
				en: "Right Leg",
				it: "Gamba destra",
				es: "Pierna derecha",
				fr: "Jambe droite",
			},
			"CircNeck-sh-ms": {
				en: "Neck Circ.",
				it: "Circ. collo",
				es: "Circ. cuello",
				fr: "Circ. cou",
			},
			"CircLeftArm-sh-ms": {
				en: "Left Arm Circ.",
				it: "Circ. braccio sinistro",
				es: "Circ. brazo izquierdo",
				fr: "Circ. bras gauche",
			},
			"MuscleCircLeftArm-sh-ms": {
				en: "Left Arm Muscle Circ.",
				it: "Circ. muscolare braccio sx",
				es: "Circ. muscular brazo izquierdo",
				fr: "Circ. musculaire bras gauche",
			},
			"CircRightArm-sh-ms": {
				en: "Right Arm Circ.",
				it: "Circ. braccio destro",
				es: "Circ. brazo derecho",
				fr: "Circ. bras droit",
			},
			"CircChest-sh-ms": {
				en: "Chest Circ.",
				it: "Circ. torace",
				es: "Circ. torax",
				fr: "Circ. poitrine",
			},
			"CircAbdomen-sh-ms": {
				en: "Abdomen Circ.",
				it: "Circ. addome",
				es: "Circ. abdomen",
				fr: "Circ. abdomen",
			},
			"CircHip-sh-ms": {
				en: "Hips Circ.",
				it: "Circ. fianchi",
				es: "Circ. caderas",
				fr: "Circ. hanches",
			},
			"CircLeftThigh-sh-ms": {
				en: "Left Thigh Circ.",
				it: "Circ. coscia sinistra",
				es: "Circ. muslo izquierdo",
				fr: "Circ. cuisse gauche",
			},
			"CircRightThigh-sh-ms": {
				en: "Right Thigh Circ.",
				it: "Circ. coscia destra",
				es: "Circ. muslo derecho",
				fr: "Circ. cuisse droit",
			},
			"PercentBodyFat-ms": {
				en: "BFP",
				it: "PGC",
				es: "PGC",
				fr: "IMG",
			},
			"PercentBodyFat-desc": {
				en: "Body Fat Percentage",
				it: "Percentuale di Grasso Corporeo",
				es: "Porcentaje de Grasa Corporal",
				fr: "Indice de masse grasse",
			},
			"segmental-lean-analysis": {
				en: "Segmental Lean Analysis",
				it: "Analisi Massa Magra Segmentale",
				es: "Análisis de masa magra",
				fr: "Analyse segmentaire masse maigre",
			},
			"segmental-fat-analysis": {
				en: "Segmental Fat Analysis",
				it: "Analisi Massa Grassa Segmentale",
				es: "Análisis de Grasa Segmental",
				fr: "Analyse segmentaire masse grasse",
			},
			"ecw-analysis": {
				en: "Extracellular Water Analysis",
				it: "Analisi Acqua Extracellulare",
				es: "Análisis de agua extracelular",
				fr: "Analyse de l'eau extracellulaire",
			},
			"inbody-score": {
				en: "InBody Score",
				it: "Punteggio InBody",
				es: "Puntuación de InBody",
				fr: "Score InBody",
			},
			score: {
				en: "Score",
				it: "Punteggio",
				es: "Puntuación",
				fr: "Score",
			},
			"weight-control-ms": {
				en: "Weight Contol",
				it: "Controllo del Peso",
				es: "Control de peso",
				fr: "Contrôle du poids",
			},
			"target-weight-ms": {
				en: "Target Weight",
				it: "Peso Target",
				es: "Peso buscado",
				fr: "Poids cible",
			},
			"fat-control-ms": {
				en: "Fat Control",
				it: "Controllo del Grasso",
				es: "Control de grasa",
				fr: "Contrôle de la masse grasse",
			},
			"muscle-control-ms": {
				en: "Muscle Control",
				it: "Controllo del Muscolo",
				es: "Control muscular",
				fr: "Contrôle de la masse musculaire",
			},
			"bf-lb-mass-control": {
				en: "Body Fat-Lean Body Mass Control",
				it: "Controllo Massa Grassa-Magra",
				es: "Control de masa corporal",
				fr: "Contrôle masse grasse/masse corporelle maigre",
			},
			"waist-hip-ratio": {
				en: "Waist-Hip Ratio",
				it: "Rapporto Cintura-Fianchi",
				es: "Relación cintura/cadera",
				fr: "Rapport Taille-Hanches",
			},
			"visceral-fat-level": {
				en: "Visceral Fat Level",
				it: "Livello di Grasso Viscerale",
				es: "Nivel de grasa visceral",
				fr: "Niveau de graisse viscérale",
			},
			"research-parameters": {
				en: "Research Parameters",
				it: "Parametri di Ricerca",
				es: "Parámetros de investigación",
				fr: "Paramètres de recherche",
			},
			"BasalMetabolicRate-ms": {
				en: "Basal Metabolic Rate",
				it: "Tasso Metabolico Basale",
				es: "Tasa metabólica basal",
				fr: "Métabolisme basal",
			},
			"BasalMetabolicRate-sh-ms": {
				en: "BMR",
				it: "BMR",
				es: "BMR",
				fr: "BMR",
			},
			"obesity-degree": {
				en: "Obesity Degree",
				it: "Grado di Obesità",
				es: "Grado de obesidad",
				fr: "Degré d'obésité",
			},
			"FatFreeMass-sh-ms": {
				en: "LeanM",
				it: "MMM",
				es: "MMM",
				fr: "MMM",
			},
			"FatFreeMass-ms": {
				en: "Lean Mass",
				it: "Massa Magra",
				es: "Masa Magra",
				fr: "Masse Maigre",
			},
			"body-measurements": {
				en: "Body Measurements",
				it: "Misure corporee",
				es: "Medidas del cuerpo",
				fr: "Mesures du corps",
			},
			"body-water-composition": {
				en: "Body Water Composition",
				it: "Composizione acqua corporea",
				es: "Composición de agua corporal",
				fr: "Composition de l'eau du corps",
			},
			"segmental-water-analysis": {
				en: "Segmental Water Analysis",
				it: "Analisi acqua segmentale",
				es: "Análisis de agua segmental",
				fr: "Analyse de l'eau segmentaire",
			},
			"visceral-fat-area": {
				en: "Visceral Fat Area",
				it: "Area grasso viscerale",
				es: "Área de grasa visceral",
				fr: "Zone de graisse viscérale",
			},
			"tbw-ffm": {
				en: "TBW/FFM",
				it: "ACT/MMC",
				es: "ACT/MMC",
				fr: "MHT/MMC",
			},
			FatFreeMassIndex: {
				en: "Fat Free Mass Index",
				it: "Indice Massa Magra Alipidica",
				es: "Índice de masa magro",
				fr: "Indice de masse maigre",
			},
			FatMassIndex: {
				en: "Fat Mass Index",
				it: "Indice Massa Grassa",
				es: "Índice de masa grasa",
				fr: "Indice de masse grasse",
			},
			"ECWTBWRatio-sh-ms": {
				en: "ECW/TBW",
				it: "AEC/ACT",
				es: "AEC/ACT",
				fr: "EEC/MHT",
			},
			"ECWTBWRatio-ms": {
				en: "ECW/TBW Ratio",
				it: "Rapporto AEC/ACT",
				es: "Proporción AEC/ACT",
				fr: "Rapport EEC/MHT",
			},
			"ECWTBWRatio-desc": {
				en: "Extra-Cellular Water / Total Body Water Ratio",
				it: "Rapporto Acqua Extra-Cellulare / Acqua Corporea Totale",
				es: "Proporción Agua Extra-Celular / Agua Corporal Total",
				fr: "Rapport Eau Extra-Cellulaire / Masse Hydrique Totale",
			},
			"segmental-ecwtbw-analysis": {
				en: "Segmental ECW/TBW Ratio Analysis",
				it: "Analisi rapporto AEC/ACT segmentale",
				es: "Análisis de la proporción AEC/ACT segmentaria",
				fr: "Analyse du rapport EEC/MHT segmentaire",
			},
			"phase-angles": {
				en: "Phase Angles",
				it: "Angoli di fase",
				es: "Ángulos de fase",
				fr: "Angles de phase",
			},
			under: {
				en: "Under",
				it: "Sotto",
				es: "Por debajo",
				fr: "Inférieur",
			},
			normal: {
				en: "Normal",
				it: "Normale",
				es: "Normal",
				fr: "Normal",
			},
			over: {
				en: "Over",
				it: "Sopra",
				es: "Por encima",
				fr: "Supérieur",
			},
			high: {
				en: "High",
				it: "Alto",
				es: "Alto",
				fr: "Élevé",
			},
			"very-high": {
				en: "Very High",
				it: "Molto Alto",
				es: "Muy alto",
				fr: "Très élevé",
			},
		},
		Menu: {
			"user-profile": {
				en: "User Profile",
				it: "Profilo Utente",
				es: "Perfil de usuario",
				fr: "Profil utilisateur",
			},
			"my-journal": {
				en: "My Journal",
				it: "Il Mio Diario",
				es: "Mi Seguimiento",
				fr: "Mon journal",
			},
			summary: {
				en: "Summary",
				it: "Riepilogo",
				es: "Resumen",
				fr: "Résumé",
			},
			"club-profile": {
				en: "Club Profile",
				it: "Profilo Club",
				es: "Perfil del club",
				fr: "Profil du club",
			},
		},
		ClubSlideShowsView: {
			slideshow: {
				en: "Slideshows",
				it: "Slideshow",
				es: "Slideshow",
				fr: "Slideshow",
			},
			"random-order": {
				en: "Random Order",
				it: "Ordine casuale",
				es: "Orden aleatorio",
				fr: "Ordre aléatoire",
			},
			"slideshow-text": {
				en: "Display a slideshow on your Uptivo monitors during quiet hours. You can use the default Uptivo slideshow, or upload one or more images to your liking (Fullscreen 1920x1005, Half screen 960x1005).",
				it: "Scegli cosa visualizzare sui monitor Uptivo quando non ci sono allenamenti in corso. Puoi mostrare lo slideshow Uptivo (selezione predefinita) o caricare una o più immagini a tua scelta (Fullscreen 1920x1005, Half screen 960x1005).",
				es: "Muestre una presentación de diapositivas en sus monitores Uptivo durante horas tranquilas. Puede usar la presentación de diapositivas Uptivo predeterminada o cargar una o más imágenes a su gusto (Fullscreen 1920x1005, Half screen 960x1005).",
				fr: "Affichez un diaporama sur vos moniteurs Uptivo pendant les heures calmes. Vous pouvez utiliser le diaporama Uptivo par défaut ou télécharger une ou plusieurs images à votre convenance (Fullscreen 1920x1005, Half screen 960x1005).",
			},
		},
		ClubLicensesWarningView: {
			"warning-upper": {
				en: "WARNING!",
				it: "ATTENZIONE!",
				es: "¡ADVERTENCIA!",
				fr: "ATTENTION!",
			},
			"club-no-license": {
				en: "The Uptivo Cloud license for {0} does not exist.",
				it: "{0} non ha una licenza Uptivo Cloud.",
				es: "{0} no tiene una licencia Uptivo Cloud.",
				fr: "{0} n'a pas de licence Uptivo Cloud.",
			},
			"club-license-expired": {
				en: "The Uptivo Cloud license for {0} has expired on {1}.",
				it: "La licenza Uptivo Cloud di {0} è scaduta il {1}.",
				es: "La licencia Uptivo Cloud de {0} expiró el {1}.",
				fr: "La licence Uptivo Cloud de {0} a expiré le {1}.",
			},
			"club-license-expiring": {
				en: "The Uptivo Cloud license for {0} will expire on {1}. The system will automatically deactivate upon expiration.",
				it: "La licenza Uptivo Cloud di {0} scadrà il {1}. Il sistema verrà automaticamente disattivato alla scadenza.",
				es: "La licencia Uptivo Cloud de {0} expira el {1}. El sistema se desactivará automáticamente al expirar.",
				fr: "La licence Uptivo Cloud de {0} expire le {1}. Le système se désactivera automatiquement à l'expiration.",
			},
			"please-contact": {
				en: 'Please contact <a href="mailto:sales@uptivo.fit">sales@uptivo.fit</a> for more information.',
				it: 'Contatta <a href="mailto:sales@uptivo.fit">sales@uptivo.fit</a> per maggiori informazioni.',
				es: 'Póngase en contacto con <a href="mailto:sales@uptivo.fit">sales@uptivo.fit</a> para más información.',
				fr: 'Contactez <a href="mailto:sales@uptivo.fit">sales@uptivo.fit</a> pour plus d\'informations.',
			},
		},
		TimersView: {
			timer: {
				en: "Timer",
				it: "Timer",
				es: "Temporizador",
				fr: "Chrono",
			},
			"timer-name": {
				en: "Timer Name",
				it: "Nome Timer",
				es: "Nombre del temporizador",
				fr: "Nom de chrono",
			},
			"circuit-timers": {
				en: "Circuit Timers",
				it: "Timer Circuiti",
				es: "Temporizadores de Circuito",
				fr: "Chronos de Circuit",
			},
			"create-timer": {
				en: "Create Timer",
				it: "Crea Timer",
				es: "Crear temporizador",
				fr: "Créer un chrono",
			},
			"edit-timer": {
				en: "Edit Timer",
				it: "Modifica Timer",
				es: "Editar temporizador",
				fr: "Modifier un chrono",
			},
			warmup: {
				en: "Warm-up",
				it: "Preparazione",
				es: "Calentamiento",
				fr: "Échauffement",
			},
			exercises: {
				en: "Exercises",
				it: "Esercizi",
				es: "Ejercicios",
				fr: "Exercices",
			},
			rest: {
				en: "Rest",
				it: "Pausa",
				es: "Descanso",
				fr: "Repos",
			},
			"reps-range": {
				en: "Reps Range",
				it: "Intervallo Ripetizioni",
				es: "Rango de repeticiones",
				fr: "Plage de répétitions",
			},
			laps: {
				en: "Rounds",
				it: "Circuiti",
				es: "Rondas",
				fr: "Manches",
			},
			cooldown: {
				en: "Cool Down",
				it: "Pausa Circuiti",
				es: "Descanso Ronda",
				fr: "Retour au calme",
			},
			"duration-format": {
				en: "Enter a duration value in format mm:ss (ex: 01:30)",
				it: "Inserisci una durata nel formato mm:ss (es: 01:30)",
				es: "Inserte un valor de duración en formato mm:ss (ej. 01:30)",
				fr: "Saisir une valeur de durée au format mm:ss (ex: 01:30)",
			},
		},
		ContextSelectorView: {
			"selected-club": {
				en: "Selected Club",
				it: "Club Selezionato",
				es: "Club Seleccionado",
				fr: "Club Sélectionné",
			},
		},
		ClubSensorsView: {
			"fitness-sensors": {
				en: "Fitness Sensors",
				it: "Sensori Fitness",
				es: "Sensores Fitness",
				fr: "Capteurs Fitness",
			},
			"add-fitness-sensor": {
				en: "Add Fitness Sensor",
				it: "Aggiungi Sensore Fitness",
				es: "Agregar Sensor De Fitness",
				fr: "Ajouter Un Capteur De Fitness",
			},
			"add-uptivo-tracking-sensors": {
				en: "Add Uptivo Tracking Sensors",
				it: "Aggiungi Uptivo Tracking Sensor",
				es: "Agregar Uptivo Tracking Sensors",
				fr: "Ajouter Uptivo Tracking Sensors",
			},
			"other-devices": {
				en: "Other Devices",
				it: "Altri Dispositivi",
				es: "Otros dispositivos",
				fr: "Autres appareils",
			},
			"uptivo-boxing-trackers": {
				en: "Uptivo Boxing Trackers",
				it: "Uptivo Boxing Trackers",
				es: "Uptivo Boxing Trackers",
				fr: "Uptivo Boxing Trackers",
			},
			"device-exists": {
				en: "A device with the same Id {0} already exists in the club!",
				it: "Un dispositivo con lo stesso ID {0} esiste già nel club!",
				es: "¡Ya existe un dispositivo con el mismo ID {0} en el club!",
				fr: "Un appareil avec le même identifiant {0} existe déjà dans le club!",
			},
			bike: {
				en: "Bike",
				it: "Bike",
				es: "Bici",
				fr: "Vélo",
			},
		},
		IntensityFlowsView: {
			"duration-error": {
				en: "Duration must be at least 15 seconds.",
				it: "La durata deve essere di almeno 15 secondi.",
				es: "La duración debe ser de al menos 15 segundos.",
				fr: "La durée doit être d'au moins 15 secondes.",
			},
			segments: {
				en: "Segments",
				it: "Segmenti",
				es: "Segmentos",
				fr: "Segments",
			},
			"begin-error": {
				en: "Begin values must generate a duration of at least 15 seconds.",
				it: "I valori di inizio devono generare una durata di almeno 15 secondi.",
				es: "Los valores iniciales deben generar una duración de al menos 15 segundos.",
				fr: "Les valeurs de départ doivent générer une durée d'au moins 15 secondes.",
			},
			"start-time": {
				en: "Begin",
				it: "Inizio",
				es: "Inicio",
				fr: "Départ",
			},
			"intensity-flows": {
				en: "Intensity Flows",
				it: "Intensity Flow",
				es: "Intensity Flow",
				fr: "Intensity Flow",
			},
			flow: {
				en: "Flow",
				it: "Flow",
				es: "Flow",
				fr: "Flow",
			},
			"edit-intensity-flow": {
				en: "Edit Intensity Flow",
				it: "Modifica Intensity Flow",
				es: "Editar Intensity Flow",
				fr: "Modifier Intensity Flow",
			},
			"create-intensity-flow": {
				en: "Create Intensity Flow",
				it: "Crea nuovo Intensity Flow",
				es: "Crear un nuevo Intensity Flow",
				fr: "Créer un nouvel Intensity Flow",
			},
			"avg-intensity": {
				en: "Avg Intensity",
				it: "Intensità Med",
				es: "Intensidad promedio",
				fr: "Intensité moy.",
			},
			intensity: {
				en: "% Intensity",
				it: "% Intensità",
				es: "% Intensidad",
				fr: "% Intensité",
			},
			"total-duration": {
				en: "Total duration",
				it: "Durata totale",
				es: "Duración total",
				fr: "Durée totale",
			},
			"use-cadence": {
				en: "Use Cadence",
				it: "Usa Cadenza",
				es: "Usar Cadencia",
				fr: "Utiliser Cadence",
			},
			rpm: {
				en: "RPM",
				it: "RPM",
				es: "RPM",
				fr: "RPM",
			},
			no: {
				en: "No",
				it: "No",
				es: "No",
				fr: "Non",
			},
		},
		ClubProfileView: {
			"max-weekly-bookings": {
				en: "Max Weekly Bookings",
				it: "Prenotazioni Massime Settimanali",
				es: "Reservas Máximas Semanales",
				fr: "Réservations Hebdomadaires Max",
			},
			"max-monthly-bookings": {
				en: "Max Monthly Bookings",
				it: "Prenotazioni Massime Mensili",
				es: "Reservas Máximas Mensuales",
				fr: "Réservations Mensuelles Max",
			},
			"booking-limits": {
				en: "Limits (without subscriptions)",
				it: "Limiti (in assenza abbonamenti)",
				es: "Límites (sin suscripciones)",
				fr: "Limites (sans abonnements)",
			},
			bookings: {
				en: "Bookings",
				it: "Prenotazioni",
				es: "Reservas",
				fr: "Réservations",
			},
			"athlete-age-period": {
				en: 'Display "new user" dots for 3 periods of',
				it: 'Mostra pallini "nuovo utente" per 3 periodi di',
				es: 'Mostrar puntos de "nuevo usuario" durante 3 períodos de',
				fr: 'Afficher les points "nouvel utilisateur" pendant 3 périodes de',
			},
			"welcome-users-after": {
				en: "Welcome users who return after",
				it: "Dà il benvenuto a utente che torna dopo",
				es: "Bienvenido a un usuario que vuelve después de",
				fr: "Bienvenue à un utilisateur qui revient après",
			},
			"remind-users-use-uptivo": {
				en: "Remind users to use Uptivo after",
				it: "Ricorda all'utente di usare Uptivo dopo",
				es: "Recuérdale al usuario que utilice Uptivo después de",
				fr: "Rappelez à l'utilisateur d'utiliser Uptivo après",
			},
			"first-training-welcome": {
				en: "First Training Email",
				it: "Email al primo allenamento",
				es: "Correo electrónico en el primer entrenamiento",
				fr: "E-mail au premier entraînement",
			},
			"x-weeks": {
				en: "{0} weeks",
				it: "{0} settimane",
				es: "{0} semanas",
				fr: "{0} semaines",
			},
			"club-information": {
				en: "Club Profile",
				it: "Profilo Del Club",
				es: "Perfil Del Club",
				fr: "Profil Du Club",
			},
			tags: {
				en: "Groups",
				it: "Gruppi",
				es: "Grupos",
				fr: "Groupes",
			},
			"default-booking-settings": {
				en: "Default Booking Settings",
				it: "Impostazioni Prenotazione Predefinite",
				es: "Configuración De Reserva Predeterminada",
				fr: "Paramètres De Réservation Par Défaut",
			},
			"club-name": {
				en: "Club Name",
				it: "Nome Club",
				es: "Nombre del club",
				fr: "Nom du club",
			},
			"club-exists": {
				en: "Club '{0}' already exists!",
				it: "Il club con nome '{0}' esiste già!",
				es: "¡Club &#39;{0}&#39; ya existe!",
				fr: "Le club '{0}' existe déjà!",
			},
			"delete-club": {
				en: "Delete Club",
				it: "Elimina Club",
				es: "Eliminar club",
				fr: "Supprimer le club",
			},
			address: {
				en: "Address",
				it: "Indirizzo",
				es: "Dirección",
				fr: "Adresse",
			},
			website: {
				en: "Web Site",
				it: "Sito Web",
				es: "Web del sitio",
				fr: "Site web",
			},
			"club-policy": {
				en: "Club Policy",
				it: "Club Policy",
				es: "Club Policy",
				fr: "Club Policy",
			},
			"club-profile": {
				en: "Club Profile",
				it: "Profilo Club",
				es: "Perfil del club",
				fr: "Profil du club",
			},
			"add-club": {
				en: "Add Club",
				it: "Aggiungi Club",
				es: "Agregar Club",
				fr: "Ajouter un club",
			},
			"uptivo-bar-preview": {
				en: "Preview of Uptivo Bridge",
				it: "Anteprima di Uptivo Bridge",
				es: "Vista previa de Uptivo Bridge",
				fr: "Aperçu de Uptivo Bridge",
			},
			"enable-user-rankings": {
				en: "Enable the Users Rankings",
				it: "Abilita le classifiche degli utenti",
				es: "Activar las clasificaciones de los usuarios",
				fr: "Activer le classement des utilisateurs",
			},
			"enable-trainer-rankings": {
				en: "Enable The Trainers Rankings",
				it: "Abilita Le Classifiche Dei Trainer",
				es: "Activar Las Clasificaciones De Los Entrenadores",
				fr: "Activer Le Classement Des Entraîneurs",
			},
			"enable-online-payments": {
				en: "Enable Online Payments",
				it: "Abilita Pagamenti Online",
				es: "Activar Pagos en Línea",
				fr: "Activer les Paiements Online",
			},
			"enable-uptivo-store": {
				en: "Enable Uptivo Store",
				it: "Abilita Uptivo Store",
				es: "Activar Uptivo Store",
				fr: "Activer la Boutique Uptivo",
			},
			"online-payments": {
				en: "Online Payments",
				it: "Pagamenti Online",
				es: "Pagos en Línea",
				fr: "Paiements Online",
			},
			state: {
				en: "State",
				it: "Stato",
				es: "Condición",
				fr: "Condition",
			},
			"not-configured": {
				en: "Not Configured",
				it: "Non configurato",
				es: "No configurado",
				fr: "Pas configuré",
			},
			"payment-services": {
				en: "Payment Services",
				it: "Servizi Di Pagamento",
				es: "Servicios de pago",
				fr: "Services de paiement",
			},
			Onboarding: {
				en: "Configuration not completed",
				it: "Configurazione non completata",
				es: "Configuración no completada",
				fr: "Configuration non terminée",
			},
			Inactive: {
				en: "Inactive",
				it: "Non attivo",
				es: "Inactivo",
				fr: "Inactif",
			},
			Active: {
				en: "Active",
				it: "Attivo",
				es: "Activo",
				fr: "Actif",
			},
			MissingData: {
				en: "Missing data",
				it: "Dati mancanti",
				es: "Datos perdidos",
				fr: "Données manquantes",
			},
			configure: {
				en: "Configure",
				it: "Configura",
				es: "Configurar",
				fr: "Configurer",
			},
			open: {
				en: "Open",
				it: "Apri",
				es: "Abre",
				fr: "Ouvert",
			},
			"currency-required": {
				en: "Currency is required",
				it: "È richiesta la valuta",
				es: "Se requiere moneda",
				fr: "La devise est requise",
			},
			"payment-account-succesfully-removed": {
				en: "Payment account successfully removed",
				it: "Account di pagamento rimosso con successo",
				es: "Cuenta de pago eliminada con éxito",
				fr: "Compte de paiement supprimé avec succès",
			},
			"stripe-description": {
				en: "Payments from your customers will be credited to your Stripe account. STRIPE fees per transaction:",
				it: "I pagamenti dei tuoi clienti verranno accreditati sul tuo account Stripe. Commissioni STRIPE per transazione:",
				es: "Los pagos de sus clientes se acreditarán en su cuenta de Stripe. Tarifas de STRIPE por transacción:",
				fr: "Les paiements de vos clients seront crédités sur votre compte Stripe. Frais STRIPE par transaction:",
			},
			"paypal-description": {
				en: "Payments from your customers will be credited to your PayPal account. PAYPAL fees per transaction:",
				it: "I pagamenti dei tuoi clienti verranno accreditati sul tuo account PayPal. Commissioni PAYPAL per transazione:",
				es: "Los pagos de sus clientes se acreditarán en su cuenta de PayPal. Tarifas de PAYPAL por transacción:",
				fr: "Les paiements de vos clients seront crédités sur votre compte PayPal. Frais PAYPAL par transaction:",
			},
			"uptivo-commission": {
				en: "Uptivo fees per transaction: 1% for each transaction.",
				it: "Commissioni Uptivo per transazione: 1% per ogni transazione.",
				es: "Tarifas de Uptivo por transacción: 1% por cada transacción.",
				fr: "Frais d'Uptivo par transaction: 1% pour chaque transaction.",
			},
			"paypal-confirm-email": {
				en: "Attention: Please confirm your email address on <a href='https://www.paypal.com/businessprofile/settings'>https://www.paypal.com/businessprofile/settings</a> in order to receive payments! You currently cannot receive payments.",
				it: "Attenzione: conferma il tuo indirizzo email su <a href='https://www.paypal.com/businessprofile/settings'>https://www.paypal.com/businessprofile/settings</a> per ricevere i pagamenti! Al momento non puoi ricevere pagamenti.",
				es: "Atención: ¡Confirme su dirección de correo electrónico en <a href='https://www.paypal.com/businessprofile/settings'>https://www.paypal.com/businessprofile/settings</a> para recibir pagos! Actualmente no puede recibir pagos.",
				fr: "Attention: Veuillez confirmer votre adresse e-mail sur <a href='https://www.paypal.com/businessprofile/settings'>https://www.paypal.com/businessprofile/settings</a> afin de recevoir les paiements! Vous ne pouvez actuellement pas recevoir de paiements.",
			},
			"paypal-no-payments": {
				en: "Attention: You currently cannot receive payments due to restriction on your PayPal account. Please reach out to PayPal Customer Support or connect to <a href='https://www.paypal.com'>https://www.paypal.com</a> for more information.",
				it: "Attenzione: al momento non puoi ricevere pagamenti a causa di restrizioni sul tuo conto PayPal. Contatta l'Assistenza clienti PayPal o connettiti a <a href='https://www.paypal.com'>https://www.paypal.com</a> per ulteriori informazioni.",
				es: "Atención: actualmente no puede recibir pagos debido a la restricción en su cuenta de PayPal. Comuníquese con Atención al cliente de PayPal o conéctese a <a href='https://www.paypal.com'>https://www.paypal.com</a> para obtener más información.",
				fr: "Attention : Vous ne pouvez actuellement pas recevoir de paiements en raison d'une restriction sur votre compte PayPal. Veuillez contacter le service clientèle de PayPal ou vous connecter à <a href='https://www.paypal.com'>https://www.paypal.com</a> pour plus d'informations.",
			},
			"stripe-no-payments": {
				en: "Attention: You currently cannot receive payments due to restriction on your Stripe account. Please reach out to Stripe Customer Support or connect to <a href='https://stripe.com/'>https://stripe.com/</a> for more information.",
				it: "Attenzione: al momento non puoi ricevere pagamenti a causa di restrizioni sul tuo conto Stripe. Contatta l'Assistenza clienti Stripe o connettiti a <a href='https://stripe.com/'>https://stripe.com/</a> per ulteriori informazioni.",
				es: "Atención: actualmente no puede recibir pagos debido a la restricción en su cuenta de Stripe. Comuníquese con Atención al cliente de Stripe o conéctese a <a href='https://stripe.com/'>https://stripe.com/</a> para obtener más información.",
				fr: "Attention : Vous ne pouvez actuellement pas recevoir de paiements en raison d'une restriction sur votre compte Stripe. Veuillez contacter le service clientèle de Stripe ou vous connecter à <a href='https://stripe.com/'>https://stripe.com/</a> pour plus d'informations.",
			},
			"club-code": {
				en: "Club Code",
				it: "Codice Club",
				es: "Código de Club",
				fr: "Code du Club",
			},
			"club-code-text": {
				en: "Invite your friends to purchase Uptivo with your Club Code to extend your Uptivo Cloud subscription for free.",
				it: "Invita i tuoi amici ad acquistare Uptivo con il tuo Codice Club per estendere gratuitamente il tuo abbonamento Uptivo Cloud.",
				es: "Invita a tus amigos a comprar Uptivo con tu Código de Club para extender tu suscripción a Uptivo Cloud gratis.",
				fr: "Invitez vos amis à acheter Uptivo avec votre code club pour prolonger votre abonnement Uptivo Cloud gratuitement.",
			},
			"discount-code": {
				en: "Discount Code",
				it: "Codice Sconto",
				es: "Código de Descuento",
				fr: "Code de Réduction",
			},
			"discount-code-text": {
				en: "Communicate to your members the discount code for the Uptivo store, so that they can have access to discounts and offers reserved for your Club (<a target='_blank' href='https://store.uptivo.fit/pages/club-sale-conditions'>General conditions of Sale</a>).",
				it: "Comunica ai tuoi membri il codice sconto per lo store Uptivo, in modo che possano aver accesso a sconti e offerte riservate al tuo Club (<a target='_blank' href='https://store.uptivo.fit/it/pages/club-sale-conditions'>Condizioni Generali di Vendita</a>).",
				es: "Comunica a tus socios el código de descuento del store Uptivo, para que tengan acceso a descuentos y ofertas reservadas para tu Club (<a target='_blank' href='https://store.uptivo.fit/es/pages/club-sale-conditions'>Condiciones Generales de Venta</a>).",
				fr: "Communiquez à vos membres le code de réduction de la boutique Uptivo, afin qu'ils puissent avoir accès aux réductions et offres réservées à votre Club (<a target='_blank' href='https://store.uptivo.fit/fr/pages/club-sale-conditions'>Conditions Générales de Vente</a>).",
			},
			licenses: {
				en: "Licenses",
				it: "Licenze",
				es: "Licencias",
				fr: "Licences",
			},
			"show-hide-all": {
				en: "Show/Hide All",
				it: "Mostra/Nascondi Tutto",
				es: "Mostrar/Ocultar todo",
				fr: "Afficher/Masquer tout",
			},
			"lic-no-valid": {
				en: "No valid licenses!",
				it: "Non ci sono licenze valide!",
				es: "¡Sin licencias válidas!",
				fr: "Aucune licence valide!",
			},
			"DurationExtension-LM": {
				en: "{0} used your Club code to become an Uptivo customer. You have been rewarded with {1} days of free cloud!",
				it: "{0} ha usato il tuo codice club per il suo primo acquisto Uptivo. Hai ottenuto {1} giorni di cloud gratuito!",
				es: "{0} ha usado tu código club para su primera compra de la solución Uptivo. ¡Te regalamos {1} días gratuitos de nube!",
				fr: "{0} a utilisé votre code club pour acheter Uptivo pour la première fois. Nous vous avons récompensé avec {1} jours de cloud gratuits!",
			},
			redeem: {
				en: "Redeem",
				it: "Attiva",
				es: "Redimir",
				fr: "Racheter",
			},
			options: {
				en: "Options",
				it: "Opzioni",
				es: "Opciones",
				fr: "Options",
			},
			"cannot-suspend-an-inactive-subscription": {
				en: "Can't suspend an inactive subscription",
				it: "Impossibile sospendere un abbonamento inattivo",
				es: "No se puede suspender una suscripción inactiva",
				fr: "Impossible de suspendre un abonnement inactif",
			},
			"subscription-succesfully-edited": {
				en: "Subscription changed successfully",
				it: "Abbonamento modificato con successo",
				es: "Suscripción cambiada con éxito",
				fr: "Abonnement modifié avec succès",
			},
			"add-new-tag": {
				en: "Add New Group",
				it: "Aggiungi Nuovo Gruppo",
				es: "Agregar Nuevo Grupo",
				fr: "Ajouter Nouveau Groupe",
			},
			"tag-name": {
				en: "Group Name",
				it: "Nome Gruppo",
				es: "Nombre De Grupo",
				fr: "Nom de la Groupe",
			},
			"edit-tag": {
				en: "Edit Group",
				it: "Modifica Gruppo",
				es: "Editar Grupo",
				fr: "Modifier Groupe",
			},
			tag: {
				en: "Group",
				it: "Gruppo",
				es: "Grupo",
				fr: "Groupe",
			},
		},
		ClubLicensesView: {
			"club-code": {
				en: "Club Code",
				it: "Codice Club",
				es: "Código de Club",
				fr: "Code du Club",
			},
			"club-code-text": {
				en: "Invite your friends to purchase Uptivo with your Club Code to extend your Uptivo Cloud subscription for free.",
				it: "Invita i tuoi amici ad acquistare Uptivo con il tuo Codice Club per estendere gratuitamente il tuo abbonamento Uptivo Cloud.",
				es: "Invita a tus amigos a comprar Uptivo con tu Código de Club para extender tu suscripción a Uptivo Cloud gratis.",
				fr: "Invitez vos amis à acheter Uptivo avec votre code club pour prolonger votre abonnement Uptivo Cloud gratuitement.",
			},
			licenses: {
				en: "License",
				it: "Licenze",
				es: "Licencias",
				fr: "Licences",
			},
			"show-hide-all": {
				en: "Show/Hide All",
				it: "Mostra/Nascondi Tutto",
				es: "Mostrar/Ocultar todo",
				fr: "Afficher/Masquer tout",
			},
			"lic-no-valid": {
				en: "No valid licenses!",
				it: "Non ci sono licenze valide!",
				es: "¡Sin licencias válidas!",
				fr: "Aucune licence valide!",
			},
			"DurationExtension-LM": {
				en: "{0} used your Club code to become an Uptivo customer. You have been rewarded with {1} days of free cloud!",
				it: "{0} ha usato il tuo codice club per il suo primo acquisto Uptivo. Hai ottenuto {1} giorni di cloud gratuito!",
				es: "{0} ha usado tu código club para su primera compra de la solución Uptivo. ¡Te regalamos {1} días gratuitos de nube!",
				fr: "{0} a utilisé votre code club pour acheter Uptivo pour la première fois. Nous vous avons récompensé avec {1} jours de cloud gratuits!",
			},
			redeem: {
				en: "Redeem",
				it: "Attiva",
				es: "Redimir",
				fr: "Racheter",
			},
		},
		ClubLicenseView: {
			"lic-type": {
				en: "License Type",
				it: "Tipo Licenza",
				es: "Tipo de licencia",
				fr: "Type de licence",
			},
			"lic-apps": {
				en: "Trainer Apps",
				it: "Trainer App",
				es: "Aplicaciones para entrenadores",
				fr: "Applis Trainer",
			},
			"lic-hr-sensors": {
				en: "Heart Rate Sensors",
				it: "Sensori Cardio",
				es: "Sensores de FC",
				fr: "Capteurs de FC",
			},
			"third-party-sensors": {
				en: "Third-party",
				it: "Altre marche",
				es: "Otras marcas",
				fr: "Autres marques",
			},
			"lic-trial": {
				en: "Trial",
				it: "Prova",
				es: "Prueba",
				fr: "Essai",
			},
			"lic-valid": {
				en: "Valid",
				it: "Valida",
				es: "Válido",
				fr: "Valide",
			},
		},
		BrandView: {
			"brand": {
				en: "Organization",
				it: "Organizzazione",
				es: "Organización",
				fr: "Organisation"
			},
			"edit-club": {
				en: "Edit Club",
				it: "Modifica Club",
				es: "Editar club",
				fr: "Modifier le club",
			},
			"brand-data-updated": {
				en: "Successfully updated brand data",
				it: "Dati del Brand modificati con successo",
				es: "Datos de la marca actualizados con éxito",
				fr: "Données de marque mises à jour avec succès",
			},
			"brand-profile": {
				en: "Brand Profile",
				it: "Profilo Brand",
				es: "Perfil de la marca",
				fr: "Profil de la marque",
			},
			"brand-information": {
				en: "Brand Information",
				it: "Informazioni Brand",
				es: "Información de la marca",
				fr: "Informations de la marque",
			},
			"brand-name": {
				en: "Brand Name",
				it: "Nome Brand",
				es: "Nombre de la marca",
				fr: "Nom de marque",
			},
			"add-new-club": {
				en: "Add New Club",
				it: "Aggiungi Club",
				es: "Añadir nuevo club",
				fr: "Ajouter nouveau club",
			},
			"use-logo-for-all": {
				en: "Use brand logo for all Clubs",
				it: "Usa il logo del brand per tutti i Club",
				es: "Usar el logotipo de la marca para todos los clubes",
				fr: "Utiliser le logo de la marque pour tous les clubs",
			},
		},
		ImageUploaderView: {
			"drag-label": {
				en: "Click or drop your image here",
				it: "Clicca o trascina la tua immagine qui",
				es: "Haga clic o suelte su imagen aquí",
				fr: "Cliquez ou déposez votre image ici",
			},
			"loading-label": {
				en: "Loading image…",
				it: "Caricamento immagine…",
				es: "Cargando imagen…",
				fr: "Chargement de l'image…",
			},
		},
		AccountView: {
			"email-updated": {
				en: "Successfully updated Email address",
				it: "Indirizzo Email modificato con successo",
				es: "Dirección de correo electrónico actualizada correctamente",
				fr: "Adresse e-mail mise à jour avec succès",
			},
			"email-exists": {
				en: "Email {0} already exists!",
				it: "L'email {0} è già in uso!",
				es: "¡El email {0} ya existe!",
				fr: "L'e-mail {0} existe déjà!",
			},
			conflict: {
				en: "Conflict",
				it: "Conflitto",
				es: "Conflicto",
				fr: "Conflit",
			},
			"confirm-email-required": {
				en: "Confirm Email is required",
				it: "Conferma Email è un campo obbligatorio",
				es: "El correo electrónico de confirmación es obligatorio",
				fr: "Il est nécessaire de confirmer l'adresse e-mail",
			},
			"new-email-required": {
				en: "New Email is required",
				it: "Nuova Email è un campo obbligatorio",
				es: "Se requiere el nuevo correo electrónico",
				fr: "Une nouvelle adresse e-mail est requise",
			},
			"updated-club-info": {
				en: "Successfully updated clubs information",
				it: "Informazioni Club modificate con successo",
				es: "Información de clubes actualizada correctamente",
				fr: "Informations sur les clubs mises à jour avec succès",
			},
			"created-club": {
				en: "Successfully created a new club",
				it: "Club creato con successo",
				es: "Ha creado un nuevo club correctamente",
				fr: "Création réussie d'un nouveau club",
			},
			"updated-account-info": {
				en: "Successfully updated account information",
				it: "Informazioni account modificate con successo",
				es: "Información de la cuenta actualizada correctamente",
				fr: "Informations sur le compte mises à jour avec succès",
			},
			"email-required": {
				en: "Email is required",
				it: "Email è un campo obbligatorio",
				es: "Se requiere una dirección de correo electrónico",
				fr: "Une adresse e-mail est requise",
			},
			"nickname-required": {
				en: "Nickname is required",
				it: "Nickname è un campo obbligatorio",
				es: "Se requiere un apodo",
				fr: "Pseudo requis",
			},
			"account-information": {
				en: "Account Information",
				it: "Informazioni Account",
				es: "Información de la cuenta",
				fr: "Informations de compte",
			},
			"leave-club": {
				en: "Leave Club",
				it: "Lascia il Club",
				es: "Dejar club",
				fr: "Quitter le club",
			},
			"no-clubs-so-far": {
				en: "No clubs so far",
				it: "Non ci sono club",
				es: "De momento, no hay clubes",
				fr: "Aucun club jusqu'à présent",
			},
			"delete-account": {
				en: "Delete account",
				it: "Elimina Account",
				es: "Eliminar cuenta",
				fr: "Supprimer le compte",
			},
			advanced: {
				en: "Advanced",
				it: "Avanzate",
				es: "Avanzado",
				fr: "Avancé",
			},
			"delete-account-info": {
				en: "You are about to delete your account. To confirm type email you use for login and Uptivo notifications",
				it: "Stai per eliminare il tuo account. Per confermare, scrivi l'email che usi per login e notifiche di Uptivo",
				es: "Está a punto de eliminar su cuenta. Para confirmar, inserte el correo electrónico que utiliza para iniciar sesión y las notificaciones Uptivo",
				fr: "Vous êtes sur le point de supprimer votre compte. Pour confirmer, saisir l'adresse e-mail utilisée pour la connexion et les notifications Uptivo",
			},
		},
		AddUsersView: {
			invited: {
				en: "Invited",
				it: "Invitato",
				es: "Invitado",
				fr: "Invité",
			},
			created: {
				en: "Created",
				it: "Creato",
				es: "Creado",
				fr: "Créé",
			},
			"pending-users": {
				en: "Pending Users",
				it: "Utenti in Sospeso",
				es: "Usuarios pendientes",
				fr: "Utilisateurs en attente",
			},
			"self-service": {
				en: "Self-Service",
				it: "Fai da Te",
				es: "Autoservicio",
				fr: "En Libre Service",
			},
			"send-link-label": {
				en: "Let the user create their own profile and join the club",
				it: "Consenti all'utente di creare il proprio profilo e di unirsi al club",
				es: "Deje que el usuario cree su propio perfil y únase al club",
				fr: "Laissez l'utilisateur créer son propre profil et rejoindre le club",
			},
			"send-link": {
				en: "Send email",
				it: "Invia email",
				es: "Enviar correo",
				fr: "Envoyer e-mail",
			},
			"create-new-user-label": {
				en: "Make life easier for your member and create their profile",
				it: "Semplifica la vita al tuo utente e crea il suo profilo",
				es: "Haz la vida más fácil a tu miembro y crea su perfil",
				fr: "Facilitez la vie de votre membre et créez son profil",
			},
			"create-new-user": {
				en: "Create Profile",
				it: "Crea il Profilo",
				es: "Crear Perfil",
				fr: "Créer un Profil",
			},
			"sent-on": {
				en: "Sent On",
				it: "Mandato Il",
				es: "Enviado el",
				fr: "Envoyé le",
			},
			"expires-on": {
				en: "Expires On",
				it: "Scade Il",
				es: "Caduca en",
				fr: "Expire le",
			},
			"date-of-birth-required": {
				en: "Date of Birth is required",
				it: "Data di Nascita è un campo obbligatorio",
				es: "Se requiere fecha de nacimiento",
				fr: "La date de naissance est requise",
			},
			"date-no-greater-than-now": {
				en: "Date can't be in future",
				it: "La data non può essere nel futuro",
				es: "La fecha no puede ser en el futuro",
				fr: "La date ne peut pas être une date future",
			},
			"gender-is-required": {
				en: "Gender is required",
				it: "Sesso è un campo obbligatorio",
				es: "Se requiere rellenar el sexo",
				fr: "Le sexe est requis",
			},
			"height-is-required": {
				en: "Height is required",
				it: "Altezza è un campo obbligatorio",
				es: "Se requiere la altura",
				fr: "La taille est requise",
			},
			"weight-is-required": {
				en: "Weight is required",
				it: "Peso è un campo obbligatorio",
				es: "Se requiere el peso",
				fr: "Le poids est requis",
			},
			"user-created-title": {
				en: "User added to the Club",
				it: "Utente aggiunto al club",
				es: "Usuario agregado al club",
				fr: "Utilisateur ajouté au club",
			},
			"user-created-details": {
				en: "The invitation must be accepted within 14 days or the user will be removed from Uptivo.",
				it: "L'utente ha 14 giorni per accettare l'invito o verrà rimosso da Uptivo.",
				es: "La invitación debe aceptarse dentro de los 14 días o el usuario será eliminado de Uptivo.",
				fr: "L'invitation doit être acceptée dans les 14 jours. Dans le cas contraire, l'utilisateur sera supprimé d'Uptivo.",
			},
			"user-invited-title": {
				en: "Invitation sent",
				it: "Invito inviato",
				es: "Invitación enviada",
				fr: "Invitation envoyée",
			},
			"user-invited-details": {
				en: "The user will be added to your Club as soon as the invite is accepted.",
				it: "L'utente verrà aggiunto al tuo Club quando accetterà l'invito.",
				es: "El usuario será agregado a su Club tan pronto como se acepte la invitación.",
				fr: "L'utilisateur sera ajouté à votre Club dès l'invitation acceptée.",
			},
			"user-already-member": {
				en: "The user with email {0} is already member of your club.",
				it: "L'utente con email {0} è già membro del tuo club.",
				es: "El usuario con el correo electrónico {0} ya es miembro de su club.",
				fr: "L'utilisateur titulaire de l'adresse e-mail {0} est déjà membre de votre club.",
			},
			"waiting-confirm": {
				en: "Waiting Confirmation",
				it: "In attesa di conferma",
				es: "Esperando confirmación",
				fr: "En attente de confirmation",
			},
			"create-new-invitation-qr-code": {
				en: "Create new invitation QR Code",
				it: "Crea nuovo QR Code di invito",
				es: "Crea nuevo código QR de invitación",
				fr: "Créer nouvelle invitation QR Code",
			},
			"edit-invitation-qr-code": {
				en: "Edit invitation QR Code",
				it: "Modifica QR Code di invito",
				es: "Cambiar el código QR de la invitación",
				fr: "Changer le QR Code d'invitation",
			},
			"qr-code": {
				en: "QR Code",
				it: "Codice QR",
				es: "QR Code",
				fr: "QR Code",
			},
			link: {
				en: "Link",
				it: "Link",
				es: "Link",
				fr: "Link",
			},
			"invitation-qr-codes": {
				en: "Invitation QR Codes",
				it: "Codici QR Di Invito",
				es: "Códigos QR De Invitación",
				fr: "Codes QR D'Invitation",
			},
			"the-qr-code-will-be-deactivated": {
				en: "The QR Code will be deactivated",
				it: "Il QR Code verrà disattivato",
				es: "El código QR se desactivará",
				fr: "Le QR Code sera désactivé",
			},
			"the-qr-code-will-be-reactivated": {
				en: "The QR Code will be reactivated",
				it: "Il QR Code verrà riattivato",
				es: "El código QR se reactivará",
				fr: "Le QR Code sera réactivé",
			},
		},
		DemoUsersView: {
			"demo-users": {
				en: "Demo Users",
				it: "Utenti Demo",
				es: "Usuarios demo",
				fr: "Utilisateurs Démo",
			},
			"demo-user": {
				en: "Demo User",
				it: "Utente Demo",
				es: "Usuario demo",
				fr: "Utilisateur Démo",
			},
			"manage-demo-users": {
				en: "Manage Demo Users",
				it: "Gestione Utenti Demo",
				es: "Administrar usuarios demo",
				fr: "Gérer les Utilisateurs Démo",
			},
			"add-demo-sensor": {
				en: "Add Demo User",
				it: "Aggiungi Utente Demo",
				es: "Agregar usuario demo",
				fr: "Ajouter un Utilisateur Démo",
			},
			"display-group-id": {
				en: "Room Id",
				it: "Id Sala",
				es: "Id Sala",
				fr: "Id Salle",
			},
			"demo-user-created": {
				en: "Successfully created demo user",
				it: "Utente demo creato con successo",
				es: "Usuario demo creado correctamente",
				fr: "Utilisateur Démo créé avec succès",
			},
			"demo-user-updated": {
				en: "Successfully updated demo user",
				it: "Utente modificato con successo",
				es: "Usuario de demostración actualizado correctamente",
				fr: "Utilisateur Démo mis à jour avec succès",
			},
			"default-display": {
				en: "Default Room",
				it: "Sala di Default",
				es: "Sala predeterminada",
				fr: "Salle par défaut",
			},
			"sensor-id": {
				en: "Sensor ID",
				it: "ID Sensore",
				es: "ID del sensor",
				fr: "Identifiant du capteur",
			},
			model: {
				en: "Model",
				it: "Modello",
				es: "Modelo",
				fr: "Modèle",
			},
		},
		AddOrUpdateUptivoBelt: {
			"invalid-uptivo-belt-number": {
				en: "The Uptivo Sensor ID is incorrect",
				it: "L'ID del Sensore Uptivo non è corretto",
				es: "El ID del Sensor Uptivo es incorrecto",
				fr: "L'identifiant du Capteur Uptivo est incorrect",
			},
		},
		AddOrUpdateMZBelt: {
			"invalid-mz-belt-number": {
				en: "The MZ Sensor SN is incorrect",
				it: "Il SN del Sensore MZ non è corretto",
				es: "El SN del Sensor MZ es incorrecto",
				fr: "Le SN du Capteur MZ est incorrect",
			},
		},
		AddOrUpdateGarminBelt: {
			"invalid-garmin-belt-number": {
				en: "The Garmin Sensor SN is incorrect",
				it: "Il SN del Sensore Garmin non è corretto",
				es: "El SN del Sensor Garmin es incorrecto",
				fr: "Le SN du Capteur Garmin est incorrect",
			},
		},

		AppManagementView: {
			"app-management": {
				en: "Trainer Apps",
				it: "Trainer App",
				es: "Trainer App",
				fr: "Trainer App",
			},
			"registered-apps": {
				en: "Registered Apps",
				it: "App registrate",
				es: "Aplicaciones registradas",
				fr: "Applications enregistrées",
			},
			"generate-code": {
				en: "Generate Code",
				it: "Genera Codice",
				es: "Generar código",
				fr: "Générer le code",
			},
			"pending-registrations": {
				en: "Pending Registrations",
				it: "Registrazioni in Sospeso",
				es: "Registros pendientes",
				fr: "Inscriptions en attente",
			},
		},
		IntegrationsView: {
			integrations: {
				en: "Integrations",
				it: "Integrazioni",
				es: "Integraciones",
				fr: "Intégrations",
			},
			"edit-device": {
				en: "Edit Device",
				it: "Modifica il dispositivo",
				es: "Editar dispositivo",
				fr: "Modifier un appareil",
			},
			"create-device": {
				en: "Add New Device",
				it: "Aggiungi Nuovo Dispositivo",
				es: "Añadir nuevo dispositivo",
				fr: "Ajouter un nouvel appareil",
			},
			"device-type": {
				en: "Device Type",
				it: "Tipo dispositivo",
				es: "Tipo de dispositivo",
				fr: "Type d'appareil",
			},
			"device-model": {
				en: "Device Model",
				it: "Modello dispositivo",
				es: "Modelo de dispositivo",
				fr: "Modèle d'appareil",
			},
			"club-devices": {
				en: "Club Devices",
				it: "Dispositivi del Club",
				es: "Dispositivos del club",
				fr: "Appareils du club",
			},
			"ip-address": {
				en: "IP Address",
				it: "Indirizzo IP",
				es: "Dirección de IP",
				fr: "Adresse IP",
			},
			"no-devices": {
				en: "No Devices Configured",
				it: "Nessun dispositivo configurato",
				es: "Sin dispositivos configurados",
				fr: "Aucun appareil configuré",
			},
		},
		DeviceManagementView: {
			"ant-disconnected": {
				en: "Some of the Uptivo Bridges are missing the ANT+ USB Antenna",
				it: "Alcuni degli Uptivo Bridge non hanno l'Antenna USB ANT+",
				es: "Algunos de los Uptivo Bridge les falta la antena USB ANT+",
				fr: "Certains des Uptivo Bridge n'ont pas l'antenne USB ANT+",
			},
			"disconnected-nodes": {
				en: "The current license is being used in multiple locations, which is a violation of the license agreement. Please ensure compliance to avoid any interruptions in service.",
				it: "La licenza attuale è utilizzata in più sedi, il che rappresenta una violazione dell'accordo di licenza. Si prega di garantire la conformità per evitare interruzioni del servizio.",
				es: "La licencia actual se está utilizando en varias ubicaciones, lo que constituye una violación del acuerdo de licencia. Por favor, asegúrese de cumplir con los términos para evitar interrupciones en el servicio.",
				fr: "La licence actuelle est utilisée dans plusieurs emplacements, ce qui constitue une violation de l'accord de licence. Veuillez assurer la conformité pour éviter toute interruption du service.",
			},
			"not-online": {
				en: "Some of the Uptivo Bridges are off-line",
				it: "Alcuni Uptivo Bridge sono disconnessi o spenti",
				es: "Algunos Uptivo Bridge están desconectados o apagados",
				fr: "Certains Uptivo Brige sont déconnectés ou désactivés",
			},
			"error-last-hour": {
				en: "Some of the Uptivo Bridges experienced network errors in the last hour",
				it: "Alcuni Uptivo Bridge hanno segnalato errori di rete nell'ultima ora",
				es: "Algunos Uptivo Bridge han reportado errores de red en la última hora",
				fr: "Certains Uptivo Bridge ont signalé des erreurs de réseau au cours de la dernière heure",
			},
			"connection-problems": {
				en: "Connection problems",
				it: "Problemi di connessione",
				es: "Problemas de conexión",
				fr: "Problèmes de connexion",
			},
			"uptivo-bridges": {
				en: "Uptivo Bridges",
				it: "Uptivo Bridge",
				es: "Uptivo Bridge",
				fr: "Uptivo Bridge",
			},
			"display-groups": {
				en: "Rooms",
				it: "Sale",
				es: "Salas",
				fr: "Salles",
			},
			"register-new-bridge": {
				en: "Register New Uptivo Bridge",
				it: "Registra nuovo Uptivo Bridge",
				es: "Registrar Nuevo Uptivo Bridge",
				fr: "Enregistrement d'un nouvel Uptivo Bridge",
			},
			"generate-code": {
				en: "Generate Code",
				it: "Genera Codice",
				es: "Generar código",
				fr: "Générer le code",
			},
			"pending-registrations": {
				en: "Pending Registrations",
				it: "Registrazioni in Sospeso",
				es: "Registros pendientes",
				fr: "Inscriptions en attente",
			},
			"add-new-display-group": {
				en: "Add new Room",
				it: "Aggiungi nuova Sala",
				es: "Agregar nueva Sala",
				fr: "Ajouter une nouvelle Salle",
			},
			"rename-display-group": {
				en: "Rename Room",
				it: "Rinomina Sala",
				es: "Cambiar nombre de Sala",
				fr: "Renommer la Salle",
			},
			"name-required": {
				en: "Name is required",
				it: "Nome è un campo obbligatorio",
				es: "Se require el nombre",
				fr: "Nom requis",
			},
			"select-valid-color": {
				en: "Please select a valid color",
				it: "Selezionare un colore valido",
				es: "Seleccione un color válido",
				fr: "Sélectionnez une couleur valide",
			},
			"added-device-group": {
				en: "Successfully added Device Group",
				it: "Gruppo Monitor aggiunto con successo",
				es: "Grupo de dispositivos agregado correctamente",
				fr: "Groupe de périphériques ajouté avec succès",
			},
			"bridge-name": {
				en: "Uptivo Bridge Name",
				it: "Nome Uptivo Bridge",
				es: "Nombre de Uptivo Bridge",
				fr: "Nom de l'Uptivo Bridge",
			},
			"ip-address": {
				en: "IP Address",
				it: "Indirizzo IP",
				es: "Dirección de IP",
				fr: "Adresse IP",
			},
			"added-on": {
				en: "Added on",
				it: "Aggiunto Il",
				es: "Añadido en",
				fr: "Ajouté le",
			},
			"move-to": {
				en: "Move To",
				it: "Sposta",
				es: "Mover a",
				fr: "Déplacer vers",
			},
			"successfully-deleted-device": {
				en: "Successfully deleted Uptivo Bridge",
				it: "Uptivo Bridge rimosso con successo",
				es: "Dispositivo eliminado correctamente",
				fr: "Uptivo Bridge  supprimé avec succès",
			},
			"successfully-renamed-group": {
				en: "Successfully renamed room",
				it: "Sala rinominata con successo",
				es: "Sala renombrada con éxito",
				fr: "Salle renommé avec succès",
			},
			"successfully-deleted-group": {
				en: "Successfully deleted room",
				it: "Sala cancellata con successo",
				es: "Sala eliminada correctamente",
				fr: "Salle supprimé avec succès",
			},
			code: {
				en: "Code",
				it: "Codice",
				es: "Código",
				fr: "Code",
			},
			"required-on": {
				en: "Required On",
				it: "Richiesto Il",
				es: "Requerido en",
				fr: "Requis le",
			},
		},
		EditUserView: {
			"edit-user": {
				en: "Edit User",
				it: "Modifica Utente",
				es: "Editar Usuario",
				fr: "Modifier l'utilisateur",
			},
			"leave-club": {
				en: "Leave Club",
				it: "Lascia il Club",
				es: "Dejar club",
				fr: "Quitter le club",
			},
			"yes-delete": {
				en: "Yes, delete!",
				it: "Sì, elimina!",
				es: "¡Sí, borrar!",
				fr: "Oui, supprimer!",
			},
			"yes-confirm": {
				en: "Yes, confirm!",
				it: "Sì, conferma!",
				es: "¡Sí, confirma!",
				fr: "Oui, confirmez !"
			},
			"will-remove-from-club": {
				en: "You will be removed from this club.",
				it: "Verrai rimosso da questo club.",
				es: "Serás eliminado de este club.",
				fr: "Vous serez retiré de ce club.",
			},
			"you-have-been-deleted": {
				en: "You have been deleted from the club.",
				it: "Sei stato rimosso dal club.",
				es: "Has sido eliminado del club.",
				fr: "Vous avez été supprimé du club.",
			},
			"form-invalid": {
				en: "Form invalid",
				it: "Modulo invalido",
				es: "Formulario no válido",
				fr: "Formulaire invalide",
			},
			"fix-values": {
				en: "Please correct the requested data before saving",
				it: "Correggere i dati richiesti per poter salvare",
				es: "Por favor, corrija los datos solicitados antes de guardar",
				fr: "Veuillez corriger les données requises avant de sauvegarder",
			},
			"fix-limits": {
				en: "Please fix the zone limits data before saving",
				it: "Correggere i limiti delle zone prima di salvare",
				es: "Corrija los datos de límites de zona antes de guardar",
				fr: "Veuillez corriger les données de limites de zone avant d'enregistrer",
			},
			"successfully-updated-physical": {
				en: "Successfully updated physical settings",
				it: "Impostazioni biometriche modificate con successo",
				es: "Configuraciones físicas actualizadas correctamente",
				fr: "Les paramètres physiques ont été mis à jour avec succès",
			},
			"sensor-created": {
				en: "Successfully created sensor",
				it: "Sensore creato con successo",
				es: "Sensor creado correctamente",
				fr: "Capteur créé avec succès",
			},
			"remove-sensor-confirm": {
				en: "Are you sure you want to remove this sensor",
				it: "Sei sicuro di voler rimuovere questo sensore?",
				es: "¿Estás seguro de que quieres quitar este sensor?",
				fr: "Êtes-vous sûr de vouloir supprimer ce capteur?",
			},
			"sensor-removed-succesfully": {
				en: "Sensor removed successfully",
				it: "Sensore rimosso con successo",
				es: "Sensor eliminado correctamente",
				fr: "Capteur supprimé avec succès",
			},
			"uptivo-sensor-id": {
				en: "Uptivo Sensor ID",
				it: "ID del Sensore Uptivo",
				es: "ID del Sensor Uptivo",
				fr: "Identifiant du Capteur Uptivo",
			},
			"send-fitness-test-notification": {
				en: "Send Fitness Test Notification",
				it: "Invia Notifica Fitness Test",
				es: "Enviar Notificación de Fitness Test",
				fr: "Envoyer une notification de Fitness Test",
			},
			"sensor-removed": {
				en: "Sensor Removed",
				it: "Sensore Rimosso",
				es: "Sensor Eliminado",
				fr: "Capteur Retiré",
			},
			"minimum-percentage-target-zone": {
				en: "Minimum Target Zone %",
				it: "Minima Target Zone %",
				es: "Mínimo Target Zone %",
				fr: "Minimale Target Zone %",
			},
			"minimum-percentage-target-zone-error": {
				en: "Minimum Target Zone % must be between 0 and 100",
				it: "Minima Target Zone % deve essere compreso tra 0 e 100",
				es: "Mínimo Target Zone % debe estar entre 0 y 100",
				fr: "Minimale Target Zone % doit être compris entre 0 et 100",
			},
			"maximum-percentage-target-zone": {
				en: "Maximum Target Zone %",
				it: "Massima Target Zone %",
				es: "Máximo Target Zone %",
				fr: "Maximum  Target Zone %",
			},
			"maximum-percentage-target-zone-error": {
				en: "Maximum Target Zone %  must be between 1 and 100",
				it: "Massima Target Zone % deve essere compreso tra 1 e 100",
				es: "Máximo Target Zone % debe estar entre 1 y 100",
				fr: "Maximum  Target Zone % doit être compris entre 1 et 100",
			},
			"custom-target-zone-prc-error": {
				"en": "Minimum Target Zone cannot be greater than or equal to field Maximum Target Zone.",
				"it": "La Target Zone Minima non può essere maggiore o uguale alla Target Zone Massima.",
				"es": "La Target Zone Mínima no puede ser mayor o igual que la Target Zone Máxima.",
				"fr": "La Target Zone Minimale ne peut pas être supérieure ou égale à la Zone Cible Maximale."
			},
			subscriptions: {
				en: "Subscriptions",
				it: "Abbonamenti",
				es: "Suscripciones",
				fr: "Abonnements",
			},
			last: {
				en: "Last",
				it: "Ultimo",
				es: "Último",
				fr: "Dernier",
			},
			number: {
				en: "Number",
				it: "Numero",
				es: "Número",
				fr: "Numéro",
			},
			awards: {
				en: "Awards",
				it: "Premi",
				es: "Premios",
				fr: "Prix",
			},
			"badge-earned-x-times": {
				en: "Earned {0} times",
				it: "Vinto {0} volte",
				es: "Ganado {0} veces",
				fr: "Gagné {0} fois",
			},
			"badge-last-earned": {
				en: "Last earned {0}",
				it: "Ultimo vinto {0}",
				es: "Último ganado {0}",
				fr: "Dernier gagné {0}",
			},
			"training-days": {
				en: "Training days",
				it: "Giorni Di Allenamento",
				es: "Días De Entrenamiento",
				fr: "Jours D'Entraînement",
			},
			"training-schedule-notes": {
				en: "Training Days Notes",
				it: "Note Sui Giorni Di Allenamento",
				es: "Notas Sobre Días De Entrenamiento",
				fr: "Notes Sur Les Jours D'Entraînement",
			},
			note: {
				en: "Note",
				it: "Nota",
				es: "Nota",
				fr: "Note",
			},
			"training-info": {
				en: "Training Info",
				it: "Info Allenamento",
				es: "Info Entrenamiento",
				fr: "Info Entraînement",
			},
			"fitness-goals": {
				en: "Fitness Goals",
				it: "Obiettivi Fitness",
				es: "Objetivos Fitness",
				fr: "Objectifs Fitness",
			},
			"injuries-history": {
				en: "Injuries History",
				it: "Cronologia Infortuni",
				es: "Historial De Lesiones",
				fr: "Historique Des Injuries",
			},
			certificates: {
				en: "Certificates",
				it: "Certificati",
				es: "Certificados",
				fr: "Certificats",
			},
			"training-comments": {
				en: "Training Comments",
				it: "Commenti Allenamento",
				es: "Comentarios De Entrenamiento",
				fr: "Commentaires D'Entraînement",
			},
			by: {
				en: "By",
				it: "Da",
				es: "Por",
				fr: "Par",
			},
			notes: {
				en: "Notes",
				it: "Note",
				es: "Notas",
				fr: "Notes",
			},
			occupation: {
				en: "Occupation",
				it: "Occupazione",
				es: "Ocupación",
				fr: "Occupation",
			},
			"not-set": {
				en: "Not set",
				it: "Non registrato",
				es: "No establecido",
				fr: "Non défini",
			},
			FTP: {
				en: "FTP",
				it: "FTP",
				es: "FTP",
				fr: "FTP",
			},
			"no-awards-in-this-club": {
				en: "No awards in this club",
				it: "Nessun premio in questo club",
				es: "No hay premios en este club",
				fr: "Aucun prix dans ce club",
			},
			city: {
				en: "City",
				it: "Città",
				es: "Ciudad",
				fr: "Ville",
			},
			"total-booking": {
				en: "Total Booking",
				it: "Totale Prenotazioni",
				es: "Reserva Total",
				fr: "Réservation Totale",
			},
			"total-bookings": {
				en: "Total Bookings",
				it: "Totale Prenotazioni",
				es: "Reserva Total",
				fr: "Réservation Totale",
			},
			"total-trainings": {
				en: "Total Trainings",
				it: "Allenamenti Totali",
				es: "Entrenamientos Totales",
				fr: "Entraînements Totaux",
			},
			"postal-code": {
				en: "Postal Code",
				it: "Codice Postale",
				es: "Código Postal",
				fr: "Code Postal",
			},
			address1: {
				en: "Address 1",
				it: "Indirizzo 1",
				es: "Dirección 1",
				fr: "Adresse 1",
			},
			address2: {
				en: "Address 2",
				it: "Indirizzo 2",
				es: "Dirección 2",
				fr: "Adresse 2",
			},
			"last-edit": {
				en: "Last Edit",
				it: "Ultima Modifica",
				es: "Última Edición",
				fr: "Dernière Modification",
			},
			"add-note": {
				en: "Add Note",
				it: "Aggiungi Nota",
				es: "Agregar Nota",
				fr: "Ajouter Note",
			},
			"edit-note": {
				en: "Edit Note",
				it: "Modifica Nota",
				es: "Editar Nota",
				fr: "Modifier Note",
			},
			"add-expiration": {
				en: "Add Expiration",
				it: "Aggiungi Scadenza",
				es: "Agregar Expiración",
				fr: "Ajouter Expiration",
			},
			"edit-expiration": {
				en: "Edit Expiration",
				it: "Modifica Scadenza",
				es: "Editar Expiración",
				fr: "Modifier Expiration",
			},
			"expiration-must-be-in-future": {
				en: "Expiration must be in future",
				it: "La Scadenza deve essere nel futuro",
				es: "La Expiración Debe Ser En El Futuro",
				fr: "L'Expiration Doit être dans le futur",
			},
		},
		FooterView: {
			copyright: {
				en: "Copyright",
				it: "Copyright",
				es: "Derechos de autor",
				fr: "Copyright",
			},
		},
		GeneralSettingsView: {
			"send-email-after": {
				en: " Send Email after training",
				it: " Invia email dopo il training",
				es: " Enviar correo electrónico después del entrenamiento",
				fr: " Envoyer un e-mail après l'entraînement",
			},
			"send-monthly-recap-email": {
				en: " Send monthly recap email",
				it: " Invia email riepilogo mensile",
				es: " Enviar correo electrónico con el resumen mensual",
				fr: " Envoyer un e-mail récapitulatif mensuel",
			},
			"send-fitness-test-notifications": {
				en: "Remind me to take my Uptivo Fitness Test",
				it: "Ricordami di fare il Uptivo Fitness Test",
				es: "Recuérdame tomar mi Uptivo Fitness Test",
				fr: "Rappelez-moi de Uptivo Fitness Test",
			},
			mon: {
				en: "Mon",
				it: "Lun",
				es: "Lun",
				fr: "Lun",
			},
			sat: {
				en: "Sat",
				it: "Sab",
				es: "Sáb",
				fr: "Sam",
			},
			sun: {
				en: "Sun",
				it: "Dom",
				es: "Dom",
				fr: "Dim",
			},
			Metric: {
				en: "Metric",
				it: "Metrico",
				es: "Métrico",
				fr: "Métrique",
			},
			Imperial: {
				en: "Imperial",
				it: "Imperiale",
				es: "Imperial",
				fr: "Impérial",
			},
			"updated-general-settings-msg": {
				en: "Successfully updated general settings",
				it: "Impostazioni modificate con successo",
				es: "Configuraciones generales actualizadas correctamente",
				fr: "Paramètres généraux mis à jour avec succès",
			},
		},
		GroupTrainingView: {
			"group-trainings": {
				en: "Group Trainings",
				it: "Training nel Gruppo",
				es: "Entrenamientos grupales",
				fr: "Entraînements de groupe",
			},
			"training-summary": {
				en: "Training Summary",
				it: "Riepilogo del Training",
				es: "Resumen del entrenamiento",
				fr: "Résumé de l'entraînement",
			},
			"avg-tz": {
				en: "Avg TZ",
				it: "TZ Med",
				es: "ZO Media (zona objetivo)",
				fr: "TZ moy.",
			},
			"calories-per-person": {
				en: "Calories/Person",
				it: "Calorie/Persona",
				es: "Calorías/Persona",
				fr: "Calories/Personne",
			},
		},
		InvitationCodeView: {
			accepted: {
				en: "Successfully accepted invitation.",
				it: "Invito accettato con successo.",
				es: "Invitación aceptada correctamente.",
				fr: "Invitation acceptée avec succès.",
			},
		},
		JournalView: {
			journal: {
				en: "Journal",
				it: "Diario",
				es: "Seguimiento",
				fr: "Journal",
			},
			month: {
				en: "Month",
				it: "Mese",
				es: "Mes",
				fr: "Mois",
			},
			list: {
				en: "List",
				it: "Lista",
				es: "Lista",
				fr: "Liste",
			},
			"month-totals": {
				en: "Month Totals",
				it: "Totali Mese",
				es: "Totales del mes",
				fr: "Totaux du mois",
			},
			"week-totals": {
				en: "Week Totals",
				it: "Totali Settimana",
				es: "Totales de la semana",
				fr: "Totaux de la semaine",
			},
			sessions: {
				en: "Sessions",
				it: "Sessioni",
				es: "Sesiones",
				fr: "Sessions",
			},
			"total-sessions": {
				en: "Total Sessions",
				it: "Sessioni totali",
				es: "Total de sesiones",
				fr: "Total des sessions",
			},
			cadence: {
				en: "Cadence",
				it: "Cadenza",
				es: "Cadencia",
				fr: "Cadence",
			},
		},
		ManageUsersView: {
			balance: {
				en: "Balance",
				it: "Saldo",
				es: "Saldo",
				fr: "Solde",
			},
			"current-shares-count": {
				en: "Number of Shares",
				it: "Numero di condivisioni",
				es: "Numero de repartos",
				fr: "Nombre de partager",
			},
			"load-program": {
				en: "Uptload a",
				it: "Carica un",
				es: "Sube un",
				fr: "Télécharger un",
			},
			"training-program": {
				en: "workout program",
				it: "programma di allenamento",
				es: "programa de entrenamiento",
				fr: "programme d'entraînement",
			},
			"no-programs-share": {
				en: "There are no Workout Programs to share.",
				it: "Non ci sono programmi di allenamento da condividere.",
				es: "No hay programas de entrenamiento para compartir.",
				fr: "Il n'y a pas de programmes d'entraînement à partager.",
			},
			"select-training-program": {
				en: "Select a program",
				it: "Seleziona un programma",
				es: "Selecciona un programa",
				fr: "Sélectionnez un programme",
			},
			"change-target-zone": {
				en: "Change Target Zone",
				it: "Cambia Target Zone",
				es: "Cambiar Target Zone",
				fr: "Modifier le Target Zone",
			},
			"group-operation-warning": {
				en: "Warning: the operation will affect <strong>{0} athletes</strong>.",
				it: "Attenzione: l'operazione agirà su <strong>{0} atleti</strong>.",
				es: "Atención: la operación actuará en <strong> {0} atletas </strong>.",
				fr: "Attention: l'opération affectera <strong>{0} athlètes</strong> athlètes.",
			},
			management: {
				en: "Management",
				it: "Gestione",
				es: "Administración",
				fr: "Gestion",
			},
			info: {
				en: "Info",
				it: "Info",
				es: "Info",
				fr: "Info",
			},
			surname: {
				en: "Surname",
				it: "Cognome",
				es: "Apellido",
				fr: "Nom de famille",
			},
			warning: {
				en: "Warning",
				it: "Attenzione",
				es: "Advertencia",
				fr: "Avertissement",
			},
			"error-removing-user-from-club": {
				en: "Error removing user rights from club",
				it: "Errore nella rimozione dei permessi dell'utente dal club",
				es: "Error al eliminar los derechos de usuario del club",
				fr: "Erreur lors de la suppression des droits d'utilisateur du club",
			},
			roles: {
				en: "Roles",
				it: "Ruoli",
				es: "Roles",
				fr: "Rôles",
			},
			"no-roles-removed": {
				en: "If confirmed, the user will be removed from the club.",
				it: "Se confermato, l'utente  verrà rimosso dal club.",
				es: "Si se confirma, el usuario será eliminado del club.",
				fr: "En cas de confirmation, l'utilisateur sera supprimé du club.",
			},
			"athlete-no-roles-removed": {
				en: "All subscriptions, bookings, workout plans, and other club-specific attributes will be removed from the user.",
				it: "Tutti gli abbonamenti, le prenotazioni, i programmi di allenamento e altri attributi specifici del club verranno rimossi dall'utente.",
				es: "Todas las suscripciones, reservas, programas de entrenamiento y otros atributos específicos del club se eliminarán del usuario.",
				fr: "Tous les abonnements, réservations, programmes d'entraînement et autres attributs spécifiques au club seront supprimés de l'utilisateur."
			},
			"athlete-confirmation-removal": {
				en: "If confirmed, all subscriptions, bookings, workout plans, and other club-specific attributes will be removed from the user.",
				it: "Se confermato, tutti gli abbonamenti, le prenotazioni, i programmi di allenamento e altri attributi specifici del club verranno rimossi dall'utente.",
				es: "Si se confirma, todas las suscripciones, reservas, programas de entrenamiento y otros atributos específicos del club se eliminarán del usuario.",
				fr: "S'il est confirmé, tous les abonnements, réservations, programmes d'entraînement et autres attributs spécifiques au club seront supprimés de l'utilisateur."
			},
			"user-permissions-removed": {
				en: "If confirmed, the user will no longer have permissions for {0}",
				it: "Se confermato, l'utente non avrà più i permessi di {0}",
				es: "Si se confirma, el usuario ya no tendrá permisos para {0}",
				fr: "Si confirmé, l'utilisateur n'aura plus les permissions pour {0}"
			},
			"user-info": {
				en: "Users Info",
				it: "Info Utenti",
				es: "Información de los usuarios",
				fr: "Informations sur les utilisateurs",
			},
			"manage-users": {
				en: "Manage Users",
				it: "Gestione Utenti",
				es: "Administrar usuarios",
				fr: "Gérer les utilisateurs",
			},
			"add-athlete-failed": {
				en: "Can't add the user as athlete of the club",
				it: "Impossibile aggiungere l'utente come atleta del club",
				es: "No se puede agregar al usuario como deportista del club",
				fr: "Impossible d'ajouter l'utilisateur en tant qu'athlète du club",
			},
			"add-trainer-failed": {
				en: "Can't add the user as trainer of the club",
				it: "Impossibile aggiungere l'utente come trainer del club",
				es: "No se puede agregar al usuario como entrenador del club",
				fr: "Impossible d'ajouter l'utilisateur en tant qu'entraîneur du club",
			},
			"add-manager-failed": {
				en: "Can't add the user as manager of the club",
				it: "Impossibile aggiungere l'utente come manager del club",
				es: "No se puede agregar al usuario como administrador del club",
				fr: "Impossible d'ajouter l'utilisateur en tant que responsable du club",
			},
			"addcredits-op": {
				en: "{0} added {1} credits to the account",
				it: "{0} ha aggiunto {1} crediti all'account",
				es: "{0} agregó {1} créditos a la cuenta",
				fr: "{0} a ajouté {1} crédits au compte",
			},
			"remcredits-op": {
				en: "{0} removed {1} credits from the account",
				it: "{0} ha rimosso {1} crediti dall'account",
				es: "{0} eliminó {1} créditos de la cuenta",
				fr: "{0} a supprimé {1} crédits du compte",
			},
			"booking-op": {
				en: "{0} subscribed {2} to {3}",
				it: "{0} ha iscritto {2} a {3}",
				es: "{0} suscribió {2} a {3}",
				fr: "{0} a abonné {2} à {3}",
			},
			"unbooking-op": {
				en: "{0} removed {2} from {3}",
				it: "{0} ha rimosso {2} da {3}",
				es: "{0} sacó {2} de {3}",
				fr: "{0} a retiré {2} de {3}",
			},
			"show-in-rankings-table": {
				en: "Rankings",
				it: "Classifiche",
				es: "Rankings",
				fr: "Classements",
			},
			"send-fitness-test-notifications-table": {
				en: "Fitness Test",
				it: "Fitness Test",
				es: "Fitness Test",
				fr: "Fitness Test",
			},
			"default-display-table": {
				en: "Room",
				it: "Sala",
				es: "Sala",
				fr: "Salle",
			},
			program: {
				en: "Workout",
				it: "Allenamento",
				es: "Entrenamiento",
				fr: "Entraînement",
			},
			tz: {
				en: "TZ",
				it: "TZ",
				es: "ZO",
				fr: "ZC",
			},
			"message-tag": {
				en: "Message",
				it: "Messaggio",
				es: "Mensaje",
				fr: "Message",
			},
			"impossible-follow-yourself": {
				en: "Impossible to follow yourself",
				it: "Impossibile seguire te stesso",
				es: "Imposible de seguirte a ti mismo",
				fr: "Impossible de se suivre",
			},
			"confirm-remove-self-join-tag": {
				en: "You are about to remove the 'SELF JOIN' tag",
				it: "Stai per rimuovere il tag 'SELF JOIN'",
				es: "Está a punto de eliminar la etiqueta 'SELF JOIN'",
				fr: "Vous êtes sur le point de supprimer la balise 'SELF JOIN'",
			},
			"confirm-remove-guest-tag": {
				en: "You are about to remove the 'GUEST' tag",
				it: "Stai per rimuovere il tag 'GUEST'",
				es: "Está a punto de eliminar la etiqueta 'GUEST'",
				fr: "Vous êtes sur le point de supprimer la balise 'GUEST'",
			},
			"remove-self-join-tags": {
				en: "Remove 'SELF JOIN' tag",
				it: "Rimuovi 'SELF JOIN' tag",
				es: "Eliminar la etiqueta 'SELF JOIN'",
				fr: "Supprimer la balise 'SELF JOIN'",
			},
			"this-sensor-is-assigned-to-multiple-club-users": {
				en: "This sensor is assigned to multiple users of the club",
				it: "Questo sensore risulta assegnato a più utenti del club",
				es: "Este sensor está asignado a múltiples usuarios del club",
				fr: "Ce capteur est attribué à plusieurs utilisateurs du club",
			},
		},
		NoAccessView: {
			"insufficient-rights": {
				en: "Insufficient rights for this operation",
				it: "Diritti insufficienti per questa operazione",
				es: "No tiene permiso para realizar esta operación",
				fr: "Droits insuffisants pour cette opération",
			},
			"no-rights": {
				en: "You don't have the appropriate rights for the selected club",
				it: "Non hai i diritti necessari per il club selezionato",
				es: "No tiene permiso para el club seleccionado",
				fr: "Vous ne disposez pas des droits requis pour le club sélectionné",
			},
		},
		NotificationView: {
			EmailError: {
				en: "Email Error",
				it: "Errore Email",
				es: "Error de correo electrónico",
				fr: "Erreur d'e-mail"
			},
			"email-error-tpl": {
				it: "Errore durante l'invio email a <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				en: "Error sending email to <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				es: "Error al enviar correo electrónico a <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				fr: "Erreur lors de l'envoi d'e-mail à <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>"
			},
			"email-error-no-nickname-tpl": {
				it: "Errore durante l'invio email all'indirizzo <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				en: "Error sending email to address <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				es: "Error al enviar el correo electrónico a la dirección <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				fr: "Erreur lors de l'envoi de l'e-mail à l'adresse <%= notification.Target.Email%>. <%= notification.Target.Message%>"
			},
			InvitationEmailError: {
				"en": "Email Error (Invitation)",
				"it": "Errore Email (Invito)",
				"es": "Error de correo electrónico (Invitación)",
				"fr": "Erreur d'e-mail (Invitation)"
			},
			"invitation-email-error-tpl": {
				it: "Errore durante l'invio email a <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				en: "Error sending email to <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				es: "Error al enviar correo electrónico a <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>",
				fr: "Erreur lors de l'envoi d'e-mail à <%= notification.Target.Nickname%> (<%= notification.Target.Email%>). <%= notification.Target.Message%>"
			},
			"invitation-email-error-no-nickname-tpl": {
				it: "Errore durante l'invio email all'indirizzo <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				en: "Error sending email to address <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				es: "Error al enviar el correo electrónico a la dirección <%= notification.Target.Email%>. <%= notification.Target.Message%>",
				fr: "Erreur lors de l'envoi de l'e-mail à l'adresse <%= notification.Target.Email%>. <%= notification.Target.Message%>"
			},
			EncodingJobError: {
				en: "Error during video encoding",
				it: "Errore durante la codifica del video",
				es: "Error durante la codificación del video",
				fr: "Erreur lors de l'encodage de la vidéo"
			},
			EncodingJobSuccess: {
				en: "Video encoded successfully",
				it: "Video codificato correttamente",
				es: "Vídeo codificado correctamente",
				fr: "Vidéo encodée avec succès"
			},
			UptivoLevel0: {
				en: "No Level",
				it: "Nessun Livello",
				es: "Sin Nivel",
				fr: "Pas De Niveau",
			},
			UptivoLevel1: {
				en: "Rookie",
				it: "Novellino",
				es: "Novicio",
				fr: "Novice",
			},
			UptivoLevel2: {
				en: "Beginner",
				it: "Principiante",
				es: "Principiante",
				fr: "Débutant",
			},
			UptivoLevel3: {
				en: "Amateur",
				it: "Amatore",
				es: "Aficionado",
				fr: "Amateur",
			},
			UptivoLevel4: {
				en: "Passionate",
				it: "Appassionato",
				es: "Apasionado",
				fr: "Passionné",
			},
			UptivoLevel5: {
				en: "Skillful",
				it: "Preparato",
				es: "Hábil",
				fr: "Habile",
			},
			UptivoLevel6: {
				en: "Outstanding",
				it: "Eccezionale",
				es: "Excepcional",
				fr: "Exceptionnel",
			},
			UptivoLevel7: {
				en: "Tireless",
				it: "Infaticabile",
				es: "Incansable",
				fr: "Infatigable",
			},
			UptivoLevel8: {
				en: "Formidable",
				it: "Formidabile",
				es: "Formidable",
				fr: "Redoutable",
			},
			UptivoLevel9: {
				en: "Phenomenal",
				it: "Fenomenale",
				es: "Fenomenal",
				fr: "Phénoménal",
			},
			UptivoLevel10: {
				en: "Titanic",
				it: "Titanico",
				es: "Titánico",
				fr: "Titanesque",
			},
			"exercise-video-processing-error-tpl": {
				en: "The processing of the exercise video <%= notification.Target.WorkoutName %> ended with error <%= notification.Target.ErrorCode %> (<%= notification.Target.ErrorMessage %>)",
				it: "L'elaborazione del video dell'esercizio <%= notification.Target.WorkoutName %> è terminata con l'errore <%= notification.Target.ErrorCode %> (<%= notification.Target.ErrorMessage %>)",
				es: "El procesamiento del vídeo del ejercicio <%= notification.Target.WorkoutName %> terminó con el error <%= notification.Target.ErrorCode %> (<%= notification.Target.ErrorMessage %>)",
				fr: "Le traitement de la vidéo de l'exercice <%= notification.Target.WorkoutName %> s'est terminé avec l'erreur <%= notification.Target.ErrorCode %> (<%= notification.Target.ErrorMessage %>)"
			},
			"exercise-video-ready-tpl": {
				en: "The video of exercise <%= notification.Target.WorkoutName %> is ready",
				it: "Il video dell'esercizio <%= notification.Target.WorkoutName %> è pronto",
				es: "El vídeo del ejercicio <%= notification.Target.WorkoutName %> está listo",
				fr: "La vidéo de l'exercice <%= notification.Target.WorkoutName %> est prête"
			},
			"user-subscription-add-tpl": {
				en: "The <%= notification.Target.SubscriptionName %> subscription has been added to your account",
				it: "L'abbonamento <%= notification.Target.SubscriptionName %> è stato aggiunto al tuo account",
				es: "La suscripción <%= notification.Target.SubscriptionName %> se ha agregado a su cuenta",
				fr: "L'abonnement <%= notification.Target.SubscriptionName %> a été ajouté à votre compte",
			},
			"user-subscription-add-manager-tpl": {
				en: "<%= notification.Actor.Nickname %> added subscription <%= notification.Target.SubscriptionName %> to <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha aggiunto l'abbonamento <%= notification.Target.SubscriptionName %> a <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> agregó la suscripción <%= notification.Target.SubscriptionName %> a <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a ajouté l'abonnement <%= notification.Target.SubscriptionName %> à <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			"TrainingFeedback": {
				en: "Comment",
				it: "Commento",
				es: "Comentario",
				fr: "Commentaire"
			},
			"TrainingFeedback-tpl": {
				en: "<%= notification.Actor.Nickname %> commented on your training: <%= notification.Target.ShortComment %>",
				it: "<%= notification.Actor.Nickname %> ha commentato il tuo training: <%= notification.Target.ShortComment %>",
				es: "<%= notification.Actor.Nickname %> comentó en tu entrenamiento: <%= notification.Target.ShortComment %>",
				fr: "<%= notification.Actor.Nickname %> a commenté votre entraînement : <%= notification.Target.ShortComment %>"
			},
			UserSubscriptionAdd: {
				en: "Subscription Added",
				it: "Abbonamento Aggiunto",
				es: "Suscripción Agregada",
				fr: "Abonnement Ajouté",
			},
			"user-subscription-update-tpl": {
				en: "The <%= notification.Target.SubscriptionName %> subscription has been updated",
				it: "L'abbonamento <%= notification.Target.SubscriptionName %> è stato modificato",
				es: "Se ha cambiado la suscripción <%= notification.Target.SubscriptionName %>",
				fr: "L'abonnement <%= notification.Target.SubscriptionName %> a été modifié",
			},
			"user-subscription-update-manager-tpl": {
				en: "<%= notification.Actor.Nickname %> modified the subscription <%= notification.Target.SubscriptionName %> for <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha modificato l'abbonamento <%= notification.Target.SubscriptionName %> di <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> modificó la suscripción <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a modifié l'abonnement <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			UserSubscriptionUpdate: {
				en: "Subscription Updated",
				it: "Abbonamento Modificato",
				es: "Suscripción Cambiada",
				fr: "Abonnement Modifié",
			},
			"user-subscription-delete-tpl": {
				en: "The <%= notification.Target.SubscriptionName %> subscription has been removed from your account",
				it: "L'abbonamento <%= notification.Target.SubscriptionName %> è stato rimosso dal tuo account",
				es: "La suscripción <%= notification.Target.SubscriptionName %> se ha eliminado de su cuenta",
				fr: "L'abonnement <%= notification.Target.SubscriptionName %> a été supprimé de votre compte",
			},
			"user-subscription-delete-manager-tpl": {
				en: "<%= notification.Actor.Nickname %> removed subscription <%= notification.Target.SubscriptionName %> from <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha rimosso l'abbonamento <%= notification.Target.SubscriptionName %> da <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> eliminó la suscripción <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a supprimé l'abonnement <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			UserSubscriptionDelete: {
				en: "Subscription Removed",
				it: "Abbonamento Rimosso",
				es: "Suscripción Eliminada",
				fr: "Abonnement Supprimé",
			},
			"user-subscription-suspend-tpl": {
				en: "The <%= notification.Target.SubscriptionName %> subscription has been suspended",
				it: "L'abbonamento <%= notification.Target.SubscriptionName %> è stato sospeso",
				es: "La suscripción <%= notification.Target.SubscriptionName %> ha sido suspendida",
				fr: "L'abonnement <%= notification.Target.SubscriptionName %> a été suspendu",
			},
			"user-subscription-suspend-manager-tpl": {
				en: "<%= notification.Actor.Nickname %> has suspended the subscription <%= notification.Target.SubscriptionName %> for <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha sospeso l'abbonamento <%= notification.Target.SubscriptionName %> di <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> ha suspendido la suscripción <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a suspendu l'abonnement <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			UserSubscriptionSuspend: {
				en: "Subscription Suspended",
				it: "Abbonamento Sospeso",
				es: "Suscripción Suspendida",
				fr: "Abonnement Suspendu",
			},
			"user-subscription-reactivate-tpl": {
				en: "The <%= notification.Target.SubscriptionName %> subscription has been reactivated",
				it: "L'abbonamento <%= notification.Target.SubscriptionName %> è stato riattivato",
				es: "La suscripción <%= notification.Target.SubscriptionName %> se ha reactivado",
				fr: "L'abonnement <%= notification.Target.SubscriptionName %> a été réactivé",
			},
			"user-subscription-reactivate-manager-tpl": {
				en: "<%= notification.Actor.Nickname %> has reactivated the subscription <%= notification.Target.SubscriptionName %> for <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha riattivato l'abbonamento <%= notification.Target.SubscriptionName %> di <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> ha reactivado la suscripción <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a réactivé l'abonnement <%= notification.Target.SubscriptionName %> de <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			UserSubscriptionReactivate: {
				en: "Subscription Reactivated",
				it: "Abbonamento Riattivato",
				es: "Suscripción Reactivada",
				fr: "Abonnement Réactivé",
			},
			"challenge-started-tpl": {
				en: "Time to test yourself! Your club has organized the <%= notification.Target.ChallengeName %> challenge. Train consistently and intensely to win participation trophies",
				it: "È ora di metterti alla prova! Il tuo club ha organizzato la sfida <%= notification.Target.ChallengeName %>, allenati con costanza e intensità per vincere i trofei di partecipazione",
				es: "¡es hora de ponerte a prueba! Tu club ha organizado el desafío <%= notification.Target.ChallengeName %>. Entrena de forma constante e intensa para ganar trofeos de participación",
				fr: "Il est temps de vous tester! Votre club a organisé le défi <%= notification.Target.ChallengeName %>. Entraînez-vous régulièrement et intensément pour gagner des trophées de participation",
			},
			ChallengeStarted: {
				en: "Challenge Started",
				it: "Sfida Cominciata",
				es: "Desafío Iniciado",
				fr: "Défi Commencé",
			},
			"challenge-canceled-tpl": {
				en: "Your club has canceled the <%= notification.Target.ChallengeName %> challenge. Keep an eye on challenges and train consistently and intensely to win participation trophies",
				it: "Il tuo club ha cancellato la sfida <%= notification.Target.ChallengeName %>. Tieni d'occhio le sfide e allenati con costanza e intensità per vincere i trofei di partecipazione",
				es: "Tu club ha cancelado el desafío <%= notification.Target.ChallengeName %>. Esté atento a los desafíos y entrene de manera constante e intensa para ganar trofeos de participación",
				fr: "Votre club a annulé le défi <%= notification.Target.ChallengeName %>. Gardez un œil sur les défis et entraînez-vous régulièrement et intensément pour remporter des trophées de participation",
			},
			ChallengeCanceled: {
				en: "Challenge Canceled",
				it: "Sfida Cancellata",
				es: "Desafío Cancelado",
				fr: "Défi Annulé",
			},
			"challenge-terminated-tpl": {
				en: "The challenge <%= notification.Target.ChallengeName %> has ended. You ranked <%= notification.Target.Rank %>. Keep an eye on your club's challenges and train consistently and intensely to win participation trophies",
				it: "La sfida <%= notification.Target.ChallengeName %> è terminata. La tua posizione è <%= notification.Target.Rank %>. Tieni d'occhio le sfide del tuo club e allenati con costanza e intensità per vincere i trofei di partecipazione",
				es: "El desafío <%= notification.Target.ChallengeName %> ha terminado. Has clasificado <%= notification.Target.Rank %>. Esté atento a los desafíos de su club y entrene de manera constante e intensa para ganar trofeos de participación",
				fr: "Le défi <%= notification.Target.ChallengeName %> est terminé. Vous avez classé <%= notification.Target.Rank %>. Gardez un œil sur les défis de votre club et entraînez-vous régulièrement et intensément pour remporter des trophées de participation",
			},
			ChallengeTerminated: {
				en: "Challenge Ended",
				it: "Sfida Terminata",
				es: "Desafío Terminado",
				fr: "Défi Terminé",
			},
			"challenge-awarded-tpl": {
				en: 'Congratulations, you have won a trophy for the <%= notification.Target.ChallengeName %> challenge! Your position is <%= notification.Target.RankPrc ? "\\"top "+notification.Target.RankPrc+"%\\"" : notification.Target.Rank %>',
				it: 'Complimenti, ti sei aggiudicato un trofeo per la sfida <%= notification.Target.ChallengeName %>! La tua posizione è <%= notification.Target.RankPrc ? "\\"top "+notification.Target.RankPrc+"%\\"" : notification.Target.Rank %>',
				es: '¡Felicitaciones, has ganado un trofeo para el desafío <%= notification.Target.ChallengeName %>! Su posición es <%= notification.Target.RankPrc ? "\\"top "+notification.Target.RankPrc+"%\\"" : notification.Target.Rank %>',
				fr: 'Félicitations, vous avez remporté un trophée pour le défi <%= notification.Target.ChallengeName %>! Votre position est <%= notification.Target.RankPrc ? "\\"top "+notification.Target.RankPrc+"%\\"" : notification.Target.Rank %>',
			},
			ChallengeAwarded: {
				en: "Trophy Won",
				it: "Trofeo Vinto",
				es: "Trofeo Ganado",
				fr: "Trophée Gagné",
			},
			OrderFulfilled: {
				en: "Purchase",
				it: "Acquisto",
				es: "Compra",
				fr: "Achat",
			},
			UserSubscriptionExpired: {
				en: "Subscription Expired",
				it: "Abbonamento Scaduto",
				es: "Suscripción Caducado",
				fr: "Abonnement Expiré",
			},
			UserSubscriptionExpiredDateUser: {
				en: "Subscription Expired",
				it: "Abbonamento Scaduto",
				es: "Suscripción Caducado",
				fr: "Abonnement Expiré",
			},
			UserSubscriptionExpiredTicketUser: {
				en: "Finished Tickets",
				it: "Ticket Terminati",
				es: "Boletos Terminados",
				fr: "Billets Finis",
			},
			UserSubscriptionExpiredDateManager: {
				en: "Subscription Expired",
				it: "Abbonamento Scaduto",
				es: "Suscripción Caducado",
				fr: "Abonnement Expiré",
			},
			UserSubscriptionExpiredTicketManager: {
				en: "Finished Tickets",
				it: "Ticket Terminati",
				es: "Boletos Terminados",
				fr: "Billets Finis",
			},
			UserSubscriptionExpiring: {
				en: "Expiring Subscription",
				it: "Abbonamento In Scadenza",
				es: "Suscripción Que Expira",
				fr: "Abonnement Expirant",
			},
			UserSubscriptionExpiringDateUser: {
				en: "Expiring Subscription",
				it: "Abbonamento In Scadenza",
				es: "Suscripción Que Expira",
				fr: "Abonnement Expirant",
			},
			UserSubscriptionExpiringTicketUser: {
				en: "Tickets Are About To End",
				it: "Ingressi Quasi Terminati",
				es: "Entradas Casi Terminadas",
				fr: "Entrées Presque Terminées",
			},
			UserSubscriptionExpiringDateManager: {
				en: "Expiring Subscription",
				it: "Abbonamento In Scadenza",
				es: "Suscripción Que Expira",
				fr: "Abonnement Expirant",
			},
			UserSubscriptionExpiringTicketManager: {
				en: "Tickets Are About To End",
				it: "Ingressi Quasi Terminati",
				es: "Entradas Casi Terminadas",
				fr: "Entrées Presque Terminées",
			},
			AthleteExpExpiredMedicalCertificateUser: {
				en: "Expired Medical Certificate",
				it: "Certificato Medico Scaduto",
				es: "Certificado Médico Caducado",
				fr: "Certificat médical expiré",
			},
			AthleteExpExpiredMembershipUser: {
				en: "Expired Membership",
				it: "Iscrizione Scaduta",
				es: "Matrícula Vencida",
				fr: "Inscription Expirée",
			},
			PoliciesNotAccepted: {
				en: "The athlete does not have accepted a required policy",
				it: "L'atleta non ha accettato una policy richiesta",
				es: "El atleta no ha aceptado una política requerida",
				fr: "L'athlète n'a pas accepté une politique requise"
			},
			AthleteExpExpired: {
				en: "Expired Documents",
				it: "Documento Scaduto",
				es: "Documento Expirado",
				fr: "Document Expiré",
			},
			AthleteExpExpiredGenericUser: {
				en: "Expired Documents",
				it: "Documento Scaduto",
				es: "Documento Expirado",
				fr: "Document Expiré",
			},
			AthleteExpExpiredMedicalCertificateManager: {
				en: "Expired Medical Certificate",
				it: "Certificato Medico Scaduto",
				es: "Certificado Médico Caducado",
				fr: "Certificat médical expiré",
			},
			AthleteExpExpiredMembershipManager: {
				en: "Expired Membership",
				it: "Iscrizione Scaduta",
				es: "Matrícula Vencida",
				fr: "Inscription Expirée",
			},
			AthleteExpExpiredGenericManager: {
				en: "Expired Documents",
				it: "Documento Scaduto",
				es: "Documento Expirado",
				fr: "Document Expiré",
			},
			AthleteExpExpiringMedicalCertificateUser: {
				en: "Expiring Medical Certificate",
				it: "Certificato Medico In Scadenza",
				es: "Certificado Médico Que Expira",
				fr: "Certificat médical Expirant",
			},
			AthleteExpExpiringMembershipUser: {
				en: "Expiring Membership",
				it: "Iscrizione In Scadenza",
				es: "Matrícula Que Expira",
				fr: "Inscription Expirant",
			},
			AthleteExpExpiringGenericUser: {
				en: "Expiring Documents",
				it: "Documento In Scadenza",
				es: "DocumentoQue Expira",
				fr: "Document Expirant",
			},
			AthleteExpExpiringMedicalCertificateManager: {
				en: "Expiring Medical Certificate",
				it: "Certificato Medico In Scadenza",
				es: "Certificado Médico Que Expira",
				fr: "Certificat médical Expirant",
			},
			AthleteExpExpiringMembershipManager: {
				en: "Expiring Membership",
				it: "Iscrizione In Scadenza",
				es: "Matrícula Que Expira",
				fr: "Inscription Expirant",
			},
			AthleteExpExpiringGenericManager: {
				en: "Expiring Documents",
				it: "Documento In Scadenza",
				es: "DocumentoQue Expira",
				fr: "Document Expirant",
			},
			"athlete-exp-expiring-medical-certificate-user-tpl": {
				en: "Your medical certificate will expire on <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Don't forget to renew it!",
				it: "Il tuo certificato medico scadrà il giorno <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Non dimenticare di rinnovarlo!",
				es: "Su certificado médico caducará el <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. ¡No olvides renovarlo!",
				fr: "Votre certificat médical expirera le <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. N'oubliez pas de le renouveler !",
			},
			"athlete-exp-expiring-membership-user-tpl": {
				en: "Your membership will expire on <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Don't forget to renew it!",
				it: "La tua iscrizione scadrà il giorno <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Non dimenticare di rinnovarla!",
				es: "Su matrícula caducará el <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. ¡No olvides renovarlo!",
				fr: "Votre inscription expirera le <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. N'oubliez pas de le renouveler !",
			},
			"athlete-exp-expired-medical-certificate-user-tpl": {
				en: "Your medical certificate has expired. Don't forget to renew it!",
				it: "Il tuo certificato medico è scaduto. Non dimenticare di rinnovarlo!",
				es: "Su certificado médico ha caducado. ¡No olvides renovarlo!",
				fr: "Votre certificat médical est expiré. N'oubliez pas de le renouveler !",
			},
			"athlete-exp-expired-medical-certificate-manager-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Medical Certificate expired.",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Certificato Medico scaduto.",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Certificado Medico caducado.",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Certificat Médical expiré.",
			},
			"athlete-exp-expired-membership-user-tpl": {
				en: "Your membership has expired. Don't forget to renew it!",
				it: "La tua iscrizione è scaduta. Non dimenticare di rinnovarla!",
				es: "Su matrícula ha expirado. ¡No olvides renovarlo!",
				fr: "Votre inscription a expiré. N'oubliez pas de le renouveler !",
			},
			"athlete-exp-expired-membership-manager-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Membership expired.",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Iscrizione scaduta.",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Matrícula caducado.",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - Inscription expiré.",
			},
			"athlete-exp-expired-generic-manager-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - <%= notification.Target.Description %> expired.",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - <%= notification.Target.Description %> scaduto.",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - <%= notification.Target.Description %> caducado.",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - <%= notification.Target.Description %> expiré.",
			},
			"athlete-exp-expired-generic-user-tpl": {
				en: "Your document <%= notification.Target.Description %> expired.",
				it: "Il tuo documento <%= notification.Target.Description %> è scaduto.",
				es: "Su documento <%= notification.Target.Description %> ha caducado.",
				fr: "Votre document <%= notification.Target.Description %> a expiré.",
			},
			"user-subscription-expiring-date-user-tpl": {
				en: "Your subscription <%= notification.Target.SubscriptionName %> will expire on <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Don't forget to renew it!",
				it: "Il tuo abbonamento <%= notification.Target.SubscriptionName %> scadrà il giorno <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. Non dimenticare di rinnovarlo!",
				es: "Su suscripción <%= notification.Target.SubscriptionName %> caducará el <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. ¡No olvides renovarlo!",
				fr: "Votre abonnement <%= notification.Target.SubscriptionName %> expirera le <%= moment(notification.Target.ExpirationDate).format(utilities.getMomentDateFormat(notification.DateFormat)) %>. N'oubliez pas de le renouveler !",
			},
			"user-subscription-expiring-ticket-user-tpl": {
				en: "You have only one ticket remaining on your <%= notification.Target.SubscriptionName %> subscription. Don't forget to renew your subscription!",
				it: "Hai un solo ingresso rimanente sul tuo abbonamento <%= notification.Target.SubscriptionName %>. Non dimenticare di rinnovare l’abbonamento!",
				es: "Solo le queda una entrada en su suscripción de <%= notification.Target.SubscriptionName %>. ¡No olvides renovar tu suscripción!",
				fr: "Il ne vous reste qu'un seul ticket sur votre abonnement <%= notification.Target.SubscriptionName %>. N'oubliez pas de renouveler votre abonnement !",
			},
			"user-subscription-expired-date-user-tpl": {
				en: "Your <%= notification.Target.SubscriptionName %> subscription has expired. Don't forget to renew it!",
				it: "Il tuo abbonamento <%= notification.Target.SubscriptionName %> è scaduto. Non dimenticare di rinnovarlo!",
				es: "Su suscripción a <%= notification.Target.SubscriptionName %> ha vencido. ¡No olvides renovarlo!",
				fr: "Votre abonnement <%= notification.Target.SubscriptionName %> a expiré. N'oubliez pas de le renouveler !",
			},
			"user-subscription-expired-ticket-user-tpl": {
				en: "You have no more tickets available on your <%= notification.Target.SubscriptionName %> subscription. Don't forget to renew your subscription!",
				it: "Non hai più ingressi disponibili sul tuo abbonamento <%= notification.Target.SubscriptionName %>. Non dimenticare di rinnovare l’abbonamento!",
				es: "No tiene más entradas disponibles en su suscripción de <%= notification.Target.SubscriptionName %>. ¡No olvides renovar tu suscripción!",
				fr: "Vous n'avez plus de tickets disponibles sur votre abonnement <%= notification.Target.SubscriptionName %>. N'oubliez pas de renouveler votre abonnement !",
			},
			"user-subscription-expired-date-manager-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - The <%= notification.Target.SubscriptionName %> subscription has expired.",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - L'abbonamento <%= notification.Target.SubscriptionName %> è scaduto.",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - La suscripción <%= notification.Target.SubscriptionName %> ha caducado.",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - L'abonnement <%= notification.Target.SubscriptionName %> a expiré.",
			},
			"user-subscription-expired-ticket-manager-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - The <%= notification.Target.SubscriptionName %> subscription has no more tickets.",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - L'abbonamento <%= notification.Target.SubscriptionName %> non ha più ingressi.",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - La suscripción <%= notification.Target.SubscriptionName %>  no tiene más entradas.",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) - L'abonnement <%= notification.Target.SubscriptionName %> n'a plus de tickets.",
			},
			"credits-sub-tpl": {
				en: "<%= notification.Actor.Nickname %> removed <%= notification.Target.Credits %> credits, your new balance is <%= notification.Target.TotalCredits %> credits",
				it: "<%= notification.Actor.Nickname %> ti ha tolto <%= notification.Target.Credits %> crediti, il tuo saldo è <%= notification.Target.TotalCredits %> crediti",
				es: "<%= notification.Actor.Nickname %> eliminó <%= notification.Target.Credits %> créditos, su nuevo saldo es de <%= notification.Target.TotalCredits %> créditos",
				fr: "<%= notification.Actor.Nickname %> a supprimé <%= notification.Target.Credits %> crédits, votre nouveau solde est de <%= notification.Target.TotalCredits %> crédits",
			},
			"credits-add-tpl": {
				en: "<%= notification.Actor.Nickname %> added <%= notification.Target.Credits %> credits, your new balance is <%= notification.Target.TotalCredits %> credits",
				it: "<%= notification.Actor.Nickname %> ti ha aggiunto <%= notification.Target.Credits %> crediti, il tuo saldo è <%= notification.Target.TotalCredits %> crediti",
				es: "<%= notification.Actor.Nickname %> agregó <%= notification.Target.Credits %> créditos, su nuevo saldo es de <%= notification.Target.TotalCredits %> créditos",
				fr: "<%= notification.Actor.Nickname %> a ajouté <%= notification.Target.Credits %> crédits, votre nouveau solde est de <%= notification.Target.TotalCredits %> crédits",
			},
			"class-unsubscription-tpl": {
				en: "<%= notification.Actor.Nickname %> removed you from <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (+ <%= notification.Target.Credits %> credits)<%}%>",
				it: "<%= notification.Actor.Nickname %> ti ha rimosso da <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (+ <%= notification.Target.Credits %> credits)<%}%>",
				es: "<%= notification.Actor.Nickname %> te quitó de <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (+ <%= notification.Target.Credits %> credits)<%}%>",
				fr: "<%= notification.Actor.Nickname %> t'a retiré de <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (+ <%= notification.Target.Credits %> credits)<%}%>",
			},
			"log-class-unsubscription-self-tpl": {
				en: "The user <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) has canceled the reservation for <%= notification.Target.ClassName %> at <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> on <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				it: "L’utente <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) ha cancellato la prenotazione a <%= notification.Target.ClassName %> delle ore <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> del <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				es: "El usuario <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) ha cancelado la reserva de <%= notification.Target.ClassName %> a las <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> horas del día <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				fr: "L'utilisateur <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) a annulé la réservation pour <%= notification.Target.ClassName %> à <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> le <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
			},
			"log-class-unsubscription-tpl": {
				en: "<%= notification.Actor.Nickname %> has removed <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) from <%= notification.Target.ClassName %> at <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> on <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				it: "<%= notification.Actor.Nickname %> ha rimosso <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) da <%= notification.Target.ClassName %> delle ore <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> del <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				es: "<%= notification.Actor.Nickname %> ha eliminado <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) de <%= notification.Target.ClassName %> a las <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> horas del día <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
				fr: "<%= notification.Actor.Nickname %> a supprimé <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) de <%= notification.Target.ClassName %> à <%= utilities.formatTime(notification.Target.ClassDate, userInfo, false) %> le <%= utilities.formatDate(notification.Target.ClassDate, userInfo) %>",
			},
			"class-subscription-tpl": {
				en: "<%= notification.Actor.Nickname %> added you to <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (- <%= notification.Target.Credits %> credits)<%}%>",
				it: "<%= notification.Actor.Nickname %> ti ha aggiunto a <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (- <%= notification.Target.Credits %> credits)<%}%>",
				es: "<%= notification.Actor.Nickname %> te agregó a <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (- <%= notification.Target.Credits %> credits)<%}%>",
				fr: "<%= notification.Actor.Nickname %> vous a ajouté à <%= notification.Target.ClassName %><% if (notification.Target.Credits) {%> (- <%= notification.Target.Credits %> credits)<%}%>",
			},
			"user-measure-expired-first-tpl": {
				en: "Verify your fitness level. Take your first Fitness Test!",
				it: "Verifica il tuo livello di forma. Fai il tuo primo Fitness Test!",
				es: "Verifica tu nivel de entrenamiento. Empieza tu primer Fitness Test!",
				fr: "Vérifiez votre niveau de forme physique. Faites votre premier Test de Condition Physique!",
			},
			"user-measure-expired-tpl": {
				en: "Verify your fitness level. Take your Fitness Test!",
				it: "Verifica il tuo livello di forma. Fai il tuo Fitness Test!",
				es: "Verifica tu nivel de entrenamiento. Empieza tu Fitness Test!",
				fr: "Vérifiez votre niveau de forme physique. Faites votre Test de Condition Physique!",
			},
			"trainer-awards-tpl": {
				en: "New Trainer Points available. Go and award Points to your favorite trainers!",
				it: "Nuovi Trainer Points disponibili. Assegna subito i punti ai tuoi trainer preferiti!",
				es: "Nuevos Trainer Points disponibles. ¡Ve y otorga puntos a tus entrenadores favoritos!",
				fr: "Nouveaux Trainer Points disponibles. Allez attribuer des points à vos entraîneurs préférés!",
			},
			"level-update-tpl": {
				en: "Congrats! You leveled up. Your new Uptivo level is <%= r('UptivoLevel'+notification.Target.Level) %>. The effort you put in has paid off.",
				it: "Congratulazioni! Il tuo nuovo livello Uptivo è <%= r('UptivoLevel'+notification.Target.Level) %>. Il duro lavoro ha dato i suoi frutti.",
				es: "¡Felicitaciones! Tu nivel ha subido. Tu nuevo nivel es <%= r('UptivoLevel'+notification.Target.Level) %>. Tu trabajo duro ha dado sus frutos.",
				fr: "Félicitations! Votre niveau d'uptivo a augmenté. Votre nouveau niveau est <%= r('UptivoLevel'+notification.Target.Level) %>. L'effort que vous avez mis a porté ses fruits.",
			},
			"created-user-tpl": {
				en: "<%= notification.Actor.Nickname %> created user <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha creato l'utente <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> creó a usuario <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a créé l'utilisateur <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			"created-invitation-tpl": {
				en: "<%= notification.Actor.Nickname %> invited <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				it: "<%= notification.Actor.Nickname %> ha invitato <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				es: "<%= notification.Actor.Nickname %> invitó a <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
				fr: "<%= notification.Actor.Nickname %> a invité <%= notification.Target.Nickname %> (<%= notification.Target.Email %>)",
			},
			"user-accepted-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) accepted the invite",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) ha confermato l'invito",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) aceptó la invitación",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) a accepté l'invitation",
			},
			"user-expired-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) did not accept the invite",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) non ha confermato l'invito",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) no aceptó la invitación",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) n'a pas accepté l'invitation",
			},
			"invitation-link-expired-tpl": {
				en: "<%= notification.Target.Email %> did not accept the invite",
				it: "<%= notification.Target.Email %> non ha confermato l'invito",
				es: "<%= notification.Target.Email %> no aceptó la invitación",
				fr: "<%= notification.Target.Email %> n'a pas accepté l'invitation",
			},
			"user-left-club-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) has left the club",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) ha lasciato il club",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) ha dejado el club",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) a quitté le club",
			},
			"removed-from-club-tpl": {
				en: "<%= notification.Actor.Nickname %> removed <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) from the club",
				it: "<%= notification.Actor.Nickname %> ha rimosso <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) dal club",
				es: "<%= notification.Actor.Nickname %> eliminó a <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) desde el club",
				fr: "<%= notification.Actor.Nickname %> a retiré <%= notification.Target.Nickname %> (<%= notification.Target.Email %>) du club",
			},
			"user-is-back-tpl": {
				en: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) is back after <%= notification.Target.Days %> days",
				it: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) è di ritorno dopo <%= notification.Target.Days %> giorni",
				es: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) está de vuelta después de  <%= notification.Target.Days %> días",
				fr: "<%= notification.Target.Nickname %> (<%= notification.Target.Email %>) est de retour après  <%= notification.Target.Days %> jours",
			},
			"workout-program-share-tpl": {
				en: "<%= notification.Actor.Nickname %> shared a Workout Program with you",
				it: "<%= notification.Actor.Nickname %> ti ha condiviso un programma di allenamento",
				es: "<%= notification.Actor.Nickname %> te compartió un programa de entrenamiento",
				fr: "<%= notification.Actor.Nickname %> vous a partagé un programme d'entraînement",
			},
			"club-message-tpl": {
				en: "<%= notification.Target.Title || 'You have a new message from the club!'  %>",
				it: "<%= notification.Target.Title || 'Hai un nuovo messaggio dal club!'  %>",
				es: "<%= notification.Target.Title || '¡Tienes un nuevo mensaje del club!'  %>",
				fr: "<%= notification.Target.Title || 'Vous avez un nouveau message du club!'  %>",
			},
			"started-live-self-tpl": {
				en: "<%= notification.Actor.Nickname %> has started an Uptivo LIVE session",
				it: "<%= notification.Actor.Nickname %> ha avviato una sessione Uptivo LIVE",
				es: "<%= notification.Actor.Nickname %> comenzó una sesión Uptivo LIVE",
				fr: "<%= notification.Actor.Nickname %> a commencé une session Uptivo LIVE",
			},
			"started-live-tpl": {
				en: "<%= notification.Actor.Nickname %> has started an Uptivo LIVE session by <%= notification.Target.Nickname %>",
				it: "<%= notification.Actor.Nickname %> ha avviato la sessione Uptivo LIVE di <%= notification.Target.Nickname %>",
				es: "<%= notification.Actor.Nickname %> comenzó la sesión Uptivo LIVE de <%= notification.Target.Nickname %>",
				fr: "<%= notification.Actor.Nickname %> a commencé la session Uptivo LIVE de <%= notification.Target.Nickname %>",
			},
			"credits-purchase-tpl": {
				en: "<%= notification.Actor.Nickname %> has purchased <%= notification.Target.Credits %> credits",
				it: "<%= notification.Actor.Nickname %> ha acquistato <%= notification.Target.Credits %> crediti",
				es: "<%= notification.Actor.Nickname %> ha comprado <%= notification.Target.Credits %> créditos",
				fr: "<%= notification.Actor.Nickname %> a acheté <%= notification.Target.Credits %> crédits",
			},
			"sub-purchase-tpl": {
				en: "<%= notification.Actor.Nickname %> has purchased the subscription <%= notification.Target.SubscriptionName %>",
				it: "<%= notification.Actor.Nickname %> ha acquistato l’abbonamento <%= notification.Target.SubscriptionName %>",
				es: "<%= notification.Actor.Nickname %> ha comprado la suscripción <%= notification.Target.SubscriptionName %>",
				fr: "<%= notification.Actor.Nickname %> a acheté l'abonnement <%= notification.Target.SubscriptionName %>",
			},
			details: {
				en: "Details",
				it: "Dettagli",
				es: "Detalles",
				fr: "Détails",
			},
			resend: {
				en: "Resend",
				it: "Riprova",
				es: "Reenviar",
				fr: "Envoyer à nouveau",
			},
			UserMeasureExpired: {
				en: "Fitness Test",
				it: "Fitness Test",
				es: "Test de entrenamiento",
				fr: "Test de condition physique",
			},
			CreatedUser: {
				en: "User creation",
				it: "Creazione utente",
				es: "Creación de usuario",
				fr: "Création d'utilisateur",
			},
			PendingUserExpired: {
				en: "Creation expired",
				it: "Creazione scaduta",
				es: "La creación expiró",
				fr: "Création expirée",
			},
			PendingUserAccepted: {
				en: "Creation accepted",
				it: "Creazione accettata",
				es: "Creación aceptada",
				fr: "Création acceptée",
			},
			CreatedInvitation: {
				en: "User invitation",
				it: "Invito utente",
				es: "Invitación de usuario",
				fr: "Invitation d'utilisateur",
			},
			InvitationExpired: {
				en: "Invitation expired",
				it: "Invito scaduto",
				es: "Invitación expirada",
				fr: "Invitation expirée",
			},
			InvitationAccepted: {
				en: "Invitation accepted",
				it: "Invito accettato",
				es: "Invitación aceptada",
				fr: "Invitation acceptée",
			},
			UserLeftClub: {
				en: "User removal",
				it: "Uscita dal club",
				es: "Eliminación de usuario",
				fr: "Suppression d'utilisateur",
			},
			UserIsBack: {
				en: "Athlete Returned",
				it: "Atleta Ritornato",
				es: "Atleta Regresó",
				fr: "Athlète Retiré",
			},
			TrainerAwards: {
				en: "Trainer Points",
				it: "Trainer Points",
				es: "Trainer Points",
				fr: "Trainer Points",
			},
			LevelUpdate: {
				en: "Uptivo Level",
				it: "Livello Uptivo",
				es: "Nivel Uptivo",
				fr: "Niveau Uptivo",
			},
			WorkoutProgramShare: {
				en: "Shared Document",
				it: "Condivisione documento",
				es: "Documento compartido",
				fr: "Document partagé",
			},
			ClubMessage: {
				en: "Club Message",
				it: "Messaggio dal club",
				es: "Mensaje del club",
				fr: "Message du club",
			},
			StartedLive: {
				en: "LIVE start",
				it: "Avvio LIVE",
				es: "Inicio de LIVE",
				fr: "Démarrage de LIVE",
			},
			ClassSubscription: {
				en: "Subscription to Activity",
				it: "Iscrizione ad Attività",
				es: "Suscripción a la Actividad",
				fr: "Inscription à l'activité",
			},
			ClassUnsubscription: {
				en: "Unsubscription from Activity",
				it: "Disiscrizione da Attività",
				es: "Cancelación de la Actividad",
				fr: "Désinscription de l'activité",
			},
			CreditsAdd: {
				en: "Credits Added",
				it: "Aggiunta Crediti",
				es: "Créditos Agregados",
				fr: "Crédits Ajoutés",
			},
			CreditsSub: {
				en: "Credits Removed",
				it: "Rimozione Crediti",
				es: "Créditos Eliminados",
				fr: "Crédits Supprimés",
			},
		},
		PhysicalSettingsView: {
			"bpm-cannot-exceed": {
				en: "Heart rate cannot exceed {0} bpm.",
				it: "I battiti non possono superare {0} bpm.",
				es: "La frecuencia cardíaca no puede exceder de {0} lpm.",
				fr: "La fréquence cardiaque ne peut pas dépasser {0} bpm.",
			},
			"height-min-error": {
				en: "The minimum height is {0}.",
				it: "L'altezza minima è {0}.",
				es: "La altura mínima es de {0}.",
				fr: "La hauteur minimale est de {0}.",
			},
			"height-max-error": {
				en: "The maximum height is {0}.",
				it: "L'altezza massima è {0}.",
				es: "La altura máxima es de {0}.",
				fr: "La hauteur maximale est de {0}.",
			},
		},
		TrainerDetailsView: {
			"trainer-points": {
				en: "Trainer Points",
				it: "Punti del Trainer",
				es: "Puntos del Entrenador",
				fr: "Points d'Entraîneur",
			},
			comments: {
				en: "Comments",
				it: "Commenti",
				es: "Comentarios",
				fr: "Commentaires",
			},
			"no-points-awarded": {
				en: "No points awarded!",
				it: "Nessun punteggio assegnato!",
				es: "¡Sin puntos otorgados!",
				fr: "Aucun point attribué!",
			},
			"watched-athletes": {
				en: "Watched Athletes",
				it: "Utenti seguiti",
				es: "Atletas seguidos",
				fr: "Athlètes suivis",
			},
		},
		RankingsView: {
			"select-dates": {
				en: "Select Dates",
				it: "Seleziona Date",
				es: "Seleccionar Fechas",
				fr: "Sélectionnez Des Dates",
			},
			"last-week": {
				en: "Last Week",
				it: "Settimana Scorsa",
				es: "La semana pasada",
				fr: "La semaine dernière",
			},
			"this-month": {
				en: "This month",
				it: "Questo Mese",
				es: "Este mes",
				fr: "Ce mois",
			},
			"last-month": {
				en: "Last Month",
				it: "Mese Scorso",
				es: "El mes pasado",
				fr: "Le mois dernier",
			},
			"this-year": {
				en: "This Year",
				it: "Quest'anno",
				es: "Este año",
				fr: "Cette année",
			},
			"last-year": {
				en: "Last Year",
				it: "L'anno scorso",
				es: "El año pasado",
				fr: "L'année dernière",
			},
			"last-12-months": {
				en: "Last 12 months",
				it: "Ultimi 12 mesi",
				es: "Últimos 12 meses",
				fr: "12 derniers mois",
			},
			yesterday: {
				en: "Yesterday",
				it: "Ieri",
				es: "Ayer",
				fr: "Hier",
			},
			"end-date-cannot-be-in-future": {
				en: "The end date cannot be in the future",
				it: "La data di fine non può essere nel futuro",
				es: "La fecha de finalización no puede ser futura",
				fr: "La date de fin ne peut pas être dans le futur",
			},
			"end-date-must-be-after-or-equal-start-date": {
				en: "The end date must be after or equal to the start date",
				it: "La data di fine deve essere successiva o uguale alla data di inizio",
				es: "La fecha de finalización debe ser posterior o igual a la fecha de inicio",
				fr: "La date de fin doit être postérieure ou égale à la date de début",
			},
			"selected-interval-cannot-exceed-one-year": {
				en: "The interval cannot be more than 365 days",
				it: "L'intervallo non può essere superiore a 365 giorni",
				es: "El intervalo no puede ser mayor a 365 días",
				fr: "L'intervalle ne peut pas être supérieur à 365 jours",
			},
		},
		TrainersJournalView: {
			"trainers-journal": {
				en: "Trainer's Journal",
				it: "Diario del Trainer",
				es: "Seguimiento del entrenador",
				fr: "Journal de l'entraîneur",
			},
			"view-by-club": {
				en: "View by Club",
				it: "Vista per Club",
				es: "Ver por club",
				fr: "Afficher par Club",
			},
			"view-by-week": {
				en: "View by week",
				it: "Vista settimanale",
				es: "Ver por semana",
				fr: "Afficher par semaine",
			},
			"view-by-user": {
				en: "View by User",
				it: "Vista per Utente",
				es: "Ver por usuario",
				fr: "Afficher par Utilisateur",
			},
			"select-week": {
				en: "Select week",
				it: "Seleziona settimana",
				es: "Seleccionar semana",
				fr: "Sélectionnez la semaine",
			},
			"select-day": {
				en: "Select day",
				it: "Seleziona giorno",
				es: "Seleccionar día",
				fr: "Sélectionnez le jour",
			},
			"no-trainings": {
				en: "No trainings",
				it: "Nessun allenamento",
				es: "No entrenamientos",
				fr: "Aucun entraînement",
			},
			"last-training": {
				en: "Last training",
				it: "Ultimo Allenamento",
				es: "Último entrenamiento",
				fr: "Dernier entraînement",
			},
		},
		TrainingView: {
			"punches-summary": {
				en: "Punches Summary",
				it: "Riepilogo Colpi",
				es: "Resumen de Golpes",
				fr: "Résumé des Coups",
			},
			"minute-breakdown": {
				en: "Breakdown in minutes",
				it: "Ripartizione in minuti",
				es: "Subdivisión en minutos",
				fr: "Répartition en minutes",
			},
			"punches-min": {
				en: "Punches/min",
				it: "Colpi/min",
				es: "Golpes/min",
				fr: "Coups/min",
			},
			punches: {
				en: "Punches",
				it: "Colpi",
				es: "Golpes",
				fr: "Coups",
			},
			selection: {
				en: "Selection",
				it: "Selezione",
				es: "Selección",
				fr: "Sélection",
			},
			"training-range": {
				en: "Interval Type",
				it: "Tipo di intervallo",
				es: "Tipo de intervalo",
				fr: "Type d'intervalle",
			},
			"training-no-comments": {
				en: "The training has not been commented yet.",
				it: "Il training non è ancora stato commentato.",
				es: "El entrenamiento no tiene ningún comentario todavía.",
				fr: "L'entraînement n'a fait l'objet d'aucun commentaire pour l'instant.",
			},
			training: {
				en: "Training",
				it: "Training",
				es: "Entrenamiento",
				fr: "Entraînement",
			},
			"delete-training": {
				en: "Delete training",
				it: "Elimina allenamento",
				es: "Eliminar entrenamiento",
				fr: "Supprimer l'entraînement",
			},
			UnspecifiedType: {
				en: "Training",
				it: "Allenamento",
				es: "Entrenamiento",
				fr: "Entraînement",
			},
			UnspecifiedServiceType: {
				en: "Other Services",
				it: "Altri Servizi",
				es: "Otros Servicios",
				fr: "Autres Services",
			},
			RunningType: {
				en: "Running",
				it: "Corsa",
				es: "Correr",
				fr: "Course",
			},
			CyclingType: {
				en: "Cycling",
				it: "Ciclismo",
				es: "Ciclismo",
				fr: "Vélo",
			},
			WalkingType: {
				en: "Walking",
				it: "Camminata",
				es: "Caminar",
				fr: "Marche",
			},
			MountainBikingType: {
				en: "Mountain Biking",
				it: "Mountain Bike",
				es: "Ciclismo De Montaña",
				fr: "Vélo Tout Terrain",
			},
			CrossCountrySkiingType: {
				en: "Cross Country Skiing",
				it: "Sci Di Fondo",
				es: "Esquí Nórdico",
				fr: "Ski De Fond",
			},
			DownhillSkiingType: {
				en: "Downhill Skiing",
				it: "Sci Alpino",
				es: "Esquí Alpino",
				fr: "Ski Alpin",
			},
			FunctionalTrainingType: {
				en: "Functional Training",
				it: "Allenamento Funzionale",
				es: "Entrenamiento Funcional",
				fr: "Entraînement Fonctionnel",
			},
			RowingType: {
				en: "Rowing",
				it: "Canottaggio",
				es: "Remo",
				fr: "Aviron",
			},
			NordicWalkingType: {
				en: "Nordic Walking",
				it: "Nordic Walking",
				es: "Caminata Nórdica",
				fr: "Marche Nordique",
			},
			SkatingType: {
				en: "Skating",
				it: "Pattinaggio",
				es: "Patinaje",
				fr: "Patinage",
			},
			HikingType: {
				en: "Hiking",
				it: "Trekking",
				es: "Senderismo",
				fr: "Randonnée",
			},
			TennisType: {
				en: "Tennis",
				it: "Tennis",
				es: "Tenis",
				fr: "Tennis",
			},
			SquashType: {
				en: "Squash",
				it: "Squash",
				es: "Squash",
				fr: "Squash",
			},
			WeightTrainingType: {
				en: "Weight Training",
				it: "Pesi",
				es: "Entrenamiento Con Pesas",
				fr: "Musculation",
			},
			OtherWithGPSType: {
				en: "Training With GPS",
				it: "Allenamento Con GPS",
				es: "Entrenamiento Con GPS",
				fr: "Entraînement Avec GPS",
			},
			OtherWithoutGPSType: {
				en: "Other Without GPS",
				it: "Altro Senza GPS",
				es: "Otro Sin GPS",
				fr: "Autre Sans GPS",
			},
			TreadmillRunningType: {
				en: "Treadmill Running",
				it: "Tapis Roulant",
				es: "Correr En La Cinta",
				fr: "Tapis Roulant",
			},
			IndoorCyclingType: {
				en: "Indoor Cycling",
				it: "Indoor Cycling",
				es: "Indoor Cycling",
				fr: "Cardiovélo",
			},
			IndoorWalkingType: {
				en: "Indoor Walking",
				it: "Indoor Walking",
				es: "Indoor Walking",
				fr: "Indoor Walking",
			},
			HIITType: {
				en: "HIIT",
				it: "HIIT",
				es: "HIIT",
				fr: "HIIT",
			},
			IndoorRowingType: {
				en: "Indoor Rowing",
				it: "Indoor Rowing",
				es: "Remo Indoor",
				fr: "Aviron En Salle",
			},
			AquaCyclingType: {
				en: "Aqua Cycling",
				it: "Acqua Biking",
				es: "Aqua Cycling",
				fr: "Aqua Biking",
			},
			WaterAerobicsType: {
				en: "Water Aerobics",
				it: "Acquagym",
				es: "Aqua Fitness",
				fr: "Aquagym",
			},
			YogaType: {
				en: "Yoga",
				it: "Yoga",
				es: "Yoga",
				fr: "Yoga",
			},
			ZumbaType: {
				en: "Zumba",
				it: "Zumba",
				es: "Zumba",
				fr: "Zumba",
			},
			BasketballType: {
				en: "Basketball",
				it: "Pallacanestro",
				es: "Baloncesto",
				fr: "Basketball",
			},
			VolleyballType: {
				en: "Volleyball",
				it: "Pallavolo",
				es: "Vóleibol",
				fr: "Volley-ball",
			},
			KayakType: {
				en: "Kayak",
				it: "Kayak",
				es: "Kayak",
				fr: "Canoë",
			},
			BootcampType: {
				en: "Bootcamp",
				it: "Bootcamp",
				es: "Bootcamp",
				fr: "Bootcamp",
			},
			CalisthenicsType: {
				en: "Calisthenics",
				it: "Calisthenics",
				es: "Calisthenics",
				fr: "Calisthenics",
			},
			ClimbingOutdoorType: {
				en: "Outdoor Climbing",
				it: "Arrampicata All'Aperto",
				es: "Escalada Al Aire Libre",
				fr: "Escalade Extérieur",
			},
			ClimbingIndoorType: {
				en: "Indoor Climbing",
				it: "Arrampicata Indoor",
				es: "Escalada En Interior",
				fr: "Escalade Intérieure",
			},
			CrossfitType: {
				en: "Crossfit",
				it: "Crossfit",
				es: "Crossfit",
				fr: "Crossfit",
			},
			DancingType: {
				en: "Dancing",
				it: "Ballo",
				es: "Danza",
				fr: "Danse",
			},
			EMSType: {
				en: "EMS",
				it: "EMS",
				es: "EMS",
				fr: "EMS",
			},
			FitboxingType: {
				en: "Fitboxing",
				it: "Fitboxing",
				es: "Fitboxing",
				fr: "Fitboxing",
			},
			CombatFitnessType: {
				en: "Combat Fitness",
				it: "Combat Fitness",
				es: "Combat Fitness",
				fr: "Combat Fitness",
			},
			PadelType: {
				en: "Padel",
				it: "Padel",
				es: "Padel",
				fr: "Padel",
			},
			PersonalTrainingType: {
				en: "Personal Training",
				it: "Personal Training",
				es: "Entrenamiento Personal",
				fr: "Entrainement Personnele",
			},
			PilatesType: {
				en: "Pilates",
				it: "Pilates",
				es: "Pilates",
				fr: "Pilates",
			},
			SwimmingType: {
				en: "Swimming",
				it: "Nuoto",
				es: "Natación",
				fr: "Natation",
			},
			TrampolineType: {
				en: "Trampoline",
				it: "Trampolino",
				es: "Trampolín",
				fr: "Trampoline",
			},
			PoleDanceType: {
				en: "Pole Dance",
				it: "Pole Dance",
				es: "Pole Dance",
				fr: "Pole Dance",
			},
			GAGType: {
				en: "ABT",
				it: "GAG",
				es: "Abdominales",
				fr: "Jambes, Abdominaux et Fesses",
			},
			EllipticalType: {
				en: "Elliptical",
				it: "Ellittica",
				es: "Elíptica",
				fr: "Elliptique",
			},
			SoccerType: {
				en: "Football (Soccer)",
				it: "Calcio",
				es: "Fútbol",
				fr: "Football",
			},
			HorseRidingType: {
				en: "Horse Riding",
				it: "Equitazione",
				es: "Equitación",
				fr: "Équitation",
			},
			DressageType: {
				en: "Dressage",
				it: "Dressage",
				es: "Dressage",
				fr: "Dressage",
			},
			ShowJumpingType: {
				en: "Show Jumping",
				it: "Salto A Ostacoli",
				es: "Salto Ecuestre",
				fr: "Saut d'Obstacles",
			},
			PosturalType: {
				en: "Postural",
				it: "Posturale",
				es: "Postural",
				fr: "Postural",
			},
			FencingType: {
				en: "Fencing",
				it: "Scherma",
				es: "Esgrima",
				fr: "Escrime",
			},
			StrafitType: {
				en: "Strafit",
				it: "Strafit",
				es: "Strafit",
				fr: "Strafit",
			},
			ZRFitType: {
				en: "ZR FitBoxing",
				it: "ZR FitBoxing",
				es: "ZR FitBoxing",
				fr: "ZR FitBoxing",
			},
			ZRStrongType: {
				en: "ZR BootCamp",
				it: "ZR BootCamp",
				es: "ZR BootCamp",
				fr: "ZR BootCamp",
			},
			ZRBoosterType: {
				en: "ZR Booster",
				it: "ZR Booster",
				es: "ZR Booster",
				fr: "ZR Booster",
			},
			ZRBilanInBodyType: {
				en: "ZR Bilan InBody",
				it: "ZR Bilan InBody",
				es: "ZR Bilan InBody",
				fr: "ZR Bilan InBody",
			},
			ZRHypericeExperienceType: {
				en: "ZR Hyperice Experience",
				it: "ZR Hyperice Experience",
				es: "ZR Hyperice Experience",
				fr: "ZR Hyperice Experience",
			},
			SwitchingType: {
				en: "Switching",
				it: "Switching",
				es: "Switching",
				fr: "Switching",
			},
			GolfType: {
				en: "Golf",
				it: "Golf",
				es: "Golf",
				fr: "Golf",
			},
			BlastJumpType: {
				en: "Blast Jump",
				it: "Blast Jump",
				es: "Blast Jump",
				fr: "Blast Jump",
			},
			BoxingType: {
				en: "Boxing",
				it: "Boxing",
				es: "Boxing",
				fr: "Boxing",
			},
			HybridTrainingType: {
				en: "Hybrid Training",
				it: "Allenamento Ibrido",
				es: "Entrenamiento Híbrido",
				fr: "Entraînement Hybride",
			},
			ATHXType: {
				en: "ATHX",
				it: "ATHX",
				es: "ATHX",
				fr: "ATHX",
			},
			"hr-zone0-name": {
				en: "Resting",
				it: "Riposo",
				es: "Descanso",
				fr: "Repos",
			},
			"hr-zone1-name": {
				en: "Moderate Effort",
				it: "Intensità Moderata",
				es: "Esfuerzo Moderado",
				fr: "Effort Modéré",
			},
			"hr-zone2-name": {
				en: "Weight Control",
				it: "Controllo Peso",
				es: "Control de peso",
				fr: "Contrôle du poids",
			},
			"hr-zone3-name": {
				en: "Aerobic",
				it: "Aerobico",
				es: "Aeróbico",
				fr: "Aérobie",
			},
			"hr-zone4-name": {
				en: "Anaerobic",
				it: "Anaerobico",
				es: "Anaeróbico",
				fr: "Anaérobie",
			},
			"hr-zone5-name": {
				en: "Maximum Effort",
				it: "Massima Intensità",
				es: "Esfuerzo Máximo",
				fr: "Effort Maximal",
			},
			elevation: {
				en: "Elevation",
				it: "Altitudine",
				es: "Altitud",
				fr: "Altitude",
			},
			grade: {
				en: "Grade",
				it: "Pendenza",
				es: "Pendiente",
				fr: "Pente",
			},
			"heart-rate": {
				en: "Heart Rate",
				it: "Frequenza cardiaca",
				es: "Frecuencia cardíaca",
				fr: "Fréquence cardiaque",
			},
			"route-info": {
				en: "Route Information",
				it: "Informazioni percorso",
				es: "Información de ruta",
				fr: "Informations itinéraire",
			},
			"link-copied": {
				en: "Link copied!",
				it: "Link copiato!",
				es: "Enlace copiado!",
				fr: "Lien copié!",
			},
			"copy-link": {
				en: "Copy Link",
				it: "Copia Link",
				es: "Copiar Link",
				fr: "Copier Lien",
			},
			"insert-email": {
				en: "Insert Email",
				it: "Inserisci Email",
				es: "Insertar Email",
				fr: "Insérer Email",
			},
		},
		UserBasicDataModalView: {
			welcome: {
				en: "Welcome to Uptivo",
				it: "Benvenuto in Uptivo",
				es: "Bienvenido a Uptivo",
				fr: "Bienvenue dans Uptivo",
			},
			"date-of-birth": {
				en: "Date of Birth",
				it: "Data di Nascita",
				es: "Fecha de nacimiento",
				fr: "Date de naissance",
			},
		},
		UserGroupsView: {
			"user-groups": {
				en: "User Groups",
				it: "Gruppi Utenti",
				es: "Grupos de usuario",
				fr: "Groupes d'utilisateurs",
			},
			members: {
				en: "Members",
				it: "Membri",
				es: "Miembros",
				fr: "Membres",
			},
		},
		ClubDeleteModalView: {
			"info-text": {
				en: "To proceed please type <b>{0}</b> below",
				it: "Per procedere scrivi <b>{0}</b> nel campo sottostante",
				es: "Para proceder, por favor escriba <b>{0}</b> abajo",
				fr: "Pour continuer, saisir <b>{0}</b> ci-dessous",
			},
			"warning-text": {
				en: "You are about to delete the club and its association to devices and users <b>PERMANENTLY</b>.",
				it: "Stai per eliminare il club e tutte le associazioni del club a utenti e device in modo <b>PERMANENTE</b>.",
				es: "Está a punto de eliminar el club y su asociación a dispositivos y usuarios <b>PERMANENTEMENTE</b>.",
				fr: "Vous êtes sur le point de supprimer le club et son association avec les appareils et utilisateurs <b>DE FAÇON PERMANENTE</b>.",
			},
			"club-name": {
				en: "Club Name",
				it: "Nome Club",
				es: "Nombre del club",
				fr: "Nom du club",
			},
		},
		CustomBindings: {
			search: {
				en: "Search",
				it: "Cerca",
				es: "Buscar",
				fr: "Recherche",
			},
			"max-heart-rate": {
				en: "Max Heart Rate",
				it: "Max Battiti",
				es: "Frecuencia cardíaca máxima",
				fr: "Fréquence cardiaque max.",
			},
		},
		VideosView: {
			"will-delete-video": {
				en: "This video will be deleted.",
				it: "Questo video sarà cancellato.",
				es: "Este vÍdeo será eliminado.",
				fr: "Cette vidéo sera supprimée.",
			},
			"no-videos-in-list": {
				en: "Your list of videos is empty!",
				it: "La tua lista di video è vuota!",
				es: "¡Su lista de vÍdeos está vacía!",
				fr: "Votre liste de vidéos est vide!",
			},
		},
		AppVersionManager: {
			"new-version-title": {
				en: "New version",
				it: "Nuova versione",
				es: "Nueva versión",
				fr: "Nouvelle version",
			},
			"new-version-description": {
				en: "A new version of Uptivo Cloud is available. It is recommended that you reload the page.",
				it: "È disponibile una nuova versione di Uptivo Cloud. Si raccomanda di ricaricare la pagina.",
				es: "Una nueva versión de Uptivo Cloud está disponible. Se recomienda que recargue la página.",
				fr: "Une nouvelle version d'Uptivo Cloud est disponible. Il est recommandé de rafraîchir la page.",
			},
			reload: {
				en: "Reload",
				it: "Ricarica",
				es: "Recargar",
				fr: "Rafraîchir",
			},
			later: {
				en: "Later",
				it: "Più tardi",
				es: "Más tarde",
				fr: "Plus tard",
			},
		},
		LiveTrainingsView: {
			"join-live-training": {
				en: "Join Training as host",
				it: "Partecipa come host",
				es: "Comienzo Live Training",
				fr: "Début Live Training",
			},
			"training-list": {
				en: "Training List",
				it: "Lista Allenamenti",
				es: "Lista De Entrenamiento",
				fr: "Liste Des Entrainement",
			},
			"recurrent-live-trainings": {
				en: "Template Allenamenti Live",
				it: "Live Trainings Template",
				es: "Live Trainings Template",
				fr: "Live Trainings Template",
			},
			"participant-limit-exceeded": {
				en: "Participant limit exceeded",
				it: "Limite partecipanti superato",
				es: "Límite de participantes excedido",
				fr: "Limite de participants dépassée",
			},
			"total-selected-athletes": {
				en: "Total selected athletes: ",
				it: "Atleti totali selezionati: ",
				es: "Total de atletas seleccionados: ",
				fr: "Total des athlètes sélectionnés: ",
			},
			"participants-max": {
				en: "Athletes/Max",
				it: "Atleti/max",
				es: "Deportistas/max",
				fr: "Athlètes/max",
			},
			"elapsed-time": {
				en: "Elapsed Time",
				it: "Tempo Trascorso",
				es: "Tiempo Transcurrido",
				fr: "Temps Ecoulé",
			},
			"delete-live-training": {
				en: "Delete Live Training",
				it: "Cancella Live Training",
				es: "Crear Live Training",
				fr: "Eliminar entrenamiento en vivo",
			},
			"remove-invitation-confirm": {
				en: "You are about to remove ",
				it: "Stai per rimuovere ",
				es: "Estás a punto de eliminar ",
				fr: "Vous êtes sur le point de supprimer ",
			},
			"max-live-training-number-reached": {
				en: "Maximum number of live training reached for the club",
				it: "Numero massimo di live training raggiunto per il club",
				es: "Número máximo de entrenamiento en vivo alcanzado para el club",
				fr: "Nombre maximum de entrainement en direct atteint pour le club",
			},
		},
		UptivoLIVEView: {
			"training-list": {
				en: "Training List",
				it: "Lista Allenamenti",
				es: "Lista De Entrenamiento",
				fr: "Liste Des Entrainement",
			},
			"uptivo-live-not-available": {
				en: "Uptivo LIVE is not available",
				it: "Uptivo LIVE non disponibile",
				es: "Uptivo LIVE no está disponible",
				fr: "Uptivo LIVE n'est pas disponible",
			},
			"uptivo-live-not-enabled-club": {
				en: "Uptivo LIVE is not enabled for the selected club.",
				it: "Uptivo LIVE non è attivo nel il club selezionato.",
				es: "Uptivo LIVE no está habilitado para el club seleccionado.",
				fr: "Uptivo LIVE n'est pas activé pour le club sélectionné.",
			},
			"cannot-delete-running-trainer": {
				en: "Unable to cancel training while running",
				it: "Impossibile cancellare il training mentre è in corso",
				es: "No se puede cancelar el entrenamiento mientras se ejecuta",
				fr: "Impossible d'annuler l'entraînement pendant la course",
			},
			"cannot-delete-running-trainer-participants": {
				en: "Unable to cancel training participants while running",
				it: "Impossibile cancellare i partecipanti di un training mentre è in corso",
				es: "No se puede cancelar la capacitación de los participantes mientras se ejecuta",
				fr: "Impossible d'annuler les participants à l' entraînement pendant la course",
			},
			"running-status": {
				en: "Running",
				it: "In corso",
				es: "Corriendo",
				fr: "Fonctionnement",
			},
			"stopped-status": {
				en: "Stopped",
				it: "Fermo",
				es: "Detenido",
				fr: "Arrêté",
			},
			"remove-participants": {
				en: "Do you want to remove all participants from the LIVE session?",
				it: "Vuoi rimuovere tutti i partecipanti dalla sessione LIVE?",
				es: "¿Desea eliminar a todos los participantes de la sesión LIVE?",
				fr: "Voulez-vous supprimer tous les participants de la session LIVE?",
			},
			"delete-uptivo-live": {
				en: "You are about to delete",
				it: "Stai per cancellare",
				es: "Estás a punto de cancelar",
				fr: "Vous êtes sur le point d'annuler",
			},
		},
		UptivoLIVEtrainingView: {
			"training-list": {
				en: "Training List",
				it: "Lista Allenamenti",
				es: "Lista De Entrenamiento",
				fr: "Liste Des Entrainement",
			},
			"no-trainer-selected": {
				en: "No Trainer Selected",
				it: "Trainer Non Selezionato",
				es: "No Hay Entrenador Seleccionado",
				fr: "Aucun Entraîneur Sélectionné",
			},
			"participants-max": {
				en: "Participants/max",
				it: "Partecipanti/max",
				es: "Participantes/max",
				fr: "Participants/max",
			},
			"add-live-training": {
				en: "Add Live Training",
				it: "Aggiungi Allenamento Live",
				es: "Editar Entrenamiento En Vivo",
				fr: "Ajouter Entraînement en direct",
			},
			"edit-live-training": {
				en: "Edit Live Training",
				it: "Modifica Allenamento Live",
				es: "Agregar Entrenamiento En Vivo",
				fr: "Modifier Entraînement En Direct",
			},
			"subscription-type": {
				en: "Subscription Type*",
				it: "Tipo Di Iscrizione*",
				es: "Tipo De Registro*",
				fr: "Type D'Inscription*",
			},
			"save-to-generate-id": {
				en: "Create LIVE to generate",
				it: "Crea il LIVE per generarlo",
				es: "Crea el LIVE para generarlo",
				fr: "Créez le LIVE pour le générer",
			},
		},
		ClubClassView: {
			Sun: {
				en: "Sun",
				it: "Dom",
				es: "Dom",
				fr: "Dim",
			},
			Mon: {
				en: "Mon",
				it: "Lun",
				es: "Lun",
				fr: "Lun",
			},
			Tue: {
				en: "Tue",
				it: "Mar",
				es: "Mar",
				fr: "Mar",
			},
			Wed: {
				en: "Wed",
				it: "Mer",
				es: "Mié",
				fr: "Mer",
			},
			Thu: {
				en: "Thu",
				it: "Gio",
				es: "Jue",
				fr: "Jeu",
			},
			Fri: {
				en: "Fri",
				it: "Ven",
				es: "Vie",
				fr: "Ven",
			},
			Sat: {
				en: "Sat",
				it: "Sab",
				es: "Sáb",
				fr: "Sam",
			},
			"class-description": {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			picture: {
				en: "Picture",
				it: "Immagine",
				es: "Imagen",
				fr: "Image",
			},
			"invite-booking-mode": {
				en: "Invite",
				it: "A Invito",
				es: "Invitación",
				fr: "Invitation",
			},
			"open-booking-mode": {
				en: "Bookable",
				it: "Prenotabile",
				es: "Reservable",
				fr: "Réservable",
			},
			"not-bookable-booking-mode": {
				en: "Free",
				it: "Libero",
				es: "Libre",
				fr: "Libre",
			},
			"external-booking-mode": {
				en: "External APP Link",
				it: "Link APP Esterna",
				es: "Link APP Externa",
				fr: "Lien APP Externe",
			},
			"cannot-change-bookingmode-not-bookable": {
				en: "Impossible to change the booking method to 'Open' because there are already participants.",
				it: "Impossibile cambiare la modalità di prenotazione su 'Aperto' perchè sono già presenti dei partecipanti.",
				es: "Imposible cambiar el método de reserva a 'Abierto' porque ya hay participantes.",
				fr: "Impossible de changer la méthode de réservation en Ouvert car il y a déjà des participants.",
			},
			"max-slots": {
				en: "Available Places",
				it: "Posti Max",
				es: "Plazas Disponibles",
				fr: "Places Disponibles",
			},
			schedule: {
				en: "Schedule",
				it: "Programmazione",
				es: "Programación",
				fr: "Programmation",
			},
			"add-new-dates": {
				en: "Add New Dates",
				it: "Aggiungi",
				es: "Añadir",
				fr: "Ajouter",
			},
			"generated-activities": {
				en: "Generated Activities",
				it: "Lista Attività",
				es: "Actividades",
				fr: "Planning",
			},
			"lesson-schedule": {
				en: "Lesson Schedule",
				it: "Programmazione ",
				es: "Programación",
				fr: "Programmation",
			},
			"create-class": {
				it: "Crea Attività",
				en: "Create Activity",
				es: "Crear actividad",
				fr: "Créer activité",
			},
			delete: {
				en: "Delete",
				it: "Elimina",
				es: "Eliminar",
				fr: "Supprimer",
			},
			type: {
				en: "Type",
				it: "Tipo",
				es: "Tipo",
				fr: "Type",
			},
			start: {
				en: "From",
				it: "Da",
				es: "Desde",
				fr: "De",
			},
			end: {
				en: "To",
				it: "Fino a",
				es: "Hasta",
				fr: "Jusqu'à",
			},
			"schedule-limit-reached": {
				en: "Impossible to schedule other dates. Limit reached.",
				it: "Impossibile programmare altre date. Limite raggiunto.",
				es: "Imposible programar otras fechas. Límite alcanzado.",
				fr: "Impossible de programmer d'autres dates. Limite atteinte.",
			},
			"need-at-least-one-place": {
				en: "You must enter at least one seat available locally or remotely",
				it: "Devi inserire almeno un posto disponibile sul posto o in remoto",
				es: "Debe ingresar al menos un asiento disponible localmente o en línea",
				fr: "Vous devez saisir au moins un siège disponible localement ou à distance",
			},
			"trainer-must-be-registered": {
				en: "To enable LIVE you need to select a trainer registered in your club",
				it: "Per abilitare i LIVE devi selezionare un trainer registrato nel tuo club",
				es: "Para habilitar LIVE necesitas seleccionar un entrenador registrado en tu club",
				fr: "Pour activer LIVE, vous devez sélectionner un entraîneur inscrit dans votre club",
			},
			"activity-succesfully-updated": {
				en: "Activity succesfully updated",
				it: "Attività aggiornata correttamente",
				es: "Actividad actualizada con éxito",
				fr: "Activité mise à jour avec succès",
			},
			"schedule-not-generate-event": {
				en: "Schedule does not generate valid events",
				it: "La programmazione impostata non genera nessun evento valido",
				es: "La programación no genera eventos válidos",
				fr: "La planification ne génère pas d'événements valides",
			},
			"cannot-unpublish-if-participants": {
				en: "It is not possible to change the activation status if participants are present",
				it: "Non è possibile cambiare lo stato di attivazione se sono presenti dei partecipanti",
				es: "No es posible cambiar el estado de activación si hay participantes",
				fr: "Il n'est pas possible de changer le statut d'activation s'il y a des participants",
			},
			updated: {
				en: "Updated",
				it: "Aggiornato/a",
				es: "Actualizado/a",
				fr: "Actualisé",
			},
			"confirm-remove-date": {
				en: "You are about to remove the following date from programming ",
				it: "Stai per rimuovere la seguente data dalla programmazione ",
				es: "Está a punto de eliminar la siguiente fecha de la programación ",
				fr: "Vous êtes sur le point de supprimer la date suivante de la programmation",
			},
			"must-have-one-schedule": {
				en: "You must enter at least one event in the schedule",
				it: "Devi inserire almeno un evento nella programmazione",
				es: "Debes ingresar al menos un evento en el horario",
				fr: "Vous devez saisir au moins un événement dans le calendrier",
			},
			"schedule-contains-invalid-dates": {
				en: "The schedule contains invalid dates",
				it: "La programmazione contiene date non valide",
				es: "La programación contiene fechas inválidas",
				fr: "La programmation contient des dates non valides",
			},
			"schedule-contains-invalid-dates-end-earlier": {
				en: "The schedule contains an end date that is earlier than a start date",
				it: "La programmazione contiene una data di fine antecedente a una data di inizio",
				es: "La programación contiene una fecha de finalización anterior a la fecha de inicio",
				fr: "La programmation contient une date de fin antérieure à une date de début",
			},
			"schedule-contains-invalid-start-time": {
				en: "The schedule contains an invalid start time",
				it: "La programmazione contiene un' ora di inizio non valida",
				es: "La programación contiene una hora de inicio no válida.",
				fr: "La programmation contient une heure de début invalide",
			},
			"schedule-contains-invalid-duration": {
				en: "The schedules must contain a duration between 10 and 240",
				it: "Le programmazioni devono contenere una durata compresa fra 10 e 240",
				es: "La programación debe contener una duración entre 10 y 240",
				fr: "La programmation doit contenir une durée comprise entre 10 et 240",
			},
			"schedule-exceeded-maximum-months": {
				en: "Schedule has exceeded the maximum number of months: ",
				it: "La programmazione ha superato il numero massimo di mesi: ",
				es: "La programación ha excedido el número máximo de meses: ",
				fr: "La programmation a dépassé le nombre maximum de mois: ",
			},
			"all-schedule-date-in-past": {
				en: "The schedule contains all dates in the past",
				it: "La programmazione contiene tutte date nel passato",
				es: "El horario contiene todas las fechas en el pasado",
				fr: "Le calendrier contient toutes les dates du passé",
			},
			"lesson-schedule-end-date-in-past": {
				en: "The end date of the lesson cannot be in the past",
				it: "La data di fine della lezione non può essere nel passato",
				es: "La fecha de finalización de la lección no puede ser anterior a la anterior",
				fr: "La date de fin de la leçon ne peut pas être dans le passé",
			},
			"calendar-visibility-must-be-greater-booking-before": {
				en: "'Calendar Visibility' must be greater or equal than 'Booking Before'",
				it: "'Visibilità Calendario' deve essere maggiore o uguale di 'Prenota Entro'",
				es: "'Calendrier Visibilidad' debe ser mayor o igual que la 'Reserva Antes'",
				fr: "'Visibilité Calendario' doit être supérieure ou égale à 'Réservation Avant'",
			},
			"booking-before-must-be-greater-cancel-before": {
				en: "'Booking Before' must be greater or equal than 'Cancel Before'",
				it: "'Prenota Entro' deve essere maggiore o uguale di 'Disdici Entro'",
				es: "'Reserva Antes' debe ser mayor o igual que la 'Cancelas Antes'",
				fr: "'Réservation Avant' doit être supérieure ou égale à 'Annuler Avant'",
			},
			"booking-before-must-be-greater-than-max-cancel-before": {
				en: "The 'Booking Before' value entered conflicts with the 'Cancel Before' value of some lessons. Insert a value greater than or equal to {0}",
				it: "Il valore di 'Prenota Entro' inserito va in conflitto con il valore di 'Disdici Entro' di alcune lezioni. Inserire un volore maggiore o uguale a {0}",
				es: "El valor 'Reserva antes' ingresado entra en conflicto con el valor 'Cancelar antes' de algunas lecciones. Inserte un valor mayor o igual que {0}",
				fr: "La valeur 'Réservation avant' entrée est en conflit avec la valeur 'Annuler avant' de certaines training. Insérez une valeur supérieure ou égale à {0}",
			},
			"cancel-before-must-be-minor-than-min-booking-before": {
				en: "The 'Cancel Before' value entered conflicts with the 'Booking Before' value of some lessons. Insert a value less than or equal to {0}",
				it: "Il valore di 'Disdici Entro' inserito va in conflitto con il valore di 'Prenota Entro' di alcune lezioni. Inserire un volore minore o uguale a {0}",
				es: "El valor 'Cancelar antes' ingresado entra en conflicto con el valor 'Reservar antes' de algunas lecciones. Inserte un valor menor o igual que {0}",
				fr: "La valeur 'Annuler avant' entrée entre en conflit avec la valeur 'Réservation avant' de certaines training. Insérer une valeur inférieure ou égale à {0}",
			},
			"max-schedule-begin-in-future-days-error": {
				en: "You cannot schedule activities beyond six months into the future",
				it: "Non puoi programmare attività oltre sei mesi nel futuro",
				es: "No puede programar actividades más allá de seis meses en el futuro",
				fr: "Vous ne pouvez pas planifier d'activités au-delà de six mois dans le futur",
			},
			"max-global-duration-days-error": {
				en: "You cannot schedule activities with a total duration of more than 370 days",
				it: "Non puoi programmare attività con una durata totale superiore a 370 giorni",
				es: "No puede programar actividades con una duración total de más de 370 días",
				fr: "Vous ne pouvez pas planifier d'activités d'une durée totale supérieure à 370 jours",
			},
			"confirm-publish-lesson-template": {
				en: "You are generating a single lesson for each scheduled event.",
				it: "Stai generando una singola lezione per ogni evento programmato.",
				es: "Estás generando una sola lección para cada evento programado.",
				fr: "Vous générez une seule leçon pour chaque événement programmé.",
			},
			"cannot-delete-activity-in-the-past": {
				en: "Unable to delete an activity in the past",
				it: "Impossibile cancellare un'attività nel passato",
				es: "No se pudo borrar una actividad en el pasado",
				fr: "Impossible de supprimer une activité dans le passé",
			},
			"class-is-unpublished-cannot-edit-participants": {
				en: "Activate the activity in order to add/remove participants",
				it: "Attiva l'attività per aggiungere/rimuovere partecipanti",
				es: "Activar la actividad para agregar/quitar participantes.",
				fr: "Activer l'activité pour ajouter/supprimer des participants",
			},
			"class-has-no-participants": {
				en: "The activity has no participants",
				it: "L'attività non ha nessun partecipante",
				es: "La actividad no tiene participantes",
				fr: "L'activité n'a pas de participants",
			},
			"live-unavailable": {
				en: "Unavailable",
				it: "Non disponibile",
				es: "Indisponible",
				fr: "Indisponible",
			},
			"full-day": {
				en: "Full Day",
				it: "Giornata Intera",
				es: "Día Completo",
				fr: "Journée Complète",
			},
			"free-access": {
				en: "Free Access",
				it: "Accesso Libero",
				es: "Acceso Libre",
				fr: "Accès Libre",
			},
			"personal-trainer": {
				en: "Personal Trainer",
				it: "Personal Trainer",
				es: "Personal Trainer",
				fr: "Personal Trainer",
			},
			"personal-trainer": {
				en: "Personal Trainer",
				it: "Personal Trainer",
				es: "Personal Trainer",
				fr: "Personal Trainer",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti obbligatori",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"edit-subscriptions": {
				en: "Edit Subscriptions",
				it: "Modifica Abbonamenti",
				es: "Editar Suscripciones",
				fr: "Modification Abonnements",
			},
			"select-subscriptions": {
				en: "Select Subscriptions",
				it: "Seleziona Abbonamenti",
				es: "Seleccione Suscripciones",
				fr: "Sélectionnez Abonnements",
			},
			"error-increase-onsite-participants-because-class-has-queue": {
				en: "Impossible to increase the number of seats available in presence because there are participants in the queue",
				it: "Impossibile aumentare i posti disponibili in presenza perchè ci sono partecipanti in coda",
				es: "Es imposible aumentar el número de asientos disponibles en presencia porque hay participantes en la cola",
				fr: "Il est impossible d'augmenter le nombre de places disponibles en présence car il y a des participants dans la file d'attente",
			},
			"error-increase-remote-participants-because-class-has-queue": {
				en: "Impossible to increase the number of seats available in remote because there are participants in the queue",
				it: "Impossibile aumentare i posti disponibili da remoto perchè ci sono partecipanti in coda",
				es: "Es imposible aumentar el número de asientos disponibles de forma remota porque hay participantes en la cola.",
				fr: "Il est impossible d'augmenter le nombre de places disponibles à distance car il y a des participants dans la file d'attente",
			},
		},
		ClubClassesView: {
			"club-activities": {
				en: "Club Activities",
				it: "Attività del Club",
				es: "Actividades del Club",
				fr: "Planning Du Club",
			},
			"add-new-course": {
				en: "Add Course",
				it: "Aggiungi Corso",
				es: "Agregar Curso",
				fr: "Ajouter Évènements",
			},
			"add-new-class": {
				en: "Add Lessons",
				it: "Aggiungi Lezioni",
				es: "Agregar Lecciones",
				fr: "Ajouter Des Training",
			},
			when: {
				en: "When",
				it: "Quando",
				es: "Cuando",
				fr: "Quand",
			},
			"onsite-credits": {
				en: "Credits for on-site registration: ",
				it: "Crediti per iscrizione in presenza: ",
				es: "Créditos por registro en el sitio: ",
				fr: "Crédits pour inscription sur place: ",
			},
			"home-credits": {
				en: "Credits for home registration: ",
				it: "Crediti per iscrizione online: ",
				es: "Créditos por registro en linea: ",
				fr: "Crédits pour inscription en ligne: ",
			},
			"onsite-tickets": {
				en: "Tickets for on-site registration: ",
				it: "Ingressi per iscrizione in presenza: ",
				es: "Tickets por registro en el sitio: ",
				fr: "Tickets pour inscription sur place: ",
			},
			"home-tickets": {
				en: "Tickets for home registration: ",
				it: "Ingressi per iscrizione online: ",
				es: "Tickets por registro en linea: ",
				fr: "Tickets pour inscription en ligne: ",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti obbligatori",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"class-description": {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			"max-slots": {
				en: "Available Places",
				it: "Posti Max",
				es: "Plazas Disponibles",
				fr: "Places Disponibles",
			},
			"selected-activities": {
				en: "selected activities",
				it: "attività selezionate",
				es: "actividades seleccionadas",
				fr: "activités sélectionnées",
			},
		},
		PersonalTrainersView: {
			"personal-trainers": {
				en: "Personal Trainers",
				it: "Personal Trainers",
				es: "Personal Trainers",
				fr: "Personal Trainers",
			},
			"add-single-lesson": {
				en: "Add Single Lesson",
				it: "Aggiungi Lezione Singola",
				es: "Agregar Lección De Sigle",
				fr: "Ajouter Une Seule Leçon",
			},
			"add-lessons": {
				en: "Add Lessons",
				it: "Aggiungi Lezioni",
				es: "Agregar Lecciones",
				fr: "Ajouter Des Training",
			},
			"repeat-for": {
				en: "Repeat For",
				it: "Ripeti Per",
				es: "Repetir Para",
				fr: "Répéter Pour",
			},
			"repeat-every": {
				en: "Repeat Every",
				it: "Ripeti Ogni",
				es: "Repetir Cada",
				fr: "Répéter Chaque",
			},
			when: {
				en: "When",
				it: "Quando",
				es: "Cuando",
				fr: "Quand",
			},
			"onsite-credits": {
				en: "Credits for on-site registration: ",
				it: "Crediti per iscrizione sul posto: ",
				es: "Créditos por registro en el sitio: ",
				fr: "Crédits pour inscription sur place: ",
			},
			"home-credits": {
				en: "Credits for home registration: ",
				it: "Crediti per iscrizione online: ",
				es: "Créditos por registro en linea: ",
				fr: "Crédits pour inscription en ligne: ",
			},
			location: {
				en: "Location",
				it: "Luogo",
				es: "Sitio",
				fr: "Lieu",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti obbligatori",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"class-description": {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			"max-slots": {
				en: "Available Places",
				it: "Posti Max",
				es: "Plazas Disponibles",
				fr: "Places Disponibles",
			},
			"pt-lesson": {
				en: "PT lesson",
				it: "Lezione PT",
				es: "Lección PT",
				fr: "Leçon TP",
			},
			"add-new-pt-lesson": {
				en: "Add New PT Lesson",
				it: "Aggiungi Nuova Lezione PT",
				es: "Agregar Nueva Lección De PT",
				fr: "Ajouter Une Nouvelle Leçon PT",
			},
		},
		ServicesView: {
			"add-service": {
				en: "Add Single Service",
				it: "Aggiungi Singolo Servizio",
				es: "Agregar Servicio Unico",
				fr: "Ajouter Service Unique",
			},
			"add-services": {
				en: "Add Services",
				it: "Aggiungi Servizi",
				es: "Agregar Servicios",
				fr: "Ajouter Services",
			},
			service: {
				en: "Service",
				it: "Servizio",
				es: "Servicio",
				fr: "Service",
			},
			"repeat-for": {
				en: "Repeat For",
				it: "Ripeti Per",
				es: "Repetir Para",
				fr: "Répéter Pour",
			},
			"repeat-every": {
				en: "Repeat Every",
				it: "Ripeti Ogni",
				es: "Repetir Cada",
				fr: "Répéter Chaque",
			},
			when: {
				en: "When",
				it: "Quando",
				es: "Cuando",
				fr: "Quand",
			},
			"onsite-credits": {
				en: "Credits for on-site registration: ",
				it: "Crediti per iscrizione sul posto: ",
				es: "Créditos por registro en el sitio: ",
				fr: "Crédits pour inscription sur place: ",
			},
			"home-credits": {
				en: "Credits for home registration: ",
				it: "Crediti per iscrizione online: ",
				es: "Créditos por registro en linea: ",
				fr: "Crédits pour inscription en ligne: ",
			},
			location: {
				en: "Location",
				it: "Luogo",
				es: "Sitio",
				fr: "Lieu",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti obbligatori",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"class-description": {
				en: "Description",
				it: "Descrizione",
				es: "Descripción",
				fr: "Description",
			},
			"max-slots": {
				en: "Available Places",
				it: "Posti Max",
				es: "Plazas Disponibles",
				fr: "Places Disponibles",
			},
			"service-lesson": {
				en: "Service Lesson",
				it: "Lezione Servizio",
				es: "Lección De Servicio",
				fr: "Leçon De Service",
			},
			"add-new-service-lesson": {
				en: "Add New Service Lesson",
				it: "Aggiungi Nuova Lezione Servizio",
				es: "Agregar Nueva Lección De Servicio",
				fr: "Ajouter Une Nouvelle Leçon Service",
			},
		},
		ClubClassParticipantsView: {
			booked: {
				en: "Booked",
				it: "Prenotati",
				es: "Reservado",
				fr: "Réservé",
			},
			waiting: {
				en: "Waiting",
				it: "In coda",
				es: "Esperando",
				fr: "Attendre",
			},
			"athlete-successfully-add": {
				en: "Athlete added successfully",
				it: "Atleta aggiunto correttamente",
				es: "Atleta agregado exitosamente",
				fr: "Athlète ajouté avec succès",
			},
			"athlete-successfully-moved": {
				en: "Athlete successfully moved",
				it: "Atleta spostato correttamente",
				es: "Atleta se movió con éxito",
				fr: "Athlète gâté correctementathlète",
			},
			"could-not-remove-participant-after-end-date": {
				en: "A participant cannot be removed after the end date",
				it: "Impossibile rimuovere il partecipante dopo la data di fine",
				es: "No se pudo eliminar al participante después de la fecha de finalización",
				fr: "Les participants ne peuvent pas être supprimés après la date de fin",
			},
			"could-not-remove-participants-after-end-date": {
				en: "Participants cannot be removed after the end date",
				it: "Impossibile rimuovere i partecipanti dopo la data di fine",
				es: "Los participantes no se pueden eliminar después de la fecha de finalización",
				fr: "Impossible de supprimer le participant après la date de fin",
			},
			"could-not-add-participant-after-end-date": {
				en: "A participant cannot be added after the end date",
				it: "Impossibile aggiungere il partecipante dopo la data di fine",
				es: "No se pudo agregar participante después de la fecha de finalización",
				fr: "Impossible d'ajouter le participant après la date de fin",
			},
			"the-time-for-unsubscribing-has-passed": {
				en: "The time for unsubscribing has passed",
				it: "Il tempo utile per la disiscrizione è passato",
				es: "El tiempo para darse de baja ha pasado.",
				fr: "L'heure de la désinscription est passée.",
			},
			"unable-to-add-participants-if-the-status-is-unpublished": {
				en: "Unable to add participants if the status is inactive",
				it: "Impossibile aggiungere partecipanti se lo stato è inattivo",
				es: "No se pueden agregar participantes si el estado es inactivo",
				fr: "Impossible d'ajouter des participants si le statut est inactif",
			},
			"already-participant": {
				en: "The athlete is already a participant",
				it: "L'atleta è già partecipante",
				es: "El atleta ya es participante",
				fr: "L'athlète est déjà un participant",
			},
			"no-registration-required": {
				en: "No registration is required",
				it: "Non è richiesta un'iscrizione",
				es: "No se requiere registro",
				fr: "Aucune inscription n'est requise",
			},
			"registrations-are-not-yet-open": {
				en: "Registrations are not yet open",
				it: "Le iscrizioni non sono ancora aperte",
				es: "Las inscripciones aún no están abiertas",
				fr: "Les inscriptions ne sont pas encore ouvertes",
			},
			"registration-is-closed": {
				en: "Registration is closed",
				it: "Le iscrizioni sono chiuse",
				es: "El registro está cerrado",
				fr: "L'inscription est fermée",
			},
			"event-already-started": {
				en: "The event has already started",
				it: "L'evento è già iniziato",
				es: "El evento ya ha comenzado",
				fr: "L'événement a déjà commencé",
			},
			"places-available-exceeded": {
				en: "The number of available places has been exceeded",
				it: "E' stato superato il numero di posti disponibili",
				es: "Se ha excedido el número de plazas disponibles",
				fr: "Le nombre de places disponibles a été dépassé",
			},
			"not-enought-credits": {
				en: "The athlete does not have enough credits to register",
				it: "L'atleta non ha abbastanza crediti per iscriversi",
				es: "El atleta no tiene suficientes créditos para registrarse",
				fr: "L'athlète n'a pas assez de crédits pour s'inscrire",
			},
			"club-limits-exceeded": {
				en: "The athlete has reached the booking limit",
				it: "L'atleta ha raggiunto il limite di prenotazione",
				es: "El atleta ha alcanzado el límite de reservas",
				fr: "L'athlète a atteint la limite de réservation",
			},
			"bookings-blocked-athlete": {
				en: "Bookings are blocked for this athlete",
				it: "Le prenotazioni sono bloccate per questo atleta",
				es: "Las reservas están bloqueadas para este atleta",
				fr: "Les réservations sont bloquées pour cet athlète"
			},
			"invalid-payment-option": {
				en: "The athlete does not have a subscription or enough credits to register",
				it: "L'atleta non ha un abbonamento o crediti validi per iscriversi",
				es: "El atleta no tiene suscripción ni créditos válidos para registrarse",
				fr: "L'athlète n'a pas d'abonnement ni de crédits valides pour s'inscrire",
			},
			"no-valid-subscriptions": {
				en: "The athlete does not have a subscription to register",
				it: "L'atleta non ha un abbonamento valido per iscriversi",
				es: "El atleta no tiene suscripción válidos para registrarse",
				fr: "L'athlète n'a pas d'abonnement  valides pour s'inscrire",
			},
			"remove-athletes-confirm": {
				en: "Are you sure you want to remove?",
				it: "Sei sicuro di voler rimuovere?",
				es: "¿Estás seguro de que quieres eliminar?",
				fr: "Êtes-vous sûr de vouloir supprimer?",
			},
			"move-to-waiting-list": {
				en: "You are moving the athlete to the waiting list",
				it: "Stai spostando l'atleta in lista di attesa",
				es: "Estás moviendo al atleta en la lista de espera",
				fr: "Vous déplacez l'athlète sur la liste d'attente",
			},
			"move-to-participants-list": {
				en: "You are moving the athlete to the list of participants ",
				it: "Stai spostando l'atleta nella lista dei partecipanti ",
				es: "Está moviendo al atleta a la lista de participantes ",
				fr: "Vous déplacez l'athlète vers la liste des participants ",
			},
		},
		MyActivitiesView: {
			"activity-without-live": {
				en: "This activity does not involve the use of UptivoLIVE",
				it: "Questa attività non prevede l'utilizzo di UptivoLIVE",
				es: "Esta actividad no implica el uso de UptivoLIVE",
				fr: "Cette activité n'implique pas l'utilisation d'UptivoLIVE",
			},
			"my-next-activities": {
				en: "My Activities In The Next 24 Hours",
				it: "Le Mie Attività Nelle Prossime 24 Ore",
				es: "Mis Actividades En Las Próximas 24 Horas",
				fr: "Mes Planning Dans Les Prochaines 24 Heures",
			},
			participant: {
				en: "Participant",
				it: "Partecipante",
				es: "Partícipe",
				fr: "Participant",
			},
			queue: {
				en: "Queue",
				it: "Coda",
				es: "Cola",
				fr: "Queue",
			},
			participants: {
				en: "Participants",
				it: "Partecipanti",
				es: "Participantes",
				fr: "Participants",
			},
		},
		AthleteFilesView: {
			"athlete-files": {
				en: "Athlete Files",
				it: "File Dell' Atleta",
				es: "Archivos Del Deportista",
				fr: "Fichiers De L'Athlète",
			},
			"upload-successful": {
				en: "Upload Successful",
				it: "Caricamento Riuscito",
				es: "Subida Exitosa",
				fr: "Téléversement Réussi",
			},
			"upload-failed": {
				en: "Some files may not have been uploaded",
				it: "Alcuni file potrebbero non essere stati caricati",
				es: "Es posible que algunos archivos no se hayan cargado",
				fr: "Certains fichiers n'ont peut-être pas été téléchargés",
			},
			"move-successful": {
				en: "File moved successfully",
				it: "File spostato correttamente",
				es: "Archivo movido exitosamente",
				fr: "Fichier déplacé avec succès",
			},
			"remove-file-sharing": {
				en: "This is a shared file. Are you sure you want to remove sharing with the user?",
				it: "Questo è un file condiviso. Sei sicuro di voler rimuovere la condivisione con l'utente?",
				es: "Este es un archivo compartido. ¿Está seguro de que desea eliminar el uso compartido con el usuario?",
				fr: "Ceci est un fichier partagé. Voulez-vous vraiment supprimer le partage avec l'utilisateur?",
			},
			"remove-file": {
				en: "The file will be deleted from the user's archive.",
				it: "Il file verrà cancellato dall'archivio dell'utente.",
				es: "El archivo se eliminará del archivo del usuario.",
				fr: "Le fichier sera supprimé de l'archive de l'utilisateur.",
			},
			"remove-folder": {
				en: "The folder will be deleted from the user's archive.",
				it: "La cartella verrà cancellata dall'archivio dell'utente.",
				es: "La carpeta se eliminará del archivo del usuario.",
				fr: "Le dossier sera supprimé de l'archive de l'utilisateur.",
			},
		},
		MyFilesView: {
			"remove-my-file": {
				en: "The file will be deleted from your archive.",
				it: "Il file verrà cancellato dal tuo archivio.",
				es: "El archivo se eliminará de su archivo.",
				fr: "Le fichier sera supprimé de votre archive.",
			},
			"remove-my-folder": {
				en: "The folder will be deleted from your archive.",
				it: "La cartella verrà cancellata dal tuo archivio.",
				es: "La carpeta se eliminará  de su archivo.",
				fr: "Le dossier sera supprimé de votre archive.",
			},
		},
		RefreshPaymentAccountView: {
			"please-wait": {
				en: "Please wait…",
				it: "Attendere prego…",
				es: "Por favor espera…",
				fr: "S'il vous plaît, attendez…",
			},
			"redirect-to-payment-accont-site": {
				en: "We are redirecting you to the service web page",
				it: "Ti stiamo reindirizzando alla pagina web del servizio",
				es: "Estamos redirigiendo a la página web del servicio.",
				fr: "Nous vous redirigeons vers la page web du service",
			},
		},
		ChallengeRankingView: {
			"in-progress": {
				en: "In progress",
				it: "In Corso",
				es: "En Progreso",
				fr: "En Cours",
			},
			"target-zone-prc": {
				en: "% Target Zone",
				it: "% Target Zone",
				es: "% Zona objetivo",
				fr: "% Zone cible",
			},
		},
		ClubChallengesView: {
			"also-shows-finished-challenges": {
				en: "Also Shows Finished Challenges",
				it: "Mostra Anche Le Sfide Completate",
				es: "También Muestra Desafíos Completados",
				fr: "Affiche Également Les Défis Finés",
			},
			"goal": {
				en: "Goal",
				it: "Obiettivo",
				es: "Objetivo",
				fr: "Objectif",
			},
			"goals": {
				en: "Goals",
				it: "Obiettivi",
				es: "Objetivos",
				fr: "Objectifs",
			},
			"scheduled": {
				en: "Scheduled",
				it: "Programmate",
				es: "Plan",
				fr: "Plan",
			},
			"zr-monthly-upps-goal-challenge": {
				en: "Zone Revolution monthly UPPs challenge",
				it: "Zone Revolution sfida mensile basata sugli UPPs",
				es: "Zone Revolution desafío mensual basado en UPP",
				fr: "Zone Revolution défi mensuel basé sur les UPP",
			},
			"zr-trainings-goal-challenge": {
				en: "Zone Revolution trainings challenge",
				it: "Zone Revolution sfida basata sul numero di allenamenti",
				es: "Zone Revolution desafío basado en la cantidad de entrenamientos",
				fr: "Zone Revolution défi basé sur le nombre d'entraînements",
			},
			"generate-default-ZR-Challenges": {
				en: "Generate default ZR Challenges",
				it: "Generate default ZR Challenges",
				es: "Generate default ZR Challenges",
				fr: "Generate default ZR Challenges",
			},
			"delete-running-challenge": {
				en: "The challenge is underway. You will not be able to recover this data!",
				it: "La sfida è in corso. Non sarà possibile recuperare questi dati!",
				es: "El desafío está en marcha. ¡No podrá recuperar este registro!",
				fr: "Le défi est lancé. Vous ne pourrez pas récupérer ces données!",
			},
		},
		ClubChallengeView: {
			"scheduled-challenge": {
				en: "Scheduled Challenge",
				it: "Sfida Programmata",
				es: "Desafío Programado",
				fr: "Défi Programmé",
			},
			"top-tier": {
				en: "TOP TIER",
				it: "ALTO",
				es: "ALTO",
				fr: "HAUT",
			},
			"middle-tier": {
				en: "MIDDLE TIER",
				it: "MEDIO",
				es: "MEDIO",
				fr: "MOYEN",
			},
			"lower-tier": {
				en: "LOWER TIER",
				it: "BASSO",
				es: "BAJO",
				fr: "BAS",
			},
			"participant-tier": {
				en: "PARTICIPANT TIER",
				it: "PARTECIPAZIONE",
				es: "PARTICIPACIÓN",
				fr: "PARTICIPATION",
			},
			"enable-rank-trainings": {
				en: "Consider only the best workouts",
				it: "Considera solo i migliori allenamenti",
				es: "Considera solo los mejores entrenamientos",
				fr: "Ne considérez que les meilleurs entraînements",
			},
			"rank-trainings": {
				en: "Consider only the best:",
				it: "Considera solo i migliori:",
				es: "Considera solo lo mejor:",
				fr: "Ne considérer que le meilleur:",
			},
		},
		ClubObjectiveView: {
			threshold: {
				en: "Threshold",
				it: "Soglia",
				es: "Límite",
				fr: "Seuil",
			},
			reward: {
				en: "Reward",
				it: "Premio",
				es: "Recompensa",
				fr: "Récompense",
			},
			"goal-challenge": {
				en: "Goal Challenge",
				it: "Sfida A Obiettivi",
				es: "Desafío De Objetivo",
				fr: "Défi D'Objectif",
			},
			"create-goal-challenge": {
				en: "Create Goal Challenge",
				it: "Crea Sfida A Obiettivi",
				es: "Crear Desafío De Objetivo",
				fr: "Créer Un Défi D'Objectif",
			},
			"goals-must-be-incremental": {
				en: "Goals must be incremental",
				it: "I goal devono essere incrementali",
				es: "Los objetivos deben ser incrementales",
				fr: "Les objectifs doivent être progressifs",
			},
			"all-goals-must-have-badge": {
				en: "All goals must have a reward",
				it: "Tutti i goal devono avere un premio",
				es: "Todos los objetivos deben tener una recompensa",
				fr: "Tous les objectifs doivent avoir une récompense",
			},
			"scheduled-goal-challenge": {
				en: "Scheduled Goal Challenge",
				it: "Sfida A Obiettivi Programmata",
				es: "Desafío De Objetivo Planificado",
				fr: "Défi Objectif Planifié",
			},
		},
		CreditsAndSubscriptionsView: {
			AutoAssign: {
				en: "Auto Assigned",
				it: "Assegnato Automaticamente",
				es: "Asignación Automática",
				fr: "Assignation Automatique",
			},
			"AutoAssign-text": {
				en: "This trial subscription will be automatically assigned to each new member",
				it: "Questo abbonamento di prova sarà automaticamente assegnato ad ogni nuovo iscritto",
				es: "Esta suscripción de prueba se asignará automáticamente a cada nuevo miembro",
				fr: "Cet abonnement d'essai sera automatiquement attribué à chaque nouveau membre",
			},
			"remember-complete-payment-account-setup": {
				en: "To enable online payments, remember to complete the setup of at least one payment method.",
				it: "Per abilitare i pagamenti online, ricordati di completare la configurazione di almeno un metodo di pagamento.",
				es: "Para habilitar los pagos en línea, recuerde completar la configuración de al menos un método de pago.",
				fr: "Pour activer les paiements en ligne, n'oubliez pas de terminer la configuration d'au moins un mode de paiement.",
			},
			"credits-description": {
				en: "You can assign credits and subscriptions to your customers in the Manage Users section. If you enable payments, your customers will also be able to purchase credits and subscriptions from their Uptivo app.",
				it: "Puoi assegnare crediti e abbonamenti ai tuoi clienti nella sezione Gestione Utenti. Se abiliti i pagamenti, i tuoi clienti potranno inoltre acquistare crediti e abbonamenti dall’app Uptivo.",
				es: "Puede asignar créditos y suscripciones a sus clientes en la sección Administrar Usuarios. Si habilita los pagos, sus clientes también podrán comprar créditos y suscripciones desde la aplicación Uptivo.",
				fr: "Vous pouvez attribuer des crédits et des abonnements à vos clients dans la section Gérer les Utilisateurs. Si vous activez les paiements, vos clients pourront également acheter des crédits et des abonnements à partir de l'application Uptivo.",
			},
			"enable-club-packages-warning": {
				en: "Enable online payments in your club settings to be able to add credit packages.",
				it: "Abilita i pagamenti online nelle impostazioni del club per poter aggiungere i pacchetti di crediti.",
				es: "Habilite los pagos en línea en la configuración de su club para poder agregar paquetes de crédito.",
				fr: "Veuillez activer les paiements en ligne dans les paramètres de votre club pour pouvoir ajouter des packs de crédits.",
			},
			"max-weekly-bookings": {
				en: "Weekly Bookings",
				it: "Prenotazioni Settimanali",
				es: "Reservas Semanales",
				fr: "Réservations Hebdomadaires",
			},
			"max-monthly-bookings": {
				en: "Monthly Bookings",
				it: "Prenotazioni Mensili",
				es: "Reservas Mensuales",
				fr: "Réservations Mensuelles",
			},
			"subscription-succesfully-removed": {
				en: "Subscription successfully removed",
				it: "Abbonamento rimosso con successo",
				es: "Suscripción eliminada correctamente",
				fr: "Abonnement supprimé avec succès",
			},
			"subscription-succesfully-suspended": {
				en: "Subscription successfully suspended",
				it: "Abbonamento sospeso con successo",
				es: "Suscripción suspendida con éxito",
				fr: "Abonnement suspendu avec succès",
			},
			"subscription-succesfully-reactivate": {
				en: "Subscription successfully reactivated",
				it: "Abbonamento riattivato con successo",
				es: "Suscripción reactivada con éxito",
				fr: "Abonnement réactivé avec succès",
			},
			"subscription-succesfully-add": {
				en: "Subscription assigned correctly",
				it: "Abbonamento assegnato correttamente",
				es: "Suscripción asignada correctamente",
				fr: "Abonnement attribué correctement",
			},
			"confirm-hide-subscription": {
				en: "You are about to hide this subscription. It will no longer appear among the purchasable ones.",
				it: "Stai per nascondere questo abbonamento. Non comparirà più tra quelli acquistabili.",
				es: "Estás a punto de ocultar esta suscripción. Ya no aparecerá entre los que se pueden comprar.",
				fr: "Vous êtes sur le point de masquer cet abonnement. Il n'apparaîtra plus parmi les achetables.",
			},
			"confirm-show-subscription": {
				en: "You are about to make this subscription visible. It will then be available for purchase.",
				it: "Stai per rendere visibile questo abbonamento. Sarà quindi disponibile all'acquisto.",
				es: "Está a punto de hacer visible esta suscripción. Entonces estará disponible para su compra.",
				fr: "Vous êtes sur le point de rendre cet abonnement visible. Il sera alors disponible à l'achat.",
			},
			"confirm-enable-auto-assign": {
				en: "You are about to enable this subscription. It will be assigned to all new members.",
				it: "Stai per abilitare questo abbonamento. Sarà assegnato automaticamente ai nuovi membri.",
				es: " Estás a punto de habilitar esta suscripción. Será asignada a todos los nuevos miembros.",
				fr: " Vous êtes sur le point d'activer cet abonnement. Il sera attribué à tous les nouveaux membres.",
			},
			"confirm-disable-auto-assign": {
				en: "You are about to disable this subscription.",
				it: "Stai per disabilitare questo abbonamento.",
				es: "Estás a punto de desactivar esta suscripción.",
				fr: "Vous êtes sur le point de désactiver cet abonnement.",
			},
			"credits-packages": {
				en: "Credits Packages",
				it: "Pacchetti Di Crediti",
				es: "Paquetes De Créditos",
				fr: "Forfaits De Crédits",
			},
			"add-credit-package": {
				en: "Add Credit Package",
				it: "Aggiungi Pacchetto Crediti",
				es: "Agregar Paquete De Crédito",
				fr: "Ajouter Un Forfait De Crédit",
			},
			"add-credits-packages": {
				en: "Add Credits Packages",
				it: "Aggiungi Pacchetti Di Crediti",
				es: "Agregar paquetes de créditos",
				fr: "Ajouter Des Forfaits De Crédits",
			},
			WaitingInitialPayment: {
				en: "Waiting for first payment",
				it: "In attesa del primo pagamento",
				es: "Esperando el primer pago",
				fr: "En attente du premier paiement",
			},
			InitialPaymentFailed: {
				en: "First payment failed",
				it: "Primo pagamento fallito",
				es: "Primer pago fallido",
				fr: "Échec du premier paiement",
			},
			RetryingPayment: {
				en: "New payment attempt",
				it: "Nuovo tentativo di pagamento",
				es: "Nuevo intento de pago",
				fr: "Nouvelle tentative de paiement",
			},
			PaymentFailed: {
				en: "Payment failed",
				it: "Pagamento fallito",
				es: "Pago fallido",
				fr: "Paiement échoué",
			},
			CanceledImmediately: {
				en: "Instant cancellation",
				it: "Cancellazione istantanea",
				es: "Cancelación instantánea",
				fr: "Annulation instantanée",
			},
			CanceledAtPeriodEnd: {
				en: "Cancellation at end of installment",
				it: "Cancellazione a fine rata",
				es: "Cancelación al final de la cuota",
				fr: "Annulation à la fin du versement",
			},
			PaymentPeriodTerminated: {
				en: "Payment period ended",
				it: "Periodo di pagamento terminato",
				es: "Período de pago terminado",
				fr: "Période de paiement terminée",
			},
			"to-pay": {
				en: "To pay",
				it: "Da pagare",
				es: "Por pagar",
				fr: "À payer"
			},
			draft: {
				en: "Draft",
				it: "Bozza",
				es: "Borrador",
				fr: "Brouillon",
			},
			"invoice-open": {
				en: "Open",
				it: "Aperta",
				es: "Abierta",
				fr: "Ouvertes",
			},
			"invoice-void": {
				en: "Void",
				it: "Non valida",
				es: "Nula",
				fr: "Nulle",
			},
			"invoice-paid": {
				en: "Paid",
				it: "Pagato",
				es: "Pagada",
				fr: "Payée",
			},
			"paid": {
				en: "Paid",
				it: "Pagato",
				es: "Pagada",
				fr: "Payée",
			},
			"invoice-uncollectible": {
				en: "Uncollectible",
				it: "Inesigibile",
				es: "Incobrable",
				fr: "Non recouvrable",
			},
			"invoice-unpaid": {
				en: "Unpaid",
				it: "Non Pagato",
				es: "No Pagado",
				fr: "Non payé",
			},
			"unpaid": {
				en: "Unpaid",
				it: "Non Pagato",
				es: "No Pagado",
				fr: "Non payé",
			},
			"canceled": {
				"en": "Canceled",
				"it": "Annullato",
				"es": "Cancelado",
				"fr": "Annulé"
			},
			"paused": {
				"en": "Paused",
				"it": "In pausa",
				"es": "Pausado",
				"fr": "En pause"
			},
			
			price: {
				en: "Price",
				it: "Prezzo",
				es: "Precio",
				fr: "Prix",
			},
			currency: {
				en: "Currency",
				it: "Valuta",
				es: "Moneda",
				fr: "Devise",
			},
			plans: {
				en: "Plans",
				it: "Piani",
				es: "Planes",
				fr: "Plans",
			},
			"confirm-delete-credits-package": {
				en: "Are you sure you want to delete this credits package?",
				it: "Sei sicuro di voler eliminare questo pacchetto di crediti?",
				es: "¿Está seguro de que desea eliminar el paquete de créditos?",
				fr: "Êtes-vous sûr de vouloir supprimer le package de crédits?",
			},
			"confirm-remove-payment-account": {
				en: "Are you sure you want to remove this payment account?",
				it: "Sei sicuro di voler rimuovere questo account di pagamento?",
				es: "¿Está seguro de que desea eliminar esta cuenta de pago?",
				fr: "Voulez-vous vraiment supprimer ce compte de paiement?",
			},
			"confirm-disable-ranking": {
				en: "Confirm disable Ranking",
				it: "Conferma disabilitazione classifica",
				es: "Confirmar desactivación del ranking",
				fr: "Confirmer la désactivation du classement"
			},
			"confirm-disable-kiosk": {
				en: "Are you sure you want to disable this Kiosk?",
				it: "Sei sicuro di voler disabilitare questo chiosco?",
				es: "¿Estás seguro de que quieres desactivar este quiosco?",
				fr: "Êtes-vous sûr de vouloir désactiver ce kiosque?"
			},
			"confirm-disable-kiosk-alert": {
				en: "Disabling the kiosk will render the associated link unusable, and the kiosks will stop functioning.",
				it: "Disattivare il chiosco renderà inutilizzabile il link associato e i chioschi smetteranno di funzionare.",
				es: "Desactivar el quiosco hará que el enlace asociado sea inutilizable y los quioscos dejarán de funcionar.",
				fr: "Désactiver le kiosque rendra le lien associé inutilisable, et les kiosques cesseront de fonctionner."
			},
			"confirm-remove-paypal": {
				en: "Disconnecting your PayPal account will prevent you from offering PayPal services and products on your website. Do you wish to continue?",
				it: "La disconnessione del tuo conto PayPal ti impedirà di offrire servizi e prodotti PayPal sul tuo sito web. Vuoi continuare?",
				es: "Desconectar su cuenta de PayPal le impedirá ofrecer servicios y productos de PayPal en su sitio web. ¿Desea continuar?",
				fr: "La déconnexion de votre compte PayPal vous empêchera de proposer des services et des produits PayPal sur votre site Web. Souhaitez-vous continuer?",
			},
			"credits-required": {
				en: "Credits required",
				it: "Crediti obbligatori",
				es: "Créditos requeridos",
				fr: "Crédits requis",
			},
			"price-required": {
				en: "Price is required",
				it: "Il prezzo è obbligatorio",
				es: "El precio es requerido",
				fr: "Le prix est obligatoire",
			},
			"add-new-subscription": {
				en: "Add New Subscription",
				it: "Aggiungi Nuovo Abbonamento",
				es: "Agregar Nueva Suscripción",
				fr: "Ajouter Un Nouvel Abonnement",
			},
			"unable-delete-subscription-because-assigned": {
				en: "Unable to delete subscription because assigned. {0} Suspended, {1} Assigned",
				it: "Impossibile eliminare l'abbonamento perché assegnato. {0} Sospesi, {1} Assegnati",
				es: "No se puede eliminar la suscripción porque está asignada. {0} Suspendido, {1} Asignado",
				fr: "Impossible de supprimer l'abonnement car attribué. {0} Suspendu, {1} Attribué",
			},
			"confirm-delete-club-subscription": {
				en: "This subscription is not assigned to any user. Do you confirm that you want to delete it?",
				it: "Questo abbonamento non è assegnato a nessun utente. Confermi di volerlo cancellare?",
				es: "Esta suscripción no está asignada a ningún usuario. ¿Confirmas que quieres eliminarlo?",
				fr: "Cet abonnement n'est attribué à aucun utilisateur. Confirmez-vous que vous souhaitez le supprimer?",
			},
			"define-subscription-plans": {
				en: "Define subscription plans",
				it: "Definisci piani abbonamento",
				es: "Definir planes de suscripción",
				fr: "Définir des plans d'abonnement",
			},
			"duration-days": {
				en: "Duration (days)",
				it: "Durata (giorni)",
				es: "Duración (días)",
				fr: "Durée (jours)",
			},
			"max-activities": {
				en: "Max Activities",
				it: "Max Attività",
				es: "Máx Actividades",
				fr: "Max Activités",
			},
			notes: {
				en: "Notes",
				it: "Note",
				es: "Notas",
				fr: "Remarques",
			},
			"subscription-management": {
				en: "Subscription Management",
				it: "Gestione Abbonamenti",
				es: "Gestión De Suscripciones",
				fr: "Gestion Des Abonnements",
			},
			"credits-management": {
				en: "Credits Management",
				it: "Gestione Crediti",
				es: "Gestión De Créditos",
				fr: "Gestion Des Crédits",
			},
			subscription: {
				en: "Subscription",
				it: "Abbonamento",
				es: "Suscripción",
				fr: "Abonnement",
			},
			"subscription-name": {
				en: "Subscription Name",
				it: "Nome Abbonamento",
				es: "Nombre De Suscripción",
				fr: "Nom De L'Abonnement",
			},
			limits: {
				en: "Limits",
				it: "Limitazioni",
				es: "Limitaciones",
				fr: "Limites",
			},
			"past-operations": {
				en: "Past Operations",
				it: "Storico Operazioni",
				es: "Operaciones Pasadas",
				fr: "Opérations Passées",
			},
			"remove-athlete-subscription": {
				en: "You are about to remove the subscription",
				it: "Stai per rimuovere l'abbonamento",
				es: "Estás a punto de darte de baja",
				fr: "Vous êtes sur le point de vous désinscrire",
			},
			"subscription-update": {
				en: "Subscription Update",
				it: "Abbonamento aggiornato",
				es: "Suscripción actualizada",
				fr: "Abonnement mis à jour",
			},
			"set-reactivation-date": {
				en: "Set Reactivation Date",
				it: "Imposta la data di riattivazione",
				es: "Establecer fecha de reactivación",
				fr: "Définir la date de réactivation",
			},
			"reactivation-date": {
				en: "Reactivation Date",
				it: "Data Di Riattivazione",
				es: "Fecha De Reactivación",
				fr: "Date De Réactivation",
			},
			"suspended-date": {
				en: "Suspended Date",
				it: "Data Sospensione",
				es: "Fecha De Suspensión",
				fr: "Date De Suspension",
			},
			"suspend-subscription-confirm": {
				en: "Are you sure you want to suspend this subscription?",
				it: "Sei sicuro di voler sospendere questo abbonamento?",
				es: "¿Está seguro de que desea suspender esta suscripción?",
				fr: "Voulez-vous vraiment suspendre cet abonnement?",
			},
			"reactivate-subscription-confirm": {
				en: "Are you sure you want to reactivate this subscription?",
				it: "Sei sicuro di voler riattivare questo abbonamento?",
				es: "¿Está seguro de que desea reactivar esta suscripción?",
				fr: "Voulez-vous vraiment réactiver cet abonnement?",
			},
			active: {
				en: "Active",
				it: "Attivo",
				es: "Activo",
				fr: "Actif",
			},
			"non-renewed": {
				en: "Non-renewed",
				it: "Non rinnovato",
				es: "No renovado",
				fr: "Non renouvelé",
			},
			"expired-date": {
				en: "Expired Date",
				it: "Scaduto Il",
				es: "Fecha De Vencimiento",
				fr: "Date d'Expiration",
			},
			"select-plan": {
				en: "Select Plan",
				it: "Seleziona Piano",
				es: "Seleccionar plan",
				fr: "Sélectionnez Plan",
			},
			purchasable: {
				en: "Purchasable",
				it: "Acquistabile",
				es: "Adquirir",
				fr: "Achetable",
			},
			"not-purchasable": {
				en: "Not Purchasable",
				it: "Non Acquistabile",
				es: "No Adquirir",
				fr: "Non Achetable",
			},
			"cannot-suspend-expired-subscription": {
				en: "Cannot suspend expired subscription",
				it: "Impossibile sospendere, abbonamento scaduto",
				es: "No se puede suspender la suscripción caducada",
				fr: "Impossible de suspendre l'abonnement expiré",
			},
			"cannot-suspend-subscription-for-less-7-days": {
				en: "Subscriptions can't be suspended for less than 7 days",
				it: "Gli abbonamenti non possono essere sospesi per meno di 7 giorni",
				es: "Las suscripciones no se pueden suspender por menos de 7 días",
				fr: "Les abonnements ne peuvent pas être suspendus pendant moins de 7 jours",
			},
			"cannot-suspend-subscription-has-bookings": {
				en: "Unable to suspend this subscription because there are associated bookings",
				it: "Impossibile sospendere l'abbonamento perché sono presenti prenotazioni associate",
				es: "No se puede suspender esta suscripción porque hay reservas asociadas",
				fr: "Impossible de suspendre cet abonnement car des réservations sont associées",
			},
			"cannot-remove-subscription-has-bookings": {
				en: "Unable to remove this subscription because there are associated bookings",
				it: "Impossibile rimuovere l'abbonamento perché sono presenti prenotazioni associate",
				es: "La suscripción no se puede eliminar porque hay reservas asociadas",
				fr: "L'abonnement ne peut pas être supprimé car il y a des réservations associées",
			},
			"subscription-end-must-be-greater-start": {
				en: "The subscription end date must be greater than the start date.",
				it: "La data di fine dell'abbonamento deve essere superiore alla data di inizio.",
				es: "La fecha de finalización de la suscripción debe ser mayor que la fecha de inicio.",
				fr: "La date de fin de l'abonnement doit être postérieure à la date de début.",
			},
			"reactivation-date-must-be-in-future": {
				en: "Reactivation date must be in the future",
				it: "La data di riattivazione deve essere una data futura",
				es: "La fecha de reactivación debe ser futura",
				fr: "La date de réactivation doit être dans le futur",
			},
			"not-purchasable": {
				en: "Not purchasable",
				it: "Non acquistabile",
				es: "No adquirible",
				fr: "Non achetable",
			},
			"without-subscriptions": {
				en: "Without Subscriptions",
				it: "Senza Abbonamenti",
				es: "Sin Suscripciones",
				fr: "Sans Abonnement",
			},
			trial: {
				en: "Trial Sessions",
				it: "Sessioni Di Prova",
				es: "Sesiones De Prueba",
				fr: "Séances D'Essai",
			},
			"subscription-type": {
				en: "Subscription Type",
				it: "Tipo Abbonamento",
				es: "Tipo De Suscripción",
				fr: "Type D'Abonnement",
			},
			model: {
				en: "Model",
				it: "Modello",
				es: "Modelo",
				fr: "Maquette",
			},
			mode: {
				en: "Mode",
				it: "Modalità",
				es: "Modo",
				fr: "Mode",
			},
			"from-table": {
				en: "From",
				it: "Da",
				es: "Desde",
				fr: "De",
			},
			"to-table": {
				en: "To",
				it: "A",
				es: "A",
				fr: "À",
			},
		},
		ClassParticipantSubscriptionsView: {
			mode: {
				en: "Mode",
				it: "Modalità",
				es: "Modo",
				fr: "Mode",
			},
			participant: {
				en: "Participant",
				it: "Partecipante",
				es: "Partícipe",
				fr: "Participant",
			},
			"in-queue": {
				en: "In Queue",
				it: "In Coda",
				es: "En Fila",
				fr: "Dans La Queue",
			},
			"participation-status": {
				en: "Participation Status",
				it: "Stato Partecipazione",
				es: "Estado De Participación",
				fr: "Statut De Participation",
			},
			pt: {
				en: "PT",
				it: "PT",
				es: "PT",
				fr: "PT",
			},
			"view-lesson": {
				en: "View lesson",
				it: "Vedi lezione",
				es: "Ver lección",
				fr: "Voir leçon",
			},
			"view-all-participants": {
				en: "View all participants",
				it: "Visualizza tutti i partecipanti",
				es: "Ver todos los participantes",
				fr: "Voir tous les participants",
			},
		},
		VideoCollectionsView: {
			"insert-valid-youtube-link": {
				en: "insert valid YouTube link",
				it: "inserisci un link YouTube valido",
				es: "inserte un enlace de YouTube válido",
				fr: "insérer un lien YouTube valide",
			},
			"insert-valid-vimeo-link": {
				en: "insert valid Vimeo link",
				it: "inserisci un link Vimeo valido",
				es: "inserte un enlace de Vimeo válido",
				fr: "insérer un lien Vimeo valide",
			},
			"video-not-found": {
				en: "Video not found",
				it: "Video non trovato",
				es: "Video no encontrado",
				fr: "Vidéo non trouvée",
			},
			"youtube-link": {
				en: "YouTube Link",
				it: "YouTube Link",
				es: "YouTube Link",
				fr: "YouTube Link",
			},
			"vimeo-link": {
				en: "Vimeo Link",
				it: "Vimeo Link",
				es: "Vimeo Link",
				fr: "Vimeo Link",
			},
			video: {
				en: "Video",
				it: "Video",
				es: "Video",
				fr: "Video",
			},
			"video-collections": {
				en: "PlayLists",
				it: "PlayLists",
				es: "PlayLists",
				fr: "PlayLists",
			},
			"add-new-collection": {
				en: "Add New PlayList",
				it: "Aggiungi Nuova PlayList",
				es: "Agregar nueva PlayList",
				fr: "Ajouter une nouvelle PlayList",
			},
			"edit-collection": {
				en: "Edit PlayList",
				it: "Modifica PlayList",
				es: "Editar PlayList",
				fr: "Modifier PlayList",
			},
			"add-new-video": {
				en: "Add New Video",
				it: "Aggiungi Nuovo Video",
				es: "Agregar Nuevo Vídeo",
				fr: "Ajouter Nouvelle Vidéo",
			},
			"import-video": {
				en: "Import Video",
				it: "Importa Video",
				es: "Importar Vídeo",
				fr: "Importer Vidéo",
			},
			"import-video": {
				en: "Import Video",
				it: "Importa Video",
				es: "Importar Vídeo",
				fr: "Importer Vidéo",
			},
			"create-video": {
				en: "Create Video",
				it: "Crea Video",
				es: "Crear Vídeo",
				fr: "Créer Vidéo",
			},
			"edit-video": {
				en: "Edit Video",
				it: "Modifica Video",
				es: "Editar Vídeo",
				fr: "Éditer Vidéo",
			},
			"confirm-disable": {
				en: "Are you sure you want to disable it?",
				it: "Sei sicuro di volerlo disabilitare?",
				es: "¿Estás seguro de que quieres desactivarlo?",
				fr: "Êtes-vous sûr de vouloir le désactiver?",
			},
			"confirm-enable": {
				en: "Are you sure you want to enable it?",
				it: "Sei sicuro di volerlo abilitare?",
				es: "¿Está seguro de que desea habilitarlo?",
				fr: "Voulez-vous vraiment l'activer?",
			},
			"a-video-must-be-in-at-least-one-collection": {
				en: "A video must be in at least one PlayList",
				it: "Un video deve essere in almeno una PlayList",
				es: "Un video debe estar en al menos una PlayList",
				fr: "Une vidéo doit être dans au moins une PlayList",
			},
			"this-video-is-present-in-several-collections": {
				en: "This video is present in several PlayLists.",
				it: "Questo video è presente in più PlayLists.",
				es: "Este video esta presente en varias PlayLists.",
				fr: "Cette vidéo est présente dans plusieurs PlayLists.",
			},
			"on-demand-not-enabled-club": {
				en: "On Demand is not enabled for the selected club.",
				it: "On Demand non è attivo nel il club selezionato.",
				es: "On Demand no está habilitado para el club seleccionado.",
				fr: "On Demand n'est pas activé pour le club sélectionné.",
			},
		},
		DashBoardView: {
			"show-client-status-boxes": {
				en: "Show Clients Status Boxes",
				it: "Mostra i Box Di Stato Dei Clienti",
				es: "Mostrar Cajas De Estado De Los Clientes",
				fr: "Afficher Les Boîtes De Statut Des Clients",
			},
			"show-lists-under-boxes": {
				en: "Show Lists Under Boxes",
				it: "Mostra Elenchi Sotto I Box",
				es: "Mostrar Listas Debajo De Las Cajas",
				fr: "Afficher Les Listes Sous Les Boîtes",
			},
			"show-extended-view": {
				en: "Show Extended View",
				it: "Mostra Vista Estesa",
				es: "Mostrar Vista Extendida",
				fr: "Afficher La Vue Étendue",
			},
		},
		DataTables: {
			"dt.decimal": {
				it: ",",
				es: ",",
				fr: ",",
			},
			"dt.emptyTable": {
				it: "Nessun dato presente nella tabella",
				es: "Ningún dato disponible en esta tabla",
				fr: "Aucune donn&eacute;e disponible dans le tableau",
			},
			"dt.info": {
				it: "Vista da _START_ a _END_ di _TOTAL_ elementi",
				es: "Mostrando del _START_ al _END_ de un total de _TOTAL_ registros",
				fr: "Affichage de l'&eacute;l&eacute;ment _START_ &agrave; _END_ sur _TOTAL_ &eacute;l&eacute;ments",
			},
			"dt.infoEmpty": {
				it: "Vista da 0 a 0 di 0 elementi",
				es: "Mostrando del 0 al 0 de un total de 0 registros",
				fr: "Affichage de l'&eacute;l&eacute;ment 0 &agrave; 0 sur 0 &eacute;l&eacute;ment",
			},
			"dt.infoFiltered": {
				en: "(filtered from _MAX_ total entries)",
				it: "(filtrati da _MAX_ elementi totali)",
				es: "(filtrado de un total de _MAX_)",
				fr: "(filtr&eacute; de _MAX_ &eacute;l&eacute;ments au total)",
			},
			"dt.thousands": {
				it: ".",
				es: ".",
				fr: "&nbsp;",
			},
			"dt.lengthMenu": {
				it: "Visualizza _MENU_ elementi",
				es: "Mostrar _MENU_ registros",
				fr: "Afficher _MENU_ &eacute;l&eacute;ments",
			},
			"dt.loadingRecords": {
				it: "Caricamento…",
				es: "Cargando…",
				fr: "Chargement en cours…",
			},
			"dt.processing": {
				it: "Elaborazione…",
				es: "Procesando…",
				fr: "Traitement en cours…",
			},
			"dt.search": {
				it: "Cerca:",
				es: "Buscar:",
				fr: "Rechercher:",
			},
			"dt.zeroRecords": {
				it: "La ricerca non ha portato alcun risultato",
				es: "No se encontraron resultados",
				fr: "Aucun &eacute;l&eacute;ment &agrave; afficher",
			},
			"dt.select.1": {
				en: "1 row selected",
				it: "1 riga selezionata",
				es: "1 fila seleccionada",
				fr: "1 rangée sélectionnée",
			},
			"dt.select.many": {
				en: "%d rows selected",
				it: "%d righe selezionate",
				es: "%d filas seleccionadas",
				fr: "%d lignes sélectionnées",
			},
		},
		Support: {
			videos: {
				en: "Videos",
				it: "Video",
				es: "Vídeos",
				fr: "Vidéos",
			},
			guide: {
				en: "Guide",
				it: "Guida",
				es: "Guía",
				fr: "Guide",
			},
			"localized-guide-url": {
				en: "https://downloads.uptivo.fit/docs/guides/Uptivo_Guide_EN_1.0.pdf",
				it: "https://downloads.uptivo.fit/docs/guides/Uptivo_Guide_IT_1.0.pdf",
				es: "https://downloads.uptivo.fit/docs/guides/Uptivo_Guide_ES_1.0.pdf",
				fr: "https://downloads.uptivo.fit/docs/guides/Uptivo_Guide_FR_1.0.pdf",
			},
			"activity-calendars-title": {
				en: "Activity Calendars",
				it: "Calendari delle attività",
				es: "Calendarios de actividades",
				fr: "Calendriers d'activités",
			},
			"activity-calendars-txt": {
				en: "How to create and manage your group lessons and personal training appointments",
				it: "Come creare e gestire le tue lezioni di gruppo e i tuoi appuntamenti di personal training",
				es: "Cómo crear y gestionar tus lecciones grupales y citas de entrenamiento personal",
				fr: "Comment créer et gérer vos cours collectifs et vos rendez-vous de formation personnelle",
			},
			"adding-participants-title": {
				en: "Adding Class Participants",
				it: "Aggiunta di partecipanti alla lezione",
				es: "Agregar participantes a la clase",
				fr: "Ajouter des participants à la classe",
			},
			"adding-participants-txt": {
				en: "How to add one or more members to one or multiple classes or activities in a few clicks",
				it: "Come aggiungere uno o più membri a una o più classi o attività in pochi clic",
				es: "Cómo agregar uno o más miembros a una o varias clases o actividades con unos pocos clics",
				fr: "Comment ajouter un ou plusieurs membres à un ou plusieurs cours ou activités en quelques clics",
			},
			"custom-challenges-title": {
				en: "Challenges – Custom",
				it: "Sfide – Personalizzate",
				es: "Desafíos – Personalizados",
				fr: "Défis – Personnalisé",
			},
			"custom-challenges-txt": {
				en: "How to create challenges over time with custom dates and settings",
				it: "Come creare sfide nel tempo con date e impostazioni personalizzate",
				es: "Cómo crear desafíos a lo largo del tiempo con fechas y configuraciones personalizadas",
				fr: "Comment créer des défis au fil du temps avec des dates et des paramètres personnalisés",
			},
			"monthly-challenges-title": {
				en: "Challenges – Monthly",
				it: "Sfide – Mensile",
				es: "Desafíos – Mensual",
				fr: "Défis – Mensuel",
			},
			"monthly-challenges-txt": {
				en: "How to create monthly challenges that restart every month automatically",
				it: "Come creare sfide mensili che si riavviano automaticamente ogni mese",
				es: "Cómo crear desafíos mensuales que se reinician cada mes automáticamente",
				fr: "Comment créer des défis mensuels qui redémarrent automatiquement chaque mois",
			},
			"garmin-connect-integration-title": {
				en: "Garmin Connect Integration",
				it: "Integrazione Garmin Connect",
				es: "Integración de Garmin Connect",
				fr: "Intégration Garmin Connect",
			},
			"garmin-connect-integration-txt": {
				en: "How to enable Garmin -> Uptivo integration to automatically import Garmin workouts",
				it: "Come abilitare l'integrazione Garmin -> Uptivo per importare automaticamente gli allenamenti Garmin",
				es: "Cómo habilitar la integración Garmin -> Uptivo para importar automáticamente entrenamientos de Garmin",
				fr: "Comment activer l'intégration Garmin -> Uptivo pour importer automatiquement les entraînements Garmin",
			},
			"invite-user-title": {
				en: "Invite New Member",
				it: "Invitare nuovo membro",
				es: "Invitar nuevo miembro",
				fr: "Inviter un nouveau membre",
			},
			"invite-user-txt": {
				en: "How to add new members to your Uptivo club account, or have them create their profile and join your account",
				it: "Come aggiungere nuovi membri al tuo account Uptivo Club o come fargli creare il proprio profilo e unirsi al tuo account",
				es: "Cómo agregar nuevos miembros a su cuenta del club Uptivo, o hacer que creen su perfil y se unan a su cuenta",
				fr: "Comment ajouter de nouveaux membres à votre compte club Uptivo, ou leur demander de créer leur profil et de rejoindre votre compte",
			},
			"sensor-pairing-title": {
				en: "Add an HR Sensor to a Member",
				it: "Aggiungi un sensore FC a un membro",
				es: "Agregar un sensor de frecuencia cardíaca a un miembro",
				fr: "Ajouter un capteur FC à un membre",
			},
			"sensor-pairing-txt": {
				en: "How to pair a heart rate sensor (Uptivo or other brand) to your members’ profile",
				it: "Come associare un sensore di frequenza cardiaca (Uptivo o altra marca) al profilo dei tuoi membri",
				es: "Cómo vincular un sensor de frecuencia cardíaca (Uptivo u otra marca) a perfiles de tu miembro",
				fr: "Comment coupler un capteur de fréquence cardiaque (Uptivo ou autre marque) à vos profils membres",
			},
			"subscription-management-title": {
				en: "Subscription Management",
				it: "Gestione degli abbonamenti",
				es: "Gestión de suscripciones",
				fr: "Gestion des abonnements",
			},
			"subscription-management-txt": {
				en: "How to create your club subscriptions and assign them to your members",
				it: "Come creare gli abbonamenti del tuo club e assegnarli ai tuoi membri",
				es: "Cómo crear las suscripciones de tu club y asignarlas a tus socios",
				fr: "Comment créer vos abonnements club et les attribuer à vos membres",
			},
			"user-profile-title": {
				en: "User Profile",
				it: "Profilo utente",
				es: "Perfil del usuario",
				fr: "Profil de l'utilisateur",
			},
			"user-profile-txt": {
				en: "How to review member information and manage member profiles",
				it: "Come rivedere le informazioni sui membri e gestire i loro profili utente",
				es: "Cómo revisar la información de los miembros y administrar los perfiles de los miembros",
				fr: "Comment consulter les informations sur les membres et gérer les profils",
			},
			"workouts-app-title": {
				en: "Workouts – In App",
				it: "Workouts – Nell'app",
				es: "Workouts – En la aplicación",
				fr: "Workouts - Dans l'application",
			},
			"workouts-app-txt": {
				en: "How to create workouts that can be assigned to members, so that they can follow along when not at the gym/studio",
				it: "Come creare allenamenti che possono essere assegnati ai membri, in modo che possano seguirli da telefono quando non sono in palestra/studio",
				es: "Cómo crear entrenamientos que se puedan asignar a los miembros, para que puedan seguirlos cuando no estén en el gimnasio/estudio",
				fr: "Comment créer des entraînements qui peuvent être attribués aux membres, afin qu'ils puissent les suivre lorsqu'ils ne sont pas au gymnase/studio",
			},
			"workouts-onscreen-title": {
				en: "Workouts – On Screen",
				it: "Workouts – A schermo",
				es: "Workouts – En pantalla",
				fr: "Workouts – À l’écran",
			},
			"workouts-onscreen-txt": {
				en: "How to create workouts that can be displayed on TVs, so that members can follow along when at the gym/studio",
				it: "Come creare allenamenti che possono essere visualizzati sui televisori, in modo che i membri possano seguirli quando sono in palestra/studio",
				es: "Cómo crear entrenamientos que se puedan mostrar en televisores, para que los miembros puedan seguirlos cuando estén en el gimnasio/estudio",
				fr: "Comment créer des entraînements qui peuvent être affichés sur les téléviseurs, afin que les membres puissent les suivre lorsqu'ils sont au gymnase/studio",
			},
			"bridge-registration-title": {
				en: "Bridge Registration",
				it: "Registrazione del Bridge",
				es: "Registro del Bridge",
				fr: "Enregistrer le Bridge"
			},
			"bridge-registration-txt": {
				en: "How to register the Bridge to your Club's Uptivo account",
				it: "Come registrare il Bridge all’account Uptivo del proprio Club",
				es: "Cómo registrar el Bridge en la cuenta Uptivo de tu Club",
				fr: "Comment enregistrer le Bridge aux services cloud Uptivo de votre Club"
			},
			"bridge-setup-title": {
				en: "Bridge Setup",
				it: "Setup del Bridge",
				es: "Configuración del Bridge",
				fr: "Configuration du Bridge"
			},
			"bridge-setup-txt": {
				en: "How to make the physical connections of the Bridge (Uptivo receiver) and how to connect it to your network",
				it: "Come effettuare i collegamenti fisici del Bridge (ricevitore Uptivo) e come connetterlo alla propria rete",
				es: "Cómo hacer las conexiones físicas del Bridge (receptor Uptivo) y cómo conectarlo a tu red",
				fr: "Comment réaliser les connexions physiques du Bridge (récepteur Uptivo) et comment le connecter à votre réseau"
			},
			"inapp-messages-title": {
				en: "In-App Messages",
				it: "Messaggi In-App",
				es: "Mensajes en la aplicación",
				fr: "Messages dans l'application"
			},
			"inapp-messages-txt": {
				en: "How to create template messages or instant messages and send them to one or more Club customers",
				it: "Come creare messaggi modello o messaggi istantanei e inviarli a uno o più clienti del Club",
				es: "Cómo crear mensajes de plantilla o mensajes instantáneos y enviarlos a uno o más clientes del Club",
				fr: "Comment créer des modèles de messages ou des messages instantanés et les envoyer à un ou plusieurs clients du Club"
			},
			"move-users-tv-title": {
				en: "Move Users to TVs",
				it: "Spostare Utenti sui Televisori",
				es: "Mover usuarios a televisores",
				fr: "Déplacer les utilisateurs vers les téléviseurs"
			},
			"move-users-tv-txt": {
				en: "How to move users from one television to another, or allow them to move independently",
				it: "Come spostare gli utenti da un televisore a un altro, o permettere che si spostino in autonomia",
				es: "Cómo pasar usuarios de un televisor a otro, o permitirles moverse de forma independiente",
				fr: "Comment déplacer les utilisateurs d'un téléviseur à un autre, ou leur permettre de se déplacer de manière indépendante"
			},
			"real-time-challenges-title": {
				en: "Real-time group challenges",
				it: "Sfide di gruppo in tempo reale",
				es: "Desafíos grupales en tiempo real",
				fr: "Défis de groupe en temps réel"
			},
			"real-time-challenges-txt": {
				en: "How to create free-for-all challenges or team challenges in real time",
				it: "Come creare sfide tutti contro tutti oppure sfide a squadre in tempo reale",
				es: "Cómo crear desafíos todos contra todos o desafíos en equipo en tiempo real",
				fr: "Comment créer des défis gratuits ou des défis d'équipe en temps réel"
			},
			"timers-intensity-flows-title": {
				en: "Timers and Intensity Flows",
				it: "Timer e Intensity Flow",
				es: "Temporizadores y flujos de intensidad",
				fr: "Chronometres et flux d'intensité"
			},
			"timers-intensity-flows-txt": {
				en: "How to create and launch timers and intensity timelines to lead a class",
				it: "Come creare e lanciare timer e timeline di intensità per guidare una classe",
				es: "Cómo crear y lanzar cronómetros y cronogramas de intensidad para dirigir una clase",
				fr: "Comment créer et lancer des chronometres et des chronologies d'intensité pour diriger une classe"
			},
		},
		WorkoutSheetView: {
			"nate-form-sedentary": {
				"en": "Sedentary",
				"it": "Sedentario",
				"es": "Sedentario",
				"fr": "Sédentaire"
			},
			"nate-form-beginner": {
				"en": "Beginner",
				"it": "Principiante",
				"es": "Principiante",
				"fr": "Débutant"
			},
			"nate-form-intermediate": {
				"en": "Intermediate",
				"it": "Intermedio",
				"es": "Intermedio",
				"fr": "Intermédiaire"
			},
			"nate-form-advanced": {
				"en": "Advanced",
				"it": "Avanzato",
				"es": "Avanzado",
				"fr": "Avancé"
			},
			"nate-form-experienced": {
				"en": "Experienced",
				"it": "Esperto",
				"es": "Experimentado",
				"fr": "Expérimenté"
			},
			"nate-form-elite": {
				"en": "Elite",
				"it": "Élite",
				"es": "Élite",
				"fr": "Élite"
			},
			"nate-form-weightLoss": {
				"en": "Weight Loss",
				"it": "Perdita di Peso",
				"es": "Pérdida de Peso",
				"fr": "Perte de Poids"
			},
			"nate-form-enduranceImprovement": {
				"en": "Endurance Improvement",
				"it": "Miglioramento della Resistenza",
				"es": "Mejora de la Resistencia",
				"fr": "Amélioration de l'Endurance"
			},
			"nate-form-muscleBuilding": {
				"en": "Muscle Building",
				"it": "Aumento della Massa Muscolare",
				"es": "Desarrollo Muscular",
				"fr": "Développement Musculaire"
			},
			"nate-form-strength": {
				"en": "Strength",
				"it": "Forza",
				"es": "Fuerza",
				"fr": "Force"
			},
			"nate-form-bodyToning": {
				"en": "Body Toning",
				"it": "Tonificazione",
				"es": "Tonificación Corporal",
				"fr": "Tonification du Corps"
			},
			"nate-form-flexibility": {
				"en": "Flexibility",
				"it": "Flessibilità",
				"es": "Flexibilidad",
				"fr": "Flexibilité"
			},
			"nate-form-generalWellness": {
				"en": "General Wellness",
				"it": "Benessere Generale",
				"es": "Bienestar General",
				"fr": "Bien-être Général"
			},
			"nate-form-rehabilitation": {
				"en": "Rehabilitation",
				"it": "Riabilitazione",
				"es": "Rehabilitación",
				"fr": "Réhabilitation"
			},
			"nate-form-weekly-frequency": {
				"en": "Weekly Frequency",
				"it": "Frequenza settimanale",
				"es": "Frecuencia semanal",
				"fr": "Fréquence hebdomadaire"
			},
			"nate-form-preferred-workout-duration": {
				"en": "Preferred Workout Duration",
				"it": "Durata preferita dell'allenamento",
				"es": "Duración preferida del entrenamiento",
				"fr": "Durée d'entraînement préférée"
			},
			"athlete_fitness_level": {
				"en": "Athlete Fitness Level",
				"it": "Livello di forma fisica dell'atleta",
				"es": "Nivel de condición física del atleta",
				"fr": "Niveau de forme physique de l'athlète"
			},
			"workout_goal": {
				"en": "Workout Goal",
				"it": "Obiettivo dell'allenamento",
				"es": "Objetivo del entrenamiento",
				"fr": "Objectif de l'entraînement"
			},
			"location": {
				"en": "Location",
				"it": "Luogo",
				"es": "Ubicación",
				"fr": "Emplacement"
			},
			"weekly-frequency": {
				"en": "Weekly Frequency",
				"it": "Frequenza Settimanale",
				"es": "Frecuencia Semanal",
				"fr": "Fréquence Hebdomadaire"
			},
			"preferred-workout-duration": {
				"en": "Preferred Workout Duration",
				"it": "Durata Allenamento Preferita",
				"es": "Duración de Entrenamiento Preferida",
				"fr": "Durée d'Entraînement Préférée"
			},
			"want-warmup-cooldown": {
				"en": "Do you want warm-up and cooldown?",
				"it": "Vuoi warm-up e cooldown?",
				"es": "¿Quieres calentamiento y enfriamiento?",
				"fr": "Voulez-vous un échauffement et un retour au calme?"
			},
			"other-instructions": {
				"en": "Other instructions",
				"it": "Altre istruzioni",
				"es": "Otras instrucciones",
				"fr": "Autres instructions"
			},
			"warmup": {
				"en": "Warm-up",
				"it": "Riscaldamento",
				"es": "Calentamiento",
				"fr": "Échauffement"
			},
			"cooldown": {
				"en": "Cooldown",
				"it": "Defaticamento",
				"es": "Enfriamiento",
				"fr": "Retour au calme"
			},
			"nate-compile-form": {
				"en": "Fill out the following form to proceed with creating the workout sheet:",
				"it": "Compila il seguente form per procedere alla creazione della scheda:",
				"es": "Complete el siguiente formulario para proceder con la creación de la hoja de entrenamiento:",
				"fr": "Remplissez le formulaire suivant pour procéder à la création de la fiche d'entraînement:"
			},
			"nate-wks-reminder-save": {
				"en": "Remember to review the sheet and save it to preserve the changes.",
				"it": "Ricordati di verificare la scheda e di salvarla per preservare le modifiche.",
				"es": "Recuerda revisar la hoja y guardarla para preservar los cambios.",
				"fr": "N'oubliez pas de vérifier la fiche et de la sauvegarder pour préserver les modifications."
			},
			"generate-workout": {
				"en": "Generate Workout",
				"it": "Genera Allenamento",
				"es": "Generar Entrenamiento",
				"fr": "Générer Entraînement"
			},
			"generate-with-nate": {
				"en": "Generate with NATE",
				"it": "Genera con NATE",
				"es": "Generar con NATE",
				"fr": "Générer avec NATE"
			}
		}
	};
}

if (typeof module !== "undefined" && module.hasOwnProperty("exports")) {
	module.exports = Resources;
}

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));

//! moment.js locale configuration

;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));

/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */

(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(['moment'], factory);
    } else if (typeof exports === 'object') {
        // Node. Does not work with strict CommonJS, but only CommonJS-like
        // enviroments that support module.exports, like Node.
        try {
            module.exports = factory(require('moment'));
        } catch (e) {
            // If moment is not available, leave the setup up to the user.
            // Like when using moment-timezone or similar moment-based package.
            module.exports = factory;
        }
    }

    if (root) {
        // Globals.
        root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
    }
})(this, function (moment) {
    // `Number#tolocaleString` is tested on plugin initialization.
    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
    // native function will be used to generate formatted output. If the feature
    // test fails, the fallback format function internal to this plugin will be
    // used.
    var toLocaleStringWorks = false;

    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `toLocaleString` will be used for formatting,
    // the plugin will "pre-round" number values using the fallback number format
    // function before passing them to `toLocaleString` for final formatting.
    var toLocaleStringRoundingWorks = false;

    // `Intl.NumberFormat#format` is tested on plugin initialization.
    // If the feature test passes, `intlNumberFormatRoundingWorks` will be set to
    // `true` and the native function will be used to generate formatted output.
    // If the feature test fails, either `Number#tolocaleString` (if
    // `toLocaleStringWorks` is `true`), or the fallback format function internal
    //  to this plugin will be used.
    var intlNumberFormatWorks = false;

    // `Intl.NumberFormat#format` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `Intl.NumberFormat#format` will be used for
    // formatting, the plugin will "pre-round" number values using the fallback number
    // format function before passing them to `Intl.NumberFormat#format` for final
    // formatting.
    var intlNumberFormatRoundingWorks = false;

    // Token type names in order of descending magnitude.
    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");

    var bubbles = [
        {
            type: "seconds",
            targets: [
                { type: "minutes", value: 60 },
                { type: "hours", value: 3600 },
                { type: "days", value: 86400 },
                { type: "weeks", value: 604800 },
                { type: "months", value: 2678400 },
                { type: "years", value: 31536000 }
            ]
        },
        {
            type: "minutes",
            targets: [
                { type: "hours", value: 60 },
                { type: "days", value: 1440 },
                { type: "weeks", value: 10080 },
                { type: "months", value: 44640 },
                { type: "years", value: 525600 }
            ]
        },
        {
            type: "hours",
            targets: [
                { type: "days", value: 24 },
                { type: "weeks", value: 168 },
                { type: "months", value: 744 },
                { type: "years", value: 8760 }
            ]
        },
        {
            type: "days",
            targets: [
                { type: "weeks", value: 7 },
                { type: "months", value: 31 },
                { type: "years", value: 365 }
            ]
        },
        {
            type: "months",
            targets: [
                { type: "years", value: 12 }
            ]
        }
    ];

    // stringIncludes
    function stringIncludes(str, search) {
        if (search.length > str.length) {
          return false;
        }

        return str.indexOf(search) !== -1;
    }

    // repeatZero(qty)
    // Returns "0" repeated `qty` times.
    // `qty` must be a integer >= 0.
    function repeatZero(qty) {
        var result = "";

        while (qty) {
            result += "0";
            qty -= 1;
        }

        return result;
    }

    function stringRound(digits) {
        var digitsArray = digits.split("").reverse();
        var i = 0;
        var carry = true;

        while (carry && i < digitsArray.length) {
            if (i) {
                if (digitsArray[i] === "9") {
                    digitsArray[i] = "0";
                } else {
                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
                    carry = false;
                }
            } else {
                if (parseInt(digitsArray[i], 10) < 5) {
                    carry = false;
                }

                digitsArray[i] = "0";
            }

            i += 1;
        }

        if (carry) {
            digitsArray.push("1");
        }

        return digitsArray.reverse().join("");
    }

    // cachedNumberFormat
    // Returns an `Intl.NumberFormat` instance for the given locale and configuration.
    // On first use of a particular configuration, the instance is cached for fast
    // repeat access.
    function cachedNumberFormat(locale, options) {
        // Create a sorted, stringified version of `options`
        // for use as part of the cache key
        var optionsString = map(
            keys(options).sort(),
            function(key) {
                return key + ':' + options[key];
            }
        ).join(',');

        // Set our cache key
        var cacheKey = locale + '+' + optionsString;

        // If we don't have this configuration cached, configure and cache it
        if (!cachedNumberFormat.cache[cacheKey]) {
            cachedNumberFormat.cache[cacheKey] = Intl.NumberFormat(locale, options);
        }

        // Return the cached version of this configuration
        return cachedNumberFormat.cache[cacheKey];
    }
    cachedNumberFormat.cache = {};

    // formatNumber
    // Formats any number greater than or equal to zero using these options:
    // - userLocale
    // - useToLocaleString
    // - useGrouping
    // - grouping
    // - maximumSignificantDigits
    // - minimumIntegerDigits
    // - fractionDigits
    // - groupingSeparator
    // - decimalSeparator
    //
    // `useToLocaleString` will use `Intl.NumberFormat` or `toLocaleString` for formatting.
    // `userLocale` option is passed through to the formatting function.
    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
    function formatNumber(number, options, userLocale) {
        var useToLocaleString = options.useToLocaleString;
        var useGrouping = options.useGrouping;
        var grouping = useGrouping && options.grouping.slice();
        var maximumSignificantDigits = options.maximumSignificantDigits;
        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
        var fractionDigits = options.fractionDigits || 0;
        var groupingSeparator = options.groupingSeparator;
        var decimalSeparator = options.decimalSeparator;

        if (useToLocaleString && userLocale) {
            var localeStringOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                useGrouping: useGrouping
            };

            if (fractionDigits) {
                localeStringOptions.maximumFractionDigits = fractionDigits;
                localeStringOptions.minimumFractionDigits = fractionDigits;
            }

            // toLocaleString output is "0.0" instead of "0" for HTC browsers
            // when maximumSignificantDigits is set. See #96.
            if (maximumSignificantDigits && number > 0) {
                localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
            }

            if (intlNumberFormatWorks) {
                if (!intlNumberFormatRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }

                return cachedNumberFormat(userLocale, localeStringOptions).format(number);
            } else {
                if (!toLocaleStringRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }

                return number.toLocaleString(userLocale, localeStringOptions);
            }
        }

        var numberString;

        // Add 1 to digit output length for floating point errors workaround. See below.
        if (maximumSignificantDigits) {
            numberString = number.toPrecision(maximumSignificantDigits + 1);
        } else {
            numberString = number.toFixed(fractionDigits + 1);
        }

        var integerString;
        var fractionString;
        var exponentString;

        var temp = numberString.split("e");

        exponentString = temp[1] || "";

        temp = temp[0].split(".");

        fractionString = temp[1] || "";
        integerString = temp[0] || "";

        // Workaround for floating point errors in `toFixed` and `toPrecision`.
        // (3.55).toFixed(1); --> "3.5"
        // (123.55 - 120).toPrecision(2); --> "3.5"
        // (123.55 - 120); --> 3.549999999999997
        // (123.55 - 120).toFixed(2); --> "3.55"
        // Round by examing the string output of the next digit.

        // *************** Implement String Rounding here ***********************
        // Check integerString + fractionString length of toPrecision before rounding.
        // Check length of fractionString from toFixed output before rounding.
        var integerLength = integerString.length;
        var fractionLength = fractionString.length;
        var digitCount = integerLength + fractionLength;
        var digits = integerString + fractionString;

        if (maximumSignificantDigits && digitCount === (maximumSignificantDigits + 1) || !maximumSignificantDigits && fractionLength === (fractionDigits + 1)) {
            // Round digits.
            digits = stringRound(digits);

            if (digits.length === digitCount + 1) {
                integerLength = integerLength + 1;
            }

            // Discard final fractionDigit.
            if (fractionLength) {
                digits = digits.slice(0, -1);
            }

            // Separate integer and fraction.
            integerString = digits.slice(0, integerLength);
            fractionString = digits.slice(integerLength);
        }

        // Trim trailing zeroes from fractionString because toPrecision outputs
        // precision, not significant digits.
        if (maximumSignificantDigits) {
            fractionString = fractionString.replace(/0*$/, "");
        }

        // Handle exponent.
        var exponent = parseInt(exponentString, 10);

        if (exponent > 0) {
            if (fractionString.length <= exponent) {
                fractionString = fractionString + repeatZero(exponent - fractionString.length);

                integerString = integerString + fractionString;
                fractionString = "";
            } else {
                integerString = integerString + fractionString.slice(0, exponent);
                fractionString = fractionString.slice(exponent);
            }
        } else if (exponent < 0) {
            fractionString = (repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString);

            integerString = "0";
        }

        if (!maximumSignificantDigits) {
            // Trim or pad fraction when not using maximumSignificantDigits.
            fractionString = fractionString.slice(0, fractionDigits);

            if (fractionString.length < fractionDigits) {
                fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
            }

            // Pad integer when using minimumIntegerDigits
            // and not using maximumSignificantDigits.
            if (integerString.length < minimumIntegerDigits) {
                integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
            }
        }

        var formattedString = "";

        // Handle grouping.
        if (useGrouping) {
            temp = integerString;
            var group;

            while (temp.length) {
                if (grouping.length) {
                    group = grouping.shift();
                }

                if (formattedString) {
                    formattedString = groupingSeparator + formattedString;
                }

                formattedString = temp.slice(-group) + formattedString;

                temp = temp.slice(0, -group);
            }
        } else {
            formattedString = integerString;
        }

        // Add decimalSeparator and fraction.
        if (fractionString) {
            formattedString = formattedString + decimalSeparator + fractionString;
        }

        return formattedString;
    }

    // durationLabelCompare
    function durationLabelCompare(a, b) {
        if (a.label.length > b.label.length) {
            return -1;
        }

        if (a.label.length < b.label.length) {
            return 1;
        }

        // a must be equal to b
        return 0;
    }

    // durationGetLabels
    function durationGetLabels(token, localeData) {
        var labels = [];

        each(keys(localeData), function (localeDataKey) {
            if (localeDataKey.slice(0, 15) !== "_durationLabels") {
                return;
            }

            var labelType = localeDataKey.slice(15).toLowerCase();

            each(keys(localeData[localeDataKey]), function (labelKey) {
                if (labelKey.slice(0, 1) === token) {
                    labels.push({
                        type: labelType,
                        key: labelKey,
                        label: localeData[localeDataKey][labelKey]
                    });
                }
            });
        });

        return labels;
    }

    // durationPluralKey
    function durationPluralKey(token, integerValue, decimalValue) {
        // Singular for a value of `1`, but not for `1.0`.
        if (integerValue === 1 && decimalValue === null) {
            return token;
        }

        return token + token;
    }

    var engLocale = {
        durationLabelsStandard: {
            S: 'millisecond',
            SS: 'milliseconds',
            s: 'second',
            ss: 'seconds',
            m: 'minute',
            mm: 'minutes',
            h: 'hour',
            hh: 'hours',
            d: 'day',
            dd: 'days',
            w: 'week',
            ww: 'weeks',
            M: 'month',
            MM: 'months',
            y: 'year',
            yy: 'years'
        },
        durationLabelsShort: {
            S: 'msec',
            SS: 'msecs',
            s: 'sec',
            ss: 'secs',
            m: 'min',
            mm: 'mins',
            h: 'hr',
            hh: 'hrs',
            d: 'dy',
            dd: 'dys',
            w: 'wk',
            ww: 'wks',
            M: 'mo',
            MM: 'mos',
            y: 'yr',
            yy: 'yrs'
        },
        durationTimeTemplates: {
            HMS: 'h:mm:ss',
            HM: 'h:mm',
            MS: 'm:ss'
        },
        durationLabelTypes: [
            { type: "standard", string: "__" },
            { type: "short", string: "_" }
        ],
        durationPluralKey: durationPluralKey
    };

    // isArray
    function isArray(array) {
        return Object.prototype.toString.call(array) === "[object Array]";
    }

    // isObject
    function isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }

    // findLast
    function findLast(array, callback) {
        var index = array.length;

        while (index -= 1) {
            if (callback(array[index])) { return array[index]; }
        }
    }

    // find
    function find(array, callback) {
        var index = 0;

        var max = array && array.length || 0;

        var match;

        if (typeof callback !== "function") {
            match = callback;
            callback = function (item) {
                return item === match;
            };
        }

        while (index < max) {
            if (callback(array[index])) { return array[index]; }
            index += 1;
        }
    }

    // each
    function each(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return; }

        while (index < max) {
            if (callback(array[index], index) === false) { return; }
            index += 1;
        }
    }

    // map
    function map(array, callback) {
        var index = 0,
            max = array.length,
            ret = [];

        if (!array || !max) { return ret; }

        while (index < max) {
            ret[index] = callback(array[index], index);
            index += 1;
        }

        return ret;
    }

    // pluck
    function pluck(array, prop) {
        return map(array, function (item) {
            return item[prop];
        });
    }

    // compact
    function compact(array) {
        var ret = [];

        each(array, function (item) {
            if (item) { ret.push(item); }
        });

        return ret;
    }

    // unique
    function unique(array) {
        var ret = [];

        each(array, function (_a) {
            if (!find(ret, _a)) { ret.push(_a); }
        });

        return ret;
    }

    // intersection
    function intersection(a, b) {
        var ret = [];

        each(a, function (_a) {
            each(b, function (_b) {
                if (_a === _b) { ret.push(_a); }
            });
        });

        return unique(ret);
    }

    // rest
    function rest(array, callback) {
        var ret = [];

        each(array, function (item, index) {
            if (!callback(item)) {
                ret = array.slice(index);
                return false;
            }
        });

        return ret;
    }

    // initial
    function initial(array, callback) {
        var reversed = array.slice().reverse();

        return rest(reversed, callback).reverse();
    }

    // extend
    function extend(a, b) {
        for (var key in b) {
            if (b.hasOwnProperty(key)) { a[key] = b[key]; }
        }

        return a;
    }

    // keys
    function keys(a) {
        var ret = [];

        for (var key in a) {
            if (a.hasOwnProperty(key)) { ret.push(key); }
        }

        return ret;
    }

    // any
    function any(array, callback) {
        var index = 0,
            max = array.length;

        if (!array || !max) { return false; }

        while (index < max) {
            if (callback(array[index], index) === true) { return true; }
            index += 1;
        }

        return false;
    }

    // flatten
    function flatten(array) {
        var ret = [];

        each(array, function(child) {
            ret = ret.concat(child);
        });

        return ret;
    }

    function toLocaleStringSupportsLocales() {
        var number = 0;
        try {
            number.toLocaleString('i');
        } catch (e) {
            return e.name === 'RangeError';
        }
        return false;
    }

    function featureTestFormatterRounding(formatter) {
        return formatter(3.55, "en", {
            useGrouping: false,
            minimumIntegerDigits: 1,
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }) === "3.6";
    }

    function featureTestFormatter(formatter) {
        var passed = true;

        // Test minimumIntegerDigits.
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 1 }) === "1";
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 2 }) === "01";
        passed = passed && formatter(1, "en", { minimumIntegerDigits: 3 }) === "001";
        if (!passed) { return false; }

        // Test maximumFractionDigits and minimumFractionDigits.
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 0, minimumFractionDigits: 0 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 1, minimumFractionDigits: 1 }) === "100.0";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 2, minimumFractionDigits: 2 }) === "99.99";
        passed = passed && formatter(99.99, "en", { maximumFractionDigits: 3, minimumFractionDigits: 3 }) === "99.990";
        if (!passed) { return false; }

        // Test maximumSignificantDigits.
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 1 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 2 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 3 }) === "100";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 4 }) === "99.99";
        passed = passed && formatter(99.99, "en", { maximumSignificantDigits: 5 }) === "99.99";
        if (!passed) { return false; }

        // Test grouping.
        passed = passed && formatter(1000, "en", { useGrouping: true }) === "1,000";
        passed = passed && formatter(1000, "en", { useGrouping: false }) === "1000";
        if (!passed) { return false; }

        return true;
    }

    // durationsFormat(durations [, template] [, precision] [, settings])
    function durationsFormat() {
        var args = [].slice.call(arguments);
        var settings = {};
        var durations;

        // Parse arguments.
        each(args, function (arg, index) {
            if (!index) {
                if (!isArray(arg)) {
                    throw "Expected array as the first argument to durationsFormat.";
                }

                durations = arg;
            }

            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        if (!durations || !durations.length) {
            return [];
        }

        settings.returnMomentTypes = true;

        var formattedDurations = map(durations, function (dur) {
            return dur.format(settings);
        });

        // Merge token types from all durations.
        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));

        var largest = settings.largest;

        if (largest) {
            outputTypes = outputTypes.slice(0, largest);
        }

        settings.returnMomentTypes = false;
        settings.outputTypes = outputTypes;

        return map(durations, function (dur) {
            return dur.format(settings);
        });
    }

    // durationFormat([template] [, precision] [, settings])
    function durationFormat() {

        var args = [].slice.call(arguments);
        var settings = extend({}, this.format.defaults);

        // Keep a shadow copy of this moment for calculating remainders.
        // Perform all calculations on positive duration value, handle negative
        // sign at the very end.
        var asMilliseconds = this.asMilliseconds();
        var asMonths = this.asMonths();

        // Treat invalid durations as having a value of 0 milliseconds.
        if (typeof this.isValid === "function" && this.isValid() === false) {
            asMilliseconds = 0;
            asMonths = 0;
        }

        var isNegative = asMilliseconds < 0;

        // Two shadow copies are needed because of the way moment.js handles
        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
        var remainderMonths = moment.duration(Math.abs(asMonths), "months");

        // Parse arguments.
        each(args, function (arg) {
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }

            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }

            if (isObject(arg)) {
                extend(settings, arg);
            }
        });

        var momentTokens = {
            years: "y",
            months: "M",
            weeks: "w",
            days: "d",
            hours: "h",
            minutes: "m",
            seconds: "s",
            milliseconds: "S"
        };

        var tokenDefs = {
            escape: /\[(.+?)\]/,
            years: /\*?[Yy]+/,
            months: /\*?M+/,
            weeks: /\*?[Ww]+/,
            days: /\*?[Dd]+/,
            hours: /\*?[Hh]+/,
            minutes: /\*?m+/,
            seconds: /\*?s+/,
            milliseconds: /\*?S+/,
            general: /.+?/
        };

        // Types array is available in the template function.
        settings.types = types;

        var typeMap = function (token) {
            return find(types, function (type) {
                return tokenDefs[type].test(token);
            });
        };

        var tokenizer = new RegExp(map(types, function (type) {
            return tokenDefs[type].source;
        }).join("|"), "g");

        // Current duration object is available in the template function.
        settings.duration = this;

        // Eval template function and cache template string.
        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;

        // outputTypes and returnMomentTypes are settings to support durationsFormat().

        // outputTypes is an array of moment token types that determines
        // the tokens returned in formatted output. This option overrides
        // trim, largest, stopTrim, etc.
        var outputTypes = settings.outputTypes;

        // returnMomentTypes is a boolean that sets durationFormat to return
        // the processed momentTypes instead of formatted output.
        var returnMomentTypes = settings.returnMomentTypes;

        var largest = settings.largest;

        // Setup stopTrim array of token types.
        var stopTrim = [];

        if (!outputTypes) {
            if (isArray(settings.stopTrim)) {
                settings.stopTrim = settings.stopTrim.join("");
            }

            // Parse stopTrim string to create token types array.
            if (settings.stopTrim) {
                each(settings.stopTrim.match(tokenizer), function (token) {
                    var type = typeMap(token);

                    if (type === "escape" || type === "general") {
                        return;
                    }

                    stopTrim.push(type);
                });
            }
        }

        // Cache moment's locale data.
        var localeData = moment.localeData();

        if (!localeData) {
            localeData = {};
        }

        // Fall back to this plugin's `eng` extension.
        each(keys(engLocale), function (key) {
            if (typeof engLocale[key] === "function") {
                if (!localeData[key]) {
                    localeData[key] = engLocale[key];
                }

                return;
            }

            if (!localeData["_" + key]) {
                localeData["_" + key] = engLocale[key];
            }
        });

        // Replace Duration Time Template strings.
        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
        each(keys(localeData._durationTimeTemplates), function (item) {
            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
        });

        // Determine user's locale.
        var userLocale = settings.userLocale || moment.locale();

        var useLeftUnits = settings.useLeftUnits;
        var usePlural = settings.usePlural;
        var precision = settings.precision;
        var forceLength = settings.forceLength;
        var useGrouping = settings.useGrouping;
        var trunc = settings.trunc;

        // Use significant digits only when precision is greater than 0.
        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
        var significantDigits = useSignificantDigits ? settings.precision : 0;
        var significantDigitsCache = significantDigits;

        var minValue = settings.minValue;
        var isMinValue = false;

        var maxValue = settings.maxValue;
        var isMaxValue = false;

        // formatNumber fallback options.
        var useToLocaleString = settings.useToLocaleString;
        var groupingSeparator = settings.groupingSeparator;
        var decimalSeparator = settings.decimalSeparator;
        var grouping = settings.grouping;

        useToLocaleString = useToLocaleString && (toLocaleStringWorks || intlNumberFormatWorks);

        // Trim options.
        var trim = settings.trim;

        if (isArray(trim)) {
            trim = trim.join(" ");
        }

        if (trim === null && (largest || maxValue || useSignificantDigits)) {
            trim = "all";
        }

        if (trim === null || trim === true || trim === "left" || trim === "right") {
            trim = "large";
        }

        if (trim === false) {
            trim = "";
        }

        var trimIncludes = function (item) {
            return item.test(trim);
        };

        var rLarge = /large/;
        var rSmall = /small/;
        var rBoth = /both/;
        var rMid = /mid/;
        var rAll = /^all|[^sm]all/;
        var rFinal = /final/;

        var trimLarge = largest > 0 || any([rLarge, rBoth, rAll], trimIncludes);
        var trimSmall = any([rSmall, rBoth, rAll], trimIncludes);
        var trimMid = any([rMid, rAll], trimIncludes);
        var trimFinal = any([rFinal, rAll], trimIncludes);

        // Parse format string to create raw tokens array.
        var rawTokens = map(template.match(tokenizer), function (token, index) {
            var type = typeMap(token);

            if (token.slice(0, 1) === "*") {
                token = token.slice(1);

                if (type !== "escape" && type !== "general") {
                    stopTrim.push(type);
                }
            }

            return {
                index: index,
                length: token.length,
                text: "",

                // Replace escaped tokens with the non-escaped token text.
                token: (type === "escape" ? token.replace(tokenDefs.escape, "$1") : token),

                // Ignore type on non-moment tokens.
                type: ((type === "escape" || type === "general") ? null : type)
            };
        });

        // Associate text tokens with moment tokens.
        var currentToken = {
            index: 0,
            length: 0,
            token: "",
            text: "",
            type: null
        };

        var tokens = [];

        if (useLeftUnits) {
            rawTokens.reverse();
        }

        each(rawTokens, function (token) {
            if (token.type) {
                if (currentToken.type || currentToken.text) {
                    tokens.push(currentToken);
                }

                currentToken = token;

                return;
            }

            if (useLeftUnits) {
                currentToken.text = token.token + currentToken.text;
            } else {
                currentToken.text += token.token;
            }
        });

        if (currentToken.type || currentToken.text) {
            tokens.push(currentToken);
        }

        if (useLeftUnits) {
            tokens.reverse();
        }

        // Find unique moment token types in the template in order of
        // descending magnitude.
        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));

        // Exit early if there are no moment token types.
        if (!momentTypes.length) {
            return pluck(tokens, "text").join("");
        }

        // Calculate values for each moment type in the template.
        // For processing the settings, values are associated with moment types.
        // Values will be assigned to tokens at the last step in order to
        // assume nothing about frequency or order of tokens in the template.
        momentTypes = map(momentTypes, function (momentType, index) {
            // Is this the least-magnitude moment token found?
            var isSmallest = ((index + 1) === momentTypes.length);

            // Is this the greatest-magnitude moment token found?
            var isLargest = (!index);

            // Get the raw value in the current units.
            var rawValue;

            if (momentType === "years" || momentType === "months") {
                rawValue = remainderMonths.as(momentType);
            } else {
                rawValue = remainder.as(momentType);
            }

            var wholeValue = Math.floor(rawValue);
            var decimalValue = rawValue - wholeValue;

            var token = find(tokens, function (token) {
                return momentType === token.type;
            });

            if (isLargest && maxValue && rawValue > maxValue) {
                isMaxValue = true;
            }

            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) {
                isMinValue = true;
            }

            // Note the length of the largest-magnitude moment token:
            // if it is greater than one and forceLength is not set,
            // then default forceLength to `true`.
            //
            // Rationale is this: If the template is "h:mm:ss" and the
            // moment value is 5 minutes, the user-friendly output is
            // "5:00", not "05:00". We shouldn't pad the `minutes` token
            // even though it has length of two if the template is "h:mm:ss";
            //
            // If the minutes output should always include the leading zero
            // even when the hour is trimmed then set `{ forceLength: true }`
            // to output "05:00". If the template is "hh:mm:ss", the user
            // clearly wanted everything padded so we should output "05:00";
            //
            // If the user wants the full padded output, they can use
            // template "hh:mm:ss" and set `{ trim: false }` to output
            // "00:05:00".
            if (isLargest && forceLength === null && token.length > 1) {
                forceLength = true;
            }

            // Update remainder.
            remainder.subtract(wholeValue, momentType);
            remainderMonths.subtract(wholeValue, momentType);

            return {
                rawValue: rawValue,
                wholeValue: wholeValue,
                // Decimal value is only retained for the least-magnitude
                // moment type in the format template.
                decimalValue: isSmallest ? decimalValue : 0,
                isSmallest: isSmallest,
                isLargest: isLargest,
                type: momentType,
                // Tokens can appear multiple times in a template string,
                // but all instances must share the same length.
                tokenLength: token.length
            };
        });

        var truncMethod = trunc ? Math.floor : Math.round;
        var truncate = function (value, places) {
            var factor = Math.pow(10, places);
            return truncMethod(value * factor) / factor;
        };

        var foundFirst = false;
        var bubbled = false;

        var formatValue = function (momentType, index) {
            var formatOptions = {
                useGrouping: useGrouping,
                groupingSeparator: groupingSeparator,
                decimalSeparator: decimalSeparator,
                grouping: grouping,
                useToLocaleString: useToLocaleString
            };

            if (useSignificantDigits) {
                if (significantDigits <= 0) {
                    momentType.rawValue = 0;
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                } else {
                    formatOptions.maximumSignificantDigits = significantDigits;
                    momentType.significantDigits = significantDigits;
                }
            }

            if (isMaxValue && !bubbled) {
                if (momentType.isLargest) {
                    momentType.wholeValue = maxValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (isMinValue && !bubbled) {
                if (momentType.isSmallest) {
                    momentType.wholeValue = minValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }

            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
                // Apply precision to least significant token value.
                if (precision < 0) {
                    momentType.value = truncate(momentType.wholeValue, precision);
                } else if (precision === 0) {
                    momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
                } else { // precision > 0
                    if (useSignificantDigits) {
                        if (trunc) {
                            momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
                        } else {
                            momentType.value = momentType.rawValue;
                        }

                        if (momentType.wholeValue) {
                            significantDigits -= momentType.wholeValue.toString().length;
                        }
                    } else {
                        formatOptions.fractionDigits = precision;

                        if (trunc) {
                            momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
                        } else {
                            momentType.value = momentType.wholeValue + momentType.decimalValue;
                        }
                    }
                }
            } else {
                if (useSignificantDigits && momentType.wholeValue) {
                    // Outer Math.round required here to handle floating point errors.
                    momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));

                    significantDigits -= momentType.wholeValue.toString().length;
                } else {
                    momentType.value = momentType.wholeValue;
                }
            }

            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
                formatOptions.minimumIntegerDigits = momentType.tokenLength;

                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) {
                    delete formatOptions.maximumSignificantDigits;
                }
            }

            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */ || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                foundFirst = true;
            }

            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);

            formatOptions.useGrouping = false;
            formatOptions.decimalSeparator = ".";
            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");

            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") {
                momentType.formattedValueMS = formatNumber(momentType.value, {
                    minimumIntegerDigits: 3,
                    useGrouping: false
                }, "en").slice(0, 2);
            }

            return momentType;
        };

        // Calculate formatted values.
        momentTypes = map(momentTypes, formatValue);
        momentTypes = compact(momentTypes);

        // Bubble rounded values.
        if (momentTypes.length > 1) {
            var findType = function (type) {
                return find(momentTypes, function (momentType) {
                    return momentType.type === type;
                });
            };

            var bubbleTypes = function (bubble) {
                var bubbleMomentType = findType(bubble.type);

                if (!bubbleMomentType) {
                    return;
                }

                each(bubble.targets, function (target) {
                    var targetMomentType = findType(target.type);

                    if (!targetMomentType) {
                        return;
                    }

                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
                        bubbleMomentType.rawValue = 0;
                        bubbleMomentType.wholeValue = 0;
                        bubbleMomentType.decimalValue = 0;
                        targetMomentType.rawValue += 1;
                        targetMomentType.wholeValue += 1;
                        targetMomentType.decimalValue = 0;
                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
                        bubbled = true;
                    }
                });
            };

            each(bubbles, bubbleTypes);
        }

        // Recalculate formatted values.
        if (bubbled) {
            foundFirst = false;
            significantDigits = significantDigitsCache;
            momentTypes = map(momentTypes, formatValue);
            momentTypes = compact(momentTypes);
        }

        if (outputTypes && !(isMaxValue && !settings.trim)) {
            momentTypes = map(momentTypes, function (momentType) {
                if (find(outputTypes, function (outputType) {
                    return momentType.type === outputType;
                })) {
                    return momentType;
                }

                return null;
            });

            momentTypes = compact(momentTypes);
        } else {
            // Trim Large.
            if (trimLarge) {
                momentTypes = rest(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - the smallest moment type
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
                });
            }

            // Largest.
            if (largest && momentTypes.length) {
                momentTypes = momentTypes.slice(0, largest);
            }

            // Trim Small.
            if (trimSmall && momentTypes.length > 1) {
                momentTypes = initial(momentTypes, function (momentType) {
                    // Stop trimming on:
                    // - a type marked for stopTrim
                    // - a type that has a whole value
                    // - the largest momentType
                    return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
                });
            }

            // Trim Mid.
            if (trimMid) {
                momentTypes = map(momentTypes, function (momentType, index) {
                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) {
                        return null;
                    }

                    return momentType;
                });

                momentTypes = compact(momentTypes);
            }

            // Trim Final.
            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) {
                momentTypes = [];
            }
        }

        if (returnMomentTypes) {
            return momentTypes;
        }

        // Localize and pluralize unit labels.
        each(tokens, function (token) {
            var key = momentTokens[token.type];

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!key || !momentType) {
                return;
            }

            var values = momentType.formattedValueEn.split(".");

            values[0] = parseInt(values[0], 10);

            if (values[1]) {
                values[1] = parseFloat("0." + values[1], 10);
            } else {
                values[1] = null;
            }

            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);

            var labels = durationGetLabels(key, localeData);

            var autoLocalized = false;

            var pluralizedLabels = {};

            // Auto-Localized unit labels.
            each(localeData._durationLabelTypes, function (labelType) {
                var label = find(labels, function (label) {
                    return label.type === labelType.type && label.key === pluralKey;
                });

                if (label) {
                    pluralizedLabels[label.type] = label.label;

                    if (stringIncludes(token.text, labelType.string)) {
                        token.text = token.text.replace(labelType.string, label.label);
                        autoLocalized = true;
                    }
                }
            });

            // Auto-pluralized unit labels.
            if (usePlural && !autoLocalized) {
                labels.sort(durationLabelCompare);

                each(labels, function (label) {
                    if (pluralizedLabels[label.type] === label.label) {
                        if (stringIncludes(token.text, label.label)) {
                            // Stop checking this token if its label is already
                            // correctly pluralized.
                            return false;
                        }

                        // Skip this label if it is correct, but not present in
                        // the token's text.
                        return;
                    }

                    if (stringIncludes(token.text, label.label)) {
                        // Replece this token's label and stop checking.
                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
                        return false;
                    }
                });
            }
        });

        // Build ouptut.
        tokens = map(tokens, function (token) {
            if (!token.type) {
                return token.text;
            }

            var momentType = find(momentTypes, function (momentType) {
                return momentType.type === token.type;
            });

            if (!momentType) {
                return "";
            }

            var out = "";

            if (useLeftUnits) {
                out += token.text;
            }

            if (isNegative && isMaxValue || !isNegative && isMinValue) {
                out += "< ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && isMinValue || !isNegative && isMaxValue) {
                out += "> ";
                isMaxValue = false;
                isMinValue = false;
            }

            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                out += "-";
                isNegative = false;
            }

            if (token.type === "milliseconds" && momentType.formattedValueMS) {
                out += momentType.formattedValueMS;
            } else {
                out += momentType.formattedValue;
            }

            if (!useLeftUnits) {
                out += token.text;
            }

            return out;
        });

        // Trim leading and trailing comma, space, colon, and dot.
        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
    }

    // defaultFormatTemplate
    function defaultFormatTemplate() {
        var dur = this.duration;

        var findType = function findType(type) {
            return dur._data[type];
        };

        var firstType = find(this.types, findType);

        var lastType = findLast(this.types, findType);

        // Default template strings for each duration dimension type.
        switch (firstType) {
            case "milliseconds":
                return "S __";
            case "seconds": // Fallthrough.
            case "minutes":
                return "*_MS_";
            case "hours":
                return "_HMS_";
            case "days": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "d __";
                }
            case "weeks":
                if (firstType === lastType) {
                    return "w __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "w __, d __, h __";
            case "months": // Possible Fallthrough.
                if (firstType === lastType) {
                    return "M __";
                }
            case "years":
                if (firstType === lastType) {
                    return "y __";
                }

                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, M __, d __";
            default:
                if (this.trim === null) {
                    this.trim = "both";
                }

                return "y __, d __, h __, m __, s __";
        }
    }

    // init
    function init(context) {
        if (!context) {
            throw "Moment Duration Format init cannot find moment instance.";
        }

        context.duration.format = durationsFormat;
        context.duration.fn.format = durationFormat;

        context.duration.fn.format.defaults = {
            // Many options are defaulted to `null` to distinguish between
            // 'not set' and 'set to `false`'

            // trim
            // Can be a string, a delimited list of strings, an array of strings,
            // or a boolean.
            // "large" - will trim largest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "small" - will trim smallest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "both" - will execute "large" trim then "small" trim.
            // "mid" - will trim any zero-value tokens that are not the first or
            // last tokens. Usually used in conjunction with "large" or "both".
            // e.g. "large mid" or "both mid".
            // "final" - will trim the final token if it is zero-value. Use this
            // option with "large" or "both" to output an empty string when
            // formatting a zero-value duration. e.g. "large final" or "both final".
            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
            // "left" - maps to "large" to support plugin's version 1 API.
            // "right" - maps to "large" to support plugin's version 1 API.
            // `false` - template tokens are not trimmed.
            // `true` - treated as "large".
            // `null` - treated as "large".
            trim: null,

            // stopTrim
            // A moment token string, a delimited set of moment token strings,
            // or an array of moment token strings. Trimming will stop when a token
            // listed in this option is reached. A "*" character in the format
            // template string will also mark a moment token as stopTrim.
            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
            stopTrim: null,

            // largest
            // Set to a positive integer to output only the "n" largest-magnitude
            // moment tokens that have a value. All lesser-magnitude moment tokens
            // will be ignored. This option takes effect even if `trim` is set
            // to `false`.
            largest: null,

            // maxValue
            // Use `maxValue` to render generalized output for large duration values,
            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
            /// applied to the greatest-magnitude moment token in the format template.
            maxValue: null,

            // minValue
            // Use `minValue` to render generalized output for small duration values,
            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
            // applied to the least-magnitude moment token in the format template.
            minValue: null,

            // precision
            // If a positive integer, number of decimal fraction digits to render.
            // If a negative integer, number of integer place digits to truncate to 0.
            // If `useSignificantDigits` is set to `true` and `precision` is a positive
            // integer, sets the maximum number of significant digits used in the
            // formatted output.
            precision: 0,

            // trunc
            // Default behavior rounds final token value. Set to `true` to
            // truncate final token value, which was the default behavior in
            // version 1 of this plugin.
            trunc: false,

            // forceLength
            // Force first moment token with a value to render at full length
            // even when template is trimmed and first moment token has length of 1.
            forceLength: null,

            // userLocale
            // Formatted numerical output is rendered using `toLocaleString`
            // and the locale of the user's environment. Set this option to render
            // numerical output using a different locale. Unit names are rendered
            // and detected using the locale set in moment.js, which can be different
            // from the locale of user's environment.
            userLocale: null,

            // usePlural
            // Will automatically singularize or pluralize unit names when they
            // appear in the text associated with each moment token. Standard and
            // short unit labels are singularized and pluralized, based on locale.
            // e.g. in english, "1 second" or "1 sec" would be rendered instead
            // of "1 seconds" or "1 secs". The default pluralization function
            // renders a plural label for a value with decimal precision.
            // e.g. "1.0 seconds" is never rendered as "1.0 second".
            // Label types and pluralization function are configurable in the
            // localeData extensions.
            usePlural: true,

            // useLeftUnits
            // The text to the right of each moment token in a format string
            // is treated as that token's units for the purposes of trimming,
            // singularizing, and auto-localizing.
            // e.g. "h [hours], m [minutes], s [seconds]".
            // To properly singularize or localize a format string such as
            // "[hours] h, [minutes] m, [seconds] s", where the units appear
            // to the left of each moment token, set useLeftUnits to `true`.
            // This plugin is not tested in the context of rtl text.
            useLeftUnits: false,

            // useGrouping
            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useGrouping: true,

            // useSignificantDigits
            // Treat the `precision` option as the maximum significant digits
            // to be rendered. Precision must be a positive integer. Significant
            // digits extend across unit types,
            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useSignificantDigits: false,

            // template
            // The template string used to format the duration. May be a function
            // or a string. Template functions are executed with the `this` binding
            // of the settings object so that template strings may be dynamically
            // generated based on the duration object (accessible via `this.duration`)
            // or any of the other settings. Leading and trailing space, comma,
            // period, and colon characters are trimmed from the resulting string.
            template: defaultFormatTemplate,

            // useToLocaleString
            // Set this option to `false` to ignore the `toLocaleString` feature
            // test and force the use of the `formatNumber` fallback function
            // included in this plugin.
            useToLocaleString: true,

            // formatNumber fallback options.
            // When `toLocaleString` is detected and passes the feature test, the
            // following options will have no effect: `toLocaleString` will be used
            // for formatting and the grouping separator, decimal separator, and
            // integer digit grouping will be determined by the user locale.

            // groupingSeparator
            // The integer digit grouping separator used when using the fallback
            // formatNumber function.
            groupingSeparator: ",",

            // decimalSeparator
            // The decimal separator used when using the fallback formatNumber
            // function.
            decimalSeparator: ".",

            // grouping
            // The integer digit grouping used when using the fallback formatNumber
            // function. Must be an array. The default value of `[3]` gives the
            // standard 3-digit thousand/million/billion digit groupings for the
            // "en" locale. Setting this option to `[3, 2]` would generate the
            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
            grouping: [3]
        };

        context.updateLocale('en', engLocale);
    }

    // Run feature tests for `Number#toLocaleString`.
    var toLocaleStringFormatter = function(number, locale, options) {
        return number.toLocaleString(locale, options);
    };

    toLocaleStringWorks = toLocaleStringSupportsLocales() && featureTestFormatter(toLocaleStringFormatter);
    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestFormatterRounding(toLocaleStringFormatter);

    // Run feature tests for `Intl.NumberFormat#format`.
    var intlNumberFormatFormatter = function(number, locale, options) {
        if (typeof window !== 'undefined' && window && window.Intl && window.Intl.NumberFormat) {
            return window.Intl.NumberFormat(locale, options).format(number);
        }
    };

    intlNumberFormatWorks = featureTestFormatter(intlNumberFormatFormatter);
    intlNumberFormatRoundingWorks = intlNumberFormatWorks && featureTestFormatterRounding(intlNumberFormatFormatter);

    // Initialize duration format on the global moment instance.
    init(moment);

    // Return the init function so that duration format can be
    // initialized on other moment instances.
    return init;
});

/*
 * Slim v4.6.4 - Image Cropping Made Easy
 * Copyright (c) 2017 Rik Schennink - http://slimimagecropper.com
 */
window.Slim = (function () {

	// custom event polyfill for IE10
	(function () {
		if (typeof window.CustomEvent === 'function') return false;

		function CustomEvent(event, params) {
			params = params || { bubbles: false, cancelable: false, detail: undefined };
			var evt = document.createEvent('CustomEvent');
			evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
			return evt;
		}

		CustomEvent.prototype = window.Event.prototype;

		window.CustomEvent = CustomEvent;
	})();
	/*
	* JavaScript Load Image
	* https://github.com/blueimp/JavaScript-Load-Image
	*
	* Copyright 2011, Sebastian Tschan
	* https://blueimp.net
	*
	* Licensed under the MIT license:
	* http://www.opensource.org/licenses/MIT
	*/

	/*global define, module, window, document, URL, webkitURL, FileReader */

	// Loads an image for a given File object.
	// Invokes the callback with an img or optional canvas
	// element (if supported by the browser) as parameter:
	var loadImage = function (file, callback, options) {
		var img = document.createElement('img')
		var url
		var oUrl
		img.onerror = callback
		img.onload = function () {
			if (oUrl && !(options && options.noRevoke)) {
				loadImage.revokeObjectURL(oUrl)
			}
			if (callback) {
				callback(loadImage.scale(img, options))
			}
		}
		if (loadImage.isInstanceOf('Blob', file) ||
			// Files are also Blob instances, but some browsers
			// (Firefox 3.6) support the File API but not Blobs:
			loadImage.isInstanceOf('File', file)) {
			url = oUrl = loadImage.createObjectURL(file)
			// Store the file type for resize processing:
			img._type = file.type
		} else if (typeof file === 'string') {
			url = file
			if (options && options.crossOrigin) {
				img.crossOrigin = options.crossOrigin
			}
		} else {
			return false
		}
		if (url) {
			img.src = url
			return img
		}
		return loadImage.readFile(file, function (e) {
			var target = e.target
			if (target && target.result) {
				img.src = target.result
			} else {
				if (callback) {
					callback(e)
				}
			}
		})
	}
	// The check for URL.revokeObjectURL fixes an issue with Opera 12,
	// which provides URL.createObjectURL but doesn't properly implement it:
	var urlAPI = (window.createObjectURL && window) ||
		(window.URL && URL.revokeObjectURL && URL) ||
		(window.webkitURL && webkitURL)

	loadImage.isInstanceOf = function (type, obj) {
		// Cross-frame instanceof check
		return Object.prototype.toString.call(obj) === '[object ' + type + ']'
	}

	// Transform image coordinates, allows to override e.g.
	// the canvas orientation based on the orientation option,
	// gets canvas, options passed as arguments:
	loadImage.transformCoordinates = function () {
		return
	}

	// Returns transformed options, allows to override e.g.
	// maxWidth, maxHeight and crop options based on the aspectRatio.
	// gets img, options passed as arguments:
	loadImage.getTransformedOptions = function (img, options) {
		var aspectRatio = options.aspectRatio
		var newOptions
		var i
		var width
		var height
		if (!aspectRatio) {
			return options
		}
		newOptions = {}
		for (i in options) {
			if (options.hasOwnProperty(i)) {
				newOptions[i] = options[i]
			}
		}
		newOptions.crop = true
		width = img.naturalWidth || img.width
		height = img.naturalHeight || img.height
		if (width / height > aspectRatio) {
			newOptions.maxWidth = height * aspectRatio
			newOptions.maxHeight = height
		} else {
			newOptions.maxWidth = width
			newOptions.maxHeight = width / aspectRatio
		}
		return newOptions
	}

	// Canvas render method, allows to implement a different rendering algorithm:
	loadImage.renderImageToCanvas = function (
		canvas,
		img,
		sourceX,
		sourceY,
		sourceWidth,
		sourceHeight,
		destX,
		destY,
		destWidth,
		destHeight
	) {
		canvas.getContext('2d').drawImage(
			img,
			sourceX,
			sourceY,
			sourceWidth,
			sourceHeight,
			destX,
			destY,
			destWidth,
			destHeight
		)
		return canvas
	}

	// This method is used to determine if the target image
	// should be a canvas element:
	loadImage.hasCanvasOption = function (options) {
		return options.canvas || options.crop || !!options.aspectRatio
	}

	// Scales and/or crops the given image (img or canvas HTML element)
	// using the given options.
	// Returns a canvas object if the browser supports canvas
	// and the hasCanvasOption method returns true or a canvas
	// object is passed as image, else the scaled image:
	loadImage.scale = function (img, options) {
		options = options || {}
		var canvas = document.createElement('canvas')
		var useCanvas = img.getContext ||
			(loadImage.hasCanvasOption(options) && canvas.getContext)
		var width = img.naturalWidth || img.width
		var height = img.naturalHeight || img.height
		var destWidth = width
		var destHeight = height
		var maxWidth
		var maxHeight
		var minWidth
		var minHeight
		var sourceWidth
		var sourceHeight
		var sourceX
		var sourceY
		var pixelRatio
		var downsamplingRatio
		var tmp
		function scaleUp() {
			var scale = Math.max(
				(minWidth || destWidth) / destWidth,
				(minHeight || destHeight) / destHeight
			)
			if (scale > 1) {
				destWidth *= scale
				destHeight *= scale
			}
		}
		function scaleDown() {
			var scale = Math.min(
				(maxWidth || destWidth) / destWidth,
				(maxHeight || destHeight) / destHeight
			)
			if (scale < 1) {
				destWidth *= scale
				destHeight *= scale
			}
		}
		if (useCanvas) {
			options = loadImage.getTransformedOptions(img, options)
			sourceX = options.left || 0
			sourceY = options.top || 0
			if (options.sourceWidth) {
				sourceWidth = options.sourceWidth
				if (options.right !== undefined && options.left === undefined) {
					sourceX = width - sourceWidth - options.right
				}
			} else {
				sourceWidth = width - sourceX - (options.right || 0)
			}
			if (options.sourceHeight) {
				sourceHeight = options.sourceHeight
				if (options.bottom !== undefined && options.top === undefined) {
					sourceY = height - sourceHeight - options.bottom
				}
			} else {
				sourceHeight = height - sourceY - (options.bottom || 0)
			}
			destWidth = sourceWidth
			destHeight = sourceHeight
		}
		maxWidth = options.maxWidth
		maxHeight = options.maxHeight
		minWidth = options.minWidth
		minHeight = options.minHeight
		if (useCanvas && maxWidth && maxHeight && options.crop) {
			destWidth = maxWidth
			destHeight = maxHeight
			tmp = sourceWidth / sourceHeight - maxWidth / maxHeight
			if (tmp < 0) {
				sourceHeight = maxHeight * sourceWidth / maxWidth
				if (options.top === undefined && options.bottom === undefined) {
					sourceY = (height - sourceHeight) / 2
				}
			} else if (tmp > 0) {
				sourceWidth = maxWidth * sourceHeight / maxHeight
				if (options.left === undefined && options.right === undefined) {
					sourceX = (width - sourceWidth) / 2
				}
			}
		} else {
			if (options.contain || options.cover) {
				minWidth = maxWidth = maxWidth || minWidth
				minHeight = maxHeight = maxHeight || minHeight
			}
			if (options.cover) {
				scaleDown()
				scaleUp()
			} else {
				scaleUp()
				scaleDown()
			}
		}
		if (useCanvas) {
			pixelRatio = options.pixelRatio
			if (pixelRatio > 1) {
				canvas.style.width = destWidth + 'px'
				canvas.style.height = destHeight + 'px'
				destWidth *= pixelRatio
				destHeight *= pixelRatio
				canvas.getContext('2d').scale(pixelRatio, pixelRatio)
			}
			downsamplingRatio = options.downsamplingRatio
			if (downsamplingRatio > 0 && downsamplingRatio < 1 &&
				destWidth < sourceWidth && destHeight < sourceHeight) {
				while (sourceWidth * downsamplingRatio > destWidth) {
					canvas.width = sourceWidth * downsamplingRatio
					canvas.height = sourceHeight * downsamplingRatio
					loadImage.renderImageToCanvas(
						canvas,
						img,
						sourceX,
						sourceY,
						sourceWidth,
						sourceHeight,
						0,
						0,
						canvas.width,
						canvas.height
					)
					sourceWidth = canvas.width
					sourceHeight = canvas.height
					img = document.createElement('canvas')
					img.width = sourceWidth
					img.height = sourceHeight
					loadImage.renderImageToCanvas(
						img,
						canvas,
						0,
						0,
						sourceWidth,
						sourceHeight,
						0,
						0,
						sourceWidth,
						sourceHeight
					)
				}
			}
			canvas.width = destWidth
			canvas.height = destHeight
			loadImage.transformCoordinates(
				canvas,
				options
			)
			return loadImage.renderImageToCanvas(
				canvas,
				img,
				sourceX,
				sourceY,
				sourceWidth,
				sourceHeight,
				0,
				0,
				destWidth,
				destHeight
			)
		}
		img.width = destWidth
		img.height = destHeight
		return img
	}

	loadImage.createObjectURL = function (file) {
		return urlAPI ? urlAPI.createObjectURL(file) : false
	}

	loadImage.revokeObjectURL = function (url) {
		return urlAPI ? urlAPI.revokeObjectURL(url) : false
	}

	// Loads a given File object via FileReader interface,
	// invokes the callback with the event object (load or error).
	// The result can be read via event.target.result:
	loadImage.readFile = function (file, callback, method) {
		if (window.FileReader) {
			var fileReader = new FileReader()
			fileReader.onload = fileReader.onerror = callback
			method = method || 'readAsDataURL'
			if (fileReader[method]) {
				fileReader[method](file)
				return fileReader
			}
		}
		return false
	}

	var originalHasCanvasOption = loadImage.hasCanvasOption
	var originalTransformCoordinates = loadImage.transformCoordinates
	var originalGetTransformedOptions = loadImage.getTransformedOptions

	// This method is used to determine if the target image
	// should be a canvas element:
	loadImage.hasCanvasOption = function (options) {
		return !!options.orientation ||
			originalHasCanvasOption.call(loadImage, options)
	}

	// Transform image orientation based on
	// the given EXIF orientation option:
	loadImage.transformCoordinates = function (canvas, options) {
		originalTransformCoordinates.call(loadImage, canvas, options)
		var ctx = canvas.getContext('2d')
		var width = canvas.width
		var height = canvas.height
		var styleWidth = canvas.style.width
		var styleHeight = canvas.style.height
		var orientation = options.orientation
		if (!orientation || orientation > 8) {
			return
		}
		if (orientation > 4) {
			canvas.width = height
			canvas.height = width
			canvas.style.width = styleHeight
			canvas.style.height = styleWidth
		}
		switch (orientation) {
			case 2:
				// horizontal flip
				ctx.translate(width, 0)
				ctx.scale(-1, 1)
				break
			case 3:
				// 180° rotate left
				ctx.translate(width, height)
				ctx.rotate(Math.PI)
				break
			case 4:
				// vertical flip
				ctx.translate(0, height)
				ctx.scale(1, -1)
				break
			case 5:
				// vertical flip + 90 rotate right
				ctx.rotate(0.5 * Math.PI)
				ctx.scale(1, -1)
				break
			case 6:
				// 90° rotate right
				ctx.rotate(0.5 * Math.PI)
				ctx.translate(0, -height)
				break
			case 7:
				// horizontal flip + 90 rotate right
				ctx.rotate(0.5 * Math.PI)
				ctx.translate(width, -height)
				ctx.scale(-1, 1)
				break
			case 8:
				// 90° rotate left
				ctx.rotate(-0.5 * Math.PI)
				ctx.translate(-width, 0)
				break
		}
	}

	// Transforms coordinate and dimension options
	// based on the given orientation option:
	loadImage.getTransformedOptions = function (img, opts) {
		var options = originalGetTransformedOptions.call(loadImage, img, opts)
		var orientation = options.orientation
		var newOptions
		var i
		if (!orientation || orientation > 8 || orientation === 1) {
			return options
		}
		newOptions = {}
		for (i in options) {
			if (options.hasOwnProperty(i)) {
				newOptions[i] = options[i]
			}
		}
		switch (options.orientation) {
			case 2:
				// horizontal flip
				newOptions.left = options.right
				newOptions.right = options.left
				break
			case 3:
				// 180° rotate left
				newOptions.left = options.right
				newOptions.top = options.bottom
				newOptions.right = options.left
				newOptions.bottom = options.top
				break
			case 4:
				// vertical flip
				newOptions.top = options.bottom
				newOptions.bottom = options.top
				break
			case 5:
				// vertical flip + 90 rotate right
				newOptions.left = options.top
				newOptions.top = options.left
				newOptions.right = options.bottom
				newOptions.bottom = options.right
				break
			case 6:
				// 90° rotate right
				newOptions.left = options.top
				newOptions.top = options.right
				newOptions.right = options.bottom
				newOptions.bottom = options.left
				break
			case 7:
				// horizontal flip + 90 rotate right
				newOptions.left = options.bottom
				newOptions.top = options.right
				newOptions.right = options.top
				newOptions.bottom = options.left
				break
			case 8:
				// 90° rotate left
				newOptions.left = options.bottom
				newOptions.top = options.left
				newOptions.right = options.top
				newOptions.bottom = options.right
				break
		}
		if (options.orientation > 4) {
			newOptions.maxWidth = options.maxHeight
			newOptions.maxHeight = options.maxWidth
			newOptions.minWidth = options.minHeight
			newOptions.minHeight = options.minWidth
			newOptions.sourceWidth = options.sourceHeight
			newOptions.sourceHeight = options.sourceWidth
		}
		return newOptions
	}

	var hasblobSlice = window.Blob && (Blob.prototype.slice ||
		Blob.prototype.webkitSlice || Blob.prototype.mozSlice)

	loadImage.blobSlice = hasblobSlice && function () {
		var slice = this.slice || this.webkitSlice || this.mozSlice
		return slice.apply(this, arguments)
	}

	loadImage.metaDataParsers = {
		jpeg: {
			0xffe1: [] // APP1 marker
		}
	}

	// Parses image meta data and calls the callback with an object argument
	// with the following properties:
	// * imageHead: The complete image head as ArrayBuffer (Uint8Array for IE10)
	// The options arguments accepts an object and supports the following properties:
	// * maxMetaDataSize: Defines the maximum number of bytes to parse.
	// * disableImageHead: Disables creating the imageHead property.
	loadImage.parseMetaData = function (file, callback, options) {
		options = options || {}
		var that = this
		// 256 KiB should contain all EXIF/ICC/IPTC segments:
		var maxMetaDataSize = options.maxMetaDataSize || 262144
		var data = {}
		var noMetaData = !(window.DataView && file && file.size >= 12 &&
			file.type === 'image/jpeg' && loadImage.blobSlice)
		if (noMetaData || !loadImage.readFile(
			loadImage.blobSlice.call(file, 0, maxMetaDataSize),
			function (e) {
				if (e.target.error) {
					// FileReader error
					//console.log(e.target.error)
					callback(data)
					return
				}
				// Note on endianness:
				// Since the marker and length bytes in JPEG files are always
				// stored in big endian order, we can leave the endian parameter
				// of the DataView methods undefined, defaulting to big endian.
				var buffer = e.target.result
				var dataView = new DataView(buffer)
				var offset = 2
				var maxOffset = dataView.byteLength - 4
				var headLength = offset
				var markerBytes
				var markerLength
				var parsers
				var i
				// Check for the JPEG marker (0xffd8):
				if (dataView.getUint16(0) === 0xffd8) {
					while (offset < maxOffset) {
						markerBytes = dataView.getUint16(offset)
						// Search for APPn (0xffeN) and COM (0xfffe) markers,
						// which contain application-specific meta-data like
						// Exif, ICC and IPTC data and text comments:
						if ((markerBytes >= 0xffe0 && markerBytes <= 0xffef) ||
							markerBytes === 0xfffe) {
							// The marker bytes (2) are always followed by
							// the length bytes (2), indicating the length of the
							// marker segment, which includes the length bytes,
							// but not the marker bytes, so we add 2:
							markerLength = dataView.getUint16(offset + 2) + 2
							if (offset + markerLength > dataView.byteLength) {
								//console.log('Invalid meta data: Invalid segment size.')
								break
							}
							parsers = loadImage.metaDataParsers.jpeg[markerBytes]
							if (parsers) {
								for (i = 0; i < parsers.length; i += 1) {
									parsers[i].call(
										that,
										dataView,
										offset,
										markerLength,
										data,
										options
									)
								}
							}
							offset += markerLength
							headLength = offset
						} else {
							// Not an APPn or COM marker, probably safe to
							// assume that this is the end of the meta data
							break
						}
					}
					// Meta length must be longer than JPEG marker (2)
					// plus APPn marker (2), followed by length bytes (2):
					if (!options.disableImageHead && headLength > 6) {
						if (buffer.slice) {
							data.imageHead = buffer.slice(0, headLength)
						} else {
							// Workaround for IE10, which does not yet
							// support ArrayBuffer.slice:
							data.imageHead = new Uint8Array(buffer)
								.subarray(0, headLength)
						}
					}
				} else {
					//console.log('Invalid JPEG file: Missing JPEG marker.')
				}
				callback(data)
			},
			'readAsArrayBuffer'
		)) {
			callback(data)
		}
	}

	loadImage.ExifMap = function () {
		return this
	}

	loadImage.ExifMap.prototype.map = {
		'Orientation': 0x0112
	}

	loadImage.ExifMap.prototype.get = function (id) {
		return this[id] || this[this.map[id]]
	}

	loadImage.getExifThumbnail = function (dataView, offset, length) {
		var hexData,
			i,
			b
		if (!length || offset + length > dataView.byteLength) {
			//console.log('Invalid Exif data: Invalid thumbnail data.')
			return
		}
		hexData = []
		for (i = 0; i < length; i += 1) {
			b = dataView.getUint8(offset + i)
			hexData.push((b < 16 ? '0' : '') + b.toString(16))
		}
		return 'data:image/jpeg,%' + hexData.join('%')
	}

	loadImage.exifTagTypes = {
		// byte, 8-bit unsigned int:
		1: {
			getValue: function (dataView, dataOffset) {
				return dataView.getUint8(dataOffset)
			},
			size: 1
		},
		// ascii, 8-bit byte:
		2: {
			getValue: function (dataView, dataOffset) {
				return String.fromCharCode(dataView.getUint8(dataOffset))
			},
			size: 1,
			ascii: true
		},
		// short, 16 bit int:
		3: {
			getValue: function (dataView, dataOffset, littleEndian) {
				return dataView.getUint16(dataOffset, littleEndian)
			},
			size: 2
		},
		// long, 32 bit int:
		4: {
			getValue: function (dataView, dataOffset, littleEndian) {
				return dataView.getUint32(dataOffset, littleEndian)
			},
			size: 4
		},
		// rational = two long values, first is numerator, second is denominator:
		5: {
			getValue: function (dataView, dataOffset, littleEndian) {
				return dataView.getUint32(dataOffset, littleEndian) /
					dataView.getUint32(dataOffset + 4, littleEndian)
			},
			size: 8
		},
		// slong, 32 bit signed int:
		9: {
			getValue: function (dataView, dataOffset, littleEndian) {
				return dataView.getInt32(dataOffset, littleEndian)
			},
			size: 4
		},
		// srational, two slongs, first is numerator, second is denominator:
		10: {
			getValue: function (dataView, dataOffset, littleEndian) {
				return dataView.getInt32(dataOffset, littleEndian) /
					dataView.getInt32(dataOffset + 4, littleEndian)
			},
			size: 8
		}
	}
	// undefined, 8-bit byte, value depending on field:
	loadImage.exifTagTypes[7] = loadImage.exifTagTypes[1]

	loadImage.getExifValue = function (dataView, tiffOffset, offset, type, length, littleEndian) {
		var tagType = loadImage.exifTagTypes[type]
		var tagSize
		var dataOffset
		var values
		var i
		var str
		var c
		if (!tagType) {
			//console.log('Invalid Exif data: Invalid tag type.')
			return
		}
		tagSize = tagType.size * length
		// Determine if the value is contained in the dataOffset bytes,
		// or if the value at the dataOffset is a pointer to the actual data:
		dataOffset = tagSize > 4
			? tiffOffset + dataView.getUint32(offset + 8, littleEndian)
			: (offset + 8)
		if (dataOffset + tagSize > dataView.byteLength) {
			//console.log('Invalid Exif data: Invalid data offset.')
			return
		}
		if (length === 1) {
			return tagType.getValue(dataView, dataOffset, littleEndian)
		}
		values = []
		for (i = 0; i < length; i += 1) {
			values[i] = tagType.getValue(dataView, dataOffset + i * tagType.size, littleEndian)
		}
		if (tagType.ascii) {
			str = ''
			// Concatenate the chars:
			for (i = 0; i < values.length; i += 1) {
				c = values[i]
				// Ignore the terminating NULL byte(s):
				if (c === '\u0000') {
					break
				}
				str += c
			}
			return str
		}
		return values
	}

	loadImage.parseExifTag = function (dataView, tiffOffset, offset, littleEndian, data) {
		var tag = dataView.getUint16(offset, littleEndian)
		data.exif[tag] = loadImage.getExifValue(
			dataView,
			tiffOffset,
			offset,
			dataView.getUint16(offset + 2, littleEndian), // tag type
			dataView.getUint32(offset + 4, littleEndian), // tag length
			littleEndian
		)
	}

	loadImage.parseExifTags = function (dataView, tiffOffset, dirOffset, littleEndian, data) {
		var tagsNumber,
			dirEndOffset,
			i
		if (dirOffset + 6 > dataView.byteLength) {
			//console.log('Invalid Exif data: Invalid directory offset.')
			return
		}
		tagsNumber = dataView.getUint16(dirOffset, littleEndian)
		dirEndOffset = dirOffset + 2 + 12 * tagsNumber
		if (dirEndOffset + 4 > dataView.byteLength) {
			//console.log('Invalid Exif data: Invalid directory size.')
			return
		}
		for (i = 0; i < tagsNumber; i += 1) {
			this.parseExifTag(
				dataView,
				tiffOffset,
				dirOffset + 2 + 12 * i, // tag offset
				littleEndian,
				data
			)
		}
		// Return the offset to the next directory:
		return dataView.getUint32(dirEndOffset, littleEndian)
	}

	loadImage.parseExifData = function (dataView, offset, length, data, options) {
		if (options.disableExif) {
			return
		}
		var tiffOffset = offset + 10
		var littleEndian
		var dirOffset
		var thumbnailData
		// Check for the ASCII code for "Exif" (0x45786966):
		if (dataView.getUint32(offset + 4) !== 0x45786966) {
			// No Exif data, might be XMP data instead
			return
		}
		if (tiffOffset + 8 > dataView.byteLength) {
			//console.log('Invalid Exif data: Invalid segment size.')
			return
		}
		// Check for the two null bytes:
		if (dataView.getUint16(offset + 8) !== 0x0000) {
			//console.log('Invalid Exif data: Missing byte alignment offset.')
			return
		}
		// Check the byte alignment:
		switch (dataView.getUint16(tiffOffset)) {
			case 0x4949:
				littleEndian = true
				break
			case 0x4D4D:
				littleEndian = false
				break
			default:
				//console.log('Invalid Exif data: Invalid byte alignment marker.')
				return
		}
		// Check for the TIFF tag marker (0x002A):
		if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002A) {
			//console.log('Invalid Exif data: Missing TIFF marker.')
			return
		}
		// Retrieve the directory offset bytes, usually 0x00000008 or 8 decimal:
		dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian)
		// Create the exif object to store the tags:
		data.exif = new loadImage.ExifMap()
		// Parse the tags of the main image directory and retrieve the
		// offset to the next directory, usually the thumbnail directory:
		dirOffset = loadImage.parseExifTags(
			dataView,
			tiffOffset,
			tiffOffset + dirOffset,
			littleEndian,
			data
		)
		if (dirOffset && !options.disableExifThumbnail) {
			thumbnailData = { exif: {} }
			dirOffset = loadImage.parseExifTags(
				dataView,
				tiffOffset,
				tiffOffset + dirOffset,
				littleEndian,
				thumbnailData
			)
			// Check for JPEG Thumbnail offset:
			if (thumbnailData.exif[0x0201]) {
				data.exif.Thumbnail = loadImage.getExifThumbnail(
					dataView,
					tiffOffset + thumbnailData.exif[0x0201],
					thumbnailData.exif[0x0202] // Thumbnail data length
				)
			}
		}
		// Check for Exif Sub IFD Pointer:
		if (data.exif[0x8769] && !options.disableExifSub) {
			loadImage.parseExifTags(
				dataView,
				tiffOffset,
				tiffOffset + data.exif[0x8769], // directory offset
				littleEndian,
				data
			)
		}
		// Check for GPS Info IFD Pointer:
		if (data.exif[0x8825] && !options.disableExifGps) {
			loadImage.parseExifTags(
				dataView,
				tiffOffset,
				tiffOffset + data.exif[0x8825], // directory offset
				littleEndian,
				data
			)
		}
	}

	// Registers the Exif parser for the APP1 JPEG meta data segment:
	loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData)
	var snabbt = (function () {

		var tickRequests = [];
		var runningAnimations = [];
		var completedAnimations = [];
		var transformProperty = 'transform';

		// Find which vendor prefix to use
		var styles = window.getComputedStyle(document.documentElement, '');
		var vendorPrefix = (Array.prototype.slice
			.call(styles)
			.join('')
			.match(/-(moz|webkit|ms)-/) || (styles.OLink === '' && ['', 'o'])
		)[1];
		if (vendorPrefix === 'webkit')
			transformProperty = 'webkitTransform';

		/* Entry point, only function to be called by user */
		var snabbt = function (arg1, arg2, arg3) {

			var elements = arg1;

			// If argument is an Array or a NodeList or other list type that can be iterable.
			// Loop through and start one animation for each element.
			if (elements.length !== undefined) {
				var aggregateChainer = {
					chainers: [],
					then: function (opts) {
						return this.snabbt(opts);
					},
					snabbt: function (opts) {
						var len = this.chainers.length;
						this.chainers.forEach(function (chainer, index) {
							chainer.snabbt(preprocessOptions(opts, index, len));
						});
						return aggregateChainer;
					},
					setValue: function (value) {
						this.chainers.forEach(function (chainer) {
							chainer.setValue(value);
						});
						return aggregateChainer;
					},
					finish: function () {
						this.chainers.forEach(function (chainer) {
							chainer.finish();
						});
						return aggregateChainer;
					},
					rollback: function () {
						this.chainers.forEach(function (chainer) {
							chainer.rollback();
						});
						return aggregateChainer;
					}
				};

				for (var i = 0, len = elements.length; i < len; ++i) {
					if (typeof arg2 == 'string')
						aggregateChainer.chainers.push(snabbtSingleElement(elements[i], arg2, preprocessOptions(arg3, i, len)));
					else
						aggregateChainer.chainers.push(snabbtSingleElement(elements[i], preprocessOptions(arg2, i, len), arg3));
				}
				return aggregateChainer;
			} else {
				if (typeof arg2 == 'string')
					return snabbtSingleElement(elements, arg2, preprocessOptions(arg3, 0, 1));
				else
					return snabbtSingleElement(elements, preprocessOptions(arg2, 0, 1), arg3);
			}
		};

		var preprocessOptions = function (options, index, len) {
			if (!options)
				return options;
			var clone = cloneObject(options);

			if (isFunction(options.delay)) {
				clone.delay = options.delay(index, len);
			}

			if (isFunction(options.callback)) {
				clone.complete = function () {
					options.callback.call(this, index, len);
				};
			}

			var hasAllDoneCallback = isFunction(options.allDone);
			var hasCompleteCallback = isFunction(options.complete);

			if (hasCompleteCallback || hasAllDoneCallback) {
				clone.complete = function () {
					if (hasCompleteCallback) {
						options.complete.call(this, index, len);
					}
					if (hasAllDoneCallback && (index == len - 1)) {
						options.allDone();
					}
				};
			}

			if (isFunction(options.valueFeeder)) {
				clone.valueFeeder = function (i, matrix) {
					return options.valueFeeder(i, matrix, index, len);
				};
			}
			if (isFunction(options.easing)) {
				clone.easing = function (i) {
					return options.easing(i, index, len);
				};
			}

			var properties = [
				'position',
				'rotation',
				'skew',
				'rotationPost',
				'scale',
				'width',
				'height',
				'opacity',
				'fromPosition',
				'fromRotation',
				'fromSkew',
				'fromRotationPost',
				'fromScale',
				'fromWidth',
				'fromHeight',
				'fromOpacity',
				'transformOrigin',
				'duration',
				'delay'
			];

			properties.forEach(function (property) {
				if (isFunction(options[property])) {
					clone[property] = options[property](index, len);
				}
			});

			return clone;
		};

		var snabbtSingleElement = function (element, arg2, arg3) {

			if (arg2 === 'attention') {
				return setupAttentionAnimation(element, arg3);
			}

			if (arg2 === 'stop') {
				return stopAnimation(element);
			}

			if (arg2 === 'detach') {
				return detachChildren(element);
			}

			var options = arg2;

			// Remove orphaned end states
			clearOphanedEndStates();

			// If there is a running or past completed animation with element, use that end state as start state
			var currentState = currentAnimationState(element);
			var start = currentState;
			// from has precendance over current animation state
			start = stateFromOptions(options, start, true);
			var end = cloneObject(currentState);
			end = stateFromOptions(options, end);

			var animOptions = setupAnimationOptions(start, end, options);
			var animation = createAnimation(animOptions);

			runningAnimations.push([element, animation]);

			animation.updateElement(element, true);
			var queue = [];
			var chainer = {
				snabbt: function (opts) {
					queue.unshift(preprocessOptions(opts, 0, 1));
					return chainer;
				},
				then: function (opts) {
					return this.snabbt(opts);
				}
			};

			function tick(time) {
				animation.tick(time);
				animation.updateElement(element);
				if (animation.isStopped())
					return;

				if (!animation.completed())
					return queueTick(tick);

				if (options.loop > 1 && !animation.isStopped()) {
					// Loop current animation
					options.loop -= 1;
					animation.restart();
					queueTick(tick);
				} else {
					if (options.complete) {
						options.complete.call(element);
					}

					// Start next animation in queue
					if (queue.length) {
						options = queue.pop();

						start = stateFromOptions(options, end, true);
						end = stateFromOptions(options, cloneObject(end));
						options = setupAnimationOptions(start, end, options);

						animation = createAnimation(options);
						runningAnimations.push([element, animation]);

						animation.tick(time);
						queueTick(tick);
					}
				}
			}

			queueTick(tick);
			// Manual animations are not chainable, instead an animation controller object is returned
			// with setValue, finish and rollback methods
			if (options.manual)
				return animation;
			return chainer;
		};

		var setupAttentionAnimation = function (element, options) {
			var movement = stateFromOptions(options, createState({}));
			options.movement = movement;
			var animation = createAttentionAnimation(options);

			runningAnimations.push([element, animation]);
			function tick(time) {
				animation.tick(time);
				animation.updateElement(element);
				if (!animation.completed()) {
					queueTick(tick);
				} else {
					if (options.callback) {
						options.callback(element);
					}
					if (options.loop && options.loop > 1) {
						options.loop--;
						animation.restart();
						queueTick(tick);
					}
				}
			}
			queueTick(tick);
		};

		var stopAnimation = function (element) {
			for (var i = 0, len = runningAnimations.length; i < len; ++i) {
				var currentAnimation = runningAnimations[i];
				var animatedElement = currentAnimation[0];
				var animation = currentAnimation[1];

				if (animatedElement === element) {
					animation.stop();
				}
			}
		};

		var indexOfElement = function (arr, element) {
			for (var i = 0, len = arr.length; i < len; ++i) {
				if (arr[i][0] === element) {
					return i;
				}
			}
			return -1;
		};

		var detachChildren = function (element) {

			var elements = [];
			var animations = runningAnimations.concat(completedAnimations);
			var el;
			var i;
			var len = animations.length;

			for (i = 0; i < len; ++i) {
				el = animations[i][0];
				if (element.contains(el) || element === el) {
					elements.push(el);
				}
			}

			len = elements.length;
			for (i = 0; i < len; ++i) {
				detachElement(elements[i]);
			}

		};

		var detachElement = function (element) {

			// stop animations
			stopAnimation(element);

			// remove
			var index = indexOfElement(runningAnimations, element);
			if (index >= 0) {
				runningAnimations.splice(index, 1);
			}

			index = indexOfElement(completedAnimations, element);
			if (index >= 0) {
				completedAnimations.splice(index, 1);
			}

		};

		var findAnimationState = function (animationList, element) {
			for (var i = 0, len = animationList.length; i < len; ++i) {
				var currentAnimation = animationList[i];
				var animatedElement = currentAnimation[0];
				var animation = currentAnimation[1];

				if (animatedElement === element) {
					var state = animation.getCurrentState();
					animation.stop();
					return state;
				}
			}
		};

		var clearOphanedEndStates = function () {
			completedAnimations = completedAnimations.filter(function (animation) {
				return (findUltimateAncestor(animation[0]).body);
			});
		};

		var findUltimateAncestor = function (node) {
			var ancestor = node;
			while (ancestor.parentNode) {
				ancestor = ancestor.parentNode;
			}
			return ancestor;
		};

		/**
		* Returns the current state of element if there is an ongoing or previously finished
		* animation releated to it. Will also call stop on the animation.
		* TODO: The stopping of the animation is better put somewhere else
		*/
		var currentAnimationState = function (element) {
			// Check if a completed animation is stored for this element
			var state = findAnimationState(runningAnimations, element);
			if (state)
				return state;

			return findAnimationState(completedAnimations, element);
		};

		/**
		* Parses an animation configuration object and returns a State instance
		*/
		var stateFromOptions = function (options, state, useFromPrefix) {
			if (!state) {
				state = createState({
					position: [0, 0, 0],
					rotation: [0, 0, 0],
					rotationPost: [0, 0, 0],
					scale: [1, 1],
					skew: [0, 0]
				});
			}
			var position = 'position';
			var rotation = 'rotation';
			var skew = 'skew';
			var rotationPost = 'rotationPost';
			var scale = 'scale';
			var scalePost = 'scalePost';
			var width = 'width';
			var height = 'height';
			var opacity = 'opacity';

			if (useFromPrefix) {
				position = 'fromPosition';
				rotation = 'fromRotation';
				skew = 'fromSkew';
				rotationPost = 'fromRotationPost';
				scale = 'fromScale';
				scalePost = 'fromScalePost';
				width = 'fromWidth';
				height = 'fromHeight';
				opacity = 'fromOpacity';
			}

			state.position = optionOrDefault(options[position], state.position);
			state.rotation = optionOrDefault(options[rotation], state.rotation);
			state.rotationPost = optionOrDefault(options[rotationPost], state.rotationPost);
			state.skew = optionOrDefault(options[skew], state.skew);
			state.scale = optionOrDefault(options[scale], state.scale);
			state.scalePost = optionOrDefault(options[scalePost], state.scalePost);
			state.opacity = options[opacity];
			state.width = options[width];
			state.height = options[height];

			return state;
		};

		var setupAnimationOptions = function (start, end, options) {
			options.startState = start;
			options.endState = end;
			return options;
		};

		var polyFillrAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) { return setTimeout(callback, 1000 / 60); };

		var queueTick = function (func) {
			if (tickRequests.length === 0)
				polyFillrAF(tickAnimations);
			tickRequests.push(func);
		};

		var tickAnimations = function (time) {
			var len = tickRequests.length;
			for (var i = 0; i < len; ++i) {
				tickRequests[i](time);
			}
			tickRequests.splice(0, len);

			var finishedAnimations = runningAnimations.filter(function (animation) {
				return animation[1].completed();
			});

			// See if there are any previously completed animations on the same element, if so, remove it before merging
			completedAnimations = completedAnimations.filter(function (animation) {
				for (var i = 0, len = finishedAnimations.length; i < len; ++i) {
					if (animation[0] === finishedAnimations[i][0]) {
						return false;
					}
				}
				return true;
			});

			completedAnimations = completedAnimations.concat(finishedAnimations);

			runningAnimations = runningAnimations.filter(function (animation) {
				return !animation[1].completed();
			});

			if (tickRequests.length !== 0)
				polyFillrAF(tickAnimations);
		};


		// Class for handling animation between two states
		var createAnimation = function (options) {
			var startState = options.startState;
			var endState = options.endState;
			var duration = optionOrDefault(options.duration, 500);
			var delay = optionOrDefault(options.delay, 0);
			var perspective = options.perspective;
			var easing = createEaser(optionOrDefault(options.easing, 'linear'), options);
			var currentState = duration === 0 ? endState.clone() : startState.clone();
			var transformOrigin = options.transformOrigin;
			currentState.transformOrigin = options.transformOrigin;

			var startTime = 0;
			var currentTime = 0;
			var stopped = false;
			var started = false;

			// Manual related
			var manual = options.manual;
			var manualValue = 0;
			var manualDelayFactor = delay / duration;
			var manualCallback;

			var tweener;
			// Setup tweener
			if (options.valueFeeder) {
				tweener = createValueFeederTweener(options.valueFeeder,
					startState,
					endState,
					currentState);
			} else {
				tweener = createStateTweener(startState, endState, currentState);
			}

			// Public api
			return {
				stop: function () {
					stopped = true;
				},
				isStopped: function () {
					return stopped;
				},

				finish: function (callback) {
					manual = false;
					var manualDuration = duration * manualValue;
					startTime = currentTime - manualDuration;
					manualCallback = callback;
					easing.resetFrom = manualValue;
				},

				rollback: function (callback) {
					manual = false;
					tweener.setReverse();
					var manualDuration = duration * (1 - manualValue);
					startTime = currentTime - manualDuration;
					manualCallback = callback;
					easing.resetFrom = manualValue;
				},

				restart: function () {
					// Restart timer
					startTime = undefined;
					easing.resetFrom(0);
				},

				tick: function (time) {
					if (stopped)
						return;

					if (manual) {
						currentTime = time;
						this.updateCurrentTransform();
						return;
					}

					// If first tick, set startTime
					if (!startTime) {
						startTime = time;
					}
					if (time - startTime > delay) {
						started = true;
						currentTime = time - delay;

						var curr = Math.min(Math.max(0.0, currentTime - startTime), duration);
						easing.tick(curr / duration);
						this.updateCurrentTransform();
						if (this.completed() && manualCallback) {
							manualCallback();
						}
					}
				},

				getCurrentState: function () {
					return currentState;
				},

				setValue: function (_manualValue) {
					started = true;
					manualValue = Math.min(Math.max(_manualValue, 0.0001), 1 + manualDelayFactor);
				},

				updateCurrentTransform: function () {
					var tweenValue = easing.getValue();
					if (manual) {
						var val = Math.max(0.00001, manualValue - manualDelayFactor);
						easing.tick(val);
						tweenValue = easing.getValue();
					}
					tweener.tween(tweenValue);
				},

				completed: function () {
					if (stopped)
						return true;
					if (startTime === 0) {
						return false;
					}
					return easing.completed();
				},

				updateElement: function (element, forceUpdate) {
					if (!started && !forceUpdate)
						return;
					var matrix = tweener.asMatrix();
					var properties = tweener.getProperties();
					updateElementTransform(element, matrix, perspective);
					updateElementProperties(element, properties);
				}
			};
		};

		// ------------------------------
		// End Time animation
		// ------------------------------

		// ------------------------
		// -- AttentionAnimation --
		// ------------------------

		var createAttentionAnimation = function (options) {
			var movement = options.movement;
			options.initialVelocity = 0.1;
			options.equilibriumPosition = 0;
			var spring = createSpringEasing(options);
			var stopped = false;
			var tweenPosition = movement.position;
			var tweenRotation = movement.rotation;
			var tweenRotationPost = movement.rotationPost;
			var tweenScale = movement.scale;
			var tweenSkew = movement.skew;

			var currentMovement = createState({
				position: tweenPosition ? [0, 0, 0] : undefined,
				rotation: tweenRotation ? [0, 0, 0] : undefined,
				rotationPost: tweenRotationPost ? [0, 0, 0] : undefined,
				scale: tweenScale ? [0, 0] : undefined,
				skew: tweenSkew ? [0, 0] : undefined,
			});

			// Public API
			return {
				stop: function () {
					stopped = true;
				},

				isStopped: function (time) {
					return stopped;
				},

				tick: function (time) {
					if (stopped)
						return;
					if (spring.equilibrium)
						return;
					spring.tick();

					this.updateMovement();
				},

				updateMovement: function () {
					var value = spring.getValue();
					if (tweenPosition) {
						currentMovement.position[0] = movement.position[0] * value;
						currentMovement.position[1] = movement.position[1] * value;
						currentMovement.position[2] = movement.position[2] * value;
					}
					if (tweenRotation) {
						currentMovement.rotation[0] = movement.rotation[0] * value;
						currentMovement.rotation[1] = movement.rotation[1] * value;
						currentMovement.rotation[2] = movement.rotation[2] * value;
					}
					if (tweenRotationPost) {
						currentMovement.rotationPost[0] = movement.rotationPost[0] * value;
						currentMovement.rotationPost[1] = movement.rotationPost[1] * value;
						currentMovement.rotationPost[2] = movement.rotationPost[2] * value;
					}
					if (tweenScale) {
						currentMovement.scale[0] = 1 + movement.scale[0] * value;
						currentMovement.scale[1] = 1 + movement.scale[1] * value;
					}

					if (tweenSkew) {
						currentMovement.skew[0] = movement.skew[0] * value;
						currentMovement.skew[1] = movement.skew[1] * value;
					}
				},

				updateElement: function (element) {
					updateElementTransform(element, currentMovement.asMatrix());
					updateElementProperties(element, currentMovement.getProperties());
				},

				getCurrentState: function () {
					return currentMovement;
				},

				completed: function () {
					return spring.equilibrium || stopped;
				},

				restart: function () {
					// Restart spring
					spring = createSpringEasing(options);
				}
			};
		};


		/**********
		* Easings *
		***********/

		var linearEasing = function (value) {
			return value;
		};

		var ease = function (value) {
			return (Math.cos(value * Math.PI + Math.PI) + 1) / 2;
		};

		var easeIn = function (value) {
			return value * value;
		};

		var easeOut = function (value) {
			return -Math.pow(value - 1, 2) + 1;
		};

		var createSpringEasing = function (options) {
			var position = optionOrDefault(options.startPosition, 0);
			var equilibriumPosition = optionOrDefault(options.equilibriumPosition, 1);
			var velocity = optionOrDefault(options.initialVelocity, 0);
			var springConstant = optionOrDefault(options.springConstant, 0.8);
			var deceleration = optionOrDefault(options.springDeceleration, 0.9);
			var mass = optionOrDefault(options.springMass, 10);

			var equilibrium = false;

			// Public API
			return {

				tick: function (value) {
					if (value === 0.0)
						return;
					if (equilibrium)
						return;
					var springForce = -(position - equilibriumPosition) * springConstant;
					// f = m * a
					// a = f / m
					var a = springForce / mass;
					// s = v * t
					// t = 1 ( for now )
					velocity += a;
					position += velocity;

					// Deceleration
					velocity *= deceleration;

					if (Math.abs(position - equilibriumPosition) < 0.001 && Math.abs(velocity) < 0.001) {
						equilibrium = true;
					}
				},

				resetFrom: function (value) {
					position = value;
					velocity = 0;
				},


				getValue: function () {
					if (equilibrium)
						return equilibriumPosition;
					return position;
				},

				completed: function () {
					return equilibrium;
				}
			};
		};

		var EASING_FUNCS = {
			'linear': linearEasing,
			'ease': ease,
			'easeIn': easeIn,
			'easeOut': easeOut,
		};


		var createEaser = function (easerName, options) {
			if (easerName == 'spring') {
				return createSpringEasing(options);
			}
			var easeFunction = easerName;
			if (!isFunction(easerName)) {
				easeFunction = EASING_FUNCS[easerName];
			}

			var easer = easeFunction;
			var value = 0;
			var lastValue;

			// Public API
			return {
				tick: function (v) {
					value = easer(v);
					lastValue = v;
				},

				resetFrom: function (value) {
					lastValue = 0;
				},

				getValue: function () {
					return value;
				},

				completed: function () {
					if (lastValue >= 1) {
						return lastValue;
					}
					return false;
				}
			};
		};

		/***
		* Matrix related
		*/

		var assignTranslate = function (matrix, x, y, z) {
			matrix[0] = 1;
			matrix[1] = 0;
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = 0;
			matrix[5] = 1;
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = 0;
			matrix[10] = 1;
			matrix[11] = 0;
			matrix[12] = x;
			matrix[13] = y;
			matrix[14] = z;
			matrix[15] = 1;
		};

		var assignRotateX = function (matrix, rad) {
			matrix[0] = 1;
			matrix[1] = 0;
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = 0;
			matrix[5] = Math.cos(rad);
			matrix[6] = -Math.sin(rad);
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = Math.sin(rad);
			matrix[10] = Math.cos(rad);
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};


		var assignRotateY = function (matrix, rad) {
			matrix[0] = Math.cos(rad);
			matrix[1] = 0;
			matrix[2] = Math.sin(rad);
			matrix[3] = 0;
			matrix[4] = 0;
			matrix[5] = 1;
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = -Math.sin(rad);
			matrix[9] = 0;
			matrix[10] = Math.cos(rad);
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};

		var assignRotateZ = function (matrix, rad) {
			matrix[0] = Math.cos(rad);
			matrix[1] = -Math.sin(rad);
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = Math.sin(rad);
			matrix[5] = Math.cos(rad);
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = 0;
			matrix[10] = 1;
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};

		var assignSkew = function (matrix, ax, ay) {
			matrix[0] = 1;
			matrix[1] = Math.tan(ax);
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = Math.tan(ay);
			matrix[5] = 1;
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = 0;
			matrix[10] = 1;
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};


		var assignScale = function (matrix, x, y) {
			matrix[0] = x;
			matrix[1] = 0;
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = 0;
			matrix[5] = y;
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = 0;
			matrix[10] = 1;
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};

		var assignIdentity = function (matrix) {
			matrix[0] = 1;
			matrix[1] = 0;
			matrix[2] = 0;
			matrix[3] = 0;
			matrix[4] = 0;
			matrix[5] = 1;
			matrix[6] = 0;
			matrix[7] = 0;
			matrix[8] = 0;
			matrix[9] = 0;
			matrix[10] = 1;
			matrix[11] = 0;
			matrix[12] = 0;
			matrix[13] = 0;
			matrix[14] = 0;
			matrix[15] = 1;
		};

		var copyArray = function (a, b) {
			b[0] = a[0];
			b[1] = a[1];
			b[2] = a[2];
			b[3] = a[3];
			b[4] = a[4];
			b[5] = a[5];
			b[6] = a[6];
			b[7] = a[7];
			b[8] = a[8];
			b[9] = a[9];
			b[10] = a[10];
			b[11] = a[11];
			b[12] = a[12];
			b[13] = a[13];
			b[14] = a[14];
			b[15] = a[15];
		};

		var createMatrix = function () {
			var data = new Float32Array(16);
			var a = new Float32Array(16);
			var b = new Float32Array(16);
			assignIdentity(data);

			return {
				data: data,

				asCSS: function () {
					var css = 'matrix3d(';
					for (var i = 0; i < 15; ++i) {
						if (Math.abs(data[i]) < 0.0001)
							css += '0,';
						else
							css += data[i].toFixed(10) + ',';
					}
					if (Math.abs(data[15]) < 0.0001)
						css += '0)';
					else
						css += data[15].toFixed(10) + ')';
					return css;
				},

				clear: function () {
					assignIdentity(data);
				},

				translate: function (x, y, z) {
					copyArray(data, a);
					assignTranslate(b, x, y, z);
					assignedMatrixMultiplication(a, b, data);
					return this;
				},

				rotateX: function (radians) {
					copyArray(data, a);
					assignRotateX(b, radians);
					assignedMatrixMultiplication(a, b, data);
					return this;
				},

				rotateY: function (radians) {
					copyArray(data, a);
					assignRotateY(b, radians);
					assignedMatrixMultiplication(a, b, data);
					return this;
				},

				rotateZ: function (radians) {
					copyArray(data, a);
					assignRotateZ(b, radians);
					assignedMatrixMultiplication(a, b, data);
					return this;
				},

				scale: function (x, y) {
					copyArray(data, a);
					assignScale(b, x, y);
					assignedMatrixMultiplication(a, b, data);
					return this;
				},

				skew: function (ax, ay) {
					copyArray(data, a);
					assignSkew(b, ax, ay);
					assignedMatrixMultiplication(a, b, data);
					return this;
				}
			};
		};

		var assignedMatrixMultiplication = function (a, b, res) {
			// Unrolled loop
			res[0] = a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12];
			res[1] = a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13];
			res[2] = a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14];
			res[3] = a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15];

			res[4] = a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12];
			res[5] = a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13];
			res[6] = a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14];
			res[7] = a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15];

			res[8] = a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12];
			res[9] = a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13];
			res[10] = a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14];
			res[11] = a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15];

			res[12] = a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12];
			res[13] = a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13];
			res[14] = a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14];
			res[15] = a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15];

			return res;
		};

		var createState = function (config) {
			// Caching of matrix and properties so we don't have to create new ones everytime they are needed
			var matrix = createMatrix();
			var properties = {
				opacity: undefined,
				width: undefined,
				height: undefined
			};

			// Public API
			return {
				position: config.position,
				rotation: config.rotation,
				rotationPost: config.rotationPost,
				skew: config.skew,
				scale: config.scale,
				scalePost: config.scalePost,
				opacity: config.opacity,
				width: config.width,
				height: config.height,


				clone: function () {
					return createState({
						position: this.position ? this.position.slice(0) : undefined,
						rotation: this.rotation ? this.rotation.slice(0) : undefined,
						rotationPost: this.rotationPost ? this.rotationPost.slice(0) : undefined,
						skew: this.skew ? this.skew.slice(0) : undefined,
						scale: this.scale ? this.scale.slice(0) : undefined,
						scalePost: this.scalePost ? this.scalePost.slice(0) : undefined,
						height: this.height,
						width: this.width,
						opacity: this.opacity
					});
				},

				asMatrix: function () {
					var m = matrix;
					m.clear();

					if (this.transformOrigin)
						m.translate(-this.transformOrigin[0], -this.transformOrigin[1], -this.transformOrigin[2]);

					if (this.scale) {
						m.scale(this.scale[0], this.scale[1]);
					}

					if (this.skew) {
						m.skew(this.skew[0], this.skew[1]);
					}

					if (this.rotation) {
						m.rotateX(this.rotation[0]);
						m.rotateY(this.rotation[1]);
						m.rotateZ(this.rotation[2]);
					}

					if (this.position) {
						m.translate(this.position[0], this.position[1], this.position[2]);
					}

					if (this.rotationPost) {
						m.rotateX(this.rotationPost[0]);
						m.rotateY(this.rotationPost[1]);
						m.rotateZ(this.rotationPost[2]);
					}

					if (this.scalePost) {
						m.scale(this.scalePost[0], this.scalePost[1]);
					}

					if (this.transformOrigin)
						m.translate(this.transformOrigin[0], this.transformOrigin[1], this.transformOrigin[2]);
					return m;
				},

				getProperties: function () {
					properties.opacity = this.opacity;
					properties.width = this.width + 'px';
					properties.height = this.height + 'px';
					return properties;
				}
			};
		};
		// ------------------
		// -- StateTweener -- 
		// -------------------

		var createStateTweener = function (startState, endState, resultState) {
			var start = startState;
			var end = endState;
			var result = resultState;

			var tweenPosition = end.position !== undefined;
			var tweenRotation = end.rotation !== undefined;
			var tweenRotationPost = end.rotationPost !== undefined;
			var tweenScale = end.scale !== undefined;
			var tweenSkew = end.skew !== undefined;
			var tweenWidth = end.width !== undefined;
			var tweenHeight = end.height !== undefined;
			var tweenOpacity = end.opacity !== undefined;

			// Public API
			return {

				tween: function (tweenValue) {

					if (tweenPosition) {
						var dX = (end.position[0] - start.position[0]);
						var dY = (end.position[1] - start.position[1]);
						var dZ = (end.position[2] - start.position[2]);
						result.position[0] = start.position[0] + tweenValue * dX;
						result.position[1] = start.position[1] + tweenValue * dY;
						result.position[2] = start.position[2] + tweenValue * dZ;
					}

					if (tweenRotation) {
						var dAX = (end.rotation[0] - start.rotation[0]);
						var dAY = (end.rotation[1] - start.rotation[1]);
						var dAZ = (end.rotation[2] - start.rotation[2]);
						result.rotation[0] = start.rotation[0] + tweenValue * dAX;
						result.rotation[1] = start.rotation[1] + tweenValue * dAY;
						result.rotation[2] = start.rotation[2] + tweenValue * dAZ;
					}

					if (tweenRotationPost) {
						var dBX = (end.rotationPost[0] - start.rotationPost[0]);
						var dBY = (end.rotationPost[1] - start.rotationPost[1]);
						var dBZ = (end.rotationPost[2] - start.rotationPost[2]);
						result.rotationPost[0] = start.rotationPost[0] + tweenValue * dBX;
						result.rotationPost[1] = start.rotationPost[1] + tweenValue * dBY;
						result.rotationPost[2] = start.rotationPost[2] + tweenValue * dBZ;
					}

					if (tweenSkew) {
						var dSX = (end.scale[0] - start.scale[0]);
						var dSY = (end.scale[1] - start.scale[1]);

						result.scale[0] = start.scale[0] + tweenValue * dSX;
						result.scale[1] = start.scale[1] + tweenValue * dSY;
					}

					if (tweenScale) {
						var dSkewX = (end.skew[0] - start.skew[0]);
						var dSkewY = (end.skew[1] - start.skew[1]);

						result.skew[0] = start.skew[0] + tweenValue * dSkewX;
						result.skew[1] = start.skew[1] + tweenValue * dSkewY;
					}

					if (tweenWidth) {
						var dWidth = (end.width - start.width);
						result.width = start.width + tweenValue * dWidth;
					}


					if (tweenHeight) {
						var dHeight = (end.height - start.height);
						result.height = start.height + tweenValue * dHeight;
					}

					if (tweenOpacity) {
						var dOpacity = (end.opacity - start.opacity);
						result.opacity = start.opacity + tweenValue * dOpacity;
					}

				},

				asMatrix: function () {
					return result.asMatrix();
				},

				getProperties: function () {
					return result.getProperties();
				},

				setReverse: function () {
					var oldStart = start;
					start = end;
					end = oldStart;
				}
			};
		};

		// ------------------------
		// -- ValueFeederTweener -- 
		// ------------------------

		var createValueFeederTweener = function (valueFeeder, startState, endState, resultState) {
			var currentMatrix = valueFeeder(0, createMatrix());
			var start = startState;
			var end = endState;
			var result = resultState;
			var reverse = false;


			// Public API
			return {

				tween: function (tweenValue) {
					if (reverse)
						tweenValue = 1 - tweenValue;
					currentMatrix.clear();
					currentMatrix = valueFeeder(tweenValue, currentMatrix);

					var dWidth = (end.width - start.width);
					var dHeight = (end.height - start.height);
					var dOpacity = (end.opacity - start.opacity);

					if (end.width !== undefined)
						result.width = start.width + tweenValue * dWidth;
					if (end.height !== undefined)
						result.height = start.height + tweenValue * dHeight;
					if (end.opacity !== undefined)
						result.opacity = start.opacity + tweenValue * dOpacity;
				},

				asMatrix: function () {
					return currentMatrix;
				},

				getProperties: function () {
					return result.getProperties();
				},

				setReverse: function () {
					reverse = true;
				}

			};
		};

		var optionOrDefault = function (option, def) {
			if (typeof option == 'undefined') {
				return def;
			}
			return option;
		};

		var updateElementTransform = function (element, matrix, perspective) {
			var cssPerspective = '';
			if (perspective) {
				cssPerspective = 'perspective(' + perspective + 'px) ';
			}
			var cssMatrix = matrix.asCSS();
			element.style[transformProperty] = cssPerspective + cssMatrix;
		};

		var updateElementProperties = function (element, properties) {
			for (var key in properties) {
				element.style[key] = properties[key];
			}
		};

		var isFunction = function (object) {
			return (typeof object === "function");
		};

		var cloneObject = function (object) {
			if (!object)
				return object;
			var clone = {};
			for (var key in object) {
				clone[key] = object[key];
			}
			return clone;
		};

		snabbt.createMatrix = createMatrix;
		snabbt.setElementTransform = updateElementTransform;
		return snabbt;
	}());
	var stackBlur = (function () {

		var mul_table = [
			512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512,
			454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512,
			482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456,
			437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512,
			497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328,
			320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456,
			446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335,
			329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512,
			505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405,
			399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328,
			324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271,
			268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456,
			451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388,
			385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335,
			332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292,
			289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];


		var shg_table = [
			9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17,
			17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19,
			19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20,
			20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21,
			21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21,
			21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22,
			22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22,
			22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23,
			23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24,
			24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

		function getImageDataFromCanvas(canvas, top_x, top_y, width, height) {
			if (typeof (canvas) == 'string')
				canvas = document.getElementById(canvas);
			else if (!canvas instanceof HTMLCanvasElement)
				return;

			var context = canvas.getContext('2d');
			var imageData;

			try {
				try {
					imageData = context.getImageData(top_x, top_y, width, height);
				} catch (e) {
					throw new Error("unable to access local image data: " + e);
					return;
				}
			} catch (e) {
				throw new Error("unable to access image data: " + e);
			}

			return imageData;
		}

		function processCanvasRGBA(canvas, top_x, top_y, width, height, radius) {
			if (isNaN(radius) || radius < 1) return;
			radius |= 0;

			var imageData = getImageDataFromCanvas(canvas, top_x, top_y, width, height);

			imageData = processImageDataRGBA(imageData, top_x, top_y, width, height, radius);

			canvas.getContext('2d').putImageData(imageData, top_x, top_y);
		}

		function processImageDataRGBA(imageData, top_x, top_y, width, height, radius) {
			var pixels = imageData.data;

			var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum,
				r_out_sum, g_out_sum, b_out_sum, a_out_sum,
				r_in_sum, g_in_sum, b_in_sum, a_in_sum,
				pr, pg, pb, pa, rbs;

			var div = radius + radius + 1;
			var w4 = width << 2;
			var widthMinus1 = width - 1;
			var heightMinus1 = height - 1;
			var radiusPlus1 = radius + 1;
			var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

			var stackStart = new BlurStack();
			var stack = stackStart;
			for (i = 1; i < div; i++) {
				stack = stack.next = new BlurStack();
				if (i == radiusPlus1) var stackEnd = stack;
			}
			stack.next = stackStart;
			var stackIn = null;
			var stackOut = null;

			yw = yi = 0;

			var mul_sum = mul_table[radius];
			var shg_sum = shg_table[radius];

			for (y = 0; y < height; y++) {
				r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;

				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
				a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;
				a_sum += sumFactor * pa;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack.a = pa;
					stack = stack.next;
				}

				for (i = 1; i < radiusPlus1; i++) {
					p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
					r_sum += (stack.r = (pr = pixels[p])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[p + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[p + 2])) * rbs;
					a_sum += (stack.a = (pa = pixels[p + 3])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;
					a_in_sum += pa;

					stack = stack.next;
				}


				stackIn = stackStart;
				stackOut = stackEnd;
				for (x = 0; x < width; x++) {
					pixels[yi + 3] = pa = (a_sum * mul_sum) >> shg_sum;
					if (pa != 0) {
						pa = 255 / pa;
						pixels[yi] = ((r_sum * mul_sum) >> shg_sum) * pa;
						pixels[yi + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
						pixels[yi + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
					} else {
						pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
					}

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;
					a_sum -= a_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;
					a_out_sum -= stackIn.a;

					p = (yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1)) << 2;

					r_in_sum += (stackIn.r = pixels[p]);
					g_in_sum += (stackIn.g = pixels[p + 1]);
					b_in_sum += (stackIn.b = pixels[p + 2]);
					a_in_sum += (stackIn.a = pixels[p + 3]);

					r_sum += r_in_sum;
					g_sum += g_in_sum;
					b_sum += b_in_sum;
					a_sum += a_in_sum;

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);
					a_out_sum += (pa = stackOut.a);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;
					a_in_sum -= pa;

					stackOut = stackOut.next;

					yi += 4;
				}
				yw += width;
			}


			for (x = 0; x < width; x++) {
				g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;

				yi = x << 2;
				r_out_sum = radiusPlus1 * (pr = pixels[yi]);
				g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
				b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
				a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

				r_sum += sumFactor * pr;
				g_sum += sumFactor * pg;
				b_sum += sumFactor * pb;
				a_sum += sumFactor * pa;

				stack = stackStart;

				for (i = 0; i < radiusPlus1; i++) {
					stack.r = pr;
					stack.g = pg;
					stack.b = pb;
					stack.a = pa;
					stack = stack.next;
				}

				yp = width;

				for (i = 1; i <= radius; i++) {
					yi = (yp + x) << 2;

					r_sum += (stack.r = (pr = pixels[yi])) * (rbs = radiusPlus1 - i);
					g_sum += (stack.g = (pg = pixels[yi + 1])) * rbs;
					b_sum += (stack.b = (pb = pixels[yi + 2])) * rbs;
					a_sum += (stack.a = (pa = pixels[yi + 3])) * rbs;

					r_in_sum += pr;
					g_in_sum += pg;
					b_in_sum += pb;
					a_in_sum += pa;

					stack = stack.next;

					if (i < heightMinus1) {
						yp += width;
					}
				}

				yi = x;
				stackIn = stackStart;
				stackOut = stackEnd;
				for (y = 0; y < height; y++) {
					p = yi << 2;
					pixels[p + 3] = pa = (a_sum * mul_sum) >> shg_sum;
					if (pa > 0) {
						pa = 255 / pa;
						pixels[p] = ((r_sum * mul_sum) >> shg_sum) * pa;
						pixels[p + 1] = ((g_sum * mul_sum) >> shg_sum) * pa;
						pixels[p + 2] = ((b_sum * mul_sum) >> shg_sum) * pa;
					} else {
						pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
					}

					r_sum -= r_out_sum;
					g_sum -= g_out_sum;
					b_sum -= b_out_sum;
					a_sum -= a_out_sum;

					r_out_sum -= stackIn.r;
					g_out_sum -= stackIn.g;
					b_out_sum -= stackIn.b;
					a_out_sum -= stackIn.a;

					p = (x + (((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width)) << 2;

					r_sum += (r_in_sum += (stackIn.r = pixels[p]));
					g_sum += (g_in_sum += (stackIn.g = pixels[p + 1]));
					b_sum += (b_in_sum += (stackIn.b = pixels[p + 2]));
					a_sum += (a_in_sum += (stackIn.a = pixels[p + 3]));

					stackIn = stackIn.next;

					r_out_sum += (pr = stackOut.r);
					g_out_sum += (pg = stackOut.g);
					b_out_sum += (pb = stackOut.b);
					a_out_sum += (pa = stackOut.a);

					r_in_sum -= pr;
					g_in_sum -= pg;
					b_in_sum -= pb;
					a_in_sum -= pa;

					stackOut = stackOut.next;

					yi += width;
				}
			}
			return imageData;
		}

		function BlurStack() {
			this.r = 0;
			this.g = 0;
			this.b = 0;
			this.a = 0;
			this.next = null;
		}

		return processCanvasRGBA;

	}());
	// canvas to blob polyfill
	// https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob#Polyfill
	if (!HTMLCanvasElement.prototype.toBlob) {
		Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
			value: function (callback, type, quality) {

				var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
					len = binStr.length,
					arr = new Uint8Array(len);

				for (var i = 0; i < len; i++) {
					arr[i] = binStr.charCodeAt(i);
				}

				callback(new Blob([arr], { type: type || 'image/png' }));
			}
		});
	}
	'use strict';

	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

	var copyString = function copyString(str) {
		return str + '';
	};

	var getDataset = function getDataset(el) {

		if (typeof el.dataset === 'undefined') {
			var res = {};
			var attr;
			var attrName;
			var attrs = el.attributes;
			for (attr in attrs) {
				if (attrs.hasOwnProperty(attr) && attrs[attr].name && /^data-[a-z_\-\d]*$/i.test(attrs[attr].name)) {
					attrName = toCamelCase(attrs[attr].name.substr(5));
					res[attrName] = attrs[attr].value;
				}
			}
			return res;
		}
		return el.dataset;
	};

	var toCamelCase = function toCamelCase(str) {
		return str.replace(/\-./g, function (substr) {
			return substr.charAt(1).toUpperCase();
		});
	};

	var getElementAttributes = function getElementAttributes(el) {
		// is a for loop on purpose as this should still function when Slim not supported
		var result = [];
		var attributes = Array.prototype.slice.call(el.attributes);
		var l = attributes.length;
		for (var i = 0; i < l; i++) {
			result.push({
				name: attributes[i].name,
				value: attributes[i].value
			});
		}
		return result;
	};

	// helper method
	var getOffsetByEvent = function getOffsetByEvent(e) {
		return {
			x: typeof e.offsetX === 'undefined' ? e.layerX : e.offsetX,
			y: typeof e.offsetY === 'undefined' ? e.layerY : e.offsetY
		};
	};

	// merge two objects together
	var mergeOptions = function mergeOptions(base, additives) {

		var key;
		var options = {};
		var optionsToMerge = additives || {};

		for (key in base) {
			if (!base.hasOwnProperty(key)) {
				continue;
			}
			options[key] = typeof optionsToMerge[key] === 'undefined' ? base[key] : optionsToMerge[key];
		}

		return options;
	};

	// keys
	var Key = {
		ESC: 27,
		RETURN: 13
	};

	// pointer events
	var Events = {
		DOWN: ['touchstart', 'pointerdown', 'mousedown'],
		MOVE: ['touchmove', 'pointermove', 'mousemove'],
		UP: ['touchend', 'touchcancel', 'pointerup', 'mouseup']
	};

	var MimeTypes = {
		'jpeg': 'image/jpeg',
		'jpg': 'image/jpeg',
		'jpe': 'image/jpeg',
		'png': 'image/png',
		'gif': 'image/gif',
		'bmp': 'image/bmp'
	};

	var ImageExtensionsRegex = /(\.png|\.bmp|\.gif|\.jpg|\.jpe|\.jpg|\.jpeg)$/;

	var CanvasExportExtensions = /(jpe|jpg|jpeg|png)/;

	// shortcuts
	var create = function create(name, className) {
		var node = document.createElement(name);
		if (className) {
			node.className = className;
		}
		return node;
	};

	// events
	var addEvents = function addEvents(obj, events, scope) {
		events.forEach(function (event) {
			obj.addEventListener(event, scope, false);
		});
	};

	var removeEvents = function removeEvents(obj, events, scope) {
		events.forEach(function (event) {
			obj.removeEventListener(event, scope, false);
		});
	};

	var getEventOffset = function getEventOffset(e) {

		var event = e.changedTouches ? e.changedTouches[0] : e;

		// no event found, quit!
		if (!event) {
			return;
		}

		// get offset from events
		return {
			x: event.pageX,
			y: event.pageY
		};
	};

	var rotate = function rotate(rect, angle) {

		var cx = .5;
		var cy = .5;

		var radians = Math.PI / 180 * angle;
		var cos = Math.cos(radians);
		var sin = Math.sin(radians);

		var x1 = rect.x;
		var y1 = rect.y;
		var x2 = rect.x + rect.width;
		var y2 = rect.y + rect.height;

		var rx1 = cos * (x1 - cx) + sin * (y1 - cy) + cx;
		var ry1 = cos * (y1 - cy) - sin * (x1 - cx) + cy;

		var rx2 = cos * (x2 - cx) + sin * (y2 - cy) + cx;
		var ry2 = cos * (y2 - cy) - sin * (x2 - cx) + cy;

		if (rx1 <= rx2) {
			rect.x = rx1;
			rect.width = rx2 - rx1;
		} else {
			rect.x = rx2;
			rect.width = rx1 - rx2;
		}

		if (ry1 <= ry2) {
			rect.y = ry1;
			rect.height = ry2 - ry1;
		} else {
			rect.y = ry2;
			rect.height = ry1 - ry2;
		}
	};

	var getEventOffsetScroll = function getEventOffsetScroll(e) {
		var offset = getEventOffset(e);
		offset.x -= window.pageXOffset || document.documentElement.scrollLeft;
		offset.y -= window.pageYOffset || document.documentElement.scrollTop;
		return offset;
	};

	var lowercaseFirstLetter = function lowercaseFirstLetter(string) {
		return string.charAt(0).toLowerCase() + string.slice(1);
	};

	var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
		return string.charAt(0).toUpperCase() + string.slice(1);
	};

	var last = function last(array) {
		return array[array.length - 1];
	};

	var limit = function limit(value, min, max) {
		return Math.max(min, Math.min(max, value));
	};

	var inArray = function inArray(needle, arr) {
		// is for loop so we can use this method on older browsers to render fallback message
		if (!arr) {
			return false;
		}
		for (var i = 0; i < arr.length; i++) {
			if (arr[i] === needle) {
				return true;
			}
		}
		return false;
	};

	var send = function send(url, data, requestDecorator, progress, success, err) {

		var xhr = new XMLHttpRequest();

		// if progress callback defined handle progress events
		if (progress) {
			xhr.upload.addEventListener('progress', function (e) {
				progress(e.loaded, e.total);
			});
		}

		// open the request
		xhr.open('POST', url, true);

		// if request decorator defined pass XMLHttpRequest instance to decorator
		if (requestDecorator) {
			requestDecorator(xhr);
		}

		// handle state changes
		xhr.onreadystatechange = function () {

			if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {

				var text = xhr.responseText;

				// if no data returned from server assume success
				if (!text.length) {
					success();
					return;
				}

				// catch possible PHP content length problem
				if (text.indexOf('Content-Length') !== -1) {
					err('file-too-big');
					return;
				}

				// if data returned it should be in suggested JSON format
				var obj = void 0;
				try {
					obj = JSON.parse(xhr.responseText);
				} catch (e) { }

				// if is failure response
				if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj && obj.status === 'failure') {
					err(obj.message);
					return;
				}

				success(obj || text);
			} else if (xhr.readyState === 4) {

				var _obj = void 0;
				try {
					_obj = JSON.parse(xhr.responseText);
				} catch (e) { }

				// if is clean failure response
				if ((typeof _obj === 'undefined' ? 'undefined' : _typeof(_obj)) === 'object' && _obj && _obj.status === 'failure') {
					err(_obj.message);
					return;
				}

				err('fail');
			}
		};

		// do request
		xhr.send(data);
	};

	var resetTransforms = function resetTransforms(element) {
		if (!element) {
			return;
		}
		element.style.webkitTransform = '';
		element.style.transform = '';
	};

	var bytesToMegaBytes = function bytesToMegaBytes(b) {
		return b / 1000000;
	};

	var megaBytesToBytes = function megaBytesToBytes(mb) {
		return mb * 1000000;
	};

	var getCommonMimeTypes = function getCommonMimeTypes() {
		var types = [];
		var type = void 0;
		var mimeType = void 0;
		for (type in MimeTypes) {
			if (!MimeTypes.hasOwnProperty(type)) {
				continue;
			}
			mimeType = MimeTypes[type];
			if (types.indexOf(mimeType) == -1) {
				types.push(mimeType);
			}
		}
		return types;
	};

	var isJPEGMimeType = function isJPEGMimeType(type) {
		return type === 'image/jpeg';
	};

	var getExtensionByMimeType = function getExtensionByMimeType(mimetype) {
		var type = void 0;
		for (type in MimeTypes) {
			if (!MimeTypes.hasOwnProperty(type)) {
				continue;
			}
			if (MimeTypes[type] === mimetype) {
				return type;
			}
		}
		return mimetype;
	};

	var getMimeTypeFromResponseType = function getMimeTypeFromResponseType(responseType) {
		var type = void 0;
		for (type in MimeTypes) {
			if (!MimeTypes.hasOwnProperty(type)) {
				continue;
			}
			if (responseType.indexOf(MimeTypes[type]) !== -1) {
				return MimeTypes[type];
			}
		}
		return null;
	};

	var getFileName = function getFileName(path) {
		return path.split('/').pop().split('?').shift();
	};

	var leftPad = function leftPad(value) {
		var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
		return (padding + value).slice(-padding.length);
	};

	var getDateString = function getDateString(date) {
		return date.getFullYear() + '-' + leftPad(date.getMonth() + 1, '00') + '-' + leftPad(date.getDate(), '00') + '_' + leftPad(date.getHours(), '00') + '-' + leftPad(date.getMinutes(), '00') + '-' + leftPad(date.getSeconds(), '00');
	};

	var getFileNameByFile = function getFileNameByFile(file) {
		if (typeof file.name === 'undefined') {
			return getDateString(new Date()) + '.' + getExtensionByMimeType(getFileTypeByFile(file));
		}
		return file.name;
	};

	var getFileTypeByFile = function getFileTypeByFile(file) {
		return file.type || 'image/jpeg';
	};

	var getFileNameWithoutExtension = function getFileNameWithoutExtension(path) {
		if (typeof path !== 'string') {
			return getDateString(new Date());
		}
		var name = getFileName(path);
		return name.split('.').shift();
	};

	var blobToFile = function blobToFile(blob, name) {
		blob.lastModifiedDate = new Date();
		blob.name = name;
		return blob;
	};

	var resourceIsFetchURL = function resourceIsFetchURL(resource) {
		return (/^fetch\//.test(resource)
		);
	};

	var resourceIsBase64Data = function resourceIsBase64Data(resource) {
		return (/^data:image/.test(resource)
		);
	};

	var loadRemoteURL = function loadRemoteURL(fetcher, url, err, cb) {

		var xhr = new XMLHttpRequest();
		xhr.open('GET', fetcher + '?url=' + url, true);
		xhr.responseType = 'json';
		xhr.onload = function (e) {

			if (this.response.status === 'failure') {
				err(this.response.message);
				return;
			}

			loadURL(this.response.body, cb);
		};

		xhr.send();
	};

	var loadURL = function loadURL(url, cb) {

		var xhr = new XMLHttpRequest();
		xhr.open('GET', url, true);
		xhr.responseType = 'blob';
		xhr.onload = function (e) {

			var name = getFileName(url);
			var type = getMimeTypeFromResponseType(this.response.type);

			if (!ImageExtensionsRegex.test(name)) {
				name += '.' + getExtensionByMimeType(type);
			}

			// get as file
			var file = blobToFile(this.response, name);

			// need to set correct type
			cb(cloneFile(file, type));
		};

		xhr.send();
	};

	var base64ToByteString = function base64ToByteString(dataURI) {

		// get data part of string (remove data:image/jpeg...,)
		var dataPart = dataURI.split(',')[1];

		// remove any whitespace as that causes InvalidCharacterError in IE
		var dataPartCleaned = dataPart.replace(/\s/g, '');

		// to bytestring
		return atob(dataPartCleaned);
	};

	var base64ToBlob = function base64ToBlob(dataURI, filename) {

		var byteString = base64ToByteString(dataURI);
		var ab = new ArrayBuffer(byteString.length);
		var ia = new Uint8Array(ab);

		for (var i = 0; i < byteString.length; i++) {
			ia[i] = byteString.charCodeAt(i);
		}

		var mimeType = getMimeTypeFromDataURI(dataURI);

		if (typeof filename === 'undefined') {
			filename = getDateString(new Date()) + '.' + getExtensionByMimeType(mimeType);
		}

		return blobToFile(createBlob(ab, mimeType), filename);
	};

	var createBlob = function createBlob(data, mimeType) {

		var BB = window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;

		if (BB) {
			var bb = new BB();
			bb.append(data);
			return bb.getBlob(mimeType);
		}

		return new Blob([data], {
			type: mimeType
		});
	};

	var getImageAsCanvas = function getImageAsCanvas(src, size, callback) {

		// only cross origin when it's not base64 data, to prevent errors in Safari
		// http://stackoverflow.com/questions/31643096/why-does-safari-throw-cors-error-when-setting-base64-data-on-a-crossorigin-an
		var crossOrigin = typeof src === 'string' ? src.indexOf('data:image') !== 0 : true;

		loadImage.parseMetaData(src, function (meta) {

			var options = {
				canvas: true,
				crossOrigin: crossOrigin
			};

			if (size) {
				options.maxWidth = size.width;
				options.maxHeight = size.height;
			}

			if (meta.exif) {
				options.orientation = meta.exif.get('Orientation');
			}

			loadImage(src, function (res) {

				if (res.type === 'error') {
					callback();
					return;
				}

				callback(res, meta);
			}, options);
		});
	};

	var getAutoCropRect = function getAutoCropRect(width, height, ratioOut) {

		var x,
			y,
			w,
			h,
			ratioIn = height / width;

		// if input is portrait and required is landscape
		// width is portrait width, height is width times outputRatio
		if (ratioIn < ratioOut) {
			h = height;
			w = h / ratioOut;
			x = (width - w) * .5;
			y = 0;
		}

		// if input is landscape and required is portrait
		// height is landscape height, width is height divided by outputRatio
		else {
			w = width;
			h = w * ratioOut;
			x = 0;
			y = (height - h) * .5;
		}

		return {
			x: x,
			y: y,
			height: h,
			width: w
		};
	};

	var transformCanvas = function transformCanvas(canvas) {
		var transforms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
		var cb = arguments[2];


		var result = create('canvas');

		var rotation = transforms.rotation,
			crop = transforms.crop,
			size = transforms.size,
			filters = transforms.filters;

		// do crop transforms

		if (crop) {

			// do crop
			var isTilted = rotation % 180 !== 0;
			var space = {
				width: isTilted ? canvas.height : canvas.width,
				height: isTilted ? canvas.width : canvas.height
			};

			// limit crop to size of canvas else safari might return transparent image
			if (crop.x < 0) {
				crop.x = 0;
			}

			if (crop.y < 0) {
				crop.y = 0;
			}

			if (crop.width > space.width) {
				crop.width = space.width;
			}

			if (crop.height > space.height) {
				crop.height = space.height;
			}

			if (crop.y + crop.height > space.height) {
				crop.y = Math.max(0, space.height - crop.height);
			}

			if (crop.x + crop.width > space.width) {
				crop.x = Math.max(0, space.width - crop.width);
			}

			// crop offsets in percentages
			var px = crop.x / space.width;
			var py = crop.y / space.height;
			var pw = crop.width / space.width;
			var ph = crop.height / space.height;

			// resize canvas to the final crop result size
			result.width = crop.width;
			result.height = crop.height;

			// draw the crop
			var ctx = result.getContext('2d');

			if (rotation === 90) {

				ctx.translate(result.width * .5, result.height * .5);
				ctx.rotate(-90 * Math.PI / 180);
				ctx.drawImage(canvas,

					// source rectangle (crop area)
					(1 - py) * canvas.width - canvas.width * ph, crop.x, crop.height, crop.width,

					// target area (cover)
					-result.height * .5, -result.width * .5, result.height, result.width);
			} else if (rotation === 180) {

				ctx.translate(result.width * .5, result.height * .5);
				ctx.rotate(-180 * Math.PI / 180);
				ctx.drawImage(canvas,

					// source rectangle (crop area)
					(1 - (px + pw)) * space.width, (1 - (py + ph)) * space.height, pw * space.width, ph * space.height,

					// target area (cover)
					-result.width * .5, -result.height * .5, result.width, result.height);
			} else if (rotation === 270) {

				ctx.translate(result.width * .5, result.height * .5);
				ctx.rotate(-270 * Math.PI / 180);
				ctx.drawImage(canvas,

					// source rectangle (crop area)
					crop.y, (1 - px) * canvas.height - canvas.height * pw, crop.height, crop.width,

					// target area (cover)
					-result.height * .5, -result.width * .5, result.height, result.width);
			} else {

				ctx.drawImage(canvas,

					// source rectangle (crop area)
					crop.x, crop.y, crop.width, crop.height,

					// target area (cover)
					0, 0, result.width, result.height);
			}
		}

		// do size transforms
		if (size) {

			var scalarX = size.width / result.width;
			var scalarY = size.height / result.height;
			var scalar = Math.min(scalarX, scalarY);

			scaleCanvas(result, scalar, size);

			// sharpen result
			if (filters.sharpen > 0) {
				filter(result, sharpen(filters.sharpen));
			}
		}

		cb(result);
	};

	function scaleCanvas(canvas, scalar, bounds) {

		// if not scaling down, bail out
		if (scalar >= 1) {
			return;
		}

		var targetWidth = Math.min(bounds.width, Math.round(canvas.width * scalar));
		var targetHeight = Math.min(bounds.height, Math.round(canvas.height * scalar));
		var w = canvas.width;
		var h = canvas.height;
		var tmp = canvas;
		var c = void 0;
		var ctx = void 0;

		while (w > targetWidth && h > targetHeight) {

			c = document.createElement('canvas');
			w = Math.round(tmp.width * .5);
			h = Math.round(tmp.height * .5);

			if (w < targetWidth) {
				w = targetWidth;
			}

			if (h < targetHeight) {
				h = targetHeight;
			}

			c.width = w;
			c.height = h;
			ctx = c.getContext('2d');
			ctx.drawImage(tmp, 0, 0, w, h);

			tmp = cloneCanvas(c);
		}

		canvas.width = targetWidth;
		canvas.height = targetHeight;
		ctx = canvas.getContext('2d');
		ctx.drawImage(tmp, 0, 0, targetWidth, targetHeight);
	}

	var getPixels = function getPixels(canvas) {
		var ctx = canvas.getContext('2d');
		return ctx.getImageData(0, 0, canvas.width, canvas.height);
	};

	var filter = function filter(canvas, _filter) {
		var ctx = canvas.getContext('2d');
		ctx.putImageData(_filter(getPixels(canvas), canvas.width, canvas.height), 0, 0);
	};

	var createImageData = function createImageData(w, h, pixels) {
		var c = document.createElement('canvas');
		c.width = w;
		c.height = h;
		var ctx = c.getContext('2d');
		var data = ctx.createImageData(c.width, c.height);
		if (pixels) {
			data.set(pixels.data);
		}
		return data;
	};

	var sharpen = function sharpen(mix) {

		return function (pixels, w, h) {

			var weights = [0, -1, 0, -1, 5, -1, 0, -1, 0],
				katet = Math.round(Math.sqrt(weights.length)),
				half = katet * 0.5 | 0,
				dstData = createImageData(w, h),
				dstBuff = dstData.data,
				srcBuff = pixels.data,
				y = h,
				x = void 0;

			while (y--) {

				x = w;

				while (x--) {

					var sy = y,
						sx = x,
						dstOff = (y * w + x) * 4,
						r = 0,
						g = 0,
						b = 0,
						a = 0;

					for (var cy = 0; cy < katet; cy++) {
						for (var cx = 0; cx < katet; cx++) {

							var scy = sy + cy - half;
							var scx = sx + cx - half;

							if (scy >= 0 && scy < h && scx >= 0 && scx < w) {

								var srcOff = (scy * w + scx) * 4;
								var wt = weights[cy * katet + cx];

								r += srcBuff[srcOff] * wt;
								g += srcBuff[srcOff + 1] * wt;
								b += srcBuff[srcOff + 2] * wt;
								a += srcBuff[srcOff + 3] * wt;
							}
						}
					}

					dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
					dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
					dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix);
					dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
				}
			}

			return dstData;
		};
	};

	var sizeDist = function sizeDist(rect, canvas) {

		var dx = Math.abs(rect.width - canvas.width);
		var dy = Math.abs(rect.height - canvas.height);

		return Math.max(dx, dy);
	};

	var cloneCanvas = function cloneCanvas(original) {
		return cloneCanvasScaled(original, 1);
	};

	var cloneCanvasScaled = function cloneCanvasScaled(original, scalar) {

		if (!original) {
			return null;
		}

		var duplicate = document.createElement('canvas');
		var ctx = duplicate.getContext('2d');
		duplicate.width = original.width;
		duplicate.height = original.height;
		ctx.drawImage(original, 0, 0);
		if (scalar > 0 && scalar != 1) {
			scaleCanvas(duplicate, scalar, {
				width: Math.round(original.width * scalar),
				height: Math.round(original.height * scalar)
			});
		}

		return duplicate;
	};

	var canvasHasDimensions = function canvasHasDimensions(canvas) {
		return canvas.width && canvas.height;
	};

	var copyCanvas = function copyCanvas(original, destination) {

		var ctx = destination.getContext('2d');
		if (canvasHasDimensions(destination)) {
			ctx.drawImage(original, 0, 0, destination.width, destination.height);
		} else {
			destination.width = original.width;
			destination.height = original.height;
			ctx.drawImage(original, 0, 0);
		}
	};

	var clearCanvas = function clearCanvas(canvas) {
		var ctx = canvas.getContext('2d');
		ctx.clearRect(0, 0, canvas.width, canvas.height);
	};

	var blurCanvas = function blurCanvas(canvas) {
		stackBlur(canvas, 0, 0, canvas.width, canvas.height, 3);
	};

	var covers = function covers(image, rect) {
		return parseInt(image.width, 10) >= rect.width && parseInt(image.height, 10) >= rect.height;
	};

	var scaleRect = function scaleRect(rect, w, h) {
		return {
			x: rect.x * w,
			y: rect.y * h,
			width: rect.width * w,
			height: rect.height * h
		};
	};

	var divideRect = function divideRect(rect, w, h) {
		return {
			x: rect.x / w,
			y: rect.y / h,
			width: rect.width / w,
			height: rect.height / h
		};
	};

	var resetFileInput = function resetFileInput(input) {

		// no value, no need to reset
		if (!input || input.value === '') {
			return;
		}

		try {
			// for modern browsers
			input.value = '';
		} catch (err) { }

		// for IE10
		if (input.value) {

			// quickly append input to temp form and reset form
			var form = document.createElement('form');
			var parentNode = input.parentNode;
			var ref = input.nextSibling;
			form.appendChild(input);
			form.reset();

			// re-inject input where it originally was
			if (ref) {
				parentNode.insertBefore(input, ref);
			} else {
				parentNode.appendChild(input);
			}
		}
	};

	var clone = function clone(obj) {
		if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
			return JSON.parse(JSON.stringify(obj));
		}
		return obj;
	};

	var cloneFile = function cloneFile(file) {
		var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

		if (!file) {
			return null;
		}
		var dupe = file.slice(0, file.size, type || file.type);
		dupe.name = file.name;
		if (file.lastModifiedDate) {
			dupe.lastModifiedDate = new Date(file.lastModifiedDate);
		}
		return dupe;
	};

	var cloneData = function cloneData(obj) {
		var dupe = clone(obj);
		dupe.input.file = cloneFile(obj.input.file);
		dupe.output.image = cloneCanvas(obj.output.image);
		return dupe;
	};

	/**
	 * @param image
	 * @param type
	 * @param jpegCompression - value between 0 and 100 or undefined/null to use default compression
	 * @returns {*}
	 */
	var toDataURL = function toDataURL(image, type, jpegCompression) {
		if (!image || !type) {
			return null;
		}
		return image.toDataURL(type, isJPEGMimeType(type) && typeof jpegCompression === 'number' ? jpegCompression / 100 : undefined);
	};

	var getMimeTypeFromDataURI = function getMimeTypeFromDataURI(dataUri) {
		if (!dataUri) {
			return null;
		}
		var matches = dataUri.substr(0, 16).match(/^.+;/);
		if (matches.length) {
			return matches[0].substring(5, matches[0].length - 1);
		}
		return null;
	};

	var flattenData = function flattenData(obj) {
		var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
		var jpegCompression = arguments[2];
		var forcedType = arguments[3];
		var async = arguments[4];


		var data = {
			server: clone(obj.server),
			meta: clone(obj.meta),
			input: {
				name: obj.input.name,
				type: obj.input.type,
				size: obj.input.size,
				width: obj.input.width,
				height: obj.input.height,
				field: obj.input.field
			}
		};

		if (inArray('input', props) && !async) {
			data.input.image = toDataURL(obj.input.image, obj.input.type);
		}

		if (inArray('output', props)) {

			data.output = {
				name: forcedType ? getFileNameWithoutExtension(obj.input.name) + '.' + forcedType : obj.input.name,
				type: MimeTypes[forcedType] || obj.input.type,
				width: obj.output.width,
				height: obj.output.height
			};

			data.output.image = toDataURL(obj.output.image, data.output.type, jpegCompression);
			data.output.type = getMimeTypeFromDataURI(data.output.image);

			// browser problem:
			// if output is of type png and input was of type jpeg we need to fix extension of filename
			// so instead of testing the above situation we just always fix extension when handling PNGs
			if (data.output.type === 'image/png') {
				data.output.name = getFileNameWithoutExtension(data.input.name) + '.png';
			}
		}

		if (inArray('actions', props)) {
			data.actions = clone(obj.actions);
		}

		return data;
	};

	var downloadCanvas = function downloadCanvas(data, jpegCompression, forcedType) {

		var canvas = data.output.image;
		var filename = forcedType ? getFileNameWithoutExtension(data.input.name) + '.' + forcedType : data.input.name;
		var type = MimeTypes[forcedType] || data.input.type;

		// browser problem:
		// if output is of type png and input was of type jpeg we need to fix extension of filename
		// so instead of testing the above situation we just always fix extension when handling PNGs
		if (type === 'image/png') {
			filename = getFileNameWithoutExtension(data.input.name) + '.png';
		}

		canvas.toBlob(function (blob) {

			if ('msSaveBlob' in window.navigator) {
				window.navigator.msSaveBlob(blob, filename);
				return;
			}

			var url = (window.URL || window.webkitURL).createObjectURL(blob);

			// setup hidden link
			var link = create('a');
			link.style.display = 'none';
			link.download = filename;
			link.href = url;

			// attach to DOM otherwise this does not work in Firefox
			document.body.appendChild(link);

			// fire click
			link.click();

			// delay on remove otherwise does not work in Firefox
			setTimeout(function () {
				document.body.removeChild(link);
				(window.URL || window.webkitURL).revokeObjectURL(url);
			}, 0);
		}, type, typeof jpegCompression === 'number' ? jpegCompression / 100 : undefined);
	};

	var toggleDisplayBySelector = function toggleDisplayBySelector(selector, enabled, root) {
		var node = root.querySelector(selector);
		if (!node) {
			return;
		}
		node.style.display = enabled ? '' : 'none';
	};

	var nodeListToArray = function nodeListToArray(nl) {
		return Array.prototype.slice.call(nl);
	};

	var removeElement = function removeElement(el) {
		el.parentNode.removeChild(el);
	};

	var wrap = function wrap(element) {
		var wrapper = create('div');
		if (element.parentNode) {
			if (element.nextSibling) {
				element.parentNode.insertBefore(wrapper, element.nextSibling);
			} else {
				element.parentNode.appendChild(wrapper);
			}
		}
		wrapper.appendChild(element);
		return wrapper;
	};

	var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
		var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

		return {
			x: centerX + radius * Math.cos(angleInRadians),
			y: centerY + radius * Math.sin(angleInRadians)
		};
	};

	var describeArc = function describeArc(x, y, radius, startAngle, endAngle) {

		var start = polarToCartesian(x, y, radius, endAngle);
		var end = polarToCartesian(x, y, radius, startAngle);

		var arcSweep = endAngle - startAngle <= 180 ? '0' : '1';

		var d = ['M', start.x, start.y, 'A', radius, radius, 0, arcSweep, 0, end.x, end.y].join(' ');

		return d;
	};

	var percentageArc = function percentageArc(x, y, radius, p) {
		return describeArc(x, y, radius, 0, p * 360);
	};
	var CropArea = function () {

		var resizers = {
			'n': function n(rect, offset, space, ratio) {

				var t, r, b, l, w, h, p, d;

				// bottom is fixed
				b = rect.y + rect.height;

				// intended top
				t = limit(offset.y, 0, b);

				// if is too small vertically
				if (b - t < space.min.height) {
					t = b - space.min.height;
				}

				// if should scale by ratio, pick width by ratio of new height
				w = ratio ? (b - t) / ratio : rect.width;

				// check if has fallen below min width or height
				if (w < space.min.width) {
					w = space.min.width;
					if (ratio) {
						t = b - w * ratio;
					}
				}

				// add half to left and half to right edge
				p = (w - rect.width) * .5;
				l = rect.x - p;
				r = rect.x + rect.width + p;

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (l < 0 || r > space.width) {

					// smallest distance to edge of space
					d = Math.min(rect.x, space.width - (rect.x + rect.width));

					// new left and right offsets
					l = rect.x - d;
					r = rect.x + rect.width + d;

					// resulting width
					w = r - l;

					// resulting height based on ratio
					if (ratio) {
						h = w * ratio;
					}

					// new top position
					t = b - h;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			's': function s(rect, offset, space, ratio) {

				var t, r, b, l, w, h, p, d;

				// top is fixed
				t = rect.y;

				// intended bottom
				b = limit(offset.y, t, space.height);

				// if is too small vertically
				if (b - t < space.min.height) {
					b = t + space.min.height;
				}

				// if should scale by ratio, pick width by ratio of new height
				w = ratio ? (b - t) / ratio : rect.width;

				// check if has fallen below min width or height
				if (w < space.min.width) {
					w = space.min.width;
					if (ratio) {
						b = t + w * ratio;
					}
				}

				// add half to left and half to right edge
				p = (w - rect.width) * .5;
				l = rect.x - p;
				r = rect.x + rect.width + p;

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (l < 0 || r > space.width) {

					// smallest distance to edge of space
					d = Math.min(rect.x, space.width - (rect.x + rect.width));

					// new left and right offsets
					l = rect.x - d;
					r = rect.x + rect.width + d;

					// resulting width
					w = r - l;

					// resulting height based on ratio
					if (ratio) {
						h = w * ratio;
					}

					// new bottom position
					b = t + h;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'e': function e(rect, offset, space, ratio) {

				var t, r, b, l, w, h, p, d;

				// left is fixed
				l = rect.x;

				// intended right edge
				r = limit(offset.x, l, space.width);

				// if is too small vertically
				if (r - l < space.min.width) {
					r = l + space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : rect.height;

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						r = l + h / ratio;
					}
				}

				// add half to top and bottom
				p = (h - rect.height) * .5;
				t = rect.y - p;
				b = rect.y + rect.height + p;

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new top and bottom offsets
					t = rect.y - d;
					b = rect.y + rect.height + d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new right position
					r = l + w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'w': function w(rect, offset, space, ratio) {

				var t, r, b, l, w, h, p, d;

				// right is fixed
				r = rect.x + rect.width;

				// intended left edge
				l = limit(offset.x, 0, r);

				// if is too small vertically
				if (r - l < space.min.width) {
					l = r - space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : rect.height;

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						l = r - h / ratio;
					}
				}

				// add half to top and bottom
				p = (h - rect.height) * .5;
				t = rect.y - p;
				b = rect.y + rect.height + p;

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new top and bottom offsets
					t = rect.y - d;
					b = rect.y + rect.height + d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new right position
					l = r - w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'ne': function ne(rect, offset, space, ratio) {

				var t, r, b, l, w, h, d;

				// left and bottom are fixed
				l = rect.x;
				b = rect.y + rect.height;

				// intended right edge
				r = limit(offset.x, l, space.width);

				// if is too small vertically
				if (r - l < space.min.width) {
					r = l + space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : limit(b - offset.y, space.min.height, b);

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						r = l + h / ratio;
					}
				}

				// add height difference with original height to top
				t = rect.y - (h - rect.height);

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new top and bottom offsets
					t = rect.y - d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new right position
					r = l + w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'se': function se(rect, offset, space, ratio) {

				var t, r, b, l, w, h, d;

				// left and top are fixed
				l = rect.x;
				t = rect.y;

				// intended right edge
				r = limit(offset.x, l, space.width);

				// if is too small vertically
				if (r - l < space.min.width) {
					r = l + space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : limit(offset.y - rect.y, space.min.height, space.height - t);

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						r = l + h / ratio;
					}
				}

				// add height difference with original height to bottom
				b = rect.y + rect.height + (h - rect.height);

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new bottom offset
					b = rect.y + rect.height + d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new right position
					r = l + w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'sw': function sw(rect, offset, space, ratio) {

				var t, r, b, l, w, h, d;

				// right and top are fixed
				r = rect.x + rect.width;
				t = rect.y;

				// intended left edge
				l = limit(offset.x, 0, r);

				// if is too small vertically
				if (r - l < space.min.width) {
					l = r - space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : limit(offset.y - rect.y, space.min.height, space.height - t);

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						l = r - h / ratio;
					}
				}

				// add height difference with original height to bottom
				b = rect.y + rect.height + (h - rect.height);

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new bottom offset
					b = rect.y + rect.height + d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new left position
					l = r - w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			},
			'nw': function nw(rect, offset, space, ratio) {

				var t, r, b, l, w, h, d;

				// right and bottom are fixed
				r = rect.x + rect.width;
				b = rect.y + rect.height;

				// intended left edge
				l = limit(offset.x, 0, r);

				// if is too small vertically
				if (r - l < space.min.width) {
					l = r - space.min.width;
				}

				// if should scale by ratio, pick height by ratio of new width
				h = ratio ? (r - l) * ratio : limit(b - offset.y, space.min.height, b);

				// check if has fallen below min width or height
				if (h < space.min.height) {
					h = space.min.height;
					if (ratio) {
						l = r - h / ratio;
					}
				}

				// add height difference with original height to bottom
				t = rect.y - (h - rect.height);

				// check if any of the edges has moved out of the available space, if so,
				// set max size of rectangle from original position
				if (t < 0 || b > space.height) {

					// smallest distance to edge of space
					d = Math.min(rect.y, space.height - (rect.y + rect.height));

					// new bottom offset
					t = rect.y - d;

					// resulting height
					h = b - t;

					// resulting width based on ratio
					if (ratio) {
						w = h / ratio;
					}

					// new left position
					l = r - w;
				}

				return {
					x: l,
					y: t,
					width: r - l,
					height: b - t
				};
			}

		};

		/**
	  * CropArea
	  */
		return function () {
			function CropArea() {
				var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');

				_classCallCheck(this, CropArea);

				this._element = element;

				this._interaction = null;

				this._minWidth = 0;
				this._minHeight = 0;

				this._ratio = null;

				this._rect = {
					x: 0,
					y: 0,
					width: 0,
					height: 0
				};

				this._space = {
					width: 0,
					height: 0
				};

				this._rectChanged = false;

				this._init();
			}

			_createClass(CropArea, [{
				key: '_init',
				value: function _init() {

					this._element.className = 'slim-crop-area';

					// lines
					var lines = create('div', 'grid');
					this._element.appendChild(lines);

					// corner & edge resize buttons
					for (var handler in resizers) {
						if (!resizers.hasOwnProperty(handler)) {
							continue;
						}
						var _btn = create('button', handler);
						this._element.appendChild(_btn);
					}
					var btn = create('button', 'c');
					this._element.appendChild(btn);

					addEvents(document, Events.DOWN, this);
				}
			}, {
				key: 'reset',
				value: function reset() {

					this._interaction = null;

					this._rect = {
						x: 0,
						y: 0,
						width: 0,
						height: 0
					};

					this._rectChanged = true;

					this._redraw();

					this._element.dispatchEvent(new CustomEvent('change'));
				}
			}, {
				key: 'rescale',
				value: function rescale(scale) {

					// no rescale
					if (scale === 1) {
						return;
					}

					this._interaction = null;

					this._rectChanged = true;

					this._rect.x *= scale;
					this._rect.y *= scale;
					this._rect.width *= scale;
					this._rect.height *= scale;

					this._redraw();

					this._element.dispatchEvent(new CustomEvent('change'));
				}
			}, {
				key: 'limit',
				value: function limit(width, height) {
					this._space.width = width;
					this._space.height = height;
				}
			}, {
				key: 'offset',
				value: function offset(x, y) {
					this._space.x = x;
					this._space.y = y;
				}
			}, {
				key: 'resize',
				value: function resize(x, y, width, height) {

					this._interaction = null;

					this._rect = {
						x: limit(x, 0, this._space.width - this._minWidth),
						y: limit(y, 0, this._space.height - this._minHeight),
						width: limit(width, this._minWidth, this._space.width),
						height: limit(height, this._minHeight, this._space.height)
					};

					this._rectChanged = true;

					this._redraw();

					this._element.dispatchEvent(new CustomEvent('change'));
				}
			}, {
				key: 'handleEvent',
				value: function handleEvent(e) {

					switch (e.type) {

						case 'touchstart':
						case 'pointerdown':
						case 'mousedown':
							{
								this._onStartDrag(e);
							}
							break;
						case 'touchmove':
						case 'pointermove':
						case 'mousemove':
							{
								this._onDrag(e);
							}
							break;
						case 'touchend':
						case 'touchcancel':
						case 'pointerup':
						case 'mouseup':
							{
								this._onStopDrag(e);
							}

					}
				}
			}, {
				key: '_onStartDrag',
				value: function _onStartDrag(e) {

					// is not my event?
					if (!this._element.contains(e.target)) {
						return;
					}

					e.preventDefault();

					// listen to drag related events
					addEvents(document, Events.MOVE, this);
					addEvents(document, Events.UP, this);

					this._interaction = {
						type: e.target.className,
						offset: getEventOffsetScroll(e)
					};

					this._interaction.offset.x -= this._rect.x;
					this._interaction.offset.y -= this._rect.y;

					// now dragging
					this._element.setAttribute('data-dragging', 'true');

					// start the redraw update loop
					this._redraw();
				}
			}, {
				key: '_onDrag',
				value: function _onDrag(e) {

					e.preventDefault();

					// get local offset for this event
					var offset = getEventOffsetScroll(e);
					var type = this._interaction.type;

					// drag
					if (type === 'c') {

						this._rect.x = limit(offset.x - this._interaction.offset.x, 0, this._space.width - this._rect.width);
						this._rect.y = limit(offset.y - this._interaction.offset.y, 0, this._space.height - this._rect.height);
					}

					// resize
					else if (resizers[type]) {
						this._rect = resizers[type](this._rect, {
							x: offset.x - this._space.x,
							y: offset.y - this._space.y
						}, {
								x: 0,
								y: 0,
								width: this._space.width,
								height: this._space.height,
								min: {
									width: this._minWidth,
									height: this._minHeight
								}
							}, this._ratio);
					}

					this._rectChanged = true;

					// dispatch
					this._element.dispatchEvent(new CustomEvent('input'));
				}
			}, {
				key: '_onStopDrag',
				value: function _onStopDrag(e) {

					e.preventDefault();

					// stop listening to drag related events
					removeEvents(document, Events.MOVE, this);
					removeEvents(document, Events.UP, this);

					// no longer interacting, so no need to redraw
					this._interaction = null;

					// now dragging
					this._element.setAttribute('data-dragging', 'false');

					// fire change event
					this._element.dispatchEvent(new CustomEvent('change'));
				}
			}, {
				key: '_redraw',
				value: function _redraw() {
					var _this = this;

					if (this._rectChanged) {

						var transform = 'translate(' + this._rect.x + 'px,' + this._rect.y + 'px);';
						this._element.style.cssText = '\n\t\t\t\t\t-webkit-transform: ' + transform + ';\n\t\t\t\t\ttransform: ' + transform + ';\n\t\t\t\t\twidth:' + this._rect.width + 'px;\n\t\t\t\t\theight:' + this._rect.height + 'px;\n\t\t\t\t';

						this._rectChanged = false;
					}

					// if no longer interacting with crop area stop here
					if (!this._interaction) {
						return;
					}

					// redraw
					requestAnimationFrame(function () {
						return _this._redraw();
					});
				}
			}, {
				key: 'destroy',
				value: function destroy() {

					this._interaction = false;
					this._rectChanged = false;

					removeEvents(document, Events.DOWN, this);
					removeEvents(document, Events.MOVE, this);
					removeEvents(document, Events.UP, this);

					removeElement(this._element);
				}
			}, {
				key: 'element',
				get: function get() {
					return this._element;
				}
			}, {
				key: 'space',
				get: function get() {
					return this._space;
				}
			}, {
				key: 'area',
				get: function get() {

					var x = this._rect.x / this._space.width;
					var y = this._rect.y / this._space.height;
					var width = this._rect.width / this._space.width;
					var height = this._rect.height / this._space.height;

					return {
						x: x,
						y: y,
						width: width,
						height: height
					};
				}
			}, {
				key: 'dirty',
				get: function get() {
					return this._rect.x !== 0 || this._rect.y !== 0 || this._rect.width !== 0 || this._rect.height !== 0;
				}
			}, {
				key: 'minWidth',
				set: function set(value) {
					this._minWidth = value;
				}
			}, {
				key: 'minHeight',
				set: function set(value) {
					this._minHeight = value;
				}
			}, {
				key: 'ratio',
				set: function set(value) {
					this._ratio = value;
				}
			}]);

			return CropArea;
		}();
	}();
	var ImageEditor = function () {

		/**
	  * ImageEditor
	  * @param element
	  * @param options
	  * @constructor
	  */

		var CropAreaEvents = ['input', 'change'];

		var ImageEditor = function () {
			function ImageEditor() {
				var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

				_classCallCheck(this, ImageEditor);

				this._element = element;
				this._options = mergeOptions(ImageEditor.options(), options);

				this._ratio = null;
				this._output = null;

				this._input = null;

				this._preview = null;
				this._previewBlurred = null;

				this._blurredPreview = false;

				this._cropper = null;
				this._straightCrop = null;
				this._previewWrapper = null;
				this._currentWindowSize = {};

				this._btnGroup = null;
				this._maskFrame = null;

				this._dirty = false;

				this._wrapperRotation = 0;
				this._wrapperScale = 1.0;

				this._init();
			}

			_createClass(ImageEditor, [{
				key: '_init',
				value: function _init() {
					var _this2 = this;

					this._element.className = 'slim-image-editor';

					// container
					this._container = create('div', 'slim-container');

					// wrapper
					this._wrapper = create('div', 'slim-wrapper');

					// photo crop mark container
					this._stage = create('div', 'slim-stage');
					this._container.appendChild(this._stage);

					// create crop marks
					this._cropper = new CropArea();
					CropAreaEvents.forEach(function (e) {
						_this2._cropper.element.addEventListener(e, _this2);
					});
					this._stage.appendChild(this._cropper.element);

					// canvas ghost
					this._previewWrapper = create('div', 'slim-image-editor-preview slim-crop-preview');
					this._previewBlurred = create('canvas', 'slim-crop-blur');
					this._previewWrapper.appendChild(this._previewBlurred);
					this._wrapper.appendChild(this._previewWrapper);

					this._previewMask = create('div', 'slim-crop-mask');
					this._preview = create('img');
					this._previewMask.appendChild(this._preview);
					//this._previewWrapper.appendChild(this._preview);
					this._cropper.element.appendChild(this._previewMask);

					// buttons
					this._btnGroup = create('div', 'slim-editor-btn-group');
					ImageEditor.Buttons.forEach(function (c) {
						var prop = capitalizeFirstLetter(c);
						var label = _this2._options['button' + prop + 'Label'];
						var title = _this2._options['button' + prop + 'Title'];
						var className = _this2._options['button' + prop + 'ClassName'];
						var btn = create('button', 'slim-editor-btn slim-btn-' + c + (className ? ' ' + className : ''));
						btn.innerHTML = label;
						btn.title = title || label;
						btn.type = 'button';
						btn.setAttribute('data-action', c);
						btn.addEventListener('click', _this2);
						_this2._btnGroup.appendChild(btn);
					});

					// utils
					this._utilsGroup = create('div', 'slim-editor-utils-group');

					// create rotation button
					var btn = create('button', 'slim-editor-utils-btn slim-btn-rotate' + (this._options.buttonRotateClassName ? ' ' + this._options.buttonRotateClassName : ''));
					btn.setAttribute('data-action', 'rotate');
					btn.addEventListener('click', this);
					btn.title = this._options.buttonRotateTitle;
					this._utilsGroup.appendChild(btn);

					this._container.appendChild(this._wrapper);

					this._element.appendChild(this._container);
					this._element.appendChild(this._utilsGroup);
					this._element.appendChild(this._btnGroup);
				}
			}, {
				key: 'dirty',
				value: function dirty() {
					this._dirty = true;
				}
			}, {
				key: 'handleEvent',
				value: function handleEvent(e) {

					switch (e.type) {
						case 'click':
							this._onClick(e);
							break;
						case 'change':
							this._onGridChange(e);
							break;
						case 'input':
							this._onGridInput(e);
							break;
						case 'keydown':
							this._onKeyDown(e);
							break;
						case 'resize':
							this._onResize(e);
							break;
					}
				}
			}, {
				key: '_onKeyDown',
				value: function _onKeyDown(e) {

					switch (e.keyCode) {
						case Key.RETURN:
							{
								this._confirm();
								break;
							}
						case Key.ESC:
							{
								this._cancel();
								break;
							}
					}
				}
			}, {
				key: '_onClick',
				value: function _onClick(e) {

					if (e.target.classList.contains('slim-btn-cancel')) {
						this._cancel();
					}

					if (e.target.classList.contains('slim-btn-confirm')) {
						this._confirm();
					}

					if (e.target.classList.contains('slim-btn-rotate')) {
						this._rotate();
					}
				}
			}, {
				key: '_onResize',
				value: function _onResize() {

					// remember window size
					this._currentWindowSize = {
						width: window.innerWidth,
						height: window.innerHeight
					};

					// redraw the image editor based on new dimensions
					this._redraw();

					this._redrawCropper(this._cropper.area);

					this._updateWrapperScale();

					// apply rotation and scale
					this._redrawWrapper();
				}
			}, {
				key: '_redrawWrapper',
				value: function _redrawWrapper() {
					var matrix = snabbt.createMatrix();
					matrix.scale(this._wrapperScale, this._wrapperScale);
					matrix.rotateZ(this._wrapperRotation * (Math.PI / 180));
					snabbt.setElementTransform(this._previewWrapper, matrix);
				}
			}, {
				key: '_onGridInput',
				value: function _onGridInput() {

					this._redrawCropMask();
				}
			}, {
				key: '_onGridChange',
				value: function _onGridChange() {

					this._redrawCropMask();
				}
			}, {
				key: '_updateWrapperRotation',
				value: function _updateWrapperRotation() {

					if (this._options.minSize.width > this._input.height || this._options.minSize.height > this._input.width) {
						this._wrapperRotation += 180;
					} else {
						this._wrapperRotation += 90;
					}
				}
			}, {
				key: '_updateWrapperScale',
				value: function _updateWrapperScale() {

					// test if is tilted
					var isTilted = this._wrapperRotation % 180 !== 0;

					// if tilted determine correct scale factor
					if (isTilted) {

						// maximum size
						var maxWidth = this._container.offsetWidth;
						var maxHeight = this._container.offsetHeight;

						// get wrapper size
						var wrapperWidth = this._wrapper.offsetHeight;
						var wrapperHeight = this._wrapper.offsetWidth;

						var scalar = maxWidth / wrapperWidth;
						if (scalar * wrapperHeight > maxHeight) {
							scalar = maxHeight / wrapperHeight;
						}

						this._wrapperScale = scalar;
					} else {
						this._wrapperScale = 1.0;
					}
				}

				/**
		* Action handlers
		*/

			}, {
				key: '_cancel',
				value: function _cancel() {

					this._element.dispatchEvent(new CustomEvent('cancel'));
				}
			}, {
				key: '_confirm',
				value: function _confirm() {

					var isTilted = this._wrapperRotation % 180 !== 0;
					var area = this._cropper.area;

					var result = scaleRect(area, isTilted ? this._input.height : this._input.width, isTilted ? this._input.width : this._input.height);

					this._element.dispatchEvent(new CustomEvent('confirm', {
						detail: {
							rotation: this._wrapperRotation % 360,
							crop: result
						}
					}));
				}
			}, {
				key: '_rotate',
				value: function _rotate() {
					var _this3 = this;

					// rotate!
					this._updateWrapperRotation();

					// only pass current rect if is 1:1 or free
					var rect = this.ratio === 1 || this._ratio === null ? this._cropper.area : null;
					if (rect) {
						rotate(rect, 90);
					}

					// wrapper might also need to be scaled
					this._updateWrapperScale();

					// hide the cropper
					this._hideCropper();

					// rotation effect
					snabbt(this._previewWrapper, {
						rotation: [0, 0, this._wrapperRotation * (Math.PI / 180)],
						scale: [this._wrapperScale, this._wrapperScale],
						easing: 'spring',
						springConstant: .8,
						springDeceleration: .65,
						complete: function complete() {

							// redraws auto cropper
							_this3._redrawCropper(rect);

							// shows the cropper
							_this3._showCropper();
						}
					});
				}
			}, {
				key: '_showCropper',
				value: function _showCropper() {

					snabbt(this._stage, {
						easing: 'ease',
						duration: 250,
						fromOpacity: 0,
						opacity: 1.0
					});
				}
			}, {
				key: '_hideCropper',
				value: function _hideCropper() {

					snabbt(this._stage, {
						duration: 0,
						fromOpacity: 0,
						opacity: 0
					});
				}
			}, {
				key: '_redrawCropMask',
				value: function _redrawCropMask() {
					var _this4 = this;

					// get rotation
					var rotation = this._wrapperRotation % 360;

					// get scale
					var scale = this._wrapperScale;

					// get image size
					var canvas = {
						width: this._wrapper.offsetWidth,
						height: this._wrapper.offsetHeight
					};

					// get default mask cropper area
					var mask = this._cropper.area;
					var preview = {
						x: 0,
						y: 0
					};

					if (rotation === 0) {
						preview.x = -mask.x;
						preview.y = -mask.y;
					} else if (rotation === 90) {
						preview.x = -(1 - mask.y);
						preview.y = -mask.x;
					} else if (rotation === 180) {
						preview.x = -(1 - mask.x);
						preview.y = -(1 - mask.y);
					} else if (rotation === 270) {
						preview.x = -mask.y;
						preview.y = -(1 - mask.x);
					}

					// scale rect to fit canvas
					preview.x *= canvas.width;
					preview.y *= canvas.height;

					// update on next frame (so it's in sync with crop area redraw)
					cancelAnimationFrame(this._maskFrame);
					this._maskFrame = requestAnimationFrame(function () {

						var transform = 'scale(' + scale + ') rotate(' + -rotation + 'deg) translate(' + preview.x + 'px, ' + preview.y + 'px);';
						_this4._preview.style.cssText = '\n\t\t\t\t\twidth: ' + _this4._previewSize.width + 'px;\n\t\t\t\t\theight: ' + _this4._previewSize.height + 'px;\n\t\t\t\t\t-webkit-transform: ' + transform + ';\n\t\t\t\t\ttransform: ' + transform + ';\n\t\t\t\t';
					});
				}
			}, {
				key: 'open',
				value: function open(image, ratio, crop, rotation, complete) {
					var _this5 = this;

					// test if is same image
					if (this._input && !this._dirty && this._ratio === ratio) {
						complete();
						return;
					}

					// remember current window size
					this._currentWindowSize = {
						width: window.innerWidth,
						height: window.innerHeight
					};

					// reset dirty value
					this._dirty = false;

					// reset rotation
					this._wrapperRotation = rotation || 0;

					// we'll always have to blur the preview of a newly opened image
					this._blurredPreview = false;

					// set ratio
					this._ratio = ratio;

					// reset preview size
					this._previewSize = null;

					// hide editor
					this._element.style.opacity = '0';

					// set as new input image
					this._input = image;

					// calculate crop
					var tilted = rotation % 180 !== 0;
					var relativeCrop = divideRect(crop, tilted ? image.height : image.width, tilted ? image.width : image.height);

					// preview has now loaded
					this._preview.onload = function () {

						// reset onload listener
						_this5._preview.onload = null;

						// setup cropper
						_this5._cropper.ratio = _this5.ratio;

						// redraw view (for first time)
						_this5._redraw();

						// redraw cropper
						_this5._redrawCropper(relativeCrop);

						// done
						complete();

						// fade in
						_this5._element.style.opacity = '';
					};

					// load lower resolution preview image
					this._preview.src = cloneCanvasScaled(this._input, Math.min(this._container.offsetWidth / this._input.width, this._container.offsetHeight / this._input.height)).toDataURL();
				}
			}, {
				key: '_redrawCropper',
				value: function _redrawCropper(rect) {

					var isTilted = this._wrapperRotation % 180 !== 0;

					// image ratio
					var imageRatio = isTilted ? this._input.height / this._input.width : this._input.width / this._input.height;

					// get dimensions of image wrapper
					var width = this._wrapper.offsetWidth;
					var height = this._wrapper.offsetHeight;

					// get space
					var maxWidth = this._container.offsetWidth;
					var maxHeight = this._container.offsetHeight;

					// rescale wrapper
					this._updateWrapperScale();

					// position cropper container to fit wrapper
					var sw = this._wrapperScale * (isTilted ? height : width);
					var sh = this._wrapperScale * (isTilted ? width : height);
					var sx = isTilted ? (maxWidth - sw) * .5 : this._wrapper.offsetLeft;
					var sy = isTilted ? (maxHeight - sh) * .5 : this._wrapper.offsetTop;

					this._stage.style.cssText = '\n\t\t\t\tleft:' + sx + 'px;\n\t\t\t\ttop:' + sy + 'px;\n\t\t\t\twidth:' + sw + 'px;\n\t\t\t\theight:' + sh + 'px;\n\t\t\t';

					// set new size limit for crops
					// use image ratio so we have exact amount of pixels
					this._cropper.limit(sw, sw / imageRatio);
					this._cropper.offset(sx + this._element.offsetLeft, sy + this._element.offsetTop);

					// set min and max height of cropper
					this._cropper.minWidth = this._wrapperScale * this._options.minSize.width * this.scalar;
					this._cropper.minHeight = this._wrapperScale * this._options.minSize.height * this.scalar;

					// set crop rect
					var crop = null;
					if (rect) {
						crop = {
							x: rect.x * sw,
							y: rect.y * sh,
							width: rect.width * sw,
							height: rect.height * sh
						};
					} else {
						crop = getAutoCropRect(sw, sh, this._ratio || sh / sw);
					}

					this._cropper.resize(crop.x, crop.y, crop.width, crop.height);
				}
			}, {
				key: '_redraw',
				value: function _redraw() {

					// image ratio
					var ratio = this._input.height / this._input.width;

					// determine rounded size
					var maxWidth = this._container.clientWidth;
					var maxHeight = this._container.clientHeight;

					var width = maxWidth;
					var height = width * ratio;

					if (height > maxHeight) {
						height = maxHeight;
						width = height / ratio;
					}

					width = Math.round(width);
					height = Math.round(height);

					// rescale and recenter wrapper
					var x = (maxWidth - width) / 2;
					var y = (maxHeight - height) / 2;

					this._wrapper.style.cssText = '\n\t\t\t\tleft:' + x + 'px;\n\t\t\t\ttop:' + y + 'px;\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

					// set image size based on container dimensions
					this._previewBlurred.style.cssText = '\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

					this._preview.style.cssText = '\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

					this._previewSize = {
						width: width,
						height: height
					};

					// scale and blur the blurry preview
					if (!this._blurredPreview) {

						this._previewBlurred.width = 300;
						this._previewBlurred.height = this._previewBlurred.width * ratio;

						copyCanvas(this._input, this._previewBlurred);

						blurCanvas(this._previewBlurred, 3);

						this._blurredPreview = true;
					}
				}
			}, {
				key: 'show',
				value: function show() {
					var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () { };


					// test if window size has changed since previous showing
					if (this._currentWindowSize.width !== window.innerWidth || this._currentWindowSize.height !== window.innerHeight) {

						// if so, reposition elements
						this._redraw();

						// redraw cropper position
						this._redrawCropper(this._cropper.area);
					}

					// listen to keydown so we can close or confirm with RETURN / ESC
					document.addEventListener('keydown', this);

					// when window is scaled we want to resize the editor
					window.addEventListener('resize', this);

					// fade in preview
					var rotation = this._wrapperRotation * (Math.PI / 180);
					snabbt(this._previewWrapper, {
						fromRotation: [0, 0, rotation],
						rotation: [0, 0, rotation],
						fromPosition: [0, 0, 0],
						position: [0, 0, 0],
						fromOpacity: 0,
						opacity: 1,
						fromScale: [this._wrapperScale - .02, this._wrapperScale - .02],
						scale: [this._wrapperScale, this._wrapperScale],
						easing: 'spring',
						springConstant: .3,
						springDeceleration: .85,
						delay: 450,
						complete: function complete() {
							// don't reset transforms because we need rotation to stick
						}
					});

					if (this._cropper.dirty) {

						// now show cropper
						snabbt(this._stage, {
							fromPosition: [0, 0, 0],
							position: [0, 0, 0],
							fromOpacity: 0,
							opacity: 1,
							duration: 250,
							delay: 850,
							complete: function complete() {
								resetTransforms(this);
								callback();
							}
						});
					} else {

						// now show cropper
						snabbt(this._stage, {
							fromPosition: [0, 0, 0],
							position: [0, 0, 0],
							fromOpacity: 0,
							opacity: 1,
							duration: 250,
							delay: 1000,
							complete: function complete() {
								resetTransforms(this);
							}
						});
					}

					// now show buttons
					snabbt(this._btnGroup.childNodes, {
						fromScale: [.9, .9],
						scale: [1, 1],
						fromOpacity: 0,
						opacity: 1,
						delay: function delay(i) {
							return 1000 + i * 100;
						},
						easing: 'spring',
						springConstant: .3,
						springDeceleration: .85,
						complete: function complete() {
							resetTransforms(this);
						}
					});

					snabbt(this._utilsGroup.childNodes, {
						fromScale: [.9, .9],
						scale: [1, 1],
						fromOpacity: 0,
						opacity: 1,
						easing: 'spring',
						springConstant: .3,
						springDeceleration: .85,
						delay: 1250,
						complete: function complete() {
							resetTransforms(this);
						}
					});
				}
			}, {
				key: 'hide',
				value: function hide() {
					var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () { };


					// no more need to listen to keydown
					document.removeEventListener('keydown', this);

					// no more need to resize editor when window is scaled
					window.removeEventListener('resize', this);

					// fade out buttons
					snabbt(this._utilsGroup.childNodes, {
						fromOpacity: 1,
						opacity: 0,
						duration: 250
					});

					snabbt(this._btnGroup.childNodes, {
						fromOpacity: 1,
						opacity: 0,
						delay: 200,
						duration: 350
					});

					snabbt([this._stage, this._previewWrapper], {
						fromPosition: [0, 0, 0],
						position: [0, -250, 0],
						fromOpacity: 1,
						opacity: 0,
						easing: 'spring',
						springConstant: .3,
						springDeceleration: .75,
						delay: 250,
						allDone: function allDone() {

							callback();
						}
					});
				}
			}, {
				key: 'destroy',
				value: function destroy() {
					var _this6 = this;

					nodeListToArray(this._btnGroup.children).forEach(function (btn) {
						btn.removeEventListener('click', _this6);
					});

					CropAreaEvents.forEach(function (e) {
						_this6._cropper.element.removeEventListener(e, _this6);
					});

					this._cropper.destroy();

					// if still attached to DOM, detach
					if (this._element.parentNode) {
						removeElement(this._element);
					}
				}
			}, {
				key: 'showRotateButton',
				set: function set(enabled) {
					if (enabled) {
						this._element.classList.remove('slim-rotation-disabled');
					} else {
						this._element.classList.add('slim-rotation-disabled');
					}
				}
			}, {
				key: 'element',
				get: function get() {
					return this._element;
				}
			}, {
				key: 'ratio',
				get: function get() {
					if (this._ratio === 'input') {
						return this._input.height / this._input.width;
					}
					return this._ratio;
				}
			}, {
				key: 'offset',
				get: function get() {
					return this._element.getBoundingClientRect();
				}
			}, {
				key: 'original',
				get: function get() {
					return this._input;
				}
			}, {
				key: 'scalar',
				get: function get() {
					return this._previewSize.width / this._input.width;
				}
			}], [{
				key: 'options',
				value: function options() {

					return {
						buttonCancelClassName: null,
						buttonConfirmClassName: null,
						buttonCancelLabel: 'Cancel',
						buttonConfirmLabel: 'Confirm',
						buttonCancelTitle: null,
						buttonConfirmTitle: null,

						buttonRotateTitle: 'Rotate',
						buttonRotateClassName: null,

						minSize: {
							width: 0,
							height: 0
						}
					};
				}
			}]);

			return ImageEditor;
		}();

		ImageEditor.Buttons = ['cancel', 'confirm'];

		return ImageEditor;
	}(CropArea);
	var FileHopper = function () {

		/**
	  * FileHopper
	  * @param element
	  * @param options
	  * @constructor
	  */
		var DragDropEvents = ['dragover', 'dragleave', 'drop'];

		return function () {
			function FileHopper() {
				var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');

				_classCallCheck(this, FileHopper);

				this._element = element;
				this._accept = [];
				this._allowURLs = false;

				this._dragPath = null;

				this._init();
			}

			// public properties


			_createClass(FileHopper, [{
				key: 'isValidDataTransfer',
				value: function isValidDataTransfer(dataTransfer) {

					if (dataTransfer.files && dataTransfer.files.length) {
						return this.areValidDataTransferFiles(dataTransfer.files);
					}

					if (dataTransfer.items && dataTransfer.items.length) {
						return this.areValidDataTransferItems(dataTransfer.items);
					}

					return null;
				}
			}, {
				key: 'areValidDataTransferFiles',
				value: function areValidDataTransferFiles(files) {
					if (this._accept.length && files) {
						return this._accept.indexOf(files[0].type) !== -1;
					}
					return true;
				}
			}, {
				key: 'areValidDataTransferItems',
				value: function areValidDataTransferItems(items) {

					if (this._accept.length && items) {

						// is possibly dropping url
						if (this._allowURLs && items[0].kind === 'string') {
							return null;
						}

						// is http website so firefox will not return file type
						if (items[0].type && items[0].type.indexOf('application') === 0) {
							return null;
						}

						return this._accept.indexOf(items[0].type) !== -1;
					}

					return true;
				}

				// public methods

			}, {
				key: 'reset',
				value: function reset() {
					this._element.files = null;
				}

				// private

			}, {
				key: '_init',
				value: function _init() {
					var _this7 = this;

					this._element.className = 'slim-file-hopper';

					DragDropEvents.forEach(function (e) {
						_this7._element.addEventListener(e, _this7);
					});
				}

				// the input has changed

			}, {
				key: 'handleEvent',
				value: function handleEvent(e) {

					switch (e.type) {
						case 'dragover':
							this._onDragOver(e);
							break;
						case 'dragleave':
							this._onDragLeave(e);
							break;
						case 'drop':
							this._onDrop(e);
							break;
					}
				}
			}, {
				key: '_onDrop',
				value: function _onDrop(e) {

					// prevents browser from opening image
					e.preventDefault();

					// test if a url was dropped
					var remote = null;

					if (this._allowURLs) {

						var url = void 0;
						var meta = void 0;
						try {
							url = e.dataTransfer.getData('url');
							meta = e.dataTransfer.getData('text/html');
						} catch (e) {
							// nope nope nope (ie11 trouble)
						}

						if (meta && meta.length) {
							var parsed = meta.match(/src\s*=\s*"(.+?)"/);
							if (parsed) {
								remote = parsed[1];
							}
						} else if (url && url.length) {
							remote = url;
						}
					}

					if (remote) {
						this._element.files = [{ remote: remote }];
					}
					// nope, must have been a file
					else {

						// test type in older browsers
						var filesValidity = this.isValidDataTransfer(e.dataTransfer);
						if (!filesValidity) {

							// invalid files, stop here
							this._element.dispatchEvent(new CustomEvent('file-invalid-drop'));

							// no longer hovering
							this._dragPath = null;
							return;
						}

						// store dropped files on element files property, so can be accessed by same function as file input handler
						this._element.files = e.dataTransfer.files;
					}

					// file has been dropped
					this._element.dispatchEvent(new CustomEvent('file-drop', {
						detail: getOffsetByEvent(e)
					}));

					// file list has changed, let's notify others
					this._element.dispatchEvent(new CustomEvent('change'));

					// no longer hovering
					this._dragPath = null;
				}
			}, {
				key: '_onDragOver',
				value: function _onDragOver(e) {

					// prevents browser from opening image
					e.preventDefault();

					// set drop effect
					e.dataTransfer.dropEffect = 'copy';

					// determin if is valid data
					var dataValidity = this.isValidDataTransfer(e.dataTransfer);
					// if validity is null is undetermined
					if (dataValidity !== null && !dataValidity) {

						// indicate drop mode to user
						e.dataTransfer.dropEffect = 'none';

						// invalid files, stop here
						this._element.dispatchEvent(new CustomEvent('file-invalid'));
						return;
					}

					// now hovering file over the area
					if (!this._dragPath) {
						this._dragPath = [];
					}

					// push location
					this._dragPath.push(getOffsetByEvent(e));

					// file is hovering over element
					this._element.dispatchEvent(new CustomEvent('file-over', {
						detail: {
							x: last(this._dragPath).x,
							y: last(this._dragPath).y
						}
					}));
				}
			}, {
				key: '_onDragLeave',
				value: function _onDragLeave(e) {

					// user has dragged file out of element area
					this._element.dispatchEvent(new CustomEvent('file-out', {
						detail: getOffsetByEvent(e)
					}));

					// now longer hovering file
					this._dragPath = null;
				}
			}, {
				key: 'destroy',
				value: function destroy() {
					var _this8 = this;

					DragDropEvents.forEach(function (e) {
						_this8._element.removeEventListener(e, _this8);
					});

					removeElement(this._element);

					this._element = null;
					this._dragPath = null;
					this._accept = null;
				}
			}, {
				key: 'element',
				get: function get() {
					return this._element;
				}
			}, {
				key: 'dragPath',
				get: function get() {
					return this._dragPath;
				}
			}, {
				key: 'enabled',
				get: function get() {
					return this._element.style.display === '';
				},
				set: function set(value) {
					this._element.style.display = value ? '' : 'none';
				}
			}, {
				key: 'allowURLs',
				set: function set(value) {
					this._allowURLs = value;
				}
			}, {
				key: 'accept',
				set: function set(mimetypes) {
					this._accept = mimetypes;
				},
				get: function get() {
					return this._accept;
				}
			}]);

			return FileHopper;
		}();
	}();
	var Popover = function () {

		/**
	  * Popover
	  */
		return function () {
			function Popover() {
				_classCallCheck(this, Popover);

				this._element = null;
				this._inner = null;

				this._init();
			}

			_createClass(Popover, [{
				key: '_init',
				value: function _init() {

					this._element = create('div', 'slim-popover');
					this._element.setAttribute('data-state', 'off');
					document.body.appendChild(this._element);
				}
			}, {
				key: 'show',
				value: function show() {
					var _this9 = this;

					var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () { };


					// turn on
					this._element.setAttribute('data-state', 'on');

					// show and animate in
					snabbt(this._element, {
						fromOpacity: 0,
						opacity: 1,
						duration: 350,
						complete: function complete() {

							// clean up transforms
							resetTransforms(_this9._element);

							// ready!
							callback();
						}
					});
				}
			}, {
				key: 'hide',
				value: function hide() {
					var _this10 = this;

					var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () { };


					// animate out and hide
					snabbt(this._element, {
						fromOpacity: 1,
						opacity: 0,
						duration: 500,
						complete: function complete() {

							// clean up transforms
							resetTransforms(_this10._element);

							// hide the editor
							_this10._element.setAttribute('data-state', 'off');

							// ready!
							callback();
						}
					});
				}
			}, {
				key: 'destroy',
				value: function destroy() {
					if (!this._element.parentNode) {
						return;
					}
					this._element.parentNode.removeChild(this._element);
					this._element = null;
					this._inner = null;
				}
			}, {
				key: 'inner',
				set: function set(element) {

					this._inner = element;
					if (this._element.firstChild) {
						this._element.removeChild(this._element.firstChild);
					}
					this._element.appendChild(this._inner);
				}
			}]);

			return Popover;
		}();
	}();
	var intSplit = function intSplit(v, c) {
		return v.split(c).map(function (v) {
			return parseInt(v, 10);
		});
	};

	var isWrapper = function isWrapper(element) {
		return element.nodeName === 'DIV' || element.nodeName === 'SPAN';
	};

	var CropType = {
		AUTO: 'auto',
		INITIAL: 'initial',
		MANUAL: 'manual'
	};

	var Rect = ['x', 'y', 'width', 'height'];

	var HopperEvents = ['file-invalid-drop', 'file-invalid', 'file-drop', 'file-over', 'file-out', 'click'];

	var ImageEditorEvents = ['cancel', 'confirm'];

	var SlimButtons = ['remove', 'edit', 'download', 'upload'];

	var SlimPopover = null;
	var SlimCount = 0;

	var SlimLoaderHTML = '\n<div class="slim-loader">\n\t<svg>\n\t\t<path class="slim-loader-background" fill="none" stroke-width="3" />\n\t\t<path class="slim-loader-foreground" fill="none" stroke-width="3" />\n\t</svg>\n</div>\n';

	var SlimUploadStatusHTML = '\n<div class="slim-upload-status"></div>\n';

	var stringToSize = function stringToSize(str) {
		var size = str.split(',');
		return {
			width: parseInt(size[0], 10),
			height: parseInt(size[1], 10)
		};
	};

	var Slim = function () {
		function Slim(element) {
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			_classCallCheck(this, Slim);

			// create popover element if not already created
			if (!SlimPopover) {
				SlimPopover = new Popover();
			}

			// we create a new counter, we use this counter to determine if we need to clean up the popover
			this._uid = SlimCount++;

			// the options to use
			this._options = mergeOptions(Slim.options(), options);

			// test options correctness
			if (this._options.forceSize) {
				if (typeof this._options.forceSize === 'string') {
					this._options.forceSize = stringToSize(this._options.forceSize);
				}
				this._options.ratio = this._options.forceSize.width + ':' + this._options.forceSize.height;
				this._options.size = clone(this._options.forceSize);
			}

			// test for size set as string
			if (typeof this._options.size === 'string') {
				this._options.size = stringToSize(this._options.size);
			}

			// test for size set as string
			if (typeof this._options.minSize === 'string') {
				this._options.minSize = stringToSize(this._options.minSize);
			}

			// reference to original element so we can restore original situation
			this._originalElement = element;
			this._originalElementInner = element.innerHTML;
			this._originalElementAttributes = getElementAttributes(element);

			// should be file input, image or slim wrapper, if not wrapper, wrap
			if (!isWrapper(element)) {

				this._element = wrap(element);
				this._element.className = element.className;
				element.className = '';

				// ratio is used for CSS so let's set default attribute
				this._element.setAttribute('data-ratio', this._options.ratio);
			} else {
				this._element = element;
			}
			this._element.classList.add('slim');
			this._element.setAttribute('data-state', 'init');

			// editor state
			this._state = [];

			// internal timer array for async processes
			this._timers = [];

			// the source element (can either be an input or an img)
			this._input = null;

			// the source element unique name if is input type file
			this._inputReference = null;

			// the output element (hidden input that contains the resulting json object)
			this._output = null;

			// current image ratio
			this._ratio = null;

			// was required field
			this._isRequired = false;

			// components
			this._imageHopper = null;
			this._imageEditor = null;

			// progress path
			this._progressEnabled = true;

			// resulting data
			this._data = {};
			this._resetData();

			// the circle below the mouse hover point
			this._drip = null;

			// had initial image
			this._hasInitialImage = false;

			// initial crop
			this._initialCrop = this._options.crop;

			// initial rotation
			this._initialRotation = this._options.rotation && this._options.rotation % 90 === 0 ? this._options.rotation : null;

			// set to true when destroy method is called, used to halt any timeouts or async processes
			this._isBeingDestroyed = false;

			// stop here if not supported
			if (!Slim.supported) {
				this._fallback();
			} else {
				// let's go!
				this._init();
			}
		}

		_createClass(Slim, [{
			key: 'setRotation',
			value: function setRotation(rotation, callback) {

				if (typeof rotation !== 'number' && rotation % 90 !== 0) {
					return;
				}

				this._data.actions.rotation = rotation;
				var isTilted = this._data.actions.rotation % 180 !== 0;

				if (this._data.input.image) {
					var w = isTilted ? this._data.input.image.height : this._data.input.image.width;
					var h = isTilted ? this._data.input.image.width : this._data.input.image.height;
					this._data.actions.crop = getAutoCropRect(w, h, this._ratio);
					this._data.actions.crop.type = CropType.AUTO;
				}

				if (this._data.input.image && callback) {
					this._manualTransform(callback);
				}
			}
		}, {
			key: 'setSize',
			value: function setSize(dimensions, callback) {

				if (typeof dimensions === 'string') {
					dimensions = stringToSize(dimensions);
				}

				if (!dimensions || !dimensions.width || !dimensions.height) {
					return;
				}

				this._options.size = clone(dimensions);
				this._data.actions.size = clone(dimensions);

				// if a crop area is set do re-crop to conform to size
				if (this._data.input.image && callback) {
					this._manualTransform(callback);
				}
			}
		}, {
			key: 'setRatio',
			value: function setRatio(ratio, callback) {
				var _this11 = this;

				if (!ratio || typeof ratio !== 'string') {
					return;
				}

				this._options.ratio = ratio;

				if (this._isFixedRatio()) {

					var parts = intSplit(this._options.ratio, ':');
					this._ratio = parts[1] / parts[0];

					if (this._data.input.image && callback) {
						this._cropAuto(function (data) {
							_this11._scaleDropArea(_this11._ratio);
							if (callback) {
								callback(data);
							}
						});
					} else {

						if (this._data.input.image) {
							this._data.actions.crop = getAutoCropRect(this._data.input.image.width, this._data.input.image.height, this._ratio);
							this._data.actions.crop.type = CropType.AUTO;
						}

						this._scaleDropArea(this._ratio);

						if (callback) {
							callback(null);
						}
					}
				} else {
					this._scaleDropArea();
				}
			}

			// methods
			// Test if this Slim object has been bound to the given element

		}, {
			key: 'isAttachedTo',
			value: function isAttachedTo(element) {
				return this._element === element || this._originalElement === element;
			}
		}, {
			key: 'isDetached',
			value: function isDetached() {
				return this._element.parentNode === null;
			}
		}, {
			key: 'load',
			value: function load(src) {
				var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
				var callback = arguments[2];


				if (typeof options === 'function') {
					callback = options;
				} else {

					// store in options
					this._options.crop = options.crop;

					// set rotation
					this._options.rotation = options.rotation;

					// initial rotation
					this._initialRotation = options.rotation && options.rotation % 90 === 0 ? options.rotation : null;

					// set initial crop
					this._initialCrop = this._options.crop;
				}

				this._load(src, callback);
			}
		}, {
			key: 'upload',
			value: function upload(callback) {
				this._doUpload(callback);
			}
		}, {
			key: 'download',
			value: function download() {
				this._doDownload();
			}
		}, {
			key: 'remove',
			value: function remove() {
				return this._doRemove(true);
			}
		}, {
			key: 'destroy',
			value: function destroy() {
				this._doDestroy();
			}
		}, {
			key: 'edit',
			value: function edit() {
				this._doEdit();
			}
		}, {
			key: 'crop',
			value: function crop(rect, callback) {
				this._crop(rect.x, rect.y, rect.width, rect.height, callback);
			}
		}, {
			key: 'containsImage',
			value: function containsImage() {
				return this._data.input.name !== null;
			}

			/**
	   * State Related
	   */

		}, {
			key: '_canInstantEdit',
			value: function _canInstantEdit() {
				return this._options.instantEdit && !this._isInitialising;
			}
		}, {
			key: '_getFileInput',
			value: function _getFileInput() {
				return this._element.querySelector('input[type=file]');
			}
		}, {
			key: '_getInitialImage',
			value: function _getInitialImage() {
				return this._element.querySelector('img');
			}
		}, {
			key: '_getInputElement',
			value: function _getInputElement() {
				return this._getFileInput() || this._getInitialImage();
			}
		}, {
			key: '_getRatioSpacerElement',
			value: function _getRatioSpacerElement() {
				return this._element.children[0];
			}
		}, {
			key: '_isImageOnly',
			value: function _isImageOnly() {
				return this._input.nodeName !== 'INPUT';
			}
		}, {
			key: '_isFixedRatio',
			value: function _isFixedRatio() {
				return this._options.ratio.indexOf(':') !== -1;
			}
		}, {
			key: '_isAutoCrop',
			value: function _isAutoCrop() {
				return this._data.actions.crop.type === CropType.AUTO;
			}
		}, {
			key: '_toggleButton',
			value: function _toggleButton(action, state) {
				toggleDisplayBySelector('.slim-btn[data-action="' + action + '"]', state, this._element);
			}
		}, {
			key: '_clearState',
			value: function _clearState() {
				this._state = [];
				this._updateState();
			}
		}, {
			key: '_removeState',
			value: function _removeState(state) {
				this._state = this._state.filter(function (item) {
					return item !== state;
				});
				this._updateState();
			}
		}, {
			key: '_addState',
			value: function _addState(state) {
				if (inArray(state, this._state)) {
					return;
				}
				this._state.push(state);
				this._updateState();
			}
		}, {
			key: '_updateState',
			value: function _updateState() {
				if (!this._element) {
					return;
				}
				this._element.setAttribute('data-state', this._state.join(','));
			}
		}, {
			key: '_resetData',
			value: function _resetData() {

				// resets data object
				this._data = {
					server: null,
					meta: clone(this._options.meta),
					input: {
						field: this._inputReference,
						name: null,
						type: null,
						width: 0,
						height: 0,
						file: null
					},
					output: {
						image: null,
						width: 0,
						height: 0
					},
					actions: {
						rotation: null,
						crop: null,
						size: null
					}
				};

				// resets hidden input clone (has not yet been created when reset call in constructor, hence the check)
				if (this._output) {
					this._output.value = '';
				}

				// should reset file input
				resetFileInput(this._getFileInput());
			}

			/**
	   * Initialisation
	   */

		}, {
			key: '_init',
			value: function _init() {
				var _this12 = this;

				// busy initialising
				this._isInitialising = true;

				// cropper root is not file input
				this._addState('empty');

				// define input reference field name
				if (inArray('input', this._options.post)) {
					this._inputReference = 'slim_input_' + this._uid;
				}

				// get input element
				this._input = this._getInputElement();

				// if no input supplied we'll automatically create one
				if (!this._input) {
					this._input = create('input');
					this._input.type = 'file';
					this._element.appendChild(this._input);
				}

				// get required state of input element
				this._isRequired = this._input.required === true;

				// set or create output field
				this._output = this._element.querySelector('input[type=hidden]');

				// if no output element defined we'll create one automagically
				if (!this._output) {
					this._output = create('input');
					this._output.type = 'hidden';
					this._output.name = this._input.name || this._options.defaultInputName;
					this._element.appendChild(this._output);
				}

				// prevent the original file input field from posting (value will be duplicated to output field)
				this._input.removeAttribute('name');

				// create drop area
				var area = create('div', 'slim-area');

				// test if contains initial image
				var initialImage = this._getInitialImage();
				var initialImageSrc = (initialImage || {}).src;
				if (initialImageSrc) {
					this._hasInitialImage = true;
				} else {
					this._initialCrop = null;
					this._initialRotation = null;
				}

				var resultHTML = '\n\t\t<div class="slim-result">\n\t\t\t<img class="in" style="opacity:0" ' + (initialImageSrc ? 'src="' + initialImageSrc + '"' : '') + '><img><img style="opacity:0">\n\t\t</div>';

				// add drop overlay
				if (this._isImageOnly()) {
					area.innerHTML = '\n\t\t\t\t' + SlimLoaderHTML + '\n\t\t\t\t' + SlimUploadStatusHTML + '\n\t\t\t\t' + resultHTML + '\n\t\t\t\t<div class="slim-status"><div class="slim-label-loading">' + (this._options.labelLoading || '') + '</div></div>\n\t\t\t';
				} else {

					// if should post input data
					if (inArray('input', this._options.post)) {

						this._data.input.field = this._inputReference;

						// if is sync post
						// and should post input data
						if (!this._options.service) {
							this._input.name = this._inputReference;
						}
					}

					// set common image mime type to the accept attribute
					var mimetypes = void 0;
					if (!this._input.hasAttribute('accept') || this._input.getAttribute('accept') === 'image/*') {
						mimetypes = getCommonMimeTypes();
						this._input.setAttribute('accept', mimetypes.join(','));
					} else {
						mimetypes = this._input.accept.split(',').map(function (mimetype) {
							return mimetype.trim();
						}).filter(function (mimetype) {
							return mimetype.length > 0;
						});
					}

					// setup hopper
					this._imageHopper = new FileHopper();
					this._imageHopper.accept = mimetypes;
					this._imageHopper.allowURLs = typeof this._options.fetcher === 'string';
					this._element.appendChild(this._imageHopper.element);
					HopperEvents.forEach(function (e) {
						_this12._imageHopper.element.addEventListener(e, _this12);
					});

					// render area
					area.innerHTML = '\n\t\t\t\t' + SlimLoaderHTML + '\n\t\t\t\t' + SlimUploadStatusHTML + '\n\t\t\t\t<div class="slim-drip"><span><span></span></span></div>\n\t\t\t\t<div class="slim-status"><div class="slim-label">' + (this._options.label || '') + '</div><div class="slim-label-loading">' + (this._options.labelLoading || '') + '</div></div>\n\t\t\t\t' + resultHTML + '\n\t\t\t';

					// start listening for events so we can load image on file input change
					this._input.addEventListener('change', this);
				}

				// add area node
				this._element.appendChild(area);

				// add button group
				this._btnGroup = create('div', 'slim-btn-group');
				this._btnGroup.style.display = 'none';
				this._element.appendChild(this._btnGroup);
				SlimButtons.filter(function (c) {
					return _this12._isButtonAllowed(c);
				}).forEach(function (c) {
					var prop = capitalizeFirstLetter(c);
					var label = _this12._options['button' + prop + 'Label'];
					var title = _this12._options['button' + prop + 'Title'] || label;
					var className = _this12._options['button' + prop + 'ClassName'];
					var btn = create('button', 'slim-btn slim-btn-' + c + (className ? ' ' + className : ''));
					btn.innerHTML = label;
					btn.title = title;
					btn.type = 'button';
					btn.addEventListener('click', _this12);
					btn.setAttribute('data-action', c);
					_this12._btnGroup.appendChild(btn);
				});

				// add ratio padding
				if (this._isFixedRatio()) {
					var parts = intSplit(this._options.ratio, ':');
					this._ratio = parts[1] / parts[0];
					this._scaleDropArea(this._ratio);
				}

				// setup loader
				this._updateProgress(.5);

				// preload source
				if (initialImageSrc) {

					this._load(initialImageSrc, function () {
						_this12._onInit();
					});
				} else {
					this._onInit();
				}
			}
		}, {
			key: '_onInit',
			value: function _onInit() {
				var _this13 = this;

				// we're done initialising
				this._isInitialising = false;

				// done initialising now, else is only called after image load
				var done = function done() {
					// we call this async so the constructor of Slim has returned before the onInit is called, allowing clean immidiate destroy
					var timer = setTimeout(function () {
						_this13._options.didInit.apply(_this13, [_this13.data]);
					}, 0);
					_this13._timers.push(timer);
				};

				// save initial image
				if (this._options.saveInitialImage && this.containsImage()) {

					if (!this._options.service) {
						this._save(function () {
							done();
						}, false);
					}
				} else {

					// by default upload button is disabled for existing images
					if (this._options.service && this.containsImage()) {
						this._toggleButton('upload', false);
					}

					done();
				}
			}
		}, {
			key: '_updateProgress',
			value: function _updateProgress(progress) {

				if (isNaN(progress)) {
					return;
				}

				progress = Math.min(.99999, progress);

				if (!this._element) {
					return;
				}

				if (!this._progressEnabled) {
					return;
				}

				var loader = this._element.querySelector('.slim-loader');
				if (!loader) {
					return;
				}

				var size = loader.offsetWidth;
				var paths = loader.querySelectorAll('path');
				var ringWidth = parseInt(paths[0].getAttribute('stroke-width'), 10);

				paths[0].setAttribute('d', percentageArc(size * .5, size * .5, size * .5 - ringWidth, .9999));

				paths[1].setAttribute('d', percentageArc(size * .5, size * .5, size * .5 - ringWidth, progress));
			}
		}, {
			key: '_startProgress',
			value: function _startProgress(cb) {
				var _this14 = this;

				if (!this._element) {
					return;
				}

				this._progressEnabled = false;

				var loader = this._element.querySelector('.slim-loader');
				if (!loader) {
					return;
				}
				var ring = loader.children[0];

				this._stopProgressLoop(function () {

					loader.removeAttribute('style');
					ring.removeAttribute('style');

					_this14._progressEnabled = true;

					_this14._updateProgress(0);

					_this14._progressEnabled = false;

					snabbt(ring, {

						fromOpacity: 0,
						opacity: 1,
						duration: 250,
						complete: function complete() {
							_this14._progressEnabled = true;
							if (cb) {
								cb();
							}
						}
					});
				});
			}
		}, {
			key: '_stopProgress',
			value: function _stopProgress() {
				var _this15 = this;

				if (!this._element) {
					return;
				}

				var loader = this._element.querySelector('.slim-loader');
				if (!loader) {
					return;
				}
				var ring = loader.children[0];

				this._updateProgress(1);

				snabbt(ring, {
					fromOpacity: 1,
					opacity: 0,
					duration: 250,
					complete: function complete() {

						loader.removeAttribute('style');
						ring.removeAttribute('style');

						_this15._updateProgress(.5);

						_this15._progressEnabled = false;
					}
				});
			}
		}, {
			key: '_startProgressLoop',
			value: function _startProgressLoop() {

				if (!this._element) {
					return;
				}

				// start loading animation
				var loader = this._element.querySelector('.slim-loader');
				if (!loader) {
					return;
				}

				var ring = loader.children[0];
				loader.removeAttribute('style');
				ring.removeAttribute('style');

				// set infinite load state
				this._updateProgress(.5);

				// repeat!
				var repeat = 1000;

				snabbt(loader, 'stop');

				snabbt(loader, {
					rotation: [0, 0, -(Math.PI * 2) * repeat],
					easing: 'linear',
					duration: repeat * 1000
				});

				snabbt(ring, {
					fromOpacity: 0,
					opacity: 1,
					duration: 250
				});
			}
		}, {
			key: '_stopProgressLoop',
			value: function _stopProgressLoop(callback) {

				if (!this._element) {
					return;
				}

				var loader = this._element.querySelector('.slim-loader');
				if (!loader) {
					return;
				}

				var ring = loader.children[0];

				snabbt(ring, {
					fromOpacity: parseFloat(ring.style.opacity),
					opacity: 0,
					duration: 250,
					complete: function complete() {

						snabbt(loader, 'stop');

						loader.removeAttribute('style');
						ring.removeAttribute('style');

						if (callback) {
							callback();
						}
					}
				});
			}
		}, {
			key: '_isButtonAllowed',
			value: function _isButtonAllowed(button) {

				if (button === 'edit') {
					return this._options.edit;
				}

				if (button === 'download') {
					return this._options.download;
				}

				if (button === 'upload') {

					// if no service defined upload button makes no sense
					if (!this._options.service) {
						return false;
					}

					// if push mode is set, no need for upload button
					if (this._options.push) {
						return false;
					}

					// set upload button
					return true;
				}

				if (button === 'remove') {
					return !this._isImageOnly();
				}

				return true;
			}
		}, {
			key: '_fallback',
			value: function _fallback() {

				// create status area
				var area = create('div', 'slim-area');
				area.innerHTML = '\n\t\t\t<div class="slim-status"><div class="slim-label">' + (this._options.label || '') + '</div></div>\n\t\t';
				this._element.appendChild(area);

				this._throwError(this._options.statusNoSupport);
			}

			/**
	   * Event routing
	   */

		}, {
			key: 'handleEvent',
			value: function handleEvent(e) {

				switch (e.type) {
					case 'click':
						this._onClick(e);
						break;
					case 'change':
						this._onChange(e);
						break;
					case 'cancel':
						this._onCancel(e);
						break;
					case 'confirm':
						this._onConfirm(e);
						break;
					case 'file-over':
						this._onFileOver(e);
						break;
					case 'file-out':
						this._onFileOut(e);
						break;
					case 'file-drop':
						this._onDropFile(e);
						break;
					case 'file-invalid':
						this._onInvalidFile(e);
						break;
					case 'file-invalid-drop':
						this._onInvalidFileDrop(e);
						break;
				}
			}
		}, {
			key: '_getIntro',
			value: function _getIntro() {
				return this._element.querySelector('.slim-result .in');
			}
		}, {
			key: '_getOutro',
			value: function _getOutro() {
				return this._element.querySelector('.slim-result .out');
			}
		}, {
			key: '_getInOut',
			value: function _getInOut() {
				return this._element.querySelectorAll('.slim-result img');
			}
		}, {
			key: '_getDrip',
			value: function _getDrip() {
				if (!this._drip) {
					this._drip = this._element.querySelector('.slim-drip > span');
				}
				return this._drip;
			}

			// errors

		}, {
			key: '_throwError',
			value: function _throwError(error) {

				this._addState('error');

				this._element.querySelector('.slim-label').style.display = 'none';

				var node = this._element.querySelector('.slim-error');
				if (!node) {
					node = create('div', 'slim-error');
					this._element.querySelector('.slim-status').appendChild(node);
				}

				node.innerHTML = error;
			}
		}, {
			key: '_removeError',
			value: function _removeError() {

				this._removeState('error');
				this._element.querySelector('.slim-label').style.display = '';

				var error = this._element.querySelector('.slim-error');
				if (error) {
					error.parentNode.removeChild(error);
				}
			}
		}, {
			key: '_openFileDialog',
			value: function _openFileDialog() {
				this._removeError();
				this._input.click();
			}

			// drop area clicked

		}, {
			key: '_onClick',
			value: function _onClick(e) {
				var _this16 = this;

				var list = e.target.classList;
				var target = e.target;

				// no preview, so possible to drop file
				if (list.contains('slim-file-hopper')) {
					this._openFileDialog();
					return;
				}

				// decide what button was clicked
				switch (target.getAttribute('data-action')) {
					case 'remove':
						this._options.willRemove.apply(this, [this.data, function () {
							_this16._doRemove(true);
						}]);
						break;
					case 'edit':
						this._doEdit();
						break;
					case 'download':
						this._doDownload();
						break;
					case 'upload':
						this._doUpload();
						break;
				}
			}
		}, {
			key: '_onInvalidFileDrop',
			value: function _onInvalidFileDrop() {

				this._onInvalidFile();

				this._removeState('file-over');

				// animate out drip
				var drip = this._getDrip();
				snabbt(drip.firstChild, {
					fromScale: [.5, .5],
					scale: [0, 0],
					fromOpacity: .5,
					opacity: 0,
					duration: 150,
					complete: function complete() {

						// clean up transforms
						resetTransforms(drip.firstChild);
					}
				});
			}
		}, {
			key: '_onInvalidFile',
			value: function _onInvalidFile() {

				var types = this._imageHopper.accept.map(getExtensionByMimeType);
				var error = this._options.statusFileType.replace('$0', types.join(', '));
				this._throwError(error);
			}
		}, {
			key: '_onImageTooSmall',
			value: function _onImageTooSmall() {

				var error = this._options.statusImageTooSmall.replace('$0', this._options.minSize.width + ' \xD7 ' + this._options.minSize.height);
				this._throwError(error);
			}
		}, {
			key: '_onOverWeightFile',
			value: function _onOverWeightFile() {

				var error = this._options.statusFileSize.replace('$0', this._options.maxFileSize);
				this._throwError(error);
			}
		}, {
			key: '_onRemoteURLProblem',
			value: function _onRemoteURLProblem(error) {
				this._throwError(error);
			}
		}, {
			key: '_onFileOver',
			value: function _onFileOver(e) {

				this._addState('file-over');
				this._removeError();

				// animations
				var drip = this._getDrip();

				// move around drip
				var matrix = snabbt.createMatrix();
				matrix.translate(e.detail.x, e.detail.y, 0);
				snabbt.setElementTransform(drip, matrix);

				// on first entry fade in blob
				if (this._imageHopper.dragPath.length == 1) {

					// show
					drip.style.opacity = 1;

					// animate in
					snabbt(drip.firstChild, {
						fromOpacity: 0,
						opacity: .5,
						fromScale: [0, 0],
						scale: [.5, .5],
						duration: 150
					});
				}
			}
		}, {
			key: '_onFileOut',
			value: function _onFileOut(e) {

				this._removeState('file-over');
				this._removeState('file-invalid');
				this._removeError();

				// move to last position
				var drip = this._getDrip();
				var matrix = snabbt.createMatrix();
				matrix.translate(e.detail.x, e.detail.y, 0);
				snabbt.setElementTransform(drip, matrix);

				// animate out
				snabbt(drip.firstChild, {
					fromScale: [.5, .5],
					scale: [0, 0],
					fromOpacity: .5,
					opacity: 0,
					duration: 150,
					complete: function complete() {

						// clean up transforms
						resetTransforms(drip.firstChild);
					}
				});
			}

			/**
	   * When a file was literally dropped on the drop area
	   * @param e
	   * @private
	   */

		}, {
			key: '_onDropFile',
			value: function _onDropFile(e) {
				var _this17 = this;

				this._removeState('file-over');

				// get drip node reference and set to last position
				var drip = this._getDrip();
				var matrix = snabbt.createMatrix();
				matrix.translate(e.detail.x, e.detail.y, 0);
				snabbt.setElementTransform(drip, matrix);

				// get element minimum 10 entries distant from the last entry so we can calculate velocity of movement
				var l = this._imageHopper.dragPath.length;
				var jump = this._imageHopper.dragPath[l - Math.min(10, l)];

				// velocity
				var dx = e.detail.x - jump.x;
				var dy = e.detail.y - jump.y;

				snabbt(drip, {
					fromPosition: [e.detail.x, e.detail.y, 0],
					position: [e.detail.x + dx, e.detail.y + dy, 0],
					duration: 200
				});

				// animate out drip
				snabbt(drip.firstChild, {

					fromScale: [.5, .5],
					scale: [2, 2],
					fromOpacity: 1,
					opacity: 0,
					duration: 200,

					complete: function complete() {

						// clean up transforms
						resetTransforms(drip.firstChild);

						// load dropped resource
						_this17._load(e.target.files[0]);
					}
				});
			}

			/**
	   * When a file has been selected after a click on the drop area
	   * @param e
	   * @private
	   */

		}, {
			key: '_onChange',
			value: function _onChange(e) {

				if (e.target.files.length) {
					this._load(e.target.files[0]);
				}
			}

			/**
	   * Loads a resource (blocking operation)
	   * @param resource
	   * @param callback(err)
	   * @private
	   */

		}, {
			key: '_load',
			value: function _load(resource, callback) {
				var _this18 = this;

				// stop here
				if (this._isBeingDestroyed) {
					return;
				}

				// if currently contains image, remove it
				if (this.containsImage()) {

					clearTimeout(this._replaceTimeout);

					this._doRemove(false, function () {

						_this18._replaceTimeout = setTimeout(function () {
							_this18._load(resource, callback);
						}, 100);
					});

					return;
				}

				// no longer empty
				this._removeState('empty');
				this._addState('busy');

				// start loading indicator
				this._startProgressLoop();

				// can't drop any other image while loading
				if (this._imageHopper) {
					this._imageHopper.enabled = false;
				}

				clearTimeout(this._loadTimeout);
				var load = function load() {
					clearTimeout(_this18._loadTimeout);
					_this18._loadTimeout = setTimeout(function () {

						if (_this18._isBeingDestroyed) {
							return;
						}

						_this18._addState('loading');

						snabbt(_this18._element.querySelector('.slim-label-loading'), {
							fromOpacity: 0,
							opacity: 1,
							duration: 250
						});
					}, 500);
				};

				// early exit
				var exit = function exit() {
					if (_this18._imageHopper) {
						_this18._imageHopper.enabled = true;
					}
					_this18._removeState('loading');
					_this18._removeState('busy');
					_this18._addState('empty');
					_this18._stopProgressLoop();
				};

				// turn string based resources (url / base64) into file objects
				if (typeof resource === 'string') {

					if (resourceIsBase64Data(resource)) {
						// resource is base64 data, turn into file
						this._load(base64ToBlob(resource), callback);
					} else {

						// will take a while, show loading indicator
						load();

						// resource is url, load with XHR
						loadURL(resource, function (file) {
							// continue with file object
							_this18._load(file, callback);
						});
					}

					// don't continue, wait for load
					return;
				} else if (typeof resource.remote !== 'undefined' && this._options.fetcher) {

					loadRemoteURL(this._options.fetcher, resource.remote, function (error) {

						exit();

						_this18._onRemoteURLProblem('<p>' + error + '</p>');

						if (callback) {
							callback.apply(_this18, ['remote-url-problem']);
						}
					}, function (file) {
						// continue with file object
						_this18._load(file, callback);
					});

					// don't continue wait for server fetch
					return;
				}

				// let's continue with file resource
				var file = resource;

				// re-test if is valid file type
				// in case of loading base64 data or url
				if (this._imageHopper && this._imageHopper.accept.indexOf(file.type) === -1) {

					exit();

					this._onInvalidFile();
					if (callback) {
						callback.apply(this, ['file-invalid']);
					}
					return;
				}

				// test if too big
				if (file.size && this._options.maxFileSize && bytesToMegaBytes(file.size) > this._options.maxFileSize) {

					exit();

					this._onOverWeightFile();
					if (callback) {
						callback.apply(this, ['file-too-big']);
					}
					return;
				}

				// if has loaded image editor set to dirty
				if (this._imageEditor) {
					this._imageEditor.dirty();
				}

				// continue
				this._data.input.name = getFileNameByFile(file);
				this._data.input.type = getFileTypeByFile(file);
				this._data.input.size = file.size;
				this._data.input.file = file;

				// fetch resource
				getImageAsCanvas(file, this._options.internalCanvasSize, function (image, meta) {

					var rewind = function rewind() {

						// rewind state
						if (_this18._imageHopper) {
							_this18._imageHopper.enabled = true;
						}

						_this18._removeState('loading');
						_this18._removeState('busy');
						_this18._addState('empty');
						_this18._stopProgressLoop();
						_this18._resetData();
					};

					// if no image, something went wrong
					if (!image) {

						rewind();

						if (callback) {
							callback.apply(_this18, ['file-not-found']);
						}

						return;
					}

					// test if image is too small
					if (!covers(image, _this18._options.minSize)) {

						rewind();

						_this18._onImageTooSmall();

						if (callback) {
							callback.apply(_this18, ['image-too-small']);
						}

						return;
					}

					var status = _this18._options.didLoad.apply(_this18, [file, image, meta]);
					if (status !== true) {

						rewind();

						if (status !== false) {
							_this18._throwError(status);
						}

						if (callback) {
							callback.apply(_this18, [status]);
						}

						return;
					}

					// done loading file
					_this18._removeState('loading');

					var revealCanvas = function revealCanvas(done) {

						// done, enable hopper
						if (_this18._imageHopper && _this18._options.dropReplace) {
							_this18._imageHopper.enabled = true;
						}

						// do intro stuff
						var intro = _this18._getIntro();

						// setup base animation
						var animation = {
							fromScale: [1.25, 1.25],
							scale: [1, 1],
							fromOpacity: 0,
							opacity: 1,
							complete: function complete() {

								resetTransforms(intro);

								intro.style.opacity = 1;

								done();
							}

						};

						// if not attached to DOM, don't animate
						if (_this18.isDetached()) {
							animation.duration = 1;
						} else {
							animation.easing = 'spring';
							animation.springConstant = .3;
							animation.springDeceleration = .7;
						}

						// if is instant edit mode don't zoom out but zoom in
						if (_this18._canInstantEdit()) {
							animation.delay = 500;
							animation.duration = 1;

							// instant edit mode just fire up the editor immidiately
							_this18._doEdit();
						}

						// reveal loaded image
						snabbt(intro, animation);
					};

					// load the image
					_this18._loadCanvas(image,

						// done loading the canvas
						function (isUploading) {

							_this18._addState('preview');

							revealCanvas(function () {

								// don't show buttons when instant editing
								// the buttons will be triggered by the closing of the popup
								if (!_this18._canInstantEdit() && !isUploading) {
									_this18._showButtons();
								}

								if (!isUploading) {
									_this18._stopProgressLoop();
									_this18._removeState('busy');
								}

								if (callback) {
									callback.apply(_this18, [null, _this18.data]);
								}
							});
						},

						// done uploading
						function () {

							// don't show buttons when instant editing
							if (!_this18._canInstantEdit()) {
								_this18._showButtons();
							}

							_this18._removeState('busy');
						});
				});
			}
		}, {
			key: '_loadCanvas',
			value: function _loadCanvas(image, ready, complete) {
				var _this19 = this;

				// halt here if cropper is currently being destroyed
				if (this._isBeingDestroyed) {
					return;
				}

				// store raw data
				this._data.input.image = image;
				this._data.input.width = image.width;
				this._data.input.height = image.height;

				if (this._initialRotation) {
					this._data.actions.rotation = this._initialRotation;
					this._initialRotation = null;
				}

				var isTilted = this._data.actions.rotation % 180 !== 0;

				// scales the drop area
				// if is 'input' or 'free' parameter
				if (!this._isFixedRatio()) {
					if (this._initialCrop) {
						this._ratio = this._initialCrop.height / this._initialCrop.width;
					} else {
						this._ratio = isTilted ? image.width / image.height : image.height / image.width;
					}
					this._scaleDropArea(this._ratio);
				}

				if (this._initialCrop) {

					// use initial supplied crop rectangle
					this._data.actions.crop = clone(this._initialCrop);
					this._data.actions.crop.type = CropType.INITIAL;

					// clear initial crop, it's no longer useful
					this._initialCrop = null;
				} else {
					// get automagical crop rectangle
					this._data.actions.crop = getAutoCropRect(isTilted ? image.height : image.width, isTilted ? image.width : image.height, this._ratio);
					this._data.actions.crop.type = CropType.AUTO;
				}

				// if max size set
				if (this._options.size) {
					this._data.actions.size = {
						width: this._options.size.width,
						height: this._options.size.height
					};
				}

				// do initial auto transform
				this._applyTransforms(image, function (transformedImage) {

					var intro = _this19._getIntro();
					var scalar = intro.offsetWidth / transformedImage.width;

					// store data, if has preview image this prevents initial load from pushing
					var willUpload = false;

					// can only do auto upload when service is defined and push is enabled...
					if (_this19._options.service && _this19._options.push) {

						// ...and is not transformation of initial image
						// + is not instant edit mode
						if (!_this19._hasInitialImage && !_this19._canInstantEdit()) {
							willUpload = true;
							_this19._stopProgressLoop(function () {
								_this19._startProgress(function () {
									_this19._updateProgress(.1);
								});
							});
						}
					}

					// no service set, and instant edit
					if (!_this19._canInstantEdit()) {

						// store data (possibly)
						_this19._save(function () {
							if (_this19._isBeingDestroyed) {
								return;
							}
							if (willUpload) {
								_this19._stopProgress();
								complete();
							}
						}, willUpload);
					}

					// show intro animation
					intro.src = '';
					intro.src = cloneCanvasScaled(transformedImage, scalar).toDataURL();
					intro.onload = function () {

						intro.onload = null;

						// bail out if we've been cleaned up
						if (_this19._isBeingDestroyed) {
							return;
						}

						if (ready) {
							ready(willUpload);
						}
					};
				});
			}
		}, {
			key: '_applyTransforms',
			value: function _applyTransforms(image, ready) {
				var _this20 = this;

				var actions = clone(this._data.actions);
				actions.filters = {
					sharpen: this._options.filterSharpen / 100
				};

				transformCanvas(image, actions, function (transformedImage) {

					var outputImage = transformedImage;

					// if should force/correct output size?
					// - is forced size set?
					// - is a discrepancy found between requested output size and transformed size
					if (_this20._options.forceSize || _this20._options.size && sizeDist(_this20._options.size, transformedImage) == 1) {
						outputImage = create('canvas');
						outputImage.width = _this20._options.size.width;
						outputImage.height = _this20._options.size.height;
						var ctx = outputImage.getContext('2d');
						ctx.drawImage(transformedImage, 0, 0, _this20._options.size.width, _this20._options.size.height);
					}

					// store output
					_this20._data.output.width = outputImage.width;
					_this20._data.output.height = outputImage.height;
					_this20._data.output.image = outputImage;

					_this20._onTransformCanvas(function (transformedData) {

						_this20._data = transformedData;

						_this20._options.didTransform.apply(_this20, [_this20.data]);

						ready(_this20._data.output.image);
					});
				});
			}
		}, {
			key: '_onTransformCanvas',
			value: function _onTransformCanvas(ready) {

				this._options.willTransform.apply(this, [this.data, ready]);
			}

			/**
	   * Creates the editor nodes
	   * @private
	   */

		}, {
			key: '_appendEditor',
			value: function _appendEditor() {
				var _this21 = this;

				// we already have an editor
				if (this._imageEditor) {
					return;
				}

				// add editor
				this._imageEditor = new ImageEditor(create('div'), {
					minSize: this._options.minSize,

					buttonConfirmClassName: this._options.buttonConfirmClassName,
					buttonCancelClassName: this._options.buttonCancelClassName,
					buttonRotateClassName: this._options.buttonRotateClassName,

					buttonConfirmLabel: this._options.buttonConfirmLabel,
					buttonCancelLabel: this._options.buttonCancelLabel,
					buttonRotateLabel: this._options.buttonRotateLabel,

					buttonConfirmTitle: this._options.buttonConfirmTitle,
					buttonCancelTitle: this._options.buttonCancelTitle,
					buttonRotateTitle: this._options.buttonRotateTitle

				});

				// listen to events
				ImageEditorEvents.forEach(function (e) {
					_this21._imageEditor.element.addEventListener(e, _this21);
				});
			}
		}, {
			key: '_scaleDropArea',
			value: function _scaleDropArea(ratio) {
				var node = this._getRatioSpacerElement();
				if (!node || !this._element) {
					return;
				}
				if (ratio) {
					node.style.marginBottom = ratio * 100 + '%';
					this._element.setAttribute('data-ratio', '1:' + ratio);
				} else {
					node.style.marginBottom = null;
					this._element.removeAttribute('data-ratio');
				}

			}

			/**
	   * Data Layer
	   * @private
	   */
			// image editor closed

		}, {
			key: '_onCancel',
			value: function _onCancel(e) {

				this._removeState('editor');

				this._options.didCancel.apply(this);

				this._showButtons();

				this._hideEditor();

				if (this._options.instantEdit && !this._hasInitialImage && this._isAutoCrop()) {
					this._doRemove(false);
				}
			}

			// user confirmed changes

		}, {
			key: '_onConfirm',
			value: function _onConfirm(e) {
				var _this22 = this;

				// if
				// - service set
				// - and we are pushing
				// - and we don't instant edit
				// we will upload
				var willUpload = this._options.service && this._options.push;
				if (willUpload) {
					this._startProgress(function () {
						_this22._updateProgress(.1);
					});
				} else {
					this._startProgressLoop();
				}

				this._removeState('editor');

				this._addState('busy');

				// clear data
				this._output.value = '';

				// apply new action object to this._data
				this._data.actions.rotation = e.detail.rotation;
				this._data.actions.crop = e.detail.crop;
				this._data.actions.crop.type = CropType.MANUAL;

				// do transforms
				this._applyTransforms(this._data.input.image, function (transformedImage) {

					// user confirmed the crop (and changes have been applied to data)
					_this22._options.didConfirm.apply(_this22, [_this22.data]);

					// set new image result
					var images = _this22._getInOut();
					var intro = images[0].className === 'out' ? images[0] : images[1];
					var outro = intro === images[0] ? images[1] : images[0];

					intro.className = 'in';
					intro.style.opacity = '0';
					intro.style.zIndex = '2';
					outro.className = 'out';
					outro.style.zIndex = '1';

					// new image get's
					intro.src = '';
					intro.src = cloneCanvasScaled(transformedImage, intro.offsetWidth / transformedImage.width).toDataURL();
					intro.onload = function () {

						intro.onload = null;

						// scale the dropzone
						if (_this22._options.ratio === 'free') {
							_this22._ratio = intro.naturalHeight / intro.naturalWidth;
							_this22._scaleDropArea(_this22._ratio);
						}

						// close the editor
						_this22._hideEditor();

						// wait a tiny bit so animations sync up nicely
						var timer = setTimeout(function () {

							// show the preview
							_this22._showPreview(intro, function () {

								// save the data
								_this22._save(function (err, data, res) {

									// done!
									_this22._toggleButton('upload', true);

									if (willUpload) {
										_this22._stopProgress();
									} else {
										_this22._stopProgressLoop();
									}

									_this22._removeState('busy');

									_this22._showButtons();
								}, willUpload);
							});
						}, 250);

						_this22._timers.push(timer);
					};
				});
			}
		}, {
			key: '_cropAuto',
			value: function _cropAuto() {
				var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (data) { };


				var isTilted = this._data.actions.rotation % 180 !== 0;

				var rect = getAutoCropRect(isTilted ? this._data.input.image.width : this._data.input.image.height, isTilted ? this._data.input.image.height : this._data.input.image.width, this._ratio);

				this._crop(rect.x, rect.y, rect.width, rect.height, callback, CropType.AUTO);
			}
		}, {
			key: '_crop',
			value: function _crop(x, y, width, height) {
				var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (data) { };
				var cropType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : CropType.MANUAL;


				// clear data
				this._output.value = '';

				// apply new action object to this._data
				this._data.actions.crop = {
					x: x,
					y: y,
					width: width,
					height: height
				};
				this._data.actions.crop.type = cropType;

				this._manualTransform(callback);
			}
		}, {
			key: '_manualTransform',
			value: function _manualTransform(callback) {
				var _this23 = this;

				this._startProgressLoop();
				this._addState('busy');

				// do transforms
				this._applyTransforms(this._data.input.image, function (transformedImage) {

					// set new image result
					var images = _this23._getInOut();
					var intro = images[0].className === 'out' ? images[0] : images[1];
					var outro = intro === images[0] ? images[1] : images[0];

					intro.className = 'in';
					intro.style.opacity = '1';
					intro.style.zIndex = '2';
					outro.className = 'out';
					outro.style.zIndex = '0';

					// new image
					intro.src = '';
					intro.src = cloneCanvasScaled(transformedImage, intro.offsetWidth / transformedImage.width).toDataURL();
					intro.onload = function () {
						intro.onload = null;

						// scale the dropzone
						if (_this23._options.ratio === 'free') {
							_this23._ratio = intro.naturalHeight / intro.naturalWidth;
							_this23._scaleDropArea(_this23._ratio);
						}

						// determine if will also upload
						var willUpload = _this23._options.service && _this23._options.push;

						var save = function save() {

							// save the data
							_this23._save(function (err, data, res) {

								// stop loader
								if (!willUpload) {
									_this23._stopProgressLoop();
								}

								_this23._removeState('busy');

								callback.apply(_this23, [_this23.data]);
							}, willUpload);
						};

						if (willUpload) {
							_this23._startProgress(save);
						} else {
							save();
						}
					};
				});
			}
		}, {
			key: '_save',
			value: function _save() {
				var _this24 = this;

				var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () { };
				var allowUpload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;


				if (this._isBeingDestroyed) {
					return;
				}

				// flatten data also turns output canvas into data uri
				// removes input file object and image object
				var data = this.dataBase64;

				// decide if we need to
				// - A. Store the data in an output field
				// - B. Upload the data and store the response in output field

				// - we are not doing async uploading (in which case output is used for response)
				// - we are not initialising a replaceable image
				if (!this._options.service && !(this._isInitialising && !this._isImageOnly())) {

					this._options.willSave.apply(this, [data, function (data) {

						_this24._store(data);

						_this24._options.didSave.apply(_this24, [data]);
					}]);
				}

				if (this._isBeingDestroyed) {
					return;
				}

				// is remote service defined upload async
				if (this._options.service && allowUpload) {

					// allow user to modify the data
					this._options.willSave.apply(this, [data, function (data) {

						_this24._addState('upload');

						if (_this24._imageHopper && _this24._options.dropReplace) {
							_this24._imageHopper.enabled = false;
						}

						// do the actual uploading
						_this24._upload(data, function (err, res) {

							if (_this24._imageHopper && _this24._options.dropReplace) {
								_this24._imageHopper.enabled = true;
							}

							// store response
							if (!err) {
								_this24._storeServerResponse(res);
							}

							// we did upload data
							_this24._options.didUpload.apply(_this24, [err, data, res]);

							_this24._removeState('upload');

							// done!
							callback(err, data, res);
						});
					}]);
				}

				// if no service, we're done here
				if (!this._options.service || !allowUpload) {
					callback();
				}
			}

			// stores active file information in hidden output field

		}, {
			key: '_storeServerResponse',
			value: function _storeServerResponse(data) {

				// remove required flag
				if (this._isRequired) {
					this._input.required = false;
				}

				// store data returned from server
				this._data.server = data;

				// sync with output value
				this._output.value = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? JSON.stringify(this._data.server) : data;
			}

			// stores data in output field

		}, {
			key: '_store',
			value: function _store(data) {

				if (this._isRequired) {
					this._input.required = false;
				}

				this._output.value = JSON.stringify(data);
			}

			// uploads given data to server

		}, {
			key: '_upload',
			value: function _upload(data, callback) {
				var _this25 = this;

				var formData = new FormData();

				// if image data is defined, turn it into a file object (we can send files if we're uploading)
				if (this._data.output.image !== null && this._options.uploadBase64 === false) {
					var output = base64ToBlob(data.output.image, data.output.name);
					var field = /* 'slim_output_' + this._uid */ this._output.name;
					data.output.image = null;
					data.output.field = field;
					formData.append(field, output, data.output.name);
				}

				// output dataset
				if (inArray('data', this._options.post)) {
					formData.append(this._output.name, JSON.stringify(data));
				}

				// if input should be posted along, append data
				// to FormData object as file
				if (inArray('input', this._options.post)) {
					formData.append(this._inputReference, this._data.input.file, this._data.input.file.name);
				}

				var statusNode = this._element.querySelector('.slim-upload-status');

				var requestDecorator = this._options.willRequest;

				send(
					// url to service
					this._options.service,

					// data
					formData,

					// decorator (useful to add headers to request
					requestDecorator,

					// progress
					function (loaded, total) {

						_this25._updateProgress(Math.max(.1, loaded / total));
					},

					// success
					function (obj) {

						var timer = setTimeout(function () {

							// it's possible that Slim has been destroyed in the mean time.
							if (_this25._isBeingDestroyed) {
								return;
							}

							statusNode.innerHTML = _this25._options.statusUploadSuccess;
							statusNode.setAttribute('data-state', 'success');
							statusNode.style.opacity = 1;

							// hide status update after 2 seconds
							var timer = setTimeout(function () {
								statusNode.style.opacity = 0;
							}, 2000);

							_this25._timers.push(timer);
						}, 250);

						_this25._timers.push(timer);

						callback(null, obj);
					},

					// error
					function (status) {

						var html = '';
						if (status === 'file-too-big') {
							html = _this25._options.statusContentLength;
						} else {
							html = _this25._options.didReceiveServerError.apply(_this25, [status, _this25._options.statusUnknownResponse]);
						}

						// when an error occurs the status update is not automatically hidden
						var timer = setTimeout(function () {

							statusNode.innerHTML = html;
							statusNode.setAttribute('data-state', 'error');
							statusNode.style.opacity = 1;
						}, 250);

						_this25._timers.push(timer);

						callback(status);
					});
			}
		}, {
			key: '_showEditor',
			value: function _showEditor() {

				SlimPopover.show();

				this._imageEditor.show();
			}
		}, {
			key: '_hideEditor',
			value: function _hideEditor() {

				this._imageEditor.hide();

				var timer = setTimeout(function () {

					SlimPopover.hide();
				}, 250);

				this._timers.push(timer);
			}

			/**
	   * Animations
	   */

		}, {
			key: '_showPreview',
			value: function _showPreview(intro, callback) {

				snabbt(intro, {

					fromPosition: [0, 50, 0],
					position: [0, 0, 0],

					fromScale: [1.5, 1.5],
					scale: [1, 1],

					fromOpacity: 0,
					opacity: 1,

					easing: 'spring',
					springConstant: .3,
					springDeceleration: .7,

					complete: function complete() {

						resetTransforms(intro);

						if (callback) {
							callback();
						}
					}

				});
			}
		}, {
			key: '_hideResult',
			value: function _hideResult(callback) {

				var intro = this._getIntro();
				if (!intro) {
					return;
				}

				snabbt(intro, {

					fromScale: [1, 1],
					scale: [.5, .5],

					fromOpacity: 1,
					opacity: 0,

					easing: 'spring',
					springConstant: .3,
					springDeceleration: .75,

					complete: function complete() {
						resetTransforms(intro);
						if (callback) {
							callback();
						}
					}

				});
			}
		}, {
			key: '_showButtons',
			value: function _showButtons(callback) {

				if (!this._btnGroup) {
					return;
				}

				this._btnGroup.style.display = '';

				// setup animation
				var animation = {
					fromScale: [.5, .5],
					scale: [1, 1],
					fromPosition: [0, 10, 0],
					position: [0, 0, 0],
					fromOpacity: 0,
					opacity: 1,
					complete: function complete() {
						resetTransforms(this);
					},
					allDone: function allDone() {
						if (callback) {
							callback();
						}
					}
				};

				// don't animate when detached
				if (this.isDetached()) {
					animation.duration = 1;
				} else {
					animation.delay = function (i) {
						return 250 + i * 50;
					};
					animation.easing = 'spring';
					animation.springConstant = .3;
					animation.springDeceleration = .85;
				}

				snabbt(this._btnGroup.childNodes, animation);
			}
		}, {
			key: '_hideButtons',
			value: function _hideButtons(callback) {
				var _this26 = this;

				if (!this._btnGroup) {
					return;
				}

				var animation = {
					fromScale: [1, 1],
					scale: [.85, .85],
					fromOpacity: 1,
					opacity: 0,
					allDone: function allDone() {
						_this26._btnGroup.style.display = 'none';
						if (callback) {
							callback();
						}
					}
				};

				// don't animate when detached
				if (this.isDetached()) {
					animation.duration = 1;
				} else {
					animation.easing = 'spring';
					animation.springConstant = .3;
					animation.springDeceleration = .75;
				}

				// go hide the buttons
				snabbt(this._btnGroup.childNodes, animation);
			}
		}, {
			key: '_hideStatus',
			value: function _hideStatus() {

				var statusNode = this._element.querySelector('.slim-upload-status');
				statusNode.style.opacity = 0;
			}
		}, {
			key: '_doEdit',
			value: function _doEdit() {
				var _this27 = this;

				// if no input data available, can't edit anything
				if (!this._data.input.image) {
					return;
				}

				// now in editor mode
				this._addState('editor');

				// create editor (if not already created)
				if (!this._imageEditor) {
					this._appendEditor();
				}

				// hide or show rotate button
				this._imageEditor.showRotateButton = this._options.rotateButton;

				// append to popover
				SlimPopover.inner = this._imageEditor.element;

				// read the data
				this._imageEditor.open(

					// send copy of canvas to the editor
					cloneCanvas(this._data.input.image),

					// determine ratio
					this._options.ratio === 'free' ? null : this._ratio,

					// the initial crop to show
					this._data.actions.crop,

					// the initial rotation of the image
					this._data.actions.rotation,

					// handle editor load
					function () {

						_this27._showEditor();

						_this27._hideButtons();

						_this27._hideStatus();
					});
			}
		}, {
			key: '_doRemove',
			value: function _doRemove(removeAction, done) {
				var _this28 = this;

				// cannot remove when is only one image
				if (this._isImageOnly()) {
					return;
				}

				this._clearState();
				this._addState('empty');

				this._hasInitialImage = false;
				if (this._imageHopper) {
					this._imageHopper.enabled = true;
				}

				if (this._isRequired) {
					this._input.required = true;
				}

				var out = this._getOutro();
				if (out) {
					out.style.opacity = '0';
				}

				// get public available clone of data
				var data = this.data;

				// now reset all data
				this._resetData();

				var timer = setTimeout(function () {

					if (_this28._isBeingDestroyed) {
						return;
					}

					_this28._hideButtons(function () {

						_this28._toggleButton('upload', true);
					});

					_this28._hideStatus();

					_this28._hideResult(function() {
						_this28._options.didRemove.apply(_this28, [removeAction, data]);
					});

					if (done) {
						done();
					}
				}, this.isDetached() ? 0 : 250);

				this._timers.push(timer);

				return data;
			}
		}, {
			key: '_doUpload',
			value: function _doUpload(callback) {
				var _this29 = this;

				// if no input data available, can't upload anything
				if (!this._data.input.image) {
					return;
				}

				this._addState('upload');
				this._startProgress();

				this._hideButtons(function () {

					// block upload button
					_this29._toggleButton('upload', false);

					_this29._save(function (err, data, res) {

						_this29._removeState('upload');
						_this29._stopProgress();

						if (callback) {
							callback.apply(_this29, [err, data, res]);
						}

						if (err) {
							_this29._toggleButton('upload', true);
						}

						_this29._showButtons();
					});
				});
			}
		}, {
			key: '_doDownload',
			value: function _doDownload() {

				var image = this._data.output.image;
				if (!image) {
					return;
				}

				downloadCanvas(this._data, this._options.jpegCompression, this._options.forceType);
			}
		}, {
			key: '_doDestroy',
			value: function _doDestroy() {
				var _this30 = this;

				// set destroy flag to halt any running functionality
				this._isBeingDestroyed = true;

				// clear timers
				this._timers.forEach(function (timer) {
					clearTimeout(timer);
				});
				this._timers = [];

				// clean up snabbt animations
				snabbt(this._element, 'detach');

				// this removes the image hopper if it's attached
				if (this._imageHopper) {
					HopperEvents.forEach(function (e) {
						_this30._imageHopper.element.removeEventListener(e, _this30);
					});
					this._imageHopper.destroy();
					this._imageHopper = null;
				}

				// this block removes the image editor
				if (this._imageEditor) {
					ImageEditorEvents.forEach(function (e) {
						_this30._imageEditor.element.removeEventListener(e, _this30);
					});
					this._imageEditor.destroy();
					this._imageEditor = null;
				}

				// remove button event listeners
				nodeListToArray(this._btnGroup.children).forEach(function (btn) {
					btn.removeEventListener('click', _this30);
				});

				// stop listening to input
				this._input.removeEventListener('change', this);

				// detect if was wrapped, if so, remove wrapping (needs to have parent node)
				if (this._element !== this._originalElement && this._element.parentNode) {
					this._element.parentNode.replaceChild(this._originalElement, this._element);
				}
/*
				// restore HTML of original element
				this._originalElement.innerHTML = this._originalElementInner;
*/
				// get current attributes and remove all, then add original attributes
				function matchesAttributeInList(a, attributes) {
					return attributes.filter(function (attr) {
						return a.name === attr.name && a.value === attr.value;
					}).length !== 0;
				}

				var attributes = getElementAttributes(this._originalElement);
				attributes.forEach(function (attribute) {

					// if attribute  is contained in original element attribute list and is the same, don't remove
					if (matchesAttributeInList(attribute, _this30._originalElementAttributes)) {
						return;
					}

					// else remove
					_this30._originalElement.removeAttribute(attribute.name);
				});

				this._originalElementAttributes.forEach(function (attribute) {

					// attribute was never removed
					if (matchesAttributeInList(attribute, attributes)) {
						return;
					}

					// add attribute
					_this30._originalElement.setAttribute(attribute.name, attribute.value);
				});

				// now destroyed this counter so the total Slim count can be lowered
				SlimCount = Math.max(0, SlimCount - 1);

				// if slim count has reached 0 it's time to clean up the popover
				if (SlimPopover && SlimCount === 0) {
					SlimPopover.destroy();
					SlimPopover = null;
				}

				this._originalElement = null;
				this._element = null;
				this._input = null;
				this._output = null;
				this._btnGroup = null;
				this._options = null;
			}
		}, {
			key: 'dataBase64',


			/**
	   * Public API
	   */
			// properties
			get: function get() {
				return flattenData(this._data, this._options.post, this._options.jpegCompression, this._options.forceType, this._options.service !== null);
			}
		}, {
			key: 'data',
			get: function get() {
				return cloneData(this._data);
			}
		}, {
			key: 'element',
			get: function get() {
				return this._element;
			}
		}, {
			key: 'service',
			set: function set(service) {
				this._options.service = service;
			}
		}, {
			key: 'size',
			set: function set(dimensions) {
				this.setSize(dimensions, null);
			}
		}, {
			key: 'rotation',
			set: function set(rotation) {
				this.setRotation(rotation, null);
			}
		}, {
			key: 'ratio',
			set: function set(ratio) {
				this.setRatio(ratio, null);
			}
		}], [{
			key: 'options',
			value: function options() {

				var defaults = {

					// edit button is enabled by default
					edit: true,

					// immidiately summons editor on load
					instantEdit: false,

					// set to true to upload data as base64 string
					uploadBase64: false,

					// metadata values
					meta: {},

					// ratio of crop by default is the same as input image ratio
					ratio: 'free',

					// dimensions to resize the resulting image to
					size: null,

					// set initial rotation
					rotation: null,

					// initial crop settings for example: {x:0, y:0, width:100, height:100}
					crop: null,

					// post these values
					post: ['output', 'actions'],

					// call this service to submit cropped data
					service: null,

					// sharpen filter value, really low values might improve image output
					filterSharpen: 0,

					// when service is set, and this is set to true, Soon will auto upload all crops (also auto crops)
					push: false,

					// default fallback name for field
					defaultInputName: 'slim[]',

					// minimum size of cropped area object with width and height property
					minSize: {
						width: 100,
						height: 100
					},

					// maximum file size in MB to upload
					maxFileSize: null,

					// compression of JPEG (between 0 and 100)
					jpegCompression: null,

					// render download link
					download: false,

					// save initially loaded image
					saveInitialImage: false,

					// the type to force (jpe|jpg|jpeg or png)
					forceType: false,

					// the forced output size of the image
					forceSize: null,

					// disable drop to replace
					dropReplace: true,

					// remote URL service
					fetcher: null,

					// set the internal canvas size
					internalCanvasSize: {
						width: 4096,
						height: 4096
					},

					// enable or disable rotation
					rotateButton: true,

					// label HTML to show inside drop area
					label: '<p>Drop your image here</p>',
					labelLoading: '<p>Loading image...</p>',

					// error messages
					statusFileType: '<p>Invalid file type, expects: $0.</p>',
					statusFileSize: '<p>File is too big, maximum file size: $0 MB.</p>',
					statusNoSupport: '<p>Your browser does not support image cropping.</p>',
					statusImageTooSmall: '<p>Image is too small, minimum size is: $0 pixels.</p>',
					statusContentLength: '<span class="slim-upload-status-icon"></span> The file is probably too big',
					statusUnknownResponse: '<span class="slim-upload-status-icon"></span> An unknown error occurred',
					statusUploadSuccess: '<span class="slim-upload-status-icon"></span> Saved',

					// callback methods
					didInit: function didInit(data) { },
					didLoad: function didLoad(file, image, meta) {
						return true;
					},
					didSave: function didSave(data) { },
					didUpload: function didUpload(err, data, res) { },
					didReceiveServerError: function didReceiveServerError(err, defaultError) {
						return defaultError;
					},
					didRemove: function didRemove(removeAction, data) { },
					didTransform: function didTransform(data) { },
					didConfirm: function didConfirm(data) { },
					didCancel: function didCancel() { },

					willTransform: function willTransform(data, cb) {
						cb(data);
					},
					willSave: function willSave(data, cb) {
						cb(data);
					},
					willRemove: function willRemove(data, cb) {
						cb();
					},
					willRequest: function willRequest(xhr) { }

				};

				// add default button labels
				SlimButtons.concat(ImageEditor.Buttons).concat('rotate').forEach(function (btn) {
					var capitalized = capitalizeFirstLetter(btn);
					defaults['button' + capitalized + 'ClassName'] = null;
					defaults['button' + capitalized + 'Label'] = capitalized;
					defaults['button' + capitalized + 'Title'] = capitalized;
				});

				return defaults;
			}
		}]);

		return Slim;
	}();

	/**
	 * Slim Static Methods
	 */


	(function () {

		var instances = [];

		var indexOfElement = function indexOfElement(element) {
			var i = 0;
			var l = instances.length;
			for (; i < l; i++) {
				if (instances[i].isAttachedTo(element)) {
					return i;
				}
			}
			return -1;
		};

		function toLabel(v) {
			// if value set, use as label
			if (v) {
				return '<p>' + v + '</p>';
			}

			// else use default text
			return null;
		}

		function toFunctionReference(name) {
			var ref = window;
			var levels = name.split('.');
			levels.forEach(function (level, index) {
				if (!ref[levels[index]]) {
					return;
				}
				ref = ref[levels[index]];
			});
			return ref !== window ? ref : null;
		}

		var passThrough = function passThrough(v) {
			return v;
		};
		var defaultFalse = function defaultFalse(v) {
			return v === 'true';
		};
		var defaultTrue = function defaultTrue(v) {
			return v ? v === 'true' : true;
		};
		var defaultLabel = function defaultLabel(v) {
			return toLabel(v);
		};
		var defaultFunction = function defaultFunction(v) {
			return v ? toFunctionReference(v) : null;
		};
		var defaultSize = function defaultSize(v) {
			if (!v) {
				return null;
			}
			var parts = intSplit(v, ',');
			return {
				width: parts[0],
				height: parts[1]
			};
		};

		var toFloat = function toFloat(v) {
			if (!v) {
				return null;
			}
			return parseFloat(v);
		};

		var toInt = function toInt(v) {
			if (!v) {
				return null;
			}
			return parseInt(v, 10);
		};

		var toRect = function toRect(v) {
			if (!v) {
				return null;
			}
			var obj = {};
			v.split(',').map(function (p) {
				return parseInt(p, 10);
			}).forEach(function (v, i) {
				obj[Rect[i]] = v;
			});
			return obj;
		};

		var defaults = {

			// is user allowed to download the cropped image?
			'download': defaultFalse,

			// is user allowed to edit the cropped image?
			'edit': defaultTrue,

			// open editor immidiately on file drop
			'instantEdit': defaultFalse,

			// minimum crop size in pixels of original image
			'minSize': defaultSize,

			// the final bounding box of the output image
			'size': defaultSize,

			// the forced output size of the image
			'forceSize': defaultSize,

			// the internal data canvas size
			'internalCanvasSize': defaultSize,

			// url to post to
			'service': function service(v) {
				return typeof v === 'undefined' ? null : v;
			},

			// url to fetch service
			'fetcher': function fetcher(v) {
				return typeof v === 'undefined' ? null : v;
			},

			// set auto push mode
			'push': defaultFalse,

			// initial rotation
			'rotation': function rotation(v) {
				return typeof v === 'undefined' ? null : parseInt(v, 10);
			},

			// set crop rect
			'crop': toRect,

			// what to post
			'post': function post(v) {
				if (!v) {
					return null;
				}
				return v.split(',').map(function (item) {
					return item.trim();
				});
			},

			// default input name
			'defaultInputName': passThrough,

			// the ratio of the crop
			'ratio': function ratio(v) {
				if (!v) {
					return null;
				}
				return v;
			},

			// maximum file size
			'maxFileSize': toFloat,

			// sharpen filter
			'filterSharpen': toInt,

			// jpeg compression
			'jpegCompression': toInt,

			// base64 data uploading
			'uploadBase64': defaultFalse,

			// sets file type to force output to
			'forceType': passThrough,

			// drop to replace
			'dropReplace': defaultTrue,

			// bool determining if initial image should be saved
			'saveInitialImage': defaultFalse,

			// rotate button
			'rotateButton': defaultTrue,

			// default labels
			'label': defaultLabel,
			'labelLoading': defaultLabel

		};

		// labels
		['FileSize', 'FileType', 'NoSupport', 'ImageTooSmall'].forEach(function (status) {
			defaults['status' + status] = defaultLabel;
		});

		// status
		['ContentLength', 'UnknownResponse', 'UploadSuccess'].forEach(function (status) {
			defaults['status' + status] = passThrough;
		});

		// the did callbacks
		['Init', 'Load', 'Save', 'Upload', 'Remove', 'Transform', 'ReceiveServerError', 'Confirm', 'Cancel'].forEach(function (cb) {
			defaults['did' + cb] = defaultFunction;
		});

		// the will callbacks
		['Transform', 'Save', 'Remove', 'Request'].forEach(function (cb) {
			defaults['will' + cb] = defaultFunction;
		});

		// button defaults
		var buttonOptions = ['ClassName', 'Label', 'Title'];
		SlimButtons.concat(ImageEditor.Buttons).concat('rotate').forEach(function (btn) {
			var capitalized = capitalizeFirstLetter(btn);
			buttonOptions.forEach(function (opt) {
				defaults['button' + capitalized + opt] = passThrough;
			});
		});

		Slim.supported = function () {

			return !(

				// is opera mini
				Object.prototype.toString.call(window.operamini) === '[object OperaMini]' ||

				// no event listener support
				typeof window.addEventListener === 'undefined' ||

				// no file reader support
				typeof window.FileReader === 'undefined' ||

				// no .createObjectURL support, used by download method but also convenient to exclude Android 4.3 and lower
				// Android 4.3 and lower don't support XHR2 responseType blob
				typeof window.URL === 'undefined' || typeof window.URL.createObjectURL === 'undefined');
		}();

		Slim.parse = function (context) {
			var elements;
			var element;
			var i;
			var croppers = [];

			// find all crop elements and bind Crop behavior
			elements = context.querySelectorAll('.slim:not([data-state])');
			i = elements.length;

			while (i--) {
				element = elements[i];
				croppers.push(Slim.create(element, Slim.getOptionsFromAttributes(element)));
			}

			return croppers;
		};

		Slim.getOptionsFromAttributes = function (element) {

			var dataset = getDataset(element);

			var options = {
				meta: {}
			};

			for (var prop in dataset) {

				var valueTransformer = defaults[prop];
				var _value = dataset[prop];

				if (valueTransformer) {
					_value = valueTransformer(_value);
					_value = _value === null ? clone(Slim.options()[prop]) : _value;
					options[prop] = _value;
				} else if (prop.indexOf('meta') === 0) {
					options['meta'][lowercaseFirstLetter(prop.substr(4))] = _value;
				}
			}

			return options;
		};

		Slim.find = function (element) {
			var result = instances.filter(function (instance) {
				return instance.isAttachedTo(element);
			});
			return result ? result[0] : null;
		};

		Slim.create = function (element, options) {

			// if already in array, can't create another slim
			if (Slim.find(element)) {
				return;
			}

			// if no options supplied, try to get the options from the element
			if (!options) {
				options = Slim.getOptionsFromAttributes(element);
			}

			// instance
			var slim = new Slim(element, options);

			// add new slim
			instances.push(slim);

			// return the slim instance
			return slim;
		};

		Slim.destroy = function (element) {
			var index = indexOfElement(element);

			if (index < 0) {
				return false;
			}

			instances[index].destroy();
			instances.splice(index, 1);

			return true;
		};
	})();
	return Slim;
}());
/*
 * Toastr
 * Copyright 2012-2015
 * Authors: John Papa, Hans Fjällemark, and Tim Ferrell.
 * All Rights Reserved.
 * Use, reproduction, distribution, and modification of this code is subject to the terms and
 * conditions of the MIT license, available at http://www.opensource.org/licenses/mit-license.php
 *
 * ARIA Support: Greta Krafsig
 *
 * Project: https://github.com/CodeSeven/toastr
 */
/* global define */
; (function (define) {
    define(['jquery'], function ($) {
        return (function () {
            var $container;
            var listener;
            var toastId = 0;
            var toastType = {
                error: 'error',
                info: 'info',
                success: 'success',
                warning: 'warning'
            };

            var toastr = {
                clear: clear,
                remove: remove,
                error: error,
                getContainer: getContainer,
                info: info,
                options: {},
                subscribe: subscribe,
                success: success,
                version: '2.1.1',
                warning: warning
            };

            var previousToast;

            return toastr;

            ////////////////

            function error(message, title, optionsOverride) {
                return notify({
                    type: toastType.error,
                    iconClass: getOptions().iconClasses.error,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function getContainer(options, create) {
                if (!options) { options = getOptions(); }
                $container = $('#' + options.containerId);
                if ($container.length) {
                    return $container;
                }
                if (create) {
                    $container = createContainer(options);
                }
                return $container;
            }

            function info(message, title, optionsOverride) {
                return notify({
                    type: toastType.info,
                    iconClass: getOptions().iconClasses.info,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function subscribe(callback) {
                listener = callback;
            }

            function success(message, title, optionsOverride) {
                return notify({
                    type: toastType.success,
                    iconClass: getOptions().iconClasses.success,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function warning(message, title, optionsOverride) {
                return notify({
                    type: toastType.warning,
                    iconClass: getOptions().iconClasses.warning,
                    message: message,
                    optionsOverride: optionsOverride,
                    title: title
                });
            }

            function clear($toastElement, clearOptions) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if (!clearToast($toastElement, options, clearOptions)) {
                    clearContainer(options);
                }
            }

            function remove($toastElement) {
                var options = getOptions();
                if (!$container) { getContainer(options); }
                if ($toastElement && $(':focus', $toastElement).length === 0) {
                    removeToast($toastElement);
                    return;
                }
                if ($container.children().length) {
                    $container.remove();
                }
            }

            // internal functions

            function clearContainer (options) {
                var toastsToClear = $container.children();
                for (var i = toastsToClear.length - 1; i >= 0; i--) {
                    clearToast($(toastsToClear[i]), options);
                }
            }

            function clearToast ($toastElement, options, clearOptions) {
                var force = clearOptions && clearOptions.force ? clearOptions.force : false;
                if ($toastElement && (force || $(':focus', $toastElement).length === 0)) {
                    $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () { removeToast($toastElement); }
                    });
                    return true;
                }
                return false;
            }

            function createContainer(options) {
                $container = $('<div/>')
                    .attr('id', options.containerId)
                    .addClass(options.positionClass)
                    .attr('aria-live', 'polite')
                    .attr('role', 'alert');

                $container.appendTo($(options.target));
                return $container;
            }

            function getDefaults() {
                return {
                    tapToDismiss: true,
                    toastClass: 'toast',
                    containerId: 'toast-container',
                    debug: false,

                    showMethod: 'fadeIn', //fadeIn, slideDown, and show are built into jQuery
                    showDuration: 300,
                    showEasing: 'swing', //swing and linear are built into jQuery
                    onShown: undefined,
                    hideMethod: 'fadeOut',
                    hideDuration: 1000,
                    hideEasing: 'swing',
                    onHidden: undefined,

                    extendedTimeOut: 1000,
                    iconClasses: {
                        error: 'toast-error',
                        info: 'toast-info',
                        success: 'toast-success',
                        warning: 'toast-warning'
                    },
                    iconClass: 'toast-info',
                    positionClass: 'toast-top-right',
                    timeOut: 5000, // Set timeOut and extendedTimeOut to 0 to make it sticky
                    titleClass: 'toast-title',
                    messageClass: 'toast-message',
                    target: $(document.documentElement),
                    closeHtml: '<button type="button">&times;</button>',
                    newestOnTop: true,
                    preventDuplicates: false,
                    progressBar: false
                };
            }

            function publish(args) {
                if (!listener) { return; }
                listener(args);
            }

            function notify(map) {
                var options = getOptions();
                var iconClass = map.iconClass || options.iconClass;

                if (typeof (map.optionsOverride) !== 'undefined') {
                    options = $.extend(options, map.optionsOverride);
                    iconClass = map.optionsOverride.iconClass || iconClass;
                }

                if (shouldExit(options, map)) { return; }

                toastId++;

                $container = getContainer(options, true);

                var intervalId = null;
                var $toastElement = $('<div/>');
                var $titleElement = $('<div/>');
                var $messageElement = $('<div/>');
                var $progressElement = $('<div/>');
                var $closeElement = $(options.closeHtml);
                var progressBar = {
                    intervalId: null,
                    hideEta: null,
                    maxHideTime: null
                };
                var response = {
                    toastId: toastId,
                    state: 'visible',
                    startTime: new Date(),
                    options: options,
                    map: map
                };

                personalizeToast();

                displayToast();

                handleEvents();

                publish(response);

                if (options.debug && console) {
                    console.log(response);
                }

                return $toastElement;

                function personalizeToast() {
                    setIcon();
                    setTitle();
                    setMessage();
                    setCloseButton();
                    setProgressBar();
                    setSequence();
                }

                function handleEvents() {
                    $toastElement.hover(stickAround, delayedHideToast);
                    if (!options.onclick && options.tapToDismiss) {
                        $toastElement.click(hideToast);
                    }

                    if (options.closeButton && $closeElement) {
                        $closeElement.click(function (event) {
                            if (event.stopPropagation) {
                                event.stopPropagation();
                            } else if (event.cancelBubble !== undefined && event.cancelBubble !== true) {
                                event.cancelBubble = true;
                            }
                            hideToast(true);
                        });
                    }

                    if (options.onclick) {
                        $toastElement.click(function () {
                            options.onclick();
                            hideToast();
                        });
                    }
                }

                function displayToast() {
                    $toastElement.hide();

                    $toastElement[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing, complete: options.onShown}
                    );

                    if (options.timeOut > 0) {
                        intervalId = setTimeout(hideToast, options.timeOut);
                        progressBar.maxHideTime = parseFloat(options.timeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                        if (options.progressBar) {
                            progressBar.intervalId = setInterval(updateProgress, 10);
                        }
                    }
                }

                function setIcon() {
                    if (map.iconClass) {
                        $toastElement.addClass(options.toastClass).addClass(iconClass);
                    }
                }

                function setSequence() {
                    if (options.newestOnTop) {
                        $container.prepend($toastElement);
                    } else {
                        $container.append($toastElement);
                    }
                }

                function setTitle() {
                    if (map.title) {
                        $titleElement.append(map.title).addClass(options.titleClass);
                        $toastElement.append($titleElement);
                    }
                }

                function setMessage() {
                    if (map.message) {
                        $messageElement.append(map.message).addClass(options.messageClass);
                        $toastElement.append($messageElement);
                    }
                }

                function setCloseButton() {
                    if (options.closeButton) {
                        $closeElement.addClass('toast-close-button').attr('role', 'button');
                        $toastElement.prepend($closeElement);
                    }
                }

                function setProgressBar() {
                    if (options.progressBar) {
                        $progressElement.addClass('toast-progress');
                        $toastElement.prepend($progressElement);
                    }
                }

                function shouldExit(options, map) {
                    if (options.preventDuplicates) {
                        if (map.message === previousToast) {
                            return true;
                        } else {
                            previousToast = map.message;
                        }
                    }
                    return false;
                }

                function hideToast(override) {
                    if ($(':focus', $toastElement).length && !override) {
                        return;
                    }
                    clearTimeout(progressBar.intervalId);
                    return $toastElement[options.hideMethod]({
                        duration: options.hideDuration,
                        easing: options.hideEasing,
                        complete: function () {
                            removeToast($toastElement);
                            if (options.onHidden && response.state !== 'hidden') {
                                options.onHidden();
                            }
                            response.state = 'hidden';
                            response.endTime = new Date();
                            publish(response);
                        }
                    });
                }

                function delayedHideToast() {
                    if (options.timeOut > 0 || options.extendedTimeOut > 0) {
                        intervalId = setTimeout(hideToast, options.extendedTimeOut);
                        progressBar.maxHideTime = parseFloat(options.extendedTimeOut);
                        progressBar.hideEta = new Date().getTime() + progressBar.maxHideTime;
                    }
                }

                function stickAround() {
                    clearTimeout(intervalId);
                    progressBar.hideEta = 0;
                    $toastElement.stop(true, true)[options.showMethod](
                        {duration: options.showDuration, easing: options.showEasing}
                    );
                }

                function updateProgress() {
                    var percentage = ((progressBar.hideEta - (new Date().getTime())) / progressBar.maxHideTime) * 100;
                    $progressElement.width(percentage + '%');
                }
            }

            function getOptions() {
                return $.extend({}, getDefaults(), toastr.options);
            }

            function removeToast($toastElement) {
                if (!$container) { $container = getContainer(); }
                if ($toastElement.is(':visible')) {
                    return;
                }
                $toastElement.remove();
                $toastElement = null;
                if ($container.children().length === 0) {
                    $container.remove();
                    previousToast = undefined;
                }
            }

        })();
    });
}(typeof define === 'function' && define.amd ? define : function (deps, factory) {
    if (typeof module !== 'undefined' && module.exports) { //Node
        module.exports = factory(require('jquery'));
    } else {
        window['toastr'] = factory(window['jQuery']);
    }
}));

/*
The MIT License (MIT)
Copyright © 2006-2007 Kevin C. Olbrich
Copyright © 2010-2016 LIM SAS (http://lim.eu) - Julien Sanchez

Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies
of the Software, and to permit persons to whom the Software is furnished to do
so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.Qty = factory());
}(this, (function () { 'use strict';

/**
 * Tests if a value is a Qty instance
 *
 * @param {*} value - Value to test
 *
 * @returns {boolean} true if value is a Qty instance, false otherwise
 */
function isQty(value) {
  return value instanceof Qty$1;
}

/**
 * Tests if a value is a string
 *
 * @param {*} value - Value to test
 *
 * @returns {boolean} true if value is a string, false otherwise
 */
function isString(value) {
  return typeof value === "string" || value instanceof String;
}

/*
 * Prefer stricter Number.isFinite if currently supported.
 * To be dropped when ES6 is finalized. Obsolete browsers will
 * have to use ES6 polyfills.
 */
var isFiniteImpl = Number.isFinite || window.isFinite;
/**
 * Tests if a value is a number
 *
 * @param {*} value - Value to test
 *
 * @returns {boolean} true if value is a number, false otherwise
 */
function isNumber(value) {
  // Number.isFinite allows not to consider NaN or '1' as numbers
  return isFiniteImpl(value);
}

/*
 * Identity function
 */
function identity(value) {
  return value;
}

/**
 * Returns unique strings from list
 *
 * @param {string[]} strings - array of strings
 *
 *
 * @returns {string[]} a new array of strings without duplicates
 */
function uniq(strings) {
  var seen = {};
  return strings.filter(function(item) {
    return seen.hasOwnProperty(item) ? false : (seen[item] = true);
  });
}

function compareArray(array1, array2) {
  if (array2.length !== array1.length) {
    return false;
  }
  for (var i = 0; i < array1.length; i++) {
    if (array2[i].compareArray) {
      if (!array2[i].compareArray(array1[i])) {
        return false;
      }
    }
    if (array2[i] !== array1[i]) {
      return false;
    }
  }
  return true;
}

function assign(target, properties) {
  Object.keys(properties).forEach(function(key) {
    target[key] = properties[key];
  });
}

/**
 * Safely multiplies numbers while avoiding floating errors
 * like 0.1 * 0.1 => 0.010000000000000002
 *
 * @returns {number} result
 * @param {...number} number
 */
function mulSafe() {
  var result = 1, decimals = 0;
  for (var i = 0; i < arguments.length; i++) {
    var arg = arguments[i];
    decimals = decimals + getFractional(arg);
    result *= arg;
  }

  return decimals !== 0 ? round(result, decimals) : result;
}

/**
 * Safely divides two numbers while avoiding floating errors
 * like 0.3 / 0.05 => 5.999999999999999
 *
 * @returns {number} result
 * @param {number} num Numerator
 * @param {number} den Denominator
 */
function divSafe(num, den) {
  if (den === 0) {
    throw new Error("Divide by zero");
  }

  var factor = Math.pow(10, getFractional(den));
  var invDen = factor / (factor * den);

  return mulSafe(num, invDen);
}

/**
 * Rounds value at the specified number of decimals
 *
 * @param {number} val - value to round
 * @param {number} decimals - number of decimals
 *
 * @returns {number} rounded number
 */
function round(val, decimals) {
  return Math.round(val * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

function getFractional(num) {
  // Check for NaNs or Infinities
  if (!isFinite(num)) {
    return 0;
  }

  // Faster than parsing strings
  // http://jsperf.com/count-decimals/2
  var count = 0;
  while (num % 1 !== 0) {
    num *= 10;
    count++;
  }
  return count;
}

/**
 * Custom error type definition
 * @constructor
 */
function QtyError() {
  var err;
  if (!this) { // Allows to instantiate QtyError without new()
    err = Object.create(QtyError.prototype);
    QtyError.apply(err, arguments);
    return err;
  }
  err = Error.apply(this, arguments);
  this.name = "QtyError";
  this.message = err.message;
  this.stack = err.stack;
}
QtyError.prototype = Object.create(Error.prototype, {constructor: { value: QtyError }});

/*
 * Throws incompatible units error
 * @param {string} left - units
 * @param {string} right - units incompatible with first argument
 * @throws "Incompatible units" error
 */
function throwIncompatibleUnits(left, right) {
  throw new QtyError("Incompatible units: " + left + " and " + right);
}

var UNITS = {
  /* prefixes */
  "<googol>" : [["googol"], 1e100, "prefix"],
  "<kibi>"  :  [["Ki","Kibi","kibi"], Math.pow(2,10), "prefix"],
  "<mebi>"  :  [["Mi","Mebi","mebi"], Math.pow(2,20), "prefix"],
  "<gibi>"  :  [["Gi","Gibi","gibi"], Math.pow(2,30), "prefix"],
  "<tebi>"  :  [["Ti","Tebi","tebi"], Math.pow(2,40), "prefix"],
  "<pebi>"  :  [["Pi","Pebi","pebi"], Math.pow(2,50), "prefix"],
  "<exi>"   :  [["Ei","Exi","exi"], Math.pow(2,60), "prefix"],
  "<zebi>"  :  [["Zi","Zebi","zebi"], Math.pow(2,70), "prefix"],
  "<yebi>"  :  [["Yi","Yebi","yebi"], Math.pow(2,80), "prefix"],
  "<yotta>" :  [["Y","Yotta","yotta"], 1e24, "prefix"],
  "<zetta>" :  [["Z","Zetta","zetta"], 1e21, "prefix"],
  "<exa>"   :  [["E","Exa","exa"], 1e18, "prefix"],
  "<peta>"  :  [["P","Peta","peta"], 1e15, "prefix"],
  "<tera>"  :  [["T","Tera","tera"], 1e12, "prefix"],
  "<giga>"  :  [["G","Giga","giga"], 1e9, "prefix"],
  "<mega>"  :  [["M","Mega","mega"], 1e6, "prefix"],
  "<kilo>"  :  [["k","kilo"], 1e3, "prefix"],
  "<hecto>" :  [["h","Hecto","hecto"], 1e2, "prefix"],
  "<deca>"  :  [["da","Deca","deca","deka"], 1e1, "prefix"],
  "<deci>"  :  [["d","Deci","deci"], 1e-1, "prefix"],
  "<centi>"  : [["c","Centi","centi"], 1e-2, "prefix"],
  "<milli>" :  [["m","Milli","milli"], 1e-3, "prefix"],
  "<micro>"  : [
    ["u","\u03BC"/*µ as greek letter*/,"\u00B5"/*µ as micro sign*/,"Micro","mc","micro"],
    1e-6,
    "prefix"
  ],
  "<nano>"  :  [["n","Nano","nano"], 1e-9, "prefix"],
  "<pico>"  :  [["p","Pico","pico"], 1e-12, "prefix"],
  "<femto>" :  [["f","Femto","femto"], 1e-15, "prefix"],
  "<atto>"  :  [["a","Atto","atto"], 1e-18, "prefix"],
  "<zepto>" :  [["z","Zepto","zepto"], 1e-21, "prefix"],
  "<yocto>" :  [["y","Yocto","yocto"], 1e-24, "prefix"],

  "<1>"     :  [["1", "<1>"], 1, ""],
  /* length units */
  "<meter>" :  [["m","meter","meters","metre","metres"], 1.0, "length", ["<meter>"] ],
  "<inch>"  :  [["in","inch","inches","\""], 0.0254, "length", ["<meter>"]],
  "<foot>"  :  [["ft","foot","feet","'"], 0.3048, "length", ["<meter>"]],
  "<yard>"  :  [["yd","yard","yards"], 0.9144, "length", ["<meter>"]],
  "<mile>"  :  [["mi","mile","miles"], 1609.344, "length", ["<meter>"]],
  "<naut-mile>" : [["nmi"], 1852, "length", ["<meter>"]],
  "<league>":  [["league","leagues"], 4828, "length", ["<meter>"]],
  "<furlong>": [["furlong","furlongs"], 201.2, "length", ["<meter>"]],
  "<rod>"   :  [["rd","rod","rods"], 5.029, "length", ["<meter>"]],
  "<mil>"   :  [["mil","mils"], 0.0000254, "length", ["<meter>"]],
  "<angstrom>"  :[["ang","angstrom","angstroms"], 1e-10, "length", ["<meter>"]],
  "<fathom>" : [["fathom","fathoms"], 1.829, "length", ["<meter>"]],
  "<pica>"  : [["pica","picas"], 0.00423333333, "length", ["<meter>"]],
  "<point>" : [["pt","point","points"], 0.000352777778, "length", ["<meter>"]],
  "<redshift>" : [["z","red-shift", "redshift"], 1.302773e26, "length", ["<meter>"]],
  "<AU>"    : [["AU","astronomical-unit"], 149597900000, "length", ["<meter>"]],
  "<light-second>":[["ls","light-second"], 299792500, "length", ["<meter>"]],
  "<light-minute>":[["lmin","light-minute"], 17987550000, "length", ["<meter>"]],
  "<light-year>" : [["ly","light-year"], 9460528000000000, "length", ["<meter>"]],
  "<parsec>"  : [["pc","parsec","parsecs"], 30856780000000000, "length", ["<meter>"]],
  "<datamile>"  :  [["DM"], 1828.8, "length", ["<meter>"]],

  /* mass */
  "<kilogram>" : [["kg","kilogram","kilograms"], 1.0, "mass", ["<kilogram>"]],
  "<AMU>" : [["u","AMU","amu"], 1.660538921e-27, "mass", ["<kilogram>"]],
  "<dalton>" : [["Da","Dalton","Daltons","dalton","daltons"], 1.660538921e-27, "mass", ["<kilogram>"]],
  "<slug>" : [["slug","slugs"], 14.5939029, "mass", ["<kilogram>"]],
  "<short-ton>" : [["tn","ton"], 907.18474, "mass", ["<kilogram>"]],
  "<metric-ton>":[["tonne"], 1000, "mass", ["<kilogram>"]],
  "<carat>" : [["ct","carat","carats"], 0.0002, "mass", ["<kilogram>"]],
  "<pound>" : [["lbs","lb","pound","pounds","#"], 0.45359237, "mass", ["<kilogram>"]],
  "<ounce>" : [["oz","ounce","ounces"], 0.0283495231, "mass", ["<kilogram>"]],
  "<gram>"    :  [["g","gram","grams","gramme","grammes"], 1e-3, "mass", ["<kilogram>"]],
  "<grain>" : [["grain","grains","gr"], 6.479891e-5, "mass", ["<kilogram>"]],
  "<dram>"  : [["dram","drams","dr"], 0.0017718452, "mass",["<kilogram>"]],
  "<stone>" : [["stone","stones","st"],6.35029318, "mass",["<kilogram>"]],

  /* area */
  "<hectare>":[["hectare"], 10000, "area", ["<meter>","<meter>"]],
  "<acre>":[["acre","acres"], 4046.85642, "area", ["<meter>","<meter>"]],
  "<sqft>":[["sqft"], 1, "area", ["<foot>","<foot>"]],

  /* volume */
  "<liter>" : [["l","L","liter","liters","litre","litres"], 0.001, "volume", ["<meter>","<meter>","<meter>"]],
  "<gallon>":  [["gal","gallon","gallons"], 0.0037854118, "volume", ["<meter>","<meter>","<meter>"]],
  "<quart>":  [["qt","quart","quarts"], 0.00094635295, "volume", ["<meter>","<meter>","<meter>"]],
  "<pint>":  [["pt","pint","pints"], 0.000473176475, "volume", ["<meter>","<meter>","<meter>"]],
  "<cup>":  [["cu","cup","cups"], 0.000236588238, "volume", ["<meter>","<meter>","<meter>"]],
  "<fluid-ounce>":  [["floz","fluid-ounce","fluid-ounces"], 2.95735297e-5, "volume", ["<meter>","<meter>","<meter>"]],
  "<tablespoon>":  [["tb","tbsp","tbs","tablespoon","tablespoons"], 1.47867648e-5, "volume", ["<meter>","<meter>","<meter>"]],
  "<teaspoon>":  [["tsp","teaspoon","teaspoons"], 4.92892161e-6, "volume", ["<meter>","<meter>","<meter>"]],
  "<bushel>":  [["bu","bsh","bushel","bushels"], 0.035239072, "volume", ["<meter>","<meter>","<meter>"]],

  /* speed */
  "<kph>" : [["kph"], 0.277777778, "speed", ["<meter>"], ["<second>"]],
  "<mph>" : [["mph"], 0.44704, "speed", ["<meter>"], ["<second>"]],
  "<knot>" : [["kt","kn","kts","knot","knots"], 0.514444444, "speed", ["<meter>"], ["<second>"]],
  "<fps>"  : [["fps"], 0.3048, "speed", ["<meter>"], ["<second>"]],

  /* acceleration */
  "<gee>" : [["gee"], 9.80665, "acceleration", ["<meter>"], ["<second>","<second>"]],

  /* temperature_difference */
  "<kelvin>" : [["degK","kelvin"], 1.0, "temperature", ["<kelvin>"]],
  "<celsius>" : [["degC","celsius","celsius","centigrade"], 1.0, "temperature", ["<kelvin>"]],
  "<fahrenheit>" : [["degF","fahrenheit"], 5 / 9, "temperature", ["<kelvin>"]],
  "<rankine>" : [["degR","rankine"], 5 / 9, "temperature", ["<kelvin>"]],
  "<temp-K>"  : [["tempK"], 1.0, "temperature", ["<temp-K>"]],
  "<temp-C>"  : [["tempC"], 1.0, "temperature", ["<temp-K>"]],
  "<temp-F>"  : [["tempF"], 5 / 9, "temperature", ["<temp-K>"]],
  "<temp-R>"  : [["tempR"], 5 / 9, "temperature", ["<temp-K>"]],

  /* time */
  "<second>":  [["s","sec","secs","second","seconds"], 1.0, "time", ["<second>"]],
  "<minute>":  [["min","mins","minute","minutes"], 60.0, "time", ["<second>"]],
  "<hour>":  [["h","hr","hrs","hour","hours"], 3600.0, "time", ["<second>"]],
  "<day>":  [["d","day","days"], 3600 * 24, "time", ["<second>"]],
  "<week>":  [["wk","week","weeks"], 7 * 3600 * 24, "time", ["<second>"]],
  "<fortnight>": [["fortnight","fortnights"], 1209600, "time", ["<second>"]],
  "<year>":  [["y","yr","year","years","annum"], 31556926, "time", ["<second>"]],
  "<decade>":[["decade","decades"], 315569260, "time", ["<second>"]],
  "<century>":[["century","centuries"], 3155692600, "time", ["<second>"]],

  /* pressure */
  "<pascal>" : [["Pa","pascal","Pascal"], 1.0, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<bar>" : [["bar","bars"], 100000, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<mmHg>" : [["mmHg"], 133.322368, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<inHg>" : [["inHg"], 3386.3881472, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<torr>" : [["torr"], 133.322368, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<atm>" : [["atm","ATM","atmosphere","atmospheres"], 101325, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<psi>" : [["psi"], 6894.76, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<cmh2o>" : [["cmH2O"], 98.0638, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],
  "<inh2o>" : [["inH2O"], 249.082052, "pressure", ["<kilogram>"],["<meter>","<second>","<second>"]],

  /* viscosity */
  "<poise>"  : [["P","poise"], 0.1, "viscosity", ["<kilogram>"],["<meter>","<second>"] ],
  "<stokes>" : [["St","stokes"], 1e-4, "viscosity", ["<meter>","<meter>"], ["<second>"]],

  /* substance */
  "<mole>"  :  [["mol","mole"], 1.0, "substance", ["<mole>"]],

  /* concentration */
  "<molar>" : [["M","molar"], 1000, "concentration", ["<mole>"], ["<meter>","<meter>","<meter>"]],
  "<wtpercent>"  : [["wt%","wtpercent"], 10, "concentration", ["<kilogram>"], ["<meter>","<meter>","<meter>"]],

  /* activity */
  "<katal>" :  [["kat","katal","Katal"], 1.0, "activity", ["<mole>"], ["<second>"]],
  "<unit>"  :  [["U","enzUnit"], 16.667e-16, "activity", ["<mole>"], ["<second>"]],

  /* capacitance */
  "<farad>" :  [["F","farad","Farad"], 1.0, "capacitance", ["<second>","<second>","<second>","<second>","<ampere>","<ampere>"], ["<meter>", "<meter>", "<kilogram>"]],

  /* charge */
  "<coulomb>" :  [["C","coulomb","Coulomb"], 1.0, "charge", ["<ampere>","<second>"]],
  "<Ah>" :  [["Ah"], 3600, "charge", ["<ampere>","<second>"]],

  /* current */
  "<ampere>"  :  [["A","Ampere","ampere","amp","amps"], 1.0, "current", ["<ampere>"]],

  /* conductance */
  "<siemens>" : [["S","Siemens","siemens"], 1.0, "conductance", ["<second>","<second>","<second>","<ampere>","<ampere>"], ["<kilogram>","<meter>","<meter>"]],

  /* inductance */
  "<henry>" :  [["H","Henry","henry"], 1.0, "inductance", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>","<ampere>","<ampere>"]],

  /* potential */
  "<volt>"  :  [["V","Volt","volt","volts"], 1.0, "potential", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>","<second>","<ampere>"]],

  /* resistance */
  "<ohm>" :  [
    ["Ohm","ohm","\u03A9"/*Ω as greek letter*/,"\u2126"/*Ω as ohm sign*/],
    1.0,
    "resistance",
    ["<meter>","<meter>","<kilogram>"],["<second>","<second>","<second>","<ampere>","<ampere>"]
  ],
  /* magnetism */
  "<weber>" : [["Wb","weber","webers"], 1.0, "magnetism", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>","<ampere>"]],
  "<tesla>"  : [["T","tesla","teslas"], 1.0, "magnetism", ["<kilogram>"], ["<second>","<second>","<ampere>"]],
  "<gauss>" : [["G","gauss"], 1e-4, "magnetism",  ["<kilogram>"], ["<second>","<second>","<ampere>"]],
  "<maxwell>" : [["Mx","maxwell","maxwells"], 1e-8, "magnetism", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>","<ampere>"]],
  "<oersted>"  : [["Oe","oersted","oersteds"], 250.0 / Math.PI, "magnetism", ["<ampere>"], ["<meter>"]],

  /* energy */
  "<joule>" :  [["J","joule","Joule","joules"], 1.0, "energy", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<erg>"   :  [["erg","ergs"], 1e-7, "energy", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<btu>"   :  [["BTU","btu","BTUs"], 1055.056, "energy", ["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<calorie>" :  [["cal","calorie","calories"], 4.18400, "energy",["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<Calorie>" :  [["Cal","Calorie","Calories"], 4184.00, "energy",["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<therm-US>" : [["th","therm","therms","Therm"], 105480400, "energy",["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],
  "<Wh>" : [["Wh"], 3600, "energy",["<meter>","<meter>","<kilogram>"], ["<second>","<second>"]],

  /* force */
  "<newton>"  : [["N","Newton","newton"], 1.0, "force", ["<kilogram>","<meter>"], ["<second>","<second>"]],
  "<dyne>"  : [["dyn","dyne"], 1e-5, "force", ["<kilogram>","<meter>"], ["<second>","<second>"]],
  "<pound-force>"  : [["lbf","pound-force"], 4.448222, "force", ["<kilogram>","<meter>"], ["<second>","<second>"]],

  /* frequency */
  "<hertz>" : [["Hz","hertz","Hertz"], 1.0, "frequency", ["<1>"], ["<second>"]],

  /* angle */
  "<radian>" :[["rad","radian","radians"], 1.0, "angle", ["<radian>"]],
  "<degree>" :[["deg","degree","degrees"], Math.PI / 180.0, "angle", ["<radian>"]],
  "<gradian>"   :[["gon","grad","gradian","grads"], Math.PI / 200.0, "angle", ["<radian>"]],
  "<steradian>"  : [["sr","steradian","steradians"], 1.0, "solid_angle", ["<steradian>"]],

  /* rotation */
  "<rotation>" : [["rotation"], 2.0 * Math.PI, "angle", ["<radian>"]],
  "<rpm>"   :[["rpm"], 2.0 * Math.PI / 60.0, "angular_velocity", ["<radian>"], ["<second>"]],

  /* information */
  "<byte>"  :[["B","byte","bytes"], 1.0, "information", ["<byte>"]],
  "<bit>"  :[["b","bit","bits"], 0.125, "information", ["<byte>"]],

  /* information rate */
  "<Bps>" : [["Bps"], 1.0, "information_rate", ["<byte>"], ["<second>"]],
  "<bps>" : [["bps"], 0.125, "information_rate", ["<byte>"], ["<second>"]],

  /* currency */
  "<dollar>":[["USD","dollar"], 1.0, "currency", ["<dollar>"]],
  "<cents>" :[["cents"], 0.01, "currency", ["<dollar>"]],

  /* luminosity */
  "<candela>" : [["cd","candela"], 1.0, "luminosity", ["<candela>"]],
  "<lumen>" : [["lm","lumen"], 1.0, "luminous_power", ["<candela>","<steradian>"]],
  "<lux>" :[["lux"], 1.0, "illuminance", ["<candela>","<steradian>"], ["<meter>","<meter>"]],

  /* power */
  "<watt>"  : [["W","watt","watts"], 1.0, "power", ["<kilogram>","<meter>","<meter>"], ["<second>","<second>","<second>"]],
  "<volt-ampere>"  : [["VA"], 1.0, "power", ["<kilogram>","<meter>","<meter>"], ["<second>","<second>","<second>"]],
  "<volt-ampere-reactive>"  : [["var","Var","VAr","VAR"], 1.0, "power", ["<kilogram>","<meter>","<meter>"], ["<second>","<second>","<second>"]],
  "<horsepower>"  :  [["hp","horsepower"], 745.699872, "power", ["<kilogram>","<meter>","<meter>"], ["<second>","<second>","<second>"]],

  /* radiation */
  "<gray>" : [["Gy","gray","grays"], 1.0, "radiation", ["<meter>","<meter>"], ["<second>","<second>"]],
  "<roentgen>" : [["R","roentgen"], 0.009330, "radiation", ["<meter>","<meter>"], ["<second>","<second>"]],
  "<sievert>" : [["Sv","sievert","sieverts"], 1.0, "radiation", ["<meter>","<meter>"], ["<second>","<second>"]],
  "<becquerel>" : [["Bq","bequerel","bequerels"], 1.0, "radiation", ["<1>"],["<second>"]],
  "<curie>" : [["Ci","curie","curies"], 3.7e10, "radiation", ["<1>"],["<second>"]],

  /* rate */
  "<cpm>" : [["cpm"], 1.0 / 60.0, "rate", ["<count>"],["<second>"]],
  "<dpm>" : [["dpm"], 1.0 / 60.0, "rate", ["<count>"],["<second>"]],
  "<bpm>" : [["bpm"], 1.0 / 60.0, "rate", ["<count>"],["<second>"]],

  /* resolution / typography */
  "<dot>" : [["dot","dots"], 1, "resolution", ["<each>"]],
  "<pixel>" : [["pixel","px"], 1, "resolution", ["<each>"]],
  "<ppi>" : [["ppi"], 1, "resolution", ["<pixel>"], ["<inch>"]],
  "<dpi>" : [["dpi"], 1, "typography", ["<dot>"], ["<inch>"]],

  /* other */
  "<cell>" : [["cells","cell"], 1, "counting", ["<each>"]],
  "<each>" : [["each"], 1.0, "counting", ["<each>"]],
  "<count>" : [["count"], 1.0, "counting", ["<each>"]],
  "<base-pair>"  : [["bp"], 1.0, "counting", ["<each>"]],
  "<nucleotide>" : [["nt"], 1.0, "counting", ["<each>"]],
  "<molecule>" : [["molecule","molecules"], 1.0, "counting", ["<1>"]],
  "<dozen>" :  [["doz","dz","dozen"],12.0,"prefix_only", ["<each>"]],
  "<percent>": [["%","percent"], 0.01, "prefix_only", ["<1>"]],
  "<ppm>" :  [["ppm"],1e-6, "prefix_only", ["<1>"]],
  "<ppt>" :  [["ppt"],1e-9, "prefix_only", ["<1>"]],
  "<gross>" :  [["gr","gross"],144.0, "prefix_only", ["<dozen>","<dozen>"]],
  "<decibel>"  : [["dB","decibel","decibels"], 1.0, "logarithmic", ["<decibel>"]]
};

var BASE_UNITS = ["<meter>","<kilogram>","<second>","<mole>", "<ampere>","<radian>","<kelvin>","<temp-K>","<byte>","<dollar>","<candela>","<each>","<steradian>","<decibel>"];

var UNITY = "<1>";
var UNITY_ARRAY = [UNITY];

// Setup

/**
 * Asserts unit definition is valid
 *
 * @param {string} unitDef - Name of unit to test
 * @param {Object} definition - Definition of unit to test
 *
 * @throws {QtyError} if unit definition is not valid
 */
function validateUnitDefinition(unitDef, definition) {
  var scalar = definition[1];
  var numerator = definition[3] || [];
  var denominator = definition[4] || [];
  if (!isNumber(scalar)) {
    throw new QtyError(unitDef + ": Invalid unit definition. " +
                       "'scalar' must be a number");
  }

  numerator.forEach(function(unit) {
    if (UNITS[unit] === undefined) {
      throw new QtyError(unitDef + ": Invalid unit definition. " +
                         "Unit " + unit + " in 'numerator' is not recognized");
    }
  });

  denominator.forEach(function(unit) {
    if (UNITS[unit] === undefined) {
      throw new QtyError(unitDef + ": Invalid unit definition. " +
                         "Unit " + unit + " in 'denominator' is not recognized");
    }
  });
}

var PREFIX_VALUES = {};
var PREFIX_MAP = {};
var UNIT_VALUES = {};
var UNIT_MAP = {};
var OUTPUT_MAP = {};
for (var unitDef in UNITS) {
  if (UNITS.hasOwnProperty(unitDef)) {
    var definition = UNITS[unitDef];
    if (definition[2] === "prefix") {
      PREFIX_VALUES[unitDef] = definition[1];
      for (var i = 0; i < definition[0].length; i++) {
        PREFIX_MAP[definition[0][i]] = unitDef;
      }
    }
    else {
      validateUnitDefinition(unitDef, definition);
      UNIT_VALUES[unitDef] = {
        scalar: definition[1],
        numerator: definition[3],
        denominator: definition[4]
      };
      for (var j = 0; j < definition[0].length; j++) {
        UNIT_MAP[definition[0][j]] = unitDef;
      }
    }
    OUTPUT_MAP[unitDef] = definition[0][0];
  }
}

/**
 * Returns a list of available units of kind
 *
 * @param {string} [kind]
 * @returns {array} names of units
 * @throws {QtyError} if kind is unknown
 */
function getUnits (kind) {
  var i;
  var units = [];
  var unitKeys = Object.keys(UNITS);
  if (typeof kind === "undefined") {
    for (i = 0; i < unitKeys.length; i++) {
      if (["", "prefix"].indexOf(UNITS[unitKeys[i]][2]) === -1) {
        units.push(unitKeys[i].substr(1, unitKeys[i].length - 2));
      }
    }
  }
  else if (Qty$1.getKinds().indexOf(kind) === -1) {
    throw new QtyError("Kind not recognized");
  }
  else {
    for (i = 0; i < unitKeys.length; i++) {
      if (UNITS[unitKeys[i]][2] === kind) {
        units.push(unitKeys[i].substr(1, unitKeys[i].length - 2));
      }
    }
  }

  return units.sort(function(a, b) {
    if (a.toLowerCase() < b.toLowerCase()) {
      return -1;
    }
    if (a.toLowerCase() > b.toLowerCase()) {
      return 1;
    }
    return 0;
  });
}

/**
 * Returns a list of alternative names for a unit
 *
 * @param {string} unitName
 * @returns {string[]} aliases for unit
 * @throws {QtyError} if unit is unknown
 */
function getAliases(unitName) {
  if (!UNIT_MAP[unitName]) {
    throw new QtyError("Unit not recognized");
  }
  return UNITS[UNIT_MAP[unitName]][0];
}

var SIGNATURE_VECTOR = ["length", "time", "temperature", "mass", "current", "substance", "luminosity", "currency", "information", "angle"];

/*
calculates the unit signature id for use in comparing compatible units and simplification
the signature is based on a simple classification of units and is based on the following publication

Novak, G.S., Jr. "Conversion of units of measurement", IEEE Transactions on Software Engineering,
21(8), Aug 1995, pp.651-661
doi://10.1109/32.403789
http://ieeexplore.ieee.org/Xplore/login.jsp?url=/iel1/32/9079/00403789.pdf?isnumber=9079&prod=JNL&arnumber=403789&arSt=651&ared=661&arAuthor=Novak%2C+G.S.%2C+Jr.
*/
function unitSignature() {
  if (this.signature) {
    return this.signature;
  }
  var vector = unitSignatureVector.call(this);
  for (var i = 0; i < vector.length; i++) {
    vector[i] *= Math.pow(20, i);
  }

  return vector.reduce(
    function(previous, current) {
      return previous + current;
    },
    0
  );
}

// calculates the unit signature vector used by unit_signature
function unitSignatureVector() {
  if (!this.isBase()) {
    return unitSignatureVector.call(this.toBase());
  }

  var vector = new Array(SIGNATURE_VECTOR.length);
  for (var i = 0; i < vector.length; i++) {
    vector[i] = 0;
  }
  var r, n;
  for (var j = 0; j < this.numerator.length; j++) {
    if ((r = UNITS[this.numerator[j]])) {
      n = SIGNATURE_VECTOR.indexOf(r[2]);
      if (n >= 0) {
        vector[n] = vector[n] + 1;
      }
    }
  }

  for (var k = 0; k < this.denominator.length; k++) {
    if ((r = UNITS[this.denominator[k]])) {
      n = SIGNATURE_VECTOR.indexOf(r[2]);
      if (n >= 0) {
        vector[n] = vector[n] - 1;
      }
    }
  }
  return vector;
}

var SIGN = "[+-]";
var INTEGER = "\\d+";
var SIGNED_INTEGER = SIGN + "?" + INTEGER;
var FRACTION = "\\." + INTEGER;
var FLOAT = "(?:" + INTEGER + "(?:" + FRACTION + ")?" + ")" +
            "|" +
            "(?:" + FRACTION + ")";
var EXPONENT = "[Ee]" + SIGNED_INTEGER;
var SCI_NUMBER = "(?:" + FLOAT + ")(?:" + EXPONENT + ")?";
var SIGNED_NUMBER = SIGN + "?\\s*" + SCI_NUMBER;
var QTY_STRING = "(" + SIGNED_NUMBER + ")?" + "\\s*([^/]*)(?:\/(.+))?";
var QTY_STRING_REGEX = new RegExp("^" + QTY_STRING + "$");

var POWER_OP = "\\^|\\*{2}";
// Allow unit powers representing scalar, length, area, volume; 4 is for some
// special case representations in SI base units.
var SAFE_POWER = "[01234]";
var TOP_REGEX = new RegExp ("([^ \\*\\d]+?)(?:" + POWER_OP + ")?(-?" + SAFE_POWER + "(?![a-zA-Z]))");
var BOTTOM_REGEX = new RegExp("([^ \\*\\d]+?)(?:" + POWER_OP + ")?(" + SAFE_POWER + "(?![a-zA-Z]))");

/* parse a string into a unit object.
 * Typical formats like :
 * "5.6 kg*m/s^2"
 * "5.6 kg*m*s^-2"
 * "5.6 kilogram*meter*second^-2"
 * "2.2 kPa"
 * "37 degC"
 * "1"  -- creates a unitless constant with value 1
 * "GPa"  -- creates a unit with scalar 1 with units 'GPa'
 * 6'4"  -- recognized as 6 feet + 4 inches
 * 8 lbs 8 oz -- recognized as 8 lbs + 8 ounces
 */
function parse(val) {
  if (!isString(val)) {
    val = val.toString();
  }
  val = val.trim();

  var result = QTY_STRING_REGEX.exec(val);
  if (!result) {
    throw new QtyError(val + ": Quantity not recognized");
  }

  var scalarMatch = result[1];
  if (scalarMatch) {
    // Allow whitespaces between sign and scalar for loose parsing
    scalarMatch = scalarMatch.replace(/\s/g, "");
    this.scalar = parseFloat(scalarMatch);
  }
  else {
    this.scalar = 1;
  }
  var top = result[2];
  var bottom = result[3];

  var n, x, nx;
  // TODO DRY me
  while ((result = TOP_REGEX.exec(top))) {
    n = parseFloat(result[2]);
    if (isNaN(n)) {
      // Prevents infinite loops
      throw new QtyError("Unit exponent is not a number");
    }
    // Disallow unrecognized unit even if exponent is 0
    if (n === 0 && !UNIT_TEST_REGEX.test(result[1])) {
      throw new QtyError("Unit not recognized");
    }
    x = result[1] + " ";
    nx = "";
    for (var i = 0; i < Math.abs(n) ; i++) {
      nx += x;
    }
    if (n >= 0) {
      top = top.replace(result[0], nx);
    }
    else {
      bottom = bottom ? bottom + nx : nx;
      top = top.replace(result[0], "");
    }
  }

  while ((result = BOTTOM_REGEX.exec(bottom))) {
    n = parseFloat(result[2]);
    if (isNaN(n)) {
      // Prevents infinite loops
      throw new QtyError("Unit exponent is not a number");
    }
    // Disallow unrecognized unit even if exponent is 0
    if (n === 0 && !UNIT_TEST_REGEX.test(result[1])) {
      throw new QtyError("Unit not recognized");
    }
    x = result[1] + " ";
    nx = "";
    for (var j = 0; j < n ; j++) {
      nx += x;
    }

    bottom = bottom.replace(result[0], nx);
  }

  if (top) {
    this.numerator = parseUnits(top.trim());
  }
  if (bottom) {
    this.denominator = parseUnits(bottom.trim());
  }
}

var PREFIX_REGEX = Object.keys(PREFIX_MAP).sort(function(a, b) {
  return b.length - a.length;
}).join("|");
var UNIT_REGEX = Object.keys(UNIT_MAP).sort(function(a, b) {
  return b.length - a.length;
}).join("|");
/*
 * Minimal boundary regex to support units with Unicode characters
 * \b only works for ASCII
 */
var BOUNDARY_REGEX = "\\b|$";
var UNIT_MATCH = "(" + PREFIX_REGEX + ")??(" +
                 UNIT_REGEX +
                 ")(?:" + BOUNDARY_REGEX + ")";
var UNIT_TEST_REGEX = new RegExp("^\\s*(" + UNIT_MATCH + "[\\s\\*]*)+$");
var UNIT_MATCH_REGEX = new RegExp(UNIT_MATCH, "g"); // g flag for multiple occurences
var parsedUnitsCache = {};
/**
 * Parses and converts units string to normalized unit array.
 * Result is cached to speed up next calls.
 *
 * @param {string} units Units string
 * @returns {string[]} Array of normalized units
 *
 * @example
 * // Returns ["<second>", "<meter>", "<second>"]
 * parseUnits("s m s");
 *
 */
function parseUnits(units) {
  var cached = parsedUnitsCache[units];
  if (cached) {
    return cached;
  }

  var unitMatch, normalizedUnits = [];

  // Scan
  if (!UNIT_TEST_REGEX.test(units)) {
    throw new QtyError("Unit not recognized");
  }

  while ((unitMatch = UNIT_MATCH_REGEX.exec(units))) {
    normalizedUnits.push(unitMatch.slice(1));
  }

  normalizedUnits = normalizedUnits.map(function(item) {
    return PREFIX_MAP[item[0]] ? [PREFIX_MAP[item[0]], UNIT_MAP[item[1]]] : [UNIT_MAP[item[1]]];
  });

  // Flatten and remove null elements
  normalizedUnits = normalizedUnits.reduce(function(a,b) {
    return a.concat(b);
  }, []);
  normalizedUnits = normalizedUnits.filter(function(item) {
    return item;
  });

  parsedUnitsCache[units] = normalizedUnits;

  return normalizedUnits;
}

/**
 * Parses a string as a quantity
 * @param {string} value - quantity as text
 * @throws if value is not a string
 * @returns {Qty|null} Parsed quantity or null if unrecognized
 */
function globalParse(value) {
  if (!isString(value)) {
    throw new QtyError("Argument should be a string");
  }

  try {
    return Qty$1(value);
  }
  catch (e) {
    return null;
  }
}

function Qty$1(initValue, initUnits) {
  assertValidConstructorArgs.apply(null, arguments);

  if (!(isQty(this))) {
    return new Qty$1(initValue, initUnits);
  }

  this.scalar = null;
  this.baseScalar = null;
  this.signature = null;
  this._conversionCache = {};
  this.numerator = UNITY_ARRAY;
  this.denominator = UNITY_ARRAY;

  if (isDefinitionObject(initValue)) {
    this.scalar = initValue.scalar;
    this.numerator = (initValue.numerator && initValue.numerator.length !== 0) ? initValue.numerator : UNITY_ARRAY;
    this.denominator = (initValue.denominator && initValue.denominator.length !== 0) ? initValue.denominator : UNITY_ARRAY;
  }
  else if (initUnits) {
    parse.call(this, initUnits);
    this.scalar = initValue;
  }
  else {
    parse.call(this, initValue);
  }

  // math with temperatures is very limited
  if (this.denominator.join("*").indexOf("temp") >= 0) {
    throw new QtyError("Cannot divide with temperatures");
  }
  if (this.numerator.join("*").indexOf("temp") >= 0) {
    if (this.numerator.length > 1) {
      throw new QtyError("Cannot multiply by temperatures");
    }
    if (!compareArray(this.denominator, UNITY_ARRAY)) {
      throw new QtyError("Cannot divide with temperatures");
    }
  }

  this.initValue = initValue;
  updateBaseScalar.call(this);

  if (this.isTemperature() && this.baseScalar < 0) {
    throw new QtyError("Temperatures must not be less than absolute zero");
  }
}

Qty$1.prototype = {
  // Properly set up constructor
  constructor: Qty$1,
};

/**
 * Asserts constructor arguments are valid
 *
 * @param {*} value - Value to test
 * @param {string} [units] - Optional units when value is passed as a number
 *
 * @throws {QtyError} if constructor arguments are invalid
 */
function assertValidConstructorArgs(value, units) {
  if (units) {
    if (!(isNumber(value) && isString(units))) {
      throw new QtyError("Only number accepted as initialization value " +
                         "when units are explicitly provided");
    }
  }
  else {
    if (!(isString(value) ||
          isNumber(value) ||
          isQty(value)    ||
          isDefinitionObject(value))) {
      throw new QtyError("Only string, number or quantity accepted as " +
                         "single initialization value");
    }
  }
}

/**
 * Tests if a value is a Qty definition object
 *
 * @param {*} value - Value to test
 *
 * @returns {boolean} true if value is a definition object, false otherwise
 */
function isDefinitionObject(value) {
  return value && typeof value === "object" && value.hasOwnProperty("scalar");
}

function updateBaseScalar() {
  if (this.baseScalar) {
    return this.baseScalar;
  }
  if (this.isBase()) {
    this.baseScalar = this.scalar;
    this.signature = unitSignature.call(this);
  }
  else {
    var base = this.toBase();
    this.baseScalar = base.scalar;
    this.signature = base.signature;
  }
}

var KINDS = {
  "-312078": "elastance",
  "-312058": "resistance",
  "-312038": "inductance",
  "-152058": "potential",
  "-152040": "magnetism",
  "-152038": "magnetism",
  "-7997": "specific_volume",
  "-79": "snap",
  "-59": "jolt",
  "-39": "acceleration",
  "-38": "radiation",
  "-20": "frequency",
  "-19": "speed",
  "-18": "viscosity",
  "-17": "volumetric_flow",
  "-1": "wavenumber",
  "0": "unitless",
  "1": "length",
  "2": "area",
  "3": "volume",
  "20": "time",
  "400": "temperature",
  "7941": "yank",
  "7942": "power",
  "7959": "pressure",
  "7961": "force",
  "7962": "energy",
  "7979": "viscosity",
  "7981": "momentum",
  "7982": "angular_momentum",
  "7997": "density",
  "7998": "area_density",
  "8000": "mass",
  "152020": "radiation_exposure",
  "159999": "magnetism",
  "160000": "current",
  "160020": "charge",
  "312058": "conductance",
  "312078": "capacitance",
  "3199980": "activity",
  "3199997": "molar_concentration",
  "3200000": "substance",
  "63999998": "illuminance",
  "64000000": "luminous_power",
  "1280000000": "currency",
  "25599999980": "information_rate",
  "25600000000": "information",
  "511999999980": "angular_velocity",
  "512000000000": "angle"
};

/**
 * Returns the list of available well-known kinds of units, e.g.
 * "radiation" or "length".
 *
 * @returns {string[]} names of kinds of units
 */
function getKinds() {
  return uniq(Object.keys(KINDS).map(function(knownSignature) {
    return KINDS[knownSignature];
  }));
}

Qty$1.prototype.kind = function() {
  return KINDS[this.signature.toString()];
};

assign(Qty$1.prototype, {
  isDegrees: function() {
    // signature may not have been calculated yet
    return (this.signature === null || this.signature === 400) &&
      this.numerator.length === 1 &&
      compareArray(this.denominator, UNITY_ARRAY) &&
      (this.numerator[0].match(/<temp-[CFRK]>/) || this.numerator[0].match(/<(kelvin|celsius|rankine|fahrenheit)>/));
  },

  isTemperature: function() {
    return this.isDegrees() && this.numerator[0].match(/<temp-[CFRK]>/);
  }
});

function subtractTemperatures(lhs,rhs) {
  var lhsUnits = lhs.units();
  var rhsConverted = rhs.to(lhsUnits);
  var dstDegrees = Qty$1(getDegreeUnits(lhsUnits));
  return Qty$1({"scalar": lhs.scalar - rhsConverted.scalar, "numerator": dstDegrees.numerator, "denominator": dstDegrees.denominator});
}

function subtractTempDegrees(temp,deg) {
  var tempDegrees = deg.to(getDegreeUnits(temp.units()));
  return Qty$1({"scalar": temp.scalar - tempDegrees.scalar, "numerator": temp.numerator, "denominator": temp.denominator});
}

function addTempDegrees(temp,deg) {
  var tempDegrees = deg.to(getDegreeUnits(temp.units()));
  return Qty$1({"scalar": temp.scalar + tempDegrees.scalar, "numerator": temp.numerator, "denominator": temp.denominator});
}

function getDegreeUnits(units) {
  if (units === "tempK") {
    return "degK";
  }
  else if (units === "tempC") {
    return "degC";
  }
  else if (units === "tempF") {
    return "degF";
  }
  else if (units === "tempR") {
    return "degR";
  }
  else {
    throw new QtyError("Unknown type for temp conversion from: " + units);
  }
}

function toDegrees(src,dst) {
  var srcDegK = toDegK(src);
  var dstUnits = dst.units();
  var dstScalar;

  if (dstUnits === "degK") {
    dstScalar = srcDegK.scalar;
  }
  else if (dstUnits === "degC") {
    dstScalar = srcDegK.scalar ;
  }
  else if (dstUnits === "degF") {
    dstScalar = srcDegK.scalar * 9 / 5;
  }
  else if (dstUnits === "degR") {
    dstScalar = srcDegK.scalar * 9 / 5;
  }
  else {
    throw new QtyError("Unknown type for degree conversion to: " + dstUnits);
  }

  return Qty$1({"scalar": dstScalar, "numerator": dst.numerator, "denominator": dst.denominator});
}

function toDegK(qty) {
  var units = qty.units();
  var q;
  if (units.match(/(deg)[CFRK]/)) {
    q = qty.baseScalar;
  }
  else if (units === "tempK") {
    q = qty.scalar;
  }
  else if (units === "tempC") {
    q = qty.scalar;
  }
  else if (units === "tempF") {
    q = qty.scalar * 5 / 9;
  }
  else if (units === "tempR") {
    q = qty.scalar * 5 / 9;
  }
  else {
    throw new QtyError("Unknown type for temp conversion from: " + units);
  }

  return Qty$1({"scalar": q, "numerator": ["<kelvin>"], "denominator": UNITY_ARRAY});
}

function toTemp(src,dst) {
  var dstUnits = dst.units();
  var dstScalar;

  if (dstUnits === "tempK") {
    dstScalar = src.baseScalar;
  }
  else if (dstUnits === "tempC") {
    dstScalar = src.baseScalar - 273.15;
  }
  else if (dstUnits === "tempF") {
    dstScalar = (src.baseScalar * 9 / 5) - 459.67;
  }
  else if (dstUnits === "tempR") {
    dstScalar = src.baseScalar * 9 / 5;
  }
  else {
    throw new QtyError("Unknown type for temp conversion to: " + dstUnits);
  }

  return Qty$1({"scalar": dstScalar, "numerator": dst.numerator, "denominator": dst.denominator});
}

function toTempK(qty) {
  var units = qty.units();
  var q;
  if (units.match(/(deg)[CFRK]/)) {
    q = qty.baseScalar;
  }
  else if (units === "tempK") {
    q = qty.scalar;
  }
  else if (units === "tempC") {
    q = qty.scalar + 273.15;
  }
  else if (units === "tempF") {
    q = (qty.scalar + 459.67) * 5 / 9;
  }
  else if (units === "tempR") {
    q = qty.scalar * 5 / 9;
  }
  else {
    throw new QtyError("Unknown type for temp conversion from: " + units);
  }

  return Qty$1({"scalar": q, "numerator": ["<temp-K>"], "denominator": UNITY_ARRAY});
}

assign(Qty$1.prototype, {
  /**
   * Converts to other compatible units.
   * Instance's converted quantities are cached for faster subsequent calls.
   *
   * @param {(string|Qty)} other - Target units as string or retrieved from
   *                               other Qty instance (scalar is ignored)
   *
   * @returns {Qty} New converted Qty instance with target units
   *
   * @throws {QtyError} if target units are incompatible
   *
   * @example
   * var weight = Qty("25 kg");
   * weight.to("lb"); // => Qty("55.11556554621939 lbs");
   * weight.to(Qty("3 g")); // => Qty("25000 g"); // scalar of passed Qty is ignored
   */
  to: function(other) {
    var cached, target;

    if (other === undefined || other === null) {
      return this;
    }

    if (!isString(other)) {
      return this.to(other.units());
    }

    cached = this._conversionCache[other];
    if (cached) {
      return cached;
    }

    // Instantiating target to normalize units
    target = Qty$1(other);
    if (target.units() === this.units()) {
      return this;
    }

    if (!this.isCompatible(target)) {
      if (this.isInverse(target)) {
        target = this.inverse().to(other);
      }
      else {
        throwIncompatibleUnits(this.units(), target.units());
      }
    }
    else {
      if (target.isTemperature()) {
        target = toTemp(this,target);
      }
      else if (target.isDegrees()) {
        target = toDegrees(this,target);
      }
      else {
        var q = divSafe(this.baseScalar, target.baseScalar);
        target = Qty$1({"scalar": q, "numerator": target.numerator, "denominator": target.denominator});
      }
    }

    this._conversionCache[other] = target;
    return target;
  },

  // convert to base SI units
  // results of the conversion are cached so subsequent calls to this will be fast
  toBase: function() {
    if (this.isBase()) {
      return this;
    }

    if (this.isTemperature()) {
      return toTempK(this);
    }

    var cached = baseUnitCache[this.units()];
    if (!cached) {
      cached = toBaseUnits(this.numerator,this.denominator);
      baseUnitCache[this.units()] = cached;
    }
    return cached.mul(this.scalar);
  },

  // Converts the unit back to a float if it is unitless.  Otherwise raises an exception
  toFloat: function() {
    if (this.isUnitless()) {
      return this.scalar;
    }
    throw new QtyError("Can't convert to Float unless unitless.  Use Unit#scalar");
  },

  /**
   * Returns the nearest multiple of quantity passed as
   * precision
   *
   * @param {(Qty|string|number)} precQuantity - Quantity, string formated
   *   quantity or number as expected precision
   *
   * @returns {Qty} Nearest multiple of precQuantity
   *
   * @example
   * Qty('5.5 ft').toPrec('2 ft'); // returns 6 ft
   * Qty('0.8 cu').toPrec('0.25 cu'); // returns 0.75 cu
   * Qty('6.3782 m').toPrec('cm'); // returns 6.38 m
   * Qty('1.146 MPa').toPrec('0.1 bar'); // returns 1.15 MPa
   *
   */
  toPrec: function(precQuantity) {
    if (isString(precQuantity)) {
      precQuantity = Qty$1(precQuantity);
    }
    if (isNumber(precQuantity)) {
      precQuantity = Qty$1(precQuantity + " " + this.units());
    }

    if (!this.isUnitless()) {
      precQuantity = precQuantity.to(this.units());
    }
    else if (!precQuantity.isUnitless()) {
      throwIncompatibleUnits(this.units(), precQuantity.units());
    }

    if (precQuantity.scalar === 0) {
      throw new QtyError("Divide by zero");
    }

    var precRoundedResult = mulSafe(Math.round(this.scalar / precQuantity.scalar),
                                       precQuantity.scalar);

    return Qty$1(precRoundedResult + this.units());
  }
});

/**
 * Configures and returns a fast function to convert
 * Number values from units to others.
 * Useful to efficiently convert large array of values
 * with same units into others with iterative methods.
 * Does not take care of rounding issues.
 *
 * @param {string} srcUnits Units of values to convert
 * @param {string} dstUnits Units to convert to
 *
 * @returns {Function} Converting function accepting Number value
 *   and returning converted value
 *
 * @throws "Incompatible units" if units are incompatible
 *
 * @example
 * // Converting large array of numbers with the same units
 * // into other units
 * var converter = Qty.swiftConverter("m/h", "ft/s");
 * var convertedSerie = largeSerie.map(converter);
 *
 */
function swiftConverter(srcUnits, dstUnits) {
  var srcQty = Qty$1(srcUnits);
  var dstQty = Qty$1(dstUnits);

  if (srcQty.eq(dstQty)) {
    return identity;
  }

  var convert;
  if (!srcQty.isTemperature()) {
    convert = function(value) {
      return value * srcQty.baseScalar / dstQty.baseScalar;
    };
  }
  else {
    convert = function(value) {
      // TODO Not optimized
      return srcQty.mul(value).to(dstQty).scalar;
    };
  }

  return function converter(value) {
    var i,
        length,
        result;
    if (!Array.isArray(value)) {
      return convert(value);
    }
    else {
      length = value.length;
      result = [];
      for (i = 0; i < length; i++) {
        result.push(convert(value[i]));
      }
      return result;
    }
  };
}

var baseUnitCache = {};

function toBaseUnits (numerator,denominator) {
  var num = [];
  var den = [];
  var q = 1;
  var unit;
  for (var i = 0; i < numerator.length; i++) {
    unit = numerator[i];
    if (PREFIX_VALUES[unit]) {
      // workaround to fix
      // 0.1 * 0.1 => 0.010000000000000002
      q = mulSafe(q, PREFIX_VALUES[unit]);
    }
    else {
      if (UNIT_VALUES[unit]) {
        q *= UNIT_VALUES[unit].scalar;

        if (UNIT_VALUES[unit].numerator) {
          num.push(UNIT_VALUES[unit].numerator);
        }
        if (UNIT_VALUES[unit].denominator) {
          den.push(UNIT_VALUES[unit].denominator);
        }
      }
    }
  }
  for (var j = 0; j < denominator.length; j++) {
    unit = denominator[j];
    if (PREFIX_VALUES[unit]) {
      q /= PREFIX_VALUES[unit];
    }
    else {
      if (UNIT_VALUES[unit]) {
        q /= UNIT_VALUES[unit].scalar;

        if (UNIT_VALUES[unit].numerator) {
          den.push(UNIT_VALUES[unit].numerator);
        }
        if (UNIT_VALUES[unit].denominator) {
          num.push(UNIT_VALUES[unit].denominator);
        }
      }
    }
  }

  // Flatten
  num = num.reduce(function(a,b) {
    return a.concat(b);
  }, []);
  den = den.reduce(function(a,b) {
    return a.concat(b);
  }, []);

  return Qty$1({"scalar": q, "numerator": num, "denominator": den});
}

Qty$1.parse = globalParse;

Qty$1.getUnits = getUnits;
Qty$1.getAliases = getAliases;

Qty$1.mulSafe = mulSafe;
Qty$1.divSafe = divSafe;

Qty$1.getKinds = getKinds;

Qty$1.swiftConverter = swiftConverter;

Qty$1.Error = QtyError;

assign(Qty$1.prototype, {
  // Returns new instance with units of this
  add: function(other) {
    if (isString(other)) {
      other = Qty$1(other);
    }

    if (!this.isCompatible(other)) {
      throwIncompatibleUnits(this.units(), other.units());
    }

    if (this.isTemperature() && other.isTemperature()) {
      throw new QtyError("Cannot add two temperatures");
    }
    else if (this.isTemperature()) {
      return addTempDegrees(this, other);
    }
    else if (other.isTemperature()) {
      return addTempDegrees(other, this);
    }

    return Qty$1({"scalar": this.scalar + other.to(this).scalar, "numerator": this.numerator, "denominator": this.denominator});
  },

  sub: function(other) {
    if (isString(other)) {
      other = Qty$1(other);
    }

    if (!this.isCompatible(other)) {
      throwIncompatibleUnits(this.units(), other.units());
    }

    if (this.isTemperature() && other.isTemperature()) {
      return subtractTemperatures(this,other);
    }
    else if (this.isTemperature()) {
      return subtractTempDegrees(this,other);
    }
    else if (other.isTemperature()) {
      throw new QtyError("Cannot subtract a temperature from a differential degree unit");
    }

    return Qty$1({"scalar": this.scalar - other.to(this).scalar, "numerator": this.numerator, "denominator": this.denominator});
  },

  mul: function(other) {
    if (isNumber(other)) {
      return Qty$1({"scalar": mulSafe(this.scalar, other), "numerator": this.numerator, "denominator": this.denominator});
    }
    else if (isString(other)) {
      other = Qty$1(other);
    }

    if ((this.isTemperature()||other.isTemperature()) && !(this.isUnitless()||other.isUnitless())) {
      throw new QtyError("Cannot multiply by temperatures");
    }

    // Quantities should be multiplied with same units if compatible, with base units else
    var op1 = this;
    var op2 = other;

    // so as not to confuse results, multiplication and division between temperature degrees will maintain original unit info in num/den
    // multiplication and division between deg[CFRK] can never factor each other out, only themselves: "degK*degC/degC^2" == "degK/degC"
    if (op1.isCompatible(op2) && op1.signature !== 400) {
      op2 = op2.to(op1);
    }
    var numden = cleanTerms(op1.numerator.concat(op2.numerator), op1.denominator.concat(op2.denominator));

    return Qty$1({"scalar": mulSafe(op1.scalar, op2.scalar), "numerator": numden[0], "denominator": numden[1]});
  },

  div: function(other) {
    if (isNumber(other)) {
      if (other === 0) {
        throw new QtyError("Divide by zero");
      }
      return Qty$1({"scalar": this.scalar / other, "numerator": this.numerator, "denominator": this.denominator});
    }
    else if (isString(other)) {
      other = Qty$1(other);
    }

    if (other.scalar === 0) {
      throw new QtyError("Divide by zero");
    }

    if (other.isTemperature()) {
      throw new QtyError("Cannot divide with temperatures");
    }
    else if (this.isTemperature() && !other.isUnitless()) {
      throw new QtyError("Cannot divide with temperatures");
    }

    // Quantities should be multiplied with same units if compatible, with base units else
    var op1 = this;
    var op2 = other;

    // so as not to confuse results, multiplication and division between temperature degrees will maintain original unit info in num/den
    // multiplication and division between deg[CFRK] can never factor each other out, only themselves: "degK*degC/degC^2" == "degK/degC"
    if (op1.isCompatible(op2) && op1.signature !== 400) {
      op2 = op2.to(op1);
    }
    var numden = cleanTerms(op1.numerator.concat(op2.denominator), op1.denominator.concat(op2.numerator));

    return Qty$1({"scalar": op1.scalar / op2.scalar, "numerator": numden[0], "denominator": numden[1]});
  },

  // Returns a Qty that is the inverse of this Qty,
  inverse: function() {
    if (this.isTemperature()) {
      throw new QtyError("Cannot divide with temperatures");
    }
    if (this.scalar === 0) {
      throw new QtyError("Divide by zero");
    }
    return Qty$1({"scalar": 1 / this.scalar, "numerator": this.denominator, "denominator": this.numerator});
  }
});

function cleanTerms(num, den) {
  num = num.filter(function(val) {
    return val !== UNITY;
  });
  den = den.filter(function(val) {
    return val !== UNITY;
  });

  var combined = {};

  var k;
  for (var i = 0; i < num.length; i++) {
    if (PREFIX_VALUES[num[i]]) {
      k = [num[i], num[i + 1]];
      i++;
    }
    else {
      k = num[i];
    }
    if (k && k !== UNITY) {
      if (combined[k]) {
        combined[k][0]++;
      }
      else {
        combined[k] = [1, k];
      }
    }
  }

  for (var j = 0; j < den.length; j++) {
    if (PREFIX_VALUES[den[j]]) {
      k = [den[j], den[j + 1]];
      j++;
    }
    else {
      k = den[j];
    }
    if (k && k !== UNITY) {
      if (combined[k]) {
        combined[k][0]--;
      }
      else {
        combined[k] = [-1, k];
      }
    }
  }

  num = [];
  den = [];

  for (var prop in combined) {
    if (combined.hasOwnProperty(prop)) {
      var item = combined[prop];
      var n;
      if (item[0] > 0) {
        for (n = 0; n < item[0]; n++) {
          num.push(item[1]);
        }
      }
      else if (item[0] < 0) {
        for (n = 0; n < -item[0]; n++) {
          den.push(item[1]);
        }
      }
    }
  }

  if (num.length === 0) {
    num = UNITY_ARRAY;
  }
  if (den.length === 0) {
    den = UNITY_ARRAY;
  }

  // Flatten
  num = num.reduce(function(a,b) {
    return a.concat(b);
  }, []);
  den = den.reduce(function(a,b) {
    return a.concat(b);
  }, []);

  return [num, den];
}

assign(Qty$1.prototype, {
  eq: function(other) {
    return this.compareTo(other) === 0;
  },

  lt: function(other) {
    return this.compareTo(other) === -1;
  },

  lte: function(other) {
    return this.eq(other) || this.lt(other);
  },

  gt: function(other) {
    return this.compareTo(other) === 1;
  },

  gte: function(other) {
    return this.eq(other) || this.gt(other);
  },

  // Compare two Qty objects. Throws an exception if they are not of compatible types.
  // Comparisons are done based on the value of the quantity in base SI units.
  //
  // NOTE: We cannot compare inverses as that breaks the general compareTo contract:
  //   if a.compareTo(b) < 0 then b.compareTo(a) > 0
  //   if a.compareTo(b) == 0 then b.compareTo(a) == 0
  //
  //   Since "10S" == ".1ohm" (10 > .1) and "10ohm" == ".1S" (10 > .1)
  //     Qty("10S").inverse().compareTo("10ohm") == -1
  //     Qty("10ohm").inverse().compareTo("10S") == -1
  //
  //   If including inverses in the sort is needed, I suggest writing: Qty.sort(qtyArray,units)
  compareTo: function(other) {
    if (isString(other)) {
      return this.compareTo(Qty$1(other));
    }
    if (!this.isCompatible(other)) {
      throwIncompatibleUnits(this.units(), other.units());
    }
    if (this.baseScalar < other.baseScalar) {
      return -1;
    }
    else if (this.baseScalar === other.baseScalar) {
      return 0;
    }
    else if (this.baseScalar > other.baseScalar) {
      return 1;
    }
  },

  // Return true if quantities and units match
  // Unit("100 cm").same(Unit("100 cm"))  # => true
  // Unit("100 cm").same(Unit("1 m"))     # => false
  same: function(other) {
    return (this.scalar === other.scalar) && (this.units() === other.units());
  }
});

assign(Qty$1.prototype, {
  // returns true if no associated units
  // false, even if the units are "unitless" like 'radians, each, etc'
  isUnitless: function() {
    return [this.numerator, this.denominator].every(function(item) {
      return compareArray(item, UNITY_ARRAY);
    });
  },

  /*
  check to see if units are compatible, but not the scalar part
  this check is done by comparing signatures for performance reasons
  if passed a string, it will create a unit object with the string and then do the comparison
  this permits a syntax like:
  unit =~ "mm"
  if you want to do a regexp on the unit string do this ...
  unit.units =~ /regexp/
  */
  isCompatible: function(other) {
    if (isString(other)) {
      return this.isCompatible(Qty$1(other));
    }

    if (!(isQty(other))) {
      return false;
    }

    if (other.signature !== undefined) {
      return this.signature === other.signature;
    }
    else {
      return false;
    }
  },

  /*
  check to see if units are inverse of each other, but not the scalar part
  this check is done by comparing signatures for performance reasons
  if passed a string, it will create a unit object with the string and then do the comparison
  this permits a syntax like:
  unit =~ "mm"
  if you want to do a regexp on the unit string do this ...
  unit.units =~ /regexp/
  */
  isInverse: function(other) {
    return this.inverse().isCompatible(other);
  },

  // Returns 'true' if the Unit is represented in base units
  isBase: function() {
    if (this._isBase !== undefined) {
      return this._isBase;
    }
    if (this.isDegrees() && this.numerator[0].match(/<(kelvin|temp-K)>/)) {
      this._isBase = true;
      return this._isBase;
    }

    this.numerator.concat(this.denominator).forEach(function(item) {
      if (item !== UNITY && BASE_UNITS.indexOf(item) === -1 ) {
        this._isBase = false;
      }
    }, this);
    if (this._isBase === false) {
      return this._isBase;
    }
    this._isBase = true;
    return this._isBase;
  }
});

function NestedMap() {}

NestedMap.prototype.get = function(keys) {

  // Allows to pass key1, key2, ... instead of [key1, key2, ...]
  if (arguments.length > 1) {
    // Slower with Firefox but faster with Chrome than
    // Array.prototype.slice.call(arguments)
    // See http://jsperf.com/array-apply-versus-array-prototype-slice-call
    keys = Array.apply(null, arguments);
  }

  return keys.reduce(function(map, key, index) {
    if (map) {

      var childMap = map[key];

      if (index === keys.length - 1) {
        return childMap ? childMap.data : undefined;
      }
      else {
        return childMap;
      }
    }
  },
  this);
};

NestedMap.prototype.set = function(keys, value) {

  if (arguments.length > 2) {
    keys = Array.prototype.slice.call(arguments, 0, -1);
    value = arguments[arguments.length - 1];
  }

  return keys.reduce(function(map, key, index) {

    var childMap = map[key];
    if (childMap === undefined) {
      childMap = map[key] = {};
    }

    if (index === keys.length - 1) {
      childMap.data = value;
      return value;
    }
    else {
      return childMap;
    }
  }, this);
};

/**
 * Default formatter
 *
 * @param {number} scalar
 * @param {string} units
 *
 * @returns {string} formatted result
 */
function defaultFormatter(scalar, units) {
  return (scalar + " " + units).trim();
}

/**
 *
 * Configurable Qty default formatter
 *
 * @type {function}
 *
 * @param {number} scalar
 * @param {string} units
 *
 * @returns {string} formatted result
 */
Qty$1.formatter = defaultFormatter;

assign(Qty$1.prototype, {

  // returns the 'unit' part of the Unit object without the scalar
  units: function() {
    if (this._units !== undefined) {
      return this._units;
    }

    var numIsUnity = compareArray(this.numerator, UNITY_ARRAY),
        denIsUnity = compareArray(this.denominator, UNITY_ARRAY);
    if (numIsUnity && denIsUnity) {
      this._units = "";
      return this._units;
    }

    var numUnits = stringifyUnits(this.numerator),
        denUnits = stringifyUnits(this.denominator);
    this._units = numUnits + (denIsUnity ? "" : ("/" + denUnits));
    return this._units;
  },

  /**
   * Stringifies the quantity
   * Deprecation notice: only units parameter is supported.
   *
   * @param {(number|string|Qty)} targetUnitsOrMaxDecimalsOrPrec -
   *                              target units if string,
   *                              max number of decimals if number,
   *                              passed to #toPrec before converting if Qty
   *
   * @param {number=} maxDecimals - Maximum number of decimals of
   *                                formatted output
   *
   * @returns {string} reparseable quantity as string
   */
  toString: function(targetUnitsOrMaxDecimalsOrPrec, maxDecimals) {
    var targetUnits;
    if (isNumber(targetUnitsOrMaxDecimalsOrPrec)) {
      targetUnits = this.units();
      maxDecimals = targetUnitsOrMaxDecimalsOrPrec;
    }
    else if (isString(targetUnitsOrMaxDecimalsOrPrec)) {
      targetUnits = targetUnitsOrMaxDecimalsOrPrec;
    }
    else if (isQty(targetUnitsOrMaxDecimalsOrPrec)) {
      return this.toPrec(targetUnitsOrMaxDecimalsOrPrec).toString(maxDecimals);
    }

    var out = this.to(targetUnits);

    var outScalar = maxDecimals !== undefined ? round(out.scalar, maxDecimals) : out.scalar;
    out = (outScalar + " " + out.units()).trim();
    return out;
  },

  /**
   * Format the quantity according to optional passed target units
   * and formatter
   *
   * @param {string} [targetUnits=current units] -
   *                 optional units to convert to before formatting
   *
   * @param {function} [formatter=Qty.formatter] -
   *                   delegates formatting to formatter callback.
   *                   formatter is called back with two parameters (scalar, units)
   *                   and should return formatted result.
   *                   If unspecified, formatting is delegated to default formatter
   *                   set to Qty.formatter
   *
   * @example
   * var roundingAndLocalizingFormatter = function(scalar, units) {
   *   // localize or limit scalar to n max decimals for instance
   *   // return formatted result
   * };
   * var qty = Qty('1.1234 m');
   * qty.format(); // same units, default formatter => "1.234 m"
   * qty.format("cm"); // converted to "cm", default formatter => "123.45 cm"
   * qty.format(roundingAndLocalizingFormatter); // same units, custom formatter => "1,2 m"
   * qty.format("cm", roundingAndLocalizingFormatter); // convert to "cm", custom formatter => "123,4 cm"
   *
   * @returns {string} quantity as string
   */
  format: function(targetUnits, formatter) {
    if (arguments.length === 1) {
      if (typeof targetUnits === "function") {
        formatter = targetUnits;
        targetUnits = undefined;
      }
    }

    formatter = formatter || Qty$1.formatter;
    var targetQty = this.to(targetUnits);
    return formatter.call(this, targetQty.scalar, targetQty.units());
  }
});

var stringifiedUnitsCache = new NestedMap();
/**
 * Returns a string representing a normalized unit array
 *
 * @param {string[]} units Normalized unit array
 * @returns {string} String representing passed normalized unit array and
 *   suitable for output
 *
 */
function stringifyUnits(units) {

  var stringified = stringifiedUnitsCache.get(units);
  if (stringified) {
    return stringified;
  }

  var isUnity = compareArray(units, UNITY_ARRAY);
  if (isUnity) {
    stringified = "1";
  }
  else {
    stringified = simplify(getOutputNames(units)).join("*");
  }

  // Cache result
  stringifiedUnitsCache.set(units, stringified);

  return stringified;
}

function getOutputNames(units) {
  var unitNames = [], token, tokenNext;
  for (var i = 0; i < units.length; i++) {
    token = units[i];
    tokenNext = units[i + 1];
    if (PREFIX_VALUES[token]) {
      unitNames.push(OUTPUT_MAP[token] + OUTPUT_MAP[tokenNext]);
      i++;
    }
    else {
      unitNames.push(OUTPUT_MAP[token]);
    }
  }
  return unitNames;
}

function simplify (units) {
  // this turns ['s','m','s'] into ['s2','m']

  var unitCounts = units.reduce(function(acc, unit) {
    var unitCounter = acc[unit];
    if (!unitCounter) {
      acc.push(unitCounter = acc[unit] = [unit, 0]);
    }

    unitCounter[1]++;

    return acc;
  }, []);

  return unitCounts.map(function(unitCount) {
    return unitCount[0] + (unitCount[1] > 1 ? unitCount[1] : "");
  });
}

Qty$1.version = "1.7.0";

return Qty$1;

})));
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));

/*! @preserve
 * numeral.js
 * locales : 2.0.6
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (typeof define === 'function' && define.amd) {
        define(['numeral'], factory);
    } else if (typeof module === 'object' && module.exports) {
        factory(require('./numeral'));
    } else {
        factory(global.numeral);
    }
}(this, function (numeral) {
    
(function() {
        numeral.register('locale', 'bg', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: { // I found these here http://www.unicode.org/cldr/charts/28/verify/numbers/bg.html
            thousand: 'хил',
            million: 'млн',
            billion: 'млрд',
            trillion: 'трлн'
        },
        ordinal: function (number) {
            // google translate suggests:
            // 1st=1-ви; 2nd=2-ри; 7th=7-ми;
            // 8th=8-ми and many others end with -ти
            // for example 3rd=3-ти
            // However since I've seen suggestions that in
            // Bulgarian the ordinal can be taken in
            // different forms (masculine, feminine, neuter)
            // I've opted to wimp out on commiting that to code
            return '';
        },
        currency: {
            symbol: 'лв'
        }
    });
})();


(function() {
    
    numeral.register('locale', 'chs', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十亿',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
})();


(function() {
        numeral.register('locale', 'cs', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: 'Kč'
        }
    });
})();


(function() {
        numeral.register('locale', 'da-dk', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mia',
            trillion: 'b'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'DKK'
        }
    });
})();


(function() {
        numeral.register('locale', 'de-ch', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'CHF'
        }
    });
})();


(function() {
        numeral.register('locale', 'de', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-au', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-gb', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '£'
        }
    });
})();


(function() {
        numeral.register('locale', 'en-za', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (~~ (number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                    (b === 2) ? 'nd' :
                        (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: 'R'
        }
    });
})();


(function() {
        numeral.register('locale', 'es-es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                    (b === 7 || b === 0) ? 'mo' :
                        (b === 8) ? 'vo' :
                            (b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'es', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            var b = number % 10;
            return (b === 1 || b === 3) ? 'er' :
                (b === 2) ? 'do' :
                (b === 7 || b === 0) ? 'mo' :
		(b === 8) ? 'vo' :
		(b === 9) ? 'no' : 'to';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'et', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tuh',
            million: ' mln',
            billion: ' mld',
            trillion: ' trl'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'fi', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr-ca', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'M',
            billion: 'G',
            trillion: 'T'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '$'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr-ch', {
        delimiters: {
            thousands: '\'',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: 'CHF'
        }
    });
})();


(function() {
        numeral.register('locale', 'fr', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return number === 1 ? 'er' : 'e';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'hu', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'E',  // ezer
            million: 'M',   // millió
            billion: 'Mrd', // milliárd
            trillion: 'T'   // trillió
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: ' Ft'
        }
    });
})();


(function() {
        numeral.register('locale', 'it', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mila',
            million: 'mil',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'ja', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: '千',
            million: '百万',
            billion: '十億',
            trillion: '兆'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '¥'
        }
    });
})();


(function() {
        numeral.register('locale', 'lv', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: ' tūkst.',
            million: ' milj.',
            billion: ' mljrd.',
            trillion: ' trilj.'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'nl-be', {
        delimiters: {
            thousands: ' ',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : ' mln',
            billion  : ' mld',
            trillion : ' bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;

            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
})();


(function() {
        numeral.register('locale', 'nl-nl', {
        delimiters: {
            thousands: '.',
            decimal  : ','
        },
        abbreviations: {
            thousand : 'k',
            million  : 'mln',
            billion  : 'mrd',
            trillion : 'bln'
        },
        ordinal : function (number) {
            var remainder = number % 100;
            return (number !== 0 && remainder <= 1 || remainder === 8 || remainder >= 20) ? 'ste' : 'de';
        },
        currency: {
            symbol: '€ '
        }
    });
})();


(function() {
        numeral.register('locale', 'no', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'kr'
        }
    });
})();


(function() {
        numeral.register('locale', 'pl', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tys.',
            million: 'mln',
            billion: 'mld',
            trillion: 'bln'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: 'PLN'
        }
    });
})();


(function() {
        numeral.register('locale', 'pt-br', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'mil',
            million: 'milhões',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function (number) {
            return 'º';
        },
        currency: {
            symbol: 'R$'
        }
    });
})();


(function() {
        numeral.register('locale', 'pt-pt', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal : function (number) {
            return 'º';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'ru-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
})();


(function() {
        numeral.register('locale', 'ru', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тыс.',
            million: 'млн.',
            billion: 'млрд.',
            trillion: 'трлн.'
        },
        ordinal: function () {
            // not ideal, but since in Russian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '.';
        },
        currency: {
            symbol: 'руб.'
        }
    });
})();


(function() {
        numeral.register('locale', 'sk', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'tis.',
            million: 'mil.',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
        numeral.register('locale', 'sl', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'k',
            million: 'mio',
            billion: 'mrd',
            trillion: 'trilijon'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '€'
        }
    });
})();


(function() {
    

    numeral.register('locale', 'th', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'พัน',
            million: 'ล้าน',
            billion: 'พันล้าน',
            trillion: 'ล้านล้าน'
        },
        ordinal: function (number) {
            return '.';
        },
        currency: {
            symbol: '฿'
        }
    });
})();


(function() {
        var suffixes = {
            1: '\'inci',
            5: '\'inci',
            8: '\'inci',
            70: '\'inci',
            80: '\'inci',

            2: '\'nci',
            7: '\'nci',
            20: '\'nci',
            50: '\'nci',

            3: '\'üncü',
            4: '\'üncü',
            100: '\'üncü',

            6: '\'ncı',

            9: '\'uncu',
            10: '\'uncu',
            30: '\'uncu',

            60: '\'ıncı',
            90: '\'ıncı'
        };

    numeral.register('locale', 'tr', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: 'bin',
            million: 'milyon',
            billion: 'milyar',
            trillion: 'trilyon'
        },
        ordinal: function (number) {
            if (number === 0) {  // special case for zero
                return '\'ıncı';
            }

            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;

          return suffixes[a] || suffixes[b] || suffixes[c];
        },
        currency: {
            symbol: '\u20BA'
        }
    });
})();


(function() {
        numeral.register('locale', 'uk-ua', {
        delimiters: {
            thousands: ' ',
            decimal: ','
        },
        abbreviations: {
            thousand: 'тис.',
            million: 'млн',
            billion: 'млрд',
            trillion: 'блн'
        },
        ordinal: function () {
            // not ideal, but since in Ukrainian it can taken on
            // different forms (masculine, feminine, neuter)
            // this is all we can do
            return '';
        },
        currency: {
            symbol: '\u20B4'
        }
    });
})();


(function() {
    
    numeral.register('locale', 'vi', {
        delimiters: {
            thousands: '.',
            decimal: ','
        },
        abbreviations: {
            thousand: ' nghìn',
            million: ' triệu',
            billion: ' tỷ',
            trillion: ' nghìn tỷ'
        },
        ordinal: function () {
            return '.';
        },
        currency: {
            symbol: '₫'
        }
    });
})();


}));

/// Knockout Mapping plugin v2.4.0
/// (c) 2013 Steven Sanderson, Roy Jacobs - http://knockoutjs.com/
/// License: MIT (http://www.opensource.org/licenses/mit-license.php)
(function (factory) {
	// Module systems magic dance.

	if (typeof require === "function" && typeof exports === "object" && typeof module === "object") {
		// CommonJS or Node: hard-coded dependency on "knockout"
		factory(require("knockout"), exports);
	} else if (typeof define === "function" && define["amd"]) {
		// AMD anonymous module with hard-coded dependency on "knockout"
		define(["knockout", "exports"], factory);
	} else {
		// <script> tag: use the global `ko` object, attaching a `mapping` property
		factory(ko, ko.mapping = {});
	}
}(function (ko, exports) {
	var DEBUG=true;
	var mappingProperty = "__ko_mapping__";
	var realKoDependentObservable = ko.dependentObservable;
	var mappingNesting = 0;
	var dependentObservables;
	var visitedObjects;
	var recognizedRootProperties = ["create", "update", "key", "arrayChanged"];
	var emptyReturn = {};

	var _defaultOptions = {
		include: ["_destroy"],
		ignore: [],
		copy: [],
		observe: []
	};
	var defaultOptions = _defaultOptions;

	// Author: KennyTM @ StackOverflow
	function unionArrays (x, y) {
		var obj = {};
		for (var i = x.length - 1; i >= 0; -- i) obj[x[i]] = x[i];
		for (var i = y.length - 1; i >= 0; -- i) obj[y[i]] = y[i];
		var res = [];

		for (var k in obj) {
			res.push(obj[k]);
		};

		return res;
	}

	function extendObject(destination, source) {
		var destType;

		for (var key in source) {
			if (source.hasOwnProperty(key) && source[key]) {
				destType = exports.getType(destination[key]);
				if (key && destination[key] && destType !== "array" && destType !== "string") {
					extendObject(destination[key], source[key]);
				} else {
					var bothArrays = exports.getType(destination[key]) === "array" && exports.getType(source[key]) === "array";
					if (bothArrays) {
						destination[key] = unionArrays(destination[key], source[key]);
					} else {
						destination[key] = source[key];
					}
				}
			}
		}
	}

	function merge(obj1, obj2) {
		var merged = {};
		extendObject(merged, obj1);
		extendObject(merged, obj2);

		return merged;
	}

	exports.isMapped = function (viewModel) {
		var unwrapped = ko.utils.unwrapObservable(viewModel);
		return unwrapped && unwrapped[mappingProperty];
	}

	exports.fromJS = function (jsObject /*, inputOptions, target*/ ) {
		if (arguments.length == 0) throw new Error("When calling ko.fromJS, pass the object you want to convert.");

		try {
			if (!mappingNesting++) {
				dependentObservables = [];
				visitedObjects = new objectLookup();
			}

			var options;
			var target;

			if (arguments.length == 2) {
				if (arguments[1][mappingProperty]) {
					target = arguments[1];
				} else {
					options = arguments[1];
				}
			}
			if (arguments.length == 3) {
				options = arguments[1];
				target = arguments[2];
			}

			if (target) {
				options = merge(options, target[mappingProperty]);
			}
			options = fillOptions(options);

			var result = updateViewModel(target, jsObject, options);
			if (target) {
				result = target;
			}

			// Evaluate any dependent observables that were proxied.
			// Do this after the model's observables have been created
			if (!--mappingNesting) {
				while (dependentObservables.length) {
					var DO = dependentObservables.pop();
					if (DO) DO();
				}
			}

			// Save any new mapping options in the view model, so that updateFromJS can use them later.
			result[mappingProperty] = merge(result[mappingProperty], options);

			return result;
		} catch(e) {
			mappingNesting = 0;
			throw e;
		}
	};

	exports.fromJSON = function (jsonString /*, options, target*/ ) {
		var parsed = ko.utils.parseJson(jsonString);
		arguments[0] = parsed;
		return exports.fromJS.apply(this, arguments);
	};

	exports.updateFromJS = function (viewModel) {
		throw new Error("ko.mapping.updateFromJS, use ko.mapping.fromJS instead. Please note that the order of parameters is different!");
	};

	exports.updateFromJSON = function (viewModel) {
		throw new Error("ko.mapping.updateFromJSON, use ko.mapping.fromJSON instead. Please note that the order of parameters is different!");
	};

	exports.toJS = function (rootObject, options) {
		if (!defaultOptions) exports.resetDefaultOptions();

		if (arguments.length == 0) throw new Error("When calling ko.mapping.toJS, pass the object you want to convert.");
		if (exports.getType(defaultOptions.ignore) !== "array") throw new Error("ko.mapping.defaultOptions().ignore should be an array.");
		if (exports.getType(defaultOptions.include) !== "array") throw new Error("ko.mapping.defaultOptions().include should be an array.");
		if (exports.getType(defaultOptions.copy) !== "array") throw new Error("ko.mapping.defaultOptions().copy should be an array.");

		// Merge in the options used in fromJS
		options = fillOptions(options, rootObject[mappingProperty]);

		// We just unwrap everything at every level in the object graph
		return exports.visitModel(rootObject, function (x) {
			return ko.utils.unwrapObservable(x)
		}, options);
	};

	exports.toJSON = function (rootObject, options) {
		var plainJavaScriptObject = exports.toJS(rootObject, options);
		return ko.utils.stringifyJson(plainJavaScriptObject);
	};

	exports.defaultOptions = function () {
		if (arguments.length > 0) {
			defaultOptions = arguments[0];
		} else {
			return defaultOptions;
		}
	};

	exports.resetDefaultOptions = function () {
		defaultOptions = {
			include: _defaultOptions.include.slice(0),
			ignore: _defaultOptions.ignore.slice(0),
			copy: _defaultOptions.copy.slice(0)
		};
	};

	exports.getType = function(x) {
		if ((x) && (typeof (x) === "object")) {
			if (x.constructor === Date) return "date";
			if (x.constructor === Array) return "array";
		}
		return typeof x;
	}

	function fillOptions(rawOptions, otherOptions) {
		var options = merge({}, rawOptions);

		// Move recognized root-level properties into a root namespace
		for (var i = recognizedRootProperties.length - 1; i >= 0; i--) {
			var property = recognizedRootProperties[i];
			
			// Carry on, unless this property is present
			if (!options[property]) continue;
			
			// Move the property into the root namespace
			if (!(options[""] instanceof Object)) options[""] = {};
			options[""][property] = options[property];
			delete options[property];
		}

		if (otherOptions) {
			options.ignore = mergeArrays(otherOptions.ignore, options.ignore);
			options.include = mergeArrays(otherOptions.include, options.include);
			options.copy = mergeArrays(otherOptions.copy, options.copy);
			options.observe = mergeArrays(otherOptions.observe, options.observe);
		}
		options.ignore = mergeArrays(options.ignore, defaultOptions.ignore);
		options.include = mergeArrays(options.include, defaultOptions.include);
		options.copy = mergeArrays(options.copy, defaultOptions.copy);
		options.observe = mergeArrays(options.observe, defaultOptions.observe);

		options.mappedProperties = options.mappedProperties || {};
		options.copiedProperties = options.copiedProperties || {};
		return options;
	}

	function mergeArrays(a, b) {
		if (exports.getType(a) !== "array") {
			if (exports.getType(a) === "undefined") a = [];
			else a = [a];
		}
		if (exports.getType(b) !== "array") {
			if (exports.getType(b) === "undefined") b = [];
			else b = [b];
		}

		return ko.utils.arrayGetDistinctValues(a.concat(b));
	}

	// When using a 'create' callback, we proxy the dependent observable so that it doesn't immediately evaluate on creation.
	// The reason is that the dependent observables in the user-specified callback may contain references to properties that have not been mapped yet.
	function withProxyDependentObservable(dependentObservables, callback) {
		var localDO = ko.dependentObservable;
		ko.dependentObservable = function (read, owner, options) {
			options = options || {};

			if (read && typeof read == "object") { // mirrors condition in knockout implementation of DO's
				options = read;
			}

			var realDeferEvaluation = options.deferEvaluation;

			var isRemoved = false;

			// We wrap the original dependent observable so that we can remove it from the 'dependentObservables' list we need to evaluate after mapping has
			// completed if the user already evaluated the DO themselves in the meantime.
			var wrap = function (DO) {
				// Temporarily revert ko.dependentObservable, since it is used in ko.isWriteableObservable
				var tmp = ko.dependentObservable;
				ko.dependentObservable = realKoDependentObservable;
				var isWriteable = ko.isWriteableObservable(DO);
				ko.dependentObservable = tmp;

				var wrapped = realKoDependentObservable({
					read: function () {
						if (!isRemoved) {
							ko.utils.arrayRemoveItem(dependentObservables, DO);
							isRemoved = true;
						}
						return DO.apply(DO, arguments);
					},
					write: isWriteable && function (val) {
						return DO(val);
					},
					deferEvaluation: true
				});
				if (DEBUG) wrapped._wrapper = true;
				return wrapped;
			};
			
			options.deferEvaluation = true; // will either set for just options, or both read/options.
			var realDependentObservable = new realKoDependentObservable(read, owner, options);

			if (!realDeferEvaluation) {
				realDependentObservable = wrap(realDependentObservable);
				dependentObservables.push(realDependentObservable);
			}

			return realDependentObservable;
		}
		ko.dependentObservable.fn = realKoDependentObservable.fn;
		ko.computed = ko.dependentObservable;
		var result = callback();
		ko.dependentObservable = localDO;
		ko.computed = ko.dependentObservable;
		return result;
	}

	function updateViewModel(mappedRootObject, rootObject, options, parentName, parent, parentPropertyName, mappedParent) {
		var isArray = exports.getType(ko.utils.unwrapObservable(rootObject)) === "array";

		parentPropertyName = parentPropertyName || "";

		// If this object was already mapped previously, take the options from there and merge them with our existing ones.
		if (exports.isMapped(mappedRootObject)) {
			var previousMapping = ko.utils.unwrapObservable(mappedRootObject)[mappingProperty];
			options = merge(previousMapping, options);
		}

		var callbackParams = {
			data: rootObject,
			parent: mappedParent || parent
		};

		var hasCreateCallback = function () {
			return options[parentName] && options[parentName].create instanceof Function;
		};

		var createCallback = function (data) {
			return withProxyDependentObservable(dependentObservables, function () {
				
				if (ko.utils.unwrapObservable(parent) instanceof Array) {
					return options[parentName].create({
						data: data || callbackParams.data,
						parent: callbackParams.parent,
						skip: emptyReturn
					});
				} else {
					return options[parentName].create({
						data: data || callbackParams.data,
						parent: callbackParams.parent
					});
				}				
			});
		};

		var hasUpdateCallback = function () {
			return options[parentName] && options[parentName].update instanceof Function;
		};

		var updateCallback = function (obj, data) {
			var params = {
				data: data || callbackParams.data,
				parent: callbackParams.parent,
				target: ko.utils.unwrapObservable(obj)
			};

			if (ko.isWriteableObservable(obj)) {
				params.observable = obj;
			}

			return options[parentName].update(params);
		}

		var alreadyMapped = visitedObjects.get(rootObject);
		if (alreadyMapped) {
			return alreadyMapped;
		}

		parentName = parentName || "";

		if (!isArray) {
			// For atomic types, do a direct update on the observable
			if (!canHaveProperties(rootObject)) {
				switch (exports.getType(rootObject)) {
				case "function":
					if (hasUpdateCallback()) {
						if (ko.isWriteableObservable(rootObject)) {
							rootObject(updateCallback(rootObject));
							mappedRootObject = rootObject;
						} else {
							mappedRootObject = updateCallback(rootObject);
						}
					} else {
						mappedRootObject = rootObject;
					}
					break;
				default:
					if (ko.isWriteableObservable(mappedRootObject)) {
						if (hasUpdateCallback()) {
							var valueToWrite = updateCallback(mappedRootObject);
							mappedRootObject(valueToWrite);
							return valueToWrite;
						} else {
							var valueToWrite = ko.utils.unwrapObservable(rootObject);
							mappedRootObject(valueToWrite);
							return valueToWrite;
						}
					} else {
						var hasCreateOrUpdateCallback = hasCreateCallback() || hasUpdateCallback();
						
						if (hasCreateCallback()) {
							mappedRootObject = createCallback();
						} else {
							mappedRootObject = ko.observable(ko.utils.unwrapObservable(rootObject));
						}

						if (hasUpdateCallback()) {
							mappedRootObject(updateCallback(mappedRootObject));
						}
						
						if (hasCreateOrUpdateCallback) return mappedRootObject;
					}
				}

			} else {
				mappedRootObject = ko.utils.unwrapObservable(mappedRootObject);
				if (!mappedRootObject) {
					if (hasCreateCallback()) {
						var result = createCallback();

						if (hasUpdateCallback()) {
							result = updateCallback(result);
						}

						return result;
					} else {
						if (hasUpdateCallback()) {
							return updateCallback(result);
						}

						mappedRootObject = {};
					}
				}

				if (hasUpdateCallback()) {
					mappedRootObject = updateCallback(mappedRootObject);
				}

				visitedObjects.save(rootObject, mappedRootObject);
				if (hasUpdateCallback()) return mappedRootObject;

				// For non-atomic types, visit all properties and update recursively
				visitPropertiesOrArrayEntries(rootObject, function (indexer) {
					var fullPropertyName = parentPropertyName.length ? parentPropertyName + "." + indexer : indexer;

					if (ko.utils.arrayIndexOf(options.ignore, fullPropertyName) != -1) {
						return;
					}

					if (ko.utils.arrayIndexOf(options.copy, fullPropertyName) != -1) {
						mappedRootObject[indexer] = rootObject[indexer];
						return;
					}

					if(typeof rootObject[indexer] != "object" && typeof rootObject[indexer] != "array" && options.observe.length > 0 && ko.utils.arrayIndexOf(options.observe, fullPropertyName) == -1)
					{
						mappedRootObject[indexer] = rootObject[indexer];
						options.copiedProperties[fullPropertyName] = true;
						return;
					}
					
					// In case we are adding an already mapped property, fill it with the previously mapped property value to prevent recursion.
					// If this is a property that was generated by fromJS, we should use the options specified there
					var prevMappedProperty = visitedObjects.get(rootObject[indexer]);
					var retval = updateViewModel(mappedRootObject[indexer], rootObject[indexer], options, indexer, mappedRootObject, fullPropertyName, mappedRootObject);
					var value = prevMappedProperty || retval;
					
					if(options.observe.length > 0 && ko.utils.arrayIndexOf(options.observe, fullPropertyName) == -1)
					{
						mappedRootObject[indexer] = value();
						options.copiedProperties[fullPropertyName] = true;
						return;
					}
					
					if (ko.isWriteableObservable(mappedRootObject[indexer])) {
						mappedRootObject[indexer](ko.utils.unwrapObservable(value));
					} else {
						value = mappedRootObject[indexer] === undefined ? value : ko.utils.unwrapObservable(value);
						mappedRootObject[indexer] = value;
					}

					options.mappedProperties[fullPropertyName] = true;
				});
			}
		} else { //mappedRootObject is an array
			var changes = [];

			var hasKeyCallback = false;
			var keyCallback = function (x) {
				return x;
			}
			if (options[parentName] && options[parentName].key) {
				keyCallback = options[parentName].key;
				hasKeyCallback = true;
			}

			if (!ko.isObservable(mappedRootObject)) {
				// When creating the new observable array, also add a bunch of utility functions that take the 'key' of the array items into account.
				mappedRootObject = ko.observableArray([]);

				mappedRootObject.mappedRemove = function (valueOrPredicate) {
					var predicate = typeof valueOrPredicate == "function" ? valueOrPredicate : function (value) {
							return value === keyCallback(valueOrPredicate);
						};
					return mappedRootObject.remove(function (item) {
						return predicate(keyCallback(item));
					});
				}

				mappedRootObject.mappedRemoveAll = function (arrayOfValues) {
					var arrayOfKeys = filterArrayByKey(arrayOfValues, keyCallback);
					return mappedRootObject.remove(function (item) {
						return ko.utils.arrayIndexOf(arrayOfKeys, keyCallback(item)) != -1;
					});
				}

				mappedRootObject.mappedDestroy = function (valueOrPredicate) {
					var predicate = typeof valueOrPredicate == "function" ? valueOrPredicate : function (value) {
							return value === keyCallback(valueOrPredicate);
						};
					return mappedRootObject.destroy(function (item) {
						return predicate(keyCallback(item));
					});
				}

				mappedRootObject.mappedDestroyAll = function (arrayOfValues) {
					var arrayOfKeys = filterArrayByKey(arrayOfValues, keyCallback);
					return mappedRootObject.destroy(function (item) {
						return ko.utils.arrayIndexOf(arrayOfKeys, keyCallback(item)) != -1;
					});
				}

				mappedRootObject.mappedIndexOf = function (item) {
					var keys = filterArrayByKey(mappedRootObject(), keyCallback);
					var key = keyCallback(item);
					return ko.utils.arrayIndexOf(keys, key);
				}

				mappedRootObject.mappedCreate = function (value) {
					if (mappedRootObject.mappedIndexOf(value) !== -1) {
						throw new Error("There already is an object with the key that you specified.");
					}

					var item = hasCreateCallback() ? createCallback(value) : value;
					if (hasUpdateCallback()) {
						var newValue = updateCallback(item, value);
						if (ko.isWriteableObservable(item)) {
							item(newValue);
						} else {
							item = newValue;
						}
					}
					mappedRootObject.push(item);
					return item;
				}
			}

			var currentArrayKeys = filterArrayByKey(ko.utils.unwrapObservable(mappedRootObject), keyCallback).sort();
			var newArrayKeys = filterArrayByKey(rootObject, keyCallback);
			if (hasKeyCallback) newArrayKeys.sort();
			var editScript = ko.utils.compareArrays(currentArrayKeys, newArrayKeys);

			var ignoreIndexOf = {};
			
			var i, j;

			var unwrappedRootObject = ko.utils.unwrapObservable(rootObject);
			var itemsByKey = {};
			var optimizedKeys = true;
			for (i = 0, j = unwrappedRootObject.length; i < j; i++) {
				var key = keyCallback(unwrappedRootObject[i]);
				if (key === undefined || key instanceof Object) {
					optimizedKeys = false;
					break;
				}
				itemsByKey[key] = unwrappedRootObject[i];
			}

			var newContents = [];
			var passedOver = 0;
			for (i = 0, j = editScript.length; i < j; i++) {
				var key = editScript[i];
				var mappedItem;
				var fullPropertyName = parentPropertyName + "[" + i + "]";
				switch (key.status) {
				case "added":
					var item = optimizedKeys ? itemsByKey[key.value] : getItemByKey(ko.utils.unwrapObservable(rootObject), key.value, keyCallback);
					mappedItem = updateViewModel(undefined, item, options, parentName, mappedRootObject, fullPropertyName, parent);
					if(!hasCreateCallback()) {
						mappedItem = ko.utils.unwrapObservable(mappedItem);
					}

					var index = ignorableIndexOf(ko.utils.unwrapObservable(rootObject), item, ignoreIndexOf);
					
					if (mappedItem === emptyReturn) {
						passedOver++;
					} else {
						newContents[index - passedOver] = mappedItem;
					}
						
					ignoreIndexOf[index] = true;
					break;
				case "retained":
					var item = optimizedKeys ? itemsByKey[key.value] : getItemByKey(ko.utils.unwrapObservable(rootObject), key.value, keyCallback);
					mappedItem = getItemByKey(mappedRootObject, key.value, keyCallback);
					updateViewModel(mappedItem, item, options, parentName, mappedRootObject, fullPropertyName, parent);

					var index = ignorableIndexOf(ko.utils.unwrapObservable(rootObject), item, ignoreIndexOf);
					newContents[index] = mappedItem;
					ignoreIndexOf[index] = true;
					break;
				case "deleted":
					mappedItem = getItemByKey(mappedRootObject, key.value, keyCallback);
					break;
				}

				changes.push({
					event: key.status,
					item: mappedItem
				});
			}

			mappedRootObject(newContents);

			if (options[parentName] && options[parentName].arrayChanged) {
				ko.utils.arrayForEach(changes, function (change) {
					options[parentName].arrayChanged(change.event, change.item);
				});
			}
		}

		return mappedRootObject;
	}

	function ignorableIndexOf(array, item, ignoreIndices) {
		for (var i = 0, j = array.length; i < j; i++) {
			if (ignoreIndices[i] === true) continue;
			if (array[i] === item) return i;
		}
		return null;
	}

	function mapKey(item, callback) {
		var mappedItem;
		if (callback) mappedItem = callback(item);
		if (exports.getType(mappedItem) === "undefined") mappedItem = item;

		return ko.utils.unwrapObservable(mappedItem);
	}

	function getItemByKey(array, key, callback) {
		array = ko.utils.unwrapObservable(array);
		for (var i = 0, j = array.length; i < j; i++) {
			var item = array[i];
			if (mapKey(item, callback) === key) return item;
		}

		throw new Error("When calling ko.update*, the key '" + key + "' was not found!");
	}

	function filterArrayByKey(array, callback) {
		return ko.utils.arrayMap(ko.utils.unwrapObservable(array), function (item) {
			if (callback) {
				return mapKey(item, callback);
			} else {
				return item;
			}
		});
	}

	function visitPropertiesOrArrayEntries(rootObject, visitorCallback) {
		if (exports.getType(rootObject) === "array") {
			for (var i = 0; i < rootObject.length; i++)
			visitorCallback(i);
		} else {
			for (var propertyName in rootObject)
			visitorCallback(propertyName);
		}
	};

	function canHaveProperties(object) {
		var type = exports.getType(object);
		return ((type === "object") || (type === "array")) && (object !== null);
	}

	// Based on the parentName, this creates a fully classified name of a property

	function getPropertyName(parentName, parent, indexer) {
		var propertyName = parentName || "";
		if (exports.getType(parent) === "array") {
			if (parentName) {
				propertyName += "[" + indexer + "]";
			}
		} else {
			if (parentName) {
				propertyName += ".";
			}
			propertyName += indexer;
		}
		return propertyName;
	}

	exports.visitModel = function (rootObject, callback, options) {
		options = options || {};
		options.visitedObjects = options.visitedObjects || new objectLookup();

		var mappedRootObject;
		var unwrappedRootObject = ko.utils.unwrapObservable(rootObject);

		if (!canHaveProperties(unwrappedRootObject)) {
			return callback(rootObject, options.parentName);
		} else {
			options = fillOptions(options, unwrappedRootObject[mappingProperty]);

			// Only do a callback, but ignore the results
			callback(rootObject, options.parentName);
			mappedRootObject = exports.getType(unwrappedRootObject) === "array" ? [] : {};
		}

		options.visitedObjects.save(rootObject, mappedRootObject);

		var parentName = options.parentName;
		visitPropertiesOrArrayEntries(unwrappedRootObject, function (indexer) {
			if (options.ignore && ko.utils.arrayIndexOf(options.ignore, indexer) != -1) return;

			var propertyValue = unwrappedRootObject[indexer];
			options.parentName = getPropertyName(parentName, unwrappedRootObject, indexer);

			// If we don't want to explicitly copy the unmapped property...
			if (ko.utils.arrayIndexOf(options.copy, indexer) === -1) {
				// ...find out if it's a property we want to explicitly include
				if (ko.utils.arrayIndexOf(options.include, indexer) === -1) {
					// The mapped properties object contains all the properties that were part of the original object.
					// If a property does not exist, and it is not because it is part of an array (e.g. "myProp[3]"), then it should not be unmapped.
				    if (unwrappedRootObject[mappingProperty]
				        && unwrappedRootObject[mappingProperty].mappedProperties && !unwrappedRootObject[mappingProperty].mappedProperties[indexer]
				        && unwrappedRootObject[mappingProperty].copiedProperties && !unwrappedRootObject[mappingProperty].copiedProperties[indexer]
				        && !(exports.getType(unwrappedRootObject) === "array")) {
						return;
					}
				}
			}

			var outputProperty;
			switch (exports.getType(ko.utils.unwrapObservable(propertyValue))) {
			case "object":
			case "array":
			case "undefined":
				var previouslyMappedValue = options.visitedObjects.get(propertyValue);
				mappedRootObject[indexer] = (exports.getType(previouslyMappedValue) !== "undefined") ? previouslyMappedValue : exports.visitModel(propertyValue, callback, options);
				break;
			default:
				mappedRootObject[indexer] = callback(propertyValue, options.parentName);
			}
		});

		return mappedRootObject;
	}

	function simpleObjectLookup() {
		var keys = [];
		var values = [];
		this.save = function (key, value) {
			var existingIndex = ko.utils.arrayIndexOf(keys, key);
			if (existingIndex >= 0) values[existingIndex] = value;
			else {
				keys.push(key);
				values.push(value);
			}
		};
		this.get = function (key) {
			var existingIndex = ko.utils.arrayIndexOf(keys, key);
			var value = (existingIndex >= 0) ? values[existingIndex] : undefined;
			return value;
		};
	};
	
	function objectLookup() {
		var buckets = {};
		
		var findBucket = function(key) {
			var bucketKey;
			try {
				bucketKey = key;//JSON.stringify(key);
			}
			catch (e) {
				bucketKey = "$$$";
			}

			var bucket = buckets[bucketKey];
			if (bucket === undefined) {
				bucket = new simpleObjectLookup();
				buckets[bucketKey] = bucket;
			}
			return bucket;
		};
		
		this.save = function (key, value) {
			findBucket(key).save(key, value);
		};
		this.get = function (key) {
			return findBucket(key).get(key);
		};
	};
}));

/*=============================================================================
	Author:			Eric M. Barnard - @ericmbarnard								
	License:		MIT (http://opensource.org/licenses/mit-license.php)		
																				
	Description:	Validation Library for KnockoutJS							
	Version:		2.0.3											
===============================================================================
*/
/*globals require: false, exports: false, define: false, ko: false */

(function (factory) {
	// Module systems magic dance.

	if (typeof require === "function" && typeof exports === "object" && typeof module === "object") {
		// CommonJS or Node: hard-coded dependency on "knockout"
		factory(require("knockout"), exports);
	} else if (typeof define === "function" && define["amd"]) {
		// AMD anonymous module with hard-coded dependency on "knockout"
		define(["knockout", "exports"], factory);
	} else {
		// <script> tag: use the global `ko` object, attaching a `mapping` property
		factory(ko, ko.validation = {});
	}
}(function ( ko, exports ) {

	if (typeof (ko) === 'undefined') {
		throw new Error('Knockout is required, please ensure it is loaded before loading this validation plug-in');
	}

	// create our namespace object
	ko.validation = exports;

	var kv = ko.validation,
		koUtils = ko.utils,
		unwrap = koUtils.unwrapObservable,
		forEach = koUtils.arrayForEach,
		extend = koUtils.extend;
;/*global ko: false*/

var defaults = {
	registerExtenders: true,
	messagesOnModified: true,
	errorsAsTitle: true,            // enables/disables showing of errors as title attribute of the target element.
	errorsAsTitleOnModified: false, // shows the error when hovering the input field (decorateElement must be true)
	messageTemplate: null,
	insertMessages: true,           // automatically inserts validation messages as <span></span>
	parseInputAttributes: false,    // parses the HTML5 validation attribute from a form element and adds that to the object
	writeInputAttributes: false,    // adds HTML5 input validation attributes to form elements that ko observable's are bound to
	decorateInputElement: false,         // false to keep backward compatibility
	decorateElementOnModified: true,// true to keep backward compatibility
	errorClass: null,               // single class for error message and element
	errorElementClass: 'validationElement',  // class to decorate error element
	errorMessageClass: 'validationMessage',  // class to decorate error message
	allowHtmlMessages: false,		// allows HTML in validation messages
	grouping: {
		deep: false,        //by default grouping is shallow
		observable: true,   //and using observables
		live: false		    //react to changes to observableArrays if observable === true
	},
	validate: {
		// throttle: 10
	}
};

// make a copy  so we can use 'reset' later
var configuration = extend({}, defaults);

configuration.html5Attributes = ['required', 'pattern', 'min', 'max', 'step'];
configuration.html5InputTypes = ['email', 'number', 'date'];

configuration.reset = function () {
	extend(configuration, defaults);
};

kv.configuration = configuration;
;kv.utils = (function () {
	var seedId = new Date().getTime();

	var domData = {}; //hash of data objects that we reference from dom elements
	var domDataKey = '__ko_validation__';

	return {
		isArray: function (o) {
			return o.isArray || Object.prototype.toString.call(o) === '[object Array]';
		},
		isObject: function (o) {
			return o !== null && typeof o === 'object';
		},
		isNumber: function(o) {
			return !isNaN(o);	
		},
		isObservableArray: function(instance) {
			return !!instance &&
					typeof instance["remove"] === "function" &&
					typeof instance["removeAll"] === "function" &&
					typeof instance["destroy"] === "function" &&
					typeof instance["destroyAll"] === "function" &&
					typeof instance["indexOf"] === "function" &&
					typeof instance["replace"] === "function";
		},
		values: function (o) {
			var r = [];
			for (var i in o) {
				if (o.hasOwnProperty(i)) {
					r.push(o[i]);
				}
			}
			return r;
		},
		getValue: function (o) {
			return (typeof o === 'function' ? o() : o);
		},
		hasAttribute: function (node, attr) {
			return node.getAttribute(attr) !== null;
		},
		getAttribute: function (element, attr) {
			return element.getAttribute(attr);
		},
		setAttribute: function (element, attr, value) {
			return element.setAttribute(attr, value);
		},
		isValidatable: function (o) {
			return !!(o && o.rules && o.isValid && o.isModified);
		},
		insertAfter: function (node, newNode) {
			node.parentNode.insertBefore(newNode, node.nextSibling);
		},
		newId: function () {
			return seedId += 1;
		},
		getConfigOptions: function (element) {
			var options = kv.utils.contextFor(element);

			return options || kv.configuration;
		},
		setDomData: function (node, data) {
			var key = node[domDataKey];

			if (!key) {
				node[domDataKey] = key = kv.utils.newId();
			}

			domData[key] = data;
		},
		getDomData: function (node) {
			var key = node[domDataKey];

			if (!key) {
				return undefined;
			}

			return domData[key];
		},
		contextFor: function (node) {
			switch (node.nodeType) {
				case 1:
				case 8:
					var context = kv.utils.getDomData(node);
					if (context) { return context; }
					if (node.parentNode) { return kv.utils.contextFor(node.parentNode); }
					break;
			}
			return undefined;
		},
		isEmptyVal: function (val) {
			if (val === undefined) {
				return true;
			}
			if (val === null) {
				return true;
			}
			if (val === "") {
				return true;
			}
		},
		getOriginalElementTitle: function (element) {
			var savedOriginalTitle = kv.utils.getAttribute(element, 'data-orig-title'),
				currentTitle = element.title,
				hasSavedOriginalTitle = kv.utils.hasAttribute(element, 'data-orig-title');

			return hasSavedOriginalTitle ?
				savedOriginalTitle : currentTitle;
		},
		async: function (expr) {
			if (window.setImmediate) { window.setImmediate(expr); }
			else { window.setTimeout(expr, 0); }
		},
		forEach: function (object, callback) {
			if (kv.utils.isArray(object)) {
				return forEach(object, callback);
			}
			for (var prop in object) {
				if (object.hasOwnProperty(prop)) {
					callback(object[prop], prop);
				}
			}
		}
	};
}());;var api = (function () {

	var isInitialized = 0,
		configuration = kv.configuration,
		utils = kv.utils;

	function cleanUpSubscriptions(context) {
		forEach(context.subscriptions, function (subscription) {
			subscription.dispose();
		});
		context.subscriptions = [];
	}

	function dispose(context) {
		if (context.options.deep) {
			forEach(context.flagged, function (obj) {
				delete obj.__kv_traversed;
			});
			context.flagged.length = 0;
		}

		if (!context.options.live) {
			cleanUpSubscriptions(context);
		}
	}

	function runTraversal(obj, context) {
		context.validatables = [];
		cleanUpSubscriptions(context);
		traverseGraph(obj, context);
		dispose(context);
	}

	function traverseGraph(obj, context, level) {
		var objValues = [],
			val = obj.peek ? obj.peek() : obj;

		if (obj.__kv_traversed === true) {
			return;
		}

		if (context.options.deep) {
			obj.__kv_traversed = true;
			context.flagged.push(obj);
		}

		//default level value depends on deep option.
		level = (level !== undefined ? level : context.options.deep ? 1 : -1);

		// if object is observable then add it to the list
		if (ko.isObservable(obj)) {
			// ensure it's validatable but don't extend validatedObservable because it
			// would overwrite isValid property.
			if (!obj.errors && !utils.isValidatable(obj)) {
				obj.extend({ validatable: true });
			}
			context.validatables.push(obj);

			if (context.options.live && utils.isObservableArray(obj)) {
				context.subscriptions.push(obj.subscribe(function () {
					context.graphMonitor.valueHasMutated();
				}));
			}
		}

		//get list of values either from array or object but ignore non-objects
		// and destroyed objects
		if (val && !val._destroy) {
			if (utils.isArray(val)) {
				objValues = val;
			}
			else if (utils.isObject(val)) {
				objValues = utils.values(val);
			}
		}

		//process recursively if it is deep grouping
		if (level !== 0) {
			utils.forEach(objValues, function (observable) {
				//but not falsy things and not HTML Elements
				if (observable && !observable.nodeType && (!ko.isComputed(observable) || observable.rules)) {
					traverseGraph(observable, context, level + 1);
				}
			});
		}
	}

	function collectErrors(array) {
		var errors = [];
		forEach(array, function (observable) {
			// Do not collect validatedObservable errors
			if (utils.isValidatable(observable) && !observable.isValid()) {
				// Use peek because we don't want a dependency for 'error' property because it
				// changes before 'isValid' does. (Issue #99)
				errors.push(observable.error.peek());
			}
		});
		return errors;
	}

	return {
		//Call this on startup
		//any config can be overridden with the passed in options
		init: function (options, force) {
			//done run this multiple times if we don't really want to
			if (isInitialized > 0 && !force) {
				return;
			}

			//because we will be accessing options properties it has to be an object at least
			options = options || {};
			//if specific error classes are not provided then apply generic errorClass
			//it has to be done on option so that options.errorClass can override default
			//errorElementClass and errorMessage class but not those provided in options
			options.errorElementClass = options.errorElementClass || options.errorClass || configuration.errorElementClass;
			options.errorMessageClass = options.errorMessageClass || options.errorClass || configuration.errorMessageClass;

			extend(configuration, options);

			if (configuration.registerExtenders) {
				kv.registerExtenders();
			}

			isInitialized = 1;
		},

		// resets the config back to its original state
		reset: kv.configuration.reset,

		// recursively walks a viewModel and creates an object that
		// provides validation information for the entire viewModel
		// obj -> the viewModel to walk
		// options -> {
		//	  deep: false, // if true, will walk past the first level of viewModel properties
		//	  observable: false // if true, returns a computed observable indicating if the viewModel is valid
		// }
		group: function group(obj, options) { // array of observables or viewModel
			options = extend(extend({}, configuration.grouping), options);

			var context = {
				options: options,
				graphMonitor: ko.observable(),
				flagged: [],
				subscriptions: [],
				validatables: []
			};

			var result = null;

			//if using observables then traverse structure once and add observables
			if (options.observable) {
				result = ko.computed(function () {
					context.graphMonitor(); //register dependency
					runTraversal(obj, context);
					return collectErrors(context.validatables);
				});
			}
			else { //if not using observables then every call to error() should traverse the structure
				result = function () {
					runTraversal(obj, context);
					return collectErrors(context.validatables);
				};
			}

			result.showAllMessages = function (show) { // thanks @heliosPortal
				if (show === undefined) {//default to true
					show = true;
				}

				result.forEach(function (observable) {
					if (utils.isValidatable(observable)) {
						observable.isModified(show);
					}
				});
			};

			result.isAnyMessageShown = function () {
				var invalidAndModifiedPresent;

				invalidAndModifiedPresent = !!result.find(function (observable) {
					return utils.isValidatable(observable) && !observable.isValid() && observable.isModified();
				});
				return invalidAndModifiedPresent;
			};

			result.filter = function(predicate) {
				predicate = predicate || function () { return true; };
				// ensure we have latest changes
				result();

				return koUtils.arrayFilter(context.validatables, predicate);
			};

			result.find = function(predicate) {
				predicate = predicate || function () { return true; };
				// ensure we have latest changes
				result();

				return koUtils.arrayFirst(context.validatables, predicate);
			};

			result.forEach = function(callback) {
				callback = callback || function () { };
				// ensure we have latest changes
				result();

				forEach(context.validatables, callback);
			};

			result.map = function(mapping) {
				mapping = mapping || function (item) { return item; };
				// ensure we have latest changes
				result();

				return koUtils.arrayMap(context.validatables, mapping);
			};

			/**
			 * @private You should not rely on this method being here.
			 * It's a private method and it may change in the future.
			 *
			 * @description Updates the validated object and collects errors from it.
			 */
			result._updateState = function(newValue) {
				if (!utils.isObject(newValue)) {
					throw new Error('An object is required.');
				}
				obj = newValue;
				if (options.observable) {
					context.graphMonitor.valueHasMutated();
				}
				else {
					runTraversal(newValue, context);
					return collectErrors(context.validatables);
				}
			};
			return result;
		},

		formatMessage: function (message, params, observable) {
			if (utils.isObject(params) && params.typeAttr) {
				params = params.value;
			}
			if (typeof message === 'function') {
				return message(params, observable);
			}
			var replacements = unwrap(params);
            if (replacements == null) {
                replacements = [];
            }
			if (!utils.isArray(replacements)) {
				replacements = [replacements];
			}
			return message.replace(/{(\d+)}/gi, function(match, index) {
				if (typeof replacements[index] !== 'undefined') {
					return replacements[index];
				}
				return match;
			});
		},

		// addRule:
		// This takes in a ko.observable and a Rule Context - which is just a rule name and params to supply to the validator
		// ie: kv.addRule(myObservable, {
		//		  rule: 'required',
		//		  params: true
		//	  });
		//
		addRule: function (observable, rule) {
			observable.extend({ validatable: true });

			var hasRule = !!koUtils.arrayFirst(observable.rules(), function(item) {
				return item.rule && item.rule === rule.rule;
			});

			if (!hasRule) {
				//push a Rule Context to the observables local array of Rule Contexts
				observable.rules.push(rule);
			}
			return observable;
		},

		// addAnonymousRule:
		// Anonymous Rules essentially have all the properties of a Rule, but are only specific for a certain property
		// and developers typically are wanting to add them on the fly or not register a rule with the 'kv.rules' object
		//
		// Example:
		// var test = ko.observable('something').extend{(
		//	  validation: {
		//		  validator: function(val, someOtherVal){
		//			  return true;
		//		  },
		//		  message: "Something must be really wrong!',
		//		  params: true
		//	  }
		//  )};
		addAnonymousRule: function (observable, ruleObj) {
			if (ruleObj['message'] === undefined) {
				ruleObj['message'] = 'Error';
			}

			//make sure onlyIf is honoured
			if (ruleObj.onlyIf) {
				ruleObj.condition = ruleObj.onlyIf;
			}

			//add the anonymous rule to the observable
			kv.addRule(observable, ruleObj);
		},

		addExtender: function (ruleName) {
			ko.extenders[ruleName] = function (observable, params) {
				//params can come in a few flavors
				// 1. Just the params to be passed to the validator
				// 2. An object containing the Message to be used and the Params to pass to the validator
				// 3. A condition when the validation rule to be applied
				//
				// Example:
				// var test = ko.observable(3).extend({
				//	  max: {
				//		  message: 'This special field has a Max of {0}',
				//		  params: 2,
				//		  onlyIf: function() {
				//					  return specialField.IsVisible();
				//				  }
				//	  }
				//  )};
				//
				if (params && (params.message || params.onlyIf)) { //if it has a message or condition object, then its an object literal to use
					return kv.addRule(observable, {
						rule: ruleName,
						message: params.message,
						params: utils.isEmptyVal(params.params) ? true : params.params,
						condition: params.onlyIf
					});
				} else {
					return kv.addRule(observable, {
						rule: ruleName,
						params: params
					});
				}
			};
		},

		// loops through all kv.rules and adds them as extenders to
		// ko.extenders
		registerExtenders: function () { // root extenders optional, use 'validation' extender if would cause conflicts
			if (configuration.registerExtenders) {
				for (var ruleName in kv.rules) {
					if (kv.rules.hasOwnProperty(ruleName)) {
						if (!ko.extenders[ruleName]) {
							kv.addExtender(ruleName);
						}
					}
				}
			}
		},

		//creates a span next to the @element with the specified error class
		insertValidationMessage: function (element) {
			var span = document.createElement('SPAN');
			span.className = utils.getConfigOptions(element).errorMessageClass;
			utils.insertAfter(element, span);
			return span;
		},

		// if html-5 validation attributes have been specified, this parses
		// the attributes on @element
		parseInputValidationAttributes: function (element, valueAccessor) {
			forEach(kv.configuration.html5Attributes, function (attr) {
				if (utils.hasAttribute(element, attr)) {

					var params = element.getAttribute(attr) || true;

					if (attr === 'min' || attr === 'max')
					{
						// If we're validating based on the min and max attributes, we'll
						// need to know what the 'type' attribute is set to
						var typeAttr = element.getAttribute('type');
						if (typeof typeAttr === "undefined" || !typeAttr)
						{
							// From http://www.w3.org/TR/html-markup/input:
							//   An input element with no type attribute specified represents the
							//   same thing as an input element with its type attribute set to "text".
							typeAttr = "text";
						}
						params = {typeAttr: typeAttr, value: params};
					}

					kv.addRule(valueAccessor(), {
						rule: attr,
						params: params
					});
				}
			});

			var currentType = element.getAttribute('type');
			forEach(kv.configuration.html5InputTypes, function (type) {
				if (type === currentType) {
					kv.addRule(valueAccessor(), {
						rule: (type === 'date') ? 'dateISO' : type,
						params: true
					});
				}
			});
		},

		// writes html5 validation attributes on the element passed in
		writeInputValidationAttributes: function (element, valueAccessor) {
			var observable = valueAccessor();

			if (!observable || !observable.rules) {
				return;
			}

			var contexts = observable.rules(); // observable array

			// loop through the attributes and add the information needed
			forEach(kv.configuration.html5Attributes, function (attr) {
				var ctx = koUtils.arrayFirst(contexts, function (ctx) {
					return ctx.rule && ctx.rule.toLowerCase() === attr.toLowerCase();
				});

				if (!ctx) {
					return;
				}

				// we have a rule matching a validation attribute at this point
				// so lets add it to the element along with the params
				ko.computed({
					read: function() {
						var params = ko.unwrap(ctx.params);

						// we have to do some special things for the pattern validation
						if (ctx.rule === "pattern" && params instanceof RegExp) {
							// we need the pure string representation of the RegExpr without the //gi stuff
							params = params.source;
						}

						element.setAttribute(attr, params);
					},
					disposeWhenNodeIsRemoved: element
				});
			});

			contexts = null;
		},

		//take an existing binding handler and make it cause automatic validations
		makeBindingHandlerValidatable: function (handlerName) {
			var init = ko.bindingHandlers[handlerName].init;

			ko.bindingHandlers[handlerName].init = function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {

				init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);

				return ko.bindingHandlers['validationCore'].init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
			};
		},

		// visit an objects properties and apply validation rules from a definition
		setRules: function (target, definition) {
			var setRules = function (target, definition) {
				if (!target || !definition) { return; }

				for (var prop in definition) {
					if (!definition.hasOwnProperty(prop)) { continue; }
					var ruleDefinitions = definition[prop];

					//check the target property exists and has a value
					if (!target[prop]) { continue; }
					var targetValue = target[prop],
						unwrappedTargetValue = unwrap(targetValue),
						rules = {},
						nonRules = {};

					for (var rule in ruleDefinitions) {
						if (!ruleDefinitions.hasOwnProperty(rule)) { continue; }
						if (kv.rules[rule]) {
							rules[rule] = ruleDefinitions[rule];
						} else {
							nonRules[rule] = ruleDefinitions[rule];
						}
					}

					//apply rules
					if (ko.isObservable(targetValue)) {
						targetValue.extend(rules);
					}

					//then apply child rules
					//if it's an array, apply rules to all children
					if (unwrappedTargetValue && utils.isArray(unwrappedTargetValue)) {
						for (var i = 0; i < unwrappedTargetValue.length; i++) {
							setRules(unwrappedTargetValue[i], nonRules);
						}
						//otherwise, just apply to this property
					} else {
						setRules(unwrappedTargetValue, nonRules);
					}
				}
			};
			setRules(target, definition);
		}
	};

}());

// expose api publicly
extend(ko.validation, api);
;//Validation Rules:
// You can view and override messages or rules via:
// kv.rules[ruleName]
//
// To implement a custom Rule, simply use this template:
// kv.rules['<custom rule name>'] = {
//      validator: function (val, param) {
//          <custom logic>
//          return <true or false>;
//      },
//      message: '<custom validation message>' //optionally you can also use a '{0}' to denote a placeholder that will be replaced with your 'param'
// };
//
// Example:
// kv.rules['mustEqual'] = {
//      validator: function( val, mustEqualVal ){
//          return val === mustEqualVal;
//      },
//      message: 'This field must equal {0}'
// };
//
kv.rules = {};
kv.rules['required'] = {
	validator: function (val, required) {
		var testVal;

		if (val === undefined || val === null) {
			return !required;
		}

		testVal = val;
		if (typeof (val) === 'string') {
			if (String.prototype.trim) {
				testVal = val.trim();
			}
			else {
				testVal = val.replace(/^\s+|\s+$/g, '');
			}
		}

		if (!required) {// if they passed: { required: false }, then don't require this
			return true;
		}

		return ((testVal + '').length > 0);
	},
	message: 'This field is required.'
};

function minMaxValidatorFactory(validatorName) {
    var isMaxValidation = validatorName === "max";

    return function (val, options) {
        if (kv.utils.isEmptyVal(val)) {
            return true;
        }

        var comparisonValue, type;
        if (options.typeAttr === undefined) {
            // This validator is being called from javascript rather than
            // being bound from markup
            type = "text";
            comparisonValue = options;
        } else {
            type = options.typeAttr;
            comparisonValue = options.value;
        }

        // From http://www.w3.org/TR/2012/WD-html5-20121025/common-input-element-attributes.html#attr-input-min,
        // if the value is parseable to a number, then the minimum should be numeric
        if (!isNaN(comparisonValue) && !(comparisonValue instanceof Date)) {
            type = "number";
        }

        var regex, valMatches, comparisonValueMatches;
        switch (type.toLowerCase()) {
            case "week":
                regex = /^(\d{4})-W(\d{2})$/;
                valMatches = val.match(regex);
                if (valMatches === null) {
                    throw new Error("Invalid value for " + validatorName + " attribute for week input.  Should look like " +
                        "'2000-W33' http://www.w3.org/TR/html-markup/input.week.html#input.week.attrs.min");
                }
                comparisonValueMatches = comparisonValue.match(regex);
                // If no regex matches were found, validation fails
                if (!comparisonValueMatches) {
                    return false;
                }

                if (isMaxValidation) {
                    return (valMatches[1] < comparisonValueMatches[1]) || // older year
                        // same year, older week
                        ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] <= comparisonValueMatches[2]));
                } else {
                    return (valMatches[1] > comparisonValueMatches[1]) || // newer year
                        // same year, newer week
                        ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] >= comparisonValueMatches[2]));
                }
                break;

            case "month":
                regex = /^(\d{4})-(\d{2})$/;
                valMatches = val.match(regex);
                if (valMatches === null) {
                    throw new Error("Invalid value for " + validatorName + " attribute for month input.  Should look like " +
                        "'2000-03' http://www.w3.org/TR/html-markup/input.month.html#input.month.attrs.min");
                }
                comparisonValueMatches = comparisonValue.match(regex);
                // If no regex matches were found, validation fails
                if (!comparisonValueMatches) {
                    return false;
                }

                if (isMaxValidation) {
                    return ((valMatches[1] < comparisonValueMatches[1]) || // older year
                        // same year, older month
                        ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] <= comparisonValueMatches[2])));
                } else {
                    return (valMatches[1] > comparisonValueMatches[1]) || // newer year
                        // same year, newer month
                        ((valMatches[1] === comparisonValueMatches[1]) && (valMatches[2] >= comparisonValueMatches[2]));
                }
                break;

            case "number":
            case "range":
                if (isMaxValidation) {
                    return (!isNaN(val) && parseFloat(val) <= parseFloat(comparisonValue));
                } else {
                    return (!isNaN(val) && parseFloat(val) >= parseFloat(comparisonValue));
                }
                break;

            default:
                if (isMaxValidation) {
                    return val <= comparisonValue;
                } else {
                    return val >= comparisonValue;
                }
        }
    };
}

kv.rules['min'] = {
	validator: minMaxValidatorFactory("min"),
	message: 'Please enter a value greater than or equal to {0}.'
};

kv.rules['max'] = {
	validator: minMaxValidatorFactory("max"),
	message: 'Please enter a value less than or equal to {0}.'
};

kv.rules['minLength'] = {
	validator: function (val, minLength) {
		if(kv.utils.isEmptyVal(val)) { return true; }
		var normalizedVal = kv.utils.isNumber(val) ? ('' + val) : val;
		return normalizedVal.length >= minLength;
	},
	message: 'Please enter at least {0} characters.'
};

kv.rules['maxLength'] = {
	validator: function (val, maxLength) {
		if(kv.utils.isEmptyVal(val)) { return true; }
		var normalizedVal = kv.utils.isNumber(val) ? ('' + val) : val;
		return normalizedVal.length <= maxLength;
	},
	message: 'Please enter no more than {0} characters.'
};

kv.rules['pattern'] = {
	validator: function (val, regex) {
		return kv.utils.isEmptyVal(val) || val.toString().match(regex) !== null;
	},
	message: 'Please check this value.'
};

kv.rules['step'] = {
	validator: function (val, step) {

		// in order to handle steps of .1 & .01 etc.. Modulus won't work
		// if the value is a decimal, so we have to correct for that
		if (kv.utils.isEmptyVal(val) || step === 'any') { return true; }
		var dif = (val * 100) % (step * 100);
		return Math.abs(dif) < 0.00001 || Math.abs(1 - dif) < 0.00001;
	},
	message: 'The value must increment by {0}.'
};

kv.rules['email'] = {
	validator: function (val, validate) {
		if (!validate) { return true; }

		//I think an empty email address is also a valid entry
		//if one want's to enforce entry it should be done with 'required: true'
		return kv.utils.isEmptyVal(val) || (
			// jquery validate regex - thanks Scott Gonzalez
			validate && /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(val)
		);
	},
	message: 'Please enter a proper email address.'
};

kv.rules['date'] = {
	validator: function (value, validate) {
		if (!validate) { return true; }
		return kv.utils.isEmptyVal(value) || (validate && !/Invalid|NaN/.test(new Date(value)));
	},
	message: 'Please enter a proper date.'
};

kv.rules['dateISO'] = {
	validator: function (value, validate) {
		if (!validate) { return true; }
		return kv.utils.isEmptyVal(value) || (validate && /^\d{4}[-/](?:0?[1-9]|1[012])[-/](?:0?[1-9]|[12][0-9]|3[01])$/.test(value));
	},
	message: 'Please enter a proper date.'
};

kv.rules['number'] = {
	validator: function (value, validate) {
		if (!validate) { return true; }
		return kv.utils.isEmptyVal(value) || (validate && /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value));
	},
	message: 'Please enter a number.'
};

kv.rules['digit'] = {
	validator: function (value, validate) {
		if (!validate) { return true; }
		return kv.utils.isEmptyVal(value) || (validate && /^\d+$/.test(value));
	},
	message: 'Please enter a digit.'
};

kv.rules['phoneUS'] = {
	validator: function (phoneNumber, validate) {
		if (!validate) { return true; }
		if (kv.utils.isEmptyVal(phoneNumber)) { return true; } // makes it optional, use 'required' rule if it should be required
		if (typeof (phoneNumber) !== 'string') { return false; }
		phoneNumber = phoneNumber.replace(/\s+/g, "");
		return validate && phoneNumber.length > 9 && phoneNumber.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
	},
	message: 'Please specify a valid phone number.'
};

kv.rules['equal'] = {
	validator: function (val, params) {
		var otherValue = params;
		return val === kv.utils.getValue(otherValue);
	},
	message: 'Values must equal.'
};

kv.rules['notEqual'] = {
	validator: function (val, params) {
		var otherValue = params;
		return val !== kv.utils.getValue(otherValue);
	},
	message: 'Please choose another value.'
};

//unique in collection
// options are:
//    collection: array or function returning (observable) array
//              in which the value has to be unique
//    valueAccessor: function that returns value from an object stored in collection
//              if it is null the value is compared directly
//    external: set to true when object you are validating is automatically updating collection
kv.rules['unique'] = {
	validator: function (val, options) {
		var c = kv.utils.getValue(options.collection),
			external = kv.utils.getValue(options.externalValue),
			counter = 0;

		if (!val || !c) { return true; }

		koUtils.arrayFilter(c, function (item) {
			if (val === (options.valueAccessor ? options.valueAccessor(item) : item)) { counter++; }
		});
		// if value is external even 1 same value in collection means the value is not unique
		return counter < (!!external ? 1 : 2);
	},
	message: 'Please make sure the value is unique.'
};


//now register all of these!
(function () {
	kv.registerExtenders();
}());
;// The core binding handler
// this allows us to setup any value binding that internally always
// performs the same functionality
ko.bindingHandlers['validationCore'] = (function () {

	return {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var config = kv.utils.getConfigOptions(element);
			var observable = valueAccessor();

			// parse html5 input validation attributes, optional feature
			if (config.parseInputAttributes) {
				kv.utils.async(function () { kv.parseInputValidationAttributes(element, valueAccessor); });
			}

			// if requested insert message element and apply bindings
			if (config.insertMessages && kv.utils.isValidatable(observable)) {

				// insert the <span></span>
				var validationMessageElement = kv.insertValidationMessage(element);

				// if we're told to use a template, make sure that gets rendered
				if (config.messageTemplate) {
					ko.renderTemplate(config.messageTemplate, { field: observable }, null, validationMessageElement, 'replaceNode');
				} else {
					ko.applyBindingsToNode(validationMessageElement, { validationMessage: observable });
				}
			}

			// write the html5 attributes if indicated by the config
			if (config.writeInputAttributes && kv.utils.isValidatable(observable)) {

				kv.writeInputValidationAttributes(element, valueAccessor);
			}

			// if requested, add binding to decorate element
			if (config.decorateInputElement && kv.utils.isValidatable(observable)) {
				ko.applyBindingsToNode(element, { validationElement: observable });
			}
		}
	};

}());

// override for KO's default 'value', 'checked', 'textInput' and selectedOptions bindings
kv.makeBindingHandlerValidatable("value");
kv.makeBindingHandlerValidatable("checked");
if (ko.bindingHandlers.textInput) {
	kv.makeBindingHandlerValidatable("textInput");
}
kv.makeBindingHandlerValidatable("selectedOptions");


ko.bindingHandlers['validationMessage'] = { // individual error message, if modified or post binding
	update: function (element, valueAccessor) {
		var obsv = valueAccessor(),
			config = kv.utils.getConfigOptions(element),
			val = unwrap(obsv),
			msg = null,
			isModified = false,
			isValid = false;

		if (obsv === null || typeof obsv === 'undefined') {
			throw new Error('Cannot bind validationMessage to undefined value. data-bind expression: ' +
				element.getAttribute('data-bind'));
		}

		isModified = obsv.isModified && obsv.isModified();
		isValid = obsv.isValid && obsv.isValid();

		var error = null;
		if (!config.messagesOnModified || isModified) {
			error = isValid ? null : obsv.error;
		}

		var isVisible = !config.messagesOnModified || isModified ? !isValid : false;
		var isCurrentlyVisible = element.style.display !== "none";

		if (config.allowHtmlMessages) {
			koUtils.setHtml(element, error);
		} else {
			ko.bindingHandlers.text.update(element, function () { return error; });
		}

		if (isCurrentlyVisible && !isVisible) {
			element.style.display = 'none';
		} else if (!isCurrentlyVisible && isVisible) {
			element.style.display = '';
		}
	}
};

ko.bindingHandlers['validationElement'] = {
	update: function (element, valueAccessor, allBindingsAccessor) {
		var obsv = valueAccessor(),
			config = kv.utils.getConfigOptions(element),
			val = unwrap(obsv),
			msg = null,
			isModified = false,
			isValid = false;

		if (obsv === null || typeof obsv === 'undefined') {
			throw new Error('Cannot bind validationElement to undefined value. data-bind expression: ' +
				element.getAttribute('data-bind'));
		}

		isModified = obsv.isModified && obsv.isModified();
		isValid = obsv.isValid && obsv.isValid();

		// create an evaluator function that will return something like:
		// css: { validationElement: true }
		var cssSettingsAccessor = function () {
			var css = {};

			var shouldShow = ((!config.decorateElementOnModified || isModified) ? !isValid : false);

			// css: { validationElement: false }
			css[config.errorElementClass] = shouldShow;

			return css;
		};

		//add or remove class on the element;
		ko.bindingHandlers.css.update(element, cssSettingsAccessor, allBindingsAccessor);
		if (!config.errorsAsTitle) { return; }

		ko.bindingHandlers.attr.update(element, function () {
			var
				hasModification = !config.errorsAsTitleOnModified || isModified,
				title = kv.utils.getOriginalElementTitle(element);

			if (hasModification && !isValid) {
				return { title: obsv.error, 'data-orig-title': title };
			} else if (!hasModification || isValid) {
				return { title: title, 'data-orig-title': null };
			}
		});
	}
};

// ValidationOptions:
// This binding handler allows you to override the initial config by setting any of the options for a specific element or context of elements
//
// Example:
// <div data-bind="validationOptions: { insertMessages: true, messageTemplate: 'customTemplate', errorMessageClass: 'mySpecialClass'}">
//      <input type="text" data-bind="value: someValue"/>
//      <input type="text" data-bind="value: someValue2"/>
// </div>
ko.bindingHandlers['validationOptions'] = (function () {
	return {
		init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var options = unwrap(valueAccessor());
			if (options) {
				var newConfig = extend({}, kv.configuration);
				extend(newConfig, options);

				//store the validation options on the node so we can retrieve it later
				kv.utils.setDomData(element, newConfig);
			}
		}
	};
}());
;// Validation Extender:
// This is for creating custom validation logic on the fly
// Example:
// var test = ko.observable('something').extend{(
//      validation: {
//          validator: function(val, someOtherVal){
//              return true;
//          },
//          message: "Something must be really wrong!',
//          params: true
//      }
//  )};
ko.extenders['validation'] = function (observable, rules) { // allow single rule or array
	forEach(kv.utils.isArray(rules) ? rules : [rules], function (rule) {
		// the 'rule' being passed in here has no name to identify a core Rule,
		// so we add it as an anonymous rule
		// If the developer is wanting to use a core Rule, but use a different message see the 'addExtender' logic for examples
		kv.addAnonymousRule(observable, rule);
	});
	return observable;
};

//This is the extender that makes a Knockout Observable also 'Validatable'
//examples include:
// 1. var test = ko.observable('something').extend({validatable: true});
// this will ensure that the Observable object is setup properly to respond to rules
//
// 2. test.extend({validatable: false});
// this will remove the validation properties from the Observable object should you need to do that.
ko.extenders['validatable'] = function (observable, options) {
	if (!kv.utils.isObject(options)) {
		options = { enable: options };
	}

	if (!('enable' in options)) {
		options.enable = true;
	}

	if (options.enable && !kv.utils.isValidatable(observable)) {
		var config = kv.configuration.validate || {};
		var validationOptions = {
			throttleEvaluation : options.throttle || config.throttle
		};

		observable.error = ko.observable(null); // holds the error message, we only need one since we stop processing validators when one is invalid

		// observable.rules:
		// ObservableArray of Rule Contexts, where a Rule Context is simply the name of a rule and the params to supply to it
		//
		// Rule Context = { rule: '<rule name>', params: '<passed in params>', message: '<Override of default Message>' }
		observable.rules = ko.observableArray(); //holds the rule Contexts to use as part of validation

		//in case async validation is occurring
		observable.isValidating = ko.observable(false);

		//the true holder of whether the observable is valid or not
		observable.__valid__ = ko.observable(true);

		observable.isModified = ko.observable(false);

		// a semi-protected observable
		observable.isValid = ko.computed(observable.__valid__);

		//manually set error state
		observable.setError = function (error) {
			var previousError = observable.error.peek();
			var previousIsValid = observable.__valid__.peek();

			observable.error(error);
			observable.__valid__(false);

			if (previousError !== error && !previousIsValid) {
				// if the observable was not valid before then isValid will not mutate,
				// hence causing any grouping to not display the latest error.
				observable.isValid.notifySubscribers();
			}
		};

		//manually clear error state
		observable.clearError = function () {
			observable.error(null);
			observable.__valid__(true);
			return observable;
		};

		//subscribe to changes in the observable
		var h_change = observable.subscribe(function () {
			observable.isModified(true);
		});

		// we use a computed here to ensure that anytime a dependency changes, the
		// validation logic evaluates
		var h_obsValidationTrigger = ko.computed(extend({
			read: function () {
				var obs = observable(),
					ruleContexts = observable.rules();

				kv.validateObservable(observable);

				return true;
			}
		}, validationOptions));

		extend(h_obsValidationTrigger, validationOptions);

		observable._disposeValidation = function () {
			//first dispose of the subscriptions
			observable.isValid.dispose();
			observable.rules.removeAll();
			h_change.dispose();
			h_obsValidationTrigger.dispose();

			delete observable['rules'];
			delete observable['error'];
			delete observable['isValid'];
			delete observable['isValidating'];
			delete observable['__valid__'];
			delete observable['isModified'];
            delete observable['setError'];
            delete observable['clearError'];
            delete observable['_disposeValidation'];
		};
	} else if (options.enable === false && observable._disposeValidation) {
		observable._disposeValidation();
	}
	return observable;
};

function validateSync(observable, rule, ctx) {
	//Execute the validator and see if its valid
	if (!rule.validator(observable(), (ctx.params === undefined ? true : unwrap(ctx.params)))) { // default param is true, eg. required = true

		//not valid, so format the error message and stick it in the 'error' variable
		observable.setError(kv.formatMessage(
					ctx.message || rule.message,
					unwrap(ctx.params),
					observable));
		return false;
	} else {
		return true;
	}
}

function validateAsync(observable, rule, ctx) {
	observable.isValidating(true);

	var callBack = function (valObj) {
		var isValid = false,
			msg = '';

		if (!observable.__valid__()) {

			// since we're returning early, make sure we turn this off
			observable.isValidating(false);

			return; //if its already NOT valid, don't add to that
		}

		//we were handed back a complex object
		if (valObj['message']) {
			isValid = valObj.isValid;
			msg = valObj.message;
		} else {
			isValid = valObj;
		}

		if (!isValid) {
			//not valid, so format the error message and stick it in the 'error' variable
			observable.error(kv.formatMessage(
				msg || ctx.message || rule.message,
				unwrap(ctx.params),
				observable));
			observable.__valid__(isValid);
		}

		// tell it that we're done
		observable.isValidating(false);
	};

	kv.utils.async(function() {
	    //fire the validator and hand it the callback
        rule.validator(observable(), ctx.params === undefined ? true : unwrap(ctx.params), callBack);
	});
}

kv.validateObservable = function (observable) {
	var i = 0,
		rule, // the rule validator to execute
		ctx, // the current Rule Context for the loop
		ruleContexts = observable.rules(), //cache for iterator
		len = ruleContexts.length; //cache for iterator

	for (; i < len; i++) {

		//get the Rule Context info to give to the core Rule
		ctx = ruleContexts[i];

		// checks an 'onlyIf' condition
		if (ctx.condition && !ctx.condition()) {
			continue;
		}

		//get the core Rule to use for validation
		rule = ctx.rule ? kv.rules[ctx.rule] : ctx;

		if (rule['async'] || ctx['async']) {
			//run async validation
			validateAsync(observable, rule, ctx);

		} else {
			//run normal sync validation
			if (!validateSync(observable, rule, ctx)) {
				return false; //break out of the loop
			}
		}
	}
	//finally if we got this far, make the observable valid again!
	observable.clearError();
	return true;
};
;
var _locales = {};
var _currentLocale;

kv.defineLocale = function(name, values) {
	if (name && values) {
		_locales[name.toLowerCase()] = values;
		return values;
	}
	return null;
};

kv.locale = function(name) {
	if (name) {
		name = name.toLowerCase();

		if (_locales.hasOwnProperty(name)) {
			kv.localize(_locales[name]);
			_currentLocale = name;
		}
		else {
			throw new Error('Localization ' + name + ' has not been loaded.');
		}
	}
	return _currentLocale;
};

//quick function to override rule messages
kv.localize = function (msgTranslations) {
	var rules = kv.rules;

	//loop the properties in the object and assign the msg to the rule
	for (var ruleName in msgTranslations) {
		if (rules.hasOwnProperty(ruleName)) {
			rules[ruleName].message = msgTranslations[ruleName];
		}
	}
};

// Populate default locale (this will make en-US.js somewhat redundant)
(function() {
	var localeData = {};
	var rules = kv.rules;

	for (var ruleName in rules) {
		if (rules.hasOwnProperty(ruleName)) {
			localeData[ruleName] = rules[ruleName].message;
		}
	}
	kv.defineLocale('en-us', localeData);
})();

// No need to invoke locale because the messages are already defined along with the rules for en-US
_currentLocale = 'en-us';
;/**
 * Possible invocations:
 * 		applyBindingsWithValidation(viewModel)
 * 		applyBindingsWithValidation(viewModel, options)
 * 		applyBindingsWithValidation(viewModel, rootNode)
 *		applyBindingsWithValidation(viewModel, rootNode, options)
 */
ko.applyBindingsWithValidation = function (viewModel, rootNode, options) {
	var node = document.body,
		config;

	if (rootNode && rootNode.nodeType) {
		node = rootNode;
		config = options;
	}
	else {
		config = rootNode;
	}

	kv.init();

	if (config) {
		config = extend(extend({}, kv.configuration), config);
		kv.utils.setDomData(node, config);
	}

	ko.applyBindings(viewModel, node);
};

//override the original applyBindings so that we can ensure all new rules and what not are correctly registered
var origApplyBindings = ko.applyBindings;
ko.applyBindings = function (viewModel, rootNode) {

	kv.init();

	origApplyBindings(viewModel, rootNode);
};

ko.validatedObservable = function (initialValue, options) {
	if (!options && !kv.utils.isObject(initialValue)) {
		return ko.observable(initialValue).extend({ validatable: true });
	}

	var obsv = ko.observable(initialValue);
	obsv.errors = kv.group(kv.utils.isObject(initialValue) ? initialValue : {}, options);
	obsv.isValid = ko.observable(obsv.errors().length === 0);

	if (ko.isObservable(obsv.errors)) {
		obsv.errors.subscribe(function(errors) {
			obsv.isValid(errors.length === 0);
		});
	}
	else {
		ko.computed(obsv.errors).subscribe(function (errors) {
			obsv.isValid(errors.length === 0);
		});
	}

	obsv.subscribe(function(newValue) {
		if (!kv.utils.isObject(newValue)) {
			/*
			 * The validation group works on objects.
			 * Since the new value is a primitive (scalar, null or undefined) we need
			 * to create an empty object to pass along.
			 */
			newValue = {};
		}
		// Force the group to refresh
		obsv.errors._updateState(newValue);
		obsv.isValid(obsv.errors().length === 0);
	});

	return obsv;
};
;}));
/**
 * Localization file for Italian - Italy (it-IT)
 */
(function(factory) {
	// Module systems magic dance.
	/*global require,ko.validation,define,module*/
	if (typeof require === 'function' && typeof exports === 'object' && typeof module === 'object') {
		// CommonJS or Node
        module.exports = factory(require('../'));
	} else if (typeof define === 'function' && define['amd']) {
		// AMD anonymous module
		define(['knockout.validation'], factory);
	} else {
		// <script> tag: use the global `ko.validation` object
		factory(ko.validation);
	}
}(function(kv) {
	if (!kv || typeof kv.defineLocale !== 'function') {
		throw new Error('Knockout-Validation is required, please ensure it is loaded before this localization file');
	}
	return kv.defineLocale('it-IT', {
		required: 'Il campo è obbligatorio.',
		min: 'Inserire un valore superiore o uguale a {0}.',
		max: 'Inserire un valore inferiore o uguale a {0}.',
		minLength: 'Inserire almeno {0} caratteri.',
		maxLength: 'Inserire al massimo {0} caratteri.',
		pattern: 'Controllare il valore inserito.',
		step: 'Il valore deve essere incrementato di {0}.',
		email: 'Indirizzo email non valido.',
		date: 'Inserire una data valida.',
		dateISO: 'Inserire una data valida.',
		number: 'Inserire un valore numerico.',
		digit: 'Inserire una cifra.',
		phoneUS: 'Specificare un numero di telefono valido.',
		equal: 'I valori devono essere uguali.',
		notEqual: 'Il valore deve essere differente.',
		unique: 'Il valore deve essere univoco.'
	});
}));
/**
 * Localization file for Spanish - Spain (es-ES)
 */
(function(factory) {
	// Module systems magic dance.
	/*global require,ko.validation,define,module*/
	if (typeof require === 'function' && typeof exports === 'object' && typeof module === 'object') {
		// CommonJS or Node
        module.exports = factory(require('../'));
	} else if (typeof define === 'function' && define['amd']) {
		// AMD anonymous module
		define(['knockout.validation'], factory);
	} else {
		// <script> tag: use the global `ko.validation` object
		factory(ko.validation);
	}
}(function(kv) {
	if (!kv || typeof kv.defineLocale !== 'function') {
		throw new Error('Knockout-Validation is required, please ensure it is loaded before this localization file');
	}
	return kv.defineLocale('es-ES', {
		required: 'Este campo es obligatorio',
		min: 'Por favor, introduzca un valor igual o mayor a {0}',
		max: 'Por favor, introduzca un valor menor o igual a {0}',
		minLength: 'Por favor, introduzca al menos {0} caracteres',
		maxLength: 'Por favor, no introduzca más de {0} caracteres',
		pattern: 'Por favor, compruebe este campo',
		step: 'El valor debe incrementarse por {0}',
		email: 'Este no es una dirección de email correcta',
		date: 'Por favor, introduzca una fecha correcta',
		dateISO: 'Por favor, introduzca una fecha correcta',
		number: 'Por favor, introduzca un número',
		digit: 'Por favor, introduzca un dígito',
		phoneUS: 'Por favor, introduzca un número de teléfono válido para EEUU',
		equal: 'Los valores deben ser iguales',
		notEqual: 'Por favor, elija otro valor',
		unique: 'Por favor, asegurese de que el valor sea único'
	});
}));
/**
 * Localization file for French - France (fr-FR)
 */
(function(factory) {
	// Module systems magic dance.
	/*global require,ko.validation,define,module*/
	if (typeof require === 'function' && typeof exports === 'object' && typeof module === 'object') {
		// CommonJS or Node
        module.exports = factory(require('../'));
	} else if (typeof define === 'function' && define['amd']) {
		// AMD anonymous module
		define(['knockout.validation'], factory);
	} else {
		// <script> tag: use the global `ko.validation` object
		factory(ko.validation);
	}
}(function(kv) {
	if (!kv || typeof kv.defineLocale !== 'function') {
		throw new Error('Knockout-Validation is required, please ensure it is loaded before this localization file');
	}
	return kv.defineLocale('fr-FR', {
		required: 'Ce champ est obligatoire.',
		min: 'Veuillez saisir une valeur supérieure ou égale à {0}.',
		max: 'Veuillez saisir une valeur inférieure ou égale à {0}.',
		minLength: 'Veuillez saisir au moins {0} caractères.',
		maxLength: 'Veuillez saisir au plus {0} caractères.',
		pattern: 'Veuillez corriger ce champ.',
		step: 'Le pas d\'incrémentation de la valeur doit être de {0}.',
		email: 'Ceci n\'est pas une adresse électronique valide.',
		date: 'Veuillez saisir une date valide.',
		dateISO: 'Veuillez saisir une date (ISO) valide.',
		number: 'Veuillez saisir un nombre.',
		digit: 'Veuillez saisir un chiffre.',
		phoneUS: 'Veuillez saisir un numéro de téléphone valide.',
		equal: 'Les valeurs doivent être égales.',
		notEqual: 'Veuillez saisir une autre valeur.',
		unique: 'Veuillez vérifier que la valeur est unique.'
	});
}));
/*!
 * Datepicker for Bootstrap v1.6.1 (https://github.com/eternicode/bootstrap-datepicker)
 *
 * Copyright 2012 Stefan Petre
 * Improvements by Andrew Rowls
 * Licensed under the Apache License v2.0 (http://www.apache.org/licenses/LICENSE-2.0)
 */(function(factory){
    if (typeof define === "function" && define.amd) {
        define(["jquery"], factory);
    } else if (typeof exports === 'object') {
        factory(require('jquery'));
    } else {
        factory(jQuery);
    }
}(function($, undefined){

	function UTCDate(){
		return new Date(Date.UTC.apply(Date, arguments));
	}
	function UTCToday(){
		var today = new Date();
		return UTCDate(today.getFullYear(), today.getMonth(), today.getDate());
	}
	function isUTCEquals(date1, date2) {
		return (
			date1.getUTCFullYear() === date2.getUTCFullYear() &&
			date1.getUTCMonth() === date2.getUTCMonth() &&
			date1.getUTCDate() === date2.getUTCDate()
		);
	}
	function alias(method){
		return function(){
			return this[method].apply(this, arguments);
		};
	}
	function isValidDate(d) {
		return d && !isNaN(d.getTime());
	}

	var DateArray = (function(){
		var extras = {
			get: function(i){
				return this.slice(i)[0];
			},
			contains: function(d){
				// Array.indexOf is not cross-browser;
				// $.inArray doesn't work with Dates
				var val = d && d.valueOf();
				for (var i=0, l=this.length; i < l; i++)
					if (this[i].valueOf() === val)
						return i;
				return -1;
			},
			remove: function(i){
				this.splice(i,1);
			},
			replace: function(new_array){
				if (!new_array)
					return;
				if (!$.isArray(new_array))
					new_array = [new_array];
				this.clear();
				this.push.apply(this, new_array);
			},
			clear: function(){
				this.length = 0;
			},
			copy: function(){
				var a = new DateArray();
				a.replace(this);
				return a;
			}
		};

		return function(){
			var a = [];
			a.push.apply(a, arguments);
			$.extend(a, extras);
			return a;
		};
	})();


	// Picker object

	var Datepicker = function(element, options){
		$(element).data('datepicker', this);
		this._process_options(options);

		this.dates = new DateArray();
		this.viewDate = this.o.defaultViewDate;
		this.focusDate = null;

		this.element = $(element);
		this.isInput = this.element.is('input');
		this.inputField = this.isInput ? this.element : this.element.find('input');
		this.component = this.element.hasClass('date') ? this.element.find('.add-on, .input-group-addon, .btn') : false;
		this.hasInput = this.component && this.inputField.length;
		if (this.component && this.component.length === 0)
			this.component = false;
		this.isInline = !this.component && this.element.is('div');

		this.picker = $(DPGlobal.template);

		// Checking templates and inserting
		if (this._check_template(this.o.templates.leftArrow)) {
			this.picker.find('.prev').html(this.o.templates.leftArrow);
		}
		if (this._check_template(this.o.templates.rightArrow)) {
			this.picker.find('.next').html(this.o.templates.rightArrow);
		}

		this._buildEvents();
		this._attachEvents();

		if (this.isInline){
			this.picker.addClass('datepicker-inline').appendTo(this.element);
		}
		else {
			this.picker.addClass('datepicker-dropdown dropdown-menu');
		}

		if (this.o.rtl){
			this.picker.addClass('datepicker-rtl');
		}

		this.viewMode = this.o.startView;

		if (this.o.calendarWeeks)
			this.picker.find('thead .datepicker-title, tfoot .today, tfoot .clear')
						.attr('colspan', function(i, val){
							return parseInt(val) + 1;
						});

		this._allow_update = false;

		this.setStartDate(this._o.startDate);
		this.setEndDate(this._o.endDate);
		this.setDaysOfWeekDisabled(this.o.daysOfWeekDisabled);
		this.setDaysOfWeekHighlighted(this.o.daysOfWeekHighlighted);
		this.setDatesDisabled(this.o.datesDisabled);

		this.fillDow();
		this.fillMonths();

		this._allow_update = true;

		this.update();
		this.showMode();

		if (this.isInline){
			this.show();
		}
	};

	Datepicker.prototype = {
		constructor: Datepicker,

		_resolveViewName: function(view, default_value){
			if (view === 0 || view === 'days' || view === 'month') {
				return 0;
			}
			if (view === 1 || view === 'months' || view === 'year') {
				return 1;
			}
			if (view === 2 || view === 'years' || view === 'decade') {
				return 2;
			}
			if (view === 3 || view === 'decades' || view === 'century') {
				return 3;
			}
			if (view === 4 || view === 'centuries' || view === 'millennium') {
				return 4;
			}
			return default_value === undefined ? false : default_value;
		},

		_check_template: function(tmp){
			try {
				// If empty
				if (tmp === undefined || tmp === "") {
					return false;
				}
				// If no html, everything ok
				if ((tmp.match(/[<>]/g) || []).length <= 0) {
					return true;
				}
				// Checking if html is fine
				var jDom = $(tmp);
				return jDom.length > 0;
			}
			catch (ex) {
				return false;
			}
		},

		_process_options: function(opts){
			// Store raw options for reference
			this._o = $.extend({}, this._o, opts);
			// Processed options
			var o = this.o = $.extend({}, this._o);

			// Check if "de-DE" style date is available, if not language should
			// fallback to 2 letter code eg "de"
			var lang = o.language;
			if (!dates[lang]){
				lang = lang.split('-')[0];
				if (!dates[lang])
					lang = defaults.language;
			}
			o.language = lang;

			// Retrieve view index from any aliases
			o.startView = this._resolveViewName(o.startView, 0);
			o.minViewMode = this._resolveViewName(o.minViewMode, 0);
			o.maxViewMode = this._resolveViewName(o.maxViewMode, 4);

			// Check that the start view is between min and max
			o.startView = Math.min(o.startView, o.maxViewMode);
			o.startView = Math.max(o.startView, o.minViewMode);

			// true, false, or Number > 0
			if (o.multidate !== true){
				o.multidate = Number(o.multidate) || false;
				if (o.multidate !== false)
					o.multidate = Math.max(0, o.multidate);
			}
			o.multidateSeparator = String(o.multidateSeparator);

			o.weekStart %= 7;
			o.weekEnd = (o.weekStart + 6) % 7;

			var format = DPGlobal.parseFormat(o.format);
			if (o.startDate !== -Infinity){
				if (!!o.startDate){
					if (o.startDate instanceof Date)
						o.startDate = this._local_to_utc(this._zero_time(o.startDate));
					else
						o.startDate = DPGlobal.parseDate(o.startDate, format, o.language, o.assumeNearbyYear);
				}
				else {
					o.startDate = -Infinity;
				}
			}
			if (o.endDate !== Infinity){
				if (!!o.endDate){
					if (o.endDate instanceof Date)
						o.endDate = this._local_to_utc(this._zero_time(o.endDate));
					else
						o.endDate = DPGlobal.parseDate(o.endDate, format, o.language, o.assumeNearbyYear);
				}
				else {
					o.endDate = Infinity;
				}
			}

			o.daysOfWeekDisabled = o.daysOfWeekDisabled||[];
			if (!$.isArray(o.daysOfWeekDisabled))
				o.daysOfWeekDisabled = o.daysOfWeekDisabled.split(/[,\s]*/);
			o.daysOfWeekDisabled = $.map(o.daysOfWeekDisabled, function(d){
				return parseInt(d, 10);
			});

			o.daysOfWeekHighlighted = o.daysOfWeekHighlighted||[];
			if (!$.isArray(o.daysOfWeekHighlighted))
				o.daysOfWeekHighlighted = o.daysOfWeekHighlighted.split(/[,\s]*/);
			o.daysOfWeekHighlighted = $.map(o.daysOfWeekHighlighted, function(d){
				return parseInt(d, 10);
			});

			o.datesDisabled = o.datesDisabled||[];
			if (!$.isArray(o.datesDisabled)) {
				o.datesDisabled = [
					o.datesDisabled
				];
			}
			o.datesDisabled = $.map(o.datesDisabled,function(d){
				return DPGlobal.parseDate(d, format, o.language, o.assumeNearbyYear);
			});

			var plc = String(o.orientation).toLowerCase().split(/\s+/g),
				_plc = o.orientation.toLowerCase();
			plc = $.grep(plc, function(word){
				return /^auto|left|right|top|bottom$/.test(word);
			});
			o.orientation = {x: 'auto', y: 'auto'};
			if (!_plc || _plc === 'auto')
				; // no action
			else if (plc.length === 1){
				switch (plc[0]){
					case 'top':
					case 'bottom':
						o.orientation.y = plc[0];
						break;
					case 'left':
					case 'right':
						o.orientation.x = plc[0];
						break;
				}
			}
			else {
				_plc = $.grep(plc, function(word){
					return /^left|right$/.test(word);
				});
				o.orientation.x = _plc[0] || 'auto';

				_plc = $.grep(plc, function(word){
					return /^top|bottom$/.test(word);
				});
				o.orientation.y = _plc[0] || 'auto';
			}
			if (o.defaultViewDate) {
				var year = o.defaultViewDate.year || new Date().getFullYear();
				var month = o.defaultViewDate.month || 0;
				var day = o.defaultViewDate.day || 1;
				o.defaultViewDate = UTCDate(year, month, day);
			} else {
				o.defaultViewDate = UTCToday();
			}
		},
		_events: [],
		_secondaryEvents: [],
		_applyEvents: function(evs){
			for (var i=0, el, ch, ev; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				}
				else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.on(ev, ch);
			}
		},
		_unapplyEvents: function(evs){
			for (var i=0, el, ev, ch; i < evs.length; i++){
				el = evs[i][0];
				if (evs[i].length === 2){
					ch = undefined;
					ev = evs[i][1];
				}
				else if (evs[i].length === 3){
					ch = evs[i][1];
					ev = evs[i][2];
				}
				el.off(ev, ch);
			}
		},
		_buildEvents: function(){
            var events = {
                keyup: $.proxy(function(e){
                    if ($.inArray(e.keyCode, [27, 37, 39, 38, 40, 32, 13, 9]) === -1)
                        this.update();
                }, this),
                keydown: $.proxy(this.keydown, this),
                paste: $.proxy(this.paste, this)
            };

            if (this.o.showOnFocus === true) {
                events.focus = $.proxy(this.show, this);
            }

            if (this.isInput) { // single input
                this._events = [
                    [this.element, events]
                ];
            }
            else if (this.component && this.hasInput) { // component: input + button
                this._events = [
                    // For components that are not readonly, allow keyboard nav
                    [this.inputField, events],
                    [this.component, {
                        click: $.proxy(this.show, this)
                    }]
                ];
            }
			else {
				this._events = [
					[this.element, {
						click: $.proxy(this.show, this),
						keydown: $.proxy(this.keydown, this)
					}]
				];
			}
			this._events.push(
				// Component: listen for blur on element descendants
				[this.element, '*', {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}],
				// Input: listen for blur on element
				[this.element, {
					blur: $.proxy(function(e){
						this._focused_from = e.target;
					}, this)
				}]
			);

			if (this.o.immediateUpdates) {
				// Trigger input updates immediately on changed year/month
				this._events.push([this.element, {
					'changeYear changeMonth': $.proxy(function(e){
						this.update(e.date);
					}, this)
				}]);
			}

			this._secondaryEvents = [
				[this.picker, {
					click: $.proxy(this.click, this)
				}],
				[$(window), {
					resize: $.proxy(this.place, this)
				}],
				[$(document), {
					mousedown: $.proxy(function(e){
						// Clicked outside the datepicker, hide it
						if (!(
							this.element.is(e.target) ||
							this.element.find(e.target).length ||
							this.picker.is(e.target) ||
							this.picker.find(e.target).length ||
							this.isInline
						)){
							this.hide();
						}
					}, this)
				}]
			];
		},
		_attachEvents: function(){
			this._detachEvents();
			this._applyEvents(this._events);
		},
		_detachEvents: function(){
			this._unapplyEvents(this._events);
		},
		_attachSecondaryEvents: function(){
			this._detachSecondaryEvents();
			this._applyEvents(this._secondaryEvents);
		},
		_detachSecondaryEvents: function(){
			this._unapplyEvents(this._secondaryEvents);
		},
		_trigger: function(event, altdate){
			var date = altdate || this.dates.get(-1),
				local_date = this._utc_to_local(date);

			this.element.trigger({
				type: event,
				date: local_date,
				dates: $.map(this.dates, this._utc_to_local),
				format: $.proxy(function(ix, format){
					if (arguments.length === 0){
						ix = this.dates.length - 1;
						format = this.o.format;
					}
					else if (typeof ix === 'string'){
						format = ix;
						ix = this.dates.length - 1;
					}
					format = format || this.o.format;
					var date = this.dates.get(ix);
					return DPGlobal.formatDate(date, format, this.o.language);
				}, this)
			});
		},

		show: function(){
			if (this.inputField.prop('disabled') || (this.inputField.prop('readonly') && this.o.enableOnReadonly === false))
				return;
			if (!this.isInline)
				this.picker.appendTo(this.o.container);
			this.place();
			this.picker.show();
			this._attachSecondaryEvents();
			this._trigger('show');
			if ((window.navigator.msMaxTouchPoints || 'ontouchstart' in document) && this.o.disableTouchKeyboard) {
				$(this.element).blur();
			}
			return this;
		},

		hide: function(){
			if (this.isInline || !this.picker.is(':visible'))
				return this;
			this.focusDate = null;
			this.picker.hide().detach();
			this._detachSecondaryEvents();
			this.viewMode = this.o.startView;
			this.showMode();

			if (this.o.forceParse && this.inputField.val())
				this.setValue();
			this._trigger('hide');
			return this;
		},

		destroy: function(){
			this.hide();
			this._detachEvents();
			this._detachSecondaryEvents();
			this.picker.remove();
			delete this.element.data().datepicker;
			if (!this.isInput){
				delete this.element.data().date;
			}
			return this;
		},

		paste: function(evt){
			var dateString;
			if (evt.originalEvent.clipboardData && evt.originalEvent.clipboardData.types
				&& $.inArray('text/plain', evt.originalEvent.clipboardData.types) !== -1) {
				dateString = evt.originalEvent.clipboardData.getData('text/plain');
			}
			else if (window.clipboardData) {
				dateString = window.clipboardData.getData('Text');
			}
			else {
				return;
			}
			this.setDate(dateString);
			this.update();
			evt.preventDefault();
		},

		_utc_to_local: function(utc){
			return utc && new Date(utc.getTime() + (utc.getTimezoneOffset()*60000));
		},
		_local_to_utc: function(local){
			return local && new Date(local.getTime() - (local.getTimezoneOffset()*60000));
		},
		_zero_time: function(local){
			return local && new Date(local.getFullYear(), local.getMonth(), local.getDate());
		},
		_zero_utc_time: function(utc){
			return utc && new Date(Date.UTC(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate()));
		},

		getDates: function(){
			return $.map(this.dates, this._utc_to_local);
		},

		getUTCDates: function(){
			return $.map(this.dates, function(d){
				return new Date(d);
			});
		},

		getDate: function(){
			return this._utc_to_local(this.getUTCDate());
		},

		getUTCDate: function(){
			var selected_date = this.dates.get(-1);
			if (typeof selected_date !== 'undefined') {
				return new Date(selected_date);
			} else {
				return null;
			}
		},

		clearDates: function(){
			if (this.inputField) {
				this.inputField.val('');
			}

			this.update();
			this._trigger('changeDate');

			if (this.o.autoclose) {
				this.hide();
			}
		},
		setDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, args);
			this._trigger('changeDate');
			this.setValue();
			return this;
		},

		setUTCDates: function(){
			var args = $.isArray(arguments[0]) ? arguments[0] : arguments;
			this.update.apply(this, $.map(args, this._utc_to_local));
			this._trigger('changeDate');
			this.setValue();
			return this;
		},

		setDate: alias('setDates'),
		setUTCDate: alias('setUTCDates'),
		remove: alias('destroy'),

		setValue: function(){
			var formatted = this.getFormattedDate();
			this.inputField.val(formatted);
			return this;
		},

		getFormattedDate: function(format){
			if (format === undefined)
				format = this.o.format;

			var lang = this.o.language;
			return $.map(this.dates, function(d){
				return DPGlobal.formatDate(d, format, lang);
			}).join(this.o.multidateSeparator);
		},

		getStartDate: function(){
			return this.o.startDate;
		},

		setStartDate: function(startDate){
			this._process_options({startDate: startDate});
			this.update();
			this.updateNavArrows();
			return this;
		},

		getEndDate: function(){
			return this.o.endDate;
		},

		setEndDate: function(endDate){
			this._process_options({endDate: endDate});
			this.update();
			this.updateNavArrows();
			return this;
		},

		setDaysOfWeekDisabled: function(daysOfWeekDisabled){
			this._process_options({daysOfWeekDisabled: daysOfWeekDisabled});
			this.update();
			this.updateNavArrows();
			return this;
		},

		setDaysOfWeekHighlighted: function(daysOfWeekHighlighted){
			this._process_options({daysOfWeekHighlighted: daysOfWeekHighlighted});
			this.update();
			return this;
		},

		setDatesDisabled: function(datesDisabled){
			this._process_options({datesDisabled: datesDisabled});
			this.update();
			this.updateNavArrows();
		},

		place: function(){
			if (this.isInline)
				return this;
			var calendarWidth = this.picker.outerWidth(),
				calendarHeight = this.picker.outerHeight(),
				visualPadding = 10,
				container = $(this.o.container),
				windowWidth = container.width(),
				scrollTop = this.o.container === 'body' ? $(document).scrollTop() : container.scrollTop(),
				appendOffset = container.offset();

			var parentsZindex = [];
			this.element.parents().each(function(){
				var itemZIndex = $(this).css('z-index');
				if (itemZIndex !== 'auto' && itemZIndex !== 0) parentsZindex.push(parseInt(99999));
			});
			var zIndex = Math.max.apply(Math, parentsZindex) + this.o.zIndexOffset;
			var offset = this.component ? this.component.parent().offset() : this.element.offset();
			var height = this.component ? this.component.outerHeight(true) : this.element.outerHeight(false);
			var width = this.component ? this.component.outerWidth(true) : this.element.outerWidth(false);
			var left = offset.left - appendOffset.left,
				top = offset.top - appendOffset.top;

			if (this.o.container !== 'body') {
				top += scrollTop;
			}

			this.picker.removeClass(
				'datepicker-orient-top datepicker-orient-bottom '+
				'datepicker-orient-right datepicker-orient-left'
			);

			if (this.o.orientation.x !== 'auto'){
				this.picker.addClass('datepicker-orient-' + this.o.orientation.x);
				if (this.o.orientation.x === 'right')
					left -= calendarWidth - width;
			}
			// auto x orientation is best-placement: if it crosses a window
			// edge, fudge it sideways
			else {
				if (offset.left < 0) {
					// component is outside the window on the left side. Move it into visible range
					this.picker.addClass('datepicker-orient-left');
					left -= offset.left - visualPadding;
				} else if (left + calendarWidth > windowWidth) {
					// the calendar passes the widow right edge. Align it to component right side
					this.picker.addClass('datepicker-orient-right');
					left += width - calendarWidth;
				} else {
					// Default to left
					this.picker.addClass('datepicker-orient-left');
				}
			}

			// auto y orientation is best-situation: top or bottom, no fudging,
			// decision based on which shows more of the calendar
			var yorient = this.o.orientation.y,
				top_overflow;
			if (yorient === 'auto'){
				top_overflow = -scrollTop + top - calendarHeight;
				yorient = top_overflow < 0 ? 'bottom' : 'top';
			}

			this.picker.addClass('datepicker-orient-' + yorient);
			if (yorient === 'top')
				top -= calendarHeight + parseInt(this.picker.css('padding-top'));
			else
				top += height;

			if (this.o.rtl) {
				var right = windowWidth - (left + width);
				this.picker.css({
					top: top,
					right: right,
					zIndex: zIndex
				});
			} else {
				this.picker.css({
					top: top,
					left: left,
					zIndex: zIndex
				});
			}
			return this;
		},

		_allow_update: true,
		update: function(){
			if (!this._allow_update)
				return this;

			var oldDates = this.dates.copy(),
				dates = [],
				fromArgs = false;
			if (arguments.length){
				$.each(arguments, $.proxy(function(i, date){
					if (date instanceof Date)
						date = this._local_to_utc(date);
					dates.push(date);
				}, this));
				fromArgs = true;
			}
			else {
				dates = this.isInput
						? this.element.val()
						: this.element.data('date') || this.inputField.val();
				if (dates && this.o.multidate)
					dates = dates.split(this.o.multidateSeparator);
				else
					dates = [dates];
				delete this.element.data().date;
			}

			dates = $.map(dates, $.proxy(function(date){
				return DPGlobal.parseDate(date, this.o.format, this.o.language, this.o.assumeNearbyYear);
			}, this));
			dates = $.grep(dates, $.proxy(function(date){
				return (
					!this.dateWithinRange(date) ||
					!date
				);
			}, this), true);
			this.dates.replace(dates);

			if (this.dates.length)
				this.viewDate = new Date(this.dates.get(-1));
			else if (this.viewDate < this.o.startDate)
				this.viewDate = new Date(this.o.startDate);
			else if (this.viewDate > this.o.endDate)
				this.viewDate = new Date(this.o.endDate);
			else
				this.viewDate = this.o.defaultViewDate;

			if (fromArgs){
				// setting date by clicking
				this.setValue();
			}
			else if (dates.length){
				// setting date by typing
				if (String(oldDates) !== String(this.dates))
					this._trigger('changeDate');
			}
			if (!this.dates.length && oldDates.length)
				this._trigger('clearDate');

			this.fill();
			this.element.change();
			return this;
		},

		fillDow: function(){
			var dowCnt = this.o.weekStart,
				html = '<tr>';
			if (this.o.calendarWeeks){
				this.picker.find('.datepicker-days .datepicker-switch')
					.attr('colspan', function(i, val){
						return parseInt(val) + 1;
					});
				html += '<th class="cw">&#160;</th>';
			}
			while (dowCnt < this.o.weekStart + 7){
				html += '<th class="dow';
        if ($.inArray(dowCnt, this.o.daysOfWeekDisabled) > -1)
          html += ' disabled';
        html += '">'+dates[this.o.language].daysMin[(dowCnt++)%7]+'</th>';
			}
			html += '</tr>';
			this.picker.find('.datepicker-days thead').append(html);
		},

		fillMonths: function(){
      var localDate = this._utc_to_local(this.viewDate);
			var html = '',
			i = 0;
			while (i < 12){
        var focused = localDate && localDate.getMonth() === i ? ' focused' : '';
				html += '<span class="month' + focused + '">' + dates[this.o.language].monthsShort[i++]+'</span>';
			}
			this.picker.find('.datepicker-months td').html(html);
		},

		setRange: function(range){
			if (!range || !range.length)
				delete this.range;
			else
				this.range = $.map(range, function(d){
					return d.valueOf();
				});
			this.fill();
		},

		getClassNames: function(date){
			var cls = [],
				year = this.viewDate.getUTCFullYear(),
				month = this.viewDate.getUTCMonth(),
				today = new Date();
			if (date.getUTCFullYear() < year || (date.getUTCFullYear() === year && date.getUTCMonth() < month)){
				cls.push('old');
			}
			else if (date.getUTCFullYear() > year || (date.getUTCFullYear() === year && date.getUTCMonth() > month)){
				cls.push('new');
			}
			if (this.focusDate && date.valueOf() === this.focusDate.valueOf())
				cls.push('focused');
			// Compare internal UTC date with local today, not UTC today
			if (this.o.todayHighlight &&
				date.getUTCFullYear() === today.getFullYear() &&
				date.getUTCMonth() === today.getMonth() &&
				date.getUTCDate() === today.getDate()){
				cls.push('today');
			}
			if (this.dates.contains(date) !== -1)
				cls.push('active');
			if (!this.dateWithinRange(date)){
				cls.push('disabled');
			}
			if (this.dateIsDisabled(date)){
				cls.push('disabled', 'disabled-date');	
			} 
			if ($.inArray(date.getUTCDay(), this.o.daysOfWeekHighlighted) !== -1){
				cls.push('highlighted');
			}

			if (this.range){
				if (date > this.range[0] && date < this.range[this.range.length-1]){
					cls.push('range');
				}
				if ($.inArray(date.valueOf(), this.range) !== -1){
					cls.push('selected');
				}
				if (date.valueOf() === this.range[0]){
          cls.push('range-start');
        }
        if (date.valueOf() === this.range[this.range.length-1]){
          cls.push('range-end');
        }
			}
			return cls;
		},

		_fill_yearsView: function(selector, cssClass, factor, step, currentYear, startYear, endYear, callback){
			var html, view, year, steps, startStep, endStep, thisYear, i, classes, tooltip, before;

			html      = '';
			view      = this.picker.find(selector);
			year      = parseInt(currentYear / factor, 10) * factor;
			startStep = parseInt(startYear / step, 10) * step;
			endStep   = parseInt(endYear / step, 10) * step;
			steps     = $.map(this.dates, function(d){
				return parseInt(d.getUTCFullYear() / step, 10) * step;
			});

			view.find('.datepicker-switch').text(year + '-' + (year + step * 9));

			thisYear = year - step;
			for (i = -1; i < 11; i += 1) {
				classes = [cssClass];
				tooltip = null;

				if (i === -1) {
					classes.push('old');
				} else if (i === 10) {
					classes.push('new');
				}
				if ($.inArray(thisYear, steps) !== -1) {
					classes.push('active');
				}
				if (thisYear < startStep || thisYear > endStep) {
					classes.push('disabled');
				}
        if (thisYear === this.viewDate.getFullYear()) {
				  classes.push('focused');
        }

				if (callback !== $.noop) {
					before = callback(new Date(thisYear, 0, 1));
					if (before === undefined) {
						before = {};
					} else if (typeof(before) === 'boolean') {
						before = {enabled: before};
					} else if (typeof(before) === 'string') {
						before = {classes: before};
					}
					if (before.enabled === false) {
						classes.push('disabled');
					}
					if (before.classes) {
						classes = classes.concat(before.classes.split(/\s+/));
					}
					if (before.tooltip) {
						tooltip = before.tooltip;
					}
				}

				html += '<span class="' + classes.join(' ') + '"' + (tooltip ? ' title="' + tooltip + '"' : '') + '>' + thisYear + '</span>';
				thisYear += step;
			}
			view.find('td').html(html);
		},

		fill: function(){
			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth(),
				startYear = this.o.startDate !== -Infinity ? this.o.startDate.getUTCFullYear() : -Infinity,
				startMonth = this.o.startDate !== -Infinity ? this.o.startDate.getUTCMonth() : -Infinity,
				endYear = this.o.endDate !== Infinity ? this.o.endDate.getUTCFullYear() : Infinity,
				endMonth = this.o.endDate !== Infinity ? this.o.endDate.getUTCMonth() : Infinity,
				todaytxt = dates[this.o.language].today || dates['en'].today || '',
				cleartxt = dates[this.o.language].clear || dates['en'].clear || '',
				titleFormat = dates[this.o.language].titleFormat || dates['en'].titleFormat,
				tooltip,
				before;
			if (isNaN(year) || isNaN(month))
				return;
			this.picker.find('.datepicker-days .datepicker-switch')
						.text(DPGlobal.formatDate(d, titleFormat, this.o.language));
			this.picker.find('tfoot .today')
						.text(todaytxt)
						.toggle(this.o.todayBtn !== false);
			this.picker.find('tfoot .clear')
						.text(cleartxt)
						.toggle(this.o.clearBtn !== false);
			this.picker.find('thead .datepicker-title')
						.text(this.o.title)
						.toggle(this.o.title !== '');
			this.updateNavArrows();
			this.fillMonths();
			var prevMonth = UTCDate(year, month-1, 28),
				day = DPGlobal.getDaysInMonth(prevMonth.getUTCFullYear(), prevMonth.getUTCMonth());
			prevMonth.setUTCDate(day);
			prevMonth.setUTCDate(day - (prevMonth.getUTCDay() - this.o.weekStart + 7)%7);
			var nextMonth = new Date(prevMonth);
			if (prevMonth.getUTCFullYear() < 100){
        nextMonth.setUTCFullYear(prevMonth.getUTCFullYear());
      }
			nextMonth.setUTCDate(nextMonth.getUTCDate() + 42);
			nextMonth = nextMonth.valueOf();
			var html = [];
			var clsName;
			while (prevMonth.valueOf() < nextMonth){
				if (prevMonth.getUTCDay() === this.o.weekStart){
					html.push('<tr>');
					if (this.o.calendarWeeks){
						// ISO 8601: First week contains first thursday.
						// ISO also states week starts on Monday, but we can be more abstract here.
						var
							// Start of current week: based on weekstart/current date
							ws = new Date(+prevMonth + (this.o.weekStart - prevMonth.getUTCDay() - 7) % 7 * 864e5),
							// Thursday of this week
							th = new Date(Number(ws) + (7 + 4 - ws.getUTCDay()) % 7 * 864e5),
							// First Thursday of year, year from thursday
							yth = new Date(Number(yth = UTCDate(th.getUTCFullYear(), 0, 1)) + (7 + 4 - yth.getUTCDay())%7*864e5),
							// Calendar week: ms between thursdays, div ms per day, div 7 days
							calWeek =  (th - yth) / 864e5 / 7 + 1;
						html.push('<td class="cw">'+ calWeek +'</td>');
					}
				}
				clsName = this.getClassNames(prevMonth);
				clsName.push('day');

				if (this.o.beforeShowDay !== $.noop){
					before = this.o.beforeShowDay(this._utc_to_local(prevMonth));
					if (before === undefined)
						before = {};
					else if (typeof(before) === 'boolean')
						before = {enabled: before};
					else if (typeof(before) === 'string')
						before = {classes: before};
					if (before.enabled === false)
						clsName.push('disabled');
					if (before.classes)
						clsName = clsName.concat(before.classes.split(/\s+/));
					if (before.tooltip)
						tooltip = before.tooltip;
				}

				clsName = $.unique(clsName);
				html.push('<td class="'+clsName.join(' ')+'"' + (tooltip ? ' title="'+tooltip+'"' : '') + '>'+prevMonth.getUTCDate() + '</td>');
				tooltip = null;
				if (prevMonth.getUTCDay() === this.o.weekEnd){
					html.push('</tr>');
				}
				prevMonth.setUTCDate(prevMonth.getUTCDate()+1);
			}
			this.picker.find('.datepicker-days tbody').empty().append(html.join(''));

			var monthsTitle = dates[this.o.language].monthsTitle || dates['en'].monthsTitle || 'Months';
			var months = this.picker.find('.datepicker-months')
						.find('.datepicker-switch')
							.text(this.o.maxViewMode < 2 ? monthsTitle : year)
							.end()
						.find('span').removeClass('active');

			$.each(this.dates, function(i, d){
				if (d.getUTCFullYear() === year)
					months.eq(d.getUTCMonth()).addClass('active');
			});

			if (year < startYear || year > endYear){
				months.addClass('disabled');
			}
			if (year === startYear){
				months.slice(0, startMonth).addClass('disabled');
			}
			if (year === endYear){
				months.slice(endMonth+1).addClass('disabled');
			}

			if (this.o.beforeShowMonth !== $.noop){
				var that = this;
				$.each(months, function(i, month){
          var moDate = new Date(year, i, 1);
          var before = that.o.beforeShowMonth(moDate);
					if (before === undefined)
						before = {};
					else if (typeof(before) === 'boolean')
						before = {enabled: before};
					else if (typeof(before) === 'string')
						before = {classes: before};
					if (before.enabled === false && !$(month).hasClass('disabled'))
					    $(month).addClass('disabled');
					if (before.classes)
					    $(month).addClass(before.classes);
					if (before.tooltip)
					    $(month).prop('title', before.tooltip);
				});
			}

			// Generating decade/years picker
			this._fill_yearsView(
				'.datepicker-years',
				'year',
				10,
				1,
				year,
				startYear,
				endYear,
				this.o.beforeShowYear
			);

			// Generating century/decades picker
			this._fill_yearsView(
				'.datepicker-decades',
				'decade',
				100,
				10,
				year,
				startYear,
				endYear,
				this.o.beforeShowDecade
			);

			// Generating millennium/centuries picker
			this._fill_yearsView(
				'.datepicker-centuries',
				'century',
				1000,
				100,
				year,
				startYear,
				endYear,
				this.o.beforeShowCentury
			);
		},

		updateNavArrows: function(){
			if (!this._allow_update)
				return;

			var d = new Date(this.viewDate),
				year = d.getUTCFullYear(),
				month = d.getUTCMonth();
			switch (this.viewMode){
				case 0:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() && month <= this.o.startDate.getUTCMonth()){
						this.picker.find('.prev').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.prev').css({visibility: 'visible'});
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() && month >= this.o.endDate.getUTCMonth()){
						this.picker.find('.next').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.next').css({visibility: 'visible'});
					}
					break;
				case 1:
				case 2:
				case 3:
				case 4:
					if (this.o.startDate !== -Infinity && year <= this.o.startDate.getUTCFullYear() || this.o.maxViewMode < 2){
						this.picker.find('.prev').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.prev').css({visibility: 'visible'});
					}
					if (this.o.endDate !== Infinity && year >= this.o.endDate.getUTCFullYear() || this.o.maxViewMode < 2){
						this.picker.find('.next').css({visibility: 'hidden'});
					}
					else {
						this.picker.find('.next').css({visibility: 'visible'});
					}
					break;
			}
		},

		click: function(e){
			e.preventDefault();
			e.stopPropagation();

			var target, dir, day, year, month, monthChanged, yearChanged;
			target = $(e.target);

			// Clicked on the switch
			if (target.hasClass('datepicker-switch')){
				this.showMode(1);
			}

			// Clicked on prev or next
			var navArrow = target.closest('.prev, .next');
			if (navArrow.length > 0) {
				dir = DPGlobal.modes[this.viewMode].navStep * (navArrow.hasClass('prev') ? -1 : 1);
				if (this.viewMode === 0){
					this.viewDate = this.moveMonth(this.viewDate, dir);
					this._trigger('changeMonth', this.viewDate);
				} else {
					this.viewDate = this.moveYear(this.viewDate, dir);
					if (this.viewMode === 1){
						this._trigger('changeYear', this.viewDate);
					}
				}
				this.fill();
			}

			// Clicked on today button
			if (target.hasClass('today') && !target.hasClass('day')){
				this.showMode(-2);
				this._setDate(UTCToday(), this.o.todayBtn === 'linked' ? null : 'view');
			}

			// Clicked on clear button
			if (target.hasClass('clear')){
				this.clearDates();
			}

			if (!target.hasClass('disabled')){
				// Clicked on a day
				if (target.hasClass('day')){
					day = parseInt(target.text(), 10) || 1;
					year = this.viewDate.getUTCFullYear();
					month = this.viewDate.getUTCMonth();

					// From last month
					if (target.hasClass('old')){
						if (month === 0) {
							month = 11;
							year = year - 1;
							monthChanged = true;
							yearChanged = true;
						} else {
							month = month - 1;
							monthChanged = true;
 						}
 					}

					// From next month
					if (target.hasClass('new')) {
						if (month === 11){
							month = 0;
							year = year + 1;
							monthChanged = true;
							yearChanged = true;
 						} else {
							month = month + 1;
							monthChanged = true;
 						}
					}
					this._setDate(UTCDate(year, month, day));
					if (yearChanged) {
						this._trigger('changeYear', this.viewDate);
					}
					if (monthChanged) {
						this._trigger('changeMonth', this.viewDate);
					}
				}

				// Clicked on a month
				if (target.hasClass('month')) {
					this.viewDate.setUTCDate(1);
					day = 1;
					month = target.parent().find('span').index(target);
					year = this.viewDate.getUTCFullYear();
					this.viewDate.setUTCMonth(month);
					this._trigger('changeMonth', this.viewDate);
					if (this.o.minViewMode === 1){
						this._setDate(UTCDate(year, month, day));
						this.showMode();
					} else {
						this.showMode(-1);
					}
					this.fill();
				}

				// Clicked on a year
				if (target.hasClass('year')
						|| target.hasClass('decade')
						|| target.hasClass('century')) {
					this.viewDate.setUTCDate(1);

					day = 1;
					month = 0;
					year = parseInt(target.text(), 10)||0;
					this.viewDate.setUTCFullYear(year);

					if (target.hasClass('year')){
						this._trigger('changeYear', this.viewDate);
						if (this.o.minViewMode === 2){
							this._setDate(UTCDate(year, month, day));
						}
					}
					if (target.hasClass('decade')){
						this._trigger('changeDecade', this.viewDate);
						if (this.o.minViewMode === 3){
							this._setDate(UTCDate(year, month, day));
						}
					}
					if (target.hasClass('century')){
						this._trigger('changeCentury', this.viewDate);
						if (this.o.minViewMode === 4){
							this._setDate(UTCDate(year, month, day));
						}
					}

					this.showMode(-1);
					this.fill();
				}
			}

			if (this.picker.is(':visible') && this._focused_from){
				$(this._focused_from).focus();
			}
			delete this._focused_from;
		},

		_toggle_multidate: function(date){
			var ix = this.dates.contains(date);
			if (!date){
				this.dates.clear();
			}

			if (ix !== -1){
				if (this.o.multidate === true || this.o.multidate > 1 || this.o.toggleActive){
					this.dates.remove(ix);
				}
			} else if (this.o.multidate === false) {
				this.dates.clear();
				this.dates.push(date);
			}
			else {
				this.dates.push(date);
			}

			if (typeof this.o.multidate === 'number')
				while (this.dates.length > this.o.multidate)
					this.dates.remove(0);
		},

		_setDate: function(date, which){
			if (!which || which === 'date')
				this._toggle_multidate(date && new Date(date));
			if (!which || which === 'view')
				this.viewDate = date && new Date(date);

			this.fill();
			this.setValue();
			if (!which || which !== 'view') {
				this._trigger('changeDate');
			}
			if (this.inputField){
				this.inputField.change();
			}
			if (this.o.autoclose && (!which || which === 'date')){
				this.hide();
			}
		},

		moveDay: function(date, dir){
			var newDate = new Date(date);
			newDate.setUTCDate(date.getUTCDate() + dir);

			return newDate;
		},

		moveWeek: function(date, dir){
			return this.moveDay(date, dir * 7);
		},

		moveMonth: function(date, dir){
			if (!isValidDate(date))
				return this.o.defaultViewDate;
			if (!dir)
				return date;
			var new_date = new Date(date.valueOf()),
				day = new_date.getUTCDate(),
				month = new_date.getUTCMonth(),
				mag = Math.abs(dir),
				new_month, test;
			dir = dir > 0 ? 1 : -1;
			if (mag === 1){
				test = dir === -1
					// If going back one month, make sure month is not current month
					// (eg, Mar 31 -> Feb 31 == Feb 28, not Mar 02)
					? function(){
						return new_date.getUTCMonth() === month;
					}
					// If going forward one month, make sure month is as expected
					// (eg, Jan 31 -> Feb 31 == Feb 28, not Mar 02)
					: function(){
						return new_date.getUTCMonth() !== new_month;
					};
				new_month = month + dir;
				new_date.setUTCMonth(new_month);
				// Dec -> Jan (12) or Jan -> Dec (-1) -- limit expected date to 0-11
				if (new_month < 0 || new_month > 11)
					new_month = (new_month + 12) % 12;
			}
			else {
				// For magnitudes >1, move one month at a time...
				for (var i=0; i < mag; i++)
					// ...which might decrease the day (eg, Jan 31 to Feb 28, etc)...
					new_date = this.moveMonth(new_date, dir);
				// ...then reset the day, keeping it in the new month
				new_month = new_date.getUTCMonth();
				new_date.setUTCDate(day);
				test = function(){
					return new_month !== new_date.getUTCMonth();
				};
			}
			// Common date-resetting loop -- if date is beyond end of month, make it
			// end of month
			while (test()){
				new_date.setUTCDate(--day);
				new_date.setUTCMonth(new_month);
			}
			return new_date;
		},

		moveYear: function(date, dir){
			return this.moveMonth(date, dir*12);
		},

		moveAvailableDate: function(date, dir, fn){
			do {
				date = this[fn](date, dir);

				if (!this.dateWithinRange(date))
					return false;

				fn = 'moveDay';
			}
			while (this.dateIsDisabled(date));

			return date;
		},

		weekOfDateIsDisabled: function(date){
			return $.inArray(date.getUTCDay(), this.o.daysOfWeekDisabled) !== -1;
		},

		dateIsDisabled: function(date){
			return (
				this.weekOfDateIsDisabled(date) ||
				$.grep(this.o.datesDisabled, function(d){
					return isUTCEquals(date, d);
				}).length > 0
			);
		},

		dateWithinRange: function(date){
			return date >= this.o.startDate && date <= this.o.endDate;
		},

		keydown: function(e){
			if (!this.picker.is(':visible')){
				if (e.keyCode === 40 || e.keyCode === 27) { // allow down to re-show picker
					this.show();
					e.stopPropagation();
        }
				return;
			}
			var dateChanged = false,
				dir, newViewDate,
				focusDate = this.focusDate || this.viewDate;
			switch (e.keyCode){
				case 27: // escape
					if (this.focusDate){
						this.focusDate = null;
						this.viewDate = this.dates.get(-1) || this.viewDate;
						this.fill();
					}
					else
						this.hide();
					e.preventDefault();
					e.stopPropagation();
					break;
				case 37: // left
				case 38: // up
				case 39: // right
				case 40: // down
					if (!this.o.keyboardNavigation || this.o.daysOfWeekDisabled.length === 7)
						break;
					dir = e.keyCode === 37 || e.keyCode === 38 ? -1 : 1;
          if (this.viewMode === 0) {
  					if (e.ctrlKey){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');

  						if (newViewDate)
  							this._trigger('changeYear', this.viewDate);
  					}
  					else if (e.shiftKey){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');

  						if (newViewDate)
  							this._trigger('changeMonth', this.viewDate);
  					}
  					else if (e.keyCode === 37 || e.keyCode === 39){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveDay');
  					}
  					else if (!this.weekOfDateIsDisabled(focusDate)){
  						newViewDate = this.moveAvailableDate(focusDate, dir, 'moveWeek');
  					}
          } else if (this.viewMode === 1) {
            if (e.keyCode === 38 || e.keyCode === 40) {
              dir = dir * 4;
            }
            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveMonth');
          } else if (this.viewMode === 2) {
            if (e.keyCode === 38 || e.keyCode === 40) {
              dir = dir * 4;
            }
            newViewDate = this.moveAvailableDate(focusDate, dir, 'moveYear');
          }
					if (newViewDate){
						this.focusDate = this.viewDate = newViewDate;
						this.setValue();
						this.fill();
						e.preventDefault();
					}
					break;
				case 13: // enter
					if (!this.o.forceParse)
						break;
					focusDate = this.focusDate || this.dates.get(-1) || this.viewDate;
					if (this.o.keyboardNavigation) {
						this._toggle_multidate(focusDate);
						dateChanged = true;
					}
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.setValue();
					this.fill();
					if (this.picker.is(':visible')){
						e.preventDefault();
						e.stopPropagation();
						if (this.o.autoclose)
							this.hide();
					}
					break;
				case 9: // tab
					this.focusDate = null;
					this.viewDate = this.dates.get(-1) || this.viewDate;
					this.fill();
					this.hide();
					break;
			}
			if (dateChanged){
				if (this.dates.length)
					this._trigger('changeDate');
				else
					this._trigger('clearDate');
				if (this.inputField){
					this.inputField.change();
				}
			}
		},

		showMode: function(dir){
			if (dir){
				this.viewMode = Math.max(this.o.minViewMode, Math.min(this.o.maxViewMode, this.viewMode + dir));
			}
			this.picker
				.children('div')
				.hide()
				.filter('.datepicker-' + DPGlobal.modes[this.viewMode].clsName)
					.show();
			this.updateNavArrows();
		}
	};

	var DateRangePicker = function(element, options){
		$(element).data('datepicker', this);
		this.element = $(element);
		this.inputs = $.map(options.inputs, function(i){
			return i.jquery ? i[0] : i;
		});
		delete options.inputs;

		datepickerPlugin.call($(this.inputs), options)
			.on('changeDate', $.proxy(this.dateUpdated, this));

		this.pickers = $.map(this.inputs, function(i){
			return $(i).data('datepicker');
		});
		this.updateDates();
	};
	DateRangePicker.prototype = {
		updateDates: function(){
			this.dates = $.map(this.pickers, function(i){
				return i.getUTCDate();
			});
			this.updateRanges();
		},
		updateRanges: function(){
			var range = $.map(this.dates, function(d){
				return d.valueOf();
			});
			$.each(this.pickers, function(i, p){
				p.setRange(range);
			});
		},
		dateUpdated: function(e){
			// `this.updating` is a workaround for preventing infinite recursion
			// between `changeDate` triggering and `setUTCDate` calling.  Until
			// there is a better mechanism.
			if (this.updating)
				return;
			this.updating = true;

			var dp = $(e.target).data('datepicker');

			if (typeof(dp) === "undefined") {
				return;
			}

			var new_date = dp.getUTCDate(),
				i = $.inArray(e.target, this.inputs),
				j = i - 1,
				k = i + 1,
				l = this.inputs.length;
			if (i === -1)
				return;

			$.each(this.pickers, function(i, p){
				if (!p.getUTCDate())
					p.setUTCDate(new_date);
			});

			if (new_date < this.dates[j]){
				// Date being moved earlier/left
				while (j >= 0 && new_date < this.dates[j]){
					this.pickers[j--].setUTCDate(new_date);
				}
			}
			else if (new_date > this.dates[k]){
				// Date being moved later/right
				while (k < l && new_date > this.dates[k]){
					this.pickers[k++].setUTCDate(new_date);
				}
			}
			this.updateDates();

			delete this.updating;
		},
		remove: function(){
			$.map(this.pickers, function(p){ p.remove(); });
			delete this.element.data().datepicker;
		}
	};

	function opts_from_el(el, prefix){
		// Derive options from element data-attrs
		var data = $(el).data(),
			out = {}, inkey,
			replace = new RegExp('^' + prefix.toLowerCase() + '([A-Z])');
		prefix = new RegExp('^' + prefix.toLowerCase());
		function re_lower(_,a){
			return a.toLowerCase();
		}
		for (var key in data)
			if (prefix.test(key)){
				inkey = key.replace(replace, re_lower);
				out[inkey] = data[key];
			}
		return out;
	}

	function opts_from_locale(lang){
		// Derive options from locale plugins
		var out = {};
		// Check if "de-DE" style date is available, if not language should
		// fallback to 2 letter code eg "de"
		if (!dates[lang]){
			lang = lang.split('-')[0];
			if (!dates[lang])
				return;
		}
		var d = dates[lang];
		$.each(locale_opts, function(i,k){
			if (k in d)
				out[k] = d[k];
		});
		return out;
	}

	var old = $.fn.datepicker;
	var datepickerPlugin = function(option){
		var args = Array.apply(null, arguments);
		args.shift();
		var internal_return;
		this.each(function(){
			var $this = $(this),
				data = $this.data('datepicker'),
				options = typeof option === 'object' && option;
			if (!data){
				var elopts = opts_from_el(this, 'date'),
					// Preliminary otions
					xopts = $.extend({}, defaults, elopts, options),
					locopts = opts_from_locale(xopts.language),
					// Options priority: js args, data-attrs, locales, defaults
					opts = $.extend({}, defaults, locopts, elopts, options);
				if ($this.hasClass('input-daterange') || opts.inputs){
					$.extend(opts, {
						inputs: opts.inputs || $this.find('input').toArray()
					});
					data = new DateRangePicker(this, opts);
				}
				else {
					data = new Datepicker(this, opts);
				}
				$this.data('datepicker', data);
			}
			if (typeof option === 'string' && typeof data[option] === 'function'){
				internal_return = data[option].apply(data, args);
			}
		});

		if (
			internal_return === undefined ||
			internal_return instanceof Datepicker ||
			internal_return instanceof DateRangePicker
		)
			return this;

		if (this.length > 1)
			throw new Error('Using only allowed for the collection of a single element (' + option + ' function)');
		else
			return internal_return;
	};
	$.fn.datepicker = datepickerPlugin;

	var defaults = $.fn.datepicker.defaults = {
		assumeNearbyYear: false,
		autoclose: false,
		beforeShowDay: $.noop,
		beforeShowMonth: $.noop,
		beforeShowYear: $.noop,
		beforeShowDecade: $.noop,
		beforeShowCentury: $.noop,
		calendarWeeks: false,
		clearBtn: false,
		toggleActive: false,
		daysOfWeekDisabled: [],
		daysOfWeekHighlighted: [],
		datesDisabled: [],
		endDate: Infinity,
		forceParse: true,
		format: 'mm/dd/yyyy',
		keyboardNavigation: true,
		language: 'en',
		minViewMode: 0,
		maxViewMode: 4,
		multidate: false,
		multidateSeparator: ',',
		orientation: "auto",
		rtl: false,
		startDate: -Infinity,
		startView: 0,
		todayBtn: false,
		todayHighlight: false,
		weekStart: 0,
		disableTouchKeyboard: false,
		enableOnReadonly: true,
		showOnFocus: true,
		zIndexOffset: 10,
		container: 'body',
		immediateUpdates: false,
		title: '',
		templates: {
			leftArrow: '&laquo;',
			rightArrow: '&raquo;'
		}
	};
	var locale_opts = $.fn.datepicker.locale_opts = [
		'format',
		'rtl',
		'weekStart'
	];
	$.fn.datepicker.Constructor = Datepicker;
	var dates = $.fn.datepicker.dates = {
		en: {
			days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
			daysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
			daysMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
			today: "Today",
			clear: "Clear",
			titleFormat: "MM yyyy"
		}
	};

	var DPGlobal = {
		modes: [
			{
				clsName: 'days',
				navFnc: 'Month',
				navStep: 1
			},
			{
				clsName: 'months',
				navFnc: 'FullYear',
				navStep: 1
			},
			{
				clsName: 'years',
				navFnc: 'FullYear',
				navStep: 10
			},
			{
				clsName: 'decades',
				navFnc: 'FullDecade',
				navStep: 100
			},
			{
				clsName: 'centuries',
				navFnc: 'FullCentury',
				navStep: 1000
		}],
		isLeapYear: function(year){
			return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0));
		},
		getDaysInMonth: function(year, month){
			return [31, (DPGlobal.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
		},
		validParts: /dd?|DD?|mm?|MM?|yy(?:yy)?/g,
		nonpunctuation: /[^ -\/:-@\u5e74\u6708\u65e5\[-`{-~\t\n\r]+/g,
		parseFormat: function(format){
			if (typeof format.toValue === 'function' && typeof format.toDisplay === 'function')
                return format;
            // IE treats \0 as a string end in inputs (truncating the value),
			// so it's a bad format delimiter, anyway
			var separators = format.replace(this.validParts, '\0').split('\0'),
				parts = format.match(this.validParts);
			if (!separators || !separators.length || !parts || parts.length === 0){
				throw new Error("Invalid date format.");
			}
			return {separators: separators, parts: parts};
		},
		parseDate: function(date, format, language, assumeNearby){
			if (!date)
				return undefined;
			if (date instanceof Date)
				return date;
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			if (format.toValue)
                return format.toValue(date, format, language);
            var part_re = /([\-+]\d+)([dmwy])/,
				parts = date.match(/([\-+]\d+)([dmwy])/g),
				fn_map = {
					d: 'moveDay',
					m: 'moveMonth',
					w: 'moveWeek',
					y: 'moveYear'
				},
				dateAliases = {
					yesterday: '-1d',
					today: '+0d',
					tomorrow: '+1d'
				},
				part, dir, i, fn;
			if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
				date = new Date();
				for (i=0; i < parts.length; i++){
					part = part_re.exec(parts[i]);
					dir = parseInt(part[1]);
					fn = fn_map[part[2]];
					date = Datepicker.prototype[fn](date, dir);
				}
				return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
			}

			if (typeof dateAliases[date] !== 'undefined') {
				date = dateAliases[date];
				parts = date.match(/([\-+]\d+)([dmwy])/g);

				if (/^[\-+]\d+[dmwy]([\s,]+[\-+]\d+[dmwy])*$/.test(date)){
					date = new Date();
				  	for (i=0; i < parts.length; i++){
						part = part_re.exec(parts[i]);
						dir = parseInt(part[1]);
						fn = fn_map[part[2]];
						date = Datepicker.prototype[fn](date, dir);
				  	}

			  		return UTCDate(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
				}
			}

			parts = date && date.match(this.nonpunctuation) || [];
			date = new Date();

			function applyNearbyYear(year, threshold){
				if (threshold === true)
					threshold = 10;

				// if year is 2 digits or less, than the user most likely is trying to get a recent century
				if (year < 100){
					year += 2000;
					// if the new year is more than threshold years in advance, use last century
					if (year > ((new Date()).getFullYear()+threshold)){
						year -= 100;
					}
				}

				return year;
			}

			var parsed = {},
				setters_order = ['yyyy', 'yy', 'M', 'MM', 'm', 'mm', 'd', 'dd'],
				setters_map = {
					yyyy: function(d,v){
						return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
					},
					yy: function(d,v){
						return d.setUTCFullYear(assumeNearby ? applyNearbyYear(v, assumeNearby) : v);
					},
					m: function(d,v){
						if (isNaN(d))
							return d;
						v -= 1;
						while (v < 0) v += 12;
						v %= 12;
						d.setUTCMonth(v);
						while (d.getUTCMonth() !== v)
							d.setUTCDate(d.getUTCDate()-1);
						return d;
					},
					d: function(d,v){
						return d.setUTCDate(v);
					}
				},
				val, filtered;
			setters_map['M'] = setters_map['MM'] = setters_map['mm'] = setters_map['m'];
			setters_map['dd'] = setters_map['d'];
			date = UTCToday();
			var fparts = format.parts.slice();
			// Remove noop parts
			if (parts.length !== fparts.length){
				fparts = $(fparts).filter(function(i,p){
					return $.inArray(p, setters_order) !== -1;
				}).toArray();
			}
			// Process remainder
			function match_part(){
				var m = this.slice(0, parts[i].length),
					p = parts[i].slice(0, m.length);
				return m.toLowerCase() === p.toLowerCase();
			}
			if (parts.length === fparts.length){
				var cnt;
				for (i=0, cnt = fparts.length; i < cnt; i++){
					val = parseInt(parts[i], 10);
					part = fparts[i];
					if (isNaN(val)){
						switch (part){
							case 'MM':
								filtered = $(dates[language].months).filter(match_part);
								val = $.inArray(filtered[0], dates[language].months) + 1;
								break;
							case 'M':
								filtered = $(dates[language].monthsShort).filter(match_part);
								val = $.inArray(filtered[0], dates[language].monthsShort) + 1;
								break;
						}
					}
					parsed[part] = val;
				}
				var _date, s;
				for (i=0; i < setters_order.length; i++){
					s = setters_order[i];
					if (s in parsed && !isNaN(parsed[s])){
						_date = new Date(date);
						setters_map[s](_date, parsed[s]);
						if (!isNaN(_date))
							date = _date;
					}
				}
			}
			return date;
		},
		formatDate: function(date, format, language){
			if (!date)
				return '';
			if (typeof format === 'string')
				format = DPGlobal.parseFormat(format);
			if (format.toDisplay)
                return format.toDisplay(date, format, language);
            var val = {
				d: date.getUTCDate(),
				D: dates[language].daysShort[date.getUTCDay()],
				DD: dates[language].days[date.getUTCDay()],
				m: date.getUTCMonth() + 1,
				M: dates[language].monthsShort[date.getUTCMonth()],
				MM: dates[language].months[date.getUTCMonth()],
				yy: date.getUTCFullYear().toString().substring(2),
				yyyy: date.getUTCFullYear()
			};
			val.dd = (val.d < 10 ? '0' : '') + val.d;
			val.mm = (val.m < 10 ? '0' : '') + val.m;
			date = [];
			var seps = $.extend([], format.separators);
			for (var i=0, cnt = format.parts.length; i <= cnt; i++){
				if (seps.length)
					date.push(seps.shift());
				date.push(val[format.parts[i]]);
			}
			return date.join('');
		},
		headTemplate: '<thead>'+
			              '<tr>'+
			                '<th colspan="7" class="datepicker-title"></th>'+
			              '</tr>'+
							'<tr>'+
								'<th class="prev">&laquo;</th>'+
								'<th colspan="5" class="datepicker-switch"></th>'+
								'<th class="next">&raquo;</th>'+
							'</tr>'+
						'</thead>',
		contTemplate: '<tbody><tr><td colspan="7"></td></tr></tbody>',
		footTemplate: '<tfoot>'+
							'<tr>'+
								'<th colspan="7" class="today"></th>'+
							'</tr>'+
							'<tr>'+
								'<th colspan="7" class="clear"></th>'+
							'</tr>'+
						'</tfoot>'
	};
	DPGlobal.template = '<div class="datepicker">'+
							'<div class="datepicker-days">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									'<tbody></tbody>'+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-months">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-years">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-decades">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
							'<div class="datepicker-centuries">'+
								'<table class="table-condensed">'+
									DPGlobal.headTemplate+
									DPGlobal.contTemplate+
									DPGlobal.footTemplate+
								'</table>'+
							'</div>'+
						'</div>';

	$.fn.datepicker.DPGlobal = DPGlobal;


	/* DATEPICKER NO CONFLICT
	* =================== */

	$.fn.datepicker.noConflict = function(){
		$.fn.datepicker = old;
		return this;
	};

	/* DATEPICKER VERSION
	 * =================== */
	$.fn.datepicker.version = '1.6.1';

	/* DATEPICKER DATA-API
	* ================== */

	$(document).on(
		'focus.datepicker.data-api click.datepicker.data-api',
		'[data-provide="datepicker"]',
		function(e){
			var $this = $(this);
			if ($this.data('datepicker'))
				return;
			e.preventDefault();
			// component click requires us to explicitly show it
			datepickerPlugin.call($this, 'show');
		}
	);
	$(function(){
		datepickerPlugin.call($('[data-provide="datepicker-inline"]'));
	});

}));

!function(a){a.fn.datepicker.dates.it={days:["Domenica","Lunedì","Martedì","Mercoledì","Giovedì","Venerdì","Sabato"],daysShort:["Dom","Lun","Mar","Mer","Gio","Ven","Sab"],daysMin:["Do","Lu","Ma","Me","Gi","Ve","Sa"],months:["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],monthsShort:["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],today:"Oggi",monthsTitle:"Mesi",clear:"Cancella",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.es={days:["Domingo","Lunes","Martes","Miércoles","Jueves","Viernes","Sábado"],daysShort:["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"],daysMin:["Do","Lu","Ma","Mi","Ju","Vi","Sa"],months:["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],monthsShort:["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],today:"Hoy",monthsTitle:"Meses",clear:"Borrar",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
!function(a){a.fn.datepicker.dates.fr={days:["dimanche","lundi","mardi","mercredi","jeudi","vendredi","samedi"],daysShort:["dim.","lun.","mar.","mer.","jeu.","ven.","sam."],daysMin:["d","l","ma","me","j","v","s"],months:["janvier","février","mars","avril","mai","juin","juillet","août","septembre","octobre","novembre","décembre"],monthsShort:["janv.","févr.","mars","avril","mai","juin","juil.","août","sept.","oct.","nov.","déc."],today:"Aujourd'hui",monthsTitle:"Mois",clear:"Effacer",weekStart:1,format:"dd/mm/yyyy"}}(jQuery);
/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.2
 *
 */

function isMobile() {
    return /mobile/i.test(navigator.userAgent) && navigator.userAgent.match(/iPad/i) == null;;
}

var isMenuShown = !isMobile();


// Full height of sidebar
function inspinia_fix_height() {
    var heightWithoutNavbar = $("body > #wrapper").height() - 61;
    $(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeigh = $('nav.navbar-default').height();
    var wrapperHeigh = $('#page-wrapper').height();

    if (navbarHeigh > wrapperHeigh) {
        $('#page-wrapper').css("min-height", navbarHeigh + "px");
    }

    if (navbarHeigh < wrapperHeigh) {
        $('#page-wrapper').css("min-height", $(window).height() + "px");
    }

    if ($('body').hasClass('fixed-nav')) {
        $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
    }
}

function initTemplate() {
    // Add body-small class if window less than 768px
    applyBodyWithHiddenMenu();

    // MetsiMenu
    //$('#side-menu').metisMenu();

    // Collapse ibox function
    $('.collapse-link').click(function () {
        var ibox = $(this).closest('div.ibox');
        var button = $(this).find('i');
        var content = ibox.find('div.ibox-content');
        content.slideToggle(200);
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        ibox.toggleClass('').toggleClass('border-bottom');
        setTimeout(function () {
            ibox.resize();
            ibox.find('[id^=map-]').resize();
        }, 50);
    });

    // Close ibox function
    $('.close-link').click(function () {
        var content = $(this).closest('div.ibox');
        content.remove();
    });

    // Fullscreen ibox function
    $('.fullscreen-link').click(function () {
        var ibox = $(this).closest('div.ibox');
        var button = $(this).find('i');
        $('body').toggleClass('fullscreen-ibox-mode');
        button.toggleClass('fa-expand').toggleClass('fa-compress');
        ibox.toggleClass('fullscreen');
        setTimeout(function () {
            $(window).trigger('resize');
        }, 100);
    });

    // Close menu in canvas mode
    $('.close-canvas-menu').click(function () {
        toggleMenu();
        SmoothlyMenu();
    });

    // Open close right sidebar
    $('.right-sidebar-toggle').click(function () {
        $('#right-sidebar').toggleClass('sidebar-open');
    });

    // Initialize slimscroll for right sidebar
    /*
    $('.sidebar-container').slimScroll({
        height: '100%',
        railOpacity: 0.4,
        wheelStep: 10
    });

    // Open close small chat
    $('.open-small-chat').click(function () {
        $(this).children().toggleClass('fa-comments').toggleClass('fa-remove');
        $('.small-chat-box').toggleClass('active');
    });

    // Initialize slimscroll for small chat
    $('.small-chat-box .content').slimScroll({
        height: '234px',
        railOpacity: 0.4
    });
    */

    // Small todo handler
    $('.check-link').click(function () {
        var button = $(this).find('i');
        var label = $(this).next('span');
        button.toggleClass('fa-check-square').toggleClass('fa-square-o');
        label.toggleClass('todo-completed');
        return false;
    });

    // Append config box / Only for demo purpose
    // Uncomment on server mode to enable XHR calls
    //$.get("skin-config.html", function (data) {
    //    if (!$('body').hasClass('no-skin-config'))
    //        $('body').append(data);
    //});

    // Minimalize menu
    $('.navbar-minimalize').click(function (event) {
        toggleMenu();
        SmoothlyMenu();
        event.preventDefault();
    });

    // Tooltips demo
    $('.tooltip-demo').tooltip({
        selector: "[data-toggle=tooltip]",
        container: "body"
    });

    // Move modal to body
    // Fix Bootstrap backdrop issu with animation.css
    $('.modal').appendTo("body");

    inspinia_fix_height();

    // Fixed Sidebar
    $(window).bind("load", function () {
        if ($("body").hasClass('fixed-sidebar')) {
            $('.sidebar-collapse').slimScroll({
                height: '100%',
                railOpacity: 0.9
            });
        }
    });

    // Move right sidebar top after scroll
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
            $('#right-sidebar').addClass('sidebar-top');
        } else {
            $('#right-sidebar').removeClass('sidebar-top');
        }
    });

    $(window).bind("load resize scroll", function () {
        if (!$("body").hasClass('body-small')) {
            inspinia_fix_height();
        }
    });

    $("[data-toggle=popover]")
        .popover();

    // Add slimscroll to element
    /*
    $('.full-height-scroll').slimscroll({
        height: '100%'
    });
    */

    $(document).click(function (e) {
        if ($(e.target).closest('.navbar-minimalize').length)
            return;
        hideMenuIfIsShown(e);
    });

    $('body').on('click', '.node', function (e) {
        isMenuShown = true;
        hideMenuIfIsShown(e);
    });
    $('body').on('click', '.nav-second-level a', function (e) {
        isMenuShown = true;
        hideMenuIfIsShown(e);
    });
}


// Minimalize menu when screen is less than 768px
$(window).bind("resize", function () {
    applyBodyWithHiddenMenu();
});

// Local Storage functions
// Set proper body class and plugins based on user configuration
$(document).ready(function () {
    if (Modernizr.localstorage) {

        var collapse = localStorage.getItem("collapse_menu");
        var fixedsidebar = localStorage.getItem("fixedsidebar");
        var fixednavbar = localStorage.getItem("fixednavbar");
        var boxedlayout = localStorage.getItem("boxedlayout");
        var fixedfooter = localStorage.getItem("fixedfooter");

        var body = $('body');

        if (fixedsidebar == 'on') {
            body.addClass('fixed-sidebar');
            /*
            $('.sidebar-collapse').slimScroll({
                height: '100%',
                railOpacity: 0.9
            });
            */
        }

        if (collapse == 'on' && !(isMobile !== undefined && isMobile())) {
            if (body.hasClass('fixed-sidebar')) {
                if (!body.hasClass('body-small')) {
                    body.addClass('mini-navbar');
                }
            } else {
                if (!body.hasClass('body-small')) {
                    body.addClass('mini-navbar');
                }

            }
        }

        if (fixednavbar == 'on') {
            $(".navbar-static-top").removeClass('navbar-static-top').addClass('navbar-fixed-top');
            body.addClass('fixed-nav');
        }

        if (boxedlayout == 'on') {
            body.addClass('boxed-layout');
        }

        if (fixedfooter == 'on') {
            $(".footer").addClass('fixed');
        }
    }
});

// For demo purpose - animation css script
function animationHover(element, animation) {
    element = $(element);
    element.hover(
        function () {
            element.addClass('animated ' + animation);
        },
        function () {
            //wait for animation to finish before removing classes
            window.setTimeout(function () {
                element.removeClass('animated ' + animation);
            }, 2000);
        });
}

function SmoothlyMenu() {
    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide();
        // For smoothly turn on menu
        setTimeout(
            function () {
                $('#side-menu').fadeIn(500);
            }, 100);
    } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide();
        setTimeout(
            function () {
                $('#side-menu').fadeIn(500);
            }, 300);
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $('#side-menu').removeAttr('style');
    }
}

// Dragable panels
function WinMove() {
    var element = "[class*=col]";
    var handle = ".ibox-title";
    var connect = "[class*=col]";
    $(element).sortable(
        {
            handle: handle,
            connectWith: connect,
            tolerance: 'pointer',
            forcePlaceholderSize: true,
            opacity: 0.8
        })
        .disableSelection();
}


function applyBodyWithHiddenMenu() {
    if (isMobile !== undefined && isMobile())
        return;

    if ($(this).width() < 769) {
        $('body').addClass('body-small');
    } else {
        $('body').removeClass('body-small');
    }

}

function toggleMenu(e) {
    if (e) {
        var target = $(e.target);
        if (target.hasClass('parent-node'))
            return;
    }

    if (!(isMobile !== undefined && isMobile())) {
        $("body").toggleClass("mini-navbar");
        window.dispatchEvent(new Event('resize'));
        return;
    }

    isMenuShown = !isMenuShown;

    var menu = $(".navbar-default");
    if (menu.length) {
        menu.animate({ left: -menu.width() - menu.position().left });
        var navbarHeader = $(".navbar-header");
        navbarHeader.animate({ marginLeft: -menu.position().left });
    }
}

function hideMenuIfIsShown(e) {
    if (!(isMobile !== undefined && isMobile()) || !isMenuShown)
        return;

    toggleMenu(e);
}
/*
 * metismenu - v2.5.2
 * A jQuery menu plugin
 * https://github.com/onokumus/metisMenu#readme
 *
 * Made by Osman Nuri Okumu� <onokumus@gmail.com> (https://github.com/onokumus)
 * Under MIT License
 */

(function (global, factory) {
    if (typeof define === "function" && define.amd) {
        define(['jquery'], factory);
    } else if (typeof exports !== "undefined") {
        factory(require('jquery'));
    } else {
        var mod = {
            exports: {}
        };
        factory(global.jquery);
        global.metisMenu = mod.exports;
    }
})(this, function (_jquery) {
    'use strict';

    var _jquery2 = _interopRequireDefault(_jquery);

    function _interopRequireDefault(obj) {
        return obj && obj.__esModule ? obj : {
            default: obj
        };
    }

    var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];
                descriptor.enumerable = descriptor.enumerable || false;
                descriptor.configurable = true;
                if ("value" in descriptor) descriptor.writable = true;
                Object.defineProperty(target, descriptor.key, descriptor);
            }
        }

        return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);
            if (staticProps) defineProperties(Constructor, staticProps);
            return Constructor;
        };
    }();

    var MetisMenu = function ($) {

        var NAME = 'metisMenu';
        var DATA_KEY = 'metisMenu';
        var EVENT_KEY = '.' + DATA_KEY;
        var DATA_API_KEY = '.data-api';
        var JQUERY_NO_CONFLICT = $.fn[NAME];
        var TRANSITION_DURATION = 350;

        var Default = {
            toggle: true,
            doubleTapToGo: false,
            preventDefault: true,
            activeClass: 'active',
            collapseClass: 'collapse',
            collapseInClass: 'in',
            collapsingClass: 'collapsing'
        };

        var Event = {
            SHOW: 'show' + EVENT_KEY,
            SHOWN: 'shown' + EVENT_KEY,
            HIDE: 'hide' + EVENT_KEY,
            HIDDEN: 'hidden' + EVENT_KEY,
            CLICK_DATA_API: 'click' + EVENT_KEY + DATA_API_KEY
        };

        var transition = false;

        var TransitionEndEvent = {
            WebkitTransition: 'webkitTransitionEnd',
            MozTransition: 'transitionend',
            OTransition: 'oTransitionEnd otransitionend',
            transition: 'transitionend'
        };

        function getSpecialTransitionEndEvent() {
            return {
                bindType: transition.end,
                delegateType: transition.end,
                handle: function handle(event) {
                    if ($(event.target).is(this)) {
                        return event.handleObj.handler.apply(this, arguments);
                    }
                }
            };
        }

        function transitionEndTest() {
            if (window.QUnit) {
                return false;
            }

            var el = document.createElement('mm');

            for (var name in TransitionEndEvent) {
                if (el.style[name] !== undefined) {
                    return {
                        end: TransitionEndEvent[name]
                    };
                }
            }

            return false;
		}
		
		var Util = {
            TRANSITION_END: 'mmTransitionEnd',

            triggerTransitionEnd: function triggerTransitionEnd(element) {
                $(element).trigger(transition.end);
            },
            supportsTransitionEnd: function supportsTransitionEnd() {
                return Boolean(transition);
            }
        };

        function transitionEndEmulator(duration) {
            var _this2 = this;

            var called = false;

            $(this).one(Util.TRANSITION_END, function () {
                called = true;
            });

            setTimeout(function () {
                if (!called) {
                    Util.triggerTransitionEnd(_this2);
                }
            }, duration);
        }

        function setTransitionEndSupport() {
            transition = transitionEndTest();

            if (Util.supportsTransitionEnd()) {
                $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
            }
        }

        setTransitionEndSupport();

        var MetisMenu = function () {
            function MetisMenu(element, config) {
                _classCallCheck(this, MetisMenu);

                this._element = element;
                this._config = this._getConfig(config);
                this._transitioning = null;

                this.init();
            }

            _createClass(MetisMenu, [{
                key: 'init',
                value: function init() {
                    var self = this;
                    $(this._element).find('li.' + this._config.activeClass).has('ul').children('ul').attr('aria-expanded', true).addClass(this._config.collapseClass + ' ' + this._config.collapseInClass);

                    $(this._element).find('li').not('.' + this._config.activeClass).has('ul').children('ul').attr('aria-expanded', false).addClass(this._config.collapseClass);

                    //add the 'doubleTapToGo' class to active items if needed
                    if (this._config.doubleTapToGo) {
                        $(this._element).find('li.' + this._config.activeClass).has('ul').children('a').addClass('doubleTapToGo');
                    }
                    $(this._element).find('li').has('ul').children('a').on(Event.CLICK_DATA_API, function (e) {
                        var _this = $(this);
                        var _parent = _this.parent('li');
                        var _list = _parent.children('ul');
                        if (self._config.preventDefault) {
                            e.preventDefault();
                        }
                        if (_this.attr('aria-disabled') === 'true') {
                            return;
                        }
                        if (_parent.hasClass(self._config.activeClass) && !self._config.doubleTapToGo) {
                            _this.attr('aria-expanded', false);
                            self._hide(_list);
                        } else {
                            self._show(_list);
                            _this.attr('aria-expanded', true);
                        }

                        if (self._config.onTransitionStart) {
                            self._config.onTransitionStart(e);
                        }

                        //Do we need to enable the double tap
                        if (self._config.doubleTapToGo) {
                            //if we hit a second time on the link and the href is valid, navigate to that url
                            if (self._doubleTapToGo(_this) && _this.attr('href') !== '#' && _this.attr('href') !== '') {
                                e.stopPropagation();
                                document.location = _this.attr('href');
                                return;
                            }
                        }
                    });
                }
            }, {
                key: '_show',
                value: function _show(element) {
                    if (this._transitioning || $(element).hasClass(this._config.collapsingClass)) {
                        return;
                    }
                    var _this = this;
                    var _el = $(element);

                    var startEvent = $.Event(Event.SHOW);
                    _el.trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    _el.parent('li').addClass(this._config.activeClass);

                    if (this._config.toggle) {
                        this._hide(_el.parent('li').siblings().children('ul.' + this._config.collapseInClass).attr('aria-expanded', false));
                    }

                    _el.removeClass(this._config.collapseClass).addClass(this._config.collapsingClass).height(0);

                    this.setTransitioning(true);

                    var complete = function complete() {

                        _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass + ' ' + _this._config.collapseInClass).height('').attr('aria-expanded', true);

                        _this.setTransitioning(false);

                        _el.trigger(Event.SHOWN);
                    };

                    if (!Util.supportsTransitionEnd()) {
                        complete();
                        return;
                    }

                    _el.height(_el[0].scrollHeight).one(Util.TRANSITION_END, complete);

                    transitionEndEmulator(TRANSITION_DURATION);
                }
            }, {
                key: '_hide',
                value: function _hide(element) {

                    if (this._transitioning || !$(element).hasClass(this._config.collapseInClass)) {
                        return;
                    }
                    var _this = this;
                    var _el = $(element);

                    var startEvent = $.Event(Event.HIDE);
                    _el.trigger(startEvent);

                    if (startEvent.isDefaultPrevented()) {
                        return;
                    }

                    _el.parent('li').removeClass(this._config.activeClass);
                    _el.height(_el.height())[0].offsetHeight;

                    _el.addClass(this._config.collapsingClass).removeClass(this._config.collapseClass).removeClass(this._config.collapseInClass);

                    this.setTransitioning(true);

                    var complete = function complete() {
                        if (_this._transitioning && _this._config.onTransitionEnd) {
                            _this._config.onTransitionEnd();
                        }

                        _this.setTransitioning(false);
                        _el.trigger(Event.HIDDEN);

                        _el.removeClass(_this._config.collapsingClass).addClass(_this._config.collapseClass).attr('aria-expanded', false);
                    };

                    if (!Util.supportsTransitionEnd()) {
                        complete();
                        return;
                    }

                    _el.height() == 0 || _el.css('display') == 'none' ? complete() : _el.height(0).one(Util.TRANSITION_END, complete);

                    transitionEndEmulator(TRANSITION_DURATION);
                }
            }, {
                key: '_doubleTapToGo',
                value: function _doubleTapToGo(element) {
                    if (element.hasClass('doubleTapToGo')) {
                        element.removeClass('doubleTapToGo');
                        return true;
                    }
                    if (element.parent().children('ul').length) {
                        $(this._element).find('.doubleTapToGo').removeClass('doubleTapToGo');

                        element.addClass('doubleTapToGo');
                        return false;
                    }
                }
            }, {
                key: 'setTransitioning',
                value: function setTransitioning(isTransitioning) {
                    this._transitioning = isTransitioning;
                }
            }, {
                key: '_getConfig',
                value: function _getConfig(config) {
                    config = $.extend({}, Default, config);
                    return config;
                }
            }], [{
                key: '_jQueryInterface',
                value: function _jQueryInterface(config) {
                    return this.each(function () {
                        var $this = $(this);
                        var data = $this.data(DATA_KEY);
                        var _config = $.extend({}, Default, $this.data(), (typeof config === 'undefined' ? 'undefined' : _typeof(config)) === 'object' && config);

                        if (!data) {
                            data = new MetisMenu(this, _config);
                            $this.data(DATA_KEY, data);
                        }

                        if (typeof config === 'string') {
                            if (data[config] === undefined) {
                                throw new Error('No method named "' + config + '"');
                            }
                            data[config]();
                        }
                    });
                }
            }]);

            return MetisMenu;
        }();

        /**
         * ------------------------------------------------------------------------
         * jQuery
         * ------------------------------------------------------------------------
         */

        $.fn[NAME] = MetisMenu._jQueryInterface;
        $.fn[NAME].Constructor = MetisMenu;
        $.fn[NAME].noConflict = function () {
            $.fn[NAME] = JQUERY_NO_CONFLICT;
            return MetisMenu._jQueryInterface;
        };
        return MetisMenu;
    }(jQuery);
});
if (!Array.prototype.find) {
	Array.prototype.find = function (predicate) {
		if (this == null) {
			throw new TypeError("Array.prototype.find called on null or undefined");
		}
		if (typeof predicate !== "function") {
			throw new TypeError("predicate must be a function");
		}

		return _.find(this, predicate);
	};
}

if (!Array.prototype.filter) {
	Array.prototype.filter = function (fun) {
		return _.filter(this, fun);
	};
}

function safeGet(obj, property) {
	if (obj == undefined) return undefined;

	if ($.isFunction(property)) return property(obj);

	return obj[property];
}

function Utilities() {
	function _ajaxErrorHander(xhr, error, status) {
		var options = this;

		if (
			xhr.status === 401 ||
			(options.ignoreCodes && options.ignoreCodes.indexOf(xhr.status) !== -1) ||
			(options.ignoreStatus && options.ignoreStatus.indexOf(status) !== -1)
		) {
			return;
		}

		if (xhr.status === 400) {
			if (trackerManager) {
				trackerManager.logError("BadRequest", {
					method: options.method,
					url: options.url,
					requestBody: options.payload,
					responseBody: xhr.responseText
				});
			}
		}

		if (xhr.status === 0 || xhr.status >= 500) {
			if (trackerManager) {
				trackerManager.logError("ServerError", {
					method: options.method,
					url: options.url,
					status: xhr.status
				})
			}
		}

		if (options.errorMsg) {
			var errorTitle;
			if (xhr.status === 403) {
				if (xhr.responseJSON && xhr.responseJSON.ErrorType) {
					switch (xhr.responseJSON.ErrorType) {
						case "LicenseResourceLimitExceeded":
							errorTitle = "error-license-limit-exceeded";
							break;

						case "LicenseRequired":
							errorTitle = "error-no-license";
							break;
					}
				} else {
					errorTitle = "insufficient-rights";
				}
			}

			toastr.error(options.errorMsg, r(errorTitle || "server-error"));
		}
	}

	function ajaxOp(method, options) {
		if (!options.url) throw new Error("Missing URL");

		return authManager.getApiTokenAsync()
			.then(function (token) {
				var ajaxConfiguration = {
					method: method,

					// HACK: fix this, all requests not starting with http are expected to be relative and using Uptivo API
					url: options.url.startsWith("http") ? options.url : CONFIGURATION.BASE_API_URL + options.url,


					headers: _.defaults({}, options.headers)
				};

				if (options.noAuth !== true) {
					ajaxConfiguration.headers["Authorization"] = "Bearer " + token;
				}

				if (_.isUndefined(options.payload)) {
					ajaxConfiguration.contentType = options.contentType;
					ajaxConfiguration.data = options.data;
				} else {
					ajaxConfiguration.contentType = "application/json; charset=utf-8";
					if (options.forceJson) {
						ajaxConfiguration.processData = false;
					} else if (options.isRaw) {
						ajaxConfiguration.processData = false;
						ajaxConfiguration.contentType = false;
					}

					ajaxConfiguration.data = options.payload;
				}

				ajaxConfiguration.async = options.async;
				ajaxConfiguration.error = _.get(options, "error", _ajaxErrorHander.bind(_.merge(options, { url: ajaxConfiguration.url, method: ajaxConfiguration.method })));
				ajaxConfiguration.success = options.success;

				return $.ajax(ajaxConfiguration);
			},
				function (error) {
					console.error("ERROR GETTING API TOKEN");
				});

	}

	//                1d        2h         3m           4s         5ms    |  6d           7h           8m          9s         10ms    |  11h        12m          13s       14ms    |   15m       16s       17ms    |  18s    19ms
	var pattern =
		"^(\\d+)\\.(2[0-3]):([0-5][0-9]):([0-5][0-9])(\\.\\d+)?$|^(\\d+)\\.([0-1][0-9]):([0-5][0-9]):([0-5][0-9])(\\.\\d+)?$|^(\\d+):([0-5][0-9]):([0-5][0-9])(\\.\\d+)?$|^(\\d+):([0-5][0-9])(\\.\\d+)?$|^(\\d+)(\\.\\d+)?$";
	var durationRegEx = new RegExp(pattern);

	function getInitials(name) {
		if (name) {
			var initials = "";
			var parts = name.split(/[ -\.,]/);
			for (var i = 0; i < parts.length; i++) {
				initials += parts[i].replace(/[^a-zA-Z0-9]/g, "").substr(0, parts.length > 2 ? 1 : 2);
			}
			return initials.substr(0, 3).toUpperCase();
		}

		return "";
	}

	var colors = [
		"#F44336",
		"#FF4081",
		"#9C27B0",
		"#673AB7",
		"#3F51B5",
		"#2196F3",
		"#03A9F4",
		"#00BCD4",
		"#009688",
		"#4CAF50",
		"#8BC34A",
		"#CDDC39",
		"#FFC107",
		"#FF9800",
		"#FF5722",
		"#795548",
		"#9E9E9E",
		"#607D8B"
	];

	var tagColors = [
		"#A4C400",
		"#60A917",
		"#008A00",
		"#00ABA9",
		"#1BA1E2",
		"#0050EF",
		"#6A00FF",
		"#AA00FF",
		"#F472D0",
		"#D80073",
		"#A20025",
		"#E51400",
		"#A0522D",
		"#F0A30A",
		"#E3C800",
		// "#76608A",
		// "#647687",
		// "#6D8764",
		// "#825A2C"
	];


	function randomColor(name) {
		return colors[name.length % colors.length];
	}

	function tagsRandomColor(name) {
		var hash = 0,
			i, chr;
		if (name.length === 0) return hash;
		for (i = 0; i < name.length; i++) {
			chr = name.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0;
		}

		var idx = hash % tagColors.length;
		var idx = idx < 0 ? idx * -1 : idx;
		return tagColors[idx];
	}

	function betterRandomColor(name) {
		var idx = _.reduce(new TextEncoder().encode(name), function (sum, n) {
			return (sum + n) % colors.length;
		}, 0);
		return colors[idx];
	}


	function lightenColor(hex, amt) {
		// From https://css-tricks.com/snippets/javascript/lighten-darken-color/
		var usePound = false;

		if (hex[0] === "#") {
			hex = hex.slice(1);
			usePound = true;
		}

		var num = parseInt(hex, 16);
		var r = (num >> 16) + amt;

		if (r > 255) r = 255;
		else if (r < 0) r = 0;

		var b = ((num >> 8) & 0x00ff) + amt;

		if (b > 255) b = 255;
		else if (b < 0) b = 0;

		var g = (num & 0x0000ff) + amt;

		if (g > 255) g = 255;
		else if (g < 0) g = 0;

		return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
	}

	return {
		lightenColor: function (hex, amt) {
			// From https://css-tricks.com/snippets/javascript/lighten-darken-color/
			var usePound = false;

			if (hex[0] === "#") {
				hex = hex.slice(1);
				usePound = true;
			}

			var num = parseInt(hex, 16);
			var r = (num >> 16) + amt;

			if (r > 255) r = 255;
			else if (r < 0) r = 0;

			var b = ((num >> 8) & 0x00ff) + amt;

			if (b > 255) b = 255;
			else if (b < 0) b = 0;

			var g = (num & 0x0000ff) + amt;

			if (g > 255) g = 255;
			else if (g < 0) g = 0;

			return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
		},
		randomColor: function (name) {
			return colors[name.length % colors.length];
		},
		betterRandomColor: function (name) {
			var idx = _.reduce(new TextEncoder().encode(name), function (sum, n) {
				return (sum + n) % colors.length;
			}, 0);
			return colors[idx];
		},
		tagsRandomColor: function (name) {
			var hash = 0,
				i, chr;
			if (name.length === 0) return hash;
			for (i = 0; i < name.length; i++) {
				chr = name.charCodeAt(i);
				hash = ((hash << 5) - hash) + chr;
				hash |= 0;
			}

			var idx = hash % tagColors.length;
			var idx = idx < 0 ? idx * -1 : idx;

			return tagColors[idx];
		},
		getInitials: function (name) {
			if (name) {
				var initials = "";
				var parts = name.split(/[ -\.,]/);
				for (var i = 0; i < parts.length; i++) {
					initials += parts[i].replace(/[^a-zA-Z0-9]/g, "").substr(0, parts.length > 2 ? 1 : 2);
				}
				return initials.substr(0, 3).toUpperCase();
			}

			return "";
		},
		preferenceSortingCriteria: function (a, b) {
			var idxA = SYSTEM_MEASURES.SORTING_PREFERENCE.indexOf(a.Name);
			var idxB = SYSTEM_MEASURES.SORTING_PREFERENCE.indexOf(b.Name);
			var loc = resourceManager.getCurrentLocale();

			var res;
			if (idxA < 0 && idxB < 0) {
				res = naturalSort(a.Name.toLocaleLowerCase(loc), b.Name.toLocaleLowerCase(loc));
			} else if (idxA < 0) {
				res = 1;
			} else if (idxB < 0) {
				res = -1;
			} else {
				res = idxA - idxB;
			}
			return res;
		},
		calcEvaluationIndex: function (val) {
			if (!val) return EVALUATIONS.length - 1;

			for (var i = 0; i < EVALUATIONS.length; ++i) {
				if (val >= EVALUATIONS[i].Value) return i;
			}

			return self.EVALUATIONS.length - 2;
		},
		parseDuration: function (durationString) {
			var match = durationRegEx.exec(durationString);
			if (!match) return null;
			var d = {
				milliseconds: match[5] || match[10] || match[14] || match[17] || match[19] || 0,
				seconds: match[4] || match[9] || match[13] || match[16] || match[18] || 0,
				minutes: match[3] || match[8] || match[12] || match[15] || 0,
				hours: match[2] || match[7] || match[11] || 0,
				days: match[1] || match[6] || 0
			};
			return moment.duration(d);
		},
		confirmWindow: function (
			text,
			confirmButtonText,
			callback,
			cancelCallback,
			params,
			index,
			array,
			deleteElement
		) {
			swal(
				{
					title: r("are-you-sure"),
					text: text ? r(text) : r("not-able-to-bring-back"),
					type: "warning",
					showCancelButton: true,
					cancelButtonText: r("cancel"),
					confirmButtonColor: "#DD6B55",
					confirmButtonText: confirmButtonText ? confirmButtonText : r("yes-delete"),
					closeOnConfirm: true
				},
				function (confirmed) {
					if (!confirmed) {
						if (cancelCallback) cancelCallback(params);
						return;
					}

					if (index == undefined || array == undefined) {
						if (callback) callback(params);
						return;
					}

					var elem = array[index];
					if (deleteElement) {
						array.splice(index, 1);
					}

					if (callback) callback(elem);
				}
			);
		},
		blobToFormData: function (blob) {
			var formData = new FormData();
			formData.append("image", blob);
			return formData;
		},
		suggestName: function (base, list, propName) {
			var name = base;
			for (var i = 1; i < 1000; ++i) {
				name = base + " " + i;
				if (
					list.filter(function (t) {
						return t[propName || "Name"].toLowerCase() == name.toLowerCase();
					}).length == 0
				) {
					break;
				}
			}
			return name;
		},
		round: function (data, decimals) {
			decimals = decimals || 0;
			return Number(Math.round(data + "e" + decimals) + "e-" + decimals);
		},
		numeralFmt: function (data, decimals) {
			decimals = decimals || 0;
			var fmt = "0,0";
			if (decimals > 0) {
				fmt += ".";
				for (var i = 0; i < decimals; ++i) {
					fmt += "0";
				}
			} else if (decimals < 0) {
				decimals = -decimals;
				fmt += ".[";
				for (var i = 0; i < decimals; ++i) {
					fmt += "0";
				}
				fmt += "]";
			}

			return numeral(data).format(fmt);
		},
		localizedToJavaScriptNumber: function (value) {
			var tSym = numeral.localeData().delimiters.thousands;
			var dSym = numeral.localeData().delimiters.decimal;

			return value.replace(tSym, '').replace(dSym, '.');
		},
		strip: function (str, config) {
			if (typeof str !== "string") {
				return str;
			}

			config = _.defaults({}, config, {
				stripHtml: true,
				stripNewlines: true,
				decodeEntities: true,
				trim: true
			});

			// Always remove script tags
			str = str.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, "");

			if (config.stripHtml) {
				str = str.replace(/<[^>]*>/g, "");
			}

			if (config.trim) {
				str = str.replace(/^\s+|\s+$/g, "");
			}

			if (config.stripNewlines) {
				str = str.replace(/\n/g, " ");
			}

			return str;
		},
		weekdayNameToNumber: function (dayname) {
			return moment()
				.locale("en")
				.day(dayname)
				.day();
		},
		weekdayBefore: function (m, weekDay) {
			var d = m.clone().day(weekDay);
			if (d.isAfter(m)) {
				d.subtract(7, "days");
			}
			return d;
		},
		weekdayAfter: function (m, weekDay) {
			var d = m.clone().day(weekDay);
			if (d.isBefore(m)) {
				d.add(7, "days");
			}
			return d;
		},
		openModal: function (modalId) {
			$("#" + modalId).modal("show");
		},
		closeModal: function (modalId) {
			$("#" + modalId).modal("hide");
			if (_.some($(".modal.inmodal.in"))) $("body").addClass("modal-open");
		},
		redirectTo: function (route) {
			window.location.hash = route;
		},
		getTable: function (tableId) {
			return $.fn.DataTable.isDataTable(tableId) ? $(tableId).DataTable() : null;
		},
		tagsGetTableSearch: function (tableId, columnName) {
			var dt = utilities.getTable(tableId);
			if (dt) {
				var column = dt.column(columnName + ":name");
				if (column) {
					return utilities.tagsTableFilterDecode(column.search());
				}
			}

			return [];
		},
		tagsSetTableSearch: function (tableId, columnName, tagIds) {
			var dt = utilities.getTable(tableId);
			if (dt) {
				var column = dt.column(columnName + ":name");
				if (column) {
					column.search(utilities.tagsTableFilterEncode(tagIds)).draw();

					var button = dt.button("filterTags:name");
					if (button) {
						button
							.node()
							.find("i")
							.toggleClass("active", !!tagIds.length);
					}
				}
			}
		},
		tagsTableFilterEncode: function (tagIds, joinMode, isGuest) {

			if (joinMode == 'SelfJoin') {
				tagIds.push(-1);
			}

			if (isGuest) {
				tagIds.push(-2);
			}

			return _.map(tagIds, function (tagId) {
				return (
					TAGS_FILTER_CHAR +
					_.reduce(
						tagId.toString(),
						function (acc, val) {
							acc += TAGS_ENCODE_CHARS[val] || val;
							return acc;
						},
						""
					) +
					TAGS_FILTER_CHAR
				);
			}).join(TAGS_FILTER_SEPARATOR);
		},
		tagsTableFilterDecode: function (search) {
			if (search) {
				return _.filter(
					_.map(search.split(TAGS_FILTER_SEPARATOR), function (val) {
						if (_.first(val) == TAGS_FILTER_CHAR && _.last(val) == TAGS_FILTER_CHAR) {
							var tagS = _.reduce(
								_.trim(val, TAGS_FILTER_CHAR),
								function (acc, val) {
									for (var i = 0; i < 10; ++i) {
										if (TAGS_ENCODE_CHARS[i] == val) {
											val = i;
											break;
										}
									}
									acc += val;
									return acc;
								},
								""
							);
							var tag = _.parseInt(tagS);
							return _.isNaN(tag) ? tagS : tag;
						}
					})
				);
			}

			return [];
		},
		drawTableTags: function (tags, joinMode, isGuest) {

			if (_.some(tags, ["ClubTagId", -1])) {
				_.remove(tags, ["ClubTagId", -1])
			}

			if (_.some(tags, ["ClubTagId", -2])) {
				_.remove(tags, ["ClubTagId", -2])
			}

			var plusBtn = ["<span class='AddTagButton uptivo-grid-button uptivo-tag uptivo-tag-button'><i class='fa fa-plus'></i></span>"];
			var tagsRow = plusBtn
				.concat(
					_.map(tags, function (t) {
						return "<span class='uptivo-tag' style='background-color: " + tagsRandomColor(t.Text) + "'>" + t.Text + "</span>";
					})
				);

			if (joinMode == 'SelfJoin') {
				tagsRow = tagsRow.concat(["<span class='RemoveSelfJoinButton uptivo-grid-button uptivo-tag' style='background-color: " + tagsRandomColor(r("self-join-tag")) + "'>" + r("self-join-tag") + "&nbsp;&nbsp;<i class='fa fa-times'></i></span>"]);
			}

			if (isGuest) {
				tagsRow = tagsRow.concat(["<span class='RemoveGuestButton uptivo-grid-button uptivo-tag' style='background-color: " + tagsRandomColor(r("guest-tag")) + "'>" + r("guest-tag") + "&nbsp;&nbsp;<i class='fa fa-times'></i></span>"]);
			}

			return _.join(tagsRow, ' ');
		},
		avatarFilter: function (mode) {
			return mode !== WATCH_MODES.NONE ? WATCH_MODES.FILTER_CHAR : undefined;
		},
		avatarColumn: function (photoUrl, nickname, fallbackUrl, height, watch, editable) {
			var avatar = utilities.generateAvatar(photoUrl, nickname, fallbackUrl, height);
			if (_.isInteger(watch)) {
				avatar = utilities.favoriteAvatar(avatar, watch, editable);
			}
			return avatar;
		},
		favoriteAvatar: function (avatarImg, value, editable) {
			if (!_.isInteger(value) || (value === WATCH_MODES.NONE && !editable)) return avatarImg;

			var container = $(
				"<div class='PhotoWatchButton photo-watch-container" +
				(editable ? " hover-icon-buzz-out uptivo-grid-button" : "") +
				"'>"
			);
			var status = $("<div class='photo-watch-status" + (editable ? " icon-buzz-out" : "") + "'>");

			status.append(WATCH_MODES.ICONS[value]);
			container.append(avatarImg).append(status);

			return container
				.wrap("<div>")
				.parent()
				.html();
		},
		generateAvatar: function (photoUrl, nickname, fallbackUrl, height) {
			if (photoUrl) {
				return "<img class='img-avatar' src='" + photoUrl + "' />";
			} else if (nickname) {
				var backgroundColor = randomColor(nickname);
				var fontColor = lightenColor(backgroundColor, 80);
				var initials = getInitials(nickname);
				var style =
					"background-color:" +
					backgroundColor +
					";color:" +
					fontColor +
					";font-size:" +
					Math.floor(height / 2.5) +
					"px;line-height:" +
					(height - 2) +
					"px";
				return (
					"<div class='img-avatar syntetic-avatar' style=\"" + style + '"><span>' + initials + "</span></div>"
				);
			} else if (fallbackUrl) {
				return "<img class='img-avatar' src='" + fallbackUrl + "' />";
			} else {
				return "<img class='img-avatar' src='" + CONFIGURATION.DEFAULT_PHOTO + "' />";
			}
		},
		formatDuration: function (duration) {
			if (!moment.isDuration(duration)) {
				duration = moment.duration(duration);
			}

			return duration.format((duration.years() > 0 || duration.months() > 0 || duration.days() > 0) ? "d.hh:mm:ss" : "hh:mm:ss", { trim: false, forceLength: true });
		},
		formatDurationShort: function (duration) {
			if (!moment.isDuration(duration)) {
				duration = moment.duration(duration);
			}

			return duration.format((duration.years() > 0 || duration.months() > 0 || duration.days() > 0 || duration.hours() > 0) ? "hh:mm:ss" : "mm:ss", { trim: false, forceLength: true });
		},
		getDurationMs: function (formattedDuration) {
			return moment.duration(formattedDuration || 0).as("ms");
		},
		weekDayNumber: function (dayName) {
			var dn = _.indexOf(
				["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"],
				dayName.toLowerCase()
			);
			return dn < 0 ? 0 : dn;
		},
		getTrainingTypeIconUrl: function (type) {
			return "template/assets/img/training-types/{0}.svg".format(type || "Unspecified");
		},
		getServiceTypeIconUrl: function (type) {
			return "template/assets/img/service-types/{0}.svg".format(type || "Unspecified");
		},
		getTrainingTypeName: function (type) {
			return r((type || "Unspecified") + "Type");
		},
		getServiceTypeName: function (type) {
			return r((type || "UnspecifiedService") + "Type");
		},
		getDistance: function (p1, p2) {
			var rad = function (x) {
				return (x * Math.PI) / 180;
			};
			var dLat = rad(p2.lat - p1.lat);
			var dLong = rad(p2.lng - p1.lng);
			var a =
				Math.sin(dLat / 2) * Math.sin(dLat / 2) +
				Math.cos(rad(p1.lat)) * Math.cos(rad(p2.lat)) * Math.sin(dLong / 2) * Math.sin(dLong / 2);
			var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
			var d = CONSTANTS.EARTH_RADIUS_METERS * c;
			return d; // returns the distance in meter
		},
		defaultGet: function (options) {
			return ajaxOp(
				"GET",
				_.defaults(options, {
					errorMsg: r("get-failed")
				})
			);
		},
		defaultUpdate: function (options) {
			if (!options.payload && !options.isRaw) throw new Error("Missing data");

			return ajaxOp(
				"PUT",
				_.defaults(options, {
					errorMsg: r("update-failed")
				})
			);
		},
		defaultDelete: function (options) {
			return ajaxOp(
				"DELETE",
				_.defaults(options, {
					errorMsg: r("delete-failed")
				})
			);
		},
		defaultCreate: function (options) {
			return ajaxOp(
				"POST",
				_.defaults(options, {
					errorMsg: r("creation-failed")
				})
			);
		},
		defaultPartialUpdate: function (options) {
			return ajaxOp(
				"POST",
				_.defaults(options, {
					errorMsg: r("update-failed")
				})
			);
		},
		getPercentage: function (value, total) {
			if (!value || !total || total == 0) return 0;
			if (isNaN(+value)) return "N/A";
			return Math.round((value * 100) / total);
		},
		getMomentDateFormat: function (uptivoFormat) {
			switch (uptivoFormat) {
				case "mmddyyyy":
					return "MM/DD/YYYY";
				case "ddmmyyyy":
					return "DD/MM/YYYY";
				case "yyyymmdd":
					return "YYYY/MM/DD";
			}
		},
		formatDate: function (datetime, ui) {
			return moment(datetime).format(this.getMomentDateFormat(ui.DateFormat));
		},
		formatTimeStamp: function (ts, ui, sep, withSeconds) {
			return ts && ts.isValid()
				? ts.format(
					utilities.getMomentDateFormat(ui.DateFormat) +
					(sep || " ") +
					utilities.getMomentTimeFormat(ui.TimeFormat, withSeconds)
				)
				: "";
		},
		getMomentTimeFormat: function (uptivoFormat, withSeconds) {
			switch (uptivoFormat) {
				case "h24":
					return withSeconds ? "HH:mm:ss" : "HH:mm";
				case "h12":
					return withSeconds ? "h:mm:ss A" : "h:mm A";
			}
		},
		formatTime: function (datetime, ui, withSeconds) {
			return moment(datetime).format(this.getMomentTimeFormat(ui.TimeFormat, withSeconds));
		},
		getMomentTimeSortable: function (datetime) {
			return datetime.format("HHmmssSSSSSSSSS");
		},
		getMomentDateSortable: function (datetime) {
			return datetime.format("YYYYMMDD");
		},
		getMomentDateTimeSortable: function (datetime) {
			return this.getMomentDateSortable(datetime) + this.getMomentTimeSortable(datetime);
		},
		removeIllegalFilenameChars: function (name) {
			return name.replace(/[\\/:"*?<>|]/g, "");
		},
		getDateOfISOWeek: function (w, y) {
			var simple = new Date(y, 0, 1 + (w - 2) * 7);
			var dow = simple.getDay();
			var ISOweekStart = simple;
			if (dow <= 4) ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
			else ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
			return ISOweekStart;
		},
		showLoader: function () {
			$(".loader").show();
		},
		hideLoader: function () {
			$(".loader").hide();
		},
		setNoAccessComponent: function () {
			routing.changeComponent("NoAccess");
		},
		getLanguageCode: function (languageEnglishName) {
			var l = _.find(LANGUAGES, { name: languageEnglishName });
			return l ? l.shortname : null;
		},
		ceilToTens: function (number) {
			return Math.ceil(number / 10) * 10;
		},
		floorToTens: function (number) {
			return Math.floor(number / 10) * 10;
		},
		roundToTens: function (number) {
			return Math.round(number * 10) / 10;
		},
		convertToMiles: function (km) {
			return km * 0.621371192;
		},
		convertToFeet: function (m) {
			return m * 3.280839895;
		},
		validateSensorId: function (submit, input, isRequired) {
			if ((!isRequired && $(input).val().length == 0) || $(input).val().length == 7) {
				$(submit).prop("disabled", false);
			} else {
				$(submit).prop("disabled", true);
			}
		},
		keepScrollBarAtElement: function (div) {
			$(document.body).scrollTop($(div)[0].scrollHeight);
		},
		pad: function (n, width, z) {
			z = z || "0";
			n = n + "";
			return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
		},
		average: function (arr) {
			if (!arr || !arr.length) return 0;
			var sum = 0;
			for (var i = 0; i < arr.length; ++i) sum += arr[i];
			return sum / arr.length;
		},
		translateUptivoLevel: function (level) {
			var UptivoLevel = "UptivoLevel" + ((level || 0));
			return r(UptivoLevel);
		},
		generateWorkoutSheetId: function (folder, fileId, clubId, userId) {

			var id = ["Folder=" + folder];

			if (fileId) {
				id.push("FileId=" + fileId);
			}

			if (clubId) {
				id.push("ClubId=" + clubId);
			}

			if (userId) {
				id.push("UserId=" + userId);
			}

			return id.join("&");
		},
		trainingDuration: function (training) {
			var begin = moment(training.Begin);
			var end = moment(training.End);

			if (begin.isValid() && end.isValid() && end.isAfter(begin)) {
				return moment.duration(end.diff(begin));
			}

			return moment.duration(training.Duration);
		},
		trainingZonesBar: function (totalZonesTime, zones) {
			var svgChart = _.reduce(
				zones,
				function (svg, zoneDuration, idx) {
					var prc = utilities.getPercentage(utilities.getDurationMs(zoneDuration), utilities.getDurationMs(totalZonesTime));
					if (prc > 0) {
						svg.text +=
							"<rect height='100%' x='" +
							svg.pos +
							"%' width='" +
							prc +
							"%' fill='" +
							ENUMS.ZONE_COLORS["ZONE_" + idx] +
							"'/>";
						svg.pos += prc;
					}
					return svg;
				},
				{
					text: "",
					pos: 0,
				}
			);

			return (
				"<svg width='100%' height='22px'><rect width='100%' height='100%' fill='#f5f5f5'/>" +
				svgChart.text +
				"</svg>"
			);
		},
		openWatchMenu: function (self, $element, $row, currentWatchMode, userId, setWatchModeFx) {
			var addClass;
			if ($row.is(":first-child")) {
				addClass = " photo-watch-menu-top";
			} else if ($row.is(":last-child")) {
				addClass = " photo-watch-menu-bottom";
			} else {
				addClass = "";
			}
			self.$menu = $(
				"<div class='photo-watch-menu" +
				addClass +
				"'><ul>" +
				"<li" +
				(currentWatchMode == WATCH_MODES.NONE ? " class='active'" : "") +
				" data-wm='" +
				WATCH_MODES.NONE +
				"'><i class='fa fa-star-o'></i> " +
				r("dont-follow") +
				"</li>" +
				"<li" +
				(currentWatchMode == WATCH_MODES.FOLLOW ? " class='active'" : "") +
				" data-wm='" +
				WATCH_MODES.FOLLOW +
				"'><i class='fa fa-star'></i> " +
				r("follow") +
				"</li>" +
				"<li" +
				(currentWatchMode == WATCH_MODES.NOTIFY ? " class='active'" : "") +
				" data-wm='" +
				WATCH_MODES.NOTIFY +
				"'><i class='fa fa-eye'></i> " +
				r("watch") +
				"</li>" +
				"</ul></div>"
			);
			$element.append(self.$menu);
			self.$menu.find("li").click(function () {
				var selection = $(this).data("wm");
				if (currentWatchMode !== selection) {
					setWatchModeFx(selection, userId);
				}
			});
		},
		generateActivityIcon: function (activity, paddingLeft, paddingTop) {
			var displayName = utilities.getTrainingTypeName(activity.TrainingType);
			var link = activity.CalendarType == "Services" ? utilities.getServiceTypeIconUrl(activity.TrainingType) : utilities.getTrainingTypeIconUrl(activity.TrainingType);

			return '<div style="display: inline-block; background-color: ' + activity.Color + '; height: 30px; width: 30px; border-radius: 5px; padding-left: ' + (paddingLeft || 0) + 'px; padding-top: ' + (paddingTop || 0) + 'px" data-toggle="tooltip" data-container="body" title="' + displayName + '">' +
				'<img class="training-type" style="width: 20px; height: 20px" src="' + link + '" data-bind="src: training.TrainingTypeIcon }" />' +
				'</div>'
		},
		generateActivityWhen: function (activity) {
			return moment(activity.Begin).format(utilities.getMomentDateFormat(userData.get().DateFormat)) + " " + moment(activity.Begin).format(utilities.getMomentTimeFormat(userData.get().TimeFormat, false)) + " - " + moment(activity.End).format(utilities.getMomentTimeFormat(userData.get().TimeFormat, false));
		},
		generateSubscriptionCircleById: function (subscriptionId, clubSubscriptions) {
			var subscription = _.find(clubSubscriptions(), function (s) { return s.ClassSubscriptionId == subscriptionId });
			var name = subscription ? subscription.Name : "";

			var color = utilities.betterRandomColor(name);

			return '<div class="subscriptions-circle-small" style="display: inline-block;  margin-left: 4px; margin-bottom: 1px; background-color: ' + color + '; color: ' + utilities.lightenColor(color, 80) + '" title="' + name + '" >' +
				'<span>' + utilities.getInitials(name) + '</span>' +
				'</div>';
		},
		parseAddAtleteAsParticipantsErrors: function (response) {
			var responseErrorArray = _.map(response.responseJSON, function (e) { return e.ErrorType });

			var errorsArray = [];

			if (response.responseJSON.ErrorType == "ClassIsFinished") {
				errorsArray.push(r("could-not-add-participant-after-end-date"));
			} else if (response.responseJSON.ErrorType == "ClassNotPublished") {
				errorsArray.push(r("unable-to-add-participants-if-the-status-is-unpublished"));
			} else if (response.responseJSON.ErrorType == "Conflict") {
				errorsArray.push(r("already-participant"));
			} else if (response.responseJSON.ErrorType == "ClassNotBookable") {
				errorsArray.push(r("no-registration-required"));
			} else {
				if (responseErrorArray.includes("ClassBookingIsEarly")) {
					errorsArray.push(r("registrations-are-not-yet-open"));
				}
				if (responseErrorArray.includes("ClassBookingIsPastDue")) {
					errorsArray.push(r("registration-is-closed"));
				}
				if (responseErrorArray.includes("ClassHasStarted")) {
					errorsArray.push(r("event-already-started"));
				}
				if (responseErrorArray.includes("ClassFull")) {
					errorsArray.push(r("places-available-exceeded"));
				}
				if (responseErrorArray.includes("NotEnoughCredits")) {
					errorsArray.push(r("not-enought-credits"));
				}
				if (responseErrorArray.includes("NoValidSubscriptions")) {
					errorsArray.push(r("no-valid-subscriptions"));
				}
				if (responseErrorArray.includes("InvalidPaymentOption")) {
					errorsArray.push(r("invalid-payment-option"));
				}
				if (responseErrorArray.includes("ClubLimitsExceeded") || responseErrorArray.includes("SubscriptionLimitsExceeded")) {
					errorsArray.push(r("club-limits-exceeded"));
				}
				if (responseErrorArray.includes("AthleteBookingDisabled")) {
					errorsArray.push(r("bookings-blocked-athlete"));
				}
				if (responseErrorArray.includes("RequiredMedicalCertificate")) {
					errorsArray.push(r("AthleteExpExpiredMedicalCertificateUser"));
				}
				if (responseErrorArray.includes("RequiredMembership")) {
					errorsArray.push(r("AthleteExpExpiredMembershipUser"));
				}
				if (responseErrorArray.includes("PoliciesNotAccepted")) {
					errorsArray.push(r("PoliciesNotAccepted"));
				}
			}

			return errorsArray;
		},
		generateUserSubscriptionPaymentStateAndColor: function (sub) {

			if (!sub.ExtInvoiceId && !sub.ExtSubscriptionId) { // Subcription has no external Payment (assigned only in Uptivo - ex. paid in cash)
				return null;
			}

			var userInfo = userData.get();
	
			var subPaymentStatus = {
				status: null,
				statusColor: null,
				formattedDueDate: null
			}
	
			if (sub.ExtSubscriptionId) { //recurrent payment
	
				if (sub.ExtStatus == "active") {
	
					if (!sub.DueDateUTC) {
						subPaymentStatus.status = "paid";
						subPaymentStatus.statusColor = "green";
					}
	
					if (moment(sub.DueDateUTC).isAfter()) {
						subPaymentStatus.status = "to-pay";
						subPaymentStatus.statusColor = "orange";
						subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
					}
	
					if (moment(sub.DueDateUTC).isBefore()) {
						subPaymentStatus.status = "unpaid";
						subPaymentStatus.statusColor = "red";
						subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
					}
	
				}
	
				if (sub.ExtStatus == "past_due") {
					subPaymentStatus.status = "to-pay";
					subPaymentStatus.statusColor = "orange";
					subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
				}
	
				if (sub.ExtStatus == "canceled") {;
					subPaymentStatus.status = "canceled";
					subPaymentStatus.statusColor = "red";
				}
	
				if (sub.ExtStatus == "unpaid") {
					subPaymentStatus.status = "unpaid";
					subPaymentStatus.statusColor = "red";
					subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
				}
	
				if (sub.ExtStatus == "paused") {
					subPaymentStatus.status = "paused";
					subPaymentStatus.statusColor = "orange";
				}
	
			} else { // one time payment (duration) with only one invoice
				if (sub.ExtStatus == "paid") {
					subPaymentStatus.status = "paid";
					subPaymentStatus.statusColor = "green";
				} else if (moment(sub.DueDateUTC).isAfter()) {
					subPaymentStatus.status = "to-pay";
					subPaymentStatus.statusColor = "orange";
					subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
				} else {
					subPaymentStatus.status = "unpaid";
					subPaymentStatus.statusColor = "red";
					subPaymentStatus.formattedDueDate = moment(sub.DueDateUTC).format(utilities.getMomentDateFormat(userInfo.DateFormat));
				}
			}
	
			return subPaymentStatus;
		},
		calculateSource: function(data) {
			var source = "Unknow";

			if (!data.DataSource && data.DataType == "GarminHealthAPI") {
				source = "Garmin";
			} else if (data.DataSource && data.DataSource.Type) {
				source = data.DataSource.Type;
			}

			return source;
		},
		generateSourceIconHtml: function (source) {
			if (source == "Unknow" || !source) {
				return;
			}

			switch (source) {
				case "Unknow":
					sourceData = undefined;
					break;
				case "Uptivo":
					sourceData = {	
						iconClass: "uptivo-circle-logo",
						title: "Uptivo"		
					}
					break;
				case "Garmin":
					sourceData = {	
						iconClass: "garmin-logo",
						title: "Garmin"		
					}
					break;
				case "AppleHealth":
					sourceData = {	
						iconClass: "apple-health-logo",
						title: "Apple Health"		
					}
					break;
				case "GoogleHealth":
					sourceData = {	
						iconClass: "google-health-logo",
						title: "Google Health Connect"		
					}
					break;
			}

			return `<i class="${sourceData.iconClass}" title="${sourceData.title}"></i></span>`;
		},
	};
}

if (typeof module !== "undefined" && module.hasOwnProperty("exports")) {
	module.exports = Utilities;
}

function NotifManager() {
	var self = this;

	self.computedTemplates = {};

	self.supported = function (notification) {
		return _.includes(ENUMS.SUPPORTED_NOTIFICATIONS, notification.Event);
	};

	self.computeDetails = function (notification, userInfo) {
		var messageEventName;

		switch (notification.Event) {
			case "ClassUnsubscription":
				messageEventName = "class-unsubscription";

				if (_.has(notification, "ClubLogEntryId")) {
					messageEventName = "log-" + messageEventName;
					if (!notification.Actor || notification.Actor.UserId == notification.Target.UserId) {
						messageEventName += "-self";
					}
				}
				break;

			case "InvitationExpired":
				if (notification.Target.Nickname) {
					messageEventName = "user-expired";
				} else {
					messageEventName = "invitation-link-expired";
				}
				break;

			case "PendingUserExpired":
				messageEventName = "user-expired";
				break;

			case "PendingUserAccepted":
			case "InvitationAccepted":
				messageEventName = "user-accepted";
				break;

			case "UserLeftClub":
				if (notification.Actor == null || notification.Actor.UserId == notification.Target.UserId)
					messageEventName = "user-left-club";
				else if (notification.Actor.UserId != notification.Target.UserId)
					messageEventName = "removed-from-club";
				break;

			case "UserMeasureExpired":
				if (!notification.Target.LastMeasurementUtc && !notification.Target.LastMetricUtc)
					messageEventName = "user-measure-expired-first";
				else messageEventName = "user-measure-expired";
				break;

			case "StartedLive":
				if (
					notification.Target == null ||
					notification.Actor == null ||
					notification.Actor.UserId == notification.Target.UserId
				)
					messageEventName = "started-live-self";
				else if (notification.Actor.UserId != notification.Target.UserId) messageEventName = "started-live";
				break;

			case "OrderFulfilled":
				if (notification.Target.OrderType == "Subscription") {
					messageEventName = "sub-purchase";
				} else {
					messageEventName = "credits-purchase";
				}
				break;

			case "CreatedUser":
			case "CreatedInvitation":
				if (notification.Actor == null) {
					notification.Actor = {
						Nickname: "Uptivo API",
					};
				}
			case "UserSubscriptionExpiring":
			case "UserSubscriptionExpired":
			case "AthleteExpExpiring":
			case "AthleteExpExpired":
				notification.Event = self.computeEvent(notification);
				break;

			case "UserSubscriptionDelete":
			case "UserSubscriptionUpdate":
			case "UserSubscriptionAdd":
			case "UserSubscriptionSuspend":
			case "UserSubscriptionReactivate":
				if (notification.UserId != notification.Target.UserId) {
					messageEventName = _.kebabCase(notification.Event + "Manager");
				}
				if (!notification.Actor || !notification.Actor.Nickname) {
					notification.Actor = {
						Nickname: "Uptivo API"
					}
				}
				break;

			case "EncodingJobSuccess":
				messageEventName = "exercise-video-ready";
				break;

			case "EncodingJobError":
				messageEventName = "exercise-video-processing-error";
				break;

			case "EmailError":
				if (!notification.Target.Nickname) {
					messageEventName = "email-error-no-nickname";
				}
				break;

			case "InvitationEmailError":
				if (!notification.Target.Nickname) {
					messageEventName = "invitation-email-error-no-nickname";
				}
				break;

			case "TrainingFeedback":
				messageEventName = notification.Event;
				break;
		}


		if (!messageEventName) {
			messageEventName = _.kebabCase(notification.Event);
		}

		var template = self.computedTemplates[messageEventName];
		if (!template) {
			template = _.template(r(messageEventName + "-tpl"));
			self.computedTemplates[messageEventName] = template;
		}

		return template({
			notification: notification,
			userInfo: userInfo
		});
	};

	self.computeSearch = function (notification) {
		var elements = [
			_.get(notification, "Actor.Nickname"),
			_.get(notification, "Actor.Email"),
			_.get(notification, "Target.Nickname"),
			_.get(notification, "Target.Email"),
		];

		return _.join(_.uniq(elements), " ");
	};

	self.computeEvent = function (notification) {
		var notificationEvent = null;

		// ABBONAMENTI SCADUTI O SENZA TICKET
		if (notification.Event == "UserSubscriptionExpired") {
			if (notification.Target.AvailableActivities == 0) {
				notificationEvent = "UserSubscriptionExpiredTicket"; // abbonamento ha finito i ticket
			} else {
				notificationEvent = "UserSubscriptionExpiredDate"; // abbonamento è scaduto nel tempo
			}
			if (notification.UserId == notification.Target.UserId) {
				notificationEvent = notificationEvent + "User";
			} else {
				notificationEvent = notificationEvent + "Manager";
			}
		}

		// ABBONAMENTI IN SCADENZA O CON UN SOLO TICKET
		if (notification.Event == "UserSubscriptionExpiring") {
			if (notification.Target.AvailableActivities == 1) {
				notificationEvent = "UserSubscriptionExpiringTicket"; // abbonamento ha 1 ticket
			} else {
				notificationEvent = "UserSubscriptionExpiringDate"; // abbonamento è quasi scaduto nel tempo
			}
			if (notification.UserId == notification.Target.UserId) {
				notificationEvent = notificationEvent + "User";
			} else {
				notificationEvent = notificationEvent + "Manager"; // non dovrebbero essercene
			}
		}

		// SCADENZE SCADUTE
		if (notification.Event == "AthleteExpExpired") {
			switch (notification.Target.ExpirationType) {
				case "MedicalCertificate":
					notificationEvent = "AthleteExpExpiredMedicalCertificate";
					break;
				case "Membership":
					notificationEvent = "AthleteExpExpiredMembership";
					break;
				case "Generic":
					notificationEvent = "AthleteExpExpiredGeneric";
					break;
			}

			if (notification.UserId == notification.Target.UserId) {
				notificationEvent = notificationEvent + "User";
			} else {
				notificationEvent = notificationEvent + "Manager";
			}
		}

		// SCADENZE IN SCADENZA
		if (notification.Event == "AthleteExpExpiring") {
			switch (notification.Target.ExpirationType) {
				case "MedicalCertificate":
					notificationEvent = "AthleteExpExpiringMedicalCertificate";
					break;
				case "Membership":
					notificationEvent = "AthleteExpExpiringMembership";
					break;
				case "Generic":
					notificationEvent = "AthleteExpExpiringGeneric";
					break;
			}

			if (notification.UserId == notification.Target.UserId) {
				notificationEvent = notificationEvent + "User";
			} else {
				notificationEvent = notificationEvent + "Manager"; // non dovrebbero essercene
			}
		}

		return notificationEvent ? notificationEvent : notification.Event;
	};
}

var notifManager = new NotifManager();

function UptivoUserDataProvider() {
	var self = this;
	var cached;

	this._updateUserInfo = function(userInfo) {
		cached = userInfo;

		if (trackerManager) {
			trackerManager.setUserId(cached ? cached.UserId : null);
		}
	};

	this._updateRoles = function(roles) {
		var role;
		if (cached) {
			cached.AvailableRoles = roles;
			role = cached.highestRole();
		}

		if (trackerManager) {
			trackerManager.setHighestRole(role);
		}
	};

	this._updateWatch = function(watch) {
		var found = $.grep(cached.Watches, function(el) {
			return el.WatcherId == watch.WatcherId && el.WatchedId == watch.WatchedId && el.Type == watch.Type;
		});

		if (found.length) {
			$.each(found, function(idx, el) {
				el.NotifyWatcher = watch.NotifyWatcher;
			});
		} else {
			cached.Watches.push(watch);
		}
	};

	this._deleteWatch = function(watcherId, watchedId, type) {
		cached.Watches = $.grep(cached.Watches, function(el) {
			return !(el.WatcherId == watcherId && el.WatchedId == watchedId && (!type || el.Type == type));
		});
	};

	this.updateWatchFromApi = function(watchedId, type) {
		var prm = $.Deferred();
		if (!cached.UserId || !cached.Watches) {
			prm.reject();
		} else {
			userService
				.getWatch(cached.UserId, watchedId, type)
				.done(function(watch) {
					self._updateWatch(watch);
					prm.resolve(watch);
				})
				.fail(function(xhr, error, status) {
					if (status === "Not Found") {
						self._deleteWatch(cached.UserId, watchedId, type);
						prm.resolve(null);
					} else {
						prm.reject(xhr);
					}
				});
		}
		return prm;
	};

	this.addWatch = function(watchedId, type, notify) {
		var prm = $.Deferred();
		if (!cached.UserId || !cached.Watches) {
			prm.reject();
		} else {
			userService
				.addWatch(cached.UserId, watchedId, type, notify)
				.done(function(watch) {
					self._updateWatch(watch);
					prm.resolve(watch);
				})
				.fail(function(xhr, error, status) {
					prm.reject(xhr);
				});
		}
		return prm;
	};

	this.deleteWatch = function(watchedId, type) {
		var prm = $.Deferred().done(function(watch) {
			self._deleteWatch(cached.UserId, watchedId, type);
		});

		if (!cached.UserId || !cached.Watches) {
			prm.reject();
		} else {
			userService
				.deleteWatch(cached.UserId, watchedId, type)
				.done(function(watch) {
					prm.resolve(watch);
				})
				.fail(function(xhr, error, status) {
					if (status === "Not Found") {
						prm.resolve(null);
					} else {
						prm.reject(xhr);
					}
				});
		}
		return prm;
	};

	this.updateWatchesFromApi = function() {
		if (!cached.UserId) return $.Deferred().reject();

		return userService.getWatches(cached.UserId).then(function(watches) {
			cached.Watches = watches;
		});
	};

	this.updateRolesFromApi = function() {
		if (!cached.UserId) return $.Deferred().reject();

		return userService.getRoles(cached.UserId).then(function(roles) {
			self._updateRoles(roles);

			eventBus.publish("UserDataChanged", cached);
			eventBus.publish("UserRolesChanged", cached.AvailableRoles);
			return roles;
		});
	};

	this.updateUserFromApi = function() {
		var data = {};

		return userService
			.getSelf()
			.then(function(user) {
				data.user = user;
				return userService.getRoles(data.user.UserId);
			})
			.then(function(roles) {
				data.roles = roles;
				return userService.getWatches(data.user.UserId);
			})
			.then(function(watches) {
				data.Watches = watches;
			})
			.then(function() {
				var info = new UserInfo();
				ko.ext.updateViewModel(info, data.user, true);
				info.IsUptivoAdmin = authManager.isUptivoAdmin();
				info.IsUptivoEditor = authManager.isUptivoEditor();

				self._updateUserInfo(info);

				resourceManager.setCurrentLanguage(utilities.getLanguageCode(data.user.Language));
				self._updateRoles(data.roles);

				cached.Watches = data.Watches;

				eventBus.publish("UserDataChanged", cached);
				eventBus.publish("UserRolesChanged", cached.AvailableRoles);
			});
	};

	self.update = function(data) {
		if (cached) {
			for (var property in data) {
				if (cached.hasOwnProperty(property)) {
					cached[property] = data[property];
				}
			}
			eventBus.publish("UserDataChanged", cached);
		}
	};

	this.get = function() {
		return cached;
	};

	this.clear = function() {
		self._updateUserInfo();
		self._updateRoles();

		eventBus.publish("UserDataChanged");
	};

	return this;
}

USER_ROLES = {
	ATHLETE: "Athlete",
	TRAINER: "Trainer",
	OWNER: "Owner",
	MANAGER: "Manager",
	USER: "User",
	ALL: "ALL"
};

function UserInfo(raw) {
	var self = this;
	$.extend(this, raw);

	this.hasAthleteRole = function(clubId) {
		return self.hasRole(USER_ROLES.ATHLETE, clubId);
	};

	this.hasTrainerRole = function(clubId) {
		return self.hasRole(USER_ROLES.TRAINER, clubId);
	};

	this.hasManagerRole = function(clubId) {
		return self.hasRole(USER_ROLES.MANAGER, clubId);
	};
	
	this.hasOwnerRole = function(brandId) {
		return self.hasRole(USER_ROLES.OWNER, brandId);
	};

	this.hasRole = function(role, resourceId) {
		if (role === USER_ROLES.USER || role === USER_ROLES.ALL) return true;

		if (self.AvailableRoles) {
			var roles = self.AvailableRoles[role];

			if (roles) {
				var filter;

				if (resourceId) {
					switch(role) {
						case USER_ROLES.TRAINER:
						case USER_ROLES.MANAGER:
							filter = { ClubId: _.toInteger(resourceId) };
							break;
		
						case USER_ROLES.OWNER:
							filter = { BrandId: _.toInteger(resourceId) };
					}
				}
	
				return _.some(roles, filter);
			}
		}

		return false;
	};

	this.highestRole = function() {
		var roles = [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER, USER_ROLES.ATHLETE];

		for (var r = 0; r < roles.length; ++r) {
			if (self.hasRole(roles[r])) {
				return roles[r];
			}
		}

		return USER_ROLES.USER;
	};

	this.getWatch = function(watchedId, type) {
		if (self.Watches) {
			var found = $.grep(self.Watches, function(el) {
				return el.WatchedId == watchedId && (!type || el.Type == type);
			});

			if (found.length > 0) {
				return found[0];
			}
		}

		return null;
	};

	this.getWatchNotify = function(watchedId, type) {
		var watch = self.getWatch(watchedId, type);
		return watch ? watch.NotifyWatcher : null;
	};

	this.getTrainerWatchNotifyStatus = function(userId) {
		if (self.UserId === userId) {
			return WATCH_MODES.NONE;
		}
		switch (self.getWatchNotify(userId, "TrainerWatch")) {
			case false:
				return WATCH_MODES.FOLLOW;

			case true:
				return WATCH_MODES.NOTIFY;

			default:
				return WATCH_MODES.NONE;
		}
	};

	this.isInOneOfRoles = function(roles, clubId) {
		var result = false;

		for (var i = 0; i < roles.length && !result; i++) {
			result = self.hasRole(roles[i], clubId);
		}

		return result;
	};

	this.managerClubs = function() {
		if (!self.AvailableRoles) return [];

		return self.AvailableRoles.Manager;
	};

	this.trainerClubs = function() {
		if (!self.AvailableRoles) return [];

		return self.AvailableRoles.Trainer;
	};

	this.getClubs = function() {
        if (!self.AvailableRoles) return [];
        return _.unionBy(
            self.AvailableRoles.Athlete,
            self.AvailableRoles.Trainer,
            self.AvailableRoles.Manager,
            "ClubId"
        );
    };
 
    this.getBrands = function() {
        if (!self.AvailableRoles) return [];
        return self.AvailableRoles.Owner;
    }
}

var ENUMS = {
	WEEK_START_DAYS: {
		MONDAY: "Monday",
		SATURDAY: "Saturday",
		SUNDAY: "Sunday",
	},
	DATE_FORMATS: {
		DMY: "ddmmyyyy",
		MDY: "mmddyyyy",
		YMD: "yyyymmdd",
	},
	TIME_FORMATS: {
		FULL_CLOCK: "h24",
		HALF_CLOCK: "h12",
	},
	UNITS: {
		METRIC: "Metric",
		IMPERIAL: "Imperial",
	},
	ZONE_COLORS: {
		ZONE_0: "#afabab",
		ZONE_1: "#9dc3e6",
		ZONE_2: "#09c",
		ZONE_3: "#090",
		ZONE_4: "#fd8003",
		ZONE_5: "#d20000",
	},
	GENDERS: {
		UNSPECIFIED: "Unspecified",
		MALE: "Male",
		FEMALE: "Female",
	},
	GENDER_ICONS: {
		UNSPECIFIED: "fa-genderless",
		MALE: "fa-mars",
		FEMALE: "fa-venus",
	},
	SUBSCRIPTION_TYPE: {
		INVITE: "Invite",
		OPEN: "Open",
		EXTERNAL: "External",
	},
	SUBSCRIPTION_TYPE_ICONS: {
		INVITE: "fa-lock",
		OPEN: "fa-unlock",
	},
	TRAINING_COLORS: {
		GROUP_TRAINING_BG_COLOR: "#3a87ad",
		INDIVIDUAL_TRAINING_APP_BG_COLOR: "#00b050",
		INDIVIDUAL_TRAINING_CLUB_BG_COLOR: "#f3712a",
		INDIVIDUAL_TRAINING_LIVE: "#8b33ff",
	},
	DISPLAY_GROUP_COLORS: ["#008600", "#fd8003", "#0099cc", "#333453", "#908d8d", "#d20000"],
	SUPPORTED_NOTIFICATIONS: [
		"CreatedUser",
		"PendingUserExpired",
		"PendingUserAccepted",
		"CreatedInvitation",
		"InvitationExpired",
		"InvitationAccepted",
		"UserLeftClub",
		"UserIsBack",
		"TrainerAwards",
		"LevelUpdate",
		"ClubMessage",
		"WorkoutProgramShare",
		"UserMeasureExpired",
		"StartedLive",
		"ClassSubscription",
		"ClassUnsubscription",
		"CreditsAdd",
		"CreditsSub",
		"ChallengeAwarded",
		"ChallengeTerminated",
		"UserSubscriptionAdd",
		"UserSubscriptionUpdate",
		"UserSubscriptionDelete",
		"UserSubscriptionSuspend",
		"UserSubscriptionReactivate",
		"ChallengeCanceled",
		"ChallengeStarted",
		"OrderFulfilled",
		"UserSubscriptionExpiring",
		"UserSubscriptionExpired",
		"AthleteExpExpiring",
		"AthleteExpExpired",
		"EncodingJobError",
		"EncodingJobSuccess",
		"TrainingFeedback",
		"EmailError",
		"InvitationEmailError",
	],
	RANKINGS_TRAININGS_OPTIONS: {
		ANY: "Any",
		PERSONAL: "Personal",
		CLUB: "Club",
	},

};

var EVALUATIONS = [
	{
		Value: 100,
		Text: {
			athlete: "top-workout-athlete",
			others: "top-workout-others",
		},
		Icon: "template/assets/img/happy.svg",
	},
	{
		Value: 70,
		Text: {
			athlete: "good-workout-athlete",
			others: "good-workout-others",
		},
		Icon: "template/assets/img/smiling.svg",
	},
	{
		Value: 50,
		Text: {
			athlete: "can-do-more-athlete",
			others: "can-do-more-others",
		},
		Icon: "template/assets/img/confused.svg",
	},
	{
		Value: 0,
		Text: {
			athlete: "can-do-more-athlete",
			others: "can-do-more-others",
		},
		Icon: "template/assets/img/confused.svg",
	},
];

var UNITS = {};
UNITS[ENUMS.UNITS.METRIC] = {
	WEIGHT: "kg",
	HEIGHT: "cm",
};
UNITS[ENUMS.UNITS.IMPERIAL] = {
	WEIGHT: "lbs",
	HEIGHT: "in",
};

var LANGUAGES = [
	{
		shortname: "en",
		name: "English",
		display: "English",
	},
	{
		shortname: "it",
		name: "Italian",
		display: "Italiano (Italian)",
	},
	{
		shortname: "es",
		name: "Spanish",
		display: "Español (Spanish)",
	},
	{
		shortname: "fr",
		name: "French",
		display: "Français (French)",
	},
];

var CARDIO_SENSOR_NAMES = {
	All: "All supported",
	Uptivo: "Uptivo",
	Licensed: "Others",
};

var LICENSE_NAMES_OVERRIDES = {
	ClubPlus: "Club Plus",
	GreenMonthly: "Green",
	OrangeMonthly: "Orange",
	RedMonthly: "Red",
	App2024: "App",
	Studio2024: "Studio",
	Club2024: "Club",
	Workout2024: "Workout",
	Enterprise2024: "Enterprise",
};

var POWER_ZONES_EFFORTS = [0.55, 0.75, 0.9, 1.05, 1.2, 1.5];
var HR_ZONES_EFFORTS = [0.5, 0.6, 0.7, 0.8, 0.9, 1];

var POINTS_PER_MINUTE = [0, 1, 3, 6, 8, 8];

CONSTANTS = {
	MM_IN_INCH: 25.4,
	CM_IN_FOOT: 30.48,
	INCH_IN_FOOT: 12,
	METERS_IN_MILE: 1609,
	METERS_IN_KILOMETER: 1000,
	LBS_IN_KG: 2.20462262185,
	EARTH_RADIUS_METERS: 6378137,
	TICKS_IN_SECOND: 1000,
	SECONDS_IN_MINUTE: 60,
};
CONSTANTS.TICKS_IN_MINUTE = CONSTANTS.SECONDS_IN_MINUTE * CONSTANTS.TICKS_IN_SECOND;
CONSTANTS.CM_IN_INCH = CONSTANTS.MM_IN_INCH / 10;

var DEFAULT_POWER_OUTPUT = {
	Unspecified: 2.6,
	Male: 2.8,
	Female: 2.4,
};

function s4() {
	return Math.floor((1 + Math.random()) * 0x10000)
		.toString(16)
		.substring(1);
}

function guid() {
	return s4() + s4() + "-" + s4() + "-" + s4() + "-" + s4() + "-" + s4() + s4() + s4();
}

function guidShort() {
	return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}

var WATCH_MODES = {
	NOTIFY: 1,
	FOLLOW: 2,
	NONE: 3,
	CLASSES: ["", "fa-eye", "fa-star", "fa-star-o"],
	ICONS: ["", '<i class="fa fa-eye"></i>', '<i class="fa fa-star"></i>', '<i class="fa fa-star-o"></i>'],
	FILTER_CHAR: "\uf073",
};

var TAGS_FILTER_SEPARATOR = " ";
var TAGS_FILTER_CHAR = "\uf074";
var TAGS_ENCODE_CHARS = {
	0: "\uf080",
	1: "\uf081",
	2: "\uf082",
	3: "\uf083",
	4: "\uf084",
	5: "\uf085",
	6: "\uf086",
	7: "\uf087",
	8: "\uf088",
	9: "\uf089",
};

var WEMUSCLES = [
	"Abductors",
	"Abs",
	"Adductors",
	"BackLower",
	"BackMiddle",
	"Bicep",
	"Calves",
	"Chest",
	"Forearms",
	"Glutes",
	"Hamstrings",
	"Lats",
	"Neck",
	"Obliques",
	"Quads",
	"Shoulder",
	"Traps",
	"Triceps",
	"Hips",
	"Rhomboids"
];

var WEEQUIPMENTS = [
	"BalanceBoard",
	"HandleBands",
	"LoopBands",
	"Barbell",
	"BattleRopes",
	"Bench",
	"BodyWeight",
	"BOSU",
	"Boxing",
	"PlyoBox",
	"Dumbbell",
	"FoamRoller",
	"PilatesRoller",
	"PilatesRing",
	"JumpRope",
	"Kettlebell",
	"LacrosseBall",
	"Landmine",
	"Strength",
	// "Mat",
	"MedicineBall",
	"MiniBand",
	"Plate",
	"PullUpBar",
	"Sandbag",
	"SlamBall",
	"Sled",
	"Sliders",
	"SuspensionTrainer",
	"SwissBall",
	"Clubbell",
	"Cardio",
	"TGEEncompass",
	"PosturalBench",
	"Blast",
	"Reformer",
	"EVOWorkstation",
	"WallBall"
];

var WEACTIVITIES = [
	"Stretching",
	"Strengthening",
	"Mobility",
	"Cardio",
	"Combat",
	"BodyWeight",
	"YogaPilates",
	"Functional"
];

var WEBRANDS = [
	"Triform",
	"TotalGym",
	"WellBackSystem",
	"Flowin",
	"XeniosUSA",
	"BlastJump",
	"BodyExercisePilates"
];

var EXERCISE_TAGS = {
	MainMuscle: WEMUSCLES,
	Muscle: WEMUSCLES,
	Equipment: WEEQUIPMENTS,
	Activity: WEACTIVITIES,
	Brand: WEBRANDS,
};


var WSACTIVITIES = [
	"Stretching",
	"Strengthening",
	"Mobility",
	"Cardio",
	"Combat",
	"YogaPilates",
	"BodyWeight",
	"CrossTraining",
	"BackSchool",
	"BodyBuilding"
];


var SYSTEM_MEASURES = {
	SORTING_PREFERENCE: [
		"Weight",
		"BodyMassIndex",
		"ArmCirc",
		"ChestCirc",
		"WaistCirc",
		"HipCirc",
		"ThighCirc",
		"BloodPressureMin",
		"BloodPressureMax",
		"HeartRateAverage",
		"HeartRateRest",
		"SpO2Prc",
		"BodyFatMass",
		"PercentBodyFat",
		"FatFreeMass",
		"SkeletalMuscleMass",
		"TotalBodyWater",
		"PercentBodyWater",
		"BoneMass",
		"PercentBoneMass",
		"ECWTBWRatio",
		"VisceralFatLevel",
		"UptivoYMCAStep.Score",
		"BloodGlucose",
		"BloodGlucose.1",
		"BloodGlucose.2",
		"BloodGlucose.3",
		"BloodGlucose.4",
	],
	GROUPS: {
		BODY_CIRCUMFERENCES: ["ArmCirc", "ChestCirc", "WaistCirc", "HipCirc", "ThighCirc"],
		SKINFOLD_MEAS: [
			"TricepsTK",
			"AbdomenTK",
			"SuprailiacTK",
			"SubscapularTK",
			"AxillaryTK",
			"PectoralTK",
			"ThighTK",
			"CalfTK",
		],
		BODY_MASS: [
			"Weight",
			"FatFreeMass",
			"BodyFatMass",
			"PercentBodyFat",
			"BoneMass",
			"PercentBoneMass",
			"SkeletalMuscleMass",
			"BodyCellMass",
			"VisceralFatLevel",
		],
		BODY_WATER: ["TotalBodyWater", "PercentBodyWater", "ExtracellularWater", "IntracellularWater", "ECWTBWRatio"],
		BODY_OTHER: [
			"BodyMassIndex",
			"UptivoYMCAStep.Score",
			"HeartRateAverage",
			"HeartRateRest",
			"BasalMetabolicRate",
		],
		BLOOD_MEAS: [
			"BloodPressureMin",
			"BloodPressureMax",
			"BloodGlucose",
			"BloodGlucose.1",
			"BloodGlucose.2",
			"BloodGlucose.3",
			"BloodGlucose.4",
			"SpO2Prc",
		],
		TEST: [
			"PushUpMaxReps1Minute",
			"SquatMaxReps1Minute",
			"Plank",
			"RowerMaxDist1Minute",
			"BenchPressMaxWgt",
			"BenchPressMaxReps",
			"HandGripTest",
			"MaxAerobicSpeed",
			"PullUpMaxReps",
			"LatPullDownMaxWgt",
			"LatPullDownMaxReps",
			"SquatMaxWgt",
			"SquatMaxReps",
		],
	},
	PRC_DEPENDENCES: {
		TotalBodyWater: "Weight",
		FatFreeMass: "Weight",
		BodyFatMass: "Weight",
		SkeletalMuscleMass: "Weight",
		BoneMass: "Weight",
	},
};

var CONFIGURATION = {
	USERS_ENDPOINT: "/api/Users",
	TRAININGS_ENDPOINT: "/api/Trainings",
	GROUP_TRAININGS_ENDPOINT: "/api/GroupTrainings",
	BRANDS_ENDPOINT: "/api/Brands",
	CLUBS_ENDPOINT: "/api/Clubs",
	CLUB_RANKINGS_ENDPOINT: "/api/ClubRankings",
	RANKINGS_ENDPOINT: "/api/Rankings",
	COUNTRIES_ENDPOINT: "/api/Countries",
	SENSORS_ENDPOINT: "/api/Sensors",
	USERRELATIONSHIPS_ENDPOINT: "/api/Relationships/users",
	INVITATION_ENDPOIND: "/api/Invitations",
	DEVICES_ENDPOINT: "/api/Devices",
	DEMO_SENSORS_ENDPOINT: "/api/Demoathletes",
	NOTIFICATIONS_ENDPOINT: "/api/Notifications",
	UPTIVO_BRIDGES_ENDPOINT: "/api/Devices/uptivobridges",
	DISPLAY_GROUPS_ENDPOINT: "/api/DisplayGroups",
	TRAINING_COMMENTS_ENDPOINT: "/api/Comments/trainings",
	TRAINING_FEEDBACKS_ENDPOINT: "/api/trainingfeedbacks",
	MEASURE_TYPES_ENDPOINT: "/api/MeasureTypes",
	USER_MEASURES_ENDPOINT: "/api/UserMeasures",
	GENERIC_DEVICES_ENDPOINT: "/api/Devices/generic",
	SHARING_ENDPOINT: "/shared",
	APPS_ENDPOINT: "/api/Apps/uptivoapps",
	CIRCUIT_TIMERS_ENDPOINT: "/api/Timers/circuits",
	BIOMETRICDATA_ENDPOINT: "/api/BiometricData",
	CLUBSENSORS_ENDPOINT: "/api/ClubSensors",
	INTENSITYFLOWS_ENDPOINT: "/api/IntensityFlows",
	CLUBSLIDESHOWS_ENDPOINT: "/api/ClubSlideShows",
	LICENSES_ENDPOINT: "/api/Licenses",
	CLUB_TAGS_ENDPOINT: "/api/ClubTags",
	LIVE_HOST_ENDPOINT: "/api/Live/hosts",
	LIVE_TRAINING_ENDPOINT: "/api/Live/trainings",
	LIVE_RECURRENT_ENDPOINT: "/api/Live/recurrent",
	LIVE_CLASSES_ENDPOINT: "/api/Live/classes",
	CLASSES_ENDPOINT: "/api/classes",
	PAYMENTS_ENDPOINT: "/api/payments",
	CURRENCIES_ENDPOINT: "/api/currencies",
	CHALLENGES_ENDPOINT: "/api/challenges",
	SUBSCRIPTIONS_ENDPOINT: "/api/subscriptions",
	BADGES_ENDPOINT: "/api/badges",
	CLUB_APP_LINKS_ENDPOINT: "/api/clubAppLinks",
	ATHLETE_EXPIRATIONS_ENDPOINT: "/api/athletes/expirations",
	ATHLETE_NOTES_ENDPOINT: "/api/athletes/notes",
	ATHLETE_TASKS_ENDPOINT: "/api/athletes/tasks",
	CLUB_VIDEO_COLLECTIONS_ENDPOINT: "/api/ClubVideoCollections",
	CLUB_VIDEOS_ENDPOINT: "/api/ClubVideos",
	DASHBOARDS_ENDPOINT: "/api/Dashboards",
	WORKOUTDEFS_ENDPOINT: "/api/WorkoutDefinitions",
	WORKOUTSHEETS_ENDPOINT: "/api/WorkoutSheets",
	BRIDGE_WORKOUTS_ENDPOINT: "/api/BridgeWorkouts",
	CLUB_TRANSACTIONS_ENDPOINT: "/api/ClubTransactions",
	CLUB_POLICIES_ENDPOINT: "/api/ClubPolicies",
	CLUB_KIOSKS_ENDPOINT: "/api/ClubKiosks",
	WORKOUTSHEETSRUN_ENDPOINT: "/api/WorkoutSheetsRuns",
	AI_ENDPOINT: "/api/ai",
	EQUIPMENTS_ENDPOINT: "/api/Equipments",

	BASE_API_URL: "https://api.uptivo.fit",
	BASE_FILE_SERVICE: "https://fileservice.uptivo.fit",
	LOCAL_BASE_API_URL: "https://api.uptivo.fit",
	// LOCAL_BASE_API_URL: "http://localhost:5000",
	LOCAL_BASE_FILE_SERVICE: "http://localhost:7071",
	TESTING_BASE_API_URL: "https://api-testing.uptivo.fit",
	TESTING_BASE_FILE_SERVICE: "https://fileservice.uptivo.fit",
	
	SPA_MASTER_VIEW_URL: "index.html",
	AUTH_COMPONENTS_URL: "Modules/Account/Components/",

	SPA_COMPONENTS_URL: "Modules/SPA/Components/",
	DEFAULT_PHOTO: "template/assets/img/profile-white.png",
	DEFAULT_DEMO_PHOTO: "template/assets/img/demosensor.png",

	LOGO_URL: "https://imgstorage.uptivo.fit/uptivo-matter-of-intensity-tm.svg",
	RESIZED_PICTURE: ".row.dz-image-preview img[data-dz-thumbnail]",
	DEFAULT_DATE_FORMAT: "DD/MM/YYYY",
	MAX_BPM: 220,
	SIDE_MENU_ID: "#side-menu",
	LANGUAGES: LANGUAGES,
	UNLIMITED_RESOURCES_LICENSE: 1000000,
	DEFAULT_TARGET_ZONE_LOW_PRC: 65,
	DEFAULT_TARGET_ZONE_HIGH_PRC: 85,
	UNLIMITED_DATE_LICENSE: "2050-01-01T00:00:00",

	NEWS_IS_NEW_DAYS: 15,
	NEWS_DATA_URI: "https://downloads.uptivo.fit/news"
};

TRAINING_TYPES = [
	{ Type: "Unspecified" },
	{ Type: "Running" },
	{ Type: "Cycling" },
	{ Type: "Walking" },
	{ Type: "MountainBiking" },
	{ Type: "CrossCountrySkiing" },
	{ Type: "DownhillSkiing" },
	{ Type: "FunctionalTraining" },
	{ Type: "Rowing" },
	{ Type: "NordicWalking" },
	{ Type: "Skating" },
	{ Type: "Hiking" },
	{ Type: "Tennis" },
	{ Type: "Squash" },
	{ Type: "WeightTraining" },
	{ Type: "OtherWithGPS" },
	{ Type: "OtherWithoutGPS" },
	{ Type: "TreadmillRunning" },
	{ Type: "IndoorCycling" },
	{ Type: "IndoorWalking" },
	{ Type: "HIIT" },
	{ Type: "IndoorRowing" },
	{ Type: "AquaCycling" },
	{ Type: "WaterAerobics" },
	{ Type: "Yoga" },
	{ Type: "Zumba" },
	{ Type: "Basketball" },
	{ Type: "Volleyball" },
	{ Type: "Kayak" },
	{ Type: "Bootcamp" },
	{ Type: "Calisthenics" },
	{ Type: "ClimbingOutdoor" },
	{ Type: "ClimbingIndoor" },
	{ Type: "Crossfit" },
	{ Type: "Dancing" },
	{ Type: "EMS" },
	{ Type: "Fitboxing" },
	{ Type: "CombatFitness" },
	{ Type: "Padel" },
	{ Type: "PersonalTraining" },
	{ Type: "Pilates" },
	{ Type: "Swimming" },
	{ Type: "Trampoline" },
	{ Type: "PoleDance" },
	{ Type: "GAG" },
	{ Type: "Soccer" },
	{ Type: "Fencing" },
	// { Type: "ZRFit" },
	// { Type: "ZRStrong" },
	// { Type: "ZRBooster" },
	// { Type: "ZRBilanInBody" },
	// { Type: "ZRHypericeExperience" },
	{ Type: "Switching" },
	{ Type: "Golf" },
	{ Type: "Elliptical" },
	// { Type: "Strafit" },
	{ Type: "HorseRiding" },
	{ Type: "Dressage" },
	{ Type: "ShowJumping" },
	{ Type: "Postural" },
	{ Type: "BlastJump" },
	{ Type: "Boxing" },
	{ Type: "HybridTraining" },
	{ Type: "ATHX" },
];

UNSUPPORTED_TRAINING_TYPES = [
	{ Type: "ZRFit" },
	{ Type: "ZRStrong" },
	{ Type: "ZRBooster" },
	{ Type: "ZRBilanInBody" },
	{ Type: "ZRHypericeExperience" },
	{ Type: "Strafit" },

];


SERVICE_TYPES = [
	{ Type: "UnspecifiedService" },
	{ Type: "Osteopathy" },
	{ Type: "MassageTherapy" },
	{ Type: "Nutrition" },
	{ Type: "BioMeasurements" },
	{ Type: "Orthopedics" },
	{ Type: "Manicure" },
	{ Type: "Pedicure" },
	{ Type: "HairRemoval" },
	{ Type: "BodyCare" },
	{ Type: "FacialCleansing" },
	{ Type: "BodyMassages" },
	{ Type: "Solarium" },
	{ Type: "AntiCelluliteTreatment" },
	{ Type: "Cryotherapy" },
	{ Type: "PosturalAssessment" },
	{ Type: "ZRBilanInBody" },
	{ Type: "ZRHypericeExperience" },
]


TRAINING_IMAGES_URL = [
	{ url: "https://imgstorage.uptivo.fit/booking/training_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/functional_training.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/basket.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/calisthenics.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/walking.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/rowing.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/cycling.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/climber_indoor.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/climber_outdoor.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/combat_fitness.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/running.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/crossfit.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/dancing.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/indoor_cycling.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/indoor_rowing.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/kayak.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/mountain_bike.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/nordic_walking.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/padel.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/skating.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/weight.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/pilates.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/pole_dance.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/downhill_skiing.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/cross_country_skiing.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/squash.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/swimming.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/tennis.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/training_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/trekking.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/volleyball.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/yoga.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zumba.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_booster.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_fit.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_strong.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_balance.png" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_wellness.png" },
];

SERVICE_IMAGES_URL = [
	{ url: "https://imgstorage.uptivo.fit/booking/anti_cellulite.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/biometrics.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/body_care_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/body_care_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/cryotherapy.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/face_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/face_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/face_3.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/hair_removal_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/hair_removal_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/manicure_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/manicure_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/manicure_3.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/massage_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/massage_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/massage_3.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/massage_4.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/nutrition_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/nutrition_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/orthopedics.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/osteopathy.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/pedicure.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/postural_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/postural_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/solarium_1.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/solarium_2.jpg" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_balance.png" },
	{ url: "https://imgstorage.uptivo.fit/booking/zr_wellness.png" },
];


STATION_COLOR_ARRAY = ["red", "#0549ff", "#ffc00b", "#01aa33", "#800180", "#ff7f00", "#80d31b", "#55318d", "#fe5d00", "#138466", "#c4027d"];


if (typeof module !== "undefined" && module.hasOwnProperty("exports")) {
	module.exports = CONFIGURATION;
}


WORKOUT_IS_NEW_DAYS = 30;

function ServiceLocator() {
	function set(key, obj) {
		window[key] = obj;
	}

	function get(key) {
		return window[key];
	}

	function lazyGet(key) {
		return function () { return get(key); }
	}

	this.init = function () {

		if (_.has(window, 'Utilities'))
			set("utilities", new Utilities());

		if (_.has(window, 'UptivoUserDataProvider'))
			set("userData", new UptivoUserDataProvider());

		if (_.has(window, 'AppContextManager'))
			set("appContext", new AppContextManager(get("utilities"), cache, get("userData")));

		if (_.has(window, 'ObjectAccessConfiguration'))
			set("objectAccessConfiguration", new ObjectAccessConfiguration(get("userData")));

		if (_.has(window, 'AuthManager'))
			set("authManager", new AuthManager());

		if (_.has(window, 'AppVersionManager'))
			set("appVersionManager", new AppVersionManager());

		if (_.has(window, 'CountryService'))
			set("countryService", new CountryService(get("utilities")));

		if (_.has(window, 'TimeZoneService'))
			set("timeZoneService", new TimeZoneService(get("utilities")));
	}
}

var serviceLocator = new ServiceLocator();
function ControlBase() {
}

ControlBase.prototype.initialize = function () {

}

ControlBase.prototype.rebind = function (viewModel) {
}
function ImageUploader($element, extraconfigOb, imageUriOb, uploadUriOb, modifiedOb, resultOb, confirmOb) {

	var self = this;
	var $element;
	var slim;
	var imageUri, uploadUri;
	var config, maxWidth, maxHeight;
	var MIN_COMPONENT_WIDTH = 55;

	self.modified = ko.observable(false);
	self.image = ko.observable();

	self.initialize = function () {
		self.$element = $element;

		if (resultOb) {
			self.image = resultOb;
		}

		if (modifiedOb) {
			self.modified = modifiedOb;
		}
	}

	self.update = function () {
		var newImageUri = ko.unwrap(imageUriOb);
		var newUploadUri = ko.unwrap(uploadUriOb);
		var newConfig = ko.unwrap(extraconfigOb);

		if (newConfig) {
			if (newConfig.maxSize) {
				var maxSize = newConfig.maxSize.split(",");

				self.maxWidth = maxSize[0];
				self.maxHeight = maxSize[1];
			}
		}

		var needsRecreate = self.uploadUri != newUploadUri || self.config != newConfig;
		var needsReload = self.imageUri != newImageUri;

		self.imageUri = newImageUri;
		self.uploadUri = newUploadUri;
		self.config = newConfig;

		if (needsRecreate) {
			recreate();
		} else if (!self.slim) {
			create();
		} else if (needsReload) {
			load();
		}
	}

	self.dispose = function () {
		destroy();
	}

	self.getBlob = function (cb) {
		if (self.slim && cb) {
			var data = self.slim.data;
			if (data.output.image)
				return data.output.image.toBlob(cb, 'image/jpeg', 0.8);
		}

		cb(null);
	}

	self.recreate = function() {
		destroy();
		create();
	}

	function recreate() {
		destroy();
		create();
	}

	function destroy() {
		_destroy(self.$element, self.slim);
		self.slim = null;
	}

	function create() {
		self.slim = _create(self.$element, self.config, self.imageUri, self.uploadUri);
	}

	function load() {
		_load(self.imageUri);
	}

	function _load(imageUri) {
		if (self.slim) {
			self.load(imageUri);
		}
	}

	function _destroy($element, slim) {
		if (slim) slim.destroy();
		if ($element) $element.empty();
	}

	function _create($element, config, imageUri, uploadUri) {
		self.image(null);
		self.modified(false);

		if ($element) {
			var $input = $("<input type='file' name='image' />");
			$element.append($input);

			if (imageUri) {
				var $img = $("<img src='" + imageUri + "' alt=''/>");
				$element.append($img);
			}

			var confirmText = r('confirm');
			var cancelText = r('cancel');
			var editText = r('edit');
			var removeText = r('remove');
			var slimConfig = _.defaults(config, {
				ratio: "1:1",
				size: "256,256",
				minSize: "128,128",
				filterSharpen: 15,
				service: uploadUri,
				instantEdit: true,
				push: false,

				label: r('drag-label'),
				labelLoading: r('loading-label'),
				buttonEditLabel: editText,
				buttonEditTitle: editText,
				buttonRemoveLabel: removeText,
				buttonRemoveTitle: removeText,
				buttonCancelLabel: cancelText,
				buttonCancelTitle: cancelText,
				buttonConfirmLabel: confirmText,
				buttonConfirmTitle: confirmText

			});

			slimConfig.didConfirm = function(val) {
				if (confirmOb) {
					confirmOb(val);
				}
			}

			slimConfig.didTransform = function () {
				_updateElementWidth($element, self.slim.data, self.maxWidth, self.maxHeight);
				if (!self.slim._isInitialising) self.modified(true);
				self.image(self.slim.dataBase64.output.image);
			};

			slimConfig.didRemove = function () {
				_updateElementWidth($element, self.slim.data, self.maxWidth, self.maxHeight);
				if (!self.slim._isInitialising) self.modified(!!self.imageUri);
				self.image(self.slim.dataBase64.output.image);
			};

			return new Slim($element.get(0), slimConfig);
		}
	}

	function _calcWidth(data, maxWidth, maxHeight) {
		if (data && maxWidth && maxHeight) {
			if (data.output.image) {
				var dataOutWidth = data.output.width;
				var dataOutHeigth = data.output.height;
				var outAspect = dataOutWidth / dataOutHeigth;

				var expectedHeight = maxWidth / outAspect;

				var newWidth = maxWidth;
				if (expectedHeight > maxHeight) {
					newWidth = Math.max(MIN_COMPONENT_WIDTH, maxHeight * outAspect);
				}

				return newWidth;
			}
		}
	}

	function _updateElementWidth($element, data, maxWidth, maxHeight) {
		if ($element) {
			var newWidth = _calcWidth(data, maxWidth, maxHeight);
			if (!newWidth) {
				self.slim.setRatio(self.config.ratio);
			}

			$element.width(newWidth || "auto");
		}
	}
}

ImageUploader.prototype = Object.create(ControlBase.prototype);
ImageUploader.prototype.constructor = ImageUploader;


function UptivoCalendar($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;

	var calendarMode = mode();
	var currentDay = day();

	function getEventColor(event) {
		if (event.Data.IsLive) return ENUMS.TRAINING_COLORS.INDIVIDUAL_TRAINING_LIVE;
		if (event.subEvents.length > 0 || event.Data.GroupTrainingId) return ENUMS.TRAINING_COLORS.GROUP_TRAINING_BG_COLOR;
		if (!event.Data.GroupTrainingId && event.Data.ClubId) return ENUMS.TRAINING_COLORS.INDIVIDUAL_TRAINING_CLUB_BG_COLOR;
		if (!event.Data.GroupTrainingId && !event.Data.ClubId) return ENUMS.TRAINING_COLORS.INDIVIDUAL_TRAINING_APP_BG_COLOR;
	};


	function updateWeeklyTotals(start, end) {
		var startOfWeek = utilities.weekdayNameToNumber(viewModel.startWeekDay());

		var from = utilities.weekdayBefore(start.clone().startOf("day"), startOfWeek);
		var to = utilities
			.weekdayAfter(end, startOfWeek)
			.subtract(1, "day")
			.endOf("day");

		var $summary = $(".fc-week-view-summary");

		for (var index = 1; index < 7; ++index) {
			var $week = $summary.find(".week-total.week{0}".format(index));

			if (from.isBefore(to)) {
				var endofweek = from
					.clone()
					.add(6, "days")
					.endOf("day");

				var sessions = viewModel.countSessions(from, endofweek);
				var duration = viewModel.sumDuration(from, endofweek);
				var points = viewModel.sumPoints(from, endofweek);
				var calories = viewModel.sumCalories(from, endofweek);
				var avgBpm = viewModel.avgBpm(from, endofweek);

				$week.find(".session-no").text(sessions);
				$week.find(".total-time").text(duration);
				$week.find(".total-points").text(utilities.numeralFmt(points));
				$week.find(".total-kcal").text(utilities.numeralFmt(calories));
				$week.find(".avg-bpm").text(utilities.numeralFmt(avgBpm));

				$week.show();
			} else {
				$week.hide();
			}

			from.add(1, "week");
		}
	}

	this.initialize = function() {
		var calendarRendering = ko.observable(true);

		ko.applyBindingsToNode($("#calendardiv")[0], {
			loadingSpinner: calendarRendering
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay"
			},
			locale: resourceManager.getCurrentLanguage(),
			height: 600,
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: false,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 5, // for all non-agenda views
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),

			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#calendar").fullCalendar("getView").intervalStart;
				var end = $("#calendar").fullCalendar("getView").intervalEnd;
				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
			},

			events: function(start, end, timezone, callback) {
				end = end.clone().startOf("day");

				calendarRendering(true);

				var trainingsDef = userService.getTrainingSummaries(viewModel.UserId, start, end, "all");
				
				var combMeasuresDef = userService.getMeasureEvents(viewModel.UserId, start, end);

				var workoutExecutionsDef = appContext.getSelectedClub() && appContext.getSelectedClub().EnableWorkoutSheets ? userService.getUserWorkoutSheetsRunsSummaries(viewModel.UserId, start, end) : $.Deferred().resolve([]);

				$.whenAll([trainingsDef, /* measuresDef, */ combMeasuresDef, workoutExecutionsDef])
					.done(function(trainingsRes, /* measuresRes, */ combMeasuresRes, workoutExecutionsRef) {
						if (
							$.grep(arguments, function(arg) {
								return arg[2] === "error";
							}).length > 0
						) {
							return;
						}

						
						var trainings = trainingsRes[1];
						/* var measures = measuresRes[1]; */
						var combMeasures = combMeasuresRes[1];
						var workoutExecutions = workoutExecutionsRef[1];

						var updatedEvents = [];
						trainings.forEach(function(training) {
							var start = moment(training.Begin);
							var end = moment(training.End);

							var event = {
								Type: "Training",
								Data: training,
								title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false,
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(subEvent) {
							if (subEvent.Data.GroupTrainingId) {
								updatedEvents.forEach(function(event) {
									if (event.Data.TrainingId != subEvent.Data.TrainingId && subEvent.start.isBetween(event.start, event.end) && !event.Data.GroupTrainingId) {
										event.subEvents.push(subEvent);
										subEvent.parentEvents.push[event];
										subEvent.isSubEvent = true;
									}
								});
							}
						});

						updatedEvents.forEach(function(event) {
							var color = getEventColor(event);
							event.backgroundColor = color;
							event.borderColor = color;
						});

			

						_.remove(updatedEvents, { isSubEvent: true });

						combMeasures.forEach(function(cm) {
							var start = moment(cm.TimeStamp);
							var event = {
								Type: cm.DataType === "None" ? "Measure" : "BiometricReport",
								Data: cm,
								title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
								start: start,
								end: start,
								className: ["uptivo-event"],
								allDay: false,
								textColor: "#676a6c",
								backgroundColor: "#ffffff",
								borderColor: "#2f4050",
							};
							updatedEvents.push(event);
						});


						workoutExecutions.forEach(function(we) {
							var start = moment(we.Begin);
							var event = {
								Type: "WorkoutExecution",
								Data: we,
								title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
								start: start,
								end: start,
								className: ["uptivo-event"],
								allDay: false,
								textColor: "white",
								backgroundColor: "#FF6B6C",
								borderColor: "#FF6B6C",
							};
							updatedEvents.push(event);
						});

						events(updatedEvents);
						callback(updatedEvents);
						updateWeeklyTotals(start, end);
					})
					.always(function() {
						calendarRendering(false);
					});
			},

			eventClick: function(event) {
				switch (event.Type) {
					case "Training":
						routing.navigateTo(
							"Training",
							{ id: event.Data.TrainingId },
							{ id: viewModel.UserId, calendarMode: calendarMode, listCalendarValue: viewModel.listCalendarValue() },
							viewModel.navigateBackStack()
						);
						break;
					case "BiometricReport":
					case "Measure":
						routing.navigateTo(
							"BiometricReport",
							{ id: event.Data.MeasureEventId },
							{ id: viewModel.UserId, calendarMode: calendarMode, listCalendarValue: viewModel.listCalendarValue() },
							viewModel.navigateBackStack()
						);
						break;
					case "WorkoutExecution":
						routing.navigateTo(
							"WorkoutSheetExecutionLog",
							{ id: event.Data.WorkoutSheetRunId },
							{ id: viewModel.UserId },
							viewModel.navigateBackStack()
						);
						break;
				}
				return false;
			},
			eventRender: function(event, eventElement) {
				if (event.Type === "Training" || event.Type === "BiometricReport" || event.Type === "Measure" || event.Type == "WorkoutExecution") {
					var $overlay = $('<div class="event-overlay"></div>');
					eventElement
						.find("div.fc-content")
						.parent()
						.append($overlay);
					var icon;
					switch (event.Type) {
						case "Training":
							var tt = (event.subEvents.length > 0 && event.subEvents[0].Data.TrainingType && event.subEvents[0].Data.TrainingType != "Unspecified") ? event.subEvents[0].Data.TrainingType : event.Data.TrainingType;
							icon = "<img class='event-icon' src='template/assets/img/training-types/{0}.svg'>".format(
								tt || "Unspecified"
							);
							if (event.subEvents.length > 0) {
								icon += "<i class='event-icon fa fa-ellipsis-v '></i>";
							}
							break;
						case "Measure":
							icon = "<i class='event-icon fa fa-balance-scale'></i>";
							break;
						case "BiometricReport":
							icon = "<i class='event-icon fa fa-file-text-o'></i>";
							break;
						case "WorkoutExecution":
							icon = "<img class='event-icon' src='template/assets/img/workout-sheet-run.svg'>";
							break;
					}

					if (icon) {
						eventElement.find("div.fc-content").prepend(icon);
					}
				} else {
					return false;
				}
			}
		});
		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();

		$element.find(".fc-view-container").append(getTotalsHtml());
	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!currentDay) {
			return new Date();
		}
		return new Date(currentDay);
	}

	function getTotalsHtml() {
		var weekTotalTemplate =
			"<div class='container' style='display: flex; flex-direction: column; justify-content: space-around; height: 118px'>" +
			"<div><img src='template/assets/img/bar-graph.svg'><span class='total-text pull-right'><span class='session-no'>0</span> <span class='total-desc'>" +
			r("sessions") +
			"</span></span></div>" +
			"<div><img src='template/assets/img/time.svg'><span class='total-text pull-right'><span class='total-time'>00:00:00</span></span></div>" +
			"<div><img src='template/assets/img/points.svg'><span class='total-text pull-right'><span class='total-points'>0</span> UPPs</span></div>" +
			"<div><img src='template/assets/img/fire.svg'><span class='total-text pull-right'><span class='total-kcal'>0</span><span class='total-desc'> kcal</span></span></div>" +
			"<div><img src='template/assets/img/heart_rate_avg.svg'><span class='total-text pull-right'><span class='avg-bpm'>0</span><span class='total-desc'> " + r("bpm-avg") + "</span></span></div>" +
			"</div>";

		var totalTemplate =
			"<div class='fc-week-view-summary'>" +
			"<table>" +
			"<thead><tr><th>" +
			r("week-totals") +
			"</th></tr></thead>" +
			"<tbody>" +
			"<tr class='week-total week1'><td>{0}</td></tr>" +
			"<tr class='week-total week2'><td>{0}</td></tr>" +
			"<tr class='week-total week3'><td>{0}</td></tr>" +
			"<tr class='week-total week4'><td>{0}</td></tr>" +
			"<tr class='week-total week5'><td>{0}</td></tr>" +
			"<tr class='week-total week6'><td>{0}</td></tr>" +
			"</tbody>" +
			"</table>" +
			"</div>";

		return totalTemplate.format(weekTotalTemplate);
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}
}

UptivoCalendar.prototype = Object.create(ControlBase.prototype);
UptivoCalendar.prototype.constructor = UptivoCalendar;

function UptivoEventsCalendar($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;

	var calendarMode = mode();

	this.initialize = function() {
		viewModel.calendarRendering(true);

		$(".start-date-class-id :input").prop("disabled", true);
		$(".end-date-class-id :input").prop("disabled", true);

		ko.applyBindingsToNode($("#calendardiv")[0], {
			loadingSpinner: viewModel.calendarRendering,
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay",
			},
			locale: resourceManager.getCurrentLanguage(),
			minTime: '06:00',
			maxTime: '22:00',
			height: "auto",
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: false,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 4,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),
			selectable: true,
			columnHeaderFormat: (userInfo.DateFormat == "mmddyyyy" || userInfo.DateFormat == "yyyymmdd") ? 'ddd M/D' : 'ddd D/M', 

			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#calendar").fullCalendar("getView").intervalStart;
				var end = $("#calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
			},
			events: function(start, end, timezone, callback) {

				if (!viewModel.isTimeFilterValid()) {
					viewModel.calendarRendering(false);
					return;
				}

				viewModel.calendarRendering(true);

				var startTimeFilter;
				var endTimeFilter;

				if (viewModel.startTimeFilter()) {
					var startTimeFilter = viewModel.startTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						startTimeFilter = moment(startTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
						
					} 
				}

				if (viewModel.endTimeFilter()) {
					var endTimeFilter = viewModel.endTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						endTimeFilter = moment(endTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
					} 
				}

				var classesDef = clubsService.getClubClasses(
					viewModel.clubId,
					0,
					0,
					1000,
					viewModel.searchText(),
					start.toJSON(),
					end.clone().subtract(1, "day").endOf('day').toJSON(),
					viewModel.locationFilter(),
					viewModel.trainerNameId(),
					viewModel.trainingTypeFilter(),
					viewModel.activityTypeFilter(),
					viewModel.placeFilter(),
					viewModel.statusFilter(),
					viewModel.participantsFilter(),
					viewModel.subscriptionNameId(),
					viewModel.dayOfWeekFilter(),
					false,
					startTimeFilter,
					endTimeFilter			
				);

				classesDef
					.done(function(classesRes) {
						$('#calendar').fullCalendar('option', 'minTime', '06:00');
						$('#calendar').fullCalendar('option', 'maxTime', '22:00');

						var classes = classesRes.data;

						var updatedEvents = [];

						classes.forEach(function(c) {
							var start = moment(c.Begin);
							var end = moment(c.End);
							var event = {
								Type: "Class",
								Data: c,
								title: c.Name,
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false,
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(event) {
	
							if(moment(event.Data.Begin).hour() < 6) {
								$('#calendar').fullCalendar('option', 'minTime', '00:00');
							}
							if(moment(event.Data.Begin).hour() > 22) {
								$('#calendar').fullCalendar('option', 'maxTime', '24:00');
							}
						});

						events(updatedEvents);
						callback(updatedEvents);
					})
					.fail(function(xhr, error, status) {
						return;
					})
					.always(function() {
						localStorage.setItem("clubClasses_activities_filter_options_v3", JSON.stringify(viewModel.generateFilterOptionsObj()));
					});
			},
			eventClick: function(event, e) {
				var $calendarElement = $(e.target);

				closeEventMenu();

				var participantsButtonVisible = event.Data.PublishState == 'Published' ? 'block' : 'none';
				// var publishButtonVisible = event.Data.PublishState == 'Unpublished' ? 'block' : 'none';

				var $menu = $(
					"<div class='uptivo-dropdown-menu" +
						"' style='border: 1px solid "+ event.Data.Color + " '>" +
						 "<i style='position: absolute;right: 2px; top: 2px; cursor: pointer' class='fa fa-times' click='closeEventMenu()'></i>" + 
						 "<ul style='padding-right: 20px;'>" +


						"<span style='display: " + participantsButtonVisible + "'>" +
						"<li" +
						" data-wm='" +
						'participants' +
						"'><i class='fa fa-users'></i> &nbsp;" +
						r("participants") +
						"</li></span>" +

						// "<span style='display: " + publishButtonVisible + "'>" +
						// "<li" +
						// " data-wm='" +
						// 'publish' +
						// "'><i class='fa fa-check-circle' data-toggle='tooltip' data-container='body' title='' style='color: green' data-original-title='Attivo'></i> &nbsp;" +
						// r("publish") +
						// "</li></span>" +

						"<li" +
						" data-wm='" +
						'edit' +
						"'><i class='fa fa-pencil-square-o'></i> &nbsp;" +
						r("edit") +
						"</li>" +

						"</ul></div>"
				);

				var cec;

				if($calendarElement[0].className.includes("uptivo-event")) {
					$containerElement = $calendarElement.parent().parent();
					var cec = $calendarElement
				} else {
					$containerElement = $calendarElement.parent().parent().parent();
					var cec = $calendarElement.parent()
				}

				$containerElement.append($menu);

				var position = cec.offset();
				
				$menu.offset({
					top: position.top + 2,
					left: position.left + 6
				});
				
				var onScreenOffset;

				if ($menu.offset().left + $menu.outerWidth() > $("body").prop("scrollWidth") - 15) {

					onScreenOffset = ($menu.offset().left + $menu.outerWidth() - $("body").prop("scrollWidth"))

					$menu.offset({
						top: position.top + 2,
						left: position.left - onScreenOffset - 15
					});	
				}


				$menu.find("li").click(function() {
					var selection = $(this).data("wm");

					switch (selection) {
						case 'participants':
							if(event.Data.PublishState == 'Unpublished') {
								return;
							}
							routing.navigateTo("ClubClassParticipants", { id: event.Data.ClassId });
							break;
						case 'publish':
							if(event.Data.PublishState == 'Published') {
								return;
							}
							updateClassPublishState(event.Data);
							break;
						case 'edit':
							routing.navigateTo("ClubClass", { id: event.Data.ClassId, type: event.Data.ClassType, calendarType: "Club" } );
							break;
						default:
							break;
					}
				});

				
			},
			eventRender: function(event, eventElement) {

				// TOOLTIP

				var tooltipTitle = '<div><span style="font-weight: 600;">' + r("title") + '</span>: ' + event.Data.Name + '</div>';
				var bookingMode = '<div><span style="font-weight: 600;">' + r("booking-mode") + '</span>: ' + translateBookingMode(event.Data.BookingMode) + '</div>';
				var tooltipTrainingType = '<div><span style="font-weight: 600;">' + r("training-type") + '</span>: ' + utilities.getTrainingTypeName(event.Data.TrainingType); + '</div>';
				var tooltipDate = '<div><span style="font-weight: 600;">' + r("date") + '</span>: {0}</div>'.format(moment(event.Data.Begin).format(utilities.getMomentDateFormat(userInfo.DateFormat)));

				var tooltipTime = '<div><span style="font-weight: 600;">' + r("hour") + '</span>: {0} - {1}</div>'.format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var trainerName = event.Data.TrainerName ? event.Data.TrainerName : "";
		
				if (event.Data.TrainerPictureUri) {
					var tooltipTrainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				tooltipTrainerAvatar = tooltipTrainerAvatar ? tooltipTrainerAvatar.replace("<img", "<img style='width: 25px;'") : "";

				var tooltipTrainer = trainerName ? '<div><span style="font-weight: 600;">' + r("trainer") + '</span>: ' + tooltipTrainerAvatar + ' ' + trainerName + '</div>' : '<div><span style="font-weight: 600;">' + r("trainer") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipLocation = event.Data.Location ? '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + event.Data.Location + '</div>' : '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipOnsitePlaces = '<div><span style="font-weight: 600;">' + r("onsite-participants") + '</span>: ' + event.Data.InSiteParticipants + '/' + event.Data.MaxInSiteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.InSiteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostInSite + '</div>';
				
				var tooltipRemotePlaces = '<div><span style="font-weight: 600;">' + r("home-participants") + '</span>: ' + event.Data.RemoteParticipants + '/' + event.Data.MaxRemoteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.RemoteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostRemote + '</div>';

				var tooltip = 
				tooltipTitle +
				bookingMode +
				tooltipTrainingType +
				tooltipDate +
				tooltipTime + 
				tooltipTrainer +
				tooltipLocation +
				(event.Data.MaxInSiteParticipants > 0 ? tooltipOnsitePlaces : "") +
				(event.Data.MaxRemoteParticipants > 0 ? tooltipRemotePlaces : "");
				$(eventElement).attr("data-original-title", tooltip);
				$(eventElement).attr("data-container", "#calendardiv");
				$(eventElement).tooltip({ html: true}).data('bs.tooltip').tip().addClass('uptivo-event-tooltip');

				// END TOOLTIP

				// CUSTOM FC CONTENT

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);
		

				eventElement.find("div.fc-content").empty();
				eventElement.find("div.fc-content").parent().css({"border-color": "rgb(164 162 162)", "border-left": "5px solid" + event.Data.Color, "margin-left": "1px"});
				eventElement.find("div.fc-content").css({"min-width": "190px", "height": "90px", "overflow": "hidden" });

				if (event.Data.InSiteParticipants + event.Data.RemoteParticipants > 0) {
					eventElement.find("div.fc-content").parent().css({"background-color": "wheat"});
				} 

				//Add diagonal stripes if event is unpublished
				if (event.Data.PublishState == "Unpublished") {
					var stripeUnpublishedColor = '#e3e3e3';
					$(eventElement).css("background", "repeating-linear-gradient(45deg," + stripeUnpublishedColor + "C0," + stripeUnpublishedColor + "C0 10px," + "white" + " 10px," + "white" + " 20px");
				}


				var startEnd = "<span>{0} - {1}</span>".format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var startTitle = "<span style='font-weight: 600'>{0} {1}</span>".format(
					moment(event.Data.Begin).format(userInfo.TimeFormat == "h12" ? "h:mma" : utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					event.Data.Name
				);

				link = utilities.getTrainingTypeIconUrl(event.Data.TrainingType);

				var iconType = '<div style="background-color: ' + event.Data.Color + '; height: 25px; width: 25px; border-radius: 5px; padding-top: 4px; padding-left: 5px;">' + 
				'<img class="training-type" style="width: 20px; height: 20px" src="'+ link + '" data-bind="changeToSvg : {color:"#f3712a", src: training.TrainingTypeIcon }" />' +
				'</div>'
		
				if (event.Data.TrainerPictureUri) {
					var trainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				trainerAvatar = trainerAvatar ? trainerAvatar : "";
			
				var eventName = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="font-size: 13px; max-height: 19px; overflow: hidden;"><b>'+ event.Data.Name + '</b></div>' : '<div style="font-size: 13px; max-height: 19px; overflow: hidden;">'+ event.Data.Name + '</div>';
				var eventParticipants = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;<b>'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) + '</b></div>' : '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) +'</div>';

				eventParticipants = event.Data.BookingMode == 'NotBookable' ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp' + translateBookingMode(event.Data.BookingMode) : eventParticipants;

				var liveIcon = event.Data.MaxRemoteParticipants > 0 ? '<div style="position: absolute; top: 53px; right: 1px"><i style="font-size: 16px" class="booking-home-icon"></i></div>' : "";
				var remoteIcon = event.Data.MaxInSiteParticipants > 0 ?'<div style="position: absolute; top: 54px; right: 18px"><i style="font-size: 16px" class="booking-onsite-icon"></i></div>' : "";
				var location = event.Data.Location ? '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + event.Data.Location + '</div>' : '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + r("unspecified") + '</div>';


				var customContent = '<div>'+ startTitle + '</div><div style="position: absolute; top: 1px; right: 1px">'+ iconType + '</div>' +
				// eventName +
				'<div>'+ trainerAvatar + ' ' + trainerName +'</div>' + 
				eventParticipants +
				liveIcon +
				remoteIcon +
				location;


				eventElement.find("div.fc-content").append(customContent);

				//add id for custom classes events css
				eventElement.find("div.fc-content").attr("id", "events-calendar-content");

			},
			eventAfterAllRender: function() {
				viewModel.calendarRendering(false);
				// SET DATE BASED ON START DATE
				if (day() != viewModel.eventsCalendarDate()) {
					$('.calendar-date-selection-input-hide').datepicker("setDate", moment($('.start-date-class-id input').datepicker("getDate")).format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				} else {
					$('.start-date-class-id input').datepicker("setDate", $("#calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.end-date-class-id input').datepicker("setDate", $("#calendar").fullCalendar("getView").intervalEnd.clone().subtract(1, "day").format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.calendar-date-selection-input-hide').datepicker("setDate", $("#calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				}
			},
			select: function(start,end, event) {

				if (viewModel.userIsManager() == false) {
					return;
				}

				if ($(event.target).closest('.uptivo-dropdown-menu').length) {
					 
				} else {

					if(end.isBefore(moment()))
					{
						toastr.error(r("lesson-schedule-end-date-in-past"), r("operation-failed"));
						return;
					}

					var singleCalendarSelectionSchedule = {
						scheduleStartDate: start.format(utilities.getMomentDateFormat(userInfo.DateFormat)),
						singleStartTime: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
						singleDuration: moment.duration(end.diff(start)).asMinutes()
					}

					routing.navigateTo("ClubClass", { singleCalendarSelectionSchedule: singleCalendarSelectionSchedule, type: "Single", calendarType: "Club" } );

				}
			}
		});

		viewModel.refreshInfoText = function(){
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}
		
		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();

		// WATCH MENU CLOSE IF CLICK OUTSIDE
		$('body').click(function(event){
			if ($(event.target).closest('.uptivo-event').length) {
				return; 
			} else {
				closeEventMenu();
			}
		});
	
	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!day() || day() == "today") {
			return new Date();
		}
		return new Date(moment(day(), utilities.getMomentDateFormat(userInfo.DateFormat), true).toJSON());
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}

	function closeEventMenu() {
	
		var menu = $(".uptivo-dropdown-menu")
		
		if (menu) {
			menu.remove();
		}
	}

	function translateBookingMode(bookingMode) {

		switch (bookingMode) {
			case 'Invite':
			  return r("invite-booking-mode");
			case 'Open':
			  return r("open-booking-mode");
			case 'NotBookable':
			  return r("free-access");
		  }
	}

	
	window.addEventListener('resize', function (e) { 
		$('.fc-content').width($('.uptivo-event').width());
	 }, false);


}

UptivoEventsCalendar.prototype = Object.create(ControlBase.prototype);
UptivoEventsCalendar.prototype.constructor = UptivoEventsCalendar;

function UptivoGeneratedActivitiesCalendar ($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;

	var calendarMode = mode;
	var currentDay = day();
	

	this.initialize = function() {
		var calendarRendering = ko.observable(true);

		ko.applyBindingsToNode($("#generated-activities-calendardiv-id")[0], {
			loadingSpinner: calendarRendering
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay"
			},
			locale: resourceManager.getCurrentLanguage(),
			height: 600,
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: false,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 1,
			eventLimitText: function(moreNumber) { return  moreNumber + " EVENTS"} ,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),

			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#calendar").fullCalendar("getView").intervalStart;
				var end = $("#calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
				
			},
			eventAfterAllRender: function() {

				if (viewModel.classInfo().PublishState != 'Published' && !viewModel.classAlreadyFinishedOrWithoutPermission()) {
					$(".fc-day-grid-event").css("cursor", "pointer");
				} else {
					$(".fc-day-grid-event").css("cursor", "not-allowed");
				}

				$(".fc-more").click(function(){
					if (viewModel.classInfo().PublishState != 'Published' && !viewModel.classAlreadyFinishedOrWithoutPermission()) {
						$(".fc-day-grid-event").css("cursor", "pointer");
					} else {
						$(".fc-day-grid-event").css("cursor", "not-allowed");
					}
				});
			},
			events: function(start, end, timezone, callback) {
				end = end.clone().startOf("day");

				calendarRendering(true);

				var scheduleDaysDef = classesService.getClassScheduledDays(viewModel.classInfo().ClassId);// Class ScheduleDays

				scheduleDaysDef.done(function(scheduleDaysRes) {
				
						var scheduleDays = scheduleDaysRes;

						var updatedEvents = [];

						scheduleDays.forEach(function(c) {
							var start = moment(c.Begin);
							var end = moment(c.Begin);
							var event = {
								Type: "ScheduleDays",
								Data: c,
								title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(event) {
							var color = event.Data.Type == "Exception" ? "rgb(204, 204, 204)" : "#03A9F4";
							event.backgroundColor = color;
							event.borderColor = color;
						});

			
						events(updatedEvents);
						callback(updatedEvents);
					})
					.fail(function(xhr, error, status) {
						return;
					})
					.always(function() {
						calendarRendering(false);
					});
			},

			eventClick: function(event) {
				if(viewModel.classInfo().PublishState == 'Published' || viewModel.classAlreadyFinishedOrWithoutPermission()) {
					return;
				}

				if (event.Data.Type == "Definition") {
					swal(
						{
							title: r("are-you-sure"),
							text: r("confirm-remove-date") + moment(event.Data.Begin).format(utilities.getMomentDateFormat(userInfo.DateFormat)) + " " + moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
							type: "warning",
							showCancelButton: true,
							cancelButtonText: r("cancel"),
							confirmButtonColor: "#DD6B55",
							confirmButtonText: r("yes-delete"),
							closeOnConfirm: true
						},
						function(confirmed) {
							if (!confirmed) return;

							addOrRemoveExceptionToScheduleDays(event);
						}
					);
				}
				else {
					addOrRemoveExceptionToScheduleDays(event);
				}

			},
			eventRender: function(event, eventElement) {
			
				//SET FULL WIDTH
				$('.fc-month-view').css('width', '100%');

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);

				if(viewModel.classInfo().PublishState != 'Published' && !viewModel.classAlreadyFinishedOrWithoutPermission()) {

					var icon;

					var tt = event.Data.TrainingType;
					icon = "<i class='event-icon {0}' >".format(
						event.Data.Type == "Exception" ? "fa fa-plus" : "fa fa-times"
					);
			
					if (icon) {
						eventElement.find("div.fc-content").prepend(icon);
					}
				}

			}
		});
		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();


	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!currentDay) {
			return new Date();
		}
		return new Date(currentDay);
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}

	function addOrRemoveExceptionToScheduleDays(event) {
		var model = [{
			Begin: event.Data.Begin,
			Type: event.Data.Type == "Definition" ? "Exception" : "Definition" 
		}];

		classesService.updateExceptionClassScheduledDays(model, event.Data.ClassId)
			.done(function(response) {

				viewModel.classInfo(response.Class);
				viewModel.scheduleDays(response.ScheduledDays);

				toastr.success(r("activity-succesfully-updated"), r("changes-saved"));
					
				$('#calendar').fullCalendar( 'refetchEvents');
			
			})
			.fail(function (Response) {
				console.log("RESPONSE ERROR STATUS:" + Response.status);

				if (Response.responseText.includes("Schedule does not generate valid events")) {
					toastr.error(r("schedule-not-generate-event"), r("update-failed"));
				}
			});
	}
}

UptivoGeneratedActivitiesCalendar.prototype = Object.create(ControlBase.prototype);
UptivoGeneratedActivitiesCalendar.prototype.constructor = UptivoGeneratedActivitiesCalendar ;

function UptivoScheduleCalendar ($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;

	var calendarMode = mode;
	var currentDay = day;

	
	self.selectedWkSubscription = viewModel.selectedWk.subscribe(function(wk) {
		
		if (!wk) {
			return;
		}

		$('#schedule-calendar').fullCalendar('refetchEvents');
		
		// $('#schedule-calendar').fullCalendar('clientEvents')[0].end = moment('2024-09-24T11:00:00+02:00')

		// $('#schedule-calendar').fullCalendar('rerenderEvents')
	
	});

	this.initialize = function() {
	
		var calendarRendering = ko.observable(true);

		ko.applyBindingsToNode($("#schedule-calendardiv-id")[0], {
			loadingSpinner: calendarRendering
		});


		$element.fullCalendar({
			header: {
				left: "",
				center: "",
				right: ""
			},
			locale: resourceManager.getCurrentLanguage(),
			height: "auto",
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: false,
			fixedWeekCount: false,
			editable: true,
			allDaySlot: false,
			slotEventOverlap: false,
			// slotDuration: "00:30:00",
			minTime: '06:00',
			maxTime: '22:00',
			displayEventTime: false,
			displayEventEnd: false,
			displayEventStart: false,
			timezone: "local",
			eventLimit: 1,
			eventLimitText: function(moreNumber) { return  moreNumber + " EVENTS"} ,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),
			selectable: true,
			// snapDuration: '00:15:00',
			selectAllow: function(selectInfo) { 
				var duration = moment.duration(selectInfo.end.diff(selectInfo.start));
				return duration.asHours() <= 4;
		   },
			views: {
				basic: {
					columnFormat: 'ddd'
				},
				agenda: {
					columnFormat: 'ddd'
				},
				week: {
					columnFormat: 'ddd'
				},
				day: {
					columnFormat: 'ddd'
				}
			},

			viewRender: function(view) {

				var start = $("#schedule-calendar").fullCalendar("getView").intervalStart;
				var end = $("#schedule-calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
				
			},
			eventAfterAllRender: function() {

				if (!viewModel.scheduleCalendarDisabled()) {
					$(".fc-time-grid-event").css("cursor", "pointer");
				} else {
					$(".fc-time-grid-event").css("cursor", "not-allowed");
				}

			},
			events: function(start, end, timezone, callback) {

				end = end.clone().startOf("day");

				calendarRendering(true);

				var updatedEvents = [];

			
				events().forEach(function(c) {
					var start = c.start
					var end = c.end
					var event = {
						id: start + end,
						Data: c,
						title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)) + " - " + end.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
						start: start,
						end: end,
						allDay: false,
						className: ["uptivo-event"],
						subEvents: [],
						parentEvents: [],
						isSubEvent: false
					};
					updatedEvents.push(event);
				});

				if (viewModel.calendarType() == 'BridgeWorkouts') {
					var selectedWk = viewModel.selectedWk();
					
					if (selectedWk) {
						var wksDurationMinutes = _.ceil(moment.duration(selectedWk.Duration).asMinutes());
						wksDuration =  wksDurationMinutes >= 10 ? moment.duration(selectedWk.Duration) : moment.duration("00:10:00");

						_.each(updatedEvents, function(e) {
							e.end = moment(e.start + wksDuration);
							e.id = e.start + e.end;
							e.title = e.start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)) + " - " + e.end.format(utilities.getMomentTimeFormat(userInfo.TimeFormat));
						});
					}
				}

				events(updatedEvents);
				callback(updatedEvents);

				calendarRendering(false);
			},

			eventClick: function(event,e) {

				if(viewModel.scheduleCalendarDisabled()) {
					return;
				}

				if (e.target.id == 'remove-schedule-event' && viewModel.scheduleCalendarDisabled() == false) {
					 events(_.filter(events(), function(e) {
					return event.id != e.id;
				}))
					$('#schedule-calendar').fullCalendar('refetchEvents');
				}

			},
			eventRender: function(event, eventElement) {
				//SET FULL WIDTH
				$('.fc-month-view').css('width', '100%');

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);

				if(!viewModel.scheduleCalendarDisabled()) {

					var icon;
				
					icon = "<i class='event-icon fa fa-times' id='remove-schedule-event' style='margin-top: -3px; font-size: 14px;cursor: pointer'>";
					
			
					if (icon) {
						eventElement.find("div.fc-content").prepend(icon);
					}
				}

			},
			eventResize: function(event) {
			
				if(viewModel.scheduleCalendarDisabled()) {
					return;
				}
				
				var duration = moment.duration(event.end.diff(event.start));
				if ( duration.asHours() > 4){
					_.remove(events(), function(e) { return e.id == event.id});
					event.start = event.Data.start;
					event.end = event.Data.end;
					events.push(event);
					$('#schedule-calendar').fullCalendar('refetchEvents');
					return;
				}

				_.remove(events(), function(e) { return e.id == event.id});

				event.Data.start = event.start;
				event.Data.end = event.end;
				event.title = event.Data.start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)) + " - " + event.Data.end.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),

				events.push(event);

				$('#schedule-calendar').fullCalendar('refetchEvents');

			},
			eventDrop: function(event) {
				_.remove(events(), function(e) { return e.id == event.id});

				event.Data.start = event.start;
				event.Data.end = event.end;
				event.title = event.Data.start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)) + " - " + event.Data.end.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),

				events.push(event);

				$('#schedule-calendar').fullCalendar('refetchEvents');

			},
			select: function(start,end) {

				var event = {
							Type: "PT",
							Data: undefined,
							title: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat)),
							start: start,
							end: end,
							allDay: false,
							className: ["uptivo-event"],
							subEvents: [],
							parentEvents: [],
							isSubEvent: false,
							backgroundColor: "#03A9F4",
							borderColor: "#03A9F4",
					};

				
			
				events.push(event);

				$('#schedule-calendar').fullCalendar('refetchEvents');
			
			}
		});
	
		$(".fc-toolbar").hide();
	};


	function defaultDate() {
		if (!currentDay) {
			return new Date();
		}
		return new Date(currentDay);
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}


	viewModel.scheduleCalendarDisabled.subscribe(function(val){
		$('#schedule-calendar').fullCalendar('option', {editable: !val, selectable: !val});
		$('#schedule-calendar').fullCalendar('refetchEvents');
	})	
	

}


UptivoScheduleCalendar.prototype = Object.create(ControlBase.prototype);
UptivoScheduleCalendar.prototype.constructor = UptivoScheduleCalendar ;



function UptivoPTCalendar($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;
		clickCount = 0;

	var calendarMode = mode();

	this.initialize = function() {

		viewModel.calendarRendering(true);

		$(".start-date-class-id :input").prop("disabled", true);
		$(".end-date-class-id :input").prop("disabled", true);

		ko.applyBindingsToNode($("#pt-calendardiv")[0], {
			loadingSpinner: viewModel.calendarRendering,
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay",
			},
				locale: resourceManager.getCurrentLanguage(),
			minTime: '06:00',
			maxTime: '22:00',
			height: "auto",
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: true,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 4,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),
			selectable: true,
			columnHeaderFormat: (userInfo.DateFormat == "mmddyyyy" || userInfo.DateFormat == "yyyymmdd") ? 'ddd M/D' : 'ddd D/M', 

			selectAllow: function(selectInfo) { 
				var duration = moment.duration(selectInfo.end.diff(selectInfo.start));
				return duration.asHours() <= 4;
		   },
			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#pt-calendar").fullCalendar("getView").intervalStart;
				var end = $("#pt-calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
			
			},
			events: function(start, end, timezone, callback) {

				if (!viewModel.isTimeFilterValid()) {
					viewModel.calendarRendering(false);
					return;
				}

				viewModel.calendarRendering(true);

				var startTimeFilter;
				var endTimeFilter;

				if (viewModel.startTimeFilter()) {
					var startTimeFilter = viewModel.startTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						startTimeFilter = moment(startTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
						
					} 
				}

				if (viewModel.endTimeFilter()) {
					var endTimeFilter = viewModel.endTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						endTimeFilter = moment(endTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
					} 
				}

				var classesDef = clubsService.getPtClasses(
					viewModel.clubId,
					0,
					0,
					1000,
					viewModel.searchText(),
					start.toJSON(),
					end.clone().subtract(1, "day").endOf('day').toJSON(),
					viewModel.locationFilter(),
					viewModel.trainerNameId(),
					viewModel.trainingTypeFilter(),
					viewModel.activityTypeFilter(),
					viewModel.placeFilter(),
					viewModel.statusFilter(),
					viewModel.participantsFilter(),
					viewModel.subscriptionNameId(),
					viewModel.dayOfWeekFilter(),
					false,
					startTimeFilter,
					endTimeFilter		
				);
				classesDef
					.done(function(classesRes) {
						$('#pt-calendar').fullCalendar('option', 'minTime', '06:00');
						$('#pt-calendar').fullCalendar('option', 'maxTime', '22:00');

						var classes = classesRes.data;

						var updatedEvents = [];

						classes.forEach(function(c) {
							var start = moment(c.Begin);
							var end = moment(c.End);
							var event = {
								Type: "Class",
								Data: c,
								title: c.Name,
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false,
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(event) {
	
							if(moment(event.Data.Begin).hour() < 6) {
								$('#pt-calendar').fullCalendar('option', 'minTime', '00:00');
							}
							if(moment(event.Data.Begin).hour() > 22) {
								$('#pt-calendar').fullCalendar('option', 'maxTime', '24:00');
							}

						});

						events(updatedEvents);
						callback(updatedEvents);
					})
					.fail(function(xhr, error, status) {
						return;
					})
					.always(function() {
						localStorage.setItem("personalTrainers_activities_filter_options_v3", JSON.stringify(viewModel.generateFilterOptionsObj()));
					});
			},
			eventClick: function(event, e) {

				var $calendarElement = $(e.target);

				closeEventMenu();

				var participantsButtonVisible = event.Data.PublishState == 'Published' ? 'block' : 'none';
				// var publishButtonVisible = event.Data.PublishState == 'Unpublished' ? 'block' : 'none';

				var $menu = $(
					"<div class='uptivo-dropdown-menu" +
						"' style='border: 1px solid "+ event.Data.Color + " '>" +
						 "<i style='position: absolute;right: 2px; top: 2px; cursor: pointer' class='fa fa-times' click='closeEventMenu()'></i>" + 
						 "<ul style='padding-right: 20px;'>" +


						"<span style='display: " + participantsButtonVisible + "'>" +
						"<li" +
						" data-wm='" +
						'participants' +
						"'><i class='fa fa-users'></i> &nbsp;" +
						r("participants") +
						"</li></span>" +

						// "<span style='display: " + publishButtonVisible + "'>" +
						// "<li" +
						// " data-wm='" +
						// 'publish' +
						// "'><i class='fa fa-check-circle' data-toggle='tooltip' data-container='body' title='' style='color: green' data-original-title='Attivo'></i> &nbsp;" +
						// r("publish") +
						// "</li></span>" +

						"<li" +
						" data-wm='" +
						'edit' +
						"'><i class='fa fa-pencil-square-o'></i> &nbsp;" +
						r("edit") +
						"</li>" +

						"</ul></div>"
				);

				var cec;

				if($calendarElement[0].className.includes("uptivo-event")) {
					$containerElement = $calendarElement.parent().parent();
					var cec = $calendarElement
				} else {
					$containerElement = $calendarElement.parent().parent().parent();
					var cec = $calendarElement.parent()
				}

				$containerElement.append($menu);

				var position = cec.offset();

				$menu.offset({
					top: position.top + 2,
					left: position.left + 6
				});
				
				var onScreenOffset;

				if ($menu.offset().left + $menu.outerWidth() > $("body").prop("scrollWidth") - 15) {

					onScreenOffset = ($menu.offset().left + $menu.outerWidth() - $("body").prop("scrollWidth"))

					$menu.offset({
						top: position.top + 2,
						left: position.left - onScreenOffset - 15
					});	
				}

				$menu.find("li").click(function() {
					var selection = $(this).data("wm");

					switch (selection) {
						case 'participants':
							if(event.Data.PublishState == 'Unpublished') {
								return;
							}
							routing.navigateTo("ClubClassParticipants", { id: event.Data.ClassId });
							break;
						case 'publish':
							if(event.Data.PublishState == 'Published') {
								return;
							}
							updateClassPublishState(event.Data);
							break;
						case 'edit':
							routing.navigateTo("ClubClass", { id: event.Data.ClassId, type: event.Data.ClassType, calendarType: "PT" } );
							break;
						default:
							break;
					}
				});

			},
			eventRender: function(event, eventElement) {

				// TOOLTIP

				var tooltipTitle = '<div><span style="font-weight: 600;">' + r("title") + '</span>: ' + event.Data.Name + '</div>';
				var tooltipTrainingType = '<div><span style="font-weight: 600;">' + r("training-type") + '</span>: ' + utilities.getTrainingTypeName(event.Data.TrainingType); + '</div>';
				var tooltipDate = '<div><span style="font-weight: 600;">' + r("date") + '</span>: {0}</div>'.format(moment(event.Data.Begin).format(utilities.getMomentDateFormat(userInfo.DateFormat)));

				var tooltipTime = '<div><span style="font-weight: 600;">' + r("hour") + '</span>: {0} - {1}</div>'.format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var trainerName = event.Data.TrainerName ? event.Data.TrainerName : "";
		
				if (event.Data.TrainerPictureUri) {
					var tooltipTrainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				tooltipTrainerAvatar = tooltipTrainerAvatar ? tooltipTrainerAvatar.replace("<img", "<img style='width: 25px;'") : "";

				var tooltipTrainer = trainerName ? '<div><span style="font-weight: 600;">' + r("trainer") + '</span>: ' + tooltipTrainerAvatar + ' ' + trainerName + '</div>' : '<div><span style="font-weight: 600;">' + r("trainer") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipLocation = event.Data.Location ? '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + event.Data.Location + '</div>' : '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipOnsitePlaces = '<div><span style="font-weight: 600;">' + r("onsite-participants") + '</span>: ' + event.Data.InSiteParticipants + '/' + event.Data.MaxInSiteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.InSiteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostInSite + '</div>';
				
				var tooltipRemotePlaces = '<div><span style="font-weight: 600;">' + r("home-participants") + '</span>: ' + event.Data.RemoteParticipants + '/' + event.Data.MaxRemoteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.RemoteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostRemote + '</div>';

				var tooltip = 
				tooltipTitle + 
				tooltipTrainingType + 
				tooltipDate + 
				tooltipTime + 
				tooltipTrainer + 
				tooltipLocation +
				(event.Data.MaxInSiteParticipants > 0 ? tooltipOnsitePlaces : "") +
				(event.Data.MaxRemoteParticipants > 0 ? tooltipRemotePlaces : "");

				$(eventElement).attr("data-original-title", tooltip);
				$(eventElement).attr("data-container", "#pt-calendardiv");
				$(eventElement).tooltip({ html: true}).data('bs.tooltip').tip().addClass('uptivo-event-tooltip');

				// END TOOLTIP

				// CUSTOM FC CONTENT

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);
		
				eventElement.find("div.fc-content").empty();
				eventElement.find("div.fc-content").parent().css({"border-color": "rgb(164 162 162)", "border-left": "5px solid" + event.Data.Color, "margin-left": "1px"});
				eventElement.find("div.fc-content").css({"min-width": "190px", "height": "90px", "overflow": "hidden" });

				if (event.Data.InSiteParticipants + event.Data.RemoteParticipants > 0) {
					eventElement.find("div.fc-content").parent().css({"background-color": "wheat"});
				} 


				//Add diagonal stripes if event is unpublished
				if (event.Data.PublishState == "Unpublished") {
					var stripeUnpublishedColor = '#e3e3e3';
					$(eventElement).css("background", "repeating-linear-gradient(45deg," + stripeUnpublishedColor + "C0," + stripeUnpublishedColor + "C0 10px," + "white" + " 10px," + "white" + " 20px");
				}


				var startEnd = "<span>{0} - {1}</span>".format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var startTitle = "<span style='font-weight: 600'>{0} {1}</span>".format(
					moment(event.Data.Begin).format(userInfo.TimeFormat == "h12" ? "h:mma" : utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					event.Data.Name
				);

				link = utilities.getTrainingTypeIconUrl(event.Data.TrainingType);

				var iconType = '<div style="background-color: ' + event.Data.Color + '; height: 25px; width: 25px; border-radius: 5px; padding-top: 4px; padding-left: 5px;">' + 
				'<img class="training-type" style="width: 20px; height: 20px" src="'+ link + '" data-bind="changeToSvg : {color:"#f3712a", src: training.TrainingTypeIcon }" />' +
				'</div>'
		
				if (event.Data.TrainerPictureUri) {
					var trainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				trainerAvatar = trainerAvatar ? trainerAvatar : "";
			
				var eventName = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="font-size: 13px; max-height: 19px; overflow: hidden;"><b>'+ event.Data.Name + '</b></div>' : '<div style="font-size: 13px; max-height: 19px; overflow: hidden;">'+ event.Data.Name + '</div>';
				var eventParticipants = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;<b>'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) + '</b></div>' : '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) +'</div>';
				eventParticipants = event.Data.BookingMode == 'NotBookable' ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp' + translateBookingMode(event.Data.BookingMode) : eventParticipants;
				var liveIcon = event.Data.MaxRemoteParticipants > 0 ? '<div style="position: absolute; top: 53px; right: 1px"><i style="font-size: 16px" class="booking-home-icon"></i></div>' : "";
				var remoteIcon = event.Data.MaxInSiteParticipants > 0 ?'<div style="position: absolute; top: 54px; right: 18px"><i style="font-size: 16px" class="booking-onsite-icon"></i></div>' : "";
				var location = event.Data.Location ? '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + event.Data.Location + '</div>' : '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + r("unspecified") + '</div>';

				var customContent = '<div>'+ startTitle + '</div><div style="position: absolute; top: 1px; right: 1px">'+ iconType + '</div>' +
				// eventName +
				'<div>'+ trainerAvatar + ' ' + trainerName +'</div>' + 
				eventParticipants +
				liveIcon +
				remoteIcon +
				location;

				eventElement.find("div.fc-content").append(customContent);

				//add id for custom classes events css
				eventElement.find("div.fc-content").attr("id", "events-calendar-content");
			},
			eventAfterAllRender: function() {
				viewModel.calendarRendering(false);
				// SET DATE BASED ON START DATE
				if (day() != viewModel.eventsCalendarDate()) {
					$('.calendar-date-selection-input-hide').datepicker("setDate", moment($('.start-date-class-id input').datepicker("getDate")).format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				} else {
					$('.start-date-class-id input').datepicker("setDate", $("#pt-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.end-date-class-id input').datepicker("setDate", $("#pt-calendar").fullCalendar("getView").intervalEnd.clone().subtract(1, "day").format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.calendar-date-selection-input-hide').datepicker("setDate", $("#pt-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				}
			},
			select: function(start,end, event) {

				if ($(event.target).closest('.uptivo-dropdown-menu').length) {
					 
				} else {

					if(end.isBefore(moment()))
					{
						toastr.error(r("lesson-schedule-end-date-in-past"), r("operation-failed"));
						return;
					}

					// DEFAULT SETTINGS
					if (userInfo.hasRole(USER_ROLES.TRAINER, viewModel.clubId))
					{
						var trainer = {
							"Nickname": userInfo.Nickname,
							"PictureUri": userInfo.PictureUri,
							"UserId": userInfo.UserId,
							"Email": userInfo.Email,
							"FirstMidName": userInfo.FirstMidName,
							"LastName": userInfo.LastName
						}
						viewModel.selectedTrainer(trainer);
					} else {
						viewModel.selectedTrainer(null);
					}

					viewModel.editData.name(r("pt-lesson"));
					viewModel.editData.maxInSiteParticipants(1);
					viewModel.editData.availableRemotePlaces(0);
					viewModel.editData.creditsCostInSite(0);
					viewModel.editData.creditsCostRemote(0);
					viewModel.editData.visibilityPreDays(7);

					viewModel.editData.scheduleStartDate(start.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					viewModel.editData.singleStartTime(start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)));
					viewModel.editData.singleDuration(moment.duration(end.diff(start)).asMinutes());
				
					_.forEach(viewModel.clubSubscriptions(), function(cs) {
						cs.InSite(false);
						cs.Remote(false);
					})
					utilities.openModal("fastCreatePTLesson");

					// var singleCalendarSelectionSchedule = {
					// 	scheduleStartDate: start.format(utilities.getMomentDateFormat(userInfo.DateFormat)),
					// 	singleStartTime: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					// 	singleDuration: moment.duration(end.diff(start)).asMinutes()
					// }

					// routing.navigateTo("ClubClass", { singleCalendarSelectionSchedule: singleCalendarSelectionSchedule, type: "Single", calendarType: "PT" } );
				}
			}
		});

		viewModel.refreshInfoText = function(){
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();


		// WATCH MENU CLOSE IF CLICK OUTSIDE
		$('body').click(function(event){
			if ($(event.target).closest('.uptivo-event').length) {
				return; 
			} else {
				closeEventMenu();
			}
		});



	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!day() || day() == "today") {
			return new Date();
		}
		return new Date(moment(day(), utilities.getMomentDateFormat(userInfo.DateFormat), true).toJSON());
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}

	function closeEventMenu() {
	
		var menu = $(".uptivo-dropdown-menu")
		
		if (menu) {
			menu.remove();
		}
	}


	function updateClassPublishState(eventData) {

		if (eventData.classType == "Group") {
			swal(
				{
					title: r("are-you-sure"),
					text: r("confirm-publish-lesson-template"),
					type: "warning",
					showCancelButton: true,
					cancelButtonText: r("cancel"),
					confirmButtonColor: "#DD6B55",
					confirmButtonText: r("confirm"),
					closeOnConfirm: true
				},
				function (confirmed) {
					if (!confirmed) return;
					publishClass(eventData);
				}
			);
		} else {
			publishClass(eventData);
		}
	}


	function publishClass(eventData) {
		
		classesService.updateClassPublishState(eventData.ClassId, "Published")
		.done(function (response) {
			toastr.success(r("status") + ": " + r("Published"), r("changes-saved"));
			$('#pt-calendar').fullCalendar('refetchEvents');
		})
	}


	window.addEventListener('resize', function (e) { 
		$('.fc-content').width($('.uptivo-event').width());
	 }, false);
}

UptivoPTCalendar.prototype = Object.create(ControlBase.prototype);
UptivoPTCalendar.prototype.constructor = UptivoPTCalendar;



function ServicesCalendar($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;
		clickCount = 0;

	var calendarMode = mode();

	this.initialize = function() {

		viewModel.calendarRendering(true);

		$(".start-date-class-id :input").prop("disabled", true);
		$(".end-date-class-id :input").prop("disabled", true);

		ko.applyBindingsToNode($("#services-calendardiv")[0], {
			loadingSpinner: viewModel.calendarRendering,
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay",
			},
				locale: resourceManager.getCurrentLanguage(),
			minTime: '06:00',
			maxTime: '22:00',
			height: "auto",
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: true,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 4,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),
			selectable: true,
			columnHeaderFormat: (userInfo.DateFormat == "mmddyyyy" || userInfo.DateFormat == "yyyymmdd") ? 'ddd M/D' : 'ddd D/M', 

			selectAllow: function(selectInfo) { 
				var duration = moment.duration(selectInfo.end.diff(selectInfo.start));
				return duration.asHours() <= 4;
		   },
			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#services-calendar").fullCalendar("getView").intervalStart;
				var end = $("#services-calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
			
			},
			events: function(start, end, timezone, callback) {

				if (!viewModel.isTimeFilterValid()) {
					viewModel.calendarRendering(false);
					return;
				}

				viewModel.calendarRendering(true);

				var startTimeFilter;
				var endTimeFilter;

				if (viewModel.startTimeFilter()) {
					var startTimeFilter = viewModel.startTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						startTimeFilter = moment(startTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
						
					} 
				}

				if (viewModel.endTimeFilter()) {
					var endTimeFilter = viewModel.endTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						endTimeFilter = moment(endTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
					} 
				}

				var classesDef = clubsService.getServicesClasses(
					viewModel.clubId,
					0,
					0,
					1000,
					viewModel.searchText(),
					start.toJSON(),
					end.clone().subtract(1, "day").endOf('day').toJSON(),
					viewModel.locationFilter(),
					viewModel.trainerNameId(),
					viewModel.serviceTypeFilter(),
					viewModel.activityTypeFilter(),
					viewModel.placeFilter(),
					viewModel.statusFilter(),
					viewModel.participantsFilter(),
					viewModel.subscriptionNameId(),
					viewModel.dayOfWeekFilter(),
					false,
					startTimeFilter,
					endTimeFilter				
				);
				classesDef
					.done(function(classesRes) {
						$('#services-calendar').fullCalendar('option', 'minTime', '06:00');
						$('#services-calendar').fullCalendar('option', 'maxTime', '22:00');

						var classes = classesRes.data;

						var updatedEvents = [];

						classes.forEach(function(c) {
							var start = moment(c.Begin);
							var end = moment(c.End);
							var event = {
								Type: "Class",
								Data: c,
								title: c.Name,
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false,
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(event) {
	
							if(moment(event.Data.Begin).hour() < 6) {
								$('#services-calendar').fullCalendar('option', 'minTime', '00:00');
							}
							if(moment(event.Data.Begin).hour() > 22) {
								$('#services-calendar').fullCalendar('option', 'maxTime', '24:00');
							}

						});

						events(updatedEvents);
						callback(updatedEvents);
					})
					.fail(function(xhr, error, status) {
						return;
					})
					.always(function() {
						localStorage.setItem("services_activities_filter_options_v3", JSON.stringify(viewModel.generateFilterOptionsObj()));
					});
			},
			eventClick: function(event, e) {

				var $calendarElement = $(e.target);

				closeEventMenu();

				var participantsButtonVisible = event.Data.PublishState == 'Published' ? 'block' : 'none';
				// var publishButtonVisible = event.Data.PublishState == 'Unpublished' ? 'block' : 'none';

				var $menu = $(
					"<div class='uptivo-dropdown-menu" +
						"' style='border: 1px solid "+ event.Data.Color + " '>" +
						 "<i style='position: absolute;right: 2px; top: 2px; cursor: pointer' class='fa fa-times' click='closeEventMenu()'></i>" + 
						 "<ul style='padding-right: 20px;'>" +


						"<span style='display: " + participantsButtonVisible + "'>" +
						"<li" +
						" data-wm='" +
						'participants' +
						"'><i class='fa fa-users'></i> &nbsp;" +
						r("participants") +
						"</li></span>" +

						// "<span style='display: " + publishButtonVisible + "'>" +
						// "<li" +
						// " data-wm='" +
						// 'publish' +
						// "'><i class='fa fa-check-circle' data-toggle='tooltip' data-container='body' title='' style='color: green' data-original-title='Attivo'></i> &nbsp;" +
						// r("publish") +
						// "</li></span>" +

						"<li" +
						" data-wm='" +
						'edit' +
						"'><i class='fa fa-pencil-square-o'></i> &nbsp;" +
						r("edit") +
						"</li>" +

						"</ul></div>"
				);

				var cec;

				if($calendarElement[0].className.includes("uptivo-event")) {
					$containerElement = $calendarElement.parent().parent();
					var cec = $calendarElement
				} else {
					$containerElement = $calendarElement.parent().parent().parent();
					var cec = $calendarElement.parent()
				}

				$containerElement.append($menu);

				var position = cec.offset();

				$menu.offset({
					top: position.top + 2,
					left: position.left + 6
				});
				
				var onScreenOffset;

				if ($menu.offset().left + $menu.outerWidth() > $("body").prop("scrollWidth") - 15) {

					onScreenOffset = ($menu.offset().left + $menu.outerWidth() - $("body").prop("scrollWidth"))

					$menu.offset({
						top: position.top + 2,
						left: position.left - onScreenOffset - 15
					});	
				}

				$menu.find("li").click(function() {
					var selection = $(this).data("wm");

					switch (selection) {
						case 'participants':
							if(event.Data.PublishState == 'Unpublished') {
								return;
							}
							routing.navigateTo("ClubClassParticipants", { id: event.Data.ClassId });
							break;
						case 'publish':
							if(event.Data.PublishState == 'Published') {
								return;
							}
							updateClassPublishState(event.Data);
							break;
						case 'edit':
							routing.navigateTo("ClubClass", { id: event.Data.ClassId, type: event.Data.ClassType, calendarType: "Services" } );
							break;
						default:
							break;
					}
				});

			},
			eventRender: function(event, eventElement) {

				// TOOLTIP

				var tooltipTitle = '<div><span style="font-weight: 600;">' + r("title") + '</span>: ' + event.Data.Name + '</div>';
				var bookingMode = '<div><span style="font-weight: 600;">' + r("booking-mode") + '</span>: ' + translateBookingMode(event.Data.BookingMode) + '</div>';
				var tooltipServiceType = '<div><span style="font-weight: 600;">' + r("service-type") + '</span>: ' + utilities.getServiceTypeName(event.Data.TrainingType); + '</div>';
				var tooltipDate = '<div><span style="font-weight: 600;">' + r("date") + '</span>: {0}</div>'.format(moment(event.Data.Begin).format(utilities.getMomentDateFormat(userInfo.DateFormat)));

				var tooltipTime = '<div><span style="font-weight: 600;">' + r("hour") + '</span>: {0} - {1}</div>'.format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var trainerName = event.Data.TrainerName ? event.Data.TrainerName : "";
		
				if (event.Data.TrainerPictureUri) {
					var tooltipTrainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				tooltipTrainerAvatar = tooltipTrainerAvatar ? tooltipTrainerAvatar.replace("<img", "<img style='width: 25px;'") : "";

				var tooltipTrainer = trainerName ? '<div><span style="font-weight: 600;">' + r("operator") + '</span>: ' + tooltipTrainerAvatar + ' ' + trainerName + '</div>' : '<div><span style="font-weight: 600;">' + r("operator") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipLocation = event.Data.Location ? '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + event.Data.Location + '</div>' : '<div><span style="font-weight: 600;">' + r("location") + '</span>: ' + r("unspecified") + '</div>';

				var tooltipOnsitePlaces = '<div><span style="font-weight: 600;">' + r("onsite-participants") + '</span>: ' + event.Data.InSiteParticipants + '/' + event.Data.MaxInSiteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.InSiteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostInSite + '</div>';
				
				var tooltipRemotePlaces = '<div><span style="font-weight: 600;">' + r("home-participants") + '</span>: ' + event.Data.RemoteParticipants + '/' + event.Data.MaxRemoteParticipants + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">   ' +  r("waiting") + '</span>: ' + event.Data.RemoteQueued + '&nbsp;&nbsp;&nbsp;<span style="font-weight: 600;">' +  r("credits-required") + '</span>: ' + event.Data.CreditsCostRemote + '</div>';

				var tooltip = 
				tooltipTitle +
				bookingMode +
				tooltipServiceType + 
				tooltipDate + 
				tooltipTime + 
				tooltipTrainer + 
				tooltipLocation +
				(event.Data.MaxInSiteParticipants > 0 ? tooltipOnsitePlaces : "") +
				(event.Data.MaxRemoteParticipants > 0 ? tooltipRemotePlaces : "");

				$(eventElement).attr("data-original-title", tooltip);
				$(eventElement).attr("data-container", "#services-calendardiv");
				$(eventElement).tooltip({ html: true}).data('bs.tooltip').tip().addClass('uptivo-event-tooltip');

				// END TOOLTIP

				// CUSTOM FC CONTENT

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);
		
				eventElement.find("div.fc-content").empty();
				eventElement.find("div.fc-content").parent().css({"border-color": "rgb(164 162 162)", "border-left": "5px solid" + event.Data.Color, "margin-left": "1px"});
				eventElement.find("div.fc-content").css({"min-width": "190px", "height": "90px", "overflow": "hidden" });

				if (event.Data.InSiteParticipants + event.Data.RemoteParticipants > 0) {
					eventElement.find("div.fc-content").parent().css({"background-color": "wheat"});
				} 


				//Add diagonal stripes if event is unpublished
				if (event.Data.PublishState == "Unpublished") {
					var stripeUnpublishedColor = '#e3e3e3';
					$(eventElement).css("background", "repeating-linear-gradient(45deg," + stripeUnpublishedColor + "C0," + stripeUnpublishedColor + "C0 10px," + "white" + " 10px," + "white" + " 20px");
				}


				var startEnd = "<span>{0} - {1}</span>".format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var startTitle = "<span style='font-weight: 600'>{0} {1}</span>".format(
					moment(event.Data.Begin).format(userInfo.TimeFormat == "h12" ? "h:mma" : utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					event.Data.Name
				);

				link = utilities.getServiceTypeIconUrl(event.Data.TrainingType);

				var iconType = '<div style="background-color: ' + event.Data.Color + '; height: 25px; width: 25px; border-radius: 5px; padding-top: 4px; padding-left: 5px;">' + 
				'<img class="training-type" style="width: 20px; height: 20px" src="'+ link + '" data-bind="changeToSvg : {color:"#f3712a", src: training.ServiceTypeIcon }" />' +
				'</div>'
		
				if (event.Data.TrainerPictureUri) {
					var trainerAvatar = utilities.avatarColumn(
						event.Data.TrainerPictureUri,
						event.Data.TrainerName,
						CONFIGURATION.DEFAULT_PHOTO,
						40,
						false
					);
				}

				trainerAvatar = trainerAvatar ? trainerAvatar : "";
			
				var eventName = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="font-size: 13px; max-height: 19px; overflow: hidden;"><b>'+ event.Data.Name + '</b></div>' : '<div style="font-size: 13px; max-height: 19px; overflow: hidden;">'+ event.Data.Name + '</div>';
				var eventParticipants = (event.Data.InSiteParticipants + event.Data.RemoteParticipants) > 0 ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;<b>'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) + '</b></div>' : '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp;'+ (event.Data.InSiteParticipants + event.Data.RemoteParticipants) + '/' + (event.Data.MaxInSiteParticipants + event.Data.MaxRemoteParticipants) +'</div>';
				eventParticipants = event.Data.BookingMode == 'NotBookable' ? '<div style="margin-top: 10px"><i class="fa fa-users"></i>&nbsp' + translateBookingMode(event.Data.BookingMode) : eventParticipants;
				var liveIcon = event.Data.MaxRemoteParticipants > 0 ? '<div style="position: absolute; top: 53px; right: 1px"><i style="font-size: 16px" class="booking-home-icon"></i></div>' : "";
				var remoteIcon = event.Data.MaxInSiteParticipants > 0 ?'<div style="position: absolute; top: 54px; right: 18px"><i style="font-size: 16px" class="booking-onsite-icon"></i></div>' : "";
				var location = event.Data.Location ? '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + event.Data.Location + '</div>' : '<div><i style="font-size: 16px" class="fa fa-map-marker"></i>&nbsp;' + r("unspecified") + '</div>';

				var customContent = '<div>'+ startTitle + '</div><div style="position: absolute; top: 1px; right: 1px">'+ iconType + '</div>' +
				// eventName +
				'<div>'+ trainerAvatar + ' ' + trainerName +'</div>' + 
				eventParticipants +
				liveIcon +
				remoteIcon +
				location;

				eventElement.find("div.fc-content").append(customContent);

				//add id for custom classes events css
				eventElement.find("div.fc-content").attr("id", "events-calendar-content");
			},
			eventAfterAllRender: function() {
				viewModel.calendarRendering(false);
				// SET DATE BASED ON START DATE
				if (day() != viewModel.eventsCalendarDate()) {
					$('.calendar-date-selection-input-hide').datepicker("setDate", moment($('.start-date-class-id input').datepicker("getDate")).format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				} else {
					$('.start-date-class-id input').datepicker("setDate", $("#services-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.end-date-class-id input').datepicker("setDate", $("#services-calendar").fullCalendar("getView").intervalEnd.clone().subtract(1, "day").format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.calendar-date-selection-input-hide').datepicker("setDate", $("#services-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				}
			},
			select: function(start,end, event) {

				if (viewModel.userIsManager() == false) {
					return;
				}

				if ($(event.target).closest('.uptivo-dropdown-menu').length) {
					 
				} else {

					if(end.isBefore(moment()))
					{
						toastr.error(r("lesson-schedule-end-date-in-past"), r("operation-failed"));
						return;
					}

					// DEFAULT SETTINGS
					// viewModel.selectedTrainer(null);
					// viewModel.editData.name(r("service-lesson"));
					// viewModel.editData.maxInSiteParticipants(1);
					// viewModel.editData.availableRemotePlaces(0);
					// viewModel.editData.creditsCostInSite(0);
					// viewModel.editData.creditsCostRemote(0);

					// viewModel.editData.scheduleStartDate(start.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					// viewModel.editData.singleStartTime(start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)));
					// viewModel.editData.singleDuration(moment.duration(end.diff(start)).asMinutes());

					// utilities.openModal("fastCreateServiceLesson");

					var singleCalendarSelectionSchedule = {
						scheduleStartDate: start.format(utilities.getMomentDateFormat(userInfo.DateFormat)),
						singleStartTime: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
						singleDuration: moment.duration(end.diff(start)).asMinutes()
					}

					routing.navigateTo("ClubClass", { singleCalendarSelectionSchedule: singleCalendarSelectionSchedule, type: "Single", calendarType: "Services" } );

				}
			}
		});

		viewModel.refreshInfoText = function(){
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();


		// WATCH MENU CLOSE IF CLICK OUTSIDE
		$('body').click(function(event){
			if ($(event.target).closest('.uptivo-event').length) {
				return; 
			} else {
				closeEventMenu();
			}
		});



	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!day() || day() == "today") {
			return new Date();
		}
		return new Date(moment(day(), utilities.getMomentDateFormat(userInfo.DateFormat), true).toJSON());
	}


	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}

	function closeEventMenu() {
	
		var menu = $(".uptivo-dropdown-menu")
		
		if (menu) {
			menu.remove();
		}
	}

	function translateBookingMode(bookingMode) {

		switch (bookingMode) {
			case 'Invite':
			  return r("invite-booking-mode");
			case 'Open':
			  return r("open-booking-mode");
			case 'NotBookable':
			  return r("free-access");
		  }
	}


	function updateClassPublishState(eventData) {

		if (eventData.classType == "Group") {
			swal(
				{
					title: r("are-you-sure"),
					text: r("confirm-publish-lesson-template"),
					type: "warning",
					showCancelButton: true,
					cancelButtonText: r("cancel"),
					confirmButtonColor: "#DD6B55",
					confirmButtonText: r("confirm"),
					closeOnConfirm: true
				},
				function (confirmed) {
					if (!confirmed) return;
					publishClass(eventData);
				}
			);
		} else {
			publishClass(eventData);
		}
	}


	function publishClass(eventData) {
		
		classesService.updateClassPublishState(eventData.ClassId, "Published")
		.done(function (response) {
			toastr.success(r("status") + ": " + r("Published"), r("changes-saved"));
			$('#services-calendar').fullCalendar('refetchEvents');
		})
	}


	window.addEventListener('resize', function (e) { 
		$('.fc-content').width($('.uptivo-event').width());
	 }, false);
}

ServicesCalendar.prototype = Object.create(ControlBase.prototype);
ServicesCalendar.prototype.constructor = ServicesCalendar;



function CircuitsCalendar($element, day, mode, source, viewModel, allBindings) {
	var NEXT_MONTH_CLASS = "uptivo-next-month",
		PREV_MONTH_CLASS = "uptivo-prev-month",
		CURRENT_MONTH_CLASS = "uptivo-current-month",
		MONTH_VIEW_CLASS = "uptivo-month-button",
		WEEK_VIEW_CLASS = "uptivo-week-button",
		events = source,
		userInfo = userData.get(),
		rendered = false,
		self = this;
		clickCount = 0;

	var calendarMode = mode();

	this.initialize = function() {

		viewModel.calendarRendering(true);

		$(".start-date-class-id :input").prop("disabled", true);
		$(".end-date-class-id :input").prop("disabled", true);

		ko.applyBindingsToNode($("#bridge-workouts-calendardiv")[0], {
			loadingSpinner: viewModel.calendarRendering,
		});

		addCalendarModeButton();

		$element.fullCalendar({
			header: {
				left: "prev,next today",
				center: "title",
				right: "month,agendaWeek,agendaDay",
			},
				locale: resourceManager.getCurrentLanguage(),
			minTime: '06:00',
			maxTime: '22:00',
			height: "auto",
			defaultView: calendarMode,
			eventOrder: "+start",
			timeFormat: "H(:mm)", // uppercase H for 24-hour clock
			droppable: true,
			editable: false,
			fixedWeekCount: false,
			allDaySlot: false,
			slotEventOverlap: false,
			slotDuration: "00:30:00",
			displayEventTime: false,
			displayEventEnd: false,
			timezone: "local",
			eventLimit: 4,
			slotLabelFormat: utilities.getMomentTimeFormat(userInfo.TimeFormat),
			defaultDate: defaultDate(),
			now: new Date(),
			firstDay: utilities.weekDayNumber(viewModel.startWeekDay()),
			selectable: true,
			columnHeaderFormat: (userInfo.DateFormat == "mmddyyyy" || userInfo.DateFormat == "yyyymmdd") ? 'ddd M/D' : 'ddd D/M', 

			selectAllow: function(selectInfo) { 
				var duration = moment.duration(selectInfo.end.diff(selectInfo.start));
				return duration.asHours() <= 4;
		   },
			viewRender: function(view) {
				if (allBindings().granularity) allBindings().granularity(view.viewSpec.durationUnit);

				var start = $("#bridge-workouts-calendar").fullCalendar("getView").intervalStart;
				var end = $("#bridge-workouts-calendar").fullCalendar("getView").intervalEnd;

				end = end
					.clone()
					.subtract(1, "day")
					.endOf("day");

				if (allBindings().start) {
					allBindings().start(start);
				}

				if (allBindings().end) {
					allBindings().end(end);
				}
			
			},
			events: function(start, end, timezone, callback) {

				if (!viewModel.isTimeFilterValid()) {
					viewModel.calendarRendering(false);
					return;
				}

				viewModel.calendarRendering(true);

				var startTimeFilter;
				var endTimeFilter;

				if (viewModel.startTimeFilter()) {
					var startTimeFilter = viewModel.startTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						startTimeFilter = moment(startTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
						
					} 
				}

				if (viewModel.endTimeFilter()) {
					var endTimeFilter = viewModel.endTimeFilter();
					if (userInfo.TimeFormat == 'h12') {
						endTimeFilter = moment(endTimeFilter, utilities.getMomentTimeFormat(userInfo.TimeFormat, false)).format('HH:mm');
					} 
				}

				var classesDef = clubsService.getBridgeWorkoutsClasses(
					viewModel.clubId,
					0,
					0,
					1000,
					viewModel.searchText(),
					start.toJSON(),
					end.clone().subtract(1, "day").endOf('day').toJSON(),
					viewModel.locationFilter(),
					viewModel.trainerNameId(),
					viewModel.serviceTypeFilter(),
					viewModel.activityTypeFilter(),
					viewModel.placeFilter(),
					viewModel.statusFilter(),
					viewModel.participantsFilter(),
					viewModel.subscriptionNameId(),
					viewModel.dayOfWeekFilter(),
					false,
					startTimeFilter,
					endTimeFilter,
					viewModel.circuitsFilter(),
					viewModel.displayGroupFilter()	
				);
				classesDef
					.done(function(classesRes) {
						$('#bridge-workouts-calendar').fullCalendar('option', 'minTime', '06:00');
						$('#bridge-workouts-calendar').fullCalendar('option', 'maxTime', '22:00');

						var classes = classesRes.data;

						var updatedEvents = [];

						classes.forEach(function(c) {
							var start = moment(c.Begin);
							var end = moment(c.End);
							var event = {
								Type: "Class",
								Data: c,
								title: c.Name,
								start: start,
								end: end,
								allDay: false,
								className: ["uptivo-event"],
								subEvents: [],
								parentEvents: [],
								isSubEvent: false,
							};
							updatedEvents.push(event);
						});

						updatedEvents.forEach(function(event) {
	
							if(moment(event.Data.Begin).hour() < 6) {
								$('#bridge-workouts-calendar').fullCalendar('option', 'minTime', '00:00');
							}
							if(moment(event.Data.Begin).hour() > 22) {
								$('#bridge-workouts-calendar').fullCalendar('option', 'maxTime', '24:00');
							}

						});

						events(updatedEvents);
						callback(updatedEvents);
					})
					.fail(function(xhr, error, status) {
						return;
					})
					.always(function() {
						localStorage.setItem("bridge_workouts_activities_filter_options_v3", JSON.stringify(viewModel.generateFilterOptionsObj()));
					});
			},
			eventClick: function(event, e) {
				routing.navigateTo("ClubClass", { id: event.Data.ClassId, type: event.Data.ClassType, calendarType: "BridgeWorkouts" } );
			},
			eventRender: function(event, eventElement) {

				var eventDisplayGroup = _.find(viewModel.clubDisplayGroups(), {"DisplayGroupId" : event.Data.DisplayGroupId });

				var eventDisplayGroupName = "";
				var eventDisplayGroupColor = "grey";

				if (eventDisplayGroup) {
					eventDisplayGroupName = eventDisplayGroup.Name;
					eventDisplayGroupColor = eventDisplayGroup.Color;
				}

				// TOOLTIP

				var tooltipTitle = '<div><span style="font-weight: 600;">' + r("title") + '</span>: ' + event.Data.Name + '</div>';
				var tooltipDate = '<div><span style="font-weight: 600;">' + r("date") + '</span>: {0}</div>'.format(moment(event.Data.Begin).format(utilities.getMomentDateFormat(userInfo.DateFormat)));

				var tooltipDisplayGroup = '<div><span style="font-weight: 600;">' + r("display-group") + '</span>: {0}</div>'.format(eventDisplayGroupName);


				var tooltipTime = '<div><span style="font-weight: 600;">' + r("hour") + '</span>: {0} - {1}</div>'.format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var tooltip = tooltipTitle + tooltipDate + tooltipTime + tooltipDisplayGroup;
			
				$(eventElement).attr("data-original-title", tooltip);
				$(eventElement).attr("data-container", "#bridge-workouts-calendardiv");
				$(eventElement).tooltip({ html: true}).data('bs.tooltip').tip().addClass('uptivo-event-tooltip');

				// END TOOLTIP

				// CUSTOM FC CONTENT

				var $overlay = $('<div class="event-overlay"></div>');
				eventElement
					.find("div.fc-content")
					.parent()
					.append($overlay);
		
				eventElement.find("div.fc-content").empty();
				eventElement.find("div.fc-content").parent().css({"border-color": "rgb(164 162 162)", "border-left": "5px solid " + eventDisplayGroupColor, "margin-left": "1px"});
				eventElement.find("div.fc-content").css({"min-width": "190px", "height": "90px", "overflow": "hidden" });

				//Add diagonal stripes if event is unpublished
				if (event.Data.PublishState == "Unpublished") {
					var stripeUnpublishedColor = '#e3e3e3';
					$(eventElement).css("background", "repeating-linear-gradient(45deg," + stripeUnpublishedColor + "C0," + stripeUnpublishedColor + "C0 10px," + "white" + " 10px," + "white" + " 20px");
				}


				var startEnd = "<span>{0} - {1}</span>".format(
					moment(event.Data.Begin).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					moment(event.Data.End).format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false))
				);

				var startTitle = "<span style='font-weight: 600'>{0} {1}</span>".format(
					moment(event.Data.Begin).format(userInfo.TimeFormat == "h12" ? "h:mma" : utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
					event.Data.Name
				);

				link = utilities.getServiceTypeIconUrl(event.Data.TrainingType);

				var customContent = '<div>'+ startTitle + '</div>';
			
				eventElement.find("div.fc-content").append(customContent);

				//add id for custom classes events css
				eventElement.find("div.fc-content").attr("id", "events-calendar-content");
			},
			eventAfterAllRender: function() {
				viewModel.calendarRendering(false);
				// SET DATE BASED ON START DATE
				if (day() != viewModel.eventsCalendarDate()) {
					$('.calendar-date-selection-input-hide').datepicker("setDate", moment($('.start-date-class-id input').datepicker("getDate")).format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				} else {
					$('.start-date-class-id input').datepicker("setDate", $("#bridge-workouts-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.end-date-class-id input').datepicker("setDate", $("#bridge-workouts-calendar").fullCalendar("getView").intervalEnd.clone().subtract(1, "day").format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					$('.calendar-date-selection-input-hide').datepicker("setDate", $("#bridge-workouts-calendar").fullCalendar("getView").intervalStart.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
				}
			},
			select: function(start,end, event) {

				if (viewModel.userIsManager() == false) {
					return;
				}

				if ($(event.target).closest('.uptivo-dropdown-menu').length) {
					 
				} else {

					if(end.isBefore(moment()))
					{
						toastr.error(r("lesson-schedule-end-date-in-past"), r("operation-failed"));
						return;
					}

					// viewModel.editData.scheduleStartDate(start.format(utilities.getMomentDateFormat(userInfo.DateFormat)));
					// viewModel.editData.singleStartTime(start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)));
					// viewModel.editData.singleDuration(moment.duration(end.diff(start)).asMinutes());
				
					// _.forEach(viewModel.clubSubscriptions(), function(cs) {
					// 	cs.InSite(false);
					// 	cs.Remote(false);
					// })
					// utilities.openModal("create-edit-circuit");

					var singleCalendarSelectionSchedule = {
						scheduleStartDate: start.format(utilities.getMomentDateFormat(userInfo.DateFormat)),
						singleStartTime: start.format(utilities.getMomentTimeFormat(userInfo.TimeFormat, false)),
						singleDuration: moment.duration(end.diff(start)).asMinutes()
					}

					routing.navigateTo("ClubClass", { singleCalendarSelectionSchedule: singleCalendarSelectionSchedule, type: "Single", calendarType: "BridgeWorkouts" } );

				}
			}
		});

		viewModel.refreshInfoText = function(){
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		function refreshInfoText() {
			var currentMonth = $(".fc-center h2").html();
			$("." + CURRENT_MONTH_CLASS).html(currentMonth);
		}

		$("." + NEXT_MONTH_CLASS).on("click", function() {
			$(".fc-next-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + PREV_MONTH_CLASS).on("click", function() {
			$(".fc-prev-button").trigger("click");
			refreshInfoText();
			preventHashChange();
		});

		$("." + MONTH_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").show();

			calendarMode = "month";
			cache.set("agendaWeek", false);

			$(".fc-month-button").trigger("click");

			$("." + WEEK_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			preventHashChange();
			refreshInfoText();
		});

		$("." + WEEK_VIEW_CLASS).on("click", function() {
			$(".fc-week-view-summary").hide();

			calendarMode = "agendaWeek";
			cache.set("agendaWeek", true);

			$(".fc-agendaWeek-button").trigger("click");

			$("." + MONTH_VIEW_CLASS).removeClass("uptivo-active");
			$(this).addClass("uptivo-active");
			refreshInfoText();
		});

		$("." + CURRENT_MONTH_CLASS).html($(".fc-center h2").html());
		$(".fc-toolbar").hide();


		// WATCH MENU CLOSE IF CLICK OUTSIDE
		$('body').click(function(event){
			if ($(event.target).closest('.uptivo-event').length) {
				return; 
			} else {
				closeEventMenu();
			}
		});



	};

	function addCalendarModeButton() {
		if (calendarMode == "month") {
			$("." + MONTH_VIEW_CLASS).addClass("uptivo-active");
			cache.set("agendaWeek", false);
		}
		if (calendarMode == "agendaWeek") {
			$("." + WEEK_VIEW_CLASS).addClass("uptivo-active");
		}
	}

	function defaultDate() {
		if (!day() || day() == "today") {
			return new Date();
		}
		return new Date(moment(day(), utilities.getMomentDateFormat(userInfo.DateFormat), true).toJSON());
	}

	this.update = function() {
		rendered = false;

		$element.trigger("viewRender");

		if (calendarMode == "agendaWeek") $(".fc-week-view-summary").hide();

		preventHashChange();
	};

	function preventHashChange() {
		$(".fc-content-skeleton").on("click", ".fc-more", function() {
			return false; //to prevent hash change on anchor click!
		});
	}

	function closeEventMenu() {
	
		var menu = $(".uptivo-dropdown-menu")
		
		if (menu) {
			menu.remove();
		}
	}

	function translateBookingMode(bookingMode) {

		switch (bookingMode) {
			case 'Invite':
			  return r("invite-booking-mode");
			case 'Open':
			  return r("open-booking-mode");
			case 'NotBookable':
			  return r("free-access");
		  }
	}


	function updateClassPublishState(eventData) {

		if (eventData.classType == "Group") {
			swal(
				{
					title: r("are-you-sure"),
					text: r("confirm-publish-lesson-template"),
					type: "warning",
					showCancelButton: true,
					cancelButtonText: r("cancel"),
					confirmButtonColor: "#DD6B55",
					confirmButtonText: r("confirm"),
					closeOnConfirm: true
				},
				function (confirmed) {
					if (!confirmed) return;
					publishClass(eventData);
				}
			);
		} else {
			publishClass(eventData);
		}
	}


	function publishClass(eventData) {
		
		classesService.updateClassPublishState(eventData.ClassId, "Published")
		.done(function (response) {
			toastr.success(r("status") + ": " + r("Published"), r("changes-saved"));
			$('#bridge-workouts-calendar').fullCalendar('refetchEvents');
		})
	}


	window.addEventListener('resize', function (e) { 
		$('.fc-content').width($('.uptivo-event').width());
	 }, false);
}

CircuitsCalendar.prototype = Object.create(ControlBase.prototype);
CircuitsCalendar.prototype.constructor = CircuitsCalendar;

function ICheckBox($element, valueAccessor, allBindings) {
	var isCheckbox = $element.get(0).type == "checkbox",
		isRadio = $element.get(0).type == "radio";

	var checkedValue = ko.pureComputed(function () {
		// Treat "value" like "checkedValue" when it is included with "checked" binding
		if (allBindings['has']('checkedValue')) {
			return ko.utils.unwrapObservable(allBindings.get('checkedValue'));
		} else if (useElementValue) {
			if (allBindings['has']('value')) {
				return ko.utils.unwrapObservable(allBindings.get('value'));
			} else {
				return element.value;
			}
		}
	});

	var rawValue = valueAccessor(),
		valueIsArray = isCheckbox && (ko.utils.unwrapObservable(rawValue) instanceof Array),
		rawValueIsNonArrayObservable = !(valueIsArray && rawValue.push && rawValue.splice),
		useElementValue = isRadio || valueIsArray,
		oldElemValue = valueIsArray ? checkedValue() : undefined;

	this.initialize = function () {
		$element.iCheck({
			checkboxClass: "icheckbox_square-orange",
			radioClass: "iradio_square-orange",
			disabledClass: 'disabled'
		});

		$element.on("ifChanged", function () {
			// This updates the model value from the view value.
			// It runs in response to DOM events (click) and changes in checkedValue.
			var isChecked = $element.get(0).checked,
				elemValue = checkedValue();

			// When we're first setting up this computed, don't change any model state.
			if (ko.computedContext.isInitial()) {
				return;
			}

			// We can ignore unchecked radio buttons, because some other radio
			// button will be checked, and that one can take care of updating state.
			// Also ignore value changes to an already unchecked checkbox.
			if (!isChecked && (isRadio || ko.computedContext.getDependenciesCount())) {
				return;
			}

			// var modelValue = ko.dependencyDetection.ignore(valueAccessor);
			// var modelValue = valueAccessor();
			var modelValue = ko.computedContext.w(valueAccessor);
			if (valueIsArray) {
				var writableValue = rawValueIsNonArrayObservable ? modelValue.peek() : modelValue,
					saveOldValue = oldElemValue;
				oldElemValue = elemValue;

				if (saveOldValue !== elemValue) {
					// When we're responding to the checkedValue changing, and the element is
					// currently checked, replace the old elem value with the new elem value
					// in the model array.
					if (isChecked) {
						ko.utils.addOrRemoveItem(writableValue, elemValue, true);
						ko.utils.addOrRemoveItem(writableValue, saveOldValue, false);
					}
				} else {
					// When we're responding to the user having checked/unchecked a checkbox,
					// add/remove the element value to the model array.
					ko.utils.addOrRemoveItem(writableValue, elemValue, isChecked);
				}

				if (rawValueIsNonArrayObservable && ko.isWriteableObservable(modelValue)) {
					modelValue(writableValue);
				}
			} else {
				if (isCheckbox) {
					if (elemValue === undefined) {
						elemValue = isChecked;
					} else if (!isChecked) {
						elemValue = undefined;
					}
				}
				ko.expressionRewriting.Ea(modelValue, allBindings, 'checked', elemValue, true);
			}
		});
	}

	this.update = function () {
		// This updates the view value from the model value.
		// It runs in response to changes in the bound (checked) value.
		var modelValue = ko.utils.unwrapObservable(valueAccessor()),
			elemValue = checkedValue(),
			enabled = ko.utils.unwrapObservable(allBindings.get('enable')),
			disabled = ko.utils.unwrapObservable(allBindings.get('disable'));

		if (valueIsArray) {
			// When a checkbox is bound to an array, being checked represents its value being present in that array
			$element.iCheck(ko.utils.arrayIndexOf(modelValue, elemValue) >= 0 ? "check" : "uncheck")
			oldElemValue = elemValue;
		} else if (isCheckbox && elemValue === undefined) {
			// When a checkbox is bound to any other value (not an array) and "checkedValue" is not defined,
			// being checked represents the value being trueish
			$element.iCheck(!!modelValue ? "check" : "uncheck")
		} else {
			// Otherwise, being checked means that the checkbox or radio button's value corresponds to the model value
			$element.iCheck(checkedValue() === modelValue ? "check" : "uncheck")
		}

		if (!_.isUndefined(enabled)) {
			$element.iCheck(enabled ? 'enable' : 'disable');
		} else if (!_.isUndefined(disabled)) {
			$element.iCheck(disabled ? 'disable' : 'enable');
		}
	}
}


ICheckBox.prototype = Object.create(ControlBase.prototype);
ICheckBox.prototype.constructor = ICheckBox;
function UptivoRadioButton($element, source) {
	var WRONG_SOURCE = "Radio button has to have a 'source' binding, pointing to an array";
	var WRONG_NAME = "Radio button must have a 'name' attribute";
	var WRONG_FIELDS = "Radio button must have 'data-text-field' and 'data-value-field' attributes specified";

	this.getList = function() {
		return $element.prev();
	};

	function _validate() {
		if (!source) throw new Error(WRONG_SOURCE);
		if (!$element.attr("name")) throw new Error(WRONG_NAME);
		if (!$element.attr("data-text-field") || !$element.attr("data-value-field")) throw new Error(WRONG_FIELDS);
	}

	var dataValueField = $element.attr("data-value-field"),
		dataTextField = $element.attr("data-text-field"),
		name = $element.attr("name"),
		cssClass = $element.attr("class");

	function _prepareHtml(source) {
		var resultHtml = "<ul class='" + cssClass + "'>";
		source.forEach(function(item, i) {
			var inputHtml =
				"<input id='" +
				name +
				"-" +
				i +
				"' type='radio' name='" +
				name +
				"' value='" +
				item[dataValueField] +
				"'/>";
			var labelHtml =
				"<label for='" +
				name +
				"-" +
				i +
				"'>" +
				(item.icon ? "<i class='fa " + item.icon + "'></i> " : "") +
				item[dataTextField] +
				"</label>";
			resultHtml += "<li>" + inputHtml + labelHtml + "</li>";
		});
		resultHtml += "</ul>";
		return $(resultHtml);
	}

	this.initialize = function() {
		try {
			_validate();
			$element.hide();
		} catch (error) {
			throw error;
		}
	};

	this.update = function(element, valueAccessor, allBindings) {
		var s = ko.unwrap(source);
		var $html = _prepareHtml(s);
		var $ul = $element.prev("ul").first();
		if ($ul.length) {
			$ul.remove();
		}
		$element.before($html);
		this.rebind(null, allBindings);
	};
}

UptivoRadioButton.prototype = Object.create(ControlBase.prototype);
UptivoRadioButton.prototype.constructor = UptivoRadioButton;

UptivoRadioButton.prototype.rebind = function(viewModel, bindings) {
	var b = bindings();
	$.each(this.getList().find("input[type='radio']"), function(i, el) {
		ko.cleanNode(el);
		var elBindings = { validationOptions: { insertMessages: false }, checked: b.checked };
		if (b.enable) elBindings.enable = b.enable;
		if (b.disable) elBindings.disable = b.disable;
		ko.applyBindingsToNode(el, elBindings);
	});
};

function DatePicker($element, format) {
	this.initialize = function() {
		$element.datepicker({
			todayBtn: "linked",
			todayHighlight: true,
			keyboardNavigation: false,
			forceParse: false,
			calendarWeeks: false,
			autoclose: true,
			format: format.toLowerCase(),
			language: moment.locale(),
			weekStart: utilities.weekdayNameToNumber(userData.get().FirstDayOfWeek)
		});
	};
}

DatePicker.prototype = Object.create(ControlBase.prototype);
DatePicker.prototype.constructor = DatePicker;

function IRadioButton($element, valueAccessor, allBindings) {
	var valueAccessor = valueAccessor,
		$element = $element;

	this.initialize = function() {
		$element.iCheck({
			checkboxClass: "icheckbox_square-orange",
			radioClass: "iradio_square-orange",
			disabledClass: 'disabled'
		});

		$element.on("ifChanged", function() {
			var observable = valueAccessor();
			observable(this.value);
		});
	};

	this.update = function(value) {
		value = ko.unwrap(valueAccessor());
		var enabled = ko.utils.unwrapObservable(allBindings.get('enable'));
		var disabled = ko.utils.unwrapObservable(allBindings.get('disable'));

		if (value == $element.attr("value")) {
			$element.iCheck("check");
		}

		if (!_.isUndefined(enabled)) {
			$element.iCheck(enabled ? 'enable' : 'disable');
		} else if (!_.isUndefined(disabled)) {
			$element.iCheck(disabled ? 'disable' : 'enable');
		}
	};
}

IRadioButton.prototype = Object.create(ControlBase.prototype);
IRadioButton.prototype.constructor = IRadioButton;

function UptivoMap($element, coordinates, units, markersDistance) {
	var self = this;
	var map, lines = [], currentBounds, mapBounds;
	var posMarker, startMarker, endMarker;
	var markersMinDistance = 1;
	var startSelectionMarker, endSelectionMarker;
	var MAP_PIN = 'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z';
	var MAP_PIN_HOLE = 'M38.853,5.324L38.853,5.324c-7.098-7.098-18.607-7.098-25.706,0h0 C6.751,11.72,6.031,23.763,11.459,31L26,52l14.541-21C45.969,23.763,45.249,11.72,38.853,5.324z M26.177,24c-3.314,0-6-2.686-6-6 s2.686-6,6-6s6,2.686,6,6S29.491,24,26.177,24z';
	var SQUARE_ROUNDED = 'M24-8c0 4.4-3.6 8-8 8h-32c-4.4 0-8-3.6-8-8v-32c0-4.4 3.6-8 8-8h32c4.4 0 8 3.6 8 8v32z';


	function findClosestFromScreenCoords(point) {
		var coordinatesArray = coordinates();
		var minDistance = Infinity, minIdx;
		for (var i = 0; i < coordinatesArray.length; ++i) {
			if (utilities.getDistance(coordinatesArray[i], point) < minDistance) {
				minDistance = utilities.getDistance(coordinatesArray[i], point);
				minIdx = i;
			}
		}
		return coordinatesArray[minIdx];
	}

	function findClosestFromTimestamp(time) {
		var coordinatesArray = coordinates();
		var minValue = Infinity, idx = -1;
		for (var i = 0; i < coordinatesArray.length; ++i) {
			var dt = Math.abs(coordinatesArray[i].timestamp - time);
			if (dt < minValue) {
				minValue = dt;
				idx = i;
			}
		}
		return coordinatesArray[idx];
	};

	function getSelectedFromTimestamp(startTime, endTime) {
		var coordinatesArray = coordinates();
		return _.filter(coordinatesArray, function (el) {
			return _.inRange(el.timestamp, startTime, endTime);
		})
	}

	function mouseMoveEventHandler(timestamp) {
		if (coordinates().length == 0) return;

		if (_.isUndefined(timestamp)) {
			hideMarker();
		} else {
			var geopos = findClosestFromTimestamp(timestamp);
			placeMarker(geopos);
			fitPosition(geopos);
		}
	};

	function selectionEventHandler(selection) {
		if (coordinates().length == 0) return;

		currentBounds = new google.maps.LatLngBounds();
		var pathRange = drawPath(coordinates(), currentBounds, markersMinDistance, selection);

		if (_.isUndefined(selection)) {
			startSelectionMarker.setVisible(false);
			endSelectionMarker.setVisible(false);
		} else {
			if (pathRange.start) {
				startSelectionMarker.setPosition(pathRange.start);
				startSelectionMarker.setVisible(true);
			} else {
				startSelectionMarker.setVisible(false);
			}
			if (pathRange.end) {
				endSelectionMarker.setPosition(pathRange.end);
				endSelectionMarker.setVisible(true);
			} else {
				endSelectionMarker.setVisible(false);
			}
			map.fitBounds(currentBounds.isEmpty() ? mapBounds : currentBounds);
		}
	}

	function fitPosition(pos) {
		if (pos && map) {
			var viewBounds = map.getBounds();
			if (currentBounds && viewBounds && currentBounds.contains(pos) && !viewBounds.contains(pos)) {
				map.panTo(pos);
			}
		}
	}

	function placeMarker(position) {
		if (position && posMarker && map) {
			posMarker.setPosition(position);
			posMarker.setVisible(true);
			eventBus.publish('map:info', position);
		}
	}

	function hideMarker() {
		eventBus.publish('map:info');
		posMarker.setVisible(false);
	}

	self.initialize = function () {
		// Subscribe to chart movement on the map
		eventBus.subscribe('chart:mousemove', mouseMoveEventHandler);
		eventBus.subscribe('chart:selection', selectionEventHandler);
	}

	self.dispose = function () {
		eventBus.unsubscribe('chart:mousemove', mouseMoveEventHandler);
		eventBus.unsubscribe('chart:selection', selectionEventHandler);
	}


	function addLineToMap(path, color, map) {
		var line = new google.maps.Polyline({
			path: path,
			strokeColor: color,
			strokeOpacity: 1.0,
			strokeWeight: 4
		});
		line.setMap(map);
		lines.push(line);
	}

	function removeLinesFromMap() {
		_.each(lines, function (l) {
			l.setMap(null);
		});
		lines = [];
	}


	function distanceIcon(color) {
		return {
			anchor: { x: -1, y: -23 },
			fillColor: color || 'white',
			fillOpacity: 1,
			strokeWeight: 0,
			labelOrigin: { x: 0, y: -23 },
			scale: 0.25,
			path: SQUARE_ROUNDED
		};
	}

	function pinIcon(color) {
		return {
			fillColor: color || 'black',
			fillOpacity: 1,
			strokeWeight: 0,
			labelOrigin: { x: 0, y: -27 },
			scale: 0.5,
			path: MAP_PIN
		};
	}
	
	function drawPath(coords, pathBounds, markersMinDistance, selection) {
		var distSep = units() == ENUMS.UNITS.METRIC ? CONSTANTS.METERS_IN_KILOMETER : CONSTANTS.METERS_IN_MILE;
		var path = [];
		var color;
		var distance = 0;
		var inRange = false;

		var pathRange = {
		};

		markersMinDistance = markersMinDistance || 1;

		removeLinesFromMap();
		_.each(coords, function (c, i, coords) {
			var cInRange = !selection || (c.timestamp >= selection.startTime && c.timestamp <= selection.endTime);
			var cDistance = Math.floor(c.totalDistance / distSep);

			path.push({ lat: c.lat, lng: c.lng });

			var cColor = (cInRange && c.color) || 'gray';
			if (pathBounds && cInRange) {
				pathBounds.extend(c);
			}

			if (!inRange && cInRange) {
				pathRange.start = c;
				inRange = true;
			} else if (inRange && !cInRange) {
				pathRange.end = coords[i - 1];
				inRange = false;
			}

			if (i == 0) {
				color = cColor;
				distance = cDistance;
			} else {
				if (color != cColor || (i == coords.length - 1 && path.length > 0)) {
					addLineToMap(path, color, map);

					path = [{ lat: c.lat, lng: c.lng }];
					color = cColor;
				}

				if (cDistance >= (distance + markersMinDistance)) {
					new google.maps.Marker({
						map: map,
						icon: distanceIcon('white'),
						position: c,
						label: { fontSize: '8px', color: 'black', text: cDistance.toString() }
					});

					distance = cDistance;
				}
			}
		});

		if (pathRange.start && !pathRange.end) {
			pathRange.end = _.last(coords);
		}

		return pathRange;
	}

	self.update = function () {
		var coordinatesArray = ko.unwrap(coordinates);
		var markersMinDistance = ko.unwrap(markersDistance);

		map = new google.maps.Map($element[0], {
			zoom: 15,
			streetViewControl: false,
			mapTypeId: 'terrain',
			mapTypeControlOptions: {
				style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
				mapTypeIds: ['terrain', 'roadmap', 'satellite', 'hybrid']
			},
			scrollwheel: true,
			scaleControl: true
		});

		currentBounds = new google.maps.LatLngBounds();
		if (coordinatesArray.length > 1) {



			drawPath(coordinatesArray, currentBounds, markersMinDistance);

			startMarker = new google.maps.Marker({
				map: map,
				icon: distanceIcon('green'),
				position: _.first(coordinatesArray)
			});

			endMarker = new google.maps.Marker({
				map: map,
				icon: distanceIcon('red'),
				position: _.last(coordinatesArray)
			});

			startSelectionMarker = new google.maps.Marker({
				visible: false,
				map: map,
				icon: pinIcon('#f3712a'),
				label: { text: "1", color: "white" }
			});

			endSelectionMarker = new google.maps.Marker({
				visible: false,
				map: map,
				icon: pinIcon('#f3712a'),
				label: { text: "2", color: "white" }
			});

		} else {
			var minLng = _.get(_.minBy(coordinatesArray, 'lng'), 'lng'),
				maxLng = _.get(_.maxBy(coordinatesArray, 'lng'), 'lng'),
				minLat = _.get(_.minBy(coordinatesArray, 'lat'), 'lat'),
				maxLat = _.get(_.maxBy(coordinatesArray, 'lat'), 'lat');

			var center = {
				lat: (minLat + maxLat) / 2,
				lng: (minLng + maxLng) / 2
			}

			var offset = 0.001;
			currentBounds.extend({ lat: minLat - offset, lng: minLng - offset });
			currentBounds.extend({ lat: maxLat + offset, lng: maxLng + offset });
		}

		mapBounds = new google.maps.LatLngBounds(currentBounds.getSouthWest(), currentBounds.getNorthEast());
		map.fitBounds(currentBounds);

		posMarker = new google.maps.Marker({
			visible: false,
			map: map,
			icon: {
				anchor: { x: 25, y: 53 },
				fillColor: 'blue',
				fillOpacity: 1,
				strokeWeight: 0,
				labelOrigin: { x: 0, y: -27 },
				scale: 0.5,
				path: MAP_PIN_HOLE
			},
			zIndex: 10000
		});



		// Listen to mouse movements on the map
		map.addListener('mousemove', function (evt) {
			var center = {
				lat: evt.latLng.lat(),
				lng: evt.latLng.lng()
			};
			var closestCoord = findClosestFromScreenCoords(center);
			placeMarker(closestCoord);

			eventBus.publish('map:mousemove', closestCoord.time);
		});

		// Listen to mouse out on the map
		map.addListener('mouseout', function (evt) {
			hideMarker();
			eventBus.publish('map:mousemove');
		});
	}
}

UptivoMap.prototype = Object.create(ControlBase.prototype);
UptivoMap.prototype.constructor = UptivoMap;

function HeightWidget($element, heightObservable, units) {
	var slider;

	function inchesToLabel(value) {
		var feet = value / CONSTANTS.INCH_IN_FOOT;
		var ftOnly = Math.floor(feet);
		var inOnly = Math.round((feet - ftOnly) * CONSTANTS.INCH_IN_FOOT);
		return inOnly == 0 ? ftOnly + "'" : ftOnly + "' " + inOnly + '"';
	}

	this.initialize = function() {
		if (units() == ENUMS.UNITS.METRIC) {
			$element.ionRangeSlider({
				min: 60,
				max: 250,
				step: 1,
				grid: true,
				onFinish: function(data) {
					heightObservable(data.from);
				}
			});
		} else {
			$element.ionRangeSlider({
				min: 24,
				max: 96,
				step: 1,
				grid: true,
				grid_num: 8,
				prettify: function(value) {
					return inchesToLabel(value);
				},
				onFinish: function(data) {
					heightObservable(data.from * CONSTANTS.CM_IN_INCH);
				}
			});
		}

		this.slider = $element.data("ionRangeSlider");
	};
	this.update = function() {
		var value = heightObservable();
		if (units() == ENUMS.UNITS.IMPERIAL) {
			value /= CONSTANTS.CM_IN_INCH;
		}
		this.slider.update({
			from: value
		});
	};
}

HeightWidget.prototype = Object.create(ControlBase.prototype);
HeightWidget.prototype.constructor = HeightWidget;

function Tabs($element, tabs, currentTabId) {
	var
		CONTENT_CONTAINERS_CLASS = ".html-content",
		NAV_ID = "#tabs-nav-" + new Date().getTime();

	function _prepareNav(tabs, currentTabId) {
		var html = '<ul class="nav nav-tabs" id="' + NAV_ID + '">';
		tabs.forEach(function(tab, i) {
			var rowHtml = '<li class="' + (tab.Id == currentTabId ? "active" : "") + '">';
			rowHtml +=
				'<a data-toggle="tab" href="#tab-' +
				tab.Id +
				'" aria-expanded="' +
				(tab.Id == currentTabId ? "true" : "false") +
				'">';
			rowHtml += tab.Title;
			rowHtml += "</a></li>";
			html += rowHtml;
		});
		html += "</ul>";
		return html;
	}

	function _prepareTab(tab, currentTabId, index) {
		var html = '<div id="tab-' + tab.Id + '" class="tab-pane ' + (tab.Id == currentTabId ? "active" : "") + '">';
		html += '<div class="panel-body">';
		var innerHtml = $element
			.find(CONTENT_CONTAINERS_CLASS)
			.eq(index)
			.html();
		html += innerHtml;
		html += "</div></div>";
		return html;
	}

	this.initialize = function() {
		var tabsArray = tabs(),
			currentTab = currentTabId();

		var nav = _prepareNav(tabsArray, currentTab),
			tabsHtml = "";
			
		tabsArray.forEach(function(tab, i) {
			tabsHtml += _prepareTab(tab, currentTab, i);
		});
		var html = '<div class="tabs-container">' + nav + tabsHtml + "</div>";

		$element.find(CONTENT_CONTAINERS_CLASS).detach();

		$element.on("click", 'a[data-toggle="tab"]', function(e) {
			$(this).tab("show");
		});

		$element.append(html);
	};

	this.update = function(value) {};
}

Tabs.prototype = Object.create(ControlBase.prototype);
Tabs.prototype.constructor = Tabs;

function UptivoTrainingZones($element, sourceZones) {
	var self = this;

	function prepareHtml(zones) {
		var resultHtml = "<div class='uptivo-training-zones'>";
		/*  x='50%' y='16' */
		zones.forEach(function(zone, i) {
			resultHtml +=
				"<div class='training-zones-row'>" +
				"<div class='zone-spent'>" +
				zone.durationPrc +
				"%</div>" +
				"<div class='zone-index'><svg width='100%' height='100%'><rect width='100%' height='100%' fill='" +
				zone.color +
				"'/><text x='50%' y='16' text-anchor='middle' fill='white'>" +
				zone.zoneIndex +
				"</text></svg></div>" +
				"<div class='zone-bar'><svg width='100%' height='100%'><rect width='100%' height='100%' fill='#f5f5f5'/><rect fill='" +
				zone.color +
				"' height='100%' width='" +
				zone.durationPrc +
				"%'/></svg></div>" +
				"<div class='zone-duration'>" +
				utilities.formatDuration(zone.duration) +
				"</div>" +
				"</div>";
		});
		resultHtml += "</div>";
		return resultHtml;
	}

	function buildZonesData(zones) {
		if (!zones) return [];

		var totalDurationTime = _.reduce(
			zones,
			function(a, v) {
				return a.add(v);
			},
			moment.duration()
		);

		var res = _.map(zones, function(v, i) {
			var revIdx = zones.length - i - 1;
			return {
				zoneIndex: revIdx,
				duration: v,
				durationPrc: utilities.getPercentage(
					utilities.getDurationMs(v),
					utilities.getDurationMs(totalDurationTime)
				),
				color: ENUMS.ZONE_COLORS["ZONE_" + revIdx]
			};
		});

		if (zones.length) {
			var totalPrc = _.sumBy(res, "durationPrc");

			if (totalPrc != 100 && totalPrc != 0) {
				var max = _.maxBy(res, "durationPrc");
				max.durationPrc += 100 - totalPrc;
			}
		}

		return res;
	}

	this.zonesData = ko.pureComputed(function() {
		var data = ko.unwrap(sourceZones());
		return buildZonesData(data);
	});

	this.initialize = function() {};
	this.update = function() {
		var html = prepareHtml(self.zonesData());
		$element.html("");
		$element.append(html);
	};
}

UptivoTrainingZones.prototype = Object.create(ControlBase.prototype);
UptivoTrainingZones.prototype.constructor = UptivoTrainingZones;

function UptivoZoneLimits($element, source, sourceName, masterSwitch) {
	function _prepareHtml(data) {
		var result = '<div class="uptivo-zone-limits">';
		data.forEach(function(zone, i) {
			var rowHtml = '<div class="' + zone.name + '">';
			rowHtml +=
				"<div data-bind=\"css: { 'error-outline':" +
				sourceName +
				"()[" +
				i +
				'].hasError }"><input type="text" maxlength="3" pattern="\\d*" data-bind="value:' +
				sourceName +
				"()[" +
				i +
				"].percentage" +
				(i > 0 ? ",enable:" + masterSwitch + "() == '1'" : "") +
				'" ' +
				(i == 0 ? "disabled " : "") +
				"/><span>%</span></div>";
			rowHtml +=
				"<div data-bind=\"css: { 'error-outline':" +
				sourceName +
				"()[" +
				i +
				'].hasError }"><input type="text" maxlength="3" pattern="\\d*" data-bind="value: ' +
				sourceName +
				"()[" +
				i +
				"].value, enable:" +
				masterSwitch +
				"() == '1'\" /><span>bpm</span></div>";
			rowHtml += "</div>";
			result += rowHtml;
		});
		result += "</div>";
		return result;
	}

	this.rebind = function(viewModel) {
		ko.applyBindings(viewModel, $(".uptivo-zone-limits")[0]);
	};

	this.update = function() {};
	this.initialize = function() {
		var data = source(),
			html = _prepareHtml(data);
		$element.append(html);
	};
}

UptivoZoneLimits.prototype = Object.create(ControlBase.prototype);
UptivoZoneLimits.prototype.constructor = UptivoZoneLimits;

function ControlFactory($element, allBindings, viewModel) {
	var $element = $element,
		bindings = allBindings(),
		viewModel = viewModel;

	this.createControl = function (type) {
		var control;

		if (typeof ICheckBox !== "undefined" && type === ICheckBox) {
			control = new ICheckBox($element, bindings.checked, bindings);
		} else if (typeof DatePicker !== "undefined" && type === DatePicker) {
			control = new DatePicker($element, utilities.getMomentDateFormat(userData.get().DateFormat));
		} else if (typeof UptivoCalendar !== "undefined" && type === UptivoCalendar) {
			control = new UptivoCalendar($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof UptivoEventsCalendar  !== "undefined" && type === UptivoEventsCalendar ) {
			control = new UptivoEventsCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof UptivoGeneratedActivitiesCalendar  !== "undefined" && type === UptivoGeneratedActivitiesCalendar ) {
			control = new UptivoGeneratedActivitiesCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof UptivoScheduleCalendar  !== "undefined" && type === UptivoScheduleCalendar ) {
			control = new UptivoScheduleCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof UptivoPTCalendar  !== "undefined" && type === UptivoPTCalendar ) {
			control = new UptivoPTCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof ServicesCalendar  !== "undefined" && type === ServicesCalendar ) {
			control = new ServicesCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof CircuitsCalendar  !== "undefined" && type === CircuitsCalendar ) {
			control = new CircuitsCalendar ($element, bindings.day, bindings.mode, bindings.source, viewModel, allBindings);
		} else if (typeof UptivoRadioButton !== "undefined" && type === UptivoRadioButton) {
			control = new UptivoRadioButton($element, bindings.source);
		} else if (typeof UptivoTrainingZones !== "undefined" && type === UptivoTrainingZones) {
			control = new UptivoTrainingZones($element, bindings.source);
		} else if (typeof UptivoZoneLimits !== "undefined" && type === UptivoZoneLimits) {
			control = new UptivoZoneLimits($element, bindings.source, bindings.sourceName, bindings.parent);
		} else if (typeof UptivoMap !== "undefined" && type == UptivoMap) {
			control = new UptivoMap($element, bindings.source, bindings.units, bindings.markersDistance);
		} else if (typeof HeightWidget !== "undefined" && type == HeightWidget) {
			control = new HeightWidget($element, bindings.source, bindings.units);
		} else if (typeof Tabs !== "undefined" && type == Tabs) {
			control = new Tabs($element, bindings.source, bindings.currentTabId);
		} else if (typeof AMChart !== "undefined" && type == AMChart) {
			control = new AMChart($element, bindings.config, viewModel, allBindings);
		} else if (typeof UptivoDataTable !== "undefined" && type == UptivoDataTable) {
			control = new UptivoDataTable($element, bindings.configuration, bindings.source, bindings.processing, bindings.loading, viewModel, allBindings);
		} else if (typeof ImageUploader !== "undefined" && type == ImageUploader) {
			control = new ImageUploader($element, bindings.config, bindings.imageUri, bindings.uploadUri, bindings.modified, bindings.result, bindings.confirm);
		}

		return control;
	}
}

$.fn.dataTable.render.numeral = function(decimals, allowEmpty) {
	return function(data, type) {
		switch (type) {
			case "export":
				return utilities.round(data, decimals);

			case "print":
			case "display":
				return _.isNumber(data) ? utilities.numeralFmt(data, decimals) : (allowEmpty ? null : 0);

			default:
				return data;
		}
	};
};

$.fn.dataTable.ext.buttons.filterWatch = {
	text: WATCH_MODES.ICONS[WATCH_MODES.NONE]
};

$.fn.dataTable.ext.buttons.filterSelected = {
	text: '<i class="fa fa-check-square-o"></i>'
};

$.fn.dataTable.ext.buttons.filterTags = {
	text: '<i class="fa fa-tag"></i>'
};

$.fn.dataTable.ext.buttons.columnVisibility.className = "buttons-columnVisibility btn btn-xs btn-primary";

$.fn.dataTable.ext.buttons.print = {
	className: "buttons-print",

	text: function(dt) {
		return dt.i18n("buttons.print", "Print");
	},

	action: function(e, dt, button, config) {
		var data = dt.buttons.exportData(config.exportOptions);
		var alignmentForCols = dt.buttons.getAlignmentForCols(dt, data.header);
		var _relToAbs = function(el) {
			/**
			 * Convert a `link` tag's URL from a relative to an absolute address so it will
			 * work correctly in the popup window which has no base URL.
			 *
			 * @param  {node}     el Element to convert
			 */

			var _link = document.createElement("a");
			var clone = $(el).clone()[0];
			var linkHost;

			if (clone.nodeName.toLowerCase() === "link") {
				_link.href = clone.href;
				linkHost = _link.host;

				// IE doesn't have a trailing slash on the host
				// Chrome has it on the pathname
				if (linkHost.indexOf("/") === -1 && _link.pathname.indexOf("/") !== 0) {
					linkHost += "/";
				}

				clone.href = _link.protocol + "//" + linkHost + _link.pathname + _link.search;
			}

			return clone.outerHTML;
		};

		var addRowWithStyle = function(d, tag) {
			var str = "<tr>";

			for (var i = 0, ien = d.length; i < ien; i++) {
				var style = "text-align: " + alignmentForCols[i];
				str += "<" + tag + ' style="' + style + '">' + d[i] + "</" + tag + ">";
			}

			return str + "</tr>";
		};

		// Construct a table for printing
		var html = '<table class="' + dt.table().node().className + ' printing">';

		if (config.header) {
			html += "<thead>" + addRowWithStyle(data.header, "th") + "</thead>";
		}

		html += "<tbody>";
		for (var i = 0, ien = data.body.length; i < ien; i++) {
			html += addRowWithStyle(data.body[i], "td");
		}
		html += "</tbody>";

		if (config.footer && data.footer) {
			html += "<tfoot>" + addRowWithStyle(data.footer, "th") + "</tfoot>";
		}

		var frame1 = $("<iframe />");
		frame1[0].name = "frame1";
		frame1.css({ position: "absolute", top: "-1000000px" });
		$("body").append(frame1);
		var frameDoc = frame1[0].contentWindow
			? frame1[0].contentWindow
			: frame1[0].contentDocument.document
			? frame1[0].contentDocument.document
			: frame1[0].contentDocument;

		// Open a new window for the printable table
		var title = config.title;

		if (typeof title === "function") {
			title = title();
		}

		if (title.indexOf("*") !== -1) {
			title = title.replace("*", $("title").text());
		}

		// Inject the title and also a copy of the style and link tags from this
		// document so the table can retain its base styling. Note that we have
		// to use string manipulation as IE won't allow elements to be created
		// in the host document and then appended to the new window.
		var head = "<title>" + title + "</title>";

		head +=
			'<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.6.3/css/font-awesome.css">';

		if (location.href.indexOf("/src") >= 0) {
			head += _relToAbs('<link rel="stylesheet" href="template/css/plugins/dataTables/datatables.min.css">');
			head += _relToAbs('<link rel="stylesheet" href="Stylesheets/Grid.css">');
		} else {
			head += _relToAbs('<link rel="stylesheet" href="Stylesheets/printCombined.css">');
		}

		head +=
			'<style>body { font-family: "Montserrat", "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif; margin: 0; } h1 { font-size: 18px; text-align: center; font-weight: 100; }</style>';

		try {
			frameDoc.document.head.innerHTML = head; // Work around for Edge
		} catch (e) {
			$(frameDoc.document.head).html(head); // Old IE
		}

		// Inject the table and other surrounding information
		frameDoc.document.body.innerHTML =
			"<h1>" +
			title +
			"</h1>" +
			"<div>" +
			(typeof config.message === "function" ? config.message(dt, button, config) : config.message) +
			"</div>" +
			html;

		if (config.customize) {
			config.customize(frameDoc);
		}

		setTimeout(function() {
			window.frames["frame1"].focus();
			window.frames["frame1"].print();
			frame1.remove();
			frameDoc = null;
			frame1 = null;
		}, 250);
	},

	title: "*",
	message: "",
	exportOptions: {},
	header: true,
	footer: false,
	autoPrint: true,
	customize: null
};

$.fn.dataTable.Api.register("processing()", function(show) {
	return this.iterator("table", function(ctx) {
		ctx.oApi._fnProcessingDisplay(ctx, show);
	});
});

$.fn.dataTable.Api.register("column().title()", function() {
	var colheader = this.header();
	return $(colheader)
		.text()
		.trim();
});

$.fn.dataTable.Api.register("buttons.getAlignmentForCols()", function(dt, headers) {
	var alignmentForCols = _.map(headers, function(header) {
		for (var i = 0; i < dt.settings()[0].aoColumns.length; i++) {
			var column = dt.settings()[0].aoColumns[i];
			if (column.title == header) {
				if (
					_.includes(column.className, "dt-right") ||
					_.includes(column.className, "dt-head-right") ||
					_.includes(column.className, "dt-body-right")
				)
					return "right";
				return "left";
			}
		}
	});

	return alignmentForCols;
});

function DataTable($element, originalConfig, source) {
	var config = _.clone(originalConfig);
	var self = this;
	self.dataTable = null;
	self._events = [];
	self._hasRowButtons = false;

	config.columnDefs = config.columnDefs || [
		{
			data: null,
			defaultContent: "",
			targets: "_all"
		}
	];

	config.language = _.defaults({}, config.language, DataTable.language);

	config.paging = _.isUndefined(config.paging) || config.paging;

	if (config.dom == "full") {
		config.dom =
			'<"uptivo-grid-top uptivo-grid-top-full"<"uptivo-grid-row"fB><"uptivo-grid-row"ir' +
			(config.paging ? "p" : "") +
			'>><"uptivo-grid-main"t>' +
			(config.paging ? '<"uptivo-grid-bottom"<"uptivo-grid-row"lp>>' : "");
	} else if (config.dom == "simple") {
		config.dom =
			'<"uptivo-grid-top uptivo-grid-top-simple"<"uptivo-grid-row"fri>><"uptivo-grid-main"t>' +
			(config.paging ? '<"uptivo-grid-bottom"<"uptivo-grid-row"lp>>' : "");
	} else if (config.dom == "full-tags") {
		config.dom =
			'<"uptivo-grid-top uptivo-grid-top-full"<"uptivo-grid-row"B><"uptivo-grid-row uptivo-tag-row"f><"uptivo-grid-row"ir' +
			(config.paging ? "p" : "") +
			'>><"uptivo-grid-main"t>' +
			(config.paging ? '<"uptivo-grid-bottom"<"uptivo-grid-row"lp>>' : "");
	} else if (config.dom == "none") {
		config.info = false;
		config.searching = false;
		config.paging = false;
		delete config.dom;
	}

	// config is an object and contains buttons
	if (config.buttons) {
		// If buttons is an array:
		// config = {
		//     buttons: [ 'a', 'b', { ... button definition object ... } ]
		// }
		// build a wrapping object:
		// config = {
		//     buttons: {
		//         buttons: [
		//            ... button definitions ...
		//         ],
		//         ... other button options ...
		//     }
		// }
		// This allows to add other button options:
		if (_.isArray(config.buttons)) {
			config.buttons = {
				buttons: config.buttons
			};
		}

		// buttons is an object
		if (_.isObject(config.buttons)) {
			// Add dom definition if missing
			config.buttons.dom = config.buttons.dom || {
				button: { tag: "span" },
				buttonLiner: { tag: null }
			};

			if (_.isArray(config.buttons.buttons)) {
				fixButtons(config.buttons.buttons, 0, config);
			}
		}
	}

	config.stateSave = true;
	config.stateDuration = -1;

	if (source && !config.data) {
		config.data = ko.unwrap(source);
	}

	self.dataTable = $element.DataTable(config);

	var $container = $(self.dataTable.table().container());
	$container.addClass("uptivo-grid");

	var filterWatchButtons = self.dataTable.buttons("filterWatch:name, filterSelected:name, filterTags:name");
	if (filterWatchButtons.length > 0) {
		filterWatchButtons
			.nodes()
			.detach()
			.appendTo($container.find(".dataTables_filter label"));
	}

	if (config.rowButtons) {
		_.each(config.rowButtons, function(el) {
			$element.on("click", "." + el.name + ".uptivo-grid-button", function() {
				var $button = $(this);
				var $row = $button.parents("tr");
				var data = self.dataTable.row($row).data();

				el.action($button, data, $row, el);
			});
		});
		self._hasRowButtons = true;
	}

	if (config.events) {
		_.each(config.events, function(el) {
			if (_.isFunction(el.action)) {
				self.dataTable.on(el.event, _.wrap(self.dataTable, el.action));
			}
		});

		self._events = config.events;
	}

	var $searchInput = $container.find(".dataTables_filter input");
	self.dataTable.on("search.dt", function() {
		$searchInput.toggleClass("filtered", self.dataTable.search() ? true : false);
	});

	if (config.tagsFilters)
	{
		var $tagsHtml = $('<span class="uptivo-tag-container">' +
			'<!-- ko foreach: tagsList() -->' +
				'<span style="cursor: pointer" class="uptivo-tag" data-bind="style: { \'border\': $parent.tagBorderColor($data), \'color\': $parent.tagColor($data), \'background-color\': $parent.tagBgColor($data) }, click: $parent.tagClicked" >'+
				'<span data-bind="text: text"></span>'+
				'</span> '+
			'<!-- /ko -->' +
			'<span data-bind="if: selectedTags().length > 0">'+
			'	<button data-localized="clear-selection" class="uptivo-tag uptivo-tag-button" type="button" data-bind="click: clearTagSelection"><i class="fa fa-times" aria-hidden="true"></i>&nbsp; Clear Selection</button>'+
			'</span>'+
		'</span>');

		var $filtersRow = $container.find(".dataTables_filter label")
		$filtersRow.find(".uptivo-tag-container").remove();
		$filtersRow.append($tagsHtml);

		ko.applyBindings({
			tagsList: config.tagsFilters.showObservable,
			selectedTags: config.tagsFilters.selectedObservable,
			tagClicked: function(tag) {
				var selList = config.tagsFilters.selectedObservable;
				if(tag.selected) {
					selList.remove(tag.id);
				} else {
					selList.push(tag.id);
				}
				tag.selected = !tag.selected;
			},
			clearTagSelection: function() {
				config.tagsFilters.selectedObservable.removeAll();
			},
			tagBorderColor: function(data) {
				var borderColor = utilities.tagsRandomColor(data.text.split(' (')[0]);
				return "1px solid" + borderColor;
			},
			tagColor: function(data) {
				if (data.selected) {
					return "white";
				}
				var txtColor = utilities.tagsRandomColor(data.text.split(' (')[0]);
				return txtColor;
			},
			tagBgColor: function(data) {
				if (!data.selected) {
					return "white";
				}
				var	bgColor = utilities.tagsRandomColor(data.text.split(' (')[0]);
				return bgColor;
			}
		}, $tagsHtml[0]);
	}


	self.dispose = function() {
		$.fn.DataTable.ext.search = [];

		self.dataTable.off("draw.dt");
		self.dataTable.off("search.dt");

		_.each(self._events, function(el) {
			self.dataTable.off(el.event);
		});

		self._events = [];

		if (self._hasRowButtons) {
			$element.off("click");
			self._hasRowButtons = null;
		}

		self.dataTable.destroy();
	};


	function fixButtons(buttons, level, config) {
		level = level || 0;

		// Fix each button
		_.each(buttons, function(button) {
			// Transform a string with button name into an
			// extension object to allow further customization
			if (_.isString(button)) {
				button = { extend: button };
			}

			// Add uptivo button skins
			button.className = (button.className || "") + " uptivo-grid-button";

			
			// Check if it is a special filterwatch button
			if (_.isObject(button) && (button.extend || "").toLowerCase() === "filterwatch") {
				button.action = watchButtonFx;
				button.init = watchButtonInit;
				button.className += " grid-search-watch";
				button.name = "filterWatch";
			} else if (_.isObject(button) && (button.extend || "").toLowerCase() === "filtertags") {
				button.action = tagsButtonFx;
				button.className += " grid-search-tags";
				button.name = "filterTags";
				if (button.info) {
					config.infoCallback = function(settings, start, end, max, total, pre ) {
						var currentSearch = this.api().column(button.column).search();
						var selectedTags = utilities.tagsTableFilterDecode(currentSearch);
						return pre + button.info(selectedTags);
					};
				}
			} else if (_.isObject(button) && (button.extend || "").toLowerCase() === "filterselected") {
				button.action = selectedButtonFx;
				button.init = selectedButtonInit;
				button.className += " grid-search-selected";
				button.name = "filterSelected";
			} else {
				// Other generic button
				button.className += " btn btn-xs btn-primary";

				if (_.isFunction(button.filename)) {
					button.filename = _.wrap(button.filename, dataTableWrapperFx);
				}

				if (_.isFunction(button.title)) {
					button.title = _.wrap(button.title, dataTableWrapperFx);
				}

				if (_.isFunction(button.actionExt)) {
					button.baseAction = $.fn.dataTable.ext.buttons[button.extend].action;
					button.action = baseActionFx;
				}
			}

			if (_.isArray(button.buttons)) {
				fixButtons(button.buttons, ++level, config);
			}
		});
	}

	function dataTableWrapperFx(fx) {
		return fx(self.dataTable);
	}

	function selectedButtonInit(dt, button) {
		var $i = $(button).find("i");
		dt.on("draw", function() {
			if ($.fn.DataTable.ext.search.length == 0) {
				$i.removeClass("fa-check-square").addClass("fa-check-square-o");
			} else {
				$i.removeClass("fa-check-square-o").addClass("fa-check-square");
			}
		});
	}

	function selectedButtonFx(e, dt) {
		if ($.fn.DataTable.ext.search.length == 0) {
			$.fn.DataTable.ext.search[0] = function(settings, data, dataIndex) {
				return $(dt.row(dataIndex).node()).hasClass("selected");
			};
		} else {
			$.fn.DataTable.ext.search = [];
		}
		dt.draw();
	}

	function watchButtonInit(dt, button, config) {
		if (dt.column(config.column).search() == WATCH_MODES.FILTER_CHAR) {
			button
				.find("i")
				.removeClass(WATCH_MODES.CLASSES[WATCH_MODES.NONE])
				.addClass(WATCH_MODES.CLASSES[WATCH_MODES.FOLLOW]);
		}
	}

	function watchButtonFx(e, dt, button, buttonConfig) {
		var $i = $(button).find("i");
		$i.toggleClass(WATCH_MODES.CLASSES[WATCH_MODES.NONE] + " " + WATCH_MODES.CLASSES[WATCH_MODES.FOLLOW]);
		dt.column(buttonConfig.column)
			.search($i.hasClass(WATCH_MODES.CLASSES[WATCH_MODES.FOLLOW]) ? WATCH_MODES.FILTER_CHAR : "")
			.draw();
	}

	function tagsButtonFx(e, dt, button, buttonConfig) {
		if (buttonConfig.filter) {
			var currentSearch = dt.column(buttonConfig.column).search();
			var selectedTags = utilities.tagsTableFilterDecode(currentSearch);
			buttonConfig.filter(selectedTags);
		}
	}

	function baseActionFx(e, dt, button, buttonConfig) {
		if (_.isFunction(buttonConfig.actionExt)) buttonConfig.actionExt.call(this, e, dt, button, buttonConfig);
		if (_.isFunction(buttonConfig.baseAction)) buttonConfig.baseAction.call(this, e, dt, button, buttonConfig);
	}
}

DataTable.language = null;

function UptivoDataTable($element, config, source, processing, loading) {
	var self = this;
	self.dt = null;
	self.dataId = null;
	self._dataSubscription = null;
	self._processingSubscription = null;

	function computedArraySubscriptionFx(newValues) {
		if (self.dt) {
			var data = self.dt.dataTable.data();
			updateTableData(_.differenceBy(newValues, data, self.dataId), _.differenceBy(data, newValues, self.dataId), _.intersectionBy(newValues, data, self.dataId));

			if(self.startBk) {
				var page = (self.startBk / self.dt.dataTable.state().length);
				self.dt.dataTable.page(page).draw('page');
				self.startBk = undefined;
			}
		}
	}

	function observableArraySubscriptionFx(changes) {
		updateTableData(_.map(_.filter(changes, { status: "added" }), "value"), _.map(_.filter(changes, { status: "deleted" }), "value"), []);
		
		if(self.startBk) {
			var page = (self.startBk / self.dt.dataTable.state().length);
			self.dt.dataTable.page(page).draw('page');
			self.startBk = undefined;
		}

	}

	function updateTableData(added, deleted, other) {
		if (self.dt) {
			var dt = self.dt.dataTable;
			var deletedAll = deleted.length == dt.rows().count() && deleted.length > 0;

			var initialRowsCount = dt.data().count();

			var selected = dt
				.rows({ selected: true })
				.ids()
				.toArray();

			// Remove deleted elements
			if (deletedAll) {
				// All rows have been removed
				self.dt.dataTable.rows().remove();
			} else if (deleted.length) {
				self.dt.dataTable
					.rows(
						_.map(deleted, function(el) {
							return "#" + el[self.dataId];
						})
					)
					.remove();
			}

			if (other.length) {
				_.each(other, function(newRowData) {
					var row = dt.row("#" + newRowData[self.dataId]);
					if (row.data() !== newRowData) {
						row.data(newRowData);
					}
				})
			}

			// Add new elements
			if (added.length)
			{
				self.dt.dataTable.rows.add(added);
			}

			if (deletedAll && added.length == 0) {
				$.fn.DataTable.ext.search = [];
			}

			// If any added element was previously selected, reselect it
			var addedSelected = _.intersection(
				_.map(added, function(el) {
					return el[self.dataId].toString();
				}),
				selected
			);

			if (addedSelected.length > 0) {
				dt.rows(
					_.map(addedSelected, function(el) {
						return "#" + el;
					})
				).select();
			}

			if (initialRowsCount == 0 && added.length > 0)
			{
				dt.columns.adjust();
			}

			dt.draw(false);
		}
	}

	self.initialize = function() {

		config.stateLoadParams =  function (settings, data) {
			self.startBk = data.start;
		};

		self.dt = new DataTable($element, config, source);

		if (ko.isObservable(processing)) {
			self._processingSubscription = processing.subscribe(self.dt.dataTable.processing);
		}

		if (ko.isObservable(source)) {
			if (config.rowId) {
				self.dataId = config.rowId;
			} else {
				console.log("Table is missing rowId!");
				debugger;
			}

			if (ko.isComputed(source))
			{
				self._dataSubscription = source.subscribe(computedArraySubscriptionFx);
			}
			else
			{
				self._dataSubscription = source.subscribe(observableArraySubscriptionFx, null, "arrayChange");
			}
		}

		if (config.select && config.select.selectAll) {
			var dtab = self.dt.dataTable;
			var chk = $(dtab.containers()).find("th.select-checkbox");
			var headerRow = chk.closest("tr");
			chk.on("click", function() {
				if (headerRow.hasClass("selected")) {
					dtab.rows({ search: "applied" }).deselect();
					headerRow.removeClass("selected");
				} else {
					dtab.rows({ search: "applied" }).select();
					headerRow.addClass("selected");
				}
			});

			dtab.on("select deselect search", function() {
				var selected = dtab
					.rows({ selected: true })
					.ids()
					.toArray();
				var filtered = dtab
					.rows({ search: "applied" })
					.ids()
					.toArray();

				if (_.intersection(selected, filtered).length === filtered.length) {
					headerRow.addClass("selected");
				} else {
					headerRow.removeClass("selected");
				}
			});
		}

		if (loading) {
			ko.applyBindingsToNode(self.dt.dataTable.table().container(), {
				loadingSpinner: loading
			});
		}
	};

	self.dispose = function() {
		if (self._dataSubscription) {
			self._dataSubscription.dispose();
			self._dataSubscription = null;
		}

		if (self._processingSubscription) {
			self._processingSubscription.dispose();
			self._processingSubscription = null;
		}

		self.dt.dispose();
		self.dt = null;
	};
}

UptivoDataTable.prototype = Object.create(ControlBase.prototype);
UptivoDataTable.prototype.constructor = UptivoDataTable;

function AMChart($element, config, viewModel, allbindings) {
	var self = this;
	var $container;
	var printing = false;

	self.update = function() {
		var cfg = ko.unwrap(config);
		if (cfg) {
			cfg = _.defaults(cfg, {
				fontFamily: "Montserrat, Open Sans, Helvetica Neue, Helvetica, Arial, sans-serif"
			});
			if (self.chart) self.chart.clear();
			self.chart = new AmCharts.makeChart($container.get(0), cfg);
		}
	};

	self.initialize = function() {
		$container = $("<div>")
			.width("100%")
			.height("100%");
		$element.append($container);

		eventBus.subscribe("BeforePrint", beforePrint);
		eventBus.subscribe("AfterPrint", afterPrint);
	};

	self.dispose = function() {
		eventBus.unsubscribe("BeforePrint", beforePrint);
		eventBus.unsubscribe("AfterPrint", afterPrint);
	};

	var beforePrint = function() {
		var cfg = ko.unwrap(config);
		if (self.chart) {
			if (cfg.printWidth) {
				self.chart.div.style.width = cfg.printWidth + "px";
				self.chart.validateNow();
			}
		}
	};

	var afterPrint = function() {
		var cfg = ko.unwrap(config);
		if (self.chart) {
			if (cfg.printWidth) {
				self.chart.div.style.width = "100%";
				self.chart.validateNow();
			}
		}
	};
}

AMChart.prototype = Object.create(ControlBase.prototype);
AMChart.prototype.constructor = AMChart;

function UserService() {
	var self = this;

	self.getSelf = function() {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/self"
		});
	};

	self.getUserById = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id
		});
	};

	self.getDemoUserById = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.DEMO_SENSORS_ENDPOINT + "/" + id
		});
	};

	self.getUserBasicDataById = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id + "/basic",
		});
	};

	self.updateDemoUser = function(model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.DEMO_SENSORS_ENDPOINT + "/" + model.DemoAthleteId(),
			payload: ko.toJSON(model)
		});
	};

	self.getUserSensors = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id + "/sensors"
		});
	};

	self.addSensor = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SENSORS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	self.UptivoCodeRe = /^([DdLlMm0Xx])0([0-5]\d\d\d\d|6[0-4]\d\d\d|65[0-4]\d\d|655[0-2]\d|6553[0-5])$/;

	self.validUptivoSensor = function(uptivoCode) {
		return self.UptivoCodeRe.test(uptivoCode);
	};

	self.parseUptivoSensor = function(uptivoCode) {
		var m = self.UptivoCodeRe.exec(uptivoCode);
		if (m) {
			var num = parseInt(m[2], 10);
			return {
				Number: num,
				Name: "UPTIVO-" + m[0].toUpperCase(),
				HardwareId: "ANT+:" + num,
				ModelId: m[1].toUpperCase()
			};
		}

		return null;
	};

	self.getUptivoSensorModel = function(userId, uptivoCode) {
		var belt = self.parseUptivoSensor(uptivoCode);
		if (belt) {
			return {
				UserId: userId,
				HardwareId: belt.HardwareId,
				Model: belt.Name,
				Name: belt.Name
			};
		}
	};

	self.addUptivoSensor = function(userId, uptivoCode) {
		var model = self.getUptivoSensorModel(userId, uptivoCode);
		if (model) {
			return self.addSensor(model);
		}
	};


	self.MZCodeRe = /^(?!0+$)(\d{0,10})$/;

	self.validMZSensor = function(mzCode) {
		return RegExp(self.MZCodeRe).test(mzCode);
	};

	self.parseMZSensor = function(mzCode) {
		var m = RegExp(self.MZCodeRe).exec(mzCode);
		if (m) {
			var num = parseInt(m[1], 10);
			var antId = num & 0xffff;
			return {
				Number: num,
				Name: "MyZone-" + m[1].padStart(7, '0'),
				HardwareId: "ANT+:" + antId,
				Model: "MZ HW:" + m[1].padStart(7, '0')
			};
		}

		return null;
	};

	self.getMZSensorModel = function(userId, mzCode) {
		var belt = self.parseMZSensor(mzCode);
		if (belt) {
			return {
				UserId: userId,
				HardwareId: belt.HardwareId,
				Model: belt.Model,
				Name: belt.Name
			};
		}
	};

	self.addMZSensor = function(userId, mzCode) {
		var model = self.getMZSensorModel(userId, mzCode);
		if (model) {
			return self.addSensor(model);
		}
	};

	self.GarminCodeRe = /^(?!0+$)(\d{0,12})$/;

	self.validGarminSensor = function(garminCode) {
		return RegExp(self.GarminCodeRe).test(garminCode);
	};

	self.parseGarminSensor = function(garminCode) {
		var m = RegExp(self.GarminCodeRe).exec(garminCode);
		if (m) {
			var num = parseInt(m[1], 10);
			var antId = num & 0xffff;
			return {
				Number: num,
				Name: "Garmin-" + m[1],
				HardwareId: "ANT+:" + antId,
				Model: "GARMIN HW:"+m[1]
			};
		}

		return null;
	};

	self.getGarminSensorModel = function(userId, garminCode) {
		var belt = self.parseGarminSensor(garminCode);
		if (belt) {
			return {
				UserId: userId,
				HardwareId: belt.HardwareId,
				Model: belt.Model,
				Name: belt.Name
			};
		}
	};

	self.addGarminSensor = function(userId, garminCode) {
		var model = self.getGarminSensorModel(userId, garminCode);
		if (model) {
			return self.addSensor(model);
		}
	};

	self.deleteSensor = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.SENSORS_ENDPOINT + "/" + id
		});
	};

	self.sendJoinLink = function(email, clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitations:sendEmail",
			payload: ko.toJSON(email),
			ignoreCodes: [409]
		});
	};

	self.createUser = function(model, clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users",
			payload: ko.toJSON(model, function(key, value) {
				if (key == "BirthDate") {
					value = moment(value, [
						moment.ISO_8601,
						utilities.getMomentDateFormat(userData.get().DateFormat)
					]).format();
				} else if (key == "UserId") return undefined;

				return value;
			}),
			ignoreCodes: [409]
		});
	};

	self.updateUser = function(id, model) {
		delete model.RowVersion;
		return utilities.defaultUpdate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id,
			payload: ko.toJSON(model, function(key, value) {
				if (key == "BirthDate") {
					value = moment(value, [
						moment.ISO_8601,
						utilities.getMomentDateFormat(userData.get().DateFormat)
					]).format();
				}
				if (key == "Height" && !value) {
					return undefined;
				}

				return value;
			}),
			ignoreCodes: [409]
		});
	};

	self.updateInvitation = function(invitationCode, userId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + (userId || userData.get().UserId) + "/invitations",
			payload: '"' + invitationCode + '"',
			forceJson: true
		});
	};

	self.deleteInvitationByCode = function(code) {
		return utilities.defaultDelete({
			url: CONFIGURATION.INVITATION_ENDPOIND + "/" + code
		});
	};

	self.deleteUser = function(userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId
		});
	};

	self.getRoles = function(id, async) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id + "/roles",
			async: async
		});
	};

	self.getUserRoles = function(userId, clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/clubs/" + clubId + "/roles"
		});
	};

	self.getCurrentUserSensors = function() {
		return self.getUserSensors(userData.get().UserId);
	};

	self.updateCurrentUser = function(model) {
		return self.updateUser(userData.get().UserId, model);
	};
	self.getCurrentUser = function() {
		return self.getUserById(userData.get().UserId);
	};
	self.getHeartbeats = function(userId, start, end) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/heartbeats?from=" +
				start.toISOString() +
				"&to=" +
				end.toISOString()
		});
	};
	self.getPower = function(userId, start, end) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/power?from=" +
				start.toISOString() +
				"&to=" +
				end.toISOString()
		});
	};
	self.getCadence = function(userId, start, end) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/cadence?from=" +
				start.toISOString() +
				"&to=" +
				end.toISOString()
		});
	};
	self.getGeopositions = function(userId, start, end) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/geopositions?from=" +
				start.toISOString() +
				"&to=" +
				end.toISOString()
		});
	};
	self.getHits = function(userId, start, end) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/hits?from=" +
				start.toISOString() +
				"&to=" +
				end.toISOString()
		});
	};
	self.getDefaultHeartZones = function(birthday, birthdayFormat) {
		if (!birthdayFormat) birthdayFormat = "DD/MM/YYYY";

		var maxRate = Math.round(208 - 0.7 * (new Date().getFullYear() - moment(birthday, birthdayFormat).year()));

		return {
			Zone5Bpm: maxRate,
			Zone4Bpm: Math.round(maxRate * 0.9),
			Zone3Bpm: Math.round(maxRate * 0.8),
			Zone2Bpm: Math.round(maxRate * 0.7),
			Zone1Bpm: Math.round(maxRate * 0.6),
			Zone0Bpm: Math.round(maxRate * 0.5)
		};
	};
	self.getDefaultFTP = function(gender, weight) {
		return gender && weight ? Math.round(DEFAULT_POWER_OUTPUT[gender] * weight) : 0;
	};

	self.getTrainingSummaries = function(userId, from, to, sub,count) {
		return utilities.defaultGet({
				url:
					CONFIGURATION.USERS_ENDPOINT +
					"/" +
					userId +
					"/calendar/trainings?from=" +
					(from ? from.toISOString() : "") +
					"&to=" +
					(to ? to.toISOString() : "") +
					(sub ? "&sub=" + sub : "") +
					(count ? "&count=" + count : "")
			})
			.then(function(trainings) {
				return trainings.map(function(training) {
					var totalTime = 0;
					for (var i = 0; i <= 5; i++) {
						var zoneTimeTicks = utilities.getDurationMs(training["Zone" + i + "Time"]);
						training["Zone" + i + "TimeTicks"] = zoneTimeTicks;
						totalTime += zoneTimeTicks;
					}
					training.DurationTicks = totalTime;
					return training;
				});
			});
	};

	self.addWatch = function(watcherId, watchedId, type, notify) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USERRELATIONSHIPS_ENDPOINT,
			ignoreCodes: [400],
			dataType: "json",
			payload: JSON.stringify({
				Type: type,
				WatcherId: watcherId,
				WatchedId: watchedId,
				NotifyWatcher: notify
			}),
			contentType: "application/json; charset=utf-8"
		});
	};

	self.deleteWatch = function(watcherId, watchedId, type) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERRELATIONSHIPS_ENDPOINT + "/" + type + "/" + watcherId + "/" + watchedId,
			ignoreCodes: [404]
		});
	};

	self.getWatches = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/relationships"
		});
	};
	/*
	self.getWatched = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + '/' + userId + '/relationships?as=Watcher'
		})
	}
	*/

	self.getWatch = function(userId, athleteId, type) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERRELATIONSHIPS_ENDPOINT + "/" + type + "/" + userId + "/" + athleteId,
			ignoreCodes: [404]
		});
	};

	self.getMeasures = function(userId, from, to, excludeEvents) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/measures?from=" +
				from.toISOString() +
				"&to=" +
				to.toISOString() +
				(excludeEvents ? "&excludeEvents=true" : "")
		});
	};

	self.getAllMeasures = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/measures"
		});
	};

	self.getMeasureEvents = function(userId, from, to, type, count) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/measures/events?from=" +
				(from ? from.toISOString() : "") +
				"&to=" +
				(to ? to.toISOString() : "") +
				(type ? "&type=" + sub : "") +
				(count ? "&count=" + count : "")
		});
	};

	self.getUserWorkoutSheetsRunsSummaries = function(userId, from, to, count) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.USERS_ENDPOINT +
				"/" +
				userId +
				"/calendar/workoutsheetsruns?from=" +
				(from ? from.toISOString() : "") +
				"&to=" +
				(to ? to.toISOString() : "") +
				(count ? "&count=" + count : "")
		});
	};

	self.getAllMeasureEvents = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/measures/events"
		});
	};

	self.deleteProfileImage = function(userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/profileimage"
		});
	};

	self.uploadProfileImage = function(userId, blob) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/profileimage",
			payload: utilities.blobToFormData(blob),
			isRaw: true
		});
	};

	self.getClubLicenseExpirations = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/clubs/licenses/expirations"
		});
	};

	self.updateTargetZone = function(userId, loPrc, hiPrc) {
		return utilities.defaultPartialUpdate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId,
			payload: JSON.stringify({
				CustomTargetZone: (loPrc == 65 && hiPrc == 85) ? false : true,
				TargetZoneLowPrc: loPrc,
				TargetZoneHighPrc: hiPrc
			}),
			contentType: "application/json; charset=utf-8"
		});
	};

	self.getTrainingPrograms = function(userId, folder) { // folder "programs" (file .doc .pdf ecc.) o "workouts" (workout sheet JSON) 
		var url = CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/shared";
		url += folder ? "/" + folder : "";
		return utilities.defaultGet({
			url: url,
			ignoreCodes: [404]
		});
	};

	self.getClubTags = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/clubs/tags"
		});
	};

	self.getlistUserPersonalFiles = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal",
			ignoreCodes: [404]
		});
	};

	self.deleteUserPersonalFile = function(userId, fileId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal/" + fileId,
		});
	};
	
	self.deleteUserPersonalFolder = function(userId, folderTagName) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal?withTag=" + encodeURI(folderTagName),
		});
	};


	self.moveUserPersonalFile = function(userId, fileId, xtags) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal/" + fileId + "/tags",
			payload: JSON.stringify(xtags)
		});
	};


	self.renameUserPersonalFile = function(userId, fileId, fileName) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal/" + fileId + "/fileName",
			payload: JSON.stringify(fileName)
		});
	};

	self.renameUserPersonalFolder = function(userId, oldFolderTagName, newFolderName) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/files/personal/tags/" + encodeURI(oldFolderTagName),
			payload: JSON.stringify(newFolderName)
		});
	};

	self.getUserSubscriptions = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/subscriptions"
		});
	};

	self.getUserExpirations = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/expirations",
		});
	};

	self.getUserNotes = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/notes",
		});
	};

	self.getUserBadges = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/badges"
		});
	};

	self.getUserAssignedTasks = function(userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/tasks/assigned",
		});
	};

	self.getUserExpiringTasks = function(userId, query) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/tasks/assigned/expiring/" + (query ? query : "")
		});
	};

	// DASHBOARD GARMIN

	// Get daily health summary data
	self.getGarminDailySummary = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/daily?from=" + from + "&to=" + to,
		});
	};

	// Get daily hrv data
	self.getGarminHrv = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/hrv?from=" + from + "&to=" + to,
		});
	};

	// Get daily pulse ox data
	self.getGarminPulseOx = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/pulseox?from=" + from + "&to=" + to,
		});
	};

	// Get daily sleep data
	self.getGarminSleep = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/sleep?from=" + from + "&to=" + to,
		});
	};

	// Get daily stress data
	self.getGarminStress = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/stress?from=" + from + "&to=" + to,
		});
	};

	// Get user training activity data for health
	self.getHealthActivity = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/activity?from=" + from + "&to=" + to,
		});
	};

	/// Get daily dashboard data for sleep
	self.getGarminSleepDashboard = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/sleep/dashboard?from=" + from + "&to=" + to,
		});
	};

	// Get daily hrv dashboard data
	self.getGarminHrvDashboard = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/hrv/dashboard?from=" + from + "&to=" + to,
		});
	};

	// Get daily health dashboard data
	self.garminDailySummaryDashboard = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/daily/dashboard?from=" + from + "&to=" + to,
		});
	};

	// Get daily stress dashboard data
	self.getGarminStressDashboard = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/garmin/stress/dashboard?from=" + from + "&to=" + to,
		});
	};

	//Get user training activity data for health dashboard
	self.getHealthActivityDashboard = function(userId, from, to) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/health/activity/dashboard?from=" + from + "&to=" + to,
		});
	};

	// Update user policy status (form user profile, management tab) - trainer can reset NotAcceptedPolicy to NotAnswered
	self.batchUpdateClubPolicyUserStates = function(userId, updatesDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/policies:batchUpdate",
			payload: JSON.stringify(updatesDto)
		});
	};

	self.getUserEquipments = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id + "/equipments",
		});
	};

	// Get user email status
	self.getUserEmailStatus = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + id + "/emails/status",
		});
	};

}

var userService = new UserService();

function BrandsService() {
	var self = this;

	self.currentClub = ko.observable();

	self.getCurrentClub = function () {
		return self.currentClub;
	}

	self.setCurrentClub = function (club) {
		self.currentClub(club.ClubId);
	};

	self.create = function (name) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BRANDS_ENDPOINT,
			payload: JSON.stringify({
				BrandId: 0,
				Name: name
			})
		});
	};

	self.getBrandsByUserId = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + '/brands'
		});
	};

	self.getClubs = function (brandId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + '/clubs'
		});
	}

	self.getOwners = function (brandId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + '/owners'
		});
	}

	self.getClubLicenses = function (brandId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + '/clubs/licenses'
		});
	}


	self.updateBrand = function (id, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + id,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			})
		});
	}

	self.brandLogoForAllClubs = function (id) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + id + '/profileimage?replaceClubImages=true'
		});
	}

	self.deleteProfileImage = function (brandId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + '/profileimage'
		});
	}

	self.uploadProfileImage = function (brandId, blob, replaceClubs) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + '/profileimage' + (replaceClubs ? '?replaceClubImages=true' : ''),
			payload: utilities.blobToFormData(blob),
			isRaw: true
		});
	}


	self.getAthletesRankings = function (brandId, from, to, origin) {
		var url = CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + "/athletes/rankings";
		var query = [];

		if (from) {
			if (!to) {
				query.push("presetRange=" + from);
			} else {
				query.push("from=" + from.toISOString() + "&to=" + to.toISOString());
			}
		}

		if (origin) {
			query.push("origin=" + origin);
		}

		if (query.length) {
			url += "?" + query.join("&");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	// BRAND CHALLENGES

	self.getBrandChallenges = function (brandId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + "/challenges",
		});
	};


	// Get brand athletes health rankings data
	self.getBrandHealthRankings = function (brandId, from, to) {
		var url = CONFIGURATION.BRANDS_ENDPOINT + "/" + brandId + "/athletes/rankings/health";
		var query = [];

		if (from) {
			if (!to) {
				query.push("presetRange=" + from);
			} else {
				query.push("from=" + from.toISOString() + "&to=" + to.toISOString());
			}
		}

		if (query.length) {
			url += "?" + query.join("&");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

}

var brandsService = new BrandsService();
function ClubsService() {
	var self = this;
	self.createClub = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT,
			payload: JSON.stringify(model),
			ignoreCodes: [409],
		});
	};

	self.getClubsForUser = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/clubs",
		});
	};

	self.getClubById = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId,
		});
	};

	self.getClubSummaryById = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/summary",
		});
	};

	self.getUsers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users",
		});
	};

	self.getUserSensors = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/sensors",
		});
	};

	self.getSensorUsersInClub = function (clubId, hardwareId) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.CLUBS_ENDPOINT +
				"/" +
				clubId +
				"/sensors/users?hardwareId=" +
				encodeURIComponent(hardwareId),
		});
	};

	self.deleteSensorFromUsersInClub = function (clubId, hardwareId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/sensors?hardwareId=" + encodeURIComponent(hardwareId),
		});
	};

	self.getUsersRoles = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/roles",
		});
	};

	self.getUsersMgmt = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/management",
		});
	};

	self.getClubAthleteCredits = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/credits",
		});
	};

	self.getUserCreditsTransactions = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/credits/transactions",
		});
	};

	self.createUserCreditsTransaction = function (clubId, userId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/credits/transactions",
			payload: JSON.stringify(model)
		});
	};

	self.getClubSensors = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/clubsensors",
		});
	};

	self.getClubIntensityFlows = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/intensityflows",
		});
	};

	self.checkIfUserInClub = function (clubId, userEmail, callback) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/email/" + userEmail + "/roles",
			error: function (xhr) {
				if (xhr.status == 404) callback();
			},
		});
	};

	self.getAthletesTrainingTotals = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes",
		});
	};

	self.getAthletesBasicInfo = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/basic",
		});
	};

	self.getClubStaffBasicData = function (clubId, trainers, managers) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/basic?";
		url += trainers ? "trainers=true&" : "";
		url += managers ? "managers=true" : "";

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getAthletesCredits = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/credits",
		});
	};

	self.getAtletesLastMeasures = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/measures/last",
		});
	};

	self.getAthletesRankings = function (clubId, from, to, origin) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/rankings";
		var query = [];

		if (from) {
			if (!to) {
				query.push("presetRange=" + from);
			} else {
				query.push("from=" + from.toISOString() + "&to=" + to.toISOString());
			}
		}

		if (origin) {
			query.push("origin=" + origin);
		}

		if (query.length) {
			url += "?" + query.join("&");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	self.createInvitationLink = function (clubId, email) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitationLinks",
			payload: JSON.stringify(email),
		});
	};

	self.getInvitationLinks = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitationLinks",
		});
	};

	self.getInvitations = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitations",
		});
	};

	self.createInvitation = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + model.ClubId + "/invitations",
			payload: JSON.stringify(model),
		});
	};

	self.getDisplayGroups = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/displayGroups",
		});
	};

	self.getDevices = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/uptivobridges",
		});
	};

	self.updateDevice = function (model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.UPTIVO_BRIDGES_ENDPOINT + "/" + model.UptivoBridgeId,
			payload: JSON.stringify(model),
		});
	};

	self.deleteDevice = function (id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.UPTIVO_BRIDGES_ENDPOINT + "/" + id,
		});
	};

	self.getUptivoBridgeState = function (id) {
		return utilities.defaultGet({
			url: CONFIGURATION.UPTIVO_BRIDGES_ENDPOINT + "/" + id + "/state",
			ignoreCodes: [404]
		});
	};

	self.deleteDisplayGroup = function (id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.DISPLAY_GROUPS_ENDPOINT + "/" + id,
		});
	};

	self.createDisplayGroup = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.DISPLAY_GROUPS_ENDPOINT,
			payload: JSON.stringify(model),
		});
	};

	self.createDemoSensor = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.DEMO_SENSORS_ENDPOINT,
			payload: JSON.stringify(model),
		});
	};

	self.updateDemoSensor = function (model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.DEMO_SENSORS_ENDPOINT + "/" + model.DemoAthleteId,
			payload: JSON.stringify(model),
		});
	};

	self.removeDemoSensor = function (model) {
		return utilities.defaultDelete({
			url: CONFIGURATION.DEMO_SENSORS_ENDPOINT + "/" + model.DemoAthleteId,
		});
	};

	self.getDemoSensors = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/demoathletes",
		});
	};

	self.getPendingDevicesRegistrations = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/registrationcodes/uptivobridges",
		});
	};

	self.getNewPendingUsers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/pending",
		});
	};

	self.generateDeviceRegistrationCode = function (clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/registrationcodes/uptivobridges",
		});
	};

	self.updateDisplayGroup = function (userId, clubId, displayGroupId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/displaygroupid",
			payload: displayGroupId,
			forceJson: true,
		});
	};

	self.renameDisplayGroup = function (model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.DISPLAY_GROUPS_ENDPOINT + "/" + model.DisplayGroupId,
			payload: JSON.stringify(model),
		});
	};

	self.addAthlete = function (userId, clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes",
			payload: userId,
			forceJson: true,
		});
	};

	self.addManager = function (userId, clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/managers",
			payload: userId,
			forceJson: true,
		});
	};
	self.addTrainer = function (userId, clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers",
			payload: userId,
			forceJson: true,
		});
	};
	self.removeAthlete = function (userId, clubId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId,
		});
	};

	self.removeManager = function (userId, clubId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/managers/" + userId,
		});
	};

	self.removeTrainer = function (userId, clubId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/" + userId,
		});
	};

	self.updateClub = function (id, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + id,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			}),
			ignoreCodes: [409],
		});
	};

	self.partialUpdateClub = function (id, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + id,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			}),
			ignoreCodes: [409],
		});
	};

	self.deleteClub = function (id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + id,
		});
	};

	self.getRankings = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/rankings",
		});
	};

	self.getCircuitTimers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/timers/circuits",
		});
	};

	self.getLicenses = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/licenses",
		});
	};

	self.getLicenseModifiers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/licenses/modifiers",
		});
	};

	self.useLicenseModifier = function (lmId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LICENSES_ENDPOINT + "/clubs/modifiers/" + lmId + "/used",
			payload: true,
			forceJson: true,
		});
	};

	self.getResources = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/resources",
		});
	};

	self.getApps = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/uptivoapps",
		});
	};

	self.deleteApp = function (app) {
		return utilities.defaultDelete({
			url: CONFIGURATION.APPS_ENDPOINT + "/" + app.UptivoAppId,
		});
	};

	self.generateAppRegistrationCode = function (clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/registrationcodes/uptivoapps",
		});
	};

	self.getPendingAppRegistrationCodes = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/registrationcodes/uptivoapps",
		});
	};

	self.getGenericDevices = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/devices/generic",
		});
	};

	self.deleteProfileImage = function (clubId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/profileimage",
		});
	};

	self.uploadProfileImage = function (clubId, blob) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/profileimage",
			payload: utilities.blobToFormData(blob),
			isRaw: true,
		});
	};

	self.getFullScreenSlideShow = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/slideshows/fullscreen",
		});
	};

	self.getTrainers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/basic",
		});
	};

	self.getTrainersRankingsStats = function (clubId, from, to) {
		var url = [
			CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/rankings/stats",
			["fromYearMonth=" + from, "toYearMonth=" + to].join("&"),
		].join("?");

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getTrainersCommentsStats = function (clubId, from, to) {
		var url = [
			CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/comments/trainings/stats",
			["from=" + from, "to=" + to].join("&"),
		].join("?");

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getTrainerWatchedStats = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/relationships/stats",
		});
	};

	self.getTrainerPoints = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/" + userId + "/trainerawards",
		});
	};

	self.getTrainerComments = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/" + userId + "/comments/trainings",
		});
	};

	self.getTrainerWatchedAthletes = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/" + userId + "/relationships/trainingstotal",
		});
	};

	self.unwatchTrainerWatchedAthletes = function (clubId, userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/trainers/" + userId + "/relationships",
		});
	};

	self.getTrainingPrograms = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/programs",
		});
	};

	self.deleteClubProgram = function (clubId, fileId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/programs/" + fileId,
		});
	};

	self.updateClubProgramName = function (clubId, fileId, fileName) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/programs/" + fileId + "/filename",
			payload: JSON.stringify(fileName),
		});
	};

	self.getClubFileShares = function (clubId, fileId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/" + fileId + "/shares",
		});
	};

	self.shareClubProgram = function (clubId, fileId, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/programs/" + fileId + "/shares:batchCreate",
			payload: JSON.stringify(userIds),
		});
	};

	self.unshareClubFile = function (clubId, fileId, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/" + fileId + "/shares:batchDelete",
			payload: JSON.stringify(userIds),
		});
	};

	self.getClubMessages = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/messages",
		});
	};

	self.deleteClubMessage = function (clubId, fileId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/messages/" + fileId,
		});
	};

	self.updateClubMessage = function (clubId, fileId, title, body) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.BASE_FILE_SERVICE + "/files/clubs/" + clubId + "/messages/" + fileId,
			isRaw: true,
			data: body,
			contentType: "text/html; charset=utf-8",
			headers: {
				"x-file-name": encodeURIComponent(title),
			},
		});
	};

	self.createClubMessage = function (clubId, title, body) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BASE_FILE_SERVICE + "/files/clubs/" + clubId + "/messages/",
			isRaw: true,
			data: body,
			contentType: "text/html; charset=utf-8",
			headers: {
				"x-file-name": encodeURIComponent(title),
			},
		});
	};

	self.sendClubMessage = function (clubId, fileId, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/messages/" + fileId + ":send",
			payload: JSON.stringify(userIds),
		});
	};

	self.getTags = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/tags",
		});
	};

	self.getUserTagIds = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/tags/ids",
		});
	};

	//UPTIVO BOOKING

	self.getAllClubClasses = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		trainingTypeFilter,
		activityTypeFilter,
		placeFilter,
		statusFilter,
		participantsFilter,
		subscriptionNameId,
		expandDates
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(trainingTypeFilter ? "&TrainingType=" + trainingTypeFilter.Value : "") +
				(activityTypeFilter != "3" ? "&ClassType=" + activityTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(statusFilter != "2" ? "&PublishState=" + statusFilter : "") +
				(participantsFilter != "3" ? "&Participants=" + participantsFilter : "") +
				(subscriptionNameId ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(expandDates ? "&expandDates=true" : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	// WITHOUT PT lessons
	self.getClubClasses = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		trainingTypeFilter,
		activityTypeFilter,
		placeFilter,
		statusFilter,
		participantsFilter,
		subscriptionNameId,
		dayOfWeekFilter,
		expandDates,
		startTimeFilter,
		endTimeFilter
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/club";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(trainingTypeFilter ? "&TrainingType=" + trainingTypeFilter.Value : "") +
				(activityTypeFilter != "3" ? "&ClassType=" + activityTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(statusFilter != "2" ? "&PublishState=" + statusFilter : "") +
				(participantsFilter != "3" ? "&Participants=" + participantsFilter : "") +
				(subscriptionNameId != undefined ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(dayOfWeekFilter != "AllDays" ? "&dayOfWeek=" + dayOfWeekFilter : "") +
				(expandDates ? "&expandDates=true" : "") +
				(startTimeFilter ? "&startTime=" + startTimeFilter : "") +
				(endTimeFilter ? "&endTime=" + endTimeFilter : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	// only PT lessons
	self.getPtClasses = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		trainingTypeFilter,
		activityTypeFilter,
		placeFilter,
		statusFilter,
		participantsFilter,
		subscriptionNameId,
		dayOfWeekFilter,
		expandDates,
		startTimeFilter,
		endTimeFilter
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/pt";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(trainingTypeFilter ? "&TrainingType=" + trainingTypeFilter.Value : "") +
				(activityTypeFilter != "3" ? "&ClassType=" + activityTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(statusFilter != "2" ? "&PublishState=" + statusFilter : "") +
				(participantsFilter != "3" ? "&Participants=" + participantsFilter : "") +
				(subscriptionNameId != undefined ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(dayOfWeekFilter != "AllDays" ? "&dayOfWeek=" + dayOfWeekFilter : "") +
				(expandDates ? "&expandDates=true" : "") +
				(startTimeFilter ? "&startTime=" + startTimeFilter : "") +
				(endTimeFilter ? "&endTime=" + endTimeFilter : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	// only Services lessons
	self.getServicesClasses = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		serviceTypeFilter,
		activityTypeFilter,
		placeFilter,
		statusFilter,
		participantsFilter,
		subscriptionNameId,
		dayOfWeekFilter,
		expandDates,
		startTimeFilter,
		endTimeFilter
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/services";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(serviceTypeFilter ? "&TrainingType=" + serviceTypeFilter.Value : "") +
				(activityTypeFilter != "3" ? "&ClassType=" + activityTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(statusFilter != "2" ? "&PublishState=" + statusFilter : "") +
				(participantsFilter != "3" ? "&Participants=" + participantsFilter : "") +
				(subscriptionNameId != undefined ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(dayOfWeekFilter != "AllDays" ? "&dayOfWeek=" + dayOfWeekFilter : "") +
				(expandDates ? "&expandDates=true" : "") +
				(startTimeFilter ? "&startTime=" + startTimeFilter : "") +
				(endTimeFilter ? "&endTime=" + endTimeFilter : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};


	// only BridgeWorkouts lessons
	self.getBridgeWorkoutsClasses = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		serviceTypeFilter,
		activityTypeFilter,
		placeFilter,
		statusFilter,
		participantsFilter,
		subscriptionNameId,
		dayOfWeekFilter,
		expandDates,
		startTimeFilter,
		endTimeFilter,
		circuitsFilter,
		displayGroupFilter
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/bridgeWorkouts";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(serviceTypeFilter ? "&TrainingType=" + serviceTypeFilter.Value : "") +
				(activityTypeFilter != "3" ? "&ClassType=" + activityTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(statusFilter != "2" ? "&PublishState=" + statusFilter : "") +
				(participantsFilter != "3" ? "&Participants=" + participantsFilter : "") +
				(subscriptionNameId != undefined ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(dayOfWeekFilter != "AllDays" ? "&dayOfWeek=" + dayOfWeekFilter : "") +
				(expandDates ? "&expandDates=true" : "") +
				(startTimeFilter ? "&startTime=" + startTimeFilter : "") +
				(endTimeFilter ? "&endTime=" + endTimeFilter : "") +
				(circuitsFilter ? "&BridgeWorkoutId=" + circuitsFilter.BridgeWorkoutId : "") +
				(displayGroupFilter ? "&DisplayGroupId=" + displayGroupFilter.DisplayGroupId : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getClubClassFiltersData = function (clubId, calendarType) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/filtersData?calendarType=" + calendarType,
		});
	};

	self.getClubClass = function (classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/classes/" + classId,
		});
	};

	self.getClubActivitiesForStaff = function (clubId, from, to, count, trainerId, withParticipants) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/management?";
		url +=
			(from ? "from=" + from : "") +
			(to ? "&to=" + to : "") +
			(count ? "&count=" + count : "") +
			(trainerId ? "&trainerId=" + trainerId : "") +
			(withParticipants ? "&withParticipants=" + withParticipants : "");

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getClubPaymentAccounts = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/payments/accounts",
		});
	};

	self.onboardPaymentAccount = function (clubId, accountType) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/payments/accounts/onboard",
			payload: JSON.stringify(accountType),
		});
	};

	self.getClubCreditsPackages = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/payments/credits/packages?showAll=true",
		});
	};

	self.orderCreditsPackage = function (clubId, userId, packageId, accountType) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/credits/orders",
			payload: JSON.stringify({
				ClubCreditsPackageId: packageId,
				PaymentAccountType: accountType,
			}),
		});
	};

	// CLUB SUBSCRIPTIONS

	self.getClubSubscriptions = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/subscriptions",
		});
	};

	self.getClubClassSubscriptionUsers = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/subscriptions/users",
		});
	};

	self.getUserClubSubscriptions = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/subscriptions",
		});
	};

	// CLUB CHALLENGES

	self.getClubChallenges = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/challenges",
		});
	};

	// CLUB BADGES

	self.getClubBadges = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/badges",
		});
	};

	self.getClassParticipantSubscriptions = function (
		clubId,
		draw,
		start,
		length,
		search,
		startDate,
		endDate,
		locationFilter,
		trainerNameId,
		trainingTypeFilter,
		calendarTypeFilter,
		placeFilter,
		participantsFilter,
		subscriptionNameId,
		absentFilter
	) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/participants";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(startDate ? "&Begin=" + startDate : "") +
				(endDate ? "&End=" + endDate : "") +
				(locationFilter ? "&Location=" + locationFilter.Value : "") +
				(trainerNameId && trainerNameId.Id ? "&TrainerId=" + trainerNameId.Id : "") +
				(trainerNameId && trainerNameId.Value ? "&TrainerName=" + trainerNameId.Value : "") +
				(trainingTypeFilter ? "&TrainingType=" + trainingTypeFilter.Value : "") +
				(calendarTypeFilter != "3" ? "&CalendarType=" + calendarTypeFilter : "") +
				(placeFilter != "2" ? "&Place=" + placeFilter : "") +
				(participantsFilter != "2" ? "&State=" + participantsFilter : "") +
				(subscriptionNameId ? "&ClassSubscriptionId=" + subscriptionNameId : "") +
				(absentFilter != "2" ? "&NoShow=" + absentFilter : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	self.getClassParticipantSubscriptionsFiltersData = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/participants/filtersData",
		});
	};

	// ATHLETE JOIN MODE

	self.updateAthleteJoinMode = function (userId, clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/JoinMode",
			payload: JSON.stringify(model),
			forceJson: true,
		});
	};

	self.updateAthleteJoinModeBatch = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/JoinMode:batchUpdate",
			payload: JSON.stringify(model),
			forceJson: true,
		});
	};

	//CLUB APP LINKS

	self.getClubAppLinks = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/applinks",
		});
	};

	// EXPIRATIONS

	self.getClubExpirations = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/expirations",
		});
	};

	self.getClubAthleteExpirations = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/expirations",
		});
	};

	// NOTES

	self.getClubAthleteNotes = function (clubId, userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/notes",
		});
	};

	// EDIT USER

	// ATHLETE CREDITS (Get user credits in clubs where the requesting user is trainer or manager)
	// NOT USED
	/*
	self.getAthleteCredits = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/credits",
		});
	};
	*/

	// ATHLETE EXPIRATIONS (Get athlete expirations in clubs where the requesting user is trainer or manager)
	self.getAthleteExpirations = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/expirations",
		});
	};

	// ATHLETE SUBSCRIPTIONS (Get user subscriptions in clubs where the requesting user is trainer or manager)
	self.getAthleteSubscriptions = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/subscriptions",
		});
	};

	// ATHLETE ACTIVITIES (Get user activity summary in clubs where the requesting user is trainer or manager)
	self.getUserActivity = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/activity",
		});
	};

	// ATHLETE NOTES (Get athlete notes in clubs where the requesting user is trainer or manager)
	self.getAthleteNotes = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/notes",
		});
	};

	// ATHLETE TASKS (Get athlete tasks in clubs where the requesting user is trainer or manager)
	self.getAthleteTasks = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/tasks",
		});
	};

	// ATHLETE TASKS (Get athlete tasks in clubs where the requesting user is trainer or manager)
	self.getClubAthleteTasks = function (userId, clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/tasks",
		});
	};

	// ATHLETE TRAINING COMMENTS (Get athlete training comments in clubs where the requesting user is trainer or manager)
	self.getAthleteTrainingComments = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/trainings/comments",
		});
	};

	// ATHLETE AWARDED BADGES (Get athlete awarded badges in clubs where the requesting user is trainer or manager)
	self.getAthleteAwardedBadges = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/badges",
		});
	};

	// ATHLETE CLASSES PARTICIPATIONS (Get user classes participations in clubs where the requesting user is trainer or manager)
	self.getAthleteClassesParticipations = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/classes/participants",
		});
	};

	// ATHLETE LEVELS (Get user level in clubs where the requesting user is trainer or manager)
	self.getAthleteLevels = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/levels",
		});
	};

	// ATHLETE POLICIES (Get user policies in clubs where the requesting user is trainer or manager)
	self.getAthletePolicies = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/policies",
		});
	};

	// VIDEO AND COLLECTIONS
	self.getClubVideosAndCollections = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/videos",
		});
	};

	// ATHLETE CLIENT STAGE (Lead, Qualified, Prospect, Client)

	self.updateAthleteClientStage = function (userId, clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/ClientStage",
			payload: JSON.stringify(model),
			forceJson: true,
		});
	};

	self.updateAthleteClientStageBatch = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/ClientStage:batchUpdate",
			payload: JSON.stringify(model),
			forceJson: true,
		});
	};

	// SMS

	// model contains text and list of phone numbers
	self.sendBatchSMSToPhones = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/phones/:batchSendSMS",
			payload: JSON.stringify(model),
			ignoreCodes: [403],
			forceJson: true,
		});
	};

	// model contains text and list of athletsId
	self.sendBatchSMSToAthletes = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/:batchSendSMS",
			payload: JSON.stringify(model),
			ignoreCodes: [403],
			forceJson: true,
		});
	};

	// ISGUEST
	self.updateAthleteIsGuest = function (clubId, userId, isGuest) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/IsGuest",
			payload: JSON.stringify(isGuest),
			forceJson: true,
		});
	};

	//  Get athletes clubs where the requesting user is trainer or manager
	self.getAthleteClubs = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/clubs",
		});
	};

	//  Get athletes clubs info where the requesting user is trainer or manager
	self.getAthleteClubsInfo = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/clubsinfo",
		});
	};

	self.getClubLogs = function (clubId, draw, start, length, search, event) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/logs";

		if (!_.isUndefined(draw)) {
			url +=
				"?draw=" +
				draw +
				"&start=" +
				start +
				"&length=" +
				length +
				(search ? "&globalSearch=" + search : "") +
				(event ? "&event=" + event : "");
		}

		return utilities.defaultGet({
			url: url,
		});
	};

	// WORKOUT SHEETS
	
	// List club workout sheets as files (shared) (Lista schede del club)
	self.listClubWorkoutSheets = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets",
		});
	};

	// List uptivo workout sheets as files (shared) (Lista schede UPTIVO condivisibili)
	self.listUptivoWorkoutSheets = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/uptivo",
		});
	};

	// Create a new club workout sheet
	self.createClubWorkoutSheet = function (clubId, model) {
		return utilities.defaultCreate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets", */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId,
			payload: model,
			forceJson: true,
		});
	};

	// Update a club workout sheet
	self.updateClubWorkoutSheet = function (clubId, model, fileId) {
		return utilities.defaultUpdate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/" + fileId,
			payload: model,
			// forceJson: true,
		});
	};

	// Get a club workout sheet
	self.getClubWorkoutSheet = function (clubId, fileId) {
		return utilities.defaultGet({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/" + fileId,
		});
	};

	// Delete club workout sheet
	self.deleteClubWorkoutSheet = function (clubId, fileId) {
		return utilities.defaultDelete({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/" + fileId,
		});
	};

	// Share workout sheet
	self.shareClubWorkoutSheet = function (clubId, fileId, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/" + fileId + "/shares:batchCreate",
			payload: JSON.stringify(userIds)
		});
	};

	// Share Uptivo workout sheet
	self.shareUptivoWorkoutSheet = function (clubId, fileId, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/uptivo/" + fileId + "/shares:batchCreate",
			payload: JSON.stringify(userIds)
		});
	};

	// CLUB ATHLETE WORKOUT SHEETS

	// List club athlete sheets as files (Lista schede degli atleti (personali) del club)
	self.listClubAthleteWorkoutSheets = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes",
		});
	};

	// List associations between athletes, workoutsheets and club subscriptions
	self.listWorkoutSheetsAthletesSubscriptions = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes/subscriptions",
		});
	};

	// Create a new club athlete personal workout sheet
	self.createClubAthleteWorkoutSheet = function (userId, clubId, model) {
		return utilities.defaultCreate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes/" + userId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/athletes/" + userId,
			payload: model,
			forceJson: true,
		});
	};

	//  Update a club athlete personal workout sheet
	self.updateClubAthleteWorkoutSheet = function (userId, clubId, model, fileId) {
		return utilities.defaultUpdate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes/" + userId + "/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/athletes/" + userId + "/" + fileId,
			payload: model,
			// forceJson: true,
		});
	};

	//Get a club athlete personal workout sheet
	self.getClubAthleteWorkoutSheet = function (userId, clubId, fileId) {
		return utilities.defaultGet({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes/" + userId + "/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/athletes/" + userId + "/" + fileId,
		});
	};

	// Delete club athlete personal workout sheet
	self.deleteClubAthleteWorkoutSheet = function (userId, clubId, fileId) {
		return utilities.defaultDelete({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/athletes/" + userId + "/" + fileId, */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/athletes/" + userId + "/" + fileId,
		});
	};


	// List club files shared with athletes - File di club o schede condivisi con tutti gli atleti.  
	self.listClubSharedFiles = function (clubId, folder) { // folder "programs" o "workouts" / opzionale (ritorna entrambi)
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/shares";
		url += folder ? "/" + folder : "";
		return utilities.defaultGet({
			url: url, 
		});
	};


	// List user workout sheets as files (profilo utente tab workouts)
	self.getAthleteWorkoutSheets = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/files/workoutsheets",
		});
	};

	// make Public (visible to all club members) club wks
	self.setClubWorkoutSheetsPublic = function (clubId, workoutSheetIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets:batchSetPublic",
			payload: JSON.stringify(workoutSheetIds),
			forceJson: true,
		});
	};

	// make Public (visible to all club members) Uptivo wks
	self.setUptivoWorkoutSheetsPublic = function (clubId, workoutSheetIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/uptivo:batchSetPublic",
			payload: JSON.stringify(workoutSheetIds),
			forceJson: true,
		});
	};

	// make Unpublic (hide to all club members) a wks
	self.unsetClubFilePublic = function (clubId, workoutSheetIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files:batchUnsetPublic",
			payload: JSON.stringify(workoutSheetIds),
			forceJson: true,
		});
	};

	// Upload an image for classes
	self.uploadClubClassImage = function (clubId, calendarType, imageFileBLob) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/" + calendarType + "/pictures/",
			payload: utilities.blobToFormData(imageFileBLob),
			isRaw: true
		});
	}

	// List images for classes
	self.getClubClassImages = function (clubId, calendarType) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/" + calendarType + "/pictures",
		});
	};
	
	// Remove an image for classes
	self.deleteClubClassImage = function (clubId, calendarType, pictureId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/classes/calendars/" + calendarType + "/pictures/" + pictureId,
		});
	};
	

	// Get club transactions (for movements page)
	self.getClubTransactions = function (clubId, from, to, presetRange, count) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/transactions";
		var query = [];

		if (presetRange) {
			query.push("presetRange=" + presetRange);
		} else {
			query.push("from=" + from);
			query.push("to=" + to);
		}

		if (count) {
			query.push("count=" + count);
		}

		if (query.length) {
			url += "?" + query.join("&");
		}

		return utilities.defaultGet({
			url: url,
		});

	};

	// Prevent athlete booking until date in club (set by user profile)
	self.updateAthleteNoBookingsUntil = function (clubId, userId, noBookingsUntilDate) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/NoBookingsUntil",
			payload: JSON.stringify(noBookingsUntilDate),
		});
	};
	
	
	// Get bridge workouts for this club
	self.getBridgeWorkoutsCached = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/bridgeworkouts",
		});
	};


	// Get athlete booking block dates
	// NOT USED
	/*
	self.getAthleteNoBookingsUntilDates = function (userId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/athletes/" + userId + "/bookingblockdates",
		});
	};
	*/
	
	// Get athlete health dashboard
	self.getHealthDashboard = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/health/dashboard",
		});
	};
	
	// WORKOUT TEMPLATES
	
	// Replace all tags on a list of workout sheets
	self.updateClubWorkoutSheetsTags = function (clubId, model) {
		return utilities.defaultCreate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets/tags", */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + "/tags",
			payload: JSON.stringify(model),
		});
	};


	// Get club permissions from current license
	self.getClubCurrentLicensePermissions = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/licenses/current/permissions",
		});
	};

	// Delete workout sheets with a specified tag
	self.deleteClubWorkoutSheetsBatch = function (clubId, model) {
		return utilities.defaultCreate({
			/* url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/files/workoutsheets:batchDelete", */
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs/" + clubId + ":batchDelete",
			payload: JSON.stringify(model),
		});
	};


	// BRIDGE WORKOUTS

	// Replace all tags on a list of workout sheets
	self.updateBridgeWorkoutsTags = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/bridgeworkouts/tags",
			payload: JSON.stringify(model),
		});
	};

	// Delete workout sheets with a specified tag
	self.deleteBridgeWorkoutsBatch = function (clubId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/bridgeworkouts:batchDelete",
			payload: JSON.stringify(model),
		});
	};

	// Get club policies
	self.getClubPolicies = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/policies",
		});
	};

	// Get club kioks
	self.getClubkiosks = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/kiosks",
		});
	};
	
	// get workout executions
	self.getClubWorkoutSheetsRunsSummaries = function(clubId, from, to, count) {
		return utilities.defaultGet({
			url:
			CONFIGURATION.CLUBS_ENDPOINT +
			"/" +
			clubId +
			"/calendar/workoutsheetsruns?from=" +
			(from ? from.toISOString() : "") +
			"&to=" +
			(to ? to.toISOString() : "") +
			(count ? "&count=" + count : "")
		})
	};

	// Set specified athlete Nate settings in club
	self.setClubAthleteNateSettings = function (clubId, userId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/" + userId + "/nate/settings",
			payload: JSON.stringify(model),
		});
	};

	// Get club Equipments
	self.getClubEquipments = function (clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/equipments",
		});
	};

	// Resend email for an existing invitation
	self.sendEmailForInvitation = function (clubId, userId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitations:sendEmail?userId=" + userId,
		});
	};

	// Resend email for a pending user
	self.sendEmailForPendingUsers = function (clubId, userId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/pending:sendEmail?userId=" + userId,
		});
	};

	// Resend and invitation link email
	self.sendEmailForInvitationLink = function (clubId, email) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitationLinks:sendEmail?email=" + email,
		});
	};

	// Delete invitation link
	self.deleteClubInvitationLink = function (clubId, email) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/invitationLinks/" + email,
		});
	};


	// Get athletes health rankings data
	self.getClubHealthRankings = function (clubId, from, to) {
		var url = CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/athletes/rankings/health";
		var query = [];

		if (from) {
			if (!to) {
				query.push("presetRange=" + from);
			} else {
				query.push("from=" + from.toISOString() + "&to=" + to.toISOString());
			}
		}

		if (query.length) {
			url += "?" + query.join("&");
		}

		return utilities.defaultGet({
			url: url,
		});
	};



}

var clubsService = new ClubsService();

function DevicesService() {
	var self = this;

	self.createGenericDevice = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.GENERIC_DEVICES_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	self.getGenericDevice = function(deviceId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GENERIC_DEVICES_ENDPOINT + "/" + deviceId
		});
	};

	self.updateGenericDevice = function(model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.GENERIC_DEVICES_ENDPOINT + "/" + model.GenericDeviceId,
			payload: JSON.stringify(model)
		});
	};

	self.deleteGenericDevice = function(model) {
		return utilities.defaultDelete({
			url: CONFIGURATION.GENERIC_DEVICES_ENDPOINT + "/" + model.GenericDeviceId
		});
	};
}

var devicesService = new DevicesService();

function UptivoBridgeManager() {
	var self = this;

	self.updateRequests = 0;
	self.fastUpdateRequests = 0;
	self.clubId = ko.observable();
	self.devices = ko.observableArray();

	self.loadingOp = ko.observable();
	self.loading = ko.pureComputed(function () {
		return !!self.loadingOp();
	});

	self.online = ko.pureComputed(function () {
		return _.filter(self.devices(), function (d) {
			return d.Ping() === "Connected";
		});
	});

	self.recentbridges = ko.pureComputed(function () {
		return _.filter(self.devices(), function (d) {
			return moment().diff(d.LastOnline(), "day") <= 15;
		});
	});

	self.offline = ko.pureComputed(function () {
		return _.filter(self.recentbridges(), function (d) {
			return _.includes(["Offline", "Partial"], d.OnlineStatus());
		});
	});

	self.deviceErrors = ko.pureComputed(function () {
		var online = self.online();
		var offline = self.offline();

		var errors = [];

		// Not online or partial connection
		if (_.some(offline)) {
			errors.push("not-online");
		}

		// Online without ANT present
		if (
			_.some(online, function (d) {
				return !d.AntPresent();
			})
		) {
			errors.push("ant-disconnected");
		}

		// Online with number of seen nodes < online nodes (excluded self)
		if (
			_.some(online, function (d) {
				return _.isArray(d.ConnNodes()) && _.size(d.ConnNodes()) < _.size(online) - 1;
			})
		) {
			errors.push("disconnected-nodes");
		}

		// Had some network problem in the last hour
		if (
			_.some(online, function (d) {
				return _.isString(d.LastError()) && moment().subtract(1, "h").isBefore(d.LastError());
			})
		) {
			errors.push("error-last-hour");
		}

		return errors;
	});

	self.QuickConnectDevice = ko.pureComputed(function () {
		return _.first(
			_.sortBy(
				_.filter(self.devices(), function (d) {
					return d.Connect() != null;
				}),
				["UptivoBridgeId"]
			)
		);
	});

	self.QuickConnectUrl = ko.pureComputed(function () {
		var cd = self.QuickConnectDevice();
		return cd ? cd.Connect().Url : null;
	});

	function setDeviceStats(device, data) {
		var lastOnline = data.PingLastOnlineTime || data.IoTLastOnlineTime;

		var onlineStatus;
		if (data.PingConnectionState === "Connected" /* && data.IoTConnectionState === "Connected" */ && (!_.isInteger(data.CldErrors) || data.CldErrors == 0)) {
			onlineStatus = "Online";
		} else if (data.PingConnectionState !== "Connected" /* && data.IoTConnectionState !== "Connected" */) {
			onlineStatus = "Offline";
		} else {
			onlineStatus = "Partial";
		}
		device.OnlineStatus(onlineStatus);

		var systemStatus;
		if (_.isBoolean(data.AntPresent) && data.AntPresent && _.isBoolean(data.Processes) && data.Processes) {
			systemStatus = "Ok";
		} else if (_.isBoolean(data.AntPresent) || _.isBoolean(data.Processes)) {
			systemStatus = "Problem";
		}
		device.SystemStatus(systemStatus);

		var addr = data.EthAddress || data.WiFiAddress;
		device.Connect(
			onlineStatus != "Offline" && !!addr
				? {
						Url: "http://" + addr,
						VerifiedAt: moment(lastOnline),
				  }
				: null
		);

		device.SwVersion(data.SwVersion);
		device.EthAddress(data.EthAddress);
		device.WiFiAddress(data.WiFiAddress);
		device.LastOnline(lastOnline);
		device.AntPresent(data.AntPresent);
		device.AppUp(data.AppUp);
		device.CldErrors(data.CldErrors);
		device.CldTotalErrors(data.CldTotalErrors);
		device.HDMI1(data.HDMI1);
		device.HDMI2(data.HDMI2);
		device.HostUp(data.HostUp);
		device.HwVersion(data.HwVersion);
		device.LastError(data.LastError);
		device.LastGood(data.LastGood);
		device.OsVersion(data.OsVersion);
		device.Processes(data.Processes);
		device.WiFiSSID(data.WiFiSSID);
		device.Ping(data.PingConnectionState);
		device.IoT(data.IoTConnectionState);
		device.IsMaster(data.IsMaster);
		device.ConnNodes(data.ConnNodes);
	}

	function networkAddressToList(addressesList) {
		if (addressesList) {
			return _.filter(_.map(addressesList.split("; "), _.trim), function (el) {
				return /^[\d]+\.[\d]+\.[\d]+\.[\d]+$/.test(el);
			});
		}

		return null;
	}

	function updateDevicesStats() {
		var devices = self.devices();

		var deferredList = _.map(devices, function (device) {
			return clubsService
				.getUptivoBridgeState(device.UptivoBridgeId)
				.done(function (data) {
					setDeviceStats(device, data);
				})
				.always(function () {
					device.IPAddresses(networkAddressToList(device.NetworkAddress));
				});
		});

		return $.whenAll(deferredList);
	}

	function updateDevicesFromApiResponse(apiResponse, noStats) {
		var devices = self.devices();

		var added = _.differenceBy(apiResponse, devices, "UptivoBridgeId");
		var removed = _.differenceBy(devices, apiResponse, "UptivoBridgeId");
		var updated = _.intersectionBy(apiResponse, devices, "UptivoBridgeId");

		// Remove removed
		self.devices.remove(function (device) {
			return _.includes(_.map(removed, "UptivoBridgeId"), device.UptivoBridgeId);
		});

		// Add added
		_.each(added, function (data) {
			self.devices.push({
				UptivoBridgeId: data.UptivoBridgeId,
				HardwareId: data.HardwareId,
				ClubId: data.ClubId,
				CreatedAt: data.CreatedAt,
				Model: data.Model,
				NetworkAddress: data.NetworkAddress,
				DisplayGroupId: ko.observable(data.DisplayGroupId),
				Name: ko.observable(data.Name),
				Station: ko.observable(data.Station),

				SwVersion: ko.observable(),
				EthAddress: ko.observable(),
				WiFiAddress: ko.observable(),
				OnlineStatus: ko.observable(),
				SystemStatus: ko.observable(),
				LastOnline: ko.observable(),
				Connect: ko.observable(),
				IPAddresses: ko.observable(),
				AntPresent: ko.observable(),
				AppUp: ko.observable(),
				CldErrors: ko.observable(),
				CldTotalErrors: ko.observable(),
				HDMI1: ko.observable(),
				HDMI2: ko.observable(),
				HostUp: ko.observable(),
				HwVersion: ko.observable(),
				LastError: ko.observable(),
				LastGood: ko.observable(),
				OsVersion: ko.observable(),
				Processes: ko.observable(),
				WiFiSSID: ko.observable(),
				IoT: ko.observable(),
				Ping: ko.observable(),
				IsMaster: ko.observable(),
				ConnNodes: ko.observableArray(),
			});
		});

		// Update updated
		_.each(updated, function (data) {
			var ex = _.find(devices, { UptivoBridgeId: data.UptivoBridgeId });
			if (ex) {
				ex.Name(data.Name);
				ex.DisplayGroupId(data.DisplayGroupId);
			}
		});

		if (noStats) {
			return $.Deferred().resolve([]);
		}

		return updateDevicesStats();
	}

	function updateDevicesFromApi(clubId, noStats) {
		if (self.clubId() == clubId && self.loadingOp()) return;
		self.clubId(clubId);
		var op = clubsService
			.getDevices(clubId)
			.done(function (res) {
				if (self.loadingOp() == op) {
					return updateDevicesFromApiResponse(res, noStats);
				}
			})
			.always(function () {
				if (self.loadingOp() == op) {
					self.loadingOp(null);
				}
			});
		self.loadingOp(op);
	}

	self.UpdateDevices = function (clubId, noStats) {
		updateDevicesFromApi(clubId, noStats);
		self.updateCycle = 1;
		restartInterval();
	};

	function _clearInterval() {
		clearTimeout(self.updateInterval);
		self.updateInterval = null;
	}

	function stopUpdateInterval() {
		if (self.updateInterval) {
			_clearInterval();
		}
	}

	function _setInterval() {
		var delay = (self.fastUpdateRequests ? 10 : 30) * 1000;

		self.updateInterval = setTimeout(function () {
			var op;

			if (!(self.updateCycle % 9)) {
				op = updateDevicesFromApi(self.clubId());
				self.updateCycle = 0;
			} else if (!(self.updateCycle % 3)) {
				op = updateDevicesStats();
			}

			self.updateCycle++;

			_setInterval();
		}, delay);
	}

	function restartInterval() {
		if (self.updateInterval) {
			_clearInterval();
			_setInterval();
		}
	}

	function startUpdateInterval() {
		if (!self.updateInterval) {
			self.updateCycle = 0;
			_setInterval();
		}
	}

	self.StartAutoUpdates = function (fast) {
		if (fast) {
			self.fastUpdateRequests++;
		} else {
			self.updateRequests++;
		}

		if (self.updateRequests + self.fastUpdateRequests > 0) {
			startUpdateInterval();
		}
	};

	self.StopAutoUpdates = function (fast) {
		if (fast) {
			self.fastUpdateRequests--;
		} else {
			self.updateRequests--;
		}

		if (self.updateRequests + self.fastUpdateRequests == 0) {
			stopUpdateInterval();
		}
	};
}

var ubManager = new UptivoBridgeManager();

function TrainingsService() {
	var self = this;

	self.getNextTrainingForUser = function(currentTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + currentTrainingId + "/next",
			ignoreCodes: [404]
		});
	};

	self.getPreviousTrainingForUser = function(currentTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + currentTrainingId + "/prev",
			ignoreCodes: [404]
		});
	};

	self.getTrainingById = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + id
		});
	};

	self.getSharingUri = function(id) {
		return utilities.defaultGet({
			async: false,
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + id + "/sharedUri"
		});
	};

	self.sharedTrainingWithEmail = function(id, email, name) {
		return utilities.defaultCreate({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + id + ":shareWithEmail",
			payload: JSON.stringify({
				Email: email,
				Name: name
			})
		});
	};

	self.getHeartbeats = function(training) {
		return userService.getHeartbeats(training.UserId, moment(training.Begin), moment(training.End));
	};

	self.getGeopositions = function(training) {
		return userService.getGeopositions(training.UserId, moment(training.Begin), moment(training.End));
	};

	self.getPower = function(training) {
		return userService.getPower(training.UserId, moment(training.Begin), moment(training.End));
	};

	self.getCadence = function(training) {
		return userService.getCadence(training.UserId, moment(training.Begin), moment(training.End));
	};

	self.getHits = function(training) {
		return userService.getHits(training.UserId, moment(training.Begin), moment(training.End));
	};

	self.getSubTrainings = function(training) {
		return utilities.defaultGet({
				url:
					CONFIGURATION.USERS_ENDPOINT +
					"/" +
					training.UserId +
					"/calendar/trainings?from=" +
					moment(training.Begin).toISOString() +
					"&to=" +
					moment(training.End).toISOString() +
					"&sub=Sub"
			});
	};

	self.getTrainingTotalsForDateRange = function(clubId, from, to, origin) {
		return utilities.defaultGet({
			url: 
			CONFIGURATION.CLUBS_ENDPOINT +
			"/" +
			clubId +
			"/athletes/trainings/totals?from=" +
			moment(from).toISOString() +
			"&to=" +
			moment(to).toISOString() +
			"&origin=" +
			origin
		});
	};

	self.getTrainingsForDate = function(clubId, from, to) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.CLUBS_ENDPOINT +
				"/" +
				clubId +
				"/calendar/trainings?from=" +
				from.toISOString() +
				"&to=" +
				to.toISOString()
		});
	};

	self.getGroupTrainingsForDate = function(clubId, from, to) {
		return utilities.defaultGet({
			url:
				CONFIGURATION.CLUBS_ENDPOINT +
				"/" +
				clubId +
				"/calendar/grouptrainings?from=" +
				from.toISOString() +
				"&to=" +
				to.toISOString()
		});
	};

	self.getTrainingComments = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId + "/comments"
		});
	};

	self.getTrainingFeedbacks = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId + "/feedbacks"
		});
	};

	self.getTrainingFeedbacksWithoutNate = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId + "/feedbacks?excludeNate=true"
		});
	};

	self.getNateTrainingFeedbacks = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId + "/feedbacks/nate",
			ignoreCodes: [400, 403]
		});
	};

	self.generateTrainingNateFeedback = function(trainingId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId + "/feedbacks/nate:generate",
		});
	};

	self.updateTraining = function(trainingId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId,
			payload: ko.toJSON(model, function(key, value) {
				return value;
			})
		});
	};

	self.deleteTraining = function(trainingId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.TRAININGS_ENDPOINT + "/" + trainingId
		});
	};

	self.getGroupTrainingTotals = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + trainingId
		});
	};

	self.getTrainingsInGroup = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + trainingId + "/trainings/summaries"
		});
	};

	self.getGroupTrainingsWithSummaries = function(trainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + trainingId + "/withSummaries"
		});
	};

	self.getNextGroupTrainingForClubWithSummaries = function(groupTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + groupTrainingId + "/withsummaries/next",
			ignoreCodes: [404]
		});
	};

	self.getPreviousGroupTrainingForClubWithSummaries = function(groupTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + groupTrainingId + "/withsummaries/prev",
			ignoreCodes: [404]
		});
	};

	self.updateGroupTraining = function(groupTrainingId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.GROUP_TRAININGS_ENDPOINT + "/" + groupTrainingId,
			payload: ko.toJSON(model, function(key, value) {
				return value;
			})
		});
	};
}

var trainingsService = new TrainingsService();

function CountryService(utils) {
	var self = this;

	this.endpoint = "/api/Countries";

	this.getAll = function (language) {
		return utils.defaultGet({
			url: "{0}/Names?language={1}".format(self.endpoint, language)
		});
	}
}

if (typeof module !== "undefined" && module.hasOwnProperty("exports")) {
	module.exports = CountryService;
}
function NotificationService() {
	var self = this;

	self.getNotifById = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.NOTIFICATIONS_ENDPOINT + "/" + id
		});
	};

	self.removeNotif = function(notification) {
		return utilities.defaultDelete({
			url: CONFIGURATION.NOTIFICATIONS_ENDPOINT + "/" + notification.NotificationId
		});
	};

	self.updateNotifState = function(id, state) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.NOTIFICATIONS_ENDPOINT + "/" + id
		});
	};

	self.getUserNotifications = function(userId, query) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/notifications" + (query ? query : "")
		});
	};

	self.getNewestUserNotifications = function(userId, query) {
		return utilities.defaultGet({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/notifications/newest" + (query ? query : "")
		});
	};

	self.removeUserNotifications = function(userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/notifications",
			success: function() {
				eventBus.publish("notifications:delete");
			}
		});
	};

	self.updateUserNotificationsState = function(userId, state) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.USERS_ENDPOINT + "/" + userId + "/notifications/state",
			payload: JSON.stringify(state),
			success: function() {
				eventBus.publish("notifications:update:state:all", state);
			}
		});
	};
}

var notificationsService = new NotificationService();

function TimeZoneService(utils) {
    var self = this;

    this.endpoint = "/api/TimeZones";
    this.countryEndpoint = "/api/Countries"; 

    this.getAll = function () {
        return utils.defaultGet({
            url: "{0}/Names".format(self.endpoint)
        });
    }

    this.getAllByCountry = function (language, countryId) {
        if (!countryId)
            return;
        return utils.defaultGet({
            url: "{0}/{1}/Timezones?language={2}".format(self.countryEndpoint, countryId, language)
        });
    }
    
}

if (typeof module !== "undefined" && module.hasOwnProperty("exports")) {
    module.exports = TimeZoneService;
}
function ClubRankingsService() {
	var self = this;

	self.createRankings = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_RANKINGS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	}

	self.updateRankings = function (rankingsKey, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_RANKINGS_ENDPOINT + "/" + rankingsKey,
			payload: JSON.stringify(model)
		});
	}

	self.deleteRankings = function (rankingsKey) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_RANKINGS_ENDPOINT + "/" + rankingsKey
		});
	}

}

var clubRankingsService = new ClubRankingsService();
function TimerService() {
	var self = this;

	self.createCircuitTimer = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CIRCUIT_TIMERS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	self.getCircuitTimer = function(timerId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CIRCUIT_TIMERS_ENDPOINT + "/" + timerId
		});
	};

	self.updateCircuitTimer = function(timerId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CIRCUIT_TIMERS_ENDPOINT + "/" + timerId,
			payload: ko.toJSON(model, function(key, value) {
				return value;
			})
		});
	};

	self.deleteCircuitTimer = function(timerId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CIRCUIT_TIMERS_ENDPOINT + "/" + timerId
		});
	};
}

var timerService = new TimerService();

function WorkoutDefinitionsService() {
	var self = this;

	self.listWorkoutDefinitions = function (clubId, brandId, lang) {
		var data = {};
		if (clubId) {
			data.clubId = clubId
		}
		if (brandId) {
			data.brandId = brandId
		}
		if (lang) {
			data.lang = lang
		}

		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT,
			data: data
		});
	}

	self.listWorkoutDefinitionsDetails = function (clubId, brandId, lang) {
		var data = {};
		if (clubId) {
			data.clubId = clubId
		}
		if (brandId) {
			data.brandId = brandId
		}
		if (lang) {
			data.lang = lang
		}

		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/details",
			data: data
		});
	}

	self.getWorkoutDefinition = function (workoutDefinitionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutDefinitionId
		});
	}

	self.saveWorkoutDefinition = function (workoutDefinition) {
		if (workoutDefinition.WorkoutDefinitionId) {
			return utilities.defaultUpdate({
				url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutDefinition.WorkoutDefinitionId,
				payload: JSON.stringify(workoutDefinition)
			});
		} else {
			return utilities.defaultCreate({
				url: CONFIGURATION.WORKOUTDEFS_ENDPOINT,
				payload: JSON.stringify(workoutDefinition)
			});
		}
	}

	self.createWorkoutDefinitionVideoUploadUri = function (workoutVideo, S3UploadPreSignedUrlDTO) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutVideo.WorkoutDefinitionId + "/videos/" + workoutVideo.WorkoutVideoId+ ":createUploadUri",
			payload: JSON.stringify(S3UploadPreSignedUrlDTO)
		});
	}

	self.setWorkoutDefinitionVideoUploadCompleted = function (workoutVideo) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutVideo.WorkoutDefinitionId + "/videos/" + workoutVideo.WorkoutVideoId+ ":completeUpload"
		});
	}

	self.updateWorkoutVideo = function (workoutVideo) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutVideo.WorkoutDefinitionId + "/videos/" + workoutVideo.WorkoutVideoId,
			payload: JSON.stringify(workoutVideo)
		});
	}

	self.deleteWorkoutDefinition = function (workoutDefinitionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/" + workoutDefinitionId
		});
	}

	self.publishWorkoutDefinitions = function (workoutDefinitionIds) {

		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + ":batchPublish",
			payload: JSON.stringify(workoutDefinitionIds)
		});
	}

	self.unpublishWorkoutDefinitions = function (workoutDefinitionIds) {

		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTDEFS_ENDPOINT + ":batchUnpublish",
			payload: JSON.stringify(workoutDefinitionIds)
		});
	}

	self.uploadWorkoutDefinitionImage = function (clubId, brandId, imageFileBLob) {

		var url = CONFIGURATION.WORKOUTDEFS_ENDPOINT + "/pictures/"

		if (brandId) {
			url += "brands/" + brandId
		} else if (clubId) {
			url += "clubs/" + clubId
		} else {
			url += "uptivo"
		}

		return utilities.defaultCreate({
			url: url,
			payload: utilities.blobToFormData(imageFileBLob),
			isRaw: true
		});
	}


}

var workoutDefsService = new WorkoutDefinitionsService();
function SystemMeasuresService() {
	var self = this;

	self._getFromApi = function () {
		return utilities.defaultGet({
			url: CONFIGURATION.MEASURE_TYPES_ENDPOINT
		});
	}

	self.get = function () {
		var dfd = $.Deferred();

		if (self.measures) {
			dfd.resolve(self.measures);
		} else {
			self._getFromApi()
				.done(function (types) {
					self.measures = types;
				})
				.always(function () {
					dfd.resolve(self.measures);
				});
		}

		return dfd.promise();
	}
}

var systemMeasuresService = new SystemMeasuresService();
function CommentsService() {
	var self = this;

	self.createTrainingComment = function (commentData) {
		return utilities.defaultCreate({
			url: CONFIGURATION.TRAINING_COMMENTS_ENDPOINT,
			payload: JSON.stringify(commentData)
		});
	};

	self.updateTrainingComment = function (id, commentData) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.TRAINING_COMMENTS_ENDPOINT + '/' + id,
			payload: JSON.stringify(commentData)
		});
	}

	self.deleteTrainingComment = function (id, getAuthorData) {
		return utilities.defaultDelete({
			url: CONFIGURATION.TRAINING_COMMENTS_ENDPOINT + '/' + id + (getAuthorData ? '/?getAuthorData=true' : '')
		});
	};


	self.askNateGenerateTrainingFeedback = function (trainingId) {
		return utilities.defaultCreate({
			url: "/api/ai/trainings/" + trainingId + "/feedbacks:generate?generatorVersion=2",
		});
	};


	self.createTrainingFeedback = function (feedbackData) {
		return utilities.defaultCreate({
			url: CONFIGURATION.TRAINING_FEEDBACKS_ENDPOINT,
			payload: JSON.stringify(feedbackData)
		});
	};

	self.updateTrainingFeedback = function (id, feedbackData) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.TRAINING_FEEDBACKS_ENDPOINT + '/' + id,
			payload: JSON.stringify(feedbackData)
		});
	}

	self.deleteTrainingFeedback = function (id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.TRAINING_FEEDBACKS_ENDPOINT + '/' + id
		});
	};
}

var commentsService = new CommentsService();
function MeasuresService() {
	var self = this;

	self.getMeasureGroup = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.USER_MEASURES_ENDPOINT + "/groups/" + id
		});
	};

	self.deleteMeasureGroup = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.USER_MEASURES_ENDPOINT + "/events/" + id
		});
	};

	self.addMeasureGroup = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USER_MEASURES_ENDPOINT + "/groups",
			payload: JSON.stringify(model)
		});
	};

	self.createBatchMeasures = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.USER_MEASURES_ENDPOINT + "/groups:batchCreate",
			payload: JSON.stringify(model)
		});
	};
}

var measuresService = new MeasuresService();

function UnitsConversionService() {
	var self = this;

	var _defaultUnits = [
		{
			Quantity: "length",
			MetricUnit: ["cm", "centimeter", "centimeters"],
			ImperialUnit: ["in", "inch", "inches"]
		},
		{
			Quantity: "length",
			MetricUnit: ["km", "kilometer", "kilometers"],
			ImperialUnit: ["mi", "mile", "miles"]
		},
		{
			Quantity: "length",
			MetricUnit: ["m", "meter", "meters"],
			ImperialUnit: ["ft", "foot", "feet"]
		},
		{
			Quantity: "length",
			MetricUnit: ["mm", "millimeter", "millimeters"],
			ImperialUnit: ["in", "inch", "inches"]
		},
		{
			Quantity: "mass",
			MetricUnit: ["kg", "kilogram", "kilograms"],
			ImperialUnit: ["lbs", "lb", "pound", "pounds"]
		},
		{
			Quantity: "ratio",
			MetricUnit: ["%", "percent"],
			ImperialUnit: ["%", "percent"]
		},
		{
			Quantity: "pressure",
			MetricUnit: ["mmHg", "millimeterofmercury"],
			ImperialUnit: ["mmHg", "millimeterofmercury"]
		},
		{
			Quantity: "frequency",
			MetricUnit: ["bpm", "beatperminute"],
			ImperialUnit: ["bpm", "beatperminute"]
		},
		{
			Quantity: "density",
			MetricUnit: ["mg/dL", "milligramperdeciliter"],
			ImperialUnit: ["mg/dL", "milligramperdeciliter"]
		},
		{
			Quantity: "energy",
			MetricUnit: ["kcal", "kilocalorie"],
			ImperialUnit: ["kcal", "kilocalorie"]
		},
		{
			Quantity: "speed",
			MetricUnit: ["km/h", "KilometerPerHour"],
			ImperialUnit: ["mph", "MilesPerHour"]
		}
	];

	function _tryParseUnit(fromUnit) {
		var fu = fromUnit.split(".");

		if (fu.length > 2) {
			return null;
		}

		if (fu.length == 2) {
			return {
				QuantityName: fu[0],
				UnitName: fu[1]
			};
		}

		return {
			UnitName: fu[0].toLowerCase()
		};
	}

	function _getUnitTypes(quantityName, unitName) {
		for (var u = 0; u < _defaultUnits.length; ++u) {
			if (!quantityName || quantityName.toLowerCase() == _defaultUnits[u].Quantity.toLowerCase()) {
				var idx;

				idx = _.map(_defaultUnits[u].MetricUnit, function(el) {
					return el.toLowerCase();
				}).indexOf(unitName.toLowerCase());
				if (idx != -1) {
					return {
						Quantity: _defaultUnits[u].Quantity,
						FromUnitSystem: ENUMS.UNITS.METRIC,
						MatchedUnit: _defaultUnits[u].MetricUnit[idx],
						ConversionUnit: _defaultUnits[u].MetricUnit[0],
						MetricUnit: _defaultUnits[u].MetricUnit,
						ImperialUnit: _defaultUnits[u].ImperialUnit
					};
				}

				if (
					_.map(_defaultUnits[u].ImperialUnit, function(el) {
						return el.toLowerCase();
					}).indexOf(unitName.toLowerCase()) != -1
				) {
					return {
						Quantity: _defaultUnits[u].Quantity,
						FromUnitSystem: ENUMS.UNITS.IMPERIAL,
						MatchedUnit: _defaultUnits[u].ImperialUnit[idx],
						ConversionUnit: _defaultUnits[u].ImperialUnit[0],
						MetricUnit: _defaultUnits[u].MetricUnit,
						ImperialUnit: _defaultUnits[u].ImperialUnit
					};
				}
			}
		}

		return null;
	}

	self.Convert = function(fromValue, fromUnit, toUnitSystem) {
		var fromUnitData = _tryParseUnit(fromUnit);
		if (fromUnitData) {
			var unitTypes = _getUnitTypes(fromUnitData.QuantityName, fromUnitData.UnitName, toUnitSystem);
			if (unitTypes) {
				var qty = Qty.parse(fromValue + unitTypes.ConversionUnit);
				if (qty) {
					var toUnit = toUnitSystem == ENUMS.UNITS.METRIC ? unitTypes.MetricUnit[0] : unitTypes.ImperialUnit[0];
					var toValue = qty.to(toUnit);

					return {
						Qty: toValue,
						Unit: toValue.units(),
						Value: toValue.scalar
					};
				}
			}
		}

		var abbr = fromUnitData ? fromUnitData.UnitName : fromUnit;
		if (abbr == "DecimalFraction") {
			abbr = "";
		}
		
		return {
			Value: fromValue,
			Unit: abbr
		};
	};

	self.ConvertUnit = function(fromUnit, toUnitSystem) {
		var unit = self.Convert(1, fromUnit, toUnitSystem);
		return unit.Unit;
	};

	self.ToFeetInchesString = function(qty) {
		if (qty.kind() == "length") {
			var FeetToInches = 12;
			var totalInches = qty.to("inch");
			var wholeFeet = Math.floor(totalInches.scalar / FeetToInches);
			var inches = totalInches.scalar % FeetToInches;
			return "{0}'{1}\"".format(wholeFeet, inches.toFixed(0));
		}

		return qty.scalar.toFixed(1);
	};
}

var unitsConversionService = new UnitsConversionService();

function ClubSensorsService() {
	var self = this;

	self.createClubSensor = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBSENSORS_ENDPOINT,
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};

	self.getClubSensor = function (clubSensorId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBSENSORS_ENDPOINT + "/" + clubSensorId
		});
	};

	self.updateClubSensor = function (clubSensorId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUBSENSORS_ENDPOINT + "/" + clubSensorId,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			}),
			ignoreCodes: [409]
		});
	};

	self.deleteClubSensor = function (clubSensorId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBSENSORS_ENDPOINT + "/" + clubSensorId
		});
	};
}

var clubSensorsService = new ClubSensorsService();
function IntensityFlowsService() {
	var self = this;

	self.createIntensityFlow = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.INTENSITYFLOWS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	}

	self.getIntensityFlow = function (intensityFlowId) {
		return utilities.defaultGet({
			url: CONFIGURATION.INTENSITYFLOWS_ENDPOINT + '/' + intensityFlowId
		});
	}

	self.updateIntensityFlow = function (intensityFlowId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.INTENSITYFLOWS_ENDPOINT + '/' + intensityFlowId,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			})
		});
	}

	self.deleteIntensityFlow = function (intensityFlowId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.INTENSITYFLOWS_ENDPOINT + '/' + intensityFlowId
		});
	}
};

var intensityFlowsService = new IntensityFlowsService();
function SlideShowsService() {
	var self = this;

	self.createSlideShow = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	}

	self.getSlideShow = function (slideShowId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId
		});
	}

	self.updateSlideShow = function (slideShowId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			})
		});
	}

	self.deleteSlideShow = function (slideShowId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId
		});
	}

	
	self.uploadSlideShowImage = function (slideShowId, duration, order, blob) {
		var data = utilities.blobToFormData(blob);
		
		data.append('Duration', duration);
		data.append('Order', order);

		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId + '/pictures/',
			payload: data,
			isRaw: true
		});
	}

	self.deleteSlideShowImage = function (slideShowId, pictureId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId + '/pictures/' + pictureId
		});
	}

	self.updateSlideShowImageData = function (slideShowId, pictureId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUBSLIDESHOWS_ENDPOINT + '/' + slideShowId + '/pictures/' + pictureId,
			payload: ko.toJSON(model, function (key, value) {
				return value;
			})
		});
	}
};

var slideShowsService = new SlideShowsService();
function ClubTagsService() {
	var self = this;

	self.createClubTag = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_TAGS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	self.getClubTag = function(clubTagId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_TAGS_ENDPOINT + "/" + clubTagId
		});
	};

	self.updateClubTag = function(clubTagId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_TAGS_ENDPOINT + "/" + clubTagId,
			payload: ko.toJSON(model, function(key, value) {
				return value;
			})
		});
	};

	self.deleteClubTag = function(clubTagId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_TAGS_ENDPOINT + "/" + clubTagId
		});
	};

	self.assignClubTags = function(clubId, clubTagIds, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/tags:batchCreate",
			payload: JSON.stringify({
				ClubTagIds: clubTagIds,
				UserIds: userIds
			})
		});
	};

	self.removeClubTags = function(clubId, clubTagIds, userIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/users/tags:batchDelete",
			payload: JSON.stringify({
				ClubTagIds: clubTagIds,
				UserIds: userIds
			})
		});
	};
}

var clubTagsService = new ClubTagsService();

function Services() {
	var self = this;

	self.init = function() {
		serviceLocator.set("countryService", new CountryService(serviceLocator.get("utilities")));
		serviceLocator.set("timeZoneService", new TimeZoneService(serviceLocator.get("utilities")));
	};
}

function LiveService() {
	var self = this;

	self.createLiveTraining = function(hostId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training",
			payload: JSON.stringify(model),
			ignoreCodes: [409, 424]
		});
	};

	self.getLiveTraining = function(hostId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training",
			ignoreCodes: [404]
		});
	};

	self.deleteLiveTraining = function(hostId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training"
		});
	};

	self.deleteLiveTrainingByLiveId = function(liveId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_TRAINING_ENDPOINT + "/" + liveId
		});
	};


	self.addParticipantsList = function(hostId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training/participants:batchCreate",
			payload: JSON.stringify(model)
		});
	};

	self.getParticipantsList = function(hostId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training/participants",
			ignoreCodes: [404]
		});
	};

	self.deleteSingleParticipant = function(hostId, userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_HOST_ENDPOINT + "/" + hostId + "/training/participants/" + userId
		});
	};


}

var liveService = new LiveService();

function RecurrentLiveTrainingService() {
	var self = this;

	self.createRecurrentLiveTraining = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT,
			payload: JSON.stringify(model),
			ignoreCodes: []
		});
	};

	self.getRecurrentLiveTraining = function(recurrentLiveTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId,
			ignoreCodes: []
		});
	};

	self.deleteRecurrentLiveTraining = function(recurrentLiveTrainingId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId,
		});
	};

	self.deleteRecurrentLiveTrainingParticipants = function(recurrentLiveTrainingId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + "/participants",
		});
	};

	self.updateRecurrentLiveTraining = function(model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + model.RecurrentLiveTrainingId,
			payload: JSON.stringify(model),
			ignoreCodes: []
		});
	};

	self.setRecurrentLiveTrainingTrainerId = function(recurrentLiveTrainingId, trainerId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + "/TrainerId",
			payload: JSON.stringify(trainerId),
			ignoreCodes: []
		});
	};


	self.addParticipantsList = function(recurrentLiveTrainingId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + "/participants:batchCreate",
			payload: JSON.stringify(model)
		});
	};



	self.getParticipantsList = function(recurrentLiveTrainingId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + "/participants",
			ignoreCodes: []
		});
	};



	self.deleteSingleParticipant = function(recurrentLiveTrainingId, userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + "/participants/" + userId
		});
	};


	//club 
	self.getClubRecurrentLiveTrainings = function(clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUBS_ENDPOINT + "/" + clubId + "/live/recurrent",
			ignoreCodes: []
		});
	};


	self.startRecurrentLiveTraining = function(recurrentLiveTrainingId ) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_RECURRENT_ENDPOINT + "/" + recurrentLiveTrainingId + ":startLive",
			payload: JSON.stringify(),
			ignoreCodes: [409, 424]
		});
	};





}

var recurrentLiveTrainingsService = new RecurrentLiveTrainingService();

function ClassesService() {
	var self = this;

	self.createClass = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT,
			payload: JSON.stringify(model),
			ignoreCodes: [400]
		});
	};

	self.getClass = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId
		});
	};

	self.updateClass = function(model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + model.ClassId,
			payload: JSON.stringify(model),
			ignoreCodes: [409, 400]
		});
	};

	self.deleteClass = function(classId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId,
		});
	};

	self.deleteClasses = function(batchRequestDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchDelete",
			payload: JSON.stringify(batchRequestDto)
		});
	};

	self.updateClassPublishState = function(classId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/PublishState",
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};

	self.publishClasses = function(batchRequestDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchPublish",
			payload: JSON.stringify(batchRequestDto)
		});
	};

	self.unpublishClasses = function(batchRequestDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchUnpublish",
			payload: JSON.stringify(batchRequestDto)
		});
	};


	self.checkUpdateClasses = function(batchRequestDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchUpdateGetInfo",
			payload: JSON.stringify(batchRequestDto)
		});
	};

	self.updateClasses = function(batchUpdateWriteDto) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchUpdate",
			payload: JSON.stringify(batchUpdateWriteDto)
		});
	};



	self.getClassSchedules = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/schedules"
		});
	};

	self.getClassScheduledDays = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/scheduledDays"
		});
	};

	self.updateExceptionClassScheduledDays  = function(model, classId) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/scheduledDays",
			payload: JSON.stringify(model),
			ignoreCodes: [400]
		});
	};

	
	self.updateClassSchedule  = function(classId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/schedules",
			payload: JSON.stringify(model),
			ignoreCodes: [400]
		});
	};


	self.getClassParticipantsCount = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants/counts"
		});
	};

	self.getClassParticipants = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants"
		});
	};

	self.addUserParticipation  = function(classId, model, force) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants" + "?paymentMode=Auto&force=" + force,
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};

	self.updateUserParticipantState  = function(classId, userId, model, force) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants/" + userId + "/State?force=" + force,
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};


	self.deleteUserParticipation = function(classId, userId, force) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants/" + userId + "?force=" + force,
			ignoreCodes: [409]
		});
	};

	self.deleteAllUsersParticipation = function(classId, force, participantsMode) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants?force=" + force + (participantsMode ? "&mode=" + participantsMode : ""),
			ignoreCodes: [409]
		});
	};

	self.startClassLive = function(classId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.LIVE_CLASSES_ENDPOINT + "/" + classId + ":startLive",
			ignoreCodes: [409, 424]
		});
	};

	self.getClassSubscriptions = function(classId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/subscriptions"
		});
	};
	
	self.setClassSubscriptions  = function(classId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/subscriptions",
			payload: JSON.stringify(model)
		});
	};
	
	self.updateClassParticipantNoShow  = function(classId, userId, newNoShow) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/" + classId + "/participants/" + userId + "/NoShow",
			payload: JSON.stringify(newNoShow)
		});
	};

	self.checkUpdateAssociatedClassSubscriptions  = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/subscriptions:batchUpdateGetInfo",
			payload: JSON.stringify(model)
		});
	};
	
	self.updateAssociatedClassSubscriptions  = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + "/subscriptions:batchUpdate",
			payload: JSON.stringify(model)
		});
	};
	
	self.cloneClasses  = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLASSES_ENDPOINT + ":batchClone",
			payload: JSON.stringify(model)
		});
	};
	


}

var classesService = new ClassesService();

function PaymentsService() {
	var self = this;


	self.createClubPaymentAccount = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.PAYMENTS_ENDPOINT  + "/accounts",
			payload: JSON.stringify(model),
		});
	};

	self.deleteClubPaymentAccount = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.PAYMENTS_ENDPOINT + "/accounts/" + id
		});
	};
	
	self.createClubCreditsPackage = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.PAYMENTS_ENDPOINT + "/credits/packages",
			payload: JSON.stringify(model),
		});
	};

	self.deleteClubCreditsPackage = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.PAYMENTS_ENDPOINT + "/credits/packages/" + id
		});
	};
	
	self.createClubPaymentAccountOnboardingLink = function(accountId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.PAYMENTS_ENDPOINT +  '/accounts/' + accountId + '/onboarding'
		});
	};
	
	self.createOrder = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.PAYMENTS_ENDPOINT + "/orders",
			payload: JSON.stringify(model),
		});
	};

	self.sendStripeInvoiceEmail = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.PAYMENTS_ENDPOINT + "/stripe/invoices:sendEmail",
			payload: JSON.stringify(model),
			ignoreCodes: [404]
		});
	};
	
}

var paymentsService = new PaymentsService();

function CurrenciesService() {
	var self = this;

	self.getSupportedCurrencies = function() {
		return utilities.defaultGet({
			url: CONFIGURATION.CURRENCIES_ENDPOINT
		});
	};

	self.getSupportedCurrenciesNames = function(language) {
		return utilities.defaultGet({
			url: CONFIGURATION.CURRENCIES_ENDPOINT + "/names?language=" + language
		});
	};

}

var currenciesService = new CurrenciesService();

function ChallengesService() {
	var self = this;


	self.createChallenge = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT,
			payload: JSON.stringify(model),
			// ignoreCodes: [400]
		});
	};


	self.editChallenge = function(model, challengeId) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId,
			payload: JSON.stringify(model),
			// ignoreCodes: [400]
		});
	};
	
	
	self.getChallenge = function(challengeId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId
		});
	};
	
	
	self.deleteChallenge = function(challengeId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId
		});
	};

	
	self.setChallengeAwards = function(model, challengeId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/awards",
			payload: JSON.stringify(model),
			// ignoreCodes: [400]
		});
	};

	self.getChallengeAwards = function(challengeId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/awards",
		});
	};

	self.getChallengeRanking = function(challengeId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/rankings"
		});
	};
	
	self.updateChallengePublishState = function(classId, enabled) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + classId + "/Enabled",
			payload: JSON.stringify(enabled)
		});
	};



	//CHALLENGE PARTICIPANTS

	self.addParticipantsList = function(challengeId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/participants:batchCreate",
			payload: JSON.stringify(model)
		});
	};


	self.getParticipantsList = function(challengeId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/participants",
			ignoreCodes: [400]
		});
	};


	self.deleteSingleParticipant = function(challengeId, userId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/participants/" + userId
		});
	};


	self.deleteAllParticipants = function(challengeId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/participants/"
		});
	};


	// challenges Goals (Objectives)

	self.createChallengeGoals = function(challengeId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/goals",
			payload: JSON.stringify(model),
		});
	};
	
	self.getChallengeGoals = function(challengeId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/" + challengeId + "/goals",
		});
	};
	 
    // single goal create
	self.createChallengeGoal = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/goals",
			payload: JSON.stringify(model),
		});
	};

    // single goal update
	self.updateChallengeGoal = function(goalId,model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/goals/" + goalId,
			payload: JSON.stringify(model),
		});
	};

	// single goal delete
	self.deleteChallengeGoal = function(goalId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CHALLENGES_ENDPOINT + "/goals/" + goalId,
		});
	};

	// single goal get
	self.getChallengeGoal = function(goalId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CHALLENGES_ENDPOINT +"/goals/" + goalId,
		});
	};


}

var challengesService = new ChallengesService();

function SubscriptionsService() {
	var self = this;


	self.createClassSubscription = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT,
			payload: JSON.stringify(model),
		});
	};

	self.deleteClassSubscription = function (classSubscriptionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + classSubscriptionId,
		});
	};

	self.updateClassSubscription = function (model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + model.ClassSubscriptionId,
			payload: JSON.stringify(model)
		});
	};

	self.setClassSubscriptionPlans = function (classSubscriptionId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + classSubscriptionId + "/plans",
			payload: JSON.stringify(model),
		});
	};


	self.getClassSubscriptionPlans = function (classSubscriptionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + classSubscriptionId + "/plans",
		});
	};


	self.getClassSubscriptionUsersCount = function (classSubscriptionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + classSubscriptionId + "/users/count",
		});
	};


	self.updateSubscriptionPublishState = function (classSubscriptionId, newStatus) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/" + classSubscriptionId + "/PublishState",
			payload: JSON.stringify(newStatus)
		});
	};



	self.addSubscriptionToUser = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users",
			payload: JSON.stringify(model)
		});
	};

	self.updateUserSubscription = function (userSubscriptionId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId,
			payload: JSON.stringify(model),
			ignoreCodes: "400"
		});
	};


	self.deleteUserClassSubscription = function (userSubscriptionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId,
			ignoreCodes: [409]
		});
	};

	self.getUserClassSubscriptionExtData = function(userSubscriptionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/extdata",
		});
	};

	//Model is reactivation date
	self.subspendUserSubscription = function (userSubscriptionId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/suspension",
			payload: JSON.stringify(model)
		});
	};


	self.reactivateUserSubscription = function (userSubscriptionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/suspension",
		});
	};

	self.unsubscribeImmediately = function (userSubscriptionId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/cancel",
			payload: JSON.stringify({
				AtEndOfBilling: false
			})
		});
	};

	self.unsubscribeAtEnd = function (userSubscriptionId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/cancel",
			payload: JSON.stringify({
				AtEndOfBilling: true
			})
		});
	};

	self.cancelUnsubscription = function (userSubscriptionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.SUBSCRIPTIONS_ENDPOINT + "/users/" + userSubscriptionId + "/cancel",
		});
	};
}

var subscriptionsService = new SubscriptionsService();

function BadgesService() {
	var self = this;

	// UPTIVO BADGES
	self.getAllBadges = function(clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BADGES_ENDPOINT
		});
	};

	
}

var badgesService = new BadgesService();

function ClubAppLinksService() {
	var self = this;

	self.createClubAppLink = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_APP_LINKS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};


	self.updateClubAppLink = function(id,model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_APP_LINKS_ENDPOINT + "/" + id,
			payload: JSON.stringify(model)
		});
	};


	self.deleteClubAppLink = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_APP_LINKS_ENDPOINT + "/" + id
		});
	};

	
}

var clubAppLinksService = new ClubAppLinksService();

function YoutubeService() {
	var self = this;

	self.getVideoInfo = function(videoId) {
		return utilities.defaultGet({
			url: 'https://www.googleapis.com/youtube/v3/videos?part=snippet&part=contentDetails&id=' + videoId + '&key=' + GOOGLE_API_KEY,
			noAuth: true
		});
	};


}

var youtubeService = new YoutubeService();

function VimeoService() {
	var self = this;

	self.getVideoInfo = function(videoId) {
		return utilities.defaultGet({
			url: 'https://vimeo.com/api/v2/video/' + videoId + ".json",
			noAuth: true
		});
	};


}

var vimeoService = new VimeoService();

function ClubVideoCollectionsService() {
	var self = this;

	self.createClubVideoCollection = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT,
			payload: model,
		});
	};
	
	self.updateClubVideoCollection = function (videoCollectionId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId,
			payload: model,
		});
	};

	self.getClubVideoCollection = function (videoCollectionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId
		});
	};

	self.deleteClubVideoCollection = function (videoCollectionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId
		});
	};

	self.addVideosToCollection = function (videoCollectionId, videoIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId + "/videos:batchCreate",
			payload: JSON.stringify(videoIds),
		});
	};

	self.removeVideosFromCollection = function (videoCollectionId, videoIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId + "/videos:batchDelete",
			payload: JSON.stringify(videoIds),
		});
	};

	self.getVideoCollectionSubscriptions = function (videoCollectionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId + "/subscriptions"
		});
	};

	self.setVideoCollectionSubscriptions = function (videoCollectionId, subscriptionIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEO_COLLECTIONS_ENDPOINT + "/" + videoCollectionId + "/subscriptions",
			payload: JSON.stringify(subscriptionIds),
		});
	};
}

var clubVideoCollectionsService = new ClubVideoCollectionsService();
function ClubVideosService() {
	var self = this;

	self.createClubVideo = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT,
			payload: model,
		});
	};

	self.updateClubVideo = function (videoId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT + "/" + videoId,
			payload: model,
			ignoreCodes: [409]
		});
	};

	self.getClubVideo = function (videoId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT + "/" + videoId
		});
	};

	self.deleteClubVideo = function (videoId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT + "/" + videoId
		});
	};

	self.addCollectionsToVideo = function (videoId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT + "/" + videoId + "/collections:batchCreate",
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};

	self.removeCollectionsFromVideo = function (videoId, model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_VIDEOS_ENDPOINT + "/" + videoId + "/collections:batchDelete",
			payload: JSON.stringify(model),
			ignoreCodes: [409]
		});
	};
}

var clubVideosService = new ClubVideosService();
function AthleteExpirationsService() {
	var self = this;

	self.createAthleteExpiration = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.ATHLETE_EXPIRATIONS_ENDPOINT,
			payload: model
		});
	};

	self.updateAthleteExpiration = function(expirationId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.ATHLETE_EXPIRATIONS_ENDPOINT + "/" + expirationId,
			payload: model
		});
	};
	
	self.getAthleteExpirations = function(expirationId) {
		return utilities.defaultGet({
			url: CONFIGURATION.ATHLETE_EXPIRATIONS_ENDPOINT + "/" + expirationId,
		});
	};

	self.deleteAthleteExpiration = function(expirationId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.ATHLETE_EXPIRATIONS_ENDPOINT + "/" + expirationId
		});
	};

	
}

var athleteExpirationsService = new AthleteExpirationsService();

function AthleteNotesService() {
	var self = this;

	self.createAthleteNote = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.ATHLETE_NOTES_ENDPOINT,
			payload: model
		});
	};

	self.updateAthleteNote = function(noteId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.ATHLETE_NOTES_ENDPOINT + "/" + noteId,
			payload: model
		});
	};
	
	self.getAthleteNote = function(noteId) {
		return utilities.defaultGet({
			url: CONFIGURATION.ATHLETE_NOTES_ENDPOINT + "/" + noteId,
		});
	};

	self.deleteAthleteNote = function(noteId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.ATHLETE_NOTES_ENDPOINT + "/" + noteId
		});
	};

	
}

var athleteNotesService = new AthleteNotesService();

function AthleteTasksService() {
	var self = this;

	self.createAthleteTask = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.ATHLETE_TASKS_ENDPOINT,
			payload: model
		});
	};

	self.updateAthleteTask = function(taskId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.ATHLETE_TASKS_ENDPOINT + "/" + taskId,
			payload: model
		});
	};

	self.setAthleteTaskCompleted = function(taskId, completedStatus) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.ATHLETE_TASKS_ENDPOINT + "/" + taskId + "/Completed",
			payload: JSON.stringify(completedStatus)
		});
	};
	
	self.getAthleteTask = function(taskId) {
		return utilities.defaultGet({
			url: CONFIGURATION.ATHLETE_TASKS_ENDPOINT + "/" + taskId,
		});
	};

	self.deleteAthleteTask = function(taskId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.ATHLETE_TASKS_ENDPOINT + "/" + taskId
		});
	};

	
}

var athleteTasksService = new AthleteTasksService();

function DashboardsService() {
	var self = this;

	// Get the list of athletes in the specified client funnnel stage
	// clientStage = Lead, Qualified, Prospect, Client
	self.getClubDashboardAthletesByClientStage = function(clubId, clientStage, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/athletes/clientstages/" + "?";
		url +=
		(clientStage ? "&clientStage=" + clientStage : "") +
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of clients with no trainings in the specified time range
	self.getClubDashboardClientsNoTraining = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/clients/notrainings" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of class participants marked as trials
	self.getClubDashboardTrialParticipations = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/classes/participants/trials" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of class participants marked as no-shows
	self.getClubDashboardNoShowParticipations = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/classes/participants/noshows" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of subscriptions with single ticket remaining
	self.getClubDashboardSingleTicketsRemaining = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/subscriptions/athletes/singletickets" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of athletes with suspended membership
	self.getClubDashboardSuspendedMemberships = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/subscriptions/athletes/suspended" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of athletes with new badges
	self.getClubDashboardNewBadges = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/athletes/badges" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of athletes with trainings with no comments
	self.getClubDashboardNoComments = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/trainings/nocomments" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};


	// Get the list of athletes with no activities
	self.getClubDashboardNoActivity = function(clubId, activeFrom, activeTo, activePresetRange, inactiveFrom, inactiveTo, inactivePresetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/athletes/noactivity" + "?";
		url +=
		(activeFrom ? "&activeFrom=" + activeFrom : "") +
		(activeTo ? "&activeTo=" + activeTo : "") +
		(activePresetRange ? "&activePresetRange=" + activePresetRange : "") +
		(inactiveFrom ? "&inactiveFrom=" + inactiveFrom : "") +
		(inactiveTo ? "&inactiveTo=" + inactiveTo : "") +
		(inactivePresetRange ? "&inactivePresetRange=" + inactivePresetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};


	// Get the list of expired clients
	self.getClubDashboardExpiredClients = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/subscriptions/athletes/expired" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};


	// Get the list of birthdays
	self.getClubDashboardBirthdays = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/athletes/birthdays" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};

	// Get the list of tasks
	self.getClubDashboardTasks = function(clubId, from, to, presetRange, count) {

		var url = CONFIGURATION.DASHBOARDS_ENDPOINT + "/clubs/" + clubId + "/tasks/uncompleted" + "?";
		url +=
		(from ? "&from=" + from : "") +
		(to ? "&to=" + to : "") +
		(presetRange ? "&presetRange=" + presetRange : "") +
		(count ? "&count=" + count : "");

		return utilities.defaultGet({
			url: url
		});
	};






}

var dashboardsService = new DashboardsService();

function LicensesService() {
	var self = this;

	self.getClubExtraFeatures = function(clubId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LICENSES_ENDPOINT + "/clubs/" + clubId + "/extras",
		});
	};

	self.getLicenseStripePortal = function(licenseId) {
		return utilities.defaultGet({
			url: CONFIGURATION.LICENSES_ENDPOINT + "/clubs/" + licenseId + "/stripe/portal",
		});
	};
}

var licensesService = new LicensesService();

function WorkoutSheetsService() {
	var self = this;

	self.listUptivoWorkoutSheets = function () { // for management Uptivo editor
		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo",
		});
	}

	// Create a new Uptivo club workout sheet
	self.createClubWorkoutSheet = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo",
			payload: model,
			forceJson: true,
		});
	};

	// Update a club workout sheet
	self.updateClubWorkoutSheet = function (model, fileId) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo/" + fileId,
			payload: model,
			// forceJson: true,
		});
	};

	self.getUptivoWorkoutSheet = function (workoutDefinitionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo/" + workoutDefinitionId
		});
	}
	
	self.deleteUptivoWorkoutSheet = function (workoutDefinitionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo/" + workoutDefinitionId
		});
	}

	self.publishUptivoWorkoutSheet = function (workoutDefinitionIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo:batchPublish",
			payload: JSON.stringify(workoutDefinitionIds)
		});
	}

	self.unpublishUptivoWorkoutSheet = function (workoutDefinitionIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/uptivo:batchUnpublish",
			payload: JSON.stringify(workoutDefinitionIds)
		});
	}

	self.getUptivoWorkoutSheetFromUri = function (wksUri) {
		return utilities.defaultGet({
			url: wksUri,
			noAuth: true
		});
	}

	// Batch clone club workouts (templates) in the same or different club
	self.cloneClubWorkouts = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + "/clubs:batchClone",
			payload: JSON.stringify(model),
		});
	};

	// Set club workout sheet subscription Ids
	self.setClubWorkoutSheetSubscriptions = function (clubId, fileId, subscriptionIds) {
		return utilities.defaultCreate({
			url: CONFIGURATION.WORKOUTSHEETS_ENDPOINT + `/clubs/${clubId}/${fileId}/subscriptions`,
			payload: JSON.stringify(subscriptionIds),
		});
	};

}

var workoutSheetsService = new WorkoutSheetsService();
function CircuitsService() { // BRIDGE WOKRKOUTS
	var self = this;

	// Create a new bridge workout
	self.createBridgeWorkout = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BRIDGE_WORKOUTS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	// Get a bridge workout
	self.getBridgeWorkout = function(bridgeWorkoutId) {
		return utilities.defaultGet({
			url: CONFIGURATION.BRIDGE_WORKOUTS_ENDPOINT + "/" + bridgeWorkoutId
		});
	};

	// Update an existing bridge workout
	self.updateBridgeWorkout = function(bridgeWorkoutId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.BRIDGE_WORKOUTS_ENDPOINT + "/" + bridgeWorkoutId,
			payload: ko.toJSON(model, function(key, value) {
				return value;
			})
		});
	};

	// Delete a bridge workout
	self.deleteBridgeWorkout = function(bridgeWorkoutId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.BRIDGE_WORKOUTS_ENDPOINT + "/" + bridgeWorkoutId
		});
	};


	// Batch clone bridge workouts in the same or different club
	self.cloneBridgeWorkouts = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.BRIDGE_WORKOUTS_ENDPOINT + ":batchClone",
			payload: JSON.stringify(model)
		});
	}

}

var circuitsService = new CircuitsService();

function ClubTransactionsService() {
	var self = this;

	self.createClubTransaction = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_TRANSACTIONS_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};
	
	self.updateClubTransaction = function(transactionId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_TRANSACTIONS_ENDPOINT + "/" + transactionId,
			payload: JSON.stringify(model)
		});
	};

	self.deleteClubTransaction = function(transactionId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_TRANSACTIONS_ENDPOINT + "/" + transactionId
		});
	};


	self.getClubTransaction = function(transactionId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_TRANSACTIONS_ENDPOINT + "/" + transactionId
		});
	};

}

var clubTransactionsService = new ClubTransactionsService();

function PoliciesService() { // CLUB POLICIES
	var self = this;

	// Create a new club policy
	self.createClubPolicy = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_POLICIES_ENDPOINT,
			payload: JSON.stringify(model)
		});
	};

	// self.createClubPolicy = function (clubId, summary, body) {
	// 	return utilities.defaultCreate({
	// 		url: CONFIGURATION.CLUB_POLICIES_ENDPOINT +,
	// 		isRaw: true,
	// 		data: body,
	// 		contentType: "text/html; charset=utf-8",
	// 		headers: {
	// 			"x-file-name": encodeURIComponent(summary),
	// 		},
	// 	});
	// };

	// Get a club policy
	self.getClubPolicy = function(policyId) {
		return utilities.defaultGet({
			url: CONFIGURATION.CLUB_POLICIES_ENDPOINT + "/" + policyId
		});
	};

	// Update an existing policy
	self.updateClubPolicy = function(policyId, model) {
		return utilities.defaultUpdate({
			url: CONFIGURATION.CLUB_POLICIES_ENDPOINT + "/" + policyId,
			payload: JSON.stringify(model)
		});
	};

	// Update an existing policy PublishState
	self.updateClubPolicyPublishState = function(policyId, publishState) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_POLICIES_ENDPOINT + "/" + policyId + "/PublishState",
			payload: JSON.stringify(publishState)
		});
	};

	// Delete a club policy
	self.deleteClubPolicy = function(policyId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_POLICIES_ENDPOINT + "/" + policyId
		});
	};

}

var policiesService = new PoliciesService();

function ClubKiosksService() {
	var self = this;

	self.createKiosk = function (clubId) {
		return utilities.defaultCreate({
			url: CONFIGURATION.CLUB_KIOSKS_ENDPOINT,
			payload: JSON.stringify({
				ClubId: clubId
			})
		});
	}

	self.deleteKiosk = function (clubKioskId) {
		return utilities.defaultDelete({
			url: CONFIGURATION.CLUB_KIOSKS_ENDPOINT + "/" + clubKioskId
		});
	}

}

var clubKiosksService = new ClubKiosksService();
function WorkoutSheetsRunsService() {
	var self = this;

	self.getWorkoutSheetRun = function(id) {
		return utilities.defaultGet({
			url: CONFIGURATION.WORKOUTSHEETSRUN_ENDPOINT + "/" + id,
		});
	}

	self.deleteWorkoutSheetRun = function(id) {
		return utilities.defaultDelete({
			url: CONFIGURATION.WORKOUTSHEETSRUN_ENDPOINT + "/" + id,
		});
	}

}

var workoutSheetsRunsService = new WorkoutSheetsRunsService();
function AiService() {
	var self = this;

	self.generateWorkoutSheet = function(model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.AI_ENDPOINT + "/WorkoutSheets:generate",
			payload: ko.toJSON(model),
			ignoreCodes: [400],
		});
	};

	
}

var aiService = new AiService();

function EquipmentsService() {
    var self = this;

	//  Set club equipments
	self.setClubEquipments = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.EQUIPMENTS_ENDPOINT + "/clubs",
			payload: JSON.stringify(model),
		});
	};

	// Set user equipments
	self.setUserEquipments = function (model) {
		return utilities.defaultCreate({
			url: CONFIGURATION.EQUIPMENTS_ENDPOINT + "/users",
			payload: JSON.stringify(model),
		});
	};
}

var equipmentsService = new EquipmentsService();
function ObjectAccessConfiguration(userData) {
	this.accessConfiguration = {
		Brand: {
			roles: [USER_ROLES.OWNER],
		},
		BrandChallenges: {
			roles: [USER_ROLES.OWNER],
		},
		DeviceManagement: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		AppManagement: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		Integrations: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		ClubSensors: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		ClubProfile: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		ClubLicenses: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		ClubSlideShows: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		Timers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.TRAINER],
		},
		IntensityFlows: {
			roles: [USER_ROLES.OWNER, USER_ROLES.TRAINER],
		},
		AddUsers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ManageUsers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		Roles: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		EditUser: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		DemoUsers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		Rankings: {
			roles: [USER_ROLES.OWNER, USER_ROLES.TRAINER],
		},
		Trainers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		TrainersJournal: {
			roles: [USER_ROLES.TRAINER],
		},
		Athletes: {
			roles: [USER_ROLES.TRAINER],
		},
		TrainingPrograms: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClubMessages: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		TrainerDetails: {
			roles: [USER_ROLES.TRAINER],
		},
		UptivoLIVE: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		UptivoLiveTraining: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		LiveTrainings: {
			roles: [USER_ROLES.TRAINER],
		},
		AthletesBiometrics: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		MyActivities: {
			roles: [USER_ROLES.TRAINER, USER_ROLES.MANAGER],
		},
		ClubClasses: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		PersonalTrainers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClubClassParticipants: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClassParticipantSubscriptions: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClubClass: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClubChallenges: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		CreditsAndSubscriptions: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		DashBoard: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		Services: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		VideoCollections: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		WorkoutSheets: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		Movements: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER],
		},
		Circuits: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		WorkoutDefinitions: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		WorkoutSheetsUsers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		HealthUsers: {
			roles: [USER_ROLES.OWNER, USER_ROLES.TRAINER],
		},
		SupportVideos: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		OnScreenWorkouts: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		},
		ClubEquipments: {
			roles: [USER_ROLES.OWNER, USER_ROLES.MANAGER, USER_ROLES.TRAINER],
		}
	};

	this.hasAccess = function(view) {

		// Check if noLoginRequired property is true using path
		// if (_.get(this.accessConfiguration, view + ".noLoginRequired")) return true;

		// Get roles, if not here then all have access
		var userInfo = userData.get();
		if (!userInfo) return false;

		if (view == "Home") return false;

		var roles = _.get(this.accessConfiguration, view + ".roles", [USER_ROLES.ALL]);

		var hasRole = userInfo.isInOneOfRoles(roles);
		var isLiveView = view == "LiveTrainings" || view == "UptivoLIVE" || view == "UptivoLiveTraining";
		var isClassesView =	view == "MyActivities" || view == "ClubClasses" || view == "ClubClassParticipants" || view == "ClubClass";

		if (!hasRole) {
			return false;
		}

		if (!isLiveView && !isClassesView) {
			return true;
		}

		if (isLiveView) {
			var enabledLiveT = _.some(userInfo.trainerClubs(), { EnableLiveTrainings: true });
			var enabledLiveM = _.some(userInfo.managerClubs(), { EnableLiveTrainings: true });

			return enabledLiveT || enabledLiveM;
		}

		if (isClassesView) {
			var enabledClassesT = _.some(userInfo.trainerClubs(), { EnableActivities: true });
			var enabledClassesM = _.some(userInfo.managerClubs(), { EnableActivities: true });
	
			return enabledClassesT || enabledClassesM;
		}

		return false;
	};
}
function AppContextManager(utilities, cache, userData) {
	var self = this;

	this.viewByClub = ko.observable();
	this.selectedClubId = ko.observable();

	this.getSelectedClubId = function () {
		if (!self.selectedClubId())
			self.selectDefaultClub();

		return self.selectedClubId();
	}

	this.getSelectedClub = function () {
		return _.find(getClubs() || [], { ClubId: self.selectedClubId() });
	};


	this.selectDefaultClub = function () {
		var clubIds = _.map(getClubs(), "ClubId");
		var cachedValue = cache.get("SELECTED_CLUB_ID");
		var clubId = _.includes(clubIds, cachedValue) ? cachedValue : _.first(clubIds);

		self.selectedClubId(clubId);
	}

	this.selectClub = function(clubId) {
		var club = _.find(getClubs() || [], { ClubId: clubId });
		if (club)
		{
			cache.set("SELECTED_CLUB_ID", clubId);
			self.selectedClubId(clubId);
			return clubId;
		}
	}


	this.assertClubWasSelected = function () {
		if (!userData.get())
			return false;

		if (self.getSelectedClubId())
			return true;

		toastr.error("You don't have enough rights to access that view.", "Not enough rights!");
		return false;
	}

	this.selectedClubId.subscribeChanged(function (n, o) {
		if (!n || n === o)
			return;
		
		cache.set("SELECTED_CLUB_ID", n);
	});

	function getClubs() {
		var user = userData.get();
		if (!user)
			return [];

		return user.getClubs();
	}


	function refreshUserDataEventHandler() {
		if (!self.selectedClubId())
			self.selectDefaultClub();
		routing.refreshRoute();
	}

	// TODO: Unsubscribe if destroyed
	eventBus.subscribe("UserDataChanged", refreshUserDataEventHandler);
}
function RoutesConfig() {
	var self = this;

	self.init = function () {
		routing.init({
			defaultViewName: function() {
				var user = _.invoke(userData, "get");
				if (user) {
					if (user.hasTrainerRole()) return "TrainersJournal";

					if (user.hasManagerRole()) return "ClubProfile";
	
					if (user.hasOwnerRole()) return "Brand";

					return "Journal";
				}

				return "Home";
			},
			mappings: [],
			routes: [
				{
					definition: "#[Ee]dit[Uu]ser/:id",
					view: "EditUser"
				},
				{
					definition: "#[Ee]dit[Dd]emo[Uu]ser/:id",
					view: "EditDemoUser"
				},
				{
					definition: "#[Jj]ournal/:id",
					view: "Journal"
				},
				{
					definition: "#[Tt]raining/:id",
					view: "Training"
				},
				{
					definition: "#[Gg]roup[Tt]raining/:id",
					view: "GroupTraining"
				},
				{
					definition: "#[Cc]lub[Pp]rofile/:id",
					view: "ClubProfile",
					hashUpdate: 'noparams'
				},
				{
					definition: "#[Cc]lub[Pp]rofile/:id/:action",
					view: "ClubProfile",
					hashUpdate: 'noparams'
				},
				{
					definition: "#[Rr]efresh[Pp]ayment[Aa]ccount/:id",
					view: "RefreshPaymentAccount"
				},
				{
					definition: "#[Cc]lub[Ll]icenses/:id",
					view: "ClubLicenses"
				},
				{
					definition: "#[Ii]nvitation[Cc]ode/:invitationCode",
					view: "InvitationCode"
				},
				{
					definition: "#[Bb]iometric[Rr]eport/:id",
					view: "BiometricReport"
				},
				{
					definition: "#[Aa]dvanced[Bb]iometrics/:id",
					view: "AdvancedBiometrics"
				},
				{
					definition: "#[Cc]omment[Tt]raining/:id",
					view: "CommentTraining"
				},
				{
					definition: "#[Tt]rainers[Rr]ankings/:id",
					view: "TrainersRankings"
				},
				{
					definition: "#[Tt]rainer[Dd]etails/:id",
					view: "TrainerDetails"
				},
				{
					definition: "#[Uu]ptivoLIVE[Tt]raining/:id",
					view: "UptivoLIVEtraining"
				},
				{
					definition: "#[Cc]lub[Cc]lass/:id",
					view: "ClubClass"
				},
				{
					definition: "#[Cc]lub[Cc]lass[Pp]articipants/:id",
					view: "ClubClassParticipants"
				},
				{
					definition: "#[Aa]thlete[Ff]iles/:id",
					view: "AthleteFiles"
				},
				{
					definition: "#[Cc]lub[Cc]hallenge/:id",
					view: "ClubChallenge"
				},
				{
					definition: "#[Cc]hallenge[Rr]anking/:id",
					view: "ChallengeRanking"
				},
				{
					definition: "#[Cc]lub[Oo]bjective/:id",
					view: "ClubObjective"
				},
				{
					definition: "#[Wv]orkout[Ss]heet/:id",
					view: "WorkoutSheet"
				},
				{
					definition: "#[Ee]xport[Wv]orkout[Ss]heet/:id",
					view: "ExportWorkoutSheet"
				},
				{
					definition: "#[Cc]ircuit/:id",
					view: "Circuit"
				},
				{
					definition: "#[Ww]orkoutSheetExecutionLog/:id",
					view: "WorkoutSheetExecutionLog"
				},
			]
		});
	}
}
function ComponentsConfig() {
	this.init = function () {
		ko.components.register("Shell", {
			template: { fromUrl: "Shell/ShellView.html" },
			viewModel: { fromUrl: "Shell/ShellViewModel.js" }
		});

		ko.components.register("Menu", {
			template: { fromUrl: "Menu/MenuView.html" },
			viewModel: { fromUrl: "Menu/MenuViewModel.js" }
		});

		ko.components.register("ContextSelector", {
			template: { fromUrl: "ContextSelector/ContextSelectorView.html" },
			viewModel: { fromUrl: "ContextSelector/ContextSelectorViewModel.js" }
		});

		ko.components.register("NotificationsSelector", {
			template: { fromUrl: "NotificationsSelector/NotificationsSelectorView.html" },
			viewModel: { fromUrl: "NotificationsSelector/NotificationsSelectorViewModel.js" }
		});

		ko.components.register("TasksSelector", {
			template: { fromUrl: "TasksSelector/TasksSelectorView.html" },
			viewModel: { fromUrl: "TasksSelector/TasksSelectorViewModel.js" }
		});

		ko.components.register("ConnectToUptivoButton", {
			template: { fromUrl: "ConnectToUptivoButton/ConnectToUptivoButtonView.html" },
			viewModel: { fromUrl: "ConnectToUptivoButton/ConnectToUptivoButtonViewModel.js" }
		});

		ko.components.register("UptivoBridgeStatus", {
			template: { fromUrl: "UptivoBridgeStatus/UptivoBridgeStatusView.html" },
			viewModel: { fromUrl: "UptivoBridgeStatus/UptivoBridgeStatusViewModel.js" }
		});

		ko.components.register("UserMenu", {
			template: { fromUrl: "UserMenu/UserMenuView.html" },
			viewModel: { fromUrl: "UserMenu/UserMenuViewModel.js" }
		});

		ko.components.register("Footer", {
			template: { fromUrl: "Footer/FooterView.html" },
			viewModel: { fromUrl: "Footer/FooterViewModel.js" }
		});

		ko.components.register("BarChart", {
			template: { fromUrl: "BarChart/BarChartView.html" },
			viewModel: { fromUrl: "BarChart/BarChartViewModel.js" }
		});

		ko.components.register("ClubLicensesWarning", {
			template: { fromUrl: "ClubLicensesWarning/ClubLicensesWarningView.html" },
			viewModel: { fromUrl: "ClubLicensesWarning/ClubLicensesWarningViewModel.js" }
		});

		ko.components.register("UptivoNews", {
			template: { fromUrl: "UptivoNews/UptivoNewsView.html" },
			viewModel: { fromUrl: "UptivoNews/UptivoNewsViewModel.js" }
		});

		ko.components.register("EditUser", {
			template: { fromUrl: "" },
			viewModel: { fromUrl: "EditUser/EditUserViewModel.js" }
		});

		ko.components.register("DashBoardDetails", {
			template: { fromUrl: "" },
			viewModel: { fromUrl: "DashBoardDetails/DashBoardDetailsViewModel.js" }
		});
	}
}

var componentsConfig = new ComponentsConfig();
function EventBus() {
    var self = this;

    self.topics = {};

    self.subscribe = function (topic, listener) {
        // create the topic if not yet created
        if (!self.topics[topic]) self.topics[topic] = [];

        // add the listener
        self.topics[topic].push(listener);
    }

    self.unsubscribe = function (topic, listener) {
        for (i = 0; i < self.topics[topic].length; ++i) {
            if (self.topics[topic][i] === listener) {
                self.topics[topic].splice(i--, 1);
            }
        }
    },

    self.publish = function (topic, data) {
        // return if the topic doesn't exist, or there are no listeners
        if (!self.topics[topic] || self.topics[topic].length < 1) return;

        // send the event to all listeners
        self.topics[topic].forEach(function (listener) {
            listener(data);
        });
    }

    self.printing = false;

    function publishBeforePrintEvent() {
        if (!self.printing) {
            self.printing = true;
            self.publish("BeforePrint");
        }
    }

    function publishAfterPrintEvent() {
        if (self.printing) {
            self.publish("AfterPrint");
            self.printing = false;
        }
    }
    
    function printHandler(mql) {
        if (mql.matches)
            publishBeforePrintEvent();
        else
            publishAfterPrintEvent();
    }

    function addPrintHandler() {
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addListener(printHandler);
        }
        window.onbeforeprint = publishBeforePrintEvent;
        window.onafterprint = publishAfterPrintEvent;
    }
    
    function removePrintHandler() {
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.removeListener(printHandler);
        }
        window.onbeforeprint = null;
        window.onafterprint = null;
    }

    function addwindowResizeHandler() {
        $(window).on('resize', resizeHandler);
    }

    function removewindowResizeHandler() {
        $(window).on('resize', resizeHandler);
    }

    var resizeTimer;
    function resizeHandler() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
            self.publish("WindowResize");
        }, 50);
    }

    addPrintHandler();
    addwindowResizeHandler();
}

var eventBus = new EventBus();

window.cookieStorage = (function() {
	/**
	 * Creates new cookie or removes cookie with negative expiration
	 * @param  key       The key or identifier for the store
	 * @param  value     Contents of the store
	 * @param  exp       Expiration - creation defaults to 30 days
	 */

	function createCookie(key, value, exp) {
		var date = new Date();
		date.setTime(date.getTime() + exp * 24 * 60 * 60 * 1000);
		var expires = "; expires=" + date.toGMTString();
		document.cookie = key + "=" + value + expires + "; path=/";
	}

	/**
	 * Returns contents of cookie
	 * @param  key       The key or identifier for the store
	 */

	function readCookie(key) {
		var nameEQ = key + "=";
		var ca = document.cookie.split(";");
		for (var i = 0, max = ca.length; i < max; i++) {
			var c = ca[i];
			while (c.charAt(0) === " ") c = c.substring(1, c.length);
			if (c.indexOf(nameEQ) === 0)
				return c.substring(nameEQ.length, c.length);
		}
		return null;
	}

	function getItem(key) {
		return readCookie(key);
	}

	function setItem(key, value) {
		return createCookie(key, value, 30);
	}

	function removeItem(key) {
		return createCookie(key, "", -1);
	}

	function clear() {
		var cookies = document.cookie.split(";");

		for (var i = 0; i < cookies.length; i++) {
			var cookie = cookies[i];
			var eqPos = cookie.indexOf("=");
			var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
			document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
		}
	}

	return {
		getItem: getItem,
		setItem: setItem,
		clear: clear,
		removeItem: removeItem
	};
})();

window.objectStorage = (function() {
	var storage = {};

	function getItem(key) {
		return storage[key];
	}

	function setItem(key, value) {
		return (storage[key] = value);
	}

	function removeItem(key) {
		return (storage[key] = undefined);
	}

	function clear() {
		storage = {};
	}

	return {
		getItem: getItem,
		setItem: setItem,
		clear: clear,
		removeItem: removeItem
	};
})();

function CacheManager(storageType) {
	var self = this;
	var storage = window[storageType];

	self.get = function(key) {
		var itemJSON = storage.getItem(key);
		if (_.isUndefined(itemJSON)) {
			return undefined;
		}
		try {
			return JSON.parse(itemJSON);
		} catch (e) {
			debugger;
		}
	};

	self.set = function(key, obj) {
		try {
			storage.setItem(key, JSON.stringify(obj));
		} catch (e) {
			debugger;
		}
	};

	self.clear = function(key) {
		storage.removeItem(key);
	};

	self.clearAll = function(key) {
		storage.clear();
	};

	self.exists = function(key) {
		return !!storage.getItem(key);
	};
}

var cache = new CacheManager(
	Modernizr.localstorage ? "localStorage" : "objectStorage"
);
var sessionCache = new CacheManager(
	Modernizr.localstorage ? "sessionStorage" : "objectStorage"
);

function ResourceManager() {
	var languageKey = "language",
		resources = new Resources();

	window.r = function (text) {
		if (!text) return;

		var result = text,
			lang = getCurrentLanguage(),
			resourceNotFound = true;

		for (var module in resources) {
			if (resources[module][text] && resources[module][text][lang]) {
				return resources[module][text][lang];
			}
		}

		console.warn("ERROR -> Resource not found with fast check: " + text);

		for (var module in resources) {
			for (var key in resources[module]) {
				var ltext = text.toLowerCase();
	
				for (var language in resources[module][key]) {
					if (resources[module][key][language].toLowerCase() == ltext) {
						return resources[module][key][getCurrentLanguage()];
					}
				}
	
				if (text != ltext) {
					if (resources[module][ltext] && resources[module][ltext][getCurrentLanguage()]) {
						return resources[module][ltext][getCurrentLanguage()];
					}
				}
			}
		}

		console.warn("ERROR -> Resource not found: " + text);

		return result;
	};

	function langToLocale(lang) {
		var _locales = {
			it: "it-IT",
			en: "en-US",
			es: "es-ES",
			fr: "fr-FR",
		};

		return _locales[lang] || "en-US";
	}

	function getCurrentLocale() {
		return langToLocale(getCurrentLanguage());
	}

	function getCurrentLanguage() {
		var lang;
		var langStore = cache.get(languageKey);

		if (!langStore || !langStore.lang) {
			lang = (navigator.language|| "en-US").split("-")[0];
		} else {
			lang = langStore.lang
		}

		if (!_.find(CONFIGURATION.LANGUAGES, { shortname:lang })) {
			lang = CONFIGURATION.LANGUAGES[0].shortname;
		}

		return lang;
	}

	function setCurrentLanguage(language, reload) {
		if (!_.find(CONFIGURATION.LANGUAGES, { shortname:language })) {
			lang = CONFIGURATION.LANGUAGES[0].shortname;
		}

		cache.set(languageKey, { lang: language });
		if (reload) location.reload();

		if (_.has(window, 'moment.locale')) {
			moment.locale(language);
		}

		if (_.has(window, 'numeral.locale')) {
			numeral.locale(language);
		}

		if (_.has(window, 'ko.validation.locale')) {
			ko.validation.locale(langToLocale(language));
		}

		if(_.has(window, 'DataTable.language')) {
			if (language === "en") {
				DataTable.language = {
					infoFiltered: "<b>" + r("dt.infoFiltered") + "</b>",
				};
			} else {
				DataTable.language = {
					decimal: r("dt.decimal"),
					emptyTable: r("dt.emptyTable"),
					info: r("dt.info"),
					infoEmpty: r("dt.infoEmpty"),
					infoFiltered: "<b>" + r("dt.infoFiltered") + "</b>",
					thousands: r("dt.thousands"),
					lengthMenu: r("dt.lengthMenu"),
					loadingRecords: r("dt.loadingRecords"),
					processing: r("dt.processing"),
					search: r("dt.search"),
					zeroRecords: r("dt.zeroRecords"),
					buttons: {
						print: r("print"),
					},
				};
			}
	
			DataTable.language.select = {
				rows: {
					_: "<b>" + r("dt.select.many") + "</b>",
					1: "<b>" + r("dt.select.1") + "</b>",
					0: "",
				},
			};
	
			DataTable.language.paginate = {
				first: "&#8676;",
				last: "&#8677;",
				previous: "&larr;",
				next: "&rarr;",
			};
		}

		_.each(TRAINING_TYPES, function(tt) {
			tt.Name = r(tt.Type + "Type");
		});

		_.each(SERVICE_TYPES, function(st) {
			st.Name = r(st.Type + "Type");
		});
	}

	return {
		get: function (key) {
			var module = key.split(".")[0],
				resource = key.split(".")[1];
			return resources[module][resource][getCurrentLanguage()] || key;
		},
		setCurrentLanguage: setCurrentLanguage,
		getCurrentLanguage: getCurrentLanguage,
		getCurrentLocale: getCurrentLocale,
	};


	


}

var resourceManager = new ResourceManager();

function AuthManager() {
	var self = this;
	var debug = true;
	var isUptivoAdmin = false;
	var isUptivoEditor = false;
	var firebaseAuth, firebaseUi;
	
	var initDeferred = $.Deferred();

	// Async initialization, wait for status
	self.initialize = function () {

		initializeFirebase();

		return initDeferred;
	};

	// Get token for API
	self.getApiTokenAsync = function () {
		var tokenDeferred = $.Deferred();

		try {
			if (!firebaseAuth.currentUser) {
				console.log("NO CURRENT USER");
				tokenDeferred.reject();
			} else {
				firebaseAuth.currentUser.getIdToken()
				.then(function (token) {
					tokenDeferred.resolve(token);
				})
				.catch(function (err) {
					console.error(err);
					tokenDeferred.reject();
				});
			}
		} catch (err) {
			console.error(err);
			tokenDeferred.reject();
		}

		return tokenDeferred;
	};

	// Get if Uptivo Admin from token
	self.isUptivoAdmin = function () {
		return isUptivoAdmin;
	};

	// Get if Uptivo Editor from token
	self.isUptivoEditor = function () {
		return isUptivoEditor;
	};


	// Login the user
	self.openUi = function (options) {
		debug && console.log("LOGIN REQUESTED");

		firebaseUi.reset();
		firebaseUi.start(options.elementId, {
			signInOptions: [
				{
					provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
					requireDisplayName: false,
					buttonColor: '#2F2F2F',
					disableSignUp: {
						status: options.mode == "signIn"
					}
				},
			],
			tosUrl: options.mode == "signUp" && "https://uptivo.fit/en/uptivo-terms-of-use/",
			privacyPolicyUrl: options.mode == "signUp" && "https://uptivo.fit/en/uptivo-terms-of-use/",
			callbacks: {
				signInSuccessWithAuthResult: function (authResult) {
					debug && console.log("AUTH COMPLETED:", authResult.operationType);

					if (_.isFunction(options.successCb)) {
						options.successCb();
					}
				}
			},
		});
	}

	// Logout the user
	self.logOut = function () {
		debug && console.log("LOGOUT REQUESTED");

		window.localStorage.clear();
		window.sessionStorage.clear();
		userData.clear();

		debug && console.log("LOGGING OUT FROM FIREBASE");
		firebaseAuth.signOut()
			.then(function() {
				debug && console.log("LOGGED OUT FROM FIREBASE");
			});
	}

	function initializeFirebase() {
		var lang = (navigator.language || "en-US").split("-")[0];
		var supportedLanguages = ["en", "it", "es", "fr"];
		if (!_.includes(supportedLanguages, lang)) {
			lang = supportedLanguages[0];
		}

		var firebaseApp = firebase.initializeApp({
			apiKey: "AIzaSyB7krsP91Hhpaiz9eOdNuvOJ33gwlB-9IU",
			authDomain: "uptivo-api.firebaseapp.com",
			projectId: "uptivo-api",
			storageBucket: "uptivo-api.appspot.com",
			messagingSenderId: "419822386841",
			appId: "1:419822386841:web:97a6d3caba4a1a564ac208",
		});

		firebaseAuth = firebaseApp.auth();

		$.ajax({
			url: "https://www.gstatic.com/firebasejs/ui/6.1.0/firebase-ui-auth__" + lang + ".js",
			dataType: "script",
			cache: true,
			success: function () {
				firebaseUi = new firebaseui.auth.AuthUI(firebaseAuth);
				// Deferred is set from async onAuthStateChanged

				firebaseAuth.onAuthStateChanged(function (user) {
					if (user) {
						user.getIdToken()
							.then(function (token) {
								return parseJwt(token);
							})
							.then(function (parsedToken) {
								isUptivoAdmin = !!_.find(parsedToken, function (v, k) { return k.endsWith("uptivo_admin") });
								isUptivoEditor = !!_.find(parsedToken, function (v, k) { return k.endsWith("uptivo_editor") });
								initDeferred.resolve();
							})
							.catch(function () {
								isUptivoAdmin = false;
								isUptivoEditor = false;
								initDeferred.reject();
							})
					} else {
						initDeferred.reject();
					}
				});
			}
		});
	}

	// PRIVATE STUFF

	function parseJwt(token) {
		if (!token) return null;

		try {
			var base64Url = token.split('.')[1];
			var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
				return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
			}).join(''));

			return JSON.parse(jsonPayload);
		} catch (err) {
			console.error(err);
			return null;
		}
	}
}

(function(jQuery) {
	jQuery.cachedScript = function(url, options) {
		// Allow user to set any option except for dataType, cache, and url
		options = $.extend(options || {}, {
			dataType: "script",
			cache: true,
			url: url
		});

		// Use $.ajax() since it is more flexible than $.getScript
		// Return the jqXHR object so we can chain callbacks
		return jQuery.ajax(options);
	};

	// TODO: MB REFACTOR
	jQuery.whenAll = function(deferreds) {
		var wrappedDeferreds = [];

		for (var i = 0; i < deferreds.length; i++) {
			wrappedDeferreds.push(jQuery.Deferred());

			var c = function(arg) {
				wrappedDeferreds[arg].resolve(arguments);
			}.bind(null, i);

			deferreds[i].always(c);
		}

		return jQuery.when.apply(jQuery, wrappedDeferreds).promise();
	};
})(jQuery);

// Register it
ko.components.loaders.unshift(
	(function() {
		var componentsPrefix = CONFIGURATION.SPA_COMPONENTS_URL; // + languagePrefix;

		////////////////////////////////////////////////////////
		///                     PRIVATE                      ///
		////////////////////////////////////////////////////////

		function getClearComponentName(componentName) {
			// Capitalized name without -nc
			// ex: shell-nc -> Shell
			var nameWithoutNc = componentName.replace("-nc", "");
			var capitalizedName = nameWithoutNc.charAt(0).toUpperCase() + nameWithoutNc.slice(1);

			return capitalizedName;
		}

		function getViewModelNameFromUrl(url) {
			// Path/Name.js -> Name
			var indexOfNameStart = url.lastIndexOf("/") + 1;
			return url.substring(indexOfNameStart).replace(".js", "");
		}

		function getViewPathFromComponentName(componentName) {
			// shell -> Shell/ShellView.html
			var name = getClearComponentName(componentName);
			return name + "/" + name + "View.html";
		}

		function getViewModelPathFromComponentName(componentName) {
			// shell -> Shell/ShellViewModel.js
			var name = getClearComponentName(componentName);
			return name + "/" + name + "ViewModel.js";
		}

		function shouldUseNamingConventionForView(viewConfig) {
			return !viewConfig.element;
		}

		function shouldUseNamingConventionForViewModel(viewModelConfig) {
			return viewModelConfig.fromUrl;
		}

		function callDefaultBehaviour(callback) {
			callback(null);
		}

		function showLoadError() {
			toastr.error(r("component-load-error"), r("server-error"));
		}

		function loadViewFromUrl(options) {
			var isLocal = location.href.indexOf("/src") >= 0;
			var languagePrefix = isLocal ? "" : resourceManager.getCurrentLanguage() + "/";
			var relativeUrl = isLocal ? options.relativeUrl : options.relativeUrl.replace(".html", "-" + APP_VERSION + ".html");

			var fullUrl =
				componentsPrefix + languagePrefix + relativeUrl;

			$.get(fullUrl, function(markupString) {
				ko.components.defaultLoader.loadTemplate(options.name, markupString, options.callback);
			}).fail(function() {
				try {
					callDefaultBehaviour(options.callback);
				} catch (Ex) {
					ko.components.defaultLoader.loadTemplate(options.name, "", options.callback);
					ko.components.clearCachedDefinition(options.name);
					showLoadError();
				}
			});
		}

		function loadViewModelFromUrl(options) {
			// ViewModels are not translatedgetCurrentLanguage
			var isLocal = location.href.indexOf("/src") >= 0;
			var relativeUrl = isLocal ? options.relativeUrl : options.relativeUrl.replace(".js", "-" + APP_VERSION + ".js");
			var fullUrl = componentsPrefix + relativeUrl;


			$.cachedScript(fullUrl)
				.done(function() {
					var viewModelConstructor = window[getViewModelNameFromUrl(options.relativeUrl)];
					var viewModelInitialization = function(data) {
						var viewModel = new viewModelConstructor();

						if (viewModel.init) viewModel.init(data);

						return viewModel;
					};

					ko.components.defaultLoader.loadViewModel(options.name, viewModelInitialization, options.callback);
				})
				.fail(function() {
					try {
						callDefaultBehaviour(options.callback);
					} catch (Ex) {
						ko.components.defaultLoader.loadViewModel(options.name, function() {}, options.callback);
						ko.components.clearCachedDefinition(options.name);
						showLoadError();
					}
				});
		}

		////////////////////////////////////////////////////////
		///                     PUBLIC                       ///
		////////////////////////////////////////////////////////

		function getConfig(name, callback) {
			// If name does not contain "-nc", use default
			if (name.indexOf("-nc") === -1) {
				callDefaultBehaviour(callback);
				return;
			}

			//provide configuration for how to load the template/widget
			callback({
				template: { fromUrl: getViewPathFromComponentName(name) },
				viewModel: { fromUrl: getViewModelPathFromComponentName(name) }
			});
		}

		function loadViewModel(name, viewModelConfig, callback) {
			if (!shouldUseNamingConventionForViewModel(viewModelConfig)) {
				callDefaultBehaviour(callback);
				return;
			}

			var url = viewModelConfig.fromUrl || getViewPathFromComponentName(name);
			loadViewModelFromUrl({
				name: name,
				relativeUrl: url,
				maxCacheAge: viewModelConfig.maxCacheAge,
				callback: callback
			});
		}

		function loadTemplate(name, templateConfig, callback) {
			if (!shouldUseNamingConventionForView(templateConfig)) {
				callDefaultBehaviour(callback);
				return;
			}

			var url = templateConfig.fromUrl || getViewPathFromComponentName(name);
			loadViewFromUrl({
				name: name,
				relativeUrl: url,
				maxCacheAge: templateConfig.maxCacheAge,
				callback: callback
			});
		}

		return {
			getConfig: getConfig,
			loadTemplate: loadTemplate,
			loadViewModel: loadViewModel
		};
	})()
);

ko.ext = ko.ext || {};

ko.ext.updateViewModel = function(viewModel, model, extend) {
	for (var prop in model) {
		if (!model.hasOwnProperty(prop)) continue;

		if (_.has(viewModel[prop], "hasWriteFunction") || _.isFunction(viewModel[prop])) {
			try {
				viewModel[prop](model[prop]);
			} catch (err) {
				if (err.message.indexOf("'write' option") === -1) throw err;
			}
		} else if (extend) {
			viewModel[prop] = model[prop];
		}
	}
};

ko.ext.getChanges = function(initialArray, updatedArray, idColumn, columnsToCompare) {
	var result = {
		removed: [],
		updated: [],
		added: []
	};

	$.each(initialArray, function(i, original) {
		var updated = updatedArray.find(function(u) {
			return ko.ext.comparePropertyValues(u, original, idColumn);
		});

		if (!updated) {
			result.removed.push(original);
			return;
		}

		var areTheSame = true;
		$.each(columnsToCompare, function(i, col) {
			areTheSame &= ko.ext.comparePropertyValues(original, updated, col);
		});

		if (!areTheSame) {
			result.updated.push(updated);
		}
	});

	$.each(updatedArray, function(i, updated) {
		var original = initialArray.find(function(u) {
			return ko.ext.comparePropertyValues(u, updated, idColumn);
		});

		if (!original) {
			result.added.push(updated);
		}
	});

	return result;
};

ko.ext.comparePropertyValues = function(obj1, obj2, prop) {
	var val1 = $.isFunction(obj1[prop]) ? obj1[prop]() : obj1[prop];
	var val2 = $.isFunction(obj2[prop]) ? obj2[prop]() : obj2[prop];

	return val1 === val2;
};

ko.ext.processChanges = function(opt) {
	var deffereds = [];

	if (opt.updateCallback) {
		$.each(opt.changes.updated, function(index, record) {
			deffereds.push(opt.updateCallback(ko.toJS(record)));
		});
	}
	if (opt.addCallback) {
		$.each(opt.changes.added, function(index, record) {
			deffereds.push(opt.addCallback(ko.toJS(record)));
		});
	}
	if (opt.removeCallback) {
		$.each(opt.changes.removed, function(index, record) {
			deffereds.push(opt.removeCallback(ko.toJS(record)));
		});
	}

	$.whenAll(deffereds).done(function() {
		if (opt.successCallback) opt.successCallback.apply(arguments);
	});
};

ko.subscribable.fn.subscribeChanged = function(callback) {
	var savedValue = this.peek();
	return this.subscribe(function(latestValue) {
		var oldValue = savedValue;
		savedValue = latestValue;
		callback(latestValue, oldValue);
	});
};

ko.observableArray.fn.filterByProperty = function(propName, matchValue) {
	return ko.pureComputed(function() {
		var allItems = this(),
			matchingItems = [];
		for (var i = 0; i < allItems.length; i++) {
			var current = allItems[i];
			if (ko.unwrap(current[propName]) === matchValue) matchingItems.push(current);
		}
		return matchingItems;
	}, this);
};

ko.observableArray.fn.firstByProperty = function(propName, matchValue) {
	return ko.pureComputed(function() {
		var allItems = this(),
			matchingItems = [];
		for (var i = 0; i < allItems.length; i++) {
			var current = allItems[i];
			if (ko.unwrap(current[propName]) == matchValue) matchingItems.push(current);
		}
		return matchingItems.length ? matchingItems[0] : undefined;
	}, this);
};

ko.observableArray.fn.refreshAll = function() {
	var data = this();
	/*
    this([]);
    this(data);
    */
	this.splice.apply(this, _.concat([0, data.length], data));
};

ko.observableArray.fn.refreshItem = function(item) {
	var index = this["indexOf"](item);
	if (index >= 0) {
		this.splice.apply(this, [index, 1, item]);
	}
};

function Validation() {
	function loadSettings() {
		var knockoutValidationSettings = {
			insertMessages: true,
			decorateElement: true,
			errorElementClass: "has-error",
			errorMessageClass: "error-msg",
			grouping: {
				deep: true,
				observable: true
			}
		};

		if (ko.validation) {
			var insertValidationMessage = ko.validation.insertValidationMessage;
			ko.validation.insertValidationMessage = function(element) {
				if ($(element.parentElement).hasClass("input-group")) {
					return insertValidationMessage(element.parentElement);
				}
				return insertValidationMessage(element);
			};

			ko.validation.init(knockoutValidationSettings);
		} else {
			console.log("Warning - no knockout validation defined!");
		}
	}

	function loadValidationRules() {
		ko.validation.rules["timeWithFormat"] = {
			validator: function(val, format) {
				return moment(val, format, true).isValid();
			},
			message: r("provide-valid-time")
		};

		ko.validation.rules["dateWithFormat"] = {
			validator: function(val, format) {
				return moment(val, format, true).isValid();
			},
			message: r("provide-valid-date")
		};

		ko.validation.rules["greaterThanNow"] = {
			validator: function(val, format) {
				return moment(val, format, true) < moment();
			},
			message: r("date-no-greater-than-now")
		};

		ko.validation.rules["ageBetween"] = {
			validator: function(val, params) {
				var date = moment(val, params.format);
				var age = moment().diff(date, "years", false);
				if (isNaN(age)) return true;
				return age >= params.min && age <= params.max;
			},
			message: function(params) {
				return r("age-comprised-between").format(params.min, params.max);
			}
		};

		ko.validation.rules["multipleOfSeconds"] = {
			validator: function(val, params) {
				return moment.duration(params.prefix + val).as("seconds") % params.seconds == 0;
			},
			message: function(params) {
				return r("value-multiple-of").format(params.seconds);
			}
		};

		ko.validation.rules["uptivoBeltId"] = {
			validator: function(val) {
				if (val) {
					return userService.validUptivoSensor(val);
				}
				return true;
			},
			message: r("invalid-uptivo-belt-number")
		};

		ko.validation.rules["mzBeltId"] = {
			validator: function(val) {
				if (val) {
					return userService.validMZSensor(val);
				}
				return true;
			},
			message: r("invalid-mz-belt-number")
		};

		ko.validation.rules["garminBeltId"] = {
			validator: function(val) {
				if (val) {
					return userService.validGarminSensor(val);
				}
				return true;
			},
			message: r("invalid-garmin-belt-number")
		};


		ko.validation.rules["ipv4Address"] = {
			validator: function(val) {
				return /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
					"" + val + ""
				);
			},
			message: r("enter-valid-ipv4")
		};

		ko.validation.rules['email'] = {
			validator: function (val, validate) {
				if (!validate) { return true; }

				//I think an empty email address is also a valid entry
				//if one want's to enforce entry it should be done with 'required: true'
				return ko.validation.utils.isEmptyVal(val) || (
					validate && /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i.test(val)
				);
			},
			message: r("provide-valid-email")
		};

		function validateLocalizedNumber(value, params) {
			if (!numeral) {
				return ko.validation.rules.number.validator(value, !!params);
			}
			var tSym = numeral.localeData().delimiters.thousands;
			var dSym = numeral.localeData().delimiters.decimal;
			
			var pattern = "^-?(?:0|[1-9]\\d*|[1-9]\\d{0,2}(?:" + (tSym == '.' ? '\\.' : tSym) + "\\d{3})+)(?:" + (dSym == '.' ? '\\.' : dSym) + "\\d+)?$";
			var regex = new RegExp(pattern);

			return regex.test(value);
		}


		ko.validation.rules["localizedNumberMin"] = {
			validator: function(value, params) {
				if (ko.validation.utils.isEmptyVal(value)) {
					return true;
				}

				if (!validateLocalizedNumber(value, params)) {
					return false;
				}

				return ko.validation.rules.min.validator(utilities.localizedToJavaScriptNumber(value), params);
			},
			message: ko.validation.rules.min.message
		}

		ko.validation.rules["localizedNumberMax"] = {
			validator: function(value, params) {
				if (ko.validation.utils.isEmptyVal(value)) {
					return true;
				}

				if (!validateLocalizedNumber(value, params)) {
					return false;
				}

				return ko.validation.rules.max.validator(utilities.localizedToJavaScriptNumber(value), params);
			},
			message: ko.validation.rules.max.message
		}

		ko.validation.rules["localizedNumber"] = {
			validator: function(value, params) {
				if (ko.validation.utils.isEmptyVal(value)) {
					return true;
				}

				return validateLocalizedNumber(value, params);
			},
			message: function(params) {
				return r("enter-valid-number").format(
					numeral.localeData().delimiters.thousands,
					numeral.localeData().delimiters.decimal
				);
			}
		};

		ko.validation.rules["duration"] = {
			validator: function(durationString, params) {
				if (durationString === undefined || durationString === null || durationString === "") {
					durationString = "0";
				}
				var duration = utilities.parseDuration(durationString);
				if (!duration) return false;

				if (params) {
					if (params.min && duration.valueOf() < moment.duration(params.min).valueOf()) return false;
					if (params.max && duration.valueOf() > moment.duration(params.max).valueOf()) return false;
				}
				return true;
			},
			message: r("enter-valid-duration")
		};

		ko.validation.rules["url"] = {
			validator: function(value) {
				return (
					ko.validation.utils.isEmptyVal(value) ||
					/^https?:\/\/([\da-zA-Z-]+)(\.[\da-zA-Z-]+)*\.([a-zA-Z]{2,6})(\/[\w \.-]*)*\/?$/.test(value)
				);
			},
			message: r("enter-valid-url")
		};

		ko.validation.rules["minTrimLength"] = {
			validator: function(val, minLength) {
				return ko.validation.rules["minLength"].validator(_.trim(val), minLength);
			},
			message: function(params) {
				return ko.validation.rules["minLength"].message.format(params);
			}
		};

		ko.validation.rules["maxTrimLength"] = {
			validator: function(val, minLength) {
				return ko.validation.rules["maxLength"].validator(_.trim(val), minLength);
			},
			message: function(params) {
				return ko.validation.rules["maxLength"].message.format(params);
			}
		};

		ko.validation.registerExtenders();
	}

	return {
		loadSettings: loadSettings,
		loadValidationRules: loadValidationRules
	};
}

var validation = new Validation();

var routing = $.sammy(function () {
	var self = this;

	var mappings = [];

	var defaultViewName;

	var noAccessViewName;

	self.currentView = ko.observable()

	// Prevent sammy from messing with forms
	this._checkFormSubmission = function (form) {
		return (false);
	};

	function getDefaultView() {
		return _.isFunction(defaultViewName) ? defaultViewName() : defaultViewName;
	}

	function getNoAccessView() {
		return _.isFunction(noAccessViewName) ? noAccessViewName() : noAccessViewName;
	}

	function updateHash(view, params, update) {

		update = update || 'allparams';

		if (update == 'nochange')
			return;

		var newHash = '#' + view;

		if (update != 'noparams')
		{
			if (params && params.id)
				newHash += '/' + params.id;

			if (params && params.action)
				newHash += '/' + params.action;
		}

		if (window.location.hash != newHash) {
			window.location.hash = newHash;
		}
	}

	function internalUpdateComponent(view, params, hashUpdate) {
		updateHash(view, params, hashUpdate);

		var matched = mappings.filter(function (el) { return el.view === view; });
		var componentName = (!matched || matched.length === 0) ? view + "-nc" : matched[0].component;

		if (app.params() != params) {
			app.params(params);
		}

		if (app.current() != componentName) {
			app.current(componentName);
		}

		if (app.currentRoute() != view) {
			app.currentRoute(view);
		}
	}

	var navigating = false;
	function changeRoute(view, params, hashUpdate) {
		if (!navigating) {
			navigating = true;

			var viewToShow = view || getDefaultView();
			self.currentView(viewToShow);
			internalUpdateComponent(viewToShow, params, hashUpdate);
			eventBus.publish("RouteChanged", viewToShow);

			navigating = false;
		}
	}


	this.navigateBack = function (navigateBackStack, extendConfig) {
		if (navigateBackStack) {
			var previousViewData = navigateBackStack.pop();

			var previousView = previousViewData.view;
			var previousViewConfig = previousViewData.config;

			if (previousViewConfig) {
				if (extendConfig && extendConfig[previousView]) {
					_.assign(previousViewConfig, extendConfig[previousView]);
				}

				if (navigateBackStack.length) {
					previousViewConfig.navigateBackStack = navigateBackStack;
				}
			}

			changeRoute(previousViewData.view, previousViewData.config);
		}
	}

	this.navigateTo = function (newView, newViewConfig, currentViewConfig, navigateBackStack) {
		if (self.currentView() && newViewConfig) {
			newViewConfig.navigateBackStack = navigateBackStack || [];
			newViewConfig.navigateBackStack.push({
				view: self.currentView(),
				config: currentViewConfig,
			});
		}

		changeRoute(newView, newViewConfig);
	}

	this.changeComponent = function (view, params) {
		if (!navigating) {
			navigating = true;
			internalUpdateComponent(view, params);
			navigating = false;
		}
	}

	this.resetRoute = function () {
		changeRoute(undefined, app.params());
		if (document.location.search.length) {
			trimUrl();
		}
	}

	this.refreshRoute = function () {
		var view = self.currentView();
		var params = app.params();

		if (!view || !objectAccessConfiguration.hasAccess(view)) {
			view = getDefaultView();
			params = undefined;
		}

		changeRoute(view, params);
		if (document.location.search.length) {
			trimUrl();
		}
	}

	function getPathFromUrl(url) {
		return url.split("?")[0];
	}

	function trimUrl() {
		var currentUrl = getPathFromUrl(window.location.href);
		var hash = window.location.hash;
		location.href = currentUrl + hash;
	}


	function initRoutes(routes) {
		if (!routes)
			return;

		$.each(routes, function (i, r) {
			self.get(r.definition, function () {
				changeRoute(r.view || this.params.view || getDefaultView(), this.params, r.hashUpdate);
			});
		});

		self.get("#:view/:id", function () {
			changeRoute(this.params.view, this.params.id);
		});

		self.get("#:view", function () {
			changeRoute(this.params.view);
		});

		self.notFound = function (method, path) {
			// At the moment, do nothing. We dont have the user yet.
		};
	}

	this.init = function (options) {
		defaultViewName = options.defaultViewName;
		noAccessViewName = options.noAccessViewName || "NoAccess";

		mappings = options.mappings;

		initRoutes(options.routes);
	}
});
(function() {
	ko.bindingHandlers.icheck = {
		init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			if ($(element).attr("type") == "checkbox")
				element.control = new ICheckBox($(element), valueAccessor, allBindings);
			//refactor - must find some other shared object
			else element.control = new IRadioButton($(element), valueAccessor, allBindings);
			element.control.initialize();
			$(element).addClass("icheck");
		},
		update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			element.control.update();
		}
	};

	ko.bindingHandlers.loadingSpinner = {
		init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var loader = $(
				' <div class="loader" style="display: none">' +
					'<div class="loader-bg"></div>' +
					'<div class="loader-spinner" style="opacity:1.0">' +
					'<div class="sk-spinner sk-spinner-wave">' +
					'<div class="sk-rect1"></div>' +
					'<div class="sk-rect2"></div>' +
					'<div class="sk-rect3"></div>' +
					'<div class="sk-rect4"></div>' +
					'<div class="sk-rect5"></div>' +
					"</div>" +
					"</div>" +
					"</div>"
			);
			var $element = $(element);

			$element.append(loader);

			if ($element.css("position") == "static") {
				$element.css("position", "relative");
			}

			if ($element.css("min-height") == "0px") {
				$element.css("min-height", "60px");
			}

			ko.applyBindingsToNode($element.find(".loader")[0], {
				visible: allBindings().loadingSpinner
			});
		}
	};

	ko.bindingHandlers.type = {
		init: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var controlFactory = new ControlFactory($(element), allBindings, viewModel);
			var control = controlFactory.createControl(valueAccessor());

			element.control = control;

			if (control.initialize) {
				control.initialize();
			}

			control.rebind(viewModel, allBindings);

			if (control.dispose) {
				ko.utils.domNodeDisposal.addDisposeCallback(element, control.dispose.bind(control));
			}

			return { controlsDescendantBindings: true };
		},
		update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			if (element.control && element.control.update) {
				element.control.update(element, valueAccessor, allBindings, viewModel, bindingContext);
			}
		}
	};

	ko.bindingHandlers.total = ko.bindingHandlers.current = {
		update: function(element, valueAccessor, allBindingsAccessor) {
			element.control.update();
		}
	};

	ko.bindingHandlers.dayList = {
		init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {},
		update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var val = ko.unwrap(valueAccessor());

			var currentDay = ko.unwrap(val.currentDay);
			var disable = ko.unwrap(val.disable);
			var cb = ko.unwrap(val.callback);

			var $el = $(element);

			var cssClass = $el.attr("class");
			if (disable) {
				cssClass += " disabled";
			}

			var $ul = $("<ul id='daylist' class='{0}'></ul>".format(cssClass));
			for (var day = val.range().begin.clone(); day.isBefore(val.range().end); day.add(1, "day")) {
				var dayStr = day.format("YYYYMMDD");
				var baseId = $el.attr("id");
				var elName = "{0}-{1}".format(baseId, dayStr);

				var attrs = [];
				if (day.isSame(currentDay, "day")) {
					attrs.push("checked");
				}
				if (disable) {
					attrs.push("disabled");
				}


				var inputHtml = "<input id='{0}' type='radio' name='{1}' value='{2}' {3}/>".format(
					elName,
					baseId,
					day.format(),
					attrs.join(" ")
				);

				var labelHtml = "<label for='{0}'>{1}</label>".format(elName, day.format("dd, DD"));

				var $li = $("<li>{0}{1}</li>".format(inputHtml, labelHtml));

				ko.applyBindingsToNode(
					$li.first(),
					{
						click: function(viewModel, event) {
							if (disable) return;
							cb(
								moment(
									$(event.currentTarget)
										.find("input")
										.prop("checked", true)
										.val()
								)
							);
						}
					},
					bindingContext
				);
				$ul.append($li);
			}

			$el.empty().append($ul);
		}
	};

	function selectListHTML(config) {
		var $ul = $("<ul id='daylist' class='{0}'></ul>".format(config.cssClass));

		config.list.forEach(function(item, i) {
			var inputHtml = "<input id='{0}-{1}' type='radio' name='{0}' value='{2}' {3}/>".format(
				config.name,
				i,
				item,
				item.id == ko.utils.unwrapObservable(config.selectedValue) ? " checked" : ""
			);
			var labelHtml = "<label for='{0}-{1}'>{2}</label>".format(config.name, i, item.name);
			var $li = $("<li>{0}{1}</li>".format(inputHtml, labelHtml));

			ko.applyBindingsToNode(
				$li.first(),
				{
					click: function(viewModel, event) {
						$(event.currentTarget)
							.find("input")
							.prop("checked", true);
						config.selectedValue(item.id);
					}
				},
				config.bindingContext
			);
			$ul.append($li);
		});
		return $ul;
	}

	ko.bindingHandlers.selectList = {
		init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var val = ko.utils.unwrapObservable(valueAccessor)();
			var $el = $(element);
			var config = {
				list: ko.utils.unwrapObservable(val.source),
				selectedValue: val.selectedValue,
				bindingContext: bindingContext,
				name: $el.attr("id"),
				cssClass: $el.attr("class")
			};

			var $result = selectListHTML(config);
			$el.append($result);
		},
		update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var val = ko.unwrap(valueAccessor());
			var $el = $(element);
			var config = {
				list: ko.unwrap(val.source),
				selectedValue: val.selectedValue,
				bindingContext: bindingContext,
				name: $el.attr("id"),
				cssClass: $el.attr("class")
			};

			$el.empty();
			var $result = selectListHTML(config);
			$el.append($result);
		}
	};

	ko.bindingHandlers.rangeSlider = {
		init: function(element, valueAccessor, allBindingsAccessor) {
			var val = ko.utils.unwrapObservable(valueAccessor)();

			var min = ko.utils.unwrapObservable(val.min);
			var max = ko.utils.unwrapObservable(val.max);
			var disabled = ko.utils.unwrapObservable(val.disabled);

			$(element).ionRangeSlider({
				min: 0,
				max: 100,
				from: min,
				to: max,
				type: "double",
				step: 1,
				postfix: "%",
				grid: true,
				grid_num: 10,
				disable: disabled ? true : false,
				onChange: function(event) {
					val.min(event.from);
					val.max(event.to);
				}
			});
		},
		update: function(element, valueAccessor, allBindings, viewModel, bindingContext) {
			var val = ko.unwrap(valueAccessor());

			var min = ko.unwrap(val.min);
			var max = ko.unwrap(val.max);
			var disabled = ko.unwrap(val.disabled);

			var data = $(element).data("ionRangeSlider");

			var currentMin = data.result.from;
			var currentMax = data.result.to;
			var currentDisabled = data.options.disable;

			if (currentMin === min && currentMax === max && disabled === currentDisabled) return;

			data.update({ from: min, to: max, disable: disabled ? true : false });
		}
	};

	ko.bindingHandlers.confirmDelete = {
		init: function(element, valueAccessor) {
			var val = ko.utils.unwrapObservable(valueAccessor)();

			var callback = ko.unwrap(val.callback);
			var array = ko.unwrap(val.array);
			var index = ko.unwrap(val.index);
			var text = val.text;
			var confirmButtonText = val.confirmButtonText;
			var deleteElement = true;
			var params = val.params;
			var disabled = val.disabled;

			if (val.deleteElement !== undefined) {
				deleteElement = Boolean(val.deleteElement);
			}

			$(element).click(function(e) {
				if (!disabled || !disabled()) {
					utilities.confirmWindow(
						text,
						confirmButtonText,
						callback,
						null,
						params,
						index,
						array,
						deleteElement
					);
				}
			});
		},

		update: function(element, valueAccessor) {}
	};

	ko.bindingHandlers.hidden = {
		update: function(element, valueAccessor) {
			ko.bindingHandlers.visible.update(element, function() {
				return !ko.utils.unwrapObservable(valueAccessor());
			});
		}
	};

	ko.bindingHandlers.modalSave = {
		init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			function onModalSave() {
				var callback = ko.unwrap(valueAccessor());
				var result = callback.apply(this, arguments);
				if (result === false) return;

				$(element)
					.closest(".modal")
					.modal("hide");
			}

			ko.applyBindingsToNode(element, { click: onModalSave }, bindingContext);
		}
	};
	ko.bindingHandlers.menu = {
		init: function(element, valueAccessor, allBindingsAccessor) {
			$(element).empty();
			var nodesObservable = valueAccessor();
			var activeNodeObservable = allBindingsAccessor().activeNode;

			function isNodeActive(node) {
				return activeNodeObservable() == node.view;
			}

			function isChildNodeActive(node) {
				return false;
			}

			function renderChildren(node) {
				var innerUl =
					"<ul class='nav nav-second-level " + (isChildNodeActive(node) ? "in" : "collapse") + "'>{0}</ul>";
				var innerLi = "<li id='{0}'{1}>{2}</li>";
				var innerA = "<a href='{0}'{1}>{2}</a>";

				var innerHtml = "";
				node.children.forEach(function(childNode) {
					if (childNode.view) {
						innerHtml += innerLi.format(
							childNode.view,
							isNodeActive(childNode) ? " class='active'" : "",
							innerA.format("#"+childNode.view, '', childNode.title)
						);
					} else if (childNode.url) {
						innerHtml += innerLi.format(
							childNode.url,
							"",
							innerA.format(childNode.url, " target='blank'", childNode.title)
						);
					}
				});
				return innerUl.format(innerHtml);
			}

			function renderMenu(nodes) {
				var result = "";
				nodes.forEach(function(node, i) {
					var li =
						"<li class='{0} " + (isNodeActive(node) ? "class='active'" : "") + "' id='{1}'>{2}{3}</li>";
					var a =
						"<a class='{0}' href='{1}'>" +
						"<i class='{2}'></i> <span class='nav-label {0}'>{3}</span>" +
						(node.hasChildren ? "<span class='fa arrow'></span>" : "") +
						"</a>";
					var nodeHtml = li.format(
						node.hasChildren ? "parent-node" : "node",
						node.view || node.title.replace(/ /g, "_"),
						a.format(
							node.hasChildren ? "parent-node" : "node",
							node.hasChildren ? "javascript:void(0)" : "#" + node.view,
							node.icon,
							node.title
						),
						node.hasChildren ? renderChildren(node) : ""
					);

					result += nodeHtml;
				});
				return result;
			}

			var menuHtml = renderMenu(nodesObservable());
			$(element).append(menuHtml);
			$(element).metisMenu();
		},
		update: function(element, valueAccessor, allBindingsAccessor) {
			var activeNode = allBindingsAccessor().activeNode();

			var nodes = valueAccessor()();
			var nodesFlat = [],
				isChildNode = false;

			nodes.forEach(function(node) {
				if (node.hasChildren) {
					node.children.forEach(function(n) {
						n.isChild = true;
						nodesFlat.push(n);
					});
				} else nodesFlat.push(node);
			});

			var node = nodesFlat.filter(function(n) {
				if (activeNode == "Journal" && parseInt(window.location.hash.split("/")[1]) && parseInt(window.location.hash.split("/")[1]) != userData.get().UserId ) {
					activeNode = "Athletes";
				}
				if (activeNode == "AdvancedBiometrics" && parseInt(window.location.hash.split("/")[1]) && parseInt(window.location.hash.split("/")[1]) != userData.get().UserId ) {
					activeNode = "AthletesBiometrics";
				}

				return n.view == activeNode;
			})[0];

			_.each(_.flatMapDeep(nodes, function(n) { return _.some(n.children) ? [n, n.children] : n }), function(node) {
				if (node.view) {
					$(element).find("#" + node.view).toggle(!node.disabled);
				}
			});

			if (!node) return;
			isChildNode = node.isChild;

			$(element)
				.find("li.active")
				.removeClass("active");
			$(element)
				.find(".in")
				.removeClass("in");
			$(element)
				.find("#" + node.view)
				.addClass("active");
			if (isChildNode) {
				$(element)
					.find("#" + node.view)
					.parent()
					.addClass("in");
				$(element)
					.find("#" + node.view)
					.parent()
					.parent()
					.addClass("active");
			}

		}
	};

	ko.bindingHandlers.enterkey = {
		init: function(element, valueAccessor, allBindings, data, context) {
			var wrapper = function(data, event) {
				if (event.keyCode === 13) {
					valueAccessor().call(this, data, event);
				}
			};
			ko.applyBindingsToNode(element, { event: { keyup: wrapper } }, context);
		}
	};

	ko.bindingHandlers.changeToSvg = {
		update: function(element, valueAccessor) {
			// Initially set the element to be instantly visible/hidden depending on the value
			var value = valueAccessor();

			var color = value.color;
			var src = ko.unwrap(value.src());

			$(element).each(function() {
				var $img = jQuery(this);
				var imgID = $img.attr("id");
				var imgClass = $img.attr("class");
				var imgURL = src || $img.attr("src");

				if (imgURL) {
					jQuery.get(
						imgURL,
						function(data) {
							// Get the SVG tag, ignore the rest
							var $svg = jQuery(data).find("svg");

							// Add replaced image's ID to the new SVG
							if (typeof imgID !== "undefined") {
								$svg = $svg.attr("id", imgID);
							}
							// Add replaced image's classes to the new SVG
							if (typeof imgClass !== "undefined") {
								$svg = $svg.attr("class", imgClass + " replaced-svg");
							}

							// Remove any invalid XML tags as per http://validator.w3.org
							$svg = $svg.removeAttr("xmlns:a");

							// Replace image with new SVG
							$img.prev("svg").remove();
							$img.before($svg);

							if (color) $svg.find("*").attr("fill", color);
						},
						"xml"
					);
				}
			});
		}
	};
})();

(function() {
	function genDateInput($el, bindings, bindingContext) {
		var uniqueId = guidShort();

		if (bindings.showIcon == false) {
			var $input = $(
				(
					"<div class='col-lg-12 input-group date'>" +
					"<input id='{0}' type='text' data-uptivo-date-picker='true' class='form-control' placeholder='{1}' />" +
					"</div>"
				).format(uniqueId, r(bindings.label))
			);
		} else {
			var $input = $(
				(
					"<div class='col-lg-12 input-group date'>" +
					"<input id='{0}' type='text' data-uptivo-date-picker='true' class='form-control' placeholder='{1}' />" +
					"<label for='{0}' class='input-group-addon'> <i class='fa fa-calendar'></i> </span>" +
					"</div>"
				).format(uniqueId, r(bindings.label))
			);
		}

		var setBindings = { type: DatePicker, value: bindings.formInput };
		if (!_.isUndefined(bindings.enable)) {
			setBindings.enable = bindings.enable;
		}

		$el.append($input);
		ko.applyBindingsToNode($input.find("input")[0], setBindings, bindingContext);
	}

	function genNumberInput($el, bindings, bindingContext) {
		var $input = $(
			(
				"<div class='col-lg-12 input-group number'>" +
				"<input type='number' class='form-control' placeholder='{0}' />" +
				(bindings.fixedUnit || bindings.unit
					? "<span class='input-group-addon'" +
					  (bindings.unit ? " data-bind='html:{1}'" : "") +
					  ">" +
					  (bindings.fixedUnit ? "{1}" : "") +
					  "</span>"
					: "") +
				"</div>"
			).format(r(bindings.label), bindings.unit || bindings.fixedUnit)
		);

		var cfg = { value: bindings.formInput };
		if (typeof bindings.enable != "undefined") {
			cfg.enable = bindings.enable;
		}
		$el.append($input);
		ko.applyBindingsToNode($input.find("input")[0], cfg, bindingContext);
	}

	function genEmailInput($el, bindings, bindingContext) {
		var $input = $(
			(
				"<div class='col-lg-8, input-group'>" +
				"<input data-localized='email' type='email' class='form-control' readonly>" +
				"<span class='input-group-btn'>" +
				"<button type='button' data-toggle='modal' data-target='#changeEmailModal' class='btn btn-primary no-border-radius'>" +
				r("change-email") +
				"</button>" +
				"</span>" +
				"</div>"
			).format(r(bindings.label))
		);

		$el.append($input);
		ko.applyBindingsToNode($input.find("input")[0], { value: bindings.formInput }, bindingContext);
	}

	function genDropdownInput($el, bindings, bindingContext) {
		var $input = $("<select class='form-control dropdown-toggle'></select>");

		var val = bindings.formInput;
		var optionsValue = ko.unwrap(bindings.optionsValue);

		var selectedItem = ko.pureComputed({
			read: function() {
				var items = ko.unwrap(bindings.items);

				if (!items || !items.length) {
					return undefined;
				}

				return (
					ko.utils.arrayFirst(items, function(item) {
						return val() == item || val() === item[optionsValue];
					}) || items[0]
				);
			},
			write: function(newItem) {
				var items = ko.unwrap(bindings.items);

				if (!items || !items.length) {
					return;
				}

				!optionsValue ? val(newItem) : val(newItem[optionsValue]);
			},
		});

		$el.append($input);
		ko.applyBindingsToNode(
			$input[0],
			{
				value: selectedItem,
				options: bindings.items,
				optionsText: bindings.optionsText,
			},
			bindingContext
		);
	}

	function genGenderInput($el, bindings, bindingContext) {
		var $input = $(
			"<input name='gender' data-value='{0}' data-text-field='title' data-value-field='id' class='uptivo-radio' />".format(
				bindings.valueField
			)
		);

		var genders = [
			{
				id: ENUMS.GENDERS.UNSPECIFIED,
				title: r(ENUMS.GENDERS.UNSPECIFIED.toLowerCase()),
				icon: ENUMS.GENDER_ICONS.UNSPECIFIED,
			},
			{ id: ENUMS.GENDERS.MALE, title: r(ENUMS.GENDERS.MALE.toLowerCase()), icon: ENUMS.GENDER_ICONS.MALE },
			{ id: ENUMS.GENDERS.FEMALE, title: r(ENUMS.GENDERS.FEMALE.toLowerCase()), icon: ENUMS.GENDER_ICONS.FEMALE },
		];

		$el.append($input);

		ko.applyBindingsToNode(
			$input[0],
			{ type: UptivoRadioButton, source: genders, checked: bindings.formInput },
			bindingContext
		);
	}

	function genTextInput($el, bindings, bindingContext) {
		var $input = $(
			"<input type='text' placeholder='{0}' maxlength='{1}' class='form-control'/>".format(
				bindings.placeholder ? r(bindings.placeholder) : r(bindings.label),
				bindings.maxLength || 10000
			)
		);

		var bindingsConfiguration = { value: bindings.formInput };

		if (bindings.enable) {
			bindingsConfiguration.enable = bindings.enable;
		}

		$el.append($input);
		ko.applyBindingsToNode($input[0], bindingsConfiguration, bindingContext);
	}

	var generators = {
		date: genDateInput,
		dropdown: genDropdownInput,
		email: genEmailInput,
		gender: genGenderInput,
		number: genNumberInput,
		text: genTextInput,
	};

	ko.bindingHandlers.formInput = {
		init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
			var $el = $(element);
			var validationProp = allBindingsAccessor().validationProp || valueAccessor();
			var inputType = (allBindingsAccessor().inputType || "text").toLowerCase();
			var generator = generators[inputType];
			if (!generator) throw new Error("No form input with type: " + inputType);

			var bindingsCfg = {};
			if (validationProp.rules) {
				bindingsCfg.validationElement = validationProp;
			}
			if (allBindingsAccessor().hideMsg) {
				bindingsCfg.validationOptions = { insertMessages: false };
			}
			ko.applyBindingsToNode(element, bindingsCfg, bindingContext);

			var isRequired =
				allBindingsAccessor().isRequired ||
				(validationProp.rules &&
					validationProp.rules().find(function(item) {
						return item.rule === "required" && item.params === true;
					}));

			$el.addClass("form-group");
			$el.append(
				"<label class='{0} control-label'>{1} {2}</label><div class='{3}'></div>".format(
					allBindingsAccessor().labelClass || "col-lg-4",
					r(allBindingsAccessor().label),
					isRequired ? "*" : "",
					allBindingsAccessor().inputClass || "col-lg-8"
				)
			);

			generator($el.find("div"), allBindingsAccessor(), bindingContext);
		},
	};
})();

if (!String.prototype.format) {
	String.prototype.format = function () {
		var args = arguments;
		return this.replace(/{(\d+)}/g, function (match, number) {
			return typeof args[number] != "undefined" ? args[number] : match;
		});
	};
}

if (!String.prototype.replaceAll) {
	String.prototype.replaceAll = function (search, replacement) {
		var target = this;
		return target.replace(new RegExp(search, "g"), replacement);
	};
}

if (!String.prototype.replaceParam) {
	// Replace or add parameters to a url
	// Author: James Bernard
	// email: jamezilla0@gmail.com
	// Version: 0.5
	String.prototype.replaceParam = function (paramsObject, add) {
		var originalUrl = this.toString();
		var params = Object.keys(paramsObject);
		var newUrl = originalUrl;
		params.forEach(function (param) {
			// Author: iratherscribble@gitHub
			var re = new RegExp("[\\?&]" + param + "=([^&#]*)", "i"),
				match = re.exec(newUrl),
				delimiter,
				newString;
			// =============
			// Author: slaveofcode@gitHub
			if (match === null && add) {
				// append new param
				var hasQuestionMark = /\?/.test(newUrl);
				delimiter = hasQuestionMark ? "&" : "?";
				newUrl = newUrl + delimiter + param + "=" + paramsObject[param];
			} else if (match) {
				delimiter = match[0].charAt(0);
				newUrl = newUrl.replace(re, delimiter + param + "=" + paramsObject[param]);
			} else {
				console.error("Parameter", "'" + param + "'", "Does not exist in url: ", originalUrl);
				console.error(
					"To add these parameters to this url please change your method call to: replaceParam([Object], [Boolean=true])"
				);
			}
		});

		return newUrl;
	};
}

/*
 * Natural Sort algorithm for Javascript - Version 0.7 - Released under MIT license
 * Author: Jim Palmer (based on chunking idea from Dave Koelle)
 * Contributors: Mike Grier (mgrier.com), Clint Priest, Kyle Adams, guillermo
 * See: http://js-naturalsort.googlecode.com/svn/trunk/naturalSort.js
 */
function naturalSort(a, b, html) {
	var re = /(^-?[0-9]+(\.?[0-9]*)[df]?e?[0-9]?%?$|^0x[0-9a-f]+$|[0-9]+)/gi,
		sre = /(^[ ]*|[ ]*$)/g,
		dre =
			/(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/,
		hre = /^0x[0-9a-f]+$/i,
		ore = /^0/,
		htmre = /(<([^>]+)>)/gi,
		// convert all to strings and trim()
		x = a.toString().replace(sre, "") || "",
		y = b.toString().replace(sre, "") || "";
	// remove html from strings if desired
	if (!html) {
		x = x.replace(htmre, "");
		y = y.replace(htmre, "");
	}
	// chunk/tokenize
	var xN = x.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
		yN = y.replace(re, "\0$1\0").replace(/\0$/, "").replace(/^\0/, "").split("\0"),
		// numeric, hex or date detection
		xD = parseInt(x.match(hre), 10) || (xN.length !== 1 && x.match(dre) && Date.parse(x)),
		yD = parseInt(y.match(hre), 10) || (xD && y.match(dre) && Date.parse(y)) || null;

	// first try and sort Hex codes or Dates
	if (yD) {
		if (xD < yD) {
			return -1;
		} else if (xD > yD) {
			return 1;
		}
	}

	// natural sorting through split numeric strings and default strings
	for (var cLoc = 0, numS = Math.max(xN.length, yN.length); cLoc < numS; cLoc++) {
		// find floats not starting with '0', string or 0 if not defined (Clint Priest)
		var oFxNcL = (!(xN[cLoc] || "").match(ore) && parseFloat(xN[cLoc], 10)) || xN[cLoc] || 0;
		var oFyNcL = (!(yN[cLoc] || "").match(ore) && parseFloat(yN[cLoc], 10)) || yN[cLoc] || 0;
		// handle numeric vs string comparison - number < string - (Kyle Adams)
		if (isNaN(oFxNcL) !== isNaN(oFyNcL)) {
			return isNaN(oFxNcL) ? 1 : -1;
		}
		// rely on string comparison if different types - i.e. '02' < 2 != '02' < '2'
		else if (typeof oFxNcL !== typeof oFyNcL) {
			oFxNcL += "";
			oFyNcL += "";
		}
		if (oFxNcL < oFyNcL) {
			return -1;
		}
		if (oFxNcL > oFyNcL) {
			return 1;
		}
	}
	return 0;
}

function KOSubscriptionsManager(debugMessages) {
	var self = this;

	self.subscriptions = {};
	self.debug = !!debugMessages;
	self.count = 0;

	self.addSubscribe = function(name, observable, func) {
		if (self.subscriptions[name]) {
			throw new Error("Duplicated subscription " + name);
		}
		self.disposeSubscription(name);

		self.subscriptions[name] = observable.subscribe(func);
		self.debug && console.log("KOSubscriptionsManager", "addSubscribe", name, ++self.count);
	};

	self.addSubscribeChanged = function(name, observable, func) {
		if (self.subscriptions[name]) {
			throw new Error("Duplicated subscription " + name);
		}
		self.disposeSubscription(name);

		self.debug && console.log("KOSubscriptionsManager", "addSubscribeChanged", name, ++self.count);
		self.subscriptions[name] = observable.subscribeChanged(func);
	};

	self.disposeSubscription = function(name) {
		if (self.subscriptions[name]) {
			self.subscriptions[name].dispose();
			delete self.subscriptions[name];

			self.debug && console.log("KOSubscriptionsManager", "disposeSubscription", name, --self.count);
		}
	};

	this.disposeSubscriptions = function() {
		$.each(self.subscriptions, function(name, sub) {
			sub.dispose();
			self.debug && console.log("KOSubscriptionsManager", "disposeSubscriptions", name, --self.count);
		});
		self.subscriptions = {};
	};
}

function AppVersionManager() {
	var intervalHandler;

	function parseVersionScript(versionScript) {
		return versionScript.match(/APP_VERSION\s*=\s*"(?:<!--\s*)?([^\s]+)(?:\s*-->)?"/)[1];
	}

	function doVersionCheck(versionScript) {
		var version = parseVersionScript(versionScript);
		if (APP_VERSION != version)
		{
			swal(
				{
					title: r("new-version-title"),
					text: r("new-version-description"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: r("reload"),
					cancelButtonText: r("later")
				},
				function(isConfirm) {
					if (isConfirm) {
						window.location.reload();
						return;
					}
					
					// Check again in 8 hours
					setCheckTimeout(8 * 3600);
				}
			);
		} else if (intervalHandler) {
			// Check again in 1 minute
			setCheckTimeout(60);
		}
	}

	function setCheckTimeout(timeoutSecs) {
		intervalHandler = setTimeout(function() {
			getDeployedVersion().done(doVersionCheck);
		}, timeoutSecs * 1000);
	}

	function getDeployedVersion() {
		return $.ajax("version.js?hash=" + guidShort(), { dataType: 'text' });
	}

	this.start = function() {
		if (!intervalHandler) {
			setCheckTimeout(0);
		}
	};

	this.stop = function() {
		if (intervalHandler) {
			clearTimeout(intervalHandler);
			intervalHandler = null;
		}
	};
}

// TODO: MB REFACTOR

// md5
!(function(n) {
	"use strict";
	function t(n, t) {
		var r = (65535 & n) + (65535 & t),
			e = (n >> 16) + (t >> 16) + (r >> 16);
		return (e << 16) | (65535 & r);
	}
	function r(n, t) {
		return (n << t) | (n >>> (32 - t));
	}
	function e(n, e, o, u, c, f) {
		return t(r(t(t(e, n), t(u, f)), c), o);
	}
	function o(n, t, r, o, u, c, f) {
		return e((t & r) | (~t & o), n, t, u, c, f);
	}
	function u(n, t, r, o, u, c, f) {
		return e((t & o) | (r & ~o), n, t, u, c, f);
	}
	function c(n, t, r, o, u, c, f) {
		return e(t ^ r ^ o, n, t, u, c, f);
	}
	function f(n, t, r, o, u, c, f) {
		return e(r ^ (t | ~o), n, t, u, c, f);
	}
	function i(n, r) {
		(n[r >> 5] |= 128 << r % 32), (n[(((r + 64) >>> 9) << 4) + 14] = r);
		var e,
			i,
			a,
			h,
			d,
			l = 1732584193,
			g = -271733879,
			v = -1732584194,
			m = 271733878;
		for (e = 0; e < n.length; e += 16)
			(i = l),
				(a = g),
				(h = v),
				(d = m),
				(l = o(l, g, v, m, n[e], 7, -680876936)),
				(m = o(m, l, g, v, n[e + 1], 12, -389564586)),
				(v = o(v, m, l, g, n[e + 2], 17, 606105819)),
				(g = o(g, v, m, l, n[e + 3], 22, -1044525330)),
				(l = o(l, g, v, m, n[e + 4], 7, -176418897)),
				(m = o(m, l, g, v, n[e + 5], 12, 1200080426)),
				(v = o(v, m, l, g, n[e + 6], 17, -1473231341)),
				(g = o(g, v, m, l, n[e + 7], 22, -45705983)),
				(l = o(l, g, v, m, n[e + 8], 7, 1770035416)),
				(m = o(m, l, g, v, n[e + 9], 12, -1958414417)),
				(v = o(v, m, l, g, n[e + 10], 17, -42063)),
				(g = o(g, v, m, l, n[e + 11], 22, -1990404162)),
				(l = o(l, g, v, m, n[e + 12], 7, 1804603682)),
				(m = o(m, l, g, v, n[e + 13], 12, -40341101)),
				(v = o(v, m, l, g, n[e + 14], 17, -1502002290)),
				(g = o(g, v, m, l, n[e + 15], 22, 1236535329)),
				(l = u(l, g, v, m, n[e + 1], 5, -165796510)),
				(m = u(m, l, g, v, n[e + 6], 9, -1069501632)),
				(v = u(v, m, l, g, n[e + 11], 14, 643717713)),
				(g = u(g, v, m, l, n[e], 20, -373897302)),
				(l = u(l, g, v, m, n[e + 5], 5, -701558691)),
				(m = u(m, l, g, v, n[e + 10], 9, 38016083)),
				(v = u(v, m, l, g, n[e + 15], 14, -660478335)),
				(g = u(g, v, m, l, n[e + 4], 20, -405537848)),
				(l = u(l, g, v, m, n[e + 9], 5, 568446438)),
				(m = u(m, l, g, v, n[e + 14], 9, -1019803690)),
				(v = u(v, m, l, g, n[e + 3], 14, -187363961)),
				(g = u(g, v, m, l, n[e + 8], 20, 1163531501)),
				(l = u(l, g, v, m, n[e + 13], 5, -1444681467)),
				(m = u(m, l, g, v, n[e + 2], 9, -51403784)),
				(v = u(v, m, l, g, n[e + 7], 14, 1735328473)),
				(g = u(g, v, m, l, n[e + 12], 20, -1926607734)),
				(l = c(l, g, v, m, n[e + 5], 4, -378558)),
				(m = c(m, l, g, v, n[e + 8], 11, -2022574463)),
				(v = c(v, m, l, g, n[e + 11], 16, 1839030562)),
				(g = c(g, v, m, l, n[e + 14], 23, -35309556)),
				(l = c(l, g, v, m, n[e + 1], 4, -1530992060)),
				(m = c(m, l, g, v, n[e + 4], 11, 1272893353)),
				(v = c(v, m, l, g, n[e + 7], 16, -155497632)),
				(g = c(g, v, m, l, n[e + 10], 23, -1094730640)),
				(l = c(l, g, v, m, n[e + 13], 4, 681279174)),
				(m = c(m, l, g, v, n[e], 11, -358537222)),
				(v = c(v, m, l, g, n[e + 3], 16, -722521979)),
				(g = c(g, v, m, l, n[e + 6], 23, 76029189)),
				(l = c(l, g, v, m, n[e + 9], 4, -640364487)),
				(m = c(m, l, g, v, n[e + 12], 11, -421815835)),
				(v = c(v, m, l, g, n[e + 15], 16, 530742520)),
				(g = c(g, v, m, l, n[e + 2], 23, -995338651)),
				(l = f(l, g, v, m, n[e], 6, -198630844)),
				(m = f(m, l, g, v, n[e + 7], 10, 1126891415)),
				(v = f(v, m, l, g, n[e + 14], 15, -1416354905)),
				(g = f(g, v, m, l, n[e + 5], 21, -57434055)),
				(l = f(l, g, v, m, n[e + 12], 6, 1700485571)),
				(m = f(m, l, g, v, n[e + 3], 10, -1894986606)),
				(v = f(v, m, l, g, n[e + 10], 15, -1051523)),
				(g = f(g, v, m, l, n[e + 1], 21, -2054922799)),
				(l = f(l, g, v, m, n[e + 8], 6, 1873313359)),
				(m = f(m, l, g, v, n[e + 15], 10, -30611744)),
				(v = f(v, m, l, g, n[e + 6], 15, -1560198380)),
				(g = f(g, v, m, l, n[e + 13], 21, 1309151649)),
				(l = f(l, g, v, m, n[e + 4], 6, -145523070)),
				(m = f(m, l, g, v, n[e + 11], 10, -1120210379)),
				(v = f(v, m, l, g, n[e + 2], 15, 718787259)),
				(g = f(g, v, m, l, n[e + 9], 21, -343485551)),
				(l = t(l, i)),
				(g = t(g, a)),
				(v = t(v, h)),
				(m = t(m, d));
		return [l, g, v, m];
	}
	function a(n) {
		var t,
			r = "",
			e = 32 * n.length;
		for (t = 0; t < e; t += 8) r += String.fromCharCode((n[t >> 5] >>> t % 32) & 255);
		return r;
	}
	function h(n) {
		var t,
			r = [];
		for (r[(n.length >> 2) - 1] = void 0, t = 0; t < r.length; t += 1) r[t] = 0;
		var e = 8 * n.length;
		for (t = 0; t < e; t += 8) r[t >> 5] |= (255 & n.charCodeAt(t / 8)) << t % 32;
		return r;
	}
	function d(n) {
		return a(i(h(n), 8 * n.length));
	}
	function l(n, t) {
		var r,
			e,
			o = h(n),
			u = [],
			c = [];
		for (u[15] = c[15] = void 0, o.length > 16 && (o = i(o, 8 * n.length)), r = 0; r < 16; r += 1)
			(u[r] = 909522486 ^ o[r]), (c[r] = 1549556828 ^ o[r]);
		return (e = i(u.concat(h(t)), 512 + 8 * t.length)), a(i(c.concat(e), 640));
	}
	function g(n) {
		var t,
			r,
			e = "0123456789abcdef",
			o = "";
		for (r = 0; r < n.length; r += 1) (t = n.charCodeAt(r)), (o += e.charAt((t >>> 4) & 15) + e.charAt(15 & t));
		return o;
	}
	function v(n) {
		return unescape(encodeURIComponent(n));
	}
	function m(n) {
		return d(v(n));
	}
	function p(n) {
		return g(m(n));
	}
	function s(n, t) {
		return l(v(n), v(t));
	}
	function C(n, t) {
		return g(s(n, t));
	}
	function A(n, t, r) {
		return t ? (r ? s(t, n) : C(t, n)) : r ? m(n) : p(n);
	}
	"function" == typeof define && define.amd
		? define(function() {
				return A;
		  })
		: "object" == typeof module && module.exports
		? (module.exports = A)
		: (n.md5 = A);
})(this);

function TrackerManager() {
	var self = this;

	var ga_tracker = window.ga;
	var ga_enabled = !_.isUndefined(ga_tracker);

	var ai_tracker = window.appInsights;
	var ai_enabled = !_.isUndefined(ai_tracker);

	console.log("AI", ai_enabled, "GA", ga_enabled);

	var lastView = undefined;

	function newId() {
		var base64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";

		var result = "";
		var random = Math.random() * 1073741824; // 5 symbols in base64, almost maxint

		while (random > 0) {
			var char = base64chars.charAt(random % 64);
			result += char;
			random = Math.floor(random / 64);
		}
		return result;
	}

	function random32() {
		return (0x100000000 * Math.random()) | 0;
	}
	function generateW3CId() {
		var hexValues = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];

		// rfc4122 version 4 UUID without dashes and with lowercase letters
		var oct = "",
			tmp;
		for (var a = 0; a < 4; a++) {
			tmp = random32();
			oct +=
				hexValues[tmp & 0xf] +
				hexValues[(tmp >> 4) & 0xf] +
				hexValues[(tmp >> 8) & 0xf] +
				hexValues[(tmp >> 12) & 0xf] +
				hexValues[(tmp >> 16) & 0xf] +
				hexValues[(tmp >> 20) & 0xf] +
				hexValues[(tmp >> 24) & 0xf] +
				hexValues[(tmp >> 28) & 0xf];
		}

		// "Set the two most significant bits (bits 6 and 7) of the clock_seq_hi_and_reserved to zero and one, respectively"
		var clockSequenceHi = hexValues[(8 + Math.random() * 4) | 0];
		return (
			oct.substr(0, 8) +
			oct.substr(9, 4) +
			"4" +
			oct.substr(13, 3) +
			clockSequenceHi +
			oct.substr(16, 3) +
			oct.substr(19, 12)
		);
	}

	self.trackView = function(viewName) {
		if (viewName && viewName !== lastView) {
			lastView = viewName;

			if (ga_enabled) {
				ga_tracker("set", "page", location.pathname + "#" + viewName);
				ga_tracker("send", "pageview");
			}

			if (ai_enabled) {
				try {
					ai_tracker.context.telemetryTrace.traceID = generateW3CId();
					ai_tracker.context.telemetryTrace.name = "Page" + viewName;
					ai_tracker.trackPageView({
						name: lastView,
						uri: location.origin + location.pathname + "#" + viewName,
						refUri: null
					});
				} catch (e) {
					console.error(e);
				}
			}
		}
	};

	self.setHighestRole = function(role) {
		if (ga_enabled) {
			// HighestRole
			ga_tracker("set", "dimension1", role);
		}
	};

	self.setUserId = function(userId) {
		if (ga_enabled) {
			ga_tracker("set", "userId", userId ? self.hashUserId(userId) : undefined);
		}

		if (ai_enabled) {
			try {
				if (userId) {
					ai_tracker.setAuthenticatedUserContext(userId.toString());
				} else {
					ai_tracker.clearAuthenticatedUserContext();
				}
			} catch (e) {
				console.error(e);
			}
		}
	};

	self.hashUserId = function(userId) {
		return md5(userId.toString());
	};

	self.log = function(message, properties, severity) {
		if (ai_enabled) {
			try {
				ai_tracker.trackTrace({
					message: message,
					properties: properties,
					severityLevel: severity,
				})
			} catch (e) {
				console.error(e);
			}
		}
	}

	self.logVerbose = function(message, properties) {
		self.log(message, properties, "Verbose");
	}

	self.logInfo = function(message, properties) {
		self.log(message, properties, "Information");
	}

	self.logWarning = function(message, properties) {
		self.log(message, properties, "Warning");
	}

	self.logError = function(message, properties) {
		self.log(message, properties, "Error");
	}

	self.logCritical = function(message, properties) {
		self.log(message, properties, "Critical");
	}
}

var trackerManager = new TrackerManager();

var app = (function () {

	function bootCompleted() {

		if (_.has(window, 'validation')) {
			validation.loadSettings();
			validation.loadValidationRules();
		}

		if (_.has(window, 'toastr')) {
			window.toastr.options.preventDuplicates = true;
		}

		AmCharts_path = (appBuildMode === "src" ? '' : _.join(_.dropRight(_.split(window.location.pathname, '/')), '/')) + "/lib/js/amcharts/";

		if (_.has(window, 'trackerManager')) {
			window.eventBus.subscribe("RouteChanged", function (viewName) {
				if (viewName !== "NoAccess") {
					trackerManager.trackView(viewName);
				}
			});
		}

		if (_.has(window, 'routing')) {
			// Sets default routing if missing
			routing.refreshRoute();
		}

		ko.applyBindings();
	}

	function boot() {
		// Configure components and services

		if (_.has(window, 'componentsConfig'))
			componentsConfig.init();

		if (_.has(window, 'serviceLocator'))
			serviceLocator.init();

		if (_.has(window, 'RoutesConfig')) {
			var routesConfig = new RoutesConfig();
			routesConfig.init();
		}

		// Start stuff

		if (_.has(window, 'appVersionManager')) {
			appVersionManager.start();
		}

		if (_.has(window, 'routing')) {
			routing.run();
		}

		if (_.has(window, 'authManager')) {
			return authManager
				.initialize()
				.then(null, function () {
					// Resume Firebase session failed
					console.log("NO FIREBASE SESSION");
				})
				.then(function () {
					console.log("GOT FIREBASE TOKEN");
					// Get all user data from API
					return userData.updateUserFromApi();
				})
				.always(function () {
					return bootCompleted();
				});
		} else {
			resourceManager.setCurrentLanguage(resourceManager.getCurrentLanguage());
			bootCompleted();
		}
	}

	function init() {
		if (window.location.hostname == "localhost" || window.location.hostname == "test.uptivo.fit" || window.location.hostname == "demo.uptivo.fit") {
			window.environment = "development";
			document.documentElement.className += " development-env";

			if (window.location.hostname == "test.uptivo.fit") {
				CONFIGURATION.BASE_API_URL = CONFIGURATION.TESTING_BASE_API_URL;
				CONFIGURATION.BASE_FILE_SERVICE = CONFIGURATION.TESTING_BASE_FILE_SERVICE;
			} else if (window.location.hostname == "localhost") {
				CONFIGURATION.BASE_API_URL = CONFIGURATION.LOCAL_BASE_API_URL;
				CONFIGURATION.BASE_FILE_SERVICE = CONFIGURATION.LOCAL_BASE_FILE_SERVICE;
			}
		} else {
			window.environment = "production";
			document.documentElement.className += " production-env";
		}

		window.deploy = window.location.hostname.endsWith(".uptivo.fit") ? "online" : "private";
		window.appBuildMode = _.includes(window.location.pathname, '/src') ? "src" : "dist";

		if (!Modernizr.cookies || !Modernizr.localstorage) {
			swal(
				{
					title: "Oops, c'è stato un errore!",
					text: r("check-browser-settings"),
					type: "error",
					html: true,
					confirmButtonColor: "#DD6B55",
					confirmButtonText: r("reload")
				},
				function (isConfirm) {
					if (isConfirm) {
						window.location.reload();
					}
				}
			);

			return;
		}

		boot();
	}

	return {
		Init: init,
		current: ko.observable(),
		currentRoute: ko.observable(),
		mapsLoaded: ko.observable(false),
		params: ko.observable(),
	};
})();

$(document).ready(function () {
	app.Init();
});
